import React$1, { Fragment, useMemo, useState, useRef, useEffect } from 'react';
import { Button as Button$1, IconButton, Snackbar as Snackbar$1, TextField, InputAdornment, InputLabel as InputLabel$1, FormHelperText, Select, FormControlLabel, Checkbox, MenuItem, Tooltip as Tooltip$1, FormControl as FormControl$1, CircularProgress as CircularProgress$1, Slider, LinearProgress } from '@mui/material';
import styled, { css, useTheme, keyframes } from 'styled-components';
import require$$3 from 'react-dom';
import moment from 'moment';
import MuiFileCopy from '@mui/icons-material/FileCopy';
import MuiEdit from '@mui/icons-material/Edit';
import MuiDelete from '@mui/icons-material/Delete';
import MuiOpenInNew from '@mui/icons-material/OpenInNew';
import MoreIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import withStyles$1 from '@mui/styles/withStyles';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import { observer } from 'mobx-react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { LocalizationProvider, DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel$1 from '@mui/material/FormControlLabel';
import { useTranslation, Trans } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Row, Col, Card } from 'reactstrap';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ReactJWPlayer from 'react-jw-player';
import MuiCheckCircle from '@mui/icons-material/CheckCircle';
import sanitizeHtml from 'sanitize-html';
import Checkbox$1 from '@mui/material/Checkbox';
import UnfoldMore from '@mui/icons-material/UnfoldMore';
import pluralize from 'pluralize';
import { Container, Draggable } from 'react-smooth-dnd';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import Fab from '@mui/material/Fab';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem$1 from '@mui/material/MenuItem';
import Popper from '@mui/material/Popper';
import EyeIcon from '@mui/icons-material/Visibility';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Popover from '@mui/material/Popover';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

var name = "@awarego/awarego-components";
var version$1 = "5.0.4";
var main = "dist/cjs/bundle.js";
var module = "dist/esm/bundle.js";
var files = [
	"dist"
];
var scripts = {
	build: "rimraf dist && rollup -c",
	watch: "rollup -c -w",
	test: "jest",
	lint: "eslint src",
	storybook: "storybook dev -p 6006",
	"build-storybook": "storybook build",
	"predeploy-storybook": "npm run build-storybook",
	"deploy-storybook": "gh-pages -d storybook-static"
};
var keywords = [
];
var author = "";
var license = "ISC";
var dependencies = {
	"@emotion/is-prop-valid": "^1.2.1",
	"@mui/icons-material": "^5.11.16",
	"@mui/lab": "^5.0.0-alpha.134",
	"@mui/material": "^5.13.6",
	"@mui/styles": "^5.13.2",
	"@mui/x-date-pickers": "^6.8.0",
	"array-move": "^3.0.1",
	"babel-plugin-dynamic-import-node": "^2.3.3",
	"babel-plugin-react-docgen": "^4.2.1",
	bootstrap: "4.4.1",
	classnames: "^2.3.1",
	"lottie-colorify": "^0.8.0",
	mobx: "6.5.0",
	"mobx-react": "^7.4.0",
	moment: "^2.29.1",
	ms: "^2.1.3",
	pluralize: "^8.0.0",
	polished: "^4.2.2",
	"prop-types": "^15.8.1",
	react: "^18.2.0",
	"react-circular-progressbar": "^2.0.3",
	"react-clipboard.js": "^2.0.16",
	"react-device-detect": "^2.1.2",
	"react-dom": "^18.2.0",
	"react-i18next": "^14.0.0",
	"react-jw-player": "^1.19.1",
	"react-lottie": "^1.2.3",
	"react-modal": "^3.8.1",
	"react-router-dom": "6.19.0",
	"react-smooth-dnd": "^0.11.1",
	"react-svgmt": "^2.0.2",
	reactstrap: "^8.9.0",
	"sanitize-html": "^2.11.0",
	"styled-components": "^5.3.11"
};
var peerDependencies = {
	"@mui/icons-material": "^5.11.16",
	"@mui/lab": "^5.0.0-alpha.134",
	"@mui/material": "^5.13.6",
	"@mui/styles": "^5.13.2",
	"@mui/x-date-pickers": "^6.8.0",
	classnames: "^2.3.1",
	mobx: "6.5.0",
	"mobx-react": "^7.4.0",
	moment: "^2.29.1",
	pluralize: "^8.0.0",
	react: "^18.2.0",
	"react-circular-progressbar": "^2.0.3",
	"react-dom": "^18.2.0",
	"react-i18next": "^13.0.0",
	"react-jw-player": "^1.19.1",
	"react-router-dom": "6.19.0",
	"react-smooth-dnd": "^0.11.1",
	reactstrap: "^8.9.0",
	"sanitize-html": "^2.11.0",
	"styled-components": "^5.3.11"
};
var devDependencies = {
	"@babel/core": "^7.21.4",
	"@babel/preset-env": "^7.21.4",
	"@babel/preset-react": "^7.18.6",
	"@rollup/plugin-babel": "^6.0.3",
	"@rollup/plugin-commonjs": "^25.0.4",
	"@rollup/plugin-json": "^6.0.0",
	"@rollup/plugin-node-resolve": "^15.2.1",
	"@storybook/addon-essentials": "^7.6.0",
	"@storybook/addon-interactions": "^7.6.0",
	"@storybook/addon-links": "^7.6.0",
	"@storybook/blocks": "^7.6.0",
	"@storybook/preset-scss": "^1.0.3",
	"@storybook/react": "^7.6.0",
	"@storybook/react-webpack5": "^7.6.0",
	"@storybook/testing-library": "^0.0.14-next.2",
	autoprefixer: "^9.0.0",
	eslint: "^8.38.0",
	"eslint-plugin-react": "^7.32.2",
	rimraf: "^4.4.1",
	rollup: "^3.28.1",
	"rollup-plugin-peer-deps-external": "^2.2.4",
	"rollup-plugin-postcss": "^4.0.2",
	sass: "^1.61.0",
	storybook: "^7.6.0"
};
var resolutions = {
	jackspeak: "2.1.1"
};
var volta = {
	node: "18.17.1"
};
var repository = {
	type: "git",
	url: "git@github.com:AwareGO/awarego-components.git"
};
var homepage = "https://github.com/AwareGO/awarego-components/blob/master/README.MD";
var description = "";
var packageJson = {
	name: name,
	version: version$1,
	main: main,
	module: module,
	files: files,
	scripts: scripts,
	keywords: keywords,
	author: author,
	license: license,
	dependencies: dependencies,
	peerDependencies: peerDependencies,
	devDependencies: devDependencies,
	resolutions: resolutions,
	volta: volta,
	repository: repository,
	homepage: homepage,
	description: description
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var dist$1 = {};

var _extends$4 = {};

var _global = {exports: {}};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$6 = _global.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global$6; // eslint-disable-line no-undef

var _globalExports = _global.exports;

var _core = {exports: {}};

var core$4 = _core.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core$4; // eslint-disable-line no-undef

var _coreExports = _core.exports;

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding
var aFunction = _aFunction;
var _ctx = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _objectDp = {};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$3 = _isObject;
var _anObject = function (it) {
  if (!isObject$3(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

var _descriptors;
var hasRequired_descriptors;

function require_descriptors () {
	if (hasRequired_descriptors) return _descriptors;
	hasRequired_descriptors = 1;
	// Thank's IE8 for his funny defineProperty
	_descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	return _descriptors;
}

var _domCreate;
var hasRequired_domCreate;

function require_domCreate () {
	if (hasRequired_domCreate) return _domCreate;
	hasRequired_domCreate = 1;
	var isObject = _isObject;
	var document = _globalExports.document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	_domCreate = function (it) {
	  return is ? document.createElement(it) : {};
	};
	return _domCreate;
}

var _ie8DomDefine;
var hasRequired_ie8DomDefine;

function require_ie8DomDefine () {
	if (hasRequired_ie8DomDefine) return _ie8DomDefine;
	hasRequired_ie8DomDefine = 1;
	_ie8DomDefine = !require_descriptors() && !_fails(function () {
	  return Object.defineProperty(require_domCreate()('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	return _ie8DomDefine;
}

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject$2 = _isObject;
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!isObject$2(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject$2(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject$2(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject$2(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasRequired_objectDp;

function require_objectDp () {
	if (hasRequired_objectDp) return _objectDp;
	hasRequired_objectDp = 1;
	var anObject = _anObject;
	var IE8_DOM_DEFINE = require_ie8DomDefine();
	var toPrimitive = _toPrimitive;
	var dP = Object.defineProperty;

	_objectDp.f = require_descriptors() ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	return _objectDp;
}

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var dP$1 = require_objectDp();
var createDesc$2 = _propertyDesc;
var _hide = require_descriptors() ? function (object, key, value) {
  return dP$1.f(object, key, createDesc$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$5 = _globalExports;
var core$3 = _coreExports;
var ctx = _ctx;
var hide$3 = _hide;
var has$7 = _has;
var PROTOTYPE$1 = 'prototype';

var $export$7 = function (type, name, source) {
  var IS_FORCED = type & $export$7.F;
  var IS_GLOBAL = type & $export$7.G;
  var IS_STATIC = type & $export$7.S;
  var IS_PROTO = type & $export$7.P;
  var IS_BIND = type & $export$7.B;
  var IS_WRAP = type & $export$7.W;
  var exports = IS_GLOBAL ? core$3 : core$3[name] || (core$3[name] = {});
  var expProto = exports[PROTOTYPE$1];
  var target = IS_GLOBAL ? global$5 : IS_STATIC ? global$5[name] : (global$5[name] || {})[PROTOTYPE$1];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has$7(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global$5)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE$1] = C[PROTOTYPE$1];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export$7.R && expProto && !expProto[key]) hide$3(expProto, key, out);
    }
  }
};
// type bitmap
$export$7.F = 1;   // forced
$export$7.G = 2;   // global
$export$7.S = 4;   // static
$export$7.P = 8;   // proto
$export$7.B = 16;  // bind
$export$7.W = 32;  // wrap
$export$7.U = 64;  // safe
$export$7.R = 128; // real proto method for `library`
var _export = $export$7;

var toString$1 = {}.toString;

var _cof = function (it) {
  return toString$1.call(it).slice(8, -1);
};

var _iobject;
var hasRequired_iobject;

function require_iobject () {
	if (hasRequired_iobject) return _iobject;
	hasRequired_iobject = 1;
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = _cof;
	// eslint-disable-next-line no-prototype-builtins
	_iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	return _iobject;
}

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require_iobject();
var defined$2 = _defined;
var _toIobject = function (it) {
  return IObject(defined$2(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength
var toInteger$2 = _toInteger;
var min$1 = Math.min;
var _toLength = function (it) {
  return it > 0 ? min$1(toInteger$2(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var toInteger$1 = _toInteger;
var max = Math.max;
var min = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = toInteger$1(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes
var toIObject$5 = _toIobject;
var toLength = _toLength;
var toAbsoluteIndex = _toAbsoluteIndex;
var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject$5($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared = {exports: {}};

var _library;
var hasRequired_library;

function require_library () {
	if (hasRequired_library) return _library;
	hasRequired_library = 1;
	_library = true;
	return _library;
}

var core$2 = _coreExports;
var global$4 = _globalExports;
var SHARED = '__core-js_shared__';
var store$1 = global$4[SHARED] || (global$4[SHARED] = {});

(_shared.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core$2.version,
  mode: require_library() ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var _sharedExports = _shared.exports;

var id$1 = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$1 + px).toString(36));
};

var shared$1 = _sharedExports('keys');
var uid$2 = _uid;
var _sharedKey = function (key) {
  return shared$1[key] || (shared$1[key] = uid$2(key));
};

var has$6 = _has;
var toIObject$4 = _toIobject;
var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO$1 = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = toIObject$4(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$1) has$6(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$6(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

var _enumBugKeys;
var hasRequired_enumBugKeys;

function require_enumBugKeys () {
	if (hasRequired_enumBugKeys) return _enumBugKeys;
	hasRequired_enumBugKeys = 1;
	// IE 8- don't enum bug keys
	_enumBugKeys = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');
	return _enumBugKeys;
}

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys$1 = _objectKeysInternal;
var enumBugKeys = require_enumBugKeys();

var _objectKeys = Object.keys || function keys(O) {
  return $keys$1(O, enumBugKeys);
};

var _objectGops = {};

_objectGops.f = Object.getOwnPropertySymbols;

var _objectPie = {};

var hasRequired_objectPie;

function require_objectPie () {
	if (hasRequired_objectPie) return _objectPie;
	hasRequired_objectPie = 1;
	_objectPie.f = {}.propertyIsEnumerable;
	return _objectPie;
}

// 7.1.13 ToObject(argument)
var defined$1 = _defined;
var _toObject = function (it) {
  return Object(defined$1(it));
};

var _objectAssign;
var hasRequired_objectAssign;

function require_objectAssign () {
	if (hasRequired_objectAssign) return _objectAssign;
	hasRequired_objectAssign = 1;
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = require_descriptors();
	var getKeys = _objectKeys;
	var gOPS = _objectGops;
	var pIE = require_objectPie();
	var toObject = _toObject;
	var IObject = require_iobject();
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	_objectAssign = !$assign || _fails(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;
	return _objectAssign;
}

// 19.1.3.1 Object.assign(target, source)
var $export$6 = _export;

$export$6($export$6.S + $export$6.F, 'Object', { assign: require_objectAssign() });

var assign$1 = _coreExports.Object.assign;

var assign = { "default": assign$1, __esModule: true };

_extends$4.__esModule = true;

var _assign = assign;

var _assign2 = _interopRequireDefault$a(_assign);

function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_extends$4.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has$5 = _has;
var toObject$2 = _toObject;
var IE_PROTO = _sharedKey('IE_PROTO');
var ObjectProto$1 = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = toObject$2(O);
  if (has$5(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto$1 : null;
};

// most Object methods by ES6 should accept primitives
var $export$5 = _export;
var core$1 = _coreExports;
var fails = _fails;
var _objectSap = function (KEY, exec) {
  var fn = (core$1.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export$5($export$5.S + $export$5.F * fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject$1 = _toObject;
var $getPrototypeOf = _objectGpo;

_objectSap('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject$1(it));
  };
});

var getPrototypeOf$2 = _coreExports.Object.getPrototypeOf;

var getPrototypeOf$1 = { "default": getPrototypeOf$2, __esModule: true };

var classCallCheck = {};

classCallCheck.__esModule = true;

classCallCheck.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = {};

var $export$4 = _export;
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export$4($export$4.S + $export$4.F * !require_descriptors(), 'Object', { defineProperty: require_objectDp().f });

var $Object$1 = _coreExports.Object;
var defineProperty$2 = function defineProperty(it, key, desc) {
  return $Object$1.defineProperty(it, key, desc);
};

var defineProperty$1 = { "default": defineProperty$2, __esModule: true };

createClass.__esModule = true;

var _defineProperty$1 = defineProperty$1;

var _defineProperty2 = _interopRequireDefault$9(_defineProperty$1);

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

createClass.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var possibleConstructorReturn = {};

var _typeof$2 = {};

var toInteger = _toInteger;
var defined = _defined;
// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _iterators = {};

var _objectDps;
var hasRequired_objectDps;

function require_objectDps () {
	if (hasRequired_objectDps) return _objectDps;
	hasRequired_objectDps = 1;
	var dP = require_objectDp();
	var anObject = _anObject;
	var getKeys = _objectKeys;

	_objectDps = require_descriptors() ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	return _objectDps;
}

var _html;
var hasRequired_html;

function require_html () {
	if (hasRequired_html) return _html;
	hasRequired_html = 1;
	var document = _globalExports.document;
	_html = document && document.documentElement;
	return _html;
}

var _objectCreate;
var hasRequired_objectCreate;

function require_objectCreate () {
	if (hasRequired_objectCreate) return _objectCreate;
	hasRequired_objectCreate = 1;
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = _anObject;
	var dPs = require_objectDps();
	var enumBugKeys = require_enumBugKeys();
	var IE_PROTO = _sharedKey('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = require_domCreate()('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  require_html().appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	_objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	return _objectCreate;
}

var _wks = {exports: {}};

var store = _sharedExports('wks');
var uid$1 = _uid;
var Symbol$1 = _globalExports.Symbol;
var USE_SYMBOL = typeof Symbol$1 == 'function';

var $exports = _wks.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol$1[name] || (USE_SYMBOL ? Symbol$1 : uid$1)('Symbol.' + name));
};

$exports.store = store;

var _wksExports = _wks.exports;

var def = require_objectDp().f;
var has$4 = _has;
var TAG = _wksExports('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !has$4(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var create$2 = require_objectCreate();
var descriptor = _propertyDesc;
var setToStringTag$2 = _setToStringTag;
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wksExports('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = create$2(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag$2(Constructor, NAME + ' Iterator');
};

var LIBRARY$1 = require_library();
var $export$3 = _export;
var redefine$1 = _redefine;
var hide$2 = _hide;
var Iterators$2 = _iterators;
var $iterCreate = _iterCreate;
var setToStringTag$1 = _setToStringTag;
var getPrototypeOf = _objectGpo;
var ITERATOR = _wksExports('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag$1(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY$1 && typeof IteratorPrototype[ITERATOR] != 'function') hide$2(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY$1 || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide$2(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators$2[NAME] = $default;
  Iterators$2[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine$1(proto, key, methods[key]);
    } else $export$3($export$3.P + $export$3.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

var step = _iterStep;
var Iterators$1 = _iterators;
var toIObject$3 = _toIobject;

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
_iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = toIObject$3(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators$1.Arguments = Iterators$1.Array;

var global$3 = _globalExports;
var hide$1 = _hide;
var Iterators = _iterators;
var TO_STRING_TAG = _wksExports('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global$3[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide$1(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

var _wksExt = {};

_wksExt.f = _wksExports;

var iterator$1 = _wksExt.f('iterator');

var iterator = { "default": iterator$1, __esModule: true };

var _meta = {exports: {}};

var META$1 = _uid('meta');
var isObject$1 = _isObject;
var has$3 = _has;
var setDesc = require_objectDp().f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META$1, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has$3(it, META$1)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META$1].i;
};
var getWeak = function (it, create) {
  if (!has$3(it, META$1)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META$1].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta$1.NEED && isExtensible(it) && !has$3(it, META$1)) setMeta(it);
  return it;
};
var meta$1 = _meta.exports = {
  KEY: META$1,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

var _metaExports = _meta.exports;

var global$2 = _globalExports;
var core = _coreExports;
var LIBRARY = require_library();
var wksExt$1 = _wksExt;
var defineProperty = require_objectDp().f;
var _wksDefine = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global$2.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt$1.f(name) });
};

// all enumerable object keys, includes symbols
var getKeys = _objectKeys;
var gOPS = _objectGops;
var pIE$1 = require_objectPie();
var _enumKeys = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE$1.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.2.2 IsArray(argument)
var cof = _cof;
var _isArray = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

var _objectGopnExt = {};

var _objectGopn = {};

var hasRequired_objectGopn;

function require_objectGopn () {
	if (hasRequired_objectGopn) return _objectGopn;
	hasRequired_objectGopn = 1;
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = _objectKeysInternal;
	var hiddenKeys = require_enumBugKeys().concat('length', 'prototype');

	_objectGopn.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	return _objectGopn;
}

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject$2 = _toIobject;
var gOPN$1 = require_objectGopn().f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN$1(it);
  } catch (e) {
    return windowNames.slice();
  }
};

_objectGopnExt.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(toIObject$2(it));
};

var _objectGopd = {};

var pIE = require_objectPie();
var createDesc$1 = _propertyDesc;
var toIObject$1 = _toIobject;
var toPrimitive$1 = _toPrimitive;
var has$2 = _has;
var IE8_DOM_DEFINE = require_ie8DomDefine();
var gOPD$1 = Object.getOwnPropertyDescriptor;

_objectGopd.f = require_descriptors() ? gOPD$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIObject$1(O);
  P = toPrimitive$1(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD$1(O, P);
  } catch (e) { /* empty */ }
  if (has$2(O, P)) return createDesc$1(!pIE.f.call(O, P), O[P]);
};

// ECMAScript 6 symbols shim
var global$1 = _globalExports;
var has$1 = _has;
var DESCRIPTORS = require_descriptors();
var $export$2 = _export;
var redefine = _redefine;
var META = _metaExports.KEY;
var $fails = _fails;
var shared = _sharedExports;
var setToStringTag = _setToStringTag;
var uid = _uid;
var wks = _wksExports;
var wksExt = _wksExt;
var wksDefine = _wksDefine;
var enumKeys = _enumKeys;
var isArray = _isArray;
var anObject = _anObject;
var isObject = _isObject;
var toObject = _toObject;
var toIObject = _toIobject;
var toPrimitive = _toPrimitive;
var createDesc = _propertyDesc;
var _create$1 = require_objectCreate();
var gOPNExt = _objectGopnExt;
var $GOPD = _objectGopd;
var $GOPS = _objectGops;
var $DP = require_objectDp();
var $keys = _objectKeys;
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global$1.Symbol;
var $JSON = global$1.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global$1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create$1(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create$1($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has$1(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has$1(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has$1(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create$1(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create$1(it) : $defineProperties(_create$1(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has$1(AllSymbols, key) && !has$1(OPSymbols, key)) return false;
  return E || !has$1(this, key) || !has$1(AllSymbols, key) || has$1(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has$1(AllSymbols, key) && !has$1(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has$1(AllSymbols, key) && !(has$1(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has$1(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has$1(AllSymbols, key = names[i++]) && (IS_OP ? has$1(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has$1(this, HIDDEN) && has$1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require_objectGopn().f = gOPNExt.f = $getOwnPropertyNames;
  require_objectPie().f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require_library()) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export$2($export$2.G + $export$2.W + $export$2.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export$2($export$2.S + $export$2.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has$1(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export$2($export$2.S + $export$2.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export$2($export$2.S + $export$2.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export$2($export$2.S + $export$2.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global$1.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol$1 = _coreExports.Symbol;

var symbol = { "default": symbol$1, __esModule: true };

_typeof$2.__esModule = true;

var _iterator = iterator;

var _iterator2 = _interopRequireDefault$8(_iterator);

var _symbol = symbol;

var _symbol2 = _interopRequireDefault$8(_symbol);

var _typeof$1 = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_typeof$2.default = typeof _symbol2.default === "function" && _typeof$1(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof$1(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof$1(obj);
};

possibleConstructorReturn.__esModule = true;

var _typeof2$1 = _typeof$2;

var _typeof3$1 = _interopRequireDefault$7(_typeof2$1);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

possibleConstructorReturn.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3$1.default)(call)) === "object" || typeof call === "function") ? call : self;
};

var inherits = {};

var _setProto;
var hasRequired_setProto;

function require_setProto () {
	if (hasRequired_setProto) return _setProto;
	hasRequired_setProto = 1;
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = _isObject;
	var anObject = _anObject;
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	_setProto = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};
	return _setProto;
}

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export$1 = _export;
$export$1($export$1.S, 'Object', { setPrototypeOf: require_setProto().set });

var setPrototypeOf$1 = _coreExports.Object.setPrototypeOf;

var setPrototypeOf = { "default": setPrototypeOf$1, __esModule: true };

var $export = _export;
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require_objectCreate() });

var $Object = _coreExports.Object;
var create$1 = function create(P, D) {
  return $Object.create(P, D);
};

var create = { "default": create$1, __esModule: true };

inherits.__esModule = true;

var _setPrototypeOf$2 = setPrototypeOf;

var _setPrototypeOf2 = _interopRequireDefault$6(_setPrototypeOf$2);

var _create = create;

var _create2 = _interopRequireDefault$6(_create);

var _typeof2 = _typeof$2;

var _typeof3 = _interopRequireDefault$6(_typeof2);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

inherits.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;

var lottie = {exports: {}};

(function (module, exports) {
	(typeof navigator !== "undefined") && (function (global, factory) {
	  module.exports = factory() ;
	})(commonjsGlobal, (function () {
	  var svgNS = 'http://www.w3.org/2000/svg';
	  var locationHref = '';
	  var _useWebWorker = false;
	  var initialDefaultFrame = -999999;

	  var setWebWorker = function setWebWorker(flag) {
	    _useWebWorker = !!flag;
	  };

	  var getWebWorker = function getWebWorker() {
	    return _useWebWorker;
	  };

	  var setLocationHref = function setLocationHref(value) {
	    locationHref = value;
	  };

	  var getLocationHref = function getLocationHref() {
	    return locationHref;
	  };

	  function createTag(type) {
	    // return {appendChild:function(){},setAttribute:function(){},style:{}}
	    return document.createElement(type);
	  }

	  function extendPrototype(sources, destination) {
	    var i;
	    var len = sources.length;
	    var sourcePrototype;

	    for (i = 0; i < len; i += 1) {
	      sourcePrototype = sources[i].prototype;

	      for (var attr in sourcePrototype) {
	        if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
	      }
	    }
	  }

	  function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	  }

	  function createProxyFunction(prototype) {
	    function ProxyFunction() {}

	    ProxyFunction.prototype = prototype;
	    return ProxyFunction;
	  }

	  // import Howl from '../../3rd_party/howler';
	  var audioControllerFactory = function () {
	    function AudioController(audioFactory) {
	      this.audios = [];
	      this.audioFactory = audioFactory;
	      this._volume = 1;
	      this._isMuted = false;
	    }

	    AudioController.prototype = {
	      addAudio: function addAudio(audio) {
	        this.audios.push(audio);
	      },
	      pause: function pause() {
	        var i;
	        var len = this.audios.length;

	        for (i = 0; i < len; i += 1) {
	          this.audios[i].pause();
	        }
	      },
	      resume: function resume() {
	        var i;
	        var len = this.audios.length;

	        for (i = 0; i < len; i += 1) {
	          this.audios[i].resume();
	        }
	      },
	      setRate: function setRate(rateValue) {
	        var i;
	        var len = this.audios.length;

	        for (i = 0; i < len; i += 1) {
	          this.audios[i].setRate(rateValue);
	        }
	      },
	      createAudio: function createAudio(assetPath) {
	        if (this.audioFactory) {
	          return this.audioFactory(assetPath);
	        }

	        if (window.Howl) {
	          return new window.Howl({
	            src: [assetPath]
	          });
	        }

	        return {
	          isPlaying: false,
	          play: function play() {
	            this.isPlaying = true;
	          },
	          seek: function seek() {
	            this.isPlaying = false;
	          },
	          playing: function playing() {},
	          rate: function rate() {},
	          setVolume: function setVolume() {}
	        };
	      },
	      setAudioFactory: function setAudioFactory(audioFactory) {
	        this.audioFactory = audioFactory;
	      },
	      setVolume: function setVolume(value) {
	        this._volume = value;

	        this._updateVolume();
	      },
	      mute: function mute() {
	        this._isMuted = true;

	        this._updateVolume();
	      },
	      unmute: function unmute() {
	        this._isMuted = false;

	        this._updateVolume();
	      },
	      getVolume: function getVolume() {
	        return this._volume;
	      },
	      _updateVolume: function _updateVolume() {
	        var i;
	        var len = this.audios.length;

	        for (i = 0; i < len; i += 1) {
	          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
	        }
	      }
	    };
	    return function () {
	      return new AudioController();
	    };
	  }();

	  var createTypedArray = function () {
	    function createRegularArray(type, len) {
	      var i = 0;
	      var arr = [];
	      var value;

	      switch (type) {
	        case 'int16':
	        case 'uint8c':
	          value = 1;
	          break;

	        default:
	          value = 1.1;
	          break;
	      }

	      for (i = 0; i < len; i += 1) {
	        arr.push(value);
	      }

	      return arr;
	    }

	    function createTypedArrayFactory(type, len) {
	      if (type === 'float32') {
	        return new Float32Array(len);
	      }

	      if (type === 'int16') {
	        return new Int16Array(len);
	      }

	      if (type === 'uint8c') {
	        return new Uint8ClampedArray(len);
	      }

	      return createRegularArray(type, len);
	    }

	    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
	      return createTypedArrayFactory;
	    }

	    return createRegularArray;
	  }();

	  function createSizedArray(len) {
	    return Array.apply(null, {
	      length: len
	    });
	  }

	  function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }
	  var subframeEnabled = true;
	  var expressionsPlugin = null;
	  var expressionsInterfaces = null;
	  var idPrefix$1 = '';
	  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	  var bmPow = Math.pow;
	  var bmSqrt = Math.sqrt;
	  var bmFloor = Math.floor;
	  var bmMax = Math.max;
	  var bmMin = Math.min;
	  var BMMath = {};

	  (function () {
	    var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
	    var i;
	    var len = propertyNames.length;

	    for (i = 0; i < len; i += 1) {
	      BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	  })();

	  BMMath.random = Math.random;

	  BMMath.abs = function (val) {
	    var tOfVal = _typeof$6(val);

	    if (tOfVal === 'object' && val.length) {
	      var absArr = createSizedArray(val.length);
	      var i;
	      var len = val.length;

	      for (i = 0; i < len; i += 1) {
	        absArr[i] = Math.abs(val[i]);
	      }

	      return absArr;
	    }

	    return Math.abs(val);
	  };

	  var defaultCurveSegments = 150;
	  var degToRads = Math.PI / 180;
	  var roundCorner = 0.5519;

	  function styleDiv(element) {
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = '0 0';
	    element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility = 'visible';
	    element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = 'preserve-3d';
	    element.style.webkitTransformStyle = 'preserve-3d';
	    element.style.mozTransformStyle = 'preserve-3d';
	  }

	  function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
	    this.type = type;
	    this.currentTime = currentTime;
	    this.totalTime = totalTime;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }

	  function BMCompleteEvent(type, frameMultiplier) {
	    this.type = type;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }

	  function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
	    this.type = type;
	    this.currentLoop = currentLoop;
	    this.totalLoops = totalLoops;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }

	  function BMSegmentStartEvent(type, firstFrame, totalFrames) {
	    this.type = type;
	    this.firstFrame = firstFrame;
	    this.totalFrames = totalFrames;
	  }

	  function BMDestroyEvent(type, target) {
	    this.type = type;
	    this.target = target;
	  }

	  function BMRenderFrameErrorEvent(nativeError, currentTime) {
	    this.type = 'renderFrameError';
	    this.nativeError = nativeError;
	    this.currentTime = currentTime;
	  }

	  function BMConfigErrorEvent(nativeError) {
	    this.type = 'configError';
	    this.nativeError = nativeError;
	  }

	  var createElementID = function () {
	    var _count = 0;
	    return function createID() {
	      _count += 1;
	      return idPrefix$1 + '__lottie_element_' + _count;
	    };
	  }();

	  function HSVtoRGB(h, s, v) {
	    var r;
	    var g;
	    var b;
	    var i;
	    var f;
	    var p;
	    var q;
	    var t;
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);

	    switch (i % 6) {
	      case 0:
	        r = v;
	        g = t;
	        b = p;
	        break;

	      case 1:
	        r = q;
	        g = v;
	        b = p;
	        break;

	      case 2:
	        r = p;
	        g = v;
	        b = t;
	        break;

	      case 3:
	        r = p;
	        g = q;
	        b = v;
	        break;

	      case 4:
	        r = t;
	        g = p;
	        b = v;
	        break;

	      case 5:
	        r = v;
	        g = p;
	        b = q;
	        break;
	    }

	    return [r, g, b];
	  }

	  function RGBtoHSV(r, g, b) {
	    var max = Math.max(r, g, b);
	    var min = Math.min(r, g, b);
	    var d = max - min;
	    var h;
	    var s = max === 0 ? 0 : d / max;
	    var v = max / 255;

	    switch (max) {
	      case min:
	        h = 0;
	        break;

	      case r:
	        h = g - b + d * (g < b ? 6 : 0);
	        h /= 6 * d;
	        break;

	      case g:
	        h = b - r + d * 2;
	        h /= 6 * d;
	        break;

	      case b:
	        h = r - g + d * 4;
	        h /= 6 * d;
	        break;
	    }

	    return [h, s, v];
	  }

	  function addSaturationToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[1] += offset;

	    if (hsv[1] > 1) {
	      hsv[1] = 1;
	    } else if (hsv[1] <= 0) {
	      hsv[1] = 0;
	    }

	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }

	  function addBrightnessToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[2] += offset;

	    if (hsv[2] > 1) {
	      hsv[2] = 1;
	    } else if (hsv[2] < 0) {
	      hsv[2] = 0;
	    }

	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }

	  function addHueToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[0] += offset / 360;

	    if (hsv[0] > 1) {
	      hsv[0] -= 1;
	    } else if (hsv[0] < 0) {
	      hsv[0] += 1;
	    }

	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }

	  var rgbToHex = function () {
	    var colorMap = [];
	    var i;
	    var hex;

	    for (i = 0; i < 256; i += 1) {
	      hex = i.toString(16);
	      colorMap[i] = hex.length === 1 ? '0' + hex : hex;
	    }

	    return function (r, g, b) {
	      if (r < 0) {
	        r = 0;
	      }

	      if (g < 0) {
	        g = 0;
	      }

	      if (b < 0) {
	        b = 0;
	      }

	      return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	  }();

	  var setSubframeEnabled = function setSubframeEnabled(flag) {
	    subframeEnabled = !!flag;
	  };

	  var getSubframeEnabled = function getSubframeEnabled() {
	    return subframeEnabled;
	  };

	  var setExpressionsPlugin = function setExpressionsPlugin(value) {
	    expressionsPlugin = value;
	  };

	  var getExpressionsPlugin = function getExpressionsPlugin() {
	    return expressionsPlugin;
	  };

	  var setExpressionInterfaces = function setExpressionInterfaces(value) {
	    expressionsInterfaces = value;
	  };

	  var getExpressionInterfaces = function getExpressionInterfaces() {
	    return expressionsInterfaces;
	  };

	  var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
	    defaultCurveSegments = value;
	  };

	  var getDefaultCurveSegments = function getDefaultCurveSegments() {
	    return defaultCurveSegments;
	  };

	  var setIdPrefix = function setIdPrefix(value) {
	    idPrefix$1 = value;
	  };

	  function createNS(type) {
	    // return {appendChild:function(){},setAttribute:function(){},style:{}}
	    return document.createElementNS(svgNS, type);
	  }

	  function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

	  var dataManager = function () {
	    var _counterId = 1;
	    var processes = [];
	    var workerFn;
	    var workerInstance;
	    var workerProxy = {
	      onmessage: function onmessage() {},
	      postMessage: function postMessage(path) {
	        workerFn({
	          data: path
	        });
	      }
	    };
	    var _workerSelf = {
	      postMessage: function postMessage(data) {
	        workerProxy.onmessage({
	          data: data
	        });
	      }
	    };

	    function createWorker(fn) {
	      if (window.Worker && window.Blob && getWebWorker()) {
	        var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], {
	          type: 'text/javascript'
	        }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });

	        var url = URL.createObjectURL(blob);
	        return new Worker(url);
	      }

	      workerFn = fn;
	      return workerProxy;
	    }

	    function setupWorker() {
	      if (!workerInstance) {
	        workerInstance = createWorker(function workerStart(e) {
	          function dataFunctionManager() {
	            function completeLayers(layers, comps) {
	              var layerData;
	              var i;
	              var len = layers.length;
	              var j;
	              var jLen;
	              var k;
	              var kLen;

	              for (i = 0; i < len; i += 1) {
	                layerData = layers[i];

	                if ('ks' in layerData && !layerData.completed) {
	                  layerData.completed = true;

	                  if (layerData.hasMask) {
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;

	                    for (j = 0; j < jLen; j += 1) {
	                      if (maskProps[j].pt.k.i) {
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                      } else {
	                        kLen = maskProps[j].pt.k.length;

	                        for (k = 0; k < kLen; k += 1) {
	                          if (maskProps[j].pt.k[k].s) {
	                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                          }

	                          if (maskProps[j].pt.k[k].e) {
	                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                          }
	                        }
	                      }
	                    }
	                  }

	                  if (layerData.ty === 0) {
	                    layerData.layers = findCompLayers(layerData.refId, comps);
	                    completeLayers(layerData.layers, comps);
	                  } else if (layerData.ty === 4) {
	                    completeShapes(layerData.shapes);
	                  } else if (layerData.ty === 5) {
	                    completeText(layerData);
	                  }
	                }
	              }
	            }

	            function completeChars(chars, assets) {
	              if (chars) {
	                var i = 0;
	                var len = chars.length;

	                for (i = 0; i < len; i += 1) {
	                  if (chars[i].t === 1) {
	                    // var compData = findComp(chars[i].data.refId, assets);
	                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
	                    // chars[i].data.op = 99999;
	                    // chars[i].data.st = 0;
	                    // chars[i].data.sr = 1;
	                    // chars[i].w = compData.w;
	                    // chars[i].data.ks = {
	                    //   a: { k: [0, 0, 0], a: 0 },
	                    //   p: { k: [0, -compData.h, 0], a: 0 },
	                    //   r: { k: 0, a: 0 },
	                    //   s: { k: [100, 100], a: 0 },
	                    //   o: { k: 100, a: 0 },
	                    // };

	                    completeLayers(chars[i].data.layers, assets);
	                  }
	                }
	              }
	            }

	            function findComp(id, comps) {
	              var i = 0;
	              var len = comps.length;

	              while (i < len) {
	                if (comps[i].id === id) {
	                  return comps[i];
	                }

	                i += 1;
	              }

	              return null;
	            }

	            function findCompLayers(id, comps) {
	              var comp = findComp(id, comps);

	              if (comp) {
	                if (!comp.layers.__used) {
	                  comp.layers.__used = true;
	                  return comp.layers;
	                }

	                return JSON.parse(JSON.stringify(comp.layers));
	              }

	              return null;
	            }

	            function completeShapes(arr) {
	              var i;
	              var len = arr.length;
	              var j;
	              var jLen;

	              for (i = len - 1; i >= 0; i -= 1) {
	                if (arr[i].ty === 'sh') {
	                  if (arr[i].ks.k.i) {
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                  } else {
	                    jLen = arr[i].ks.k.length;

	                    for (j = 0; j < jLen; j += 1) {
	                      if (arr[i].ks.k[j].s) {
	                        convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                      }

	                      if (arr[i].ks.k[j].e) {
	                        convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                      }
	                    }
	                  }
	                } else if (arr[i].ty === 'gr') {
	                  completeShapes(arr[i].it);
	                }
	              }
	            }

	            function convertPathsToAbsoluteValues(path) {
	              var i;
	              var len = path.i.length;

	              for (i = 0; i < len; i += 1) {
	                path.i[i][0] += path.v[i][0];
	                path.i[i][1] += path.v[i][1];
	                path.o[i][0] += path.v[i][0];
	                path.o[i][1] += path.v[i][1];
	              }
	            }

	            function checkVersion(minimum, animVersionString) {
	              var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];

	              if (minimum[0] > animVersion[0]) {
	                return true;
	              }

	              if (animVersion[0] > minimum[0]) {
	                return false;
	              }

	              if (minimum[1] > animVersion[1]) {
	                return true;
	              }

	              if (animVersion[1] > minimum[1]) {
	                return false;
	              }

	              if (minimum[2] > animVersion[2]) {
	                return true;
	              }

	              if (animVersion[2] > minimum[2]) {
	                return false;
	              }

	              return null;
	            }

	            var checkText = function () {
	              var minimumVersion = [4, 4, 14];

	              function updateTextLayer(textLayer) {
	                var documentData = textLayer.t.d;
	                textLayer.t.d = {
	                  k: [{
	                    s: documentData,
	                    t: 0
	                  }]
	                };
	              }

	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;

	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 5) {
	                    updateTextLayer(layers[i]);
	                  }
	                }
	              }

	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);

	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;

	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            var checkChars = function () {
	              var minimumVersion = [4, 7, 99];
	              return function (animationData) {
	                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
	                  var i;
	                  var len = animationData.chars.length;

	                  for (i = 0; i < len; i += 1) {
	                    var charData = animationData.chars[i];

	                    if (charData.data && charData.data.shapes) {
	                      completeShapes(charData.data.shapes);
	                      charData.data.ip = 0;
	                      charData.data.op = 99999;
	                      charData.data.st = 0;
	                      charData.data.sr = 1;
	                      charData.data.ks = {
	                        p: {
	                          k: [0, 0],
	                          a: 0
	                        },
	                        s: {
	                          k: [100, 100],
	                          a: 0
	                        },
	                        a: {
	                          k: [0, 0],
	                          a: 0
	                        },
	                        r: {
	                          k: 0,
	                          a: 0
	                        },
	                        o: {
	                          k: 100,
	                          a: 0
	                        }
	                      };

	                      if (!animationData.chars[i].t) {
	                        charData.data.shapes.push({
	                          ty: 'no'
	                        });
	                        charData.data.shapes[0].it.push({
	                          p: {
	                            k: [0, 0],
	                            a: 0
	                          },
	                          s: {
	                            k: [100, 100],
	                            a: 0
	                          },
	                          a: {
	                            k: [0, 0],
	                            a: 0
	                          },
	                          r: {
	                            k: 0,
	                            a: 0
	                          },
	                          o: {
	                            k: 100,
	                            a: 0
	                          },
	                          sk: {
	                            k: 0,
	                            a: 0
	                          },
	                          sa: {
	                            k: 0,
	                            a: 0
	                          },
	                          ty: 'tr'
	                        });
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            var checkPathProperties = function () {
	              var minimumVersion = [5, 7, 15];

	              function updateTextLayer(textLayer) {
	                var pathData = textLayer.t.p;

	                if (typeof pathData.a === 'number') {
	                  pathData.a = {
	                    a: 0,
	                    k: pathData.a
	                  };
	                }

	                if (typeof pathData.p === 'number') {
	                  pathData.p = {
	                    a: 0,
	                    k: pathData.p
	                  };
	                }

	                if (typeof pathData.r === 'number') {
	                  pathData.r = {
	                    a: 0,
	                    k: pathData.r
	                  };
	                }
	              }

	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;

	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 5) {
	                    updateTextLayer(layers[i]);
	                  }
	                }
	              }

	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);

	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;

	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            var checkColors = function () {
	              var minimumVersion = [4, 1, 9];

	              function iterateShapes(shapes) {
	                var i;
	                var len = shapes.length;
	                var j;
	                var jLen;

	                for (i = 0; i < len; i += 1) {
	                  if (shapes[i].ty === 'gr') {
	                    iterateShapes(shapes[i].it);
	                  } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
	                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
	                      jLen = shapes[i].c.k.length;

	                      for (j = 0; j < jLen; j += 1) {
	                        if (shapes[i].c.k[j].s) {
	                          shapes[i].c.k[j].s[0] /= 255;
	                          shapes[i].c.k[j].s[1] /= 255;
	                          shapes[i].c.k[j].s[2] /= 255;
	                          shapes[i].c.k[j].s[3] /= 255;
	                        }

	                        if (shapes[i].c.k[j].e) {
	                          shapes[i].c.k[j].e[0] /= 255;
	                          shapes[i].c.k[j].e[1] /= 255;
	                          shapes[i].c.k[j].e[2] /= 255;
	                          shapes[i].c.k[j].e[3] /= 255;
	                        }
	                      }
	                    } else {
	                      shapes[i].c.k[0] /= 255;
	                      shapes[i].c.k[1] /= 255;
	                      shapes[i].c.k[2] /= 255;
	                      shapes[i].c.k[3] /= 255;
	                    }
	                  }
	                }
	              }

	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;

	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 4) {
	                    iterateShapes(layers[i].shapes);
	                  }
	                }
	              }

	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);

	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;

	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            var checkShapes = function () {
	              var minimumVersion = [4, 4, 18];

	              function completeClosingShapes(arr) {
	                var i;
	                var len = arr.length;
	                var j;
	                var jLen;

	                for (i = len - 1; i >= 0; i -= 1) {
	                  if (arr[i].ty === 'sh') {
	                    if (arr[i].ks.k.i) {
	                      arr[i].ks.k.c = arr[i].closed;
	                    } else {
	                      jLen = arr[i].ks.k.length;

	                      for (j = 0; j < jLen; j += 1) {
	                        if (arr[i].ks.k[j].s) {
	                          arr[i].ks.k[j].s[0].c = arr[i].closed;
	                        }

	                        if (arr[i].ks.k[j].e) {
	                          arr[i].ks.k[j].e[0].c = arr[i].closed;
	                        }
	                      }
	                    }
	                  } else if (arr[i].ty === 'gr') {
	                    completeClosingShapes(arr[i].it);
	                  }
	                }
	              }

	              function iterateLayers(layers) {
	                var layerData;
	                var i;
	                var len = layers.length;
	                var j;
	                var jLen;
	                var k;
	                var kLen;

	                for (i = 0; i < len; i += 1) {
	                  layerData = layers[i];

	                  if (layerData.hasMask) {
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;

	                    for (j = 0; j < jLen; j += 1) {
	                      if (maskProps[j].pt.k.i) {
	                        maskProps[j].pt.k.c = maskProps[j].cl;
	                      } else {
	                        kLen = maskProps[j].pt.k.length;

	                        for (k = 0; k < kLen; k += 1) {
	                          if (maskProps[j].pt.k[k].s) {
	                            maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                          }

	                          if (maskProps[j].pt.k[k].e) {
	                            maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                          }
	                        }
	                      }
	                    }
	                  }

	                  if (layerData.ty === 4) {
	                    completeClosingShapes(layerData.shapes);
	                  }
	                }
	              }

	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);

	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;

	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            function completeData(animationData) {
	              if (animationData.__complete) {
	                return;
	              }

	              checkColors(animationData);
	              checkText(animationData);
	              checkChars(animationData);
	              checkPathProperties(animationData);
	              checkShapes(animationData);
	              completeLayers(animationData.layers, animationData.assets);
	              completeChars(animationData.chars, animationData.assets);
	              animationData.__complete = true;
	            }

	            function completeText(data) {
	              if (data.t.a.length === 0 && !('m' in data.t.p)) ;
	            }

	            var moduleOb = {};
	            moduleOb.completeData = completeData;
	            moduleOb.checkColors = checkColors;
	            moduleOb.checkChars = checkChars;
	            moduleOb.checkPathProperties = checkPathProperties;
	            moduleOb.checkShapes = checkShapes;
	            moduleOb.completeLayers = completeLayers;
	            return moduleOb;
	          }

	          if (!_workerSelf.dataManager) {
	            _workerSelf.dataManager = dataFunctionManager();
	          }

	          if (!_workerSelf.assetLoader) {
	            _workerSelf.assetLoader = function () {
	              function formatResponse(xhr) {
	                // using typeof doubles the time of execution of this method,
	                // so if available, it's better to use the header to validate the type
	                var contentTypeHeader = xhr.getResponseHeader('content-type');

	                if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
	                  return xhr.response;
	                }

	                if (xhr.response && _typeof$5(xhr.response) === 'object') {
	                  return xhr.response;
	                }

	                if (xhr.response && typeof xhr.response === 'string') {
	                  return JSON.parse(xhr.response);
	                }

	                if (xhr.responseText) {
	                  return JSON.parse(xhr.responseText);
	                }

	                return null;
	              }

	              function loadAsset(path, fullPath, callback, errorCallback) {
	                var response;
	                var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.

	                try {
	                  // This crashes on Android WebView prior to KitKat
	                  xhr.responseType = 'json';
	                } catch (err) {} // eslint-disable-line no-empty


	                xhr.onreadystatechange = function () {
	                  if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                      response = formatResponse(xhr);
	                      callback(response);
	                    } else {
	                      try {
	                        response = formatResponse(xhr);
	                        callback(response);
	                      } catch (err) {
	                        if (errorCallback) {
	                          errorCallback(err);
	                        }
	                      }
	                    }
	                  }
	                };

	                try {
	                  // Hack to workaround banner validation
	                  xhr.open(['G', 'E', 'T'].join(''), path, true);
	                } catch (error) {
	                  // Hack to workaround banner validation
	                  xhr.open(['G', 'E', 'T'].join(''), fullPath + '/' + path, true);
	                }

	                xhr.send();
	              }

	              return {
	                load: loadAsset
	              };
	            }();
	          }

	          if (e.data.type === 'loadAnimation') {
	            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
	              _workerSelf.dataManager.completeData(data);

	              _workerSelf.postMessage({
	                id: e.data.id,
	                payload: data,
	                status: 'success'
	              });
	            }, function () {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                status: 'error'
	              });
	            });
	          } else if (e.data.type === 'complete') {
	            var animation = e.data.animation;

	            _workerSelf.dataManager.completeData(animation);

	            _workerSelf.postMessage({
	              id: e.data.id,
	              payload: animation,
	              status: 'success'
	            });
	          } else if (e.data.type === 'loadData') {
	            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                payload: data,
	                status: 'success'
	              });
	            }, function () {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                status: 'error'
	              });
	            });
	          }
	        });

	        workerInstance.onmessage = function (event) {
	          var data = event.data;
	          var id = data.id;
	          var process = processes[id];
	          processes[id] = null;

	          if (data.status === 'success') {
	            process.onComplete(data.payload);
	          } else if (process.onError) {
	            process.onError();
	          }
	        };
	      }
	    }

	    function createProcess(onComplete, onError) {
	      _counterId += 1;
	      var id = 'processId_' + _counterId;
	      processes[id] = {
	        onComplete: onComplete,
	        onError: onError
	      };
	      return id;
	    }

	    function loadAnimation(path, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'loadAnimation',
	        path: path,
	        fullPath: window.location.origin + window.location.pathname,
	        id: processId
	      });
	    }

	    function loadData(path, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'loadData',
	        path: path,
	        fullPath: window.location.origin + window.location.pathname,
	        id: processId
	      });
	    }

	    function completeAnimation(anim, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'complete',
	        animation: anim,
	        id: processId
	      });
	    }

	    return {
	      loadAnimation: loadAnimation,
	      loadData: loadData,
	      completeAnimation: completeAnimation
	    };
	  }();

	  var ImagePreloader = function () {
	    var proxyImage = function () {
	      var canvas = createTag('canvas');
	      canvas.width = 1;
	      canvas.height = 1;
	      var ctx = canvas.getContext('2d');
	      ctx.fillStyle = 'rgba(0,0,0,0)';
	      ctx.fillRect(0, 0, 1, 1);
	      return canvas;
	    }();

	    function imageLoaded() {
	      this.loadedAssets += 1;

	      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
	        if (this.imagesLoadedCb) {
	          this.imagesLoadedCb(null);
	        }
	      }
	    }

	    function footageLoaded() {
	      this.loadedFootagesCount += 1;

	      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
	        if (this.imagesLoadedCb) {
	          this.imagesLoadedCb(null);
	        }
	      }
	    }

	    function getAssetsPath(assetData, assetsPath, originalPath) {
	      var path = '';

	      if (assetData.e) {
	        path = assetData.p;
	      } else if (assetsPath) {
	        var imagePath = assetData.p;

	        if (imagePath.indexOf('images/') !== -1) {
	          imagePath = imagePath.split('/')[1];
	        }

	        path = assetsPath + imagePath;
	      } else {
	        path = originalPath;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	      }

	      return path;
	    }

	    function testImageLoaded(img) {
	      var _count = 0;
	      var intervalId = setInterval(function () {
	        var box = img.getBBox();

	        if (box.width || _count > 500) {
	          this._imageLoaded();

	          clearInterval(intervalId);
	        }

	        _count += 1;
	      }.bind(this), 50);
	    }

	    function createImageData(assetData) {
	      var path = getAssetsPath(assetData, this.assetsPath, this.path);
	      var img = createNS('image');

	      if (isSafari) {
	        this.testImageLoaded(img);
	      } else {
	        img.addEventListener('load', this._imageLoaded, false);
	      }

	      img.addEventListener('error', function () {
	        ob.img = proxyImage;

	        this._imageLoaded();
	      }.bind(this), false);
	      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);

	      if (this._elementHelper.append) {
	        this._elementHelper.append(img);
	      } else {
	        this._elementHelper.appendChild(img);
	      }

	      var ob = {
	        img: img,
	        assetData: assetData
	      };
	      return ob;
	    }

	    function createImgData(assetData) {
	      var path = getAssetsPath(assetData, this.assetsPath, this.path);
	      var img = createTag('img');
	      img.crossOrigin = 'anonymous';
	      img.addEventListener('load', this._imageLoaded, false);
	      img.addEventListener('error', function () {
	        ob.img = proxyImage;

	        this._imageLoaded();
	      }.bind(this), false);
	      img.src = path;
	      var ob = {
	        img: img,
	        assetData: assetData
	      };
	      return ob;
	    }

	    function createFootageData(data) {
	      var ob = {
	        assetData: data
	      };
	      var path = getAssetsPath(data, this.assetsPath, this.path);
	      dataManager.loadData(path, function (footageData) {
	        ob.img = footageData;

	        this._footageLoaded();
	      }.bind(this), function () {
	        ob.img = {};

	        this._footageLoaded();
	      }.bind(this));
	      return ob;
	    }

	    function loadAssets(assets, cb) {
	      this.imagesLoadedCb = cb;
	      var i;
	      var len = assets.length;

	      for (i = 0; i < len; i += 1) {
	        if (!assets[i].layers) {
	          if (!assets[i].t || assets[i].t === 'seq') {
	            this.totalImages += 1;
	            this.images.push(this._createImageData(assets[i]));
	          } else if (assets[i].t === 3) {
	            this.totalFootages += 1;
	            this.images.push(this.createFootageData(assets[i]));
	          }
	        }
	      }
	    }

	    function setPath(path) {
	      this.path = path || '';
	    }

	    function setAssetsPath(path) {
	      this.assetsPath = path || '';
	    }

	    function getAsset(assetData) {
	      var i = 0;
	      var len = this.images.length;

	      while (i < len) {
	        if (this.images[i].assetData === assetData) {
	          return this.images[i].img;
	        }

	        i += 1;
	      }

	      return null;
	    }

	    function destroy() {
	      this.imagesLoadedCb = null;
	      this.images.length = 0;
	    }

	    function loadedImages() {
	      return this.totalImages === this.loadedAssets;
	    }

	    function loadedFootages() {
	      return this.totalFootages === this.loadedFootagesCount;
	    }

	    function setCacheType(type, elementHelper) {
	      if (type === 'svg') {
	        this._elementHelper = elementHelper;
	        this._createImageData = this.createImageData.bind(this);
	      } else {
	        this._createImageData = this.createImgData.bind(this);
	      }
	    }

	    function ImagePreloaderFactory() {
	      this._imageLoaded = imageLoaded.bind(this);
	      this._footageLoaded = footageLoaded.bind(this);
	      this.testImageLoaded = testImageLoaded.bind(this);
	      this.createFootageData = createFootageData.bind(this);
	      this.assetsPath = '';
	      this.path = '';
	      this.totalImages = 0;
	      this.totalFootages = 0;
	      this.loadedAssets = 0;
	      this.loadedFootagesCount = 0;
	      this.imagesLoadedCb = null;
	      this.images = [];
	    }

	    ImagePreloaderFactory.prototype = {
	      loadAssets: loadAssets,
	      setAssetsPath: setAssetsPath,
	      setPath: setPath,
	      loadedImages: loadedImages,
	      loadedFootages: loadedFootages,
	      destroy: destroy,
	      getAsset: getAsset,
	      createImgData: createImgData,
	      createImageData: createImageData,
	      imageLoaded: imageLoaded,
	      footageLoaded: footageLoaded,
	      setCacheType: setCacheType
	    };
	    return ImagePreloaderFactory;
	  }();

	  function BaseEvent() {}

	  BaseEvent.prototype = {
	    triggerEvent: function triggerEvent(eventName, args) {
	      if (this._cbs[eventName]) {
	        var callbacks = this._cbs[eventName];

	        for (var i = 0; i < callbacks.length; i += 1) {
	          callbacks[i](args);
	        }
	      }
	    },
	    addEventListener: function addEventListener(eventName, callback) {
	      if (!this._cbs[eventName]) {
	        this._cbs[eventName] = [];
	      }

	      this._cbs[eventName].push(callback);

	      return function () {
	        this.removeEventListener(eventName, callback);
	      }.bind(this);
	    },
	    removeEventListener: function removeEventListener(eventName, callback) {
	      if (!callback) {
	        this._cbs[eventName] = null;
	      } else if (this._cbs[eventName]) {
	        var i = 0;
	        var len = this._cbs[eventName].length;

	        while (i < len) {
	          if (this._cbs[eventName][i] === callback) {
	            this._cbs[eventName].splice(i, 1);

	            i -= 1;
	            len -= 1;
	          }

	          i += 1;
	        }

	        if (!this._cbs[eventName].length) {
	          this._cbs[eventName] = null;
	        }
	      }
	    }
	  };

	  var markerParser = function () {
	    function parsePayloadLines(payload) {
	      var lines = payload.split('\r\n');
	      var keys = {};
	      var line;
	      var keysCount = 0;

	      for (var i = 0; i < lines.length; i += 1) {
	        line = lines[i].split(':');

	        if (line.length === 2) {
	          keys[line[0]] = line[1].trim();
	          keysCount += 1;
	        }
	      }

	      if (keysCount === 0) {
	        throw new Error();
	      }

	      return keys;
	    }

	    return function (_markers) {
	      var markers = [];

	      for (var i = 0; i < _markers.length; i += 1) {
	        var _marker = _markers[i];
	        var markerData = {
	          time: _marker.tm,
	          duration: _marker.dr
	        };

	        try {
	          markerData.payload = JSON.parse(_markers[i].cm);
	        } catch (_) {
	          try {
	            markerData.payload = parsePayloadLines(_markers[i].cm);
	          } catch (__) {
	            markerData.payload = {
	              name: _markers[i].cm
	            };
	          }
	        }

	        markers.push(markerData);
	      }

	      return markers;
	    };
	  }();

	  var ProjectInterface = function () {
	    function registerComposition(comp) {
	      this.compositions.push(comp);
	    }

	    return function () {
	      function _thisProjectFunction(name) {
	        var i = 0;
	        var len = this.compositions.length;

	        while (i < len) {
	          if (this.compositions[i].data && this.compositions[i].data.nm === name) {
	            if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
	              this.compositions[i].prepareFrame(this.currentFrame);
	            }

	            return this.compositions[i].compInterface;
	          }

	          i += 1;
	        }

	        return null;
	      }

	      _thisProjectFunction.compositions = [];
	      _thisProjectFunction.currentFrame = 0;
	      _thisProjectFunction.registerComposition = registerComposition;
	      return _thisProjectFunction;
	    };
	  }();

	  var renderers = {};

	  var registerRenderer = function registerRenderer(key, value) {
	    renderers[key] = value;
	  };

	  function getRenderer(key) {
	    return renderers[key];
	  }

	  function getRegisteredRenderer() {
	    // Returns canvas by default for compatibility
	    if (renderers.canvas) {
	      return 'canvas';
	    } // Returns any renderer that is registered


	    for (var key in renderers) {
	      if (renderers[key]) {
	        return key;
	      }
	    }

	    return '';
	  }

	  function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

	  var AnimationItem = function AnimationItem() {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.firstFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.playCount = 0;
	    this.animationData = {};
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = createElementID();
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.isSubframeEnabled = getSubframeEnabled();
	    this.segments = [];
	    this._idle = true;
	    this._completedLoop = false;
	    this.projectInterface = ProjectInterface();
	    this.imagePreloader = new ImagePreloader();
	    this.audioController = audioControllerFactory();
	    this.markers = [];
	    this.configAnimation = this.configAnimation.bind(this);
	    this.onSetupError = this.onSetupError.bind(this);
	    this.onSegmentComplete = this.onSegmentComplete.bind(this);
	    this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
	    this.expressionsPlugin = getExpressionsPlugin();
	  };

	  extendPrototype([BaseEvent], AnimationItem);

	  AnimationItem.prototype.setParams = function (params) {
	    if (params.wrapper || params.container) {
	      this.wrapper = params.wrapper || params.container;
	    }

	    var animType = 'svg';

	    if (params.animType) {
	      animType = params.animType;
	    } else if (params.renderer) {
	      animType = params.renderer;
	    }

	    var RendererClass = getRenderer(animType);
	    this.renderer = new RendererClass(this, params.rendererSettings);
	    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;

	    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) {
	      this.loop = true;
	    } else if (params.loop === false) {
	      this.loop = false;
	    } else {
	      this.loop = parseInt(params.loop, 10);
	    }

	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name : '';
	    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
	    this.assetsPath = params.assetsPath;
	    this.initialSegment = params.initialSegment;

	    if (params.audioFactory) {
	      this.audioController.setAudioFactory(params.audioFactory);
	    }

	    if (params.animationData) {
	      this.setupAnimation(params.animationData);
	    } else if (params.path) {
	      if (params.path.lastIndexOf('\\') !== -1) {
	        this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
	      } else {
	        this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
	      }

	      this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
	      this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
	      dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
	    }
	  };

	  AnimationItem.prototype.onSetupError = function () {
	    this.trigger('data_failed');
	  };

	  AnimationItem.prototype.setupAnimation = function (data) {
	    dataManager.completeAnimation(data, this.configAnimation);
	  };

	  AnimationItem.prototype.setData = function (wrapper, animationData) {
	    if (animationData) {
	      if (_typeof$4(animationData) !== 'object') {
	        animationData = JSON.parse(animationData);
	      }
	    }

	    var params = {
	      wrapper: wrapper,
	      animationData: animationData
	    };
	    var wrapperAttributes = wrapper.attributes;
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';

	    if (loop === 'false') {
	      params.loop = false;
	    } else if (loop === 'true') {
	      params.loop = true;
	    } else if (loop !== '') {
	      params.loop = parseInt(loop, 10);
	    }

	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== 'false';
	    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

	    if (prerender === 'false') {
	      params.prerender = false;
	    }

	    if (!params.path) {
	      this.trigger('destroy');
	    } else {
	      this.setParams(params);
	    }
	  };

	  AnimationItem.prototype.includeLayers = function (data) {
	    if (data.op > this.animationData.op) {
	      this.animationData.op = data.op;
	      this.totalFrames = Math.floor(data.op - this.animationData.ip);
	    }

	    var layers = this.animationData.layers;
	    var i;
	    var len = layers.length;
	    var newLayers = data.layers;
	    var j;
	    var jLen = newLayers.length;

	    for (j = 0; j < jLen; j += 1) {
	      i = 0;

	      while (i < len) {
	        if (layers[i].id === newLayers[j].id) {
	          layers[i] = newLayers[j];
	          break;
	        }

	        i += 1;
	      }
	    }

	    if (data.chars || data.fonts) {
	      this.renderer.globalData.fontManager.addChars(data.chars);
	      this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }

	    if (data.assets) {
	      len = data.assets.length;

	      for (i = 0; i < len; i += 1) {
	        this.animationData.assets.push(data.assets[i]);
	      }
	    }

	    this.animationData.__complete = false;
	    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
	  };

	  AnimationItem.prototype.onSegmentComplete = function (data) {
	    this.animationData = data;
	    var expressionsPlugin = getExpressionsPlugin();

	    if (expressionsPlugin) {
	      expressionsPlugin.initExpressions(this);
	    }

	    this.loadNextSegment();
	  };

	  AnimationItem.prototype.loadNextSegment = function () {
	    var segments = this.animationData.segments;

	    if (!segments || segments.length === 0 || !this.autoloadSegments) {
	      this.trigger('data_ready');
	      this.timeCompleted = this.totalFrames;
	      return;
	    }

	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
	      this.trigger('data_failed');
	    }.bind(this));
	  };

	  AnimationItem.prototype.loadSegments = function () {
	    var segments = this.animationData.segments;

	    if (!segments) {
	      this.timeCompleted = this.totalFrames;
	    }

	    this.loadNextSegment();
	  };

	  AnimationItem.prototype.imagesLoaded = function () {
	    this.trigger('loaded_images');
	    this.checkLoaded();
	  };

	  AnimationItem.prototype.preloadImages = function () {
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
	  };

	  AnimationItem.prototype.configAnimation = function (animData) {
	    if (!this.renderer) {
	      return;
	    }

	    try {
	      this.animationData = animData;

	      if (this.initialSegment) {
	        this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
	        this.firstFrame = Math.round(this.initialSegment[0]);
	      } else {
	        this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	        this.firstFrame = Math.round(this.animationData.ip);
	      }

	      this.renderer.configAnimation(animData);

	      if (!animData.assets) {
	        animData.assets = [];
	      }

	      this.assets = this.animationData.assets;
	      this.frameRate = this.animationData.fr;
	      this.frameMult = this.animationData.fr / 1000;
	      this.renderer.searchExtraCompositions(animData.assets);
	      this.markers = markerParser(animData.markers || []);
	      this.trigger('config_ready');
	      this.preloadImages();
	      this.loadSegments();
	      this.updaFrameModifier();
	      this.waitForFontsLoaded();

	      if (this.isPaused) {
	        this.audioController.pause();
	      }
	    } catch (error) {
	      this.triggerConfigError(error);
	    }
	  };

	  AnimationItem.prototype.waitForFontsLoaded = function () {
	    if (!this.renderer) {
	      return;
	    }

	    if (this.renderer.globalData.fontManager.isLoaded) {
	      this.checkLoaded();
	    } else {
	      setTimeout(this.waitForFontsLoaded.bind(this), 20);
	    }
	  };

	  AnimationItem.prototype.checkLoaded = function () {
	    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
	      this.isLoaded = true;
	      var expressionsPlugin = getExpressionsPlugin();

	      if (expressionsPlugin) {
	        expressionsPlugin.initExpressions(this);
	      }

	      this.renderer.initItems();
	      setTimeout(function () {
	        this.trigger('DOMLoaded');
	      }.bind(this), 0);
	      this.gotoFrame();

	      if (this.autoplay) {
	        this.play();
	      }
	    }
	  };

	  AnimationItem.prototype.resize = function (width, height) {
	    // Adding this validation for backwards compatibility in case an event object was being passed down
	    var _width = typeof width === 'number' ? width : undefined;

	    var _height = typeof height === 'number' ? height : undefined;

	    this.renderer.updateContainerSize(_width, _height);
	  };

	  AnimationItem.prototype.setSubframe = function (flag) {
	    this.isSubframeEnabled = !!flag;
	  };

	  AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

	    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
	      this.currentFrame = this.timeCompleted;
	    }

	    this.trigger('enterFrame');
	    this.renderFrame();
	    this.trigger('drawnFrame');
	  };

	  AnimationItem.prototype.renderFrame = function () {
	    if (this.isLoaded === false || !this.renderer) {
	      return;
	    }

	    try {
	      if (this.expressionsPlugin) {
	        this.expressionsPlugin.resetFrame();
	      }

	      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	    } catch (error) {
	      this.triggerRenderFrameError(error);
	    }
	  };

	  AnimationItem.prototype.play = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    if (this.isPaused === true) {
	      this.isPaused = false;
	      this.trigger('_play');
	      this.audioController.resume();

	      if (this._idle) {
	        this._idle = false;
	        this.trigger('_active');
	      }
	    }
	  };

	  AnimationItem.prototype.pause = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    if (this.isPaused === false) {
	      this.isPaused = true;
	      this.trigger('_pause');
	      this._idle = true;
	      this.trigger('_idle');
	      this.audioController.pause();
	    }
	  };

	  AnimationItem.prototype.togglePause = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    if (this.isPaused === true) {
	      this.play();
	    } else {
	      this.pause();
	    }
	  };

	  AnimationItem.prototype.stop = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    this.pause();
	    this.playCount = 0;
	    this._completedLoop = false;
	    this.setCurrentRawFrameValue(0);
	  };

	  AnimationItem.prototype.getMarkerData = function (markerName) {
	    var marker;

	    for (var i = 0; i < this.markers.length; i += 1) {
	      marker = this.markers[i];

	      if (marker.payload && marker.payload.name === markerName) {
	        return marker;
	      }
	    }

	    return null;
	  };

	  AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    var numValue = Number(value);

	    if (isNaN(numValue)) {
	      var marker = this.getMarkerData(value);

	      if (marker) {
	        this.goToAndStop(marker.time, true);
	      }
	    } else if (isFrame) {
	      this.setCurrentRawFrameValue(value);
	    } else {
	      this.setCurrentRawFrameValue(value * this.frameModifier);
	    }

	    this.pause();
	  };

	  AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    var numValue = Number(value);

	    if (isNaN(numValue)) {
	      var marker = this.getMarkerData(value);

	      if (marker) {
	        if (!marker.duration) {
	          this.goToAndStop(marker.time, true);
	        } else {
	          this.playSegments([marker.time, marker.time + marker.duration], true);
	        }
	      }
	    } else {
	      this.goToAndStop(numValue, isFrame, name);
	    }

	    this.play();
	  };

	  AnimationItem.prototype.advanceTime = function (value) {
	    if (this.isPaused === true || this.isLoaded === false) {
	      return;
	    }

	    var nextValue = this.currentRawFrame + value * this.frameModifier;
	    var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.

	    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
	      if (!this.loop || this.playCount === this.loop) {
	        if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
	          _isComplete = true;
	          nextValue = this.totalFrames - 1;
	        }
	      } else if (nextValue >= this.totalFrames) {
	        this.playCount += 1;

	        if (!this.checkSegments(nextValue % this.totalFrames)) {
	          this.setCurrentRawFrameValue(nextValue % this.totalFrames);
	          this._completedLoop = true;
	          this.trigger('loopComplete');
	        }
	      } else {
	        this.setCurrentRawFrameValue(nextValue);
	      }
	    } else if (nextValue < 0) {
	      if (!this.checkSegments(nextValue % this.totalFrames)) {
	        if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
	          // eslint-disable-line no-plusplus
	          this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);

	          if (!this._completedLoop) {
	            this._completedLoop = true;
	          } else {
	            this.trigger('loopComplete');
	          }
	        } else {
	          _isComplete = true;
	          nextValue = 0;
	        }
	      }
	    } else {
	      this.setCurrentRawFrameValue(nextValue);
	    }

	    if (_isComplete) {
	      this.setCurrentRawFrameValue(nextValue);
	      this.pause();
	      this.trigger('complete');
	    }
	  };

	  AnimationItem.prototype.adjustSegment = function (arr, offset) {
	    this.playCount = 0;

	    if (arr[1] < arr[0]) {
	      if (this.frameModifier > 0) {
	        if (this.playSpeed < 0) {
	          this.setSpeed(-this.playSpeed);
	        } else {
	          this.setDirection(-1);
	        }
	      }

	      this.totalFrames = arr[0] - arr[1];
	      this.timeCompleted = this.totalFrames;
	      this.firstFrame = arr[1];
	      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
	    } else if (arr[1] > arr[0]) {
	      if (this.frameModifier < 0) {
	        if (this.playSpeed < 0) {
	          this.setSpeed(-this.playSpeed);
	        } else {
	          this.setDirection(1);
	        }
	      }

	      this.totalFrames = arr[1] - arr[0];
	      this.timeCompleted = this.totalFrames;
	      this.firstFrame = arr[0];
	      this.setCurrentRawFrameValue(0.001 + offset);
	    }

	    this.trigger('segmentStart');
	  };

	  AnimationItem.prototype.setSegment = function (init, end) {
	    var pendingFrame = -1;

	    if (this.isPaused) {
	      if (this.currentRawFrame + this.firstFrame < init) {
	        pendingFrame = init;
	      } else if (this.currentRawFrame + this.firstFrame > end) {
	        pendingFrame = end - init;
	      }
	    }

	    this.firstFrame = init;
	    this.totalFrames = end - init;
	    this.timeCompleted = this.totalFrames;

	    if (pendingFrame !== -1) {
	      this.goToAndStop(pendingFrame, true);
	    }
	  };

	  AnimationItem.prototype.playSegments = function (arr, forceFlag) {
	    if (forceFlag) {
	      this.segments.length = 0;
	    }

	    if (_typeof$4(arr[0]) === 'object') {
	      var i;
	      var len = arr.length;

	      for (i = 0; i < len; i += 1) {
	        this.segments.push(arr[i]);
	      }
	    } else {
	      this.segments.push(arr);
	    }

	    if (this.segments.length && forceFlag) {
	      this.adjustSegment(this.segments.shift(), 0);
	    }

	    if (this.isPaused) {
	      this.play();
	    }
	  };

	  AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip, this.animationData.op]);

	    if (forceFlag) {
	      this.checkSegments(0);
	    }
	  };

	  AnimationItem.prototype.checkSegments = function (offset) {
	    if (this.segments.length) {
	      this.adjustSegment(this.segments.shift(), offset);
	      return true;
	    }

	    return false;
	  };

	  AnimationItem.prototype.destroy = function (name) {
	    if (name && this.name !== name || !this.renderer) {
	      return;
	    }

	    this.renderer.destroy();
	    this.imagePreloader.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = null;
	    this.onLoopComplete = null;
	    this.onComplete = null;
	    this.onSegmentStart = null;
	    this.onDestroy = null;
	    this.renderer = null;
	    this.expressionsPlugin = null;
	    this.imagePreloader = null;
	    this.projectInterface = null;
	  };

	  AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
	    this.currentRawFrame = value;
	    this.gotoFrame();
	  };

	  AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	  };

	  AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	  };

	  AnimationItem.prototype.setLoop = function (isLooping) {
	    this.loop = isLooping;
	  };

	  AnimationItem.prototype.setVolume = function (val, name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    this.audioController.setVolume(val);
	  };

	  AnimationItem.prototype.getVolume = function () {
	    return this.audioController.getVolume();
	  };

	  AnimationItem.prototype.mute = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    this.audioController.mute();
	  };

	  AnimationItem.prototype.unmute = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    this.audioController.unmute();
	  };

	  AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	    this.audioController.setRate(this.playSpeed * this.playDirection);
	  };

	  AnimationItem.prototype.getPath = function () {
	    return this.path;
	  };

	  AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';

	    if (assetData.e) {
	      path = assetData.p;
	    } else if (this.assetsPath) {
	      var imagePath = assetData.p;

	      if (imagePath.indexOf('images/') !== -1) {
	        imagePath = imagePath.split('/')[1];
	      }

	      path = this.assetsPath + imagePath;
	    } else {
	      path = this.path;
	      path += assetData.u ? assetData.u : '';
	      path += assetData.p;
	    }

	    return path;
	  };

	  AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0;
	    var len = this.assets.length;

	    while (i < len) {
	      if (id === this.assets[i].id) {
	        return this.assets[i];
	      }

	      i += 1;
	    }

	    return null;
	  };

	  AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	  };

	  AnimationItem.prototype.show = function () {
	    this.renderer.show();
	  };

	  AnimationItem.prototype.getDuration = function (isFrame) {
	    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
	  };

	  AnimationItem.prototype.updateDocumentData = function (path, documentData, index) {
	    try {
	      var element = this.renderer.getElementByPath(path);
	      element.updateDocumentData(documentData, index);
	    } catch (error) {// TODO: decide how to handle catch case
	    }
	  };

	  AnimationItem.prototype.trigger = function (name) {
	    if (this._cbs && this._cbs[name]) {
	      switch (name) {
	        case 'enterFrame':
	          this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
	          break;

	        case 'drawnFrame':
	          this.drawnFrameEvent.currentTime = this.currentFrame;
	          this.drawnFrameEvent.totalTime = this.totalFrames;
	          this.drawnFrameEvent.direction = this.frameModifier;
	          this.triggerEvent(name, this.drawnFrameEvent);
	          break;

	        case 'loopComplete':
	          this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
	          break;

	        case 'complete':
	          this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
	          break;

	        case 'segmentStart':
	          this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
	          break;

	        case 'destroy':
	          this.triggerEvent(name, new BMDestroyEvent(name, this));
	          break;

	        default:
	          this.triggerEvent(name);
	      }
	    }

	    if (name === 'enterFrame' && this.onEnterFrame) {
	      this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
	    }

	    if (name === 'loopComplete' && this.onLoopComplete) {
	      this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
	    }

	    if (name === 'complete' && this.onComplete) {
	      this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
	    }

	    if (name === 'segmentStart' && this.onSegmentStart) {
	      this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
	    }

	    if (name === 'destroy' && this.onDestroy) {
	      this.onDestroy.call(this, new BMDestroyEvent(name, this));
	    }
	  };

	  AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
	    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);

	    if (this.onError) {
	      this.onError.call(this, error);
	    }
	  };

	  AnimationItem.prototype.triggerConfigError = function (nativeError) {
	    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);

	    if (this.onError) {
	      this.onError.call(this, error);
	    }
	  };

	  var animationManager = function () {
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var playingAnimationsNum = 0;
	    var _stopped = true;
	    var _isFrozen = false;

	    function removeElement(ev) {
	      var i = 0;
	      var animItem = ev.target;

	      while (i < len) {
	        if (registeredAnimations[i].animation === animItem) {
	          registeredAnimations.splice(i, 1);
	          i -= 1;
	          len -= 1;

	          if (!animItem.isPaused) {
	            subtractPlayingCount();
	          }
	        }

	        i += 1;
	      }
	    }

	    function registerAnimation(element, animationData) {
	      if (!element) {
	        return null;
	      }

	      var i = 0;

	      while (i < len) {
	        if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
	          return registeredAnimations[i].animation;
	        }

	        i += 1;
	      }

	      var animItem = new AnimationItem();
	      setupAnimation(animItem, element);
	      animItem.setData(element, animationData);
	      return animItem;
	    }

	    function getRegisteredAnimations() {
	      var i;
	      var lenAnims = registeredAnimations.length;
	      var animations = [];

	      for (i = 0; i < lenAnims; i += 1) {
	        animations.push(registeredAnimations[i].animation);
	      }

	      return animations;
	    }

	    function addPlayingCount() {
	      playingAnimationsNum += 1;
	      activate();
	    }

	    function subtractPlayingCount() {
	      playingAnimationsNum -= 1;
	    }

	    function setupAnimation(animItem, element) {
	      animItem.addEventListener('destroy', removeElement);
	      animItem.addEventListener('_active', addPlayingCount);
	      animItem.addEventListener('_idle', subtractPlayingCount);
	      registeredAnimations.push({
	        elem: element,
	        animation: animItem
	      });
	      len += 1;
	    }

	    function loadAnimation(params) {
	      var animItem = new AnimationItem();
	      setupAnimation(animItem, null);
	      animItem.setParams(params);
	      return animItem;
	    }

	    function setSpeed(val, animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setSpeed(val, animation);
	      }
	    }

	    function setDirection(val, animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setDirection(val, animation);
	      }
	    }

	    function play(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.play(animation);
	      }
	    }

	    function resume(nowTime) {
	      var elapsedTime = nowTime - initTime;
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.advanceTime(elapsedTime);
	      }

	      initTime = nowTime;

	      if (playingAnimationsNum && !_isFrozen) {
	        window.requestAnimationFrame(resume);
	      } else {
	        _stopped = true;
	      }
	    }

	    function first(nowTime) {
	      initTime = nowTime;
	      window.requestAnimationFrame(resume);
	    }

	    function pause(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.pause(animation);
	      }
	    }

	    function goToAndStop(value, isFrame, animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
	      }
	    }

	    function stop(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.stop(animation);
	      }
	    }

	    function togglePause(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.togglePause(animation);
	      }
	    }

	    function destroy(animation) {
	      var i;

	      for (i = len - 1; i >= 0; i -= 1) {
	        registeredAnimations[i].animation.destroy(animation);
	      }
	    }

	    function searchAnimations(animationData, standalone, renderer) {
	      var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
	      var i;
	      var lenAnims = animElements.length;

	      for (i = 0; i < lenAnims; i += 1) {
	        if (renderer) {
	          animElements[i].setAttribute('data-bm-type', renderer);
	        }

	        registerAnimation(animElements[i], animationData);
	      }

	      if (standalone && lenAnims === 0) {
	        if (!renderer) {
	          renderer = 'svg';
	        }

	        var body = document.getElementsByTagName('body')[0];
	        body.innerText = '';
	        var div = createTag('div');
	        div.style.width = '100%';
	        div.style.height = '100%';
	        div.setAttribute('data-bm-type', renderer);
	        body.appendChild(div);
	        registerAnimation(div, animationData);
	      }
	    }

	    function resize() {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.resize();
	      }
	    }

	    function activate() {
	      if (!_isFrozen && playingAnimationsNum) {
	        if (_stopped) {
	          window.requestAnimationFrame(first);
	          _stopped = false;
	        }
	      }
	    }

	    function freeze() {
	      _isFrozen = true;
	    }

	    function unfreeze() {
	      _isFrozen = false;
	      activate();
	    }

	    function setVolume(val, animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setVolume(val, animation);
	      }
	    }

	    function mute(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.mute(animation);
	      }
	    }

	    function unmute(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.unmute(animation);
	      }
	    }

	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize; // moduleOb.start = start;

	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    moduleOb.freeze = freeze;
	    moduleOb.unfreeze = unfreeze;
	    moduleOb.setVolume = setVolume;
	    moduleOb.mute = mute;
	    moduleOb.unmute = unmute;
	    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
	    return moduleOb;
	  }();

	  /* eslint-disable */
	  var BezierFactory = function () {
	    /**
	       * BezierEasing - use bezier curve for transition easing function
	       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	       *
	       * Credits: is based on Firefox's nsSMILKeySpline.cpp
	       * Usage:
	       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	       * spline.get(x) => returns the easing value | x must be in [0, 1] range
	       *
	       */
	    var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};

	    function getBezierEasing(a, b, c, d, nm) {
	      var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');

	      if (beziers[str]) {
	        return beziers[str];
	      }

	      var bezEasing = new BezierEasing([a, b, c, d]);
	      beziers[str] = bezEasing;
	      return bezEasing;
	    } // These values are established by empiricism with tests (tradeoff: performance VS precision)


	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	    var float32ArraySupported = typeof Float32Array === 'function';

	    function A(aA1, aA2) {
	      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
	    }

	    function B(aA1, aA2) {
	      return 3.0 * aA2 - 6.0 * aA1;
	    }

	    function C(aA1) {
	      return 3.0 * aA1;
	    } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


	    function calcBezier(aT, aA1, aA2) {
	      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
	    } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


	    function getSlope(aT, aA1, aA2) {
	      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }

	    function binarySubdivide(aX, aA, aB, mX1, mX2) {
	      var currentX,
	          currentT,
	          i = 0;

	      do {
	        currentT = aA + (aB - aA) / 2.0;
	        currentX = calcBezier(currentT, mX1, mX2) - aX;

	        if (currentX > 0.0) {
	          aB = currentT;
	        } else {
	          aA = currentT;
	        }
	      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

	      return currentT;
	    }

	    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
	      for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	        var currentSlope = getSlope(aGuessT, mX1, mX2);
	        if (currentSlope === 0.0) return aGuessT;
	        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	        aGuessT -= currentX / currentSlope;
	      }

	      return aGuessT;
	    }
	    /**
	       * points is an array of [ mX1, mY1, mX2, mY2 ]
	       */


	    function BezierEasing(points) {
	      this._p = points;
	      this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	      this._precomputed = false;
	      this.get = this.get.bind(this);
	    }

	    BezierEasing.prototype = {
	      get: function get(x) {
	        var mX1 = this._p[0],
	            mY1 = this._p[1],
	            mX2 = this._p[2],
	            mY2 = this._p[3];
	        if (!this._precomputed) this._precompute();
	        if (mX1 === mY1 && mX2 === mY2) return x; // linear
	        // Because JavaScript number are imprecise, we should guarantee the extremes are right.

	        if (x === 0) return 0;
	        if (x === 1) return 1;
	        return calcBezier(this._getTForX(x), mY1, mY2);
	      },
	      // Private part
	      _precompute: function _precompute() {
	        var mX1 = this._p[0],
	            mY1 = this._p[1],
	            mX2 = this._p[2],
	            mY2 = this._p[3];
	        this._precomputed = true;

	        if (mX1 !== mY1 || mX2 !== mY2) {
	          this._calcSampleValues();
	        }
	      },
	      _calcSampleValues: function _calcSampleValues() {
	        var mX1 = this._p[0],
	            mX2 = this._p[2];

	        for (var i = 0; i < kSplineTableSize; ++i) {
	          this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	        }
	      },

	      /**
	           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	           */
	      _getTForX: function _getTForX(aX) {
	        var mX1 = this._p[0],
	            mX2 = this._p[2],
	            mSampleValues = this._mSampleValues;
	        var intervalStart = 0.0;
	        var currentSample = 1;
	        var lastSample = kSplineTableSize - 1;

	        for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	          intervalStart += kSampleStepSize;
	        }

	        --currentSample; // Interpolate to provide an initial guess for t

	        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
	        var guessForT = intervalStart + dist * kSampleStepSize;
	        var initialSlope = getSlope(guessForT, mX1, mX2);

	        if (initialSlope >= NEWTON_MIN_SLOPE) {
	          return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	        }

	        if (initialSlope === 0.0) {
	          return guessForT;
	        }

	        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	      }
	    };
	    return ob;
	  }();

	  var pooling = function () {
	    function _double(arr) {
	      return arr.concat(createSizedArray(arr.length));
	    }

	    return {
	      "double": _double
	    };
	  }();

	  var poolFactory = function () {
	    return function (initialLength, _create, _release) {
	      var _length = 0;
	      var _maxLength = initialLength;
	      var pool = createSizedArray(_maxLength);
	      var ob = {
	        newElement: newElement,
	        release: release
	      };

	      function newElement() {
	        var element;

	        if (_length) {
	          _length -= 1;
	          element = pool[_length];
	        } else {
	          element = _create();
	        }

	        return element;
	      }

	      function release(element) {
	        if (_length === _maxLength) {
	          pool = pooling["double"](pool);
	          _maxLength *= 2;
	        }

	        if (_release) {
	          _release(element);
	        }

	        pool[_length] = element;
	        _length += 1;
	      }

	      return ob;
	    };
	  }();

	  var bezierLengthPool = function () {
	    function create() {
	      return {
	        addedLength: 0,
	        percents: createTypedArray('float32', getDefaultCurveSegments()),
	        lengths: createTypedArray('float32', getDefaultCurveSegments())
	      };
	    }

	    return poolFactory(8, create);
	  }();

	  var segmentsLengthPool = function () {
	    function create() {
	      return {
	        lengths: [],
	        totalLength: 0
	      };
	    }

	    function release(element) {
	      var i;
	      var len = element.lengths.length;

	      for (i = 0; i < len; i += 1) {
	        bezierLengthPool.release(element.lengths[i]);
	      }

	      element.lengths.length = 0;
	    }

	    return poolFactory(8, create, release);
	  }();

	  function bezFunction() {
	    var math = Math;

	    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
	      var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
	      return det1 > -0.001 && det1 < 0.001;
	    }

	    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
	      if (z1 === 0 && z2 === 0 && z3 === 0) {
	        return pointOnLine2D(x1, y1, x2, y2, x3, y3);
	      }

	      var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
	      var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
	      var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
	      var diffDist;

	      if (dist1 > dist2) {
	        if (dist1 > dist3) {
	          diffDist = dist1 - dist2 - dist3;
	        } else {
	          diffDist = dist3 - dist2 - dist1;
	        }
	      } else if (dist3 > dist2) {
	        diffDist = dist3 - dist2 - dist1;
	      } else {
	        diffDist = dist2 - dist1 - dist3;
	      }

	      return diffDist > -0.0001 && diffDist < 0.0001;
	    }

	    var getBezierLength = function () {
	      return function (pt1, pt2, pt3, pt4) {
	        var curveSegments = getDefaultCurveSegments();
	        var k;
	        var i;
	        var len;
	        var ptCoord;
	        var perc;
	        var addedLength = 0;
	        var ptDistance;
	        var point = [];
	        var lastPoint = [];
	        var lengthData = bezierLengthPool.newElement();
	        len = pt3.length;

	        for (k = 0; k < curveSegments; k += 1) {
	          perc = k / (curveSegments - 1);
	          ptDistance = 0;

	          for (i = 0; i < len; i += 1) {
	            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
	            point[i] = ptCoord;

	            if (lastPoint[i] !== null) {
	              ptDistance += bmPow(point[i] - lastPoint[i], 2);
	            }

	            lastPoint[i] = point[i];
	          }

	          if (ptDistance) {
	            ptDistance = bmSqrt(ptDistance);
	            addedLength += ptDistance;
	          }

	          lengthData.percents[k] = perc;
	          lengthData.lengths[k] = addedLength;
	        }

	        lengthData.addedLength = addedLength;
	        return lengthData;
	      };
	    }();

	    function getSegmentsLength(shapeData) {
	      var segmentsLength = segmentsLengthPool.newElement();
	      var closed = shapeData.c;
	      var pathV = shapeData.v;
	      var pathO = shapeData.o;
	      var pathI = shapeData.i;
	      var i;
	      var len = shapeData._length;
	      var lengths = segmentsLength.lengths;
	      var totalLength = 0;

	      for (i = 0; i < len - 1; i += 1) {
	        lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
	        totalLength += lengths[i].addedLength;
	      }

	      if (closed && len) {
	        lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
	        totalLength += lengths[i].addedLength;
	      }

	      segmentsLength.totalLength = totalLength;
	      return segmentsLength;
	    }

	    function BezierData(length) {
	      this.segmentLength = 0;
	      this.points = new Array(length);
	    }

	    function PointData(partial, point) {
	      this.partialLength = partial;
	      this.point = point;
	    }

	    var buildBezierData = function () {
	      var storedData = {};
	      return function (pt1, pt2, pt3, pt4) {
	        var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');

	        if (!storedData[bezierName]) {
	          var curveSegments = getDefaultCurveSegments();
	          var k;
	          var i;
	          var len;
	          var ptCoord;
	          var perc;
	          var addedLength = 0;
	          var ptDistance;
	          var point;
	          var lastPoint = null;

	          if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
	            curveSegments = 2;
	          }

	          var bezierData = new BezierData(curveSegments);
	          len = pt3.length;

	          for (k = 0; k < curveSegments; k += 1) {
	            point = createSizedArray(len);
	            perc = k / (curveSegments - 1);
	            ptDistance = 0;

	            for (i = 0; i < len; i += 1) {
	              ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
	              point[i] = ptCoord;

	              if (lastPoint !== null) {
	                ptDistance += bmPow(point[i] - lastPoint[i], 2);
	              }
	            }

	            ptDistance = bmSqrt(ptDistance);
	            addedLength += ptDistance;
	            bezierData.points[k] = new PointData(ptDistance, point);
	            lastPoint = point;
	          }

	          bezierData.segmentLength = addedLength;
	          storedData[bezierName] = bezierData;
	        }

	        return storedData[bezierName];
	      };
	    }();

	    function getDistancePerc(perc, bezierData) {
	      var percents = bezierData.percents;
	      var lengths = bezierData.lengths;
	      var len = percents.length;
	      var initPos = bmFloor((len - 1) * perc);
	      var lengthPos = perc * bezierData.addedLength;
	      var lPerc = 0;

	      if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
	        return percents[initPos];
	      }

	      var dir = lengths[initPos] > lengthPos ? -1 : 1;
	      var flag = true;

	      while (flag) {
	        if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
	          lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
	          flag = false;
	        } else {
	          initPos += dir;
	        }

	        if (initPos < 0 || initPos >= len - 1) {
	          // FIX for TypedArrays that don't store floating point values with enough accuracy
	          if (initPos === len - 1) {
	            return percents[initPos];
	          }

	          flag = false;
	        }
	      }

	      return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
	    }

	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	      var t1 = getDistancePerc(percent, bezierData);
	      var u1 = 1 - t1;
	      var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
	      var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
	      return [ptX, ptY];
	    }

	    var bezierSegmentPoints = createTypedArray('float32', 8);

	    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
	      if (startPerc < 0) {
	        startPerc = 0;
	      } else if (startPerc > 1) {
	        startPerc = 1;
	      }

	      var t0 = getDistancePerc(startPerc, bezierData);
	      endPerc = endPerc > 1 ? 1 : endPerc;
	      var t1 = getDistancePerc(endPerc, bezierData);
	      var i;
	      var len = pt1.length;
	      var u0 = 1 - t0;
	      var u1 = 1 - t1;
	      var u0u0u0 = u0 * u0 * u0;
	      var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase

	      var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase

	      var t0t0t0 = t0 * t0 * t0; //

	      var u0u0u1 = u0 * u0 * u1;
	      var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase

	      var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase

	      var t0t0t1 = t0 * t0 * t1; //

	      var u0u1u1 = u0 * u1 * u1;
	      var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase

	      var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase

	      var t0t1t1 = t0 * t1 * t1; //

	      var u1u1u1 = u1 * u1 * u1;
	      var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase

	      var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase

	      var t1t1t1 = t1 * t1 * t1;

	      for (i = 0; i < len; i += 1) {
	        bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

	        bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

	        bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

	        bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	      }

	      return bezierSegmentPoints;
	    }

	    return {
	      getSegmentsLength: getSegmentsLength,
	      getNewSegment: getNewSegment,
	      getPointInSegment: getPointInSegment,
	      buildBezierData: buildBezierData,
	      pointOnLine2D: pointOnLine2D,
	      pointOnLine3D: pointOnLine3D
	    };
	  }

	  var bez = bezFunction();

	  var initFrame = initialDefaultFrame;
	  var mathAbs = Math.abs;

	  function interpolateValue(frameNum, caching) {
	    var offsetTime = this.offsetTime;
	    var newValue;

	    if (this.propType === 'multidimensional') {
	      newValue = createTypedArray('float32', this.pv.length);
	    }

	    var iterationIndex = caching.lastIndex;
	    var i = iterationIndex;
	    var len = this.keyframes.length - 1;
	    var flag = true;
	    var keyData;
	    var nextKeyData;
	    var keyframeMetadata;

	    while (flag) {
	      keyData = this.keyframes[i];
	      nextKeyData = this.keyframes[i + 1];

	      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
	        if (keyData.h) {
	          keyData = nextKeyData;
	        }

	        iterationIndex = 0;
	        break;
	      }

	      if (nextKeyData.t - offsetTime > frameNum) {
	        iterationIndex = i;
	        break;
	      }

	      if (i < len - 1) {
	        i += 1;
	      } else {
	        iterationIndex = 0;
	        flag = false;
	      }
	    }

	    keyframeMetadata = this.keyframesMetadata[i] || {};
	    var k;
	    var kLen;
	    var perc;
	    var jLen;
	    var j;
	    var fnc;
	    var nextKeyTime = nextKeyData.t - offsetTime;
	    var keyTime = keyData.t - offsetTime;
	    var endValue;

	    if (keyData.to) {
	      if (!keyframeMetadata.bezierData) {
	        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
	      }

	      var bezierData = keyframeMetadata.bezierData;

	      if (frameNum >= nextKeyTime || frameNum < keyTime) {
	        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
	        kLen = bezierData.points[ind].point.length;

	        for (k = 0; k < kLen; k += 1) {
	          newValue[k] = bezierData.points[ind].point[k];
	        } // caching._lastKeyframeIndex = -1;

	      } else {
	        if (keyframeMetadata.__fnct) {
	          fnc = keyframeMetadata.__fnct;
	        } else {
	          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
	          keyframeMetadata.__fnct = fnc;
	        }

	        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	        var distanceInLine = bezierData.segmentLength * perc;
	        var segmentPerc;
	        var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
	        j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
	        flag = true;
	        jLen = bezierData.points.length;

	        while (flag) {
	          addedLength += bezierData.points[j].partialLength;

	          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
	            kLen = bezierData.points[j].point.length;

	            for (k = 0; k < kLen; k += 1) {
	              newValue[k] = bezierData.points[j].point[k];
	            }

	            break;
	          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
	            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
	            kLen = bezierData.points[j].point.length;

	            for (k = 0; k < kLen; k += 1) {
	              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
	            }

	            break;
	          }

	          if (j < jLen - 1) {
	            j += 1;
	          } else {
	            flag = false;
	          }
	        }

	        caching._lastPoint = j;
	        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	        caching._lastKeyframeIndex = i;
	      }
	    } else {
	      var outX;
	      var outY;
	      var inX;
	      var inY;
	      var keyValue;
	      len = keyData.s.length;
	      endValue = nextKeyData.s || keyData.e;

	      if (this.sh && keyData.h !== 1) {
	        if (frameNum >= nextKeyTime) {
	          newValue[0] = endValue[0];
	          newValue[1] = endValue[1];
	          newValue[2] = endValue[2];
	        } else if (frameNum <= keyTime) {
	          newValue[0] = keyData.s[0];
	          newValue[1] = keyData.s[1];
	          newValue[2] = keyData.s[2];
	        } else {
	          var quatStart = createQuaternion(keyData.s);
	          var quatEnd = createQuaternion(endValue);
	          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
	          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
	        }
	      } else {
	        for (i = 0; i < len; i += 1) {
	          if (keyData.h !== 1) {
	            if (frameNum >= nextKeyTime) {
	              perc = 1;
	            } else if (frameNum < keyTime) {
	              perc = 0;
	            } else {
	              if (keyData.o.x.constructor === Array) {
	                if (!keyframeMetadata.__fnct) {
	                  keyframeMetadata.__fnct = [];
	                }

	                if (!keyframeMetadata.__fnct[i]) {
	                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
	                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
	                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
	                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
	                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                  keyframeMetadata.__fnct[i] = fnc;
	                } else {
	                  fnc = keyframeMetadata.__fnct[i];
	                }
	              } else if (!keyframeMetadata.__fnct) {
	                outX = keyData.o.x;
	                outY = keyData.o.y;
	                inX = keyData.i.x;
	                inY = keyData.i.y;
	                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                keyData.keyframeMetadata = fnc;
	              } else {
	                fnc = keyframeMetadata.__fnct;
	              }

	              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	            }
	          }

	          endValue = nextKeyData.s || keyData.e;
	          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

	          if (this.propType === 'multidimensional') {
	            newValue[i] = keyValue;
	          } else {
	            newValue = keyValue;
	          }
	        }
	      }
	    }

	    caching.lastIndex = iterationIndex;
	    return newValue;
	  } // based on @Toji's https://github.com/toji/gl-matrix/


	  function slerp(a, b, t) {
	    var out = [];
	    var ax = a[0];
	    var ay = a[1];
	    var az = a[2];
	    var aw = a[3];
	    var bx = b[0];
	    var by = b[1];
	    var bz = b[2];
	    var bw = b[3];
	    var omega;
	    var cosom;
	    var sinom;
	    var scale0;
	    var scale1;
	    cosom = ax * bx + ay * by + az * bz + aw * bw;

	    if (cosom < 0.0) {
	      cosom = -cosom;
	      bx = -bx;
	      by = -by;
	      bz = -bz;
	      bw = -bw;
	    }

	    if (1.0 - cosom > 0.000001) {
	      omega = Math.acos(cosom);
	      sinom = Math.sin(omega);
	      scale0 = Math.sin((1.0 - t) * omega) / sinom;
	      scale1 = Math.sin(t * omega) / sinom;
	    } else {
	      scale0 = 1.0 - t;
	      scale1 = t;
	    }

	    out[0] = scale0 * ax + scale1 * bx;
	    out[1] = scale0 * ay + scale1 * by;
	    out[2] = scale0 * az + scale1 * bz;
	    out[3] = scale0 * aw + scale1 * bw;
	    return out;
	  }

	  function quaternionToEuler(out, quat) {
	    var qx = quat[0];
	    var qy = quat[1];
	    var qz = quat[2];
	    var qw = quat[3];
	    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
	    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
	    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
	    out[0] = heading / degToRads;
	    out[1] = attitude / degToRads;
	    out[2] = bank / degToRads;
	  }

	  function createQuaternion(values) {
	    var heading = values[0] * degToRads;
	    var attitude = values[1] * degToRads;
	    var bank = values[2] * degToRads;
	    var c1 = Math.cos(heading / 2);
	    var c2 = Math.cos(attitude / 2);
	    var c3 = Math.cos(bank / 2);
	    var s1 = Math.sin(heading / 2);
	    var s2 = Math.sin(attitude / 2);
	    var s3 = Math.sin(bank / 2);
	    var w = c1 * c2 * c3 - s1 * s2 * s3;
	    var x = s1 * s2 * c3 + c1 * c2 * s3;
	    var y = s1 * c2 * c3 + c1 * s2 * s3;
	    var z = c1 * s2 * c3 - s1 * c2 * s3;
	    return [x, y, z, w];
	  }

	  function getValueAtCurrentTime() {
	    var frameNum = this.comp.renderedFrame - this.offsetTime;
	    var initTime = this.keyframes[0].t - this.offsetTime;
	    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;

	    if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
	      if (this._caching.lastFrame >= frameNum) {
	        this._caching._lastKeyframeIndex = -1;
	        this._caching.lastIndex = 0;
	      }

	      var renderResult = this.interpolateValue(frameNum, this._caching);
	      this.pv = renderResult;
	    }

	    this._caching.lastFrame = frameNum;
	    return this.pv;
	  }

	  function setVValue(val) {
	    var multipliedValue;

	    if (this.propType === 'unidimensional') {
	      multipliedValue = val * this.mult;

	      if (mathAbs(this.v - multipliedValue) > 0.00001) {
	        this.v = multipliedValue;
	        this._mdf = true;
	      }
	    } else {
	      var i = 0;
	      var len = this.v.length;

	      while (i < len) {
	        multipliedValue = val[i] * this.mult;

	        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
	          this.v[i] = multipliedValue;
	          this._mdf = true;
	        }

	        i += 1;
	      }
	    }
	  }

	  function processEffectsSequence() {
	    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	      return;
	    }

	    if (this.lock) {
	      this.setVValue(this.pv);
	      return;
	    }

	    this.lock = true;
	    this._mdf = this._isFirstFrame;
	    var i;
	    var len = this.effectsSequence.length;
	    var finalValue = this.kf ? this.pv : this.data.k;

	    for (i = 0; i < len; i += 1) {
	      finalValue = this.effectsSequence[i](finalValue);
	    }

	    this.setVValue(finalValue);
	    this._isFirstFrame = false;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	  }

	  function addEffect(effectFunction) {
	    this.effectsSequence.push(effectFunction);
	    this.container.addDynamicProperty(this);
	  }

	  function ValueProperty(elem, data, mult, container) {
	    this.propType = 'unidimensional';
	    this.mult = mult || 1;
	    this.data = data;
	    this.v = mult ? data.k * mult : data.k;
	    this.pv = data.k;
	    this._mdf = false;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.k = false;
	    this.kf = false;
	    this.vel = 0;
	    this.effectsSequence = [];
	    this._isFirstFrame = true;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.addEffect = addEffect;
	  }

	  function MultiDimensionalProperty(elem, data, mult, container) {
	    this.propType = 'multidimensional';
	    this.mult = mult || 1;
	    this.data = data;
	    this._mdf = false;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.k = false;
	    this.kf = false;
	    this.frameId = -1;
	    var i;
	    var len = data.k.length;
	    this.v = createTypedArray('float32', len);
	    this.pv = createTypedArray('float32', len);
	    this.vel = createTypedArray('float32', len);

	    for (i = 0; i < len; i += 1) {
	      this.v[i] = data.k[i] * this.mult;
	      this.pv[i] = data.k[i];
	    }

	    this._isFirstFrame = true;
	    this.effectsSequence = [];
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.addEffect = addEffect;
	  }

	  function KeyframedValueProperty(elem, data, mult, container) {
	    this.propType = 'unidimensional';
	    this.keyframes = data.k;
	    this.keyframesMetadata = [];
	    this.offsetTime = elem.data.st;
	    this.frameId = -1;
	    this._caching = {
	      lastFrame: initFrame,
	      lastIndex: 0,
	      value: 0,
	      _lastKeyframeIndex: -1
	    };
	    this.k = true;
	    this.kf = true;
	    this.data = data;
	    this.mult = mult || 1;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.v = initFrame;
	    this.pv = initFrame;
	    this._isFirstFrame = true;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.interpolateValue = interpolateValue;
	    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	    this.addEffect = addEffect;
	  }

	  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
	    this.propType = 'multidimensional';
	    var i;
	    var len = data.k.length;
	    var s;
	    var e;
	    var to;
	    var ti;

	    for (i = 0; i < len - 1; i += 1) {
	      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
	        s = data.k[i].s;
	        e = data.k[i + 1].s;
	        to = data.k[i].to;
	        ti = data.k[i].ti;

	        if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
	          data.k[i].to = null;
	          data.k[i].ti = null;
	        }

	        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
	          if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
	            data.k[i].to = null;
	            data.k[i].ti = null;
	          }
	        }
	      }
	    }

	    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	    this.data = data;
	    this.keyframes = data.k;
	    this.keyframesMetadata = [];
	    this.offsetTime = elem.data.st;
	    this.k = true;
	    this.kf = true;
	    this._isFirstFrame = true;
	    this.mult = mult || 1;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.interpolateValue = interpolateValue;
	    this.frameId = -1;
	    var arrLen = data.k[0].s.length;
	    this.v = createTypedArray('float32', arrLen);
	    this.pv = createTypedArray('float32', arrLen);

	    for (i = 0; i < arrLen; i += 1) {
	      this.v[i] = initFrame;
	      this.pv[i] = initFrame;
	    }

	    this._caching = {
	      lastFrame: initFrame,
	      lastIndex: 0,
	      value: createTypedArray('float32', arrLen)
	    };
	    this.addEffect = addEffect;
	  }

	  var PropertyFactory = function () {
	    function getProp(elem, data, type, mult, container) {
	      if (data.sid) {
	        data = elem.globalData.slotManager.getProp(data);
	      }

	      var p;

	      if (!data.k.length) {
	        p = new ValueProperty(elem, data, mult, container);
	      } else if (typeof data.k[0] === 'number') {
	        p = new MultiDimensionalProperty(elem, data, mult, container);
	      } else {
	        switch (type) {
	          case 0:
	            p = new KeyframedValueProperty(elem, data, mult, container);
	            break;

	          case 1:
	            p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
	            break;
	        }
	      }

	      if (p.effectsSequence.length) {
	        container.addDynamicProperty(p);
	      }

	      return p;
	    }

	    var ob = {
	      getProp: getProp
	    };
	    return ob;
	  }();

	  function DynamicPropertyContainer() {}

	  DynamicPropertyContainer.prototype = {
	    addDynamicProperty: function addDynamicProperty(prop) {
	      if (this.dynamicProperties.indexOf(prop) === -1) {
	        this.dynamicProperties.push(prop);
	        this.container.addDynamicProperty(this);
	        this._isAnimated = true;
	      }
	    },
	    iterateDynamicProperties: function iterateDynamicProperties() {
	      this._mdf = false;
	      var i;
	      var len = this.dynamicProperties.length;

	      for (i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();

	        if (this.dynamicProperties[i]._mdf) {
	          this._mdf = true;
	        }
	      }
	    },
	    initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
	      this.container = container;
	      this.dynamicProperties = [];
	      this._mdf = false;
	      this._isAnimated = false;
	    }
	  };

	  var pointPool = function () {
	    function create() {
	      return createTypedArray('float32', 2);
	    }

	    return poolFactory(8, create);
	  }();

	  function ShapePath() {
	    this.c = false;
	    this._length = 0;
	    this._maxLength = 8;
	    this.v = createSizedArray(this._maxLength);
	    this.o = createSizedArray(this._maxLength);
	    this.i = createSizedArray(this._maxLength);
	  }

	  ShapePath.prototype.setPathData = function (closed, len) {
	    this.c = closed;
	    this.setLength(len);
	    var i = 0;

	    while (i < len) {
	      this.v[i] = pointPool.newElement();
	      this.o[i] = pointPool.newElement();
	      this.i[i] = pointPool.newElement();
	      i += 1;
	    }
	  };

	  ShapePath.prototype.setLength = function (len) {
	    while (this._maxLength < len) {
	      this.doubleArrayLength();
	    }

	    this._length = len;
	  };

	  ShapePath.prototype.doubleArrayLength = function () {
	    this.v = this.v.concat(createSizedArray(this._maxLength));
	    this.i = this.i.concat(createSizedArray(this._maxLength));
	    this.o = this.o.concat(createSizedArray(this._maxLength));
	    this._maxLength *= 2;
	  };

	  ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
	    var arr;
	    this._length = Math.max(this._length, pos + 1);

	    if (this._length >= this._maxLength) {
	      this.doubleArrayLength();
	    }

	    switch (type) {
	      case 'v':
	        arr = this.v;
	        break;

	      case 'i':
	        arr = this.i;
	        break;

	      case 'o':
	        arr = this.o;
	        break;

	      default:
	        arr = [];
	        break;
	    }

	    if (!arr[pos] || arr[pos] && !replace) {
	      arr[pos] = pointPool.newElement();
	    }

	    arr[pos][0] = x;
	    arr[pos][1] = y;
	  };

	  ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
	    this.setXYAt(vX, vY, 'v', pos, replace);
	    this.setXYAt(oX, oY, 'o', pos, replace);
	    this.setXYAt(iX, iY, 'i', pos, replace);
	  };

	  ShapePath.prototype.reverse = function () {
	    var newPath = new ShapePath();
	    newPath.setPathData(this.c, this._length);
	    var vertices = this.v;
	    var outPoints = this.o;
	    var inPoints = this.i;
	    var init = 0;

	    if (this.c) {
	      newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	      init = 1;
	    }

	    var cnt = this._length - 1;
	    var len = this._length;
	    var i;

	    for (i = init; i < len; i += 1) {
	      newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	      cnt -= 1;
	    }

	    return newPath;
	  };

	  ShapePath.prototype.length = function () {
	    return this._length;
	  };

	  var shapePool = function () {
	    function create() {
	      return new ShapePath();
	    }

	    function release(shapePath) {
	      var len = shapePath._length;
	      var i;

	      for (i = 0; i < len; i += 1) {
	        pointPool.release(shapePath.v[i]);
	        pointPool.release(shapePath.i[i]);
	        pointPool.release(shapePath.o[i]);
	        shapePath.v[i] = null;
	        shapePath.i[i] = null;
	        shapePath.o[i] = null;
	      }

	      shapePath._length = 0;
	      shapePath.c = false;
	    }

	    function clone(shape) {
	      var cloned = factory.newElement();
	      var i;
	      var len = shape._length === undefined ? shape.v.length : shape._length;
	      cloned.setLength(len);
	      cloned.c = shape.c;

	      for (i = 0; i < len; i += 1) {
	        cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
	      }

	      return cloned;
	    }

	    var factory = poolFactory(4, create, release);
	    factory.clone = clone;
	    return factory;
	  }();

	  function ShapeCollection() {
	    this._length = 0;
	    this._maxLength = 4;
	    this.shapes = createSizedArray(this._maxLength);
	  }

	  ShapeCollection.prototype.addShape = function (shapeData) {
	    if (this._length === this._maxLength) {
	      this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
	      this._maxLength *= 2;
	    }

	    this.shapes[this._length] = shapeData;
	    this._length += 1;
	  };

	  ShapeCollection.prototype.releaseShapes = function () {
	    var i;

	    for (i = 0; i < this._length; i += 1) {
	      shapePool.release(this.shapes[i]);
	    }

	    this._length = 0;
	  };

	  var shapeCollectionPool = function () {
	    var ob = {
	      newShapeCollection: newShapeCollection,
	      release: release
	    };
	    var _length = 0;
	    var _maxLength = 4;
	    var pool = createSizedArray(_maxLength);

	    function newShapeCollection() {
	      var shapeCollection;

	      if (_length) {
	        _length -= 1;
	        shapeCollection = pool[_length];
	      } else {
	        shapeCollection = new ShapeCollection();
	      }

	      return shapeCollection;
	    }

	    function release(shapeCollection) {
	      var i;
	      var len = shapeCollection._length;

	      for (i = 0; i < len; i += 1) {
	        shapePool.release(shapeCollection.shapes[i]);
	      }

	      shapeCollection._length = 0;

	      if (_length === _maxLength) {
	        pool = pooling["double"](pool);
	        _maxLength *= 2;
	      }

	      pool[_length] = shapeCollection;
	      _length += 1;
	    }

	    return ob;
	  }();

	  var ShapePropertyFactory = function () {
	    var initFrame = -999999;

	    function interpolateShape(frameNum, previousValue, caching) {
	      var iterationIndex = caching.lastIndex;
	      var keyPropS;
	      var keyPropE;
	      var isHold;
	      var j;
	      var k;
	      var jLen;
	      var kLen;
	      var perc;
	      var vertexValue;
	      var kf = this.keyframes;

	      if (frameNum < kf[0].t - this.offsetTime) {
	        keyPropS = kf[0].s[0];
	        isHold = true;
	        iterationIndex = 0;
	      } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
	        keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
	        /* if(kf[kf.length - 1].s){
	                  keyPropS = kf[kf.length - 1].s[0];
	              }else{
	                  keyPropS = kf[kf.length - 2].e[0];
	              } */

	        isHold = true;
	      } else {
	        var i = iterationIndex;
	        var len = kf.length - 1;
	        var flag = true;
	        var keyData;
	        var nextKeyData;
	        var keyframeMetadata;

	        while (flag) {
	          keyData = kf[i];
	          nextKeyData = kf[i + 1];

	          if (nextKeyData.t - this.offsetTime > frameNum) {
	            break;
	          }

	          if (i < len - 1) {
	            i += 1;
	          } else {
	            flag = false;
	          }
	        }

	        keyframeMetadata = this.keyframesMetadata[i] || {};
	        isHold = keyData.h === 1;
	        iterationIndex = i;

	        if (!isHold) {
	          if (frameNum >= nextKeyData.t - this.offsetTime) {
	            perc = 1;
	          } else if (frameNum < keyData.t - this.offsetTime) {
	            perc = 0;
	          } else {
	            var fnc;

	            if (keyframeMetadata.__fnct) {
	              fnc = keyframeMetadata.__fnct;
	            } else {
	              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
	              keyframeMetadata.__fnct = fnc;
	            }

	            perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
	          }

	          keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
	        }

	        keyPropS = keyData.s[0];
	      }

	      jLen = previousValue._length;
	      kLen = keyPropS.i[0].length;
	      caching.lastIndex = iterationIndex;

	      for (j = 0; j < jLen; j += 1) {
	        for (k = 0; k < kLen; k += 1) {
	          vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
	          previousValue.i[j][k] = vertexValue;
	          vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
	          previousValue.o[j][k] = vertexValue;
	          vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
	          previousValue.v[j][k] = vertexValue;
	        }
	      }
	    }

	    function interpolateShapeCurrentTime() {
	      var frameNum = this.comp.renderedFrame - this.offsetTime;
	      var initTime = this.keyframes[0].t - this.offsetTime;
	      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	      var lastFrame = this._caching.lastFrame;

	      if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
	        /// /
	        this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
	        this.interpolateShape(frameNum, this.pv, this._caching); /// /
	      }

	      this._caching.lastFrame = frameNum;
	      return this.pv;
	    }

	    function resetShape() {
	      this.paths = this.localShapeCollection;
	    }

	    function shapesEqual(shape1, shape2) {
	      if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
	        return false;
	      }

	      var i;
	      var len = shape1._length;

	      for (i = 0; i < len; i += 1) {
	        if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
	          return false;
	        }
	      }

	      return true;
	    }

	    function setVValue(newPath) {
	      if (!shapesEqual(this.v, newPath)) {
	        this.v = shapePool.clone(newPath);
	        this.localShapeCollection.releaseShapes();
	        this.localShapeCollection.addShape(this.v);
	        this._mdf = true;
	        this.paths = this.localShapeCollection;
	      }
	    }

	    function processEffectsSequence() {
	      if (this.elem.globalData.frameId === this.frameId) {
	        return;
	      }

	      if (!this.effectsSequence.length) {
	        this._mdf = false;
	        return;
	      }

	      if (this.lock) {
	        this.setVValue(this.pv);
	        return;
	      }

	      this.lock = true;
	      this._mdf = false;
	      var finalValue;

	      if (this.kf) {
	        finalValue = this.pv;
	      } else if (this.data.ks) {
	        finalValue = this.data.ks.k;
	      } else {
	        finalValue = this.data.pt.k;
	      }

	      var i;
	      var len = this.effectsSequence.length;

	      for (i = 0; i < len; i += 1) {
	        finalValue = this.effectsSequence[i](finalValue);
	      }

	      this.setVValue(finalValue);
	      this.lock = false;
	      this.frameId = this.elem.globalData.frameId;
	    }

	    function ShapeProperty(elem, data, type) {
	      this.propType = 'shape';
	      this.comp = elem.comp;
	      this.container = elem;
	      this.elem = elem;
	      this.data = data;
	      this.k = false;
	      this.kf = false;
	      this._mdf = false;
	      var pathData = type === 3 ? data.pt.k : data.ks.k;
	      this.v = shapePool.clone(pathData);
	      this.pv = shapePool.clone(this.v);
	      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	      this.paths = this.localShapeCollection;
	      this.paths.addShape(this.v);
	      this.reset = resetShape;
	      this.effectsSequence = [];
	    }

	    function addEffect(effectFunction) {
	      this.effectsSequence.push(effectFunction);
	      this.container.addDynamicProperty(this);
	    }

	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.setVValue = setVValue;
	    ShapeProperty.prototype.addEffect = addEffect;

	    function KeyframedShapeProperty(elem, data, type) {
	      this.propType = 'shape';
	      this.comp = elem.comp;
	      this.elem = elem;
	      this.container = elem;
	      this.offsetTime = elem.data.st;
	      this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	      this.keyframesMetadata = [];
	      this.k = true;
	      this.kf = true;
	      var len = this.keyframes[0].s[0].i.length;
	      this.v = shapePool.newElement();
	      this.v.setPathData(this.keyframes[0].s[0].c, len);
	      this.pv = shapePool.clone(this.v);
	      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	      this.paths = this.localShapeCollection;
	      this.paths.addShape(this.v);
	      this.lastFrame = initFrame;
	      this.reset = resetShape;
	      this._caching = {
	        lastFrame: initFrame,
	        lastIndex: 0
	      };
	      this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
	    }

	    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	    KeyframedShapeProperty.prototype.setVValue = setVValue;
	    KeyframedShapeProperty.prototype.addEffect = addEffect;

	    var EllShapeProperty = function () {
	      var cPoint = roundCorner;

	      function EllShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.setPathData(true, 4);
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.localShapeCollection.addShape(this.v);
	        this.d = data.d;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.frameId = -1;
	        this.initDynamicPropertyContainer(elem);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);

	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertEllToPath();
	        }
	      }

	      EllShapePropertyFactory.prototype = {
	        reset: resetShape,
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }

	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();

	          if (this._mdf) {
	            this.convertEllToPath();
	          }
	        },
	        convertEllToPath: function convertEllToPath() {
	          var p0 = this.p.v[0];
	          var p1 = this.p.v[1];
	          var s0 = this.s.v[0] / 2;
	          var s1 = this.s.v[1] / 2;

	          var _cw = this.d !== 3;

	          var _v = this.v;
	          _v.v[0][0] = p0;
	          _v.v[0][1] = p1 - s1;
	          _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.v[1][1] = p1;
	          _v.v[2][0] = p0;
	          _v.v[2][1] = p1 + s1;
	          _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.v[3][1] = p1;
	          _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	          _v.i[0][1] = p1 - s1;
	          _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.i[1][1] = p1 - s1 * cPoint;
	          _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	          _v.i[2][1] = p1 + s1;
	          _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.i[3][1] = p1 + s1 * cPoint;
	          _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	          _v.o[0][1] = p1 - s1;
	          _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.o[1][1] = p1 + s1 * cPoint;
	          _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	          _v.o[2][1] = p1 + s1;
	          _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.o[3][1] = p1 - s1 * cPoint;
	        }
	      };
	      extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
	      return EllShapePropertyFactory;
	    }();

	    var StarShapeProperty = function () {
	      function StarShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.setPathData(true, 0);
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.data = data;
	        this.frameId = -1;
	        this.d = data.d;
	        this.initDynamicPropertyContainer(elem);

	        if (data.sy === 1) {
	          this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
	          this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
	          this.convertToPath = this.convertStarToPath;
	        } else {
	          this.convertToPath = this.convertPolygonToPath;
	        }

	        this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
	        this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
	        this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.localShapeCollection.addShape(this.v);
	        this.paths = this.localShapeCollection;

	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertToPath();
	        }
	      }

	      StarShapePropertyFactory.prototype = {
	        reset: resetShape,
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }

	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();

	          if (this._mdf) {
	            this.convertToPath();
	          }
	        },
	        convertStarToPath: function convertStarToPath() {
	          var numPts = Math.floor(this.pt.v) * 2;
	          var angle = Math.PI * 2 / numPts;
	          /* this.v.v.length = numPts;
	                  this.v.i.length = numPts;
	                  this.v.o.length = numPts; */

	          var longFlag = true;
	          var longRad = this.or.v;
	          var shortRad = this.ir.v;
	          var longRound = this.os.v;
	          var shortRound = this.is.v;
	          var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
	          var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
	          var i;
	          var rad;
	          var roundness;
	          var perimSegment;
	          var currentAng = -Math.PI / 2;
	          currentAng += this.r.v;
	          var dir = this.data.d === 3 ? -1 : 1;
	          this.v._length = 0;

	          for (i = 0; i < numPts; i += 1) {
	            rad = longFlag ? longRad : shortRad;
	            roundness = longFlag ? longRound : shortRound;
	            perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	            var x = rad * Math.cos(currentAng);
	            var y = rad * Math.sin(currentAng);
	            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
	            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
	            x += +this.p.v[0];
	            y += +this.p.v[1];
	            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
	            /* this.v.v[i] = [x,y];
	                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                      this.v._length = numPts; */

	            longFlag = !longFlag;
	            currentAng += angle * dir;
	          }
	        },
	        convertPolygonToPath: function convertPolygonToPath() {
	          var numPts = Math.floor(this.pt.v);
	          var angle = Math.PI * 2 / numPts;
	          var rad = this.or.v;
	          var roundness = this.os.v;
	          var perimSegment = 2 * Math.PI * rad / (numPts * 4);
	          var i;
	          var currentAng = -Math.PI * 0.5;
	          var dir = this.data.d === 3 ? -1 : 1;
	          currentAng += this.r.v;
	          this.v._length = 0;

	          for (i = 0; i < numPts; i += 1) {
	            var x = rad * Math.cos(currentAng);
	            var y = rad * Math.sin(currentAng);
	            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
	            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
	            x += +this.p.v[0];
	            y += +this.p.v[1];
	            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
	            currentAng += angle * dir;
	          }

	          this.paths.length = 0;
	          this.paths[0] = this.v;
	        }
	      };
	      extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
	      return StarShapePropertyFactory;
	    }();

	    var RectShapeProperty = function () {
	      function RectShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.c = true;
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.localShapeCollection.addShape(this.v);
	        this.paths = this.localShapeCollection;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.frameId = -1;
	        this.d = data.d;
	        this.initDynamicPropertyContainer(elem);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
	        this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);

	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertRectToPath();
	        }
	      }

	      RectShapePropertyFactory.prototype = {
	        convertRectToPath: function convertRectToPath() {
	          var p0 = this.p.v[0];
	          var p1 = this.p.v[1];
	          var v0 = this.s.v[0] / 2;
	          var v1 = this.s.v[1] / 2;
	          var round = bmMin(v0, v1, this.r.v);
	          var cPoint = round * (1 - roundCorner);
	          this.v._length = 0;

	          if (this.d === 2 || this.d === 1) {
	            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
	            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);

	            if (round !== 0) {
	              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
	              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
	              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
	            } else {
	              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
	              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
	            }
	          } else {
	            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);

	            if (round !== 0) {
	              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
	              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
	              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
	              this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
	            } else {
	              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
	              this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
	            }
	          }
	        },
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }

	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();

	          if (this._mdf) {
	            this.convertRectToPath();
	          }
	        },
	        reset: resetShape
	      };
	      extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
	      return RectShapePropertyFactory;
	    }();

	    function getShapeProp(elem, data, type) {
	      var prop;

	      if (type === 3 || type === 4) {
	        var dataProp = type === 3 ? data.pt : data.ks;
	        var keys = dataProp.k;

	        if (keys.length) {
	          prop = new KeyframedShapeProperty(elem, data, type);
	        } else {
	          prop = new ShapeProperty(elem, data, type);
	        }
	      } else if (type === 5) {
	        prop = new RectShapeProperty(elem, data);
	      } else if (type === 6) {
	        prop = new EllShapeProperty(elem, data);
	      } else if (type === 7) {
	        prop = new StarShapeProperty(elem, data);
	      }

	      if (prop.k) {
	        elem.addDynamicProperty(prop);
	      }

	      return prop;
	    }

	    function getConstructorFunction() {
	      return ShapeProperty;
	    }

	    function getKeyframedConstructorFunction() {
	      return KeyframedShapeProperty;
	    }

	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	  }();

	  /*!
	   Transformation Matrix v2.0
	   (c) Epistemex 2014-2015
	   www.epistemex.com
	   By Ken Fyrstenberg
	   Contributions by leeoniya.
	   License: MIT, header required.
	   */

	  /**
	   * 2D transformation matrix object initialized with identity matrix.
	   *
	   * The matrix can synchronize a canvas context by supplying the context
	   * as an argument, or later apply current absolute transform to an
	   * existing context.
	   *
	   * All values are handled as floating point values.
	   *
	   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	   * @prop {number} a - scale x
	   * @prop {number} b - shear y
	   * @prop {number} c - shear x
	   * @prop {number} d - scale y
	   * @prop {number} e - translate x
	   * @prop {number} f - translate y
	   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	   * @constructor
	   */

	  var Matrix = function () {
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;

	    function reset() {
	      this.props[0] = 1;
	      this.props[1] = 0;
	      this.props[2] = 0;
	      this.props[3] = 0;
	      this.props[4] = 0;
	      this.props[5] = 1;
	      this.props[6] = 0;
	      this.props[7] = 0;
	      this.props[8] = 0;
	      this.props[9] = 0;
	      this.props[10] = 1;
	      this.props[11] = 0;
	      this.props[12] = 0;
	      this.props[13] = 0;
	      this.props[14] = 0;
	      this.props[15] = 1;
	      return this;
	    }

	    function rotate(angle) {
	      if (angle === 0) {
	        return this;
	      }

	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
	    }

	    function rotateX(angle) {
	      if (angle === 0) {
	        return this;
	      }

	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
	    }

	    function rotateY(angle) {
	      if (angle === 0) {
	        return this;
	      }

	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
	    }

	    function rotateZ(angle) {
	      if (angle === 0) {
	        return this;
	      }

	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
	    }

	    function shear(sx, sy) {
	      return this._t(1, sy, sx, 1, 0, 0);
	    }

	    function skew(ax, ay) {
	      return this.shear(_tan(ax), _tan(ay));
	    }

	    function skewFromAxis(ax, angle) {
	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }

	    function scale(sx, sy, sz) {
	      if (!sz && sz !== 0) {
	        sz = 1;
	      }

	      if (sx === 1 && sy === 1 && sz === 1) {
	        return this;
	      }

	      return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }

	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	      this.props[0] = a;
	      this.props[1] = b;
	      this.props[2] = c;
	      this.props[3] = d;
	      this.props[4] = e;
	      this.props[5] = f;
	      this.props[6] = g;
	      this.props[7] = h;
	      this.props[8] = i;
	      this.props[9] = j;
	      this.props[10] = k;
	      this.props[11] = l;
	      this.props[12] = m;
	      this.props[13] = n;
	      this.props[14] = o;
	      this.props[15] = p;
	      return this;
	    }

	    function translate(tx, ty, tz) {
	      tz = tz || 0;

	      if (tx !== 0 || ty !== 0 || tz !== 0) {
	        return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
	      }

	      return this;
	    }

	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	      var _p = this.props;

	      if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
	        // NOTE: commenting this condition because TurboFan deoptimizes code when present
	        // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	        _p[12] = _p[12] * a2 + _p[15] * m2;
	        _p[13] = _p[13] * f2 + _p[15] * n2;
	        _p[14] = _p[14] * k2 + _p[15] * o2;
	        _p[15] *= p2; // }

	        this._identityCalculated = false;
	        return this;
	      }

	      var a1 = _p[0];
	      var b1 = _p[1];
	      var c1 = _p[2];
	      var d1 = _p[3];
	      var e1 = _p[4];
	      var f1 = _p[5];
	      var g1 = _p[6];
	      var h1 = _p[7];
	      var i1 = _p[8];
	      var j1 = _p[9];
	      var k1 = _p[10];
	      var l1 = _p[11];
	      var m1 = _p[12];
	      var n1 = _p[13];
	      var o1 = _p[14];
	      var p1 = _p[15];
	      /* matrix order (canvas compatible):
	           * ace
	           * bdf
	           * 001
	           */

	      _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	      _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
	      _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
	      _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
	      _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
	      _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
	      _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
	      _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
	      _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
	      _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
	      _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
	      _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
	      _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
	      _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
	      _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
	      _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
	      this._identityCalculated = false;
	      return this;
	    }

	    function multiply(matrix) {
	      var matrixProps = matrix.props;
	      return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
	    }

	    function isIdentity() {
	      if (!this._identityCalculated) {
	        this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	        this._identityCalculated = true;
	      }

	      return this._identity;
	    }

	    function equals(matr) {
	      var i = 0;

	      while (i < 16) {
	        if (matr.props[i] !== this.props[i]) {
	          return false;
	        }

	        i += 1;
	      }

	      return true;
	    }

	    function clone(matr) {
	      var i;

	      for (i = 0; i < 16; i += 1) {
	        matr.props[i] = this.props[i];
	      }

	      return matr;
	    }

	    function cloneFromProps(props) {
	      var i;

	      for (i = 0; i < 16; i += 1) {
	        this.props[i] = props[i];
	      }
	    }

	    function applyToPoint(x, y, z) {
	      return {
	        x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	        y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	        z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	      };
	      /* return {
	           x: x * me.a + y * me.c + me.e,
	           y: x * me.b + y * me.d + me.f
	           }; */
	    }

	    function applyToX(x, y, z) {
	      return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }

	    function applyToY(x, y, z) {
	      return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }

	    function applyToZ(x, y, z) {
	      return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }

	    function getInverseMatrix() {
	      var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	      var a = this.props[5] / determinant;
	      var b = -this.props[1] / determinant;
	      var c = -this.props[4] / determinant;
	      var d = this.props[0] / determinant;
	      var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
	      var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
	      var inverseMatrix = new Matrix();
	      inverseMatrix.props[0] = a;
	      inverseMatrix.props[1] = b;
	      inverseMatrix.props[4] = c;
	      inverseMatrix.props[5] = d;
	      inverseMatrix.props[12] = e;
	      inverseMatrix.props[13] = f;
	      return inverseMatrix;
	    }

	    function inversePoint(pt) {
	      var inverseMatrix = this.getInverseMatrix();
	      return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
	    }

	    function inversePoints(pts) {
	      var i;
	      var len = pts.length;
	      var retPts = [];

	      for (i = 0; i < len; i += 1) {
	        retPts[i] = inversePoint(pts[i]);
	      }

	      return retPts;
	    }

	    function applyToTriplePoints(pt1, pt2, pt3) {
	      var arr = createTypedArray('float32', 6);

	      if (this.isIdentity()) {
	        arr[0] = pt1[0];
	        arr[1] = pt1[1];
	        arr[2] = pt2[0];
	        arr[3] = pt2[1];
	        arr[4] = pt3[0];
	        arr[5] = pt3[1];
	      } else {
	        var p0 = this.props[0];
	        var p1 = this.props[1];
	        var p4 = this.props[4];
	        var p5 = this.props[5];
	        var p12 = this.props[12];
	        var p13 = this.props[13];
	        arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
	        arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
	        arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
	        arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
	        arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
	        arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
	      }

	      return arr;
	    }

	    function applyToPointArray(x, y, z) {
	      var arr;

	      if (this.isIdentity()) {
	        arr = [x, y, z];
	      } else {
	        arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	      }

	      return arr;
	    }

	    function applyToPointStringified(x, y) {
	      if (this.isIdentity()) {
	        return x + ',' + y;
	      }

	      var _p = this.props;
	      return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
	    }

	    function toCSS() {
	      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

	      /* if(this.isIdentity()) {
	              return '';
	          } */
	      var i = 0;
	      var props = this.props;
	      var cssValue = 'matrix3d(';
	      var v = 10000;

	      while (i < 16) {
	        cssValue += _rnd(props[i] * v) / v;
	        cssValue += i === 15 ? ')' : ',';
	        i += 1;
	      }

	      return cssValue;
	    }

	    function roundMatrixProperty(val) {
	      var v = 10000;

	      if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) {
	        return _rnd(val * v) / v;
	      }

	      return val;
	    }

	    function to2dCSS() {
	      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

	      /* if(this.isIdentity()) {
	              return '';
	          } */
	      var props = this.props;

	      var _a = roundMatrixProperty(props[0]);

	      var _b = roundMatrixProperty(props[1]);

	      var _c = roundMatrixProperty(props[4]);

	      var _d = roundMatrixProperty(props[5]);

	      var _e = roundMatrixProperty(props[12]);

	      var _f = roundMatrixProperty(props[13]);

	      return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
	    }

	    return function () {
	      this.reset = reset;
	      this.rotate = rotate;
	      this.rotateX = rotateX;
	      this.rotateY = rotateY;
	      this.rotateZ = rotateZ;
	      this.skew = skew;
	      this.skewFromAxis = skewFromAxis;
	      this.shear = shear;
	      this.scale = scale;
	      this.setTransform = setTransform;
	      this.translate = translate;
	      this.transform = transform;
	      this.multiply = multiply;
	      this.applyToPoint = applyToPoint;
	      this.applyToX = applyToX;
	      this.applyToY = applyToY;
	      this.applyToZ = applyToZ;
	      this.applyToPointArray = applyToPointArray;
	      this.applyToTriplePoints = applyToTriplePoints;
	      this.applyToPointStringified = applyToPointStringified;
	      this.toCSS = toCSS;
	      this.to2dCSS = to2dCSS;
	      this.clone = clone;
	      this.cloneFromProps = cloneFromProps;
	      this.equals = equals;
	      this.inversePoints = inversePoints;
	      this.inversePoint = inversePoint;
	      this.getInverseMatrix = getInverseMatrix;
	      this._t = this.transform;
	      this.isIdentity = isIdentity;
	      this._identity = true;
	      this._identityCalculated = false;
	      this.props = createTypedArray('float32', 16);
	      this.reset();
	    };
	  }();

	  function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
	  var lottie = {};

	  function setLocation(href) {
	    setLocationHref(href);
	  }

	  function searchAnimations() {
	    {
	      animationManager.searchAnimations();
	    }
	  }

	  function setSubframeRendering(flag) {
	    setSubframeEnabled(flag);
	  }

	  function setPrefix(prefix) {
	    setIdPrefix(prefix);
	  }

	  function loadAnimation(params) {

	    return animationManager.loadAnimation(params);
	  }

	  function setQuality(value) {
	    if (typeof value === 'string') {
	      switch (value) {
	        case 'high':
	          setDefaultCurveSegments(200);
	          break;

	        default:
	        case 'medium':
	          setDefaultCurveSegments(50);
	          break;

	        case 'low':
	          setDefaultCurveSegments(10);
	          break;
	      }
	    } else if (!isNaN(value) && value > 1) {
	      setDefaultCurveSegments(value);
	    }
	  }

	  function inBrowser() {
	    return typeof navigator !== 'undefined';
	  }

	  function installPlugin(type, plugin) {
	    if (type === 'expressions') {
	      setExpressionsPlugin(plugin);
	    }
	  }

	  function getFactory(name) {
	    switch (name) {
	      case 'propertyFactory':
	        return PropertyFactory;

	      case 'shapePropertyFactory':
	        return ShapePropertyFactory;

	      case 'matrix':
	        return Matrix;

	      default:
	        return null;
	    }
	  }

	  lottie.play = animationManager.play;
	  lottie.pause = animationManager.pause;
	  lottie.setLocationHref = setLocation;
	  lottie.togglePause = animationManager.togglePause;
	  lottie.setSpeed = animationManager.setSpeed;
	  lottie.setDirection = animationManager.setDirection;
	  lottie.stop = animationManager.stop;
	  lottie.searchAnimations = searchAnimations;
	  lottie.registerAnimation = animationManager.registerAnimation;
	  lottie.loadAnimation = loadAnimation;
	  lottie.setSubframeRendering = setSubframeRendering;
	  lottie.resize = animationManager.resize; // lottie.start = start;

	  lottie.goToAndStop = animationManager.goToAndStop;
	  lottie.destroy = animationManager.destroy;
	  lottie.setQuality = setQuality;
	  lottie.inBrowser = inBrowser;
	  lottie.installPlugin = installPlugin;
	  lottie.freeze = animationManager.freeze;
	  lottie.unfreeze = animationManager.unfreeze;
	  lottie.setVolume = animationManager.setVolume;
	  lottie.mute = animationManager.mute;
	  lottie.unmute = animationManager.unmute;
	  lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
	  lottie.useWebWorker = setWebWorker;
	  lottie.setIDPrefix = setPrefix;
	  lottie.__getFactory = getFactory;
	  lottie.version = '5.12.2';

	  function checkReady() {
	    if (document.readyState === 'complete') {
	      clearInterval(readyStateCheckInterval);
	      searchAnimations();
	    }
	  }

	  function getQueryVariable(variable) {
	    var vars = queryString.split('&');

	    for (var i = 0; i < vars.length; i += 1) {
	      var pair = vars[i].split('=');

	      if (decodeURIComponent(pair[0]) == variable) {
	        // eslint-disable-line eqeqeq
	        return decodeURIComponent(pair[1]);
	      }
	    }

	    return null;
	  }

	  var queryString = '';

	  {
	    var scripts = document.getElementsByTagName('script');
	    var index = scripts.length - 1;
	    var myScript = scripts[index] || {
	      src: ''
	    };
	    queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape

	    getQueryVariable('renderer');
	  }

	  var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility

	  try {
	    if (!(('object' === "undefined" ? "undefined" : _typeof$3(exports)) === 'object' && 'object' !== 'undefined') && !(typeof undefined === 'function' && undefined.amd) // eslint-disable-line no-undef
	    ) {
	      window.bodymovin = lottie;
	    }
	  } catch (err) {//
	  }

	  var ShapeModifiers = function () {
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;

	    function registerModifier(nm, factory) {
	      if (!modifiers[nm]) {
	        modifiers[nm] = factory;
	      }
	    }

	    function getModifier(nm, elem, data) {
	      return new modifiers[nm](elem, data);
	    }

	    return ob;
	  }();

	  function ShapeModifier() {}

	  ShapeModifier.prototype.initModifierProperties = function () {};

	  ShapeModifier.prototype.addShapeToModifier = function () {};

	  ShapeModifier.prototype.addShape = function (data) {
	    if (!this.closed) {
	      // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
	      data.sh.container.addDynamicProperty(data.sh);
	      var shapeData = {
	        shape: data.sh,
	        data: data,
	        localShapeCollection: shapeCollectionPool.newShapeCollection()
	      };
	      this.shapes.push(shapeData);
	      this.addShapeToModifier(shapeData);

	      if (this._isAnimated) {
	        data.setAsAnimated();
	      }
	    }
	  };

	  ShapeModifier.prototype.init = function (elem, data) {
	    this.shapes = [];
	    this.elem = elem;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem, data);
	    this.frameId = initialDefaultFrame;
	    this.closed = false;
	    this.k = false;

	    if (this.dynamicProperties.length) {
	      this.k = true;
	    } else {
	      this.getValue(true);
	    }
	  };

	  ShapeModifier.prototype.processKeys = function () {
	    if (this.elem.globalData.frameId === this.frameId) {
	      return;
	    }

	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	  };

	  extendPrototype([DynamicPropertyContainer], ShapeModifier);

	  function TrimModifier() {}

	  extendPrototype([ShapeModifier], TrimModifier);

	  TrimModifier.prototype.initModifierProperties = function (elem, data) {
	    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
	    this.sValue = 0;
	    this.eValue = 0;
	    this.getValue = this.processKeys;
	    this.m = data.m;
	    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
	  };

	  TrimModifier.prototype.addShapeToModifier = function (shapeData) {
	    shapeData.pathsData = [];
	  };

	  TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = [];

	    if (e <= 1) {
	      segments.push({
	        s: s,
	        e: e
	      });
	    } else if (s >= 1) {
	      segments.push({
	        s: s - 1,
	        e: e - 1
	      });
	    } else {
	      segments.push({
	        s: s,
	        e: 1
	      });
	      segments.push({
	        s: 0,
	        e: e - 1
	      });
	    }

	    var shapeSegments = [];
	    var i;
	    var len = segments.length;
	    var segmentOb;

	    for (i = 0; i < len; i += 1) {
	      segmentOb = segments[i];

	      if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
	        var shapeS;
	        var shapeE;

	        if (segmentOb.s * totalModifierLength <= addedLength) {
	          shapeS = 0;
	        } else {
	          shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	        }

	        if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	          shapeE = 1;
	        } else {
	          shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
	        }

	        shapeSegments.push([shapeS, shapeE]);
	      }
	    }

	    if (!shapeSegments.length) {
	      shapeSegments.push([0, 0]);
	    }

	    return shapeSegments;
	  };

	  TrimModifier.prototype.releasePathsData = function (pathsData) {
	    var i;
	    var len = pathsData.length;

	    for (i = 0; i < len; i += 1) {
	      segmentsLengthPool.release(pathsData[i]);
	    }

	    pathsData.length = 0;
	    return pathsData;
	  };

	  TrimModifier.prototype.processShapes = function (_isFirstFrame) {
	    var s;
	    var e;

	    if (this._mdf || _isFirstFrame) {
	      var o = this.o.v % 360 / 360;

	      if (o < 0) {
	        o += 1;
	      }

	      if (this.s.v > 1) {
	        s = 1 + o;
	      } else if (this.s.v < 0) {
	        s = 0 + o;
	      } else {
	        s = this.s.v + o;
	      }

	      if (this.e.v > 1) {
	        e = 1 + o;
	      } else if (this.e.v < 0) {
	        e = 0 + o;
	      } else {
	        e = this.e.v + o;
	      }

	      if (s > e) {
	        var _s = s;
	        s = e;
	        e = _s;
	      }

	      s = Math.round(s * 10000) * 0.0001;
	      e = Math.round(e * 10000) * 0.0001;
	      this.sValue = s;
	      this.eValue = e;
	    } else {
	      s = this.sValue;
	      e = this.eValue;
	    }

	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var pathsData;
	    var pathData;
	    var totalShapeLength;
	    var totalModifierLength = 0;

	    if (e === s) {
	      for (i = 0; i < len; i += 1) {
	        this.shapes[i].localShapeCollection.releaseShapes();
	        this.shapes[i].shape._mdf = true;
	        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;

	        if (this._mdf) {
	          this.shapes[i].pathsData.length = 0;
	        }
	      }
	    } else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
	      var segments = [];
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used

	        if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
	          shapeData.shape.paths = shapeData.localShapeCollection;
	        } else {
	          shapePaths = shapeData.shape.paths;
	          jLen = shapePaths._length;
	          totalShapeLength = 0;

	          if (!shapeData.shape._mdf && shapeData.pathsData.length) {
	            totalShapeLength = shapeData.totalShapeLength;
	          } else {
	            pathsData = this.releasePathsData(shapeData.pathsData);

	            for (j = 0; j < jLen; j += 1) {
	              pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	              pathsData.push(pathData);
	              totalShapeLength += pathData.totalLength;
	            }

	            shapeData.totalShapeLength = totalShapeLength;
	            shapeData.pathsData = pathsData;
	          }

	          totalModifierLength += totalShapeLength;
	          shapeData.shape._mdf = true;
	        }
	      }

	      var shapeS = s;
	      var shapeE = e;
	      var addedLength = 0;
	      var edges;

	      for (i = len - 1; i >= 0; i -= 1) {
	        shapeData = this.shapes[i];

	        if (shapeData.shape._mdf) {
	          localShapeCollection = shapeData.localShapeCollection;
	          localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group

	          if (this.m === 2 && len > 1) {
	            edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	            addedLength += shapeData.totalShapeLength;
	          } else {
	            edges = [[shapeS, shapeE]];
	          }

	          jLen = edges.length;

	          for (j = 0; j < jLen; j += 1) {
	            shapeS = edges[j][0];
	            shapeE = edges[j][1];
	            segments.length = 0;

	            if (shapeE <= 1) {
	              segments.push({
	                s: shapeData.totalShapeLength * shapeS,
	                e: shapeData.totalShapeLength * shapeE
	              });
	            } else if (shapeS >= 1) {
	              segments.push({
	                s: shapeData.totalShapeLength * (shapeS - 1),
	                e: shapeData.totalShapeLength * (shapeE - 1)
	              });
	            } else {
	              segments.push({
	                s: shapeData.totalShapeLength * shapeS,
	                e: shapeData.totalShapeLength
	              });
	              segments.push({
	                s: 0,
	                e: shapeData.totalShapeLength * (shapeE - 1)
	              });
	            }

	            var newShapesData = this.addShapes(shapeData, segments[0]);

	            if (segments[0].s !== segments[0].e) {
	              if (segments.length > 1) {
	                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];

	                if (lastShapeInCollection.c) {
	                  var lastShape = newShapesData.pop();
	                  this.addPaths(newShapesData, localShapeCollection);
	                  newShapesData = this.addShapes(shapeData, segments[1], lastShape);
	                } else {
	                  this.addPaths(newShapesData, localShapeCollection);
	                  newShapesData = this.addShapes(shapeData, segments[1]);
	                }
	              }

	              this.addPaths(newShapesData, localShapeCollection);
	            }
	          }

	          shapeData.shape.paths = localShapeCollection;
	        }
	      }
	    } else if (this._mdf) {
	      for (i = 0; i < len; i += 1) {
	        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
	        // Don't remove this even if it's losing cached info.
	        this.shapes[i].pathsData.length = 0;
	        this.shapes[i].shape._mdf = true;
	      }
	    }
	  };

	  TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
	    var i;
	    var len = newPaths.length;

	    for (i = 0; i < len; i += 1) {
	      localShapeCollection.addShape(newPaths[i]);
	    }
	  };

	  TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
	    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
	    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);

	    if (newShape) {
	      shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
	    }

	    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
	  };

	  TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
	    shapePath.setXYAt(points[1], points[5], 'o', pos);
	    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);

	    if (newShape) {
	      shapePath.setXYAt(points[0], points[4], 'v', pos);
	    }

	    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
	  };

	  TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i;
	    var len = shapeData.shape.paths._length;
	    var j;
	    var jLen;
	    var addedLength = 0;
	    var currentLengthData;
	    var segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;

	    if (!shapePath) {
	      shapePath = shapePool.newElement();
	      segmentCount = 0;
	      initPos = 0;
	    } else {
	      segmentCount = shapePath._length;
	      initPos = shapePath._length;
	    }

	    shapes.push(shapePath);

	    for (i = 0; i < len; i += 1) {
	      lengths = pathsData[i].lengths;
	      shapePath.c = shapePaths[i].c;
	      jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;

	      for (j = 1; j < jLen; j += 1) {
	        currentLengthData = lengths[j - 1];

	        if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
	          addedLength += currentLengthData.addedLength;
	          shapePath.c = false;
	        } else if (addedLength > shapeSegment.e) {
	          shapePath.c = false;
	          break;
	        } else {
	          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
	            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
	            newShape = false;
	          } else {
	            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
	            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

	            newShape = false;
	            shapePath.c = false;
	          }

	          addedLength += currentLengthData.addedLength;
	          segmentCount += 1;
	        }
	      }

	      if (shapePaths[i].c && lengths.length) {
	        currentLengthData = lengths[j - 1];

	        if (addedLength <= shapeSegment.e) {
	          var segmentLength = lengths[j - 1].addedLength;

	          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
	            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
	            newShape = false;
	          } else {
	            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
	            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

	            newShape = false;
	            shapePath.c = false;
	          }
	        } else {
	          shapePath.c = false;
	        }

	        addedLength += currentLengthData.addedLength;
	        segmentCount += 1;
	      }

	      if (shapePath._length) {
	        shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
	        shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
	      }

	      if (addedLength > shapeSegment.e) {
	        break;
	      }

	      if (i < len - 1) {
	        shapePath = shapePool.newElement();
	        newShape = true;
	        shapes.push(shapePath);
	        segmentCount = 0;
	      }
	    }

	    return shapes;
	  };

	  function PuckerAndBloatModifier() {}

	  extendPrototype([ShapeModifier], PuckerAndBloatModifier);

	  PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
	    this._isAnimated = !!this.amount.effectsSequence.length;
	  };

	  PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
	    var percent = amount / 100;
	    var centerPoint = [0, 0];
	    var pathLength = path._length;
	    var i = 0;

	    for (i = 0; i < pathLength; i += 1) {
	      centerPoint[0] += path.v[i][0];
	      centerPoint[1] += path.v[i][1];
	    }

	    centerPoint[0] /= pathLength;
	    centerPoint[1] /= pathLength;
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	    var vX;
	    var vY;
	    var oX;
	    var oY;
	    var iX;
	    var iY;

	    for (i = 0; i < pathLength; i += 1) {
	      vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
	      vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
	      oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
	      oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
	      iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
	      iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
	      clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
	    }

	    return clonedPath;
	  };

	  PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amount = this.amount.v;

	    if (amount !== 0) {
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;

	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;

	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
	          }
	        }

	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }

	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };

	  var TransformPropertyFactory = function () {
	    var defaultVector = [0, 0];

	    function applyToMatrix(mat) {
	      var _mdf = this._mdf;
	      this.iterateDynamicProperties();
	      this._mdf = this._mdf || _mdf;

	      if (this.a) {
	        mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	      }

	      if (this.s) {
	        mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	      }

	      if (this.sk) {
	        mat.skewFromAxis(-this.sk.v, this.sa.v);
	      }

	      if (this.r) {
	        mat.rotate(-this.r.v);
	      } else {
	        mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	      }

	      if (this.data.p.s) {
	        if (this.data.p.z) {
	          mat.translate(this.px.v, this.py.v, -this.pz.v);
	        } else {
	          mat.translate(this.px.v, this.py.v, 0);
	        }
	      } else {
	        mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	      }
	    }

	    function processKeys(forceRender) {
	      if (this.elem.globalData.frameId === this.frameId) {
	        return;
	      }

	      if (this._isDirty) {
	        this.precalculateMatrix();
	        this._isDirty = false;
	      }

	      this.iterateDynamicProperties();

	      if (this._mdf || forceRender) {
	        var frameRate;
	        this.v.cloneFromProps(this.pre.props);

	        if (this.appliedTransformations < 1) {
	          this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }

	        if (this.appliedTransformations < 2) {
	          this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }

	        if (this.sk && this.appliedTransformations < 3) {
	          this.v.skewFromAxis(-this.sk.v, this.sa.v);
	        }

	        if (this.r && this.appliedTransformations < 4) {
	          this.v.rotate(-this.r.v);
	        } else if (!this.r && this.appliedTransformations < 4) {
	          this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }

	        if (this.autoOriented) {
	          var v1;
	          var v2;
	          frameRate = this.elem.globalData.frameRate;

	          if (this.p && this.p.keyframes && this.p.getValueAtTime) {
	            if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
	              v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
	              v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
	            } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	              v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
	              v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
	            } else {
	              v1 = this.p.pv;
	              v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
	            }
	          } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
	            v1 = [];
	            v2 = [];
	            var px = this.px;
	            var py = this.py;

	            if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
	              v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
	              v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
	              v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
	              v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
	            } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
	              v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
	              v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
	              v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
	              v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
	            } else {
	              v1 = [px.pv, py.pv];
	              v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
	              v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
	            }
	          } else {
	            v2 = defaultVector;
	            v1 = v2;
	          }

	          this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	        }

	        if (this.data.p && this.data.p.s) {
	          if (this.data.p.z) {
	            this.v.translate(this.px.v, this.py.v, -this.pz.v);
	          } else {
	            this.v.translate(this.px.v, this.py.v, 0);
	          }
	        } else {
	          this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	      }

	      this.frameId = this.elem.globalData.frameId;
	    }

	    function precalculateMatrix() {
	      this.appliedTransformations = 0;
	      this.pre.reset();

	      if (!this.a.effectsSequence.length) {
	        this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        this.appliedTransformations = 1;
	      } else {
	        return;
	      }

	      if (!this.s.effectsSequence.length) {
	        this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        this.appliedTransformations = 2;
	      } else {
	        return;
	      }

	      if (this.sk) {
	        if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
	          this.pre.skewFromAxis(-this.sk.v, this.sa.v);
	          this.appliedTransformations = 3;
	        } else {
	          return;
	        }
	      }

	      if (this.r) {
	        if (!this.r.effectsSequence.length) {
	          this.pre.rotate(-this.r.v);
	          this.appliedTransformations = 4;
	        }
	      } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
	        this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        this.appliedTransformations = 4;
	      }
	    }

	    function autoOrient() {//
	      // var prevP = this.getValueAtTime();
	    }

	    function addDynamicProperty(prop) {
	      this._addDynamicProperty(prop);

	      this.elem.addDynamicProperty(prop);
	      this._isDirty = true;
	    }

	    function TransformProperty(elem, data, container) {
	      this.elem = elem;
	      this.frameId = -1;
	      this.propType = 'transform';
	      this.data = data;
	      this.v = new Matrix(); // Precalculated matrix with non animated properties

	      this.pre = new Matrix();
	      this.appliedTransformations = 0;
	      this.initDynamicPropertyContainer(container || elem);

	      if (data.p && data.p.s) {
	        this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
	        this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);

	        if (data.p.z) {
	          this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
	        }
	      } else {
	        this.p = PropertyFactory.getProp(elem, data.p || {
	          k: [0, 0, 0]
	        }, 1, 0, this);
	      }

	      if (data.rx) {
	        this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
	        this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
	        this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);

	        if (data.or.k[0].ti) {
	          var i;
	          var len = data.or.k.length;

	          for (i = 0; i < len; i += 1) {
	            data.or.k[i].to = null;
	            data.or.k[i].ti = null;
	          }
	        }

	        this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180

	        this.or.sh = true;
	      } else {
	        this.r = PropertyFactory.getProp(elem, data.r || {
	          k: 0
	        }, 0, degToRads, this);
	      }

	      if (data.sk) {
	        this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
	        this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
	      }

	      this.a = PropertyFactory.getProp(elem, data.a || {
	        k: [0, 0, 0]
	      }, 1, 0, this);
	      this.s = PropertyFactory.getProp(elem, data.s || {
	        k: [100, 100, 100]
	      }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.

	      if (data.o) {
	        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
	      } else {
	        this.o = {
	          _mdf: false,
	          v: 1
	        };
	      }

	      this._isDirty = true;

	      if (!this.dynamicProperties.length) {
	        this.getValue(true);
	      }
	    }

	    TransformProperty.prototype = {
	      applyToMatrix: applyToMatrix,
	      getValue: processKeys,
	      precalculateMatrix: precalculateMatrix,
	      autoOrient: autoOrient
	    };
	    extendPrototype([DynamicPropertyContainer], TransformProperty);
	    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
	    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

	    function getTransformProperty(elem, data, container) {
	      return new TransformProperty(elem, data, container);
	    }

	    return {
	      getTransformProperty: getTransformProperty
	    };
	  }();

	  function RepeaterModifier() {}

	  extendPrototype([ShapeModifier], RepeaterModifier);

	  RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
	    this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
	    this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
	    this.data = data;

	    if (!this.dynamicProperties.length) {
	      this.getValue(true);
	    }

	    this._isAnimated = !!this.dynamicProperties.length;
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	  };

	  RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	  };

	  RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.frameId = -1;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem, arr[pos]);

	    while (pos > 0) {
	      pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);

	      this._elements.unshift(arr[pos]);
	    }

	    if (this.dynamicProperties.length) {
	      this.k = true;
	    } else {
	      this.getValue(true);
	    }
	  };

	  RepeaterModifier.prototype.resetElements = function (elements) {
	    var i;
	    var len = elements.length;

	    for (i = 0; i < len; i += 1) {
	      elements[i]._processed = false;

	      if (elements[i].ty === 'gr') {
	        this.resetElements(elements[i].it);
	      }
	    }
	  };

	  RepeaterModifier.prototype.cloneElements = function (elements) {
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	  };

	  RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
	    var i;
	    var len = elements.length;

	    for (i = 0; i < len; i += 1) {
	      elements[i]._render = renderFlag;

	      if (elements[i].ty === 'gr') {
	        this.changeGroupRender(elements[i].it, renderFlag);
	      }
	    }
	  };

	  RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
	    var items;
	    var itemsTransform;
	    var i;
	    var dir;
	    var cont;
	    var hasReloaded = false;

	    if (this._mdf || _isFirstFrame) {
	      var copies = Math.ceil(this.c.v);

	      if (this._groups.length < copies) {
	        while (this._groups.length < copies) {
	          var group = {
	            it: this.cloneElements(this._elements),
	            ty: 'gr'
	          };
	          group.it.push({
	            a: {
	              a: 0,
	              ix: 1,
	              k: [0, 0]
	            },
	            nm: 'Transform',
	            o: {
	              a: 0,
	              ix: 7,
	              k: 100
	            },
	            p: {
	              a: 0,
	              ix: 2,
	              k: [0, 0]
	            },
	            r: {
	              a: 1,
	              ix: 6,
	              k: [{
	                s: 0,
	                e: 0,
	                t: 0
	              }, {
	                s: 0,
	                e: 0,
	                t: 1
	              }]
	            },
	            s: {
	              a: 0,
	              ix: 3,
	              k: [100, 100]
	            },
	            sa: {
	              a: 0,
	              ix: 5,
	              k: 0
	            },
	            sk: {
	              a: 0,
	              ix: 4,
	              k: 0
	            },
	            ty: 'tr'
	          });
	          this.arr.splice(0, 0, group);

	          this._groups.splice(0, 0, group);

	          this._currentCopies += 1;
	        }

	        this.elem.reloadShapes();
	        hasReloaded = true;
	      }

	      cont = 0;
	      var renderFlag;

	      for (i = 0; i <= this._groups.length - 1; i += 1) {
	        renderFlag = cont < copies;
	        this._groups[i]._render = renderFlag;
	        this.changeGroupRender(this._groups[i].it, renderFlag);

	        if (!renderFlag) {
	          var elems = this.elemsData[i].it;
	          var transformData = elems[elems.length - 1];

	          if (transformData.transform.op.v !== 0) {
	            transformData.transform.op._mdf = true;
	            transformData.transform.op.v = 0;
	          } else {
	            transformData.transform.op._mdf = false;
	          }
	        }

	        cont += 1;
	      }

	      this._currentCopies = copies; /// /

	      var offset = this.o.v;
	      var offsetModulo = offset % 1;
	      var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	      var pProps = this.pMatrix.props;
	      var rProps = this.rMatrix.props;
	      var sProps = this.sMatrix.props;
	      this.pMatrix.reset();
	      this.rMatrix.reset();
	      this.sMatrix.reset();
	      this.tMatrix.reset();
	      this.matrix.reset();
	      var iteration = 0;

	      if (offset > 0) {
	        while (iteration < roundOffset) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	          iteration += 1;
	        }

	        if (offsetModulo) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	          iteration += offsetModulo;
	        }
	      } else if (offset < 0) {
	        while (iteration > roundOffset) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	          iteration -= 1;
	        }

	        if (offsetModulo) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
	          iteration -= offsetModulo;
	        }
	      }

	      i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	      dir = this.data.m === 1 ? 1 : -1;
	      cont = this._currentCopies;
	      var j;
	      var jLen;

	      while (cont) {
	        items = this.elemsData[i].it;
	        itemsTransform = items[items.length - 1].transform.mProps.v.props;
	        jLen = itemsTransform.length;
	        items[items.length - 1].transform.mProps._mdf = true;
	        items[items.length - 1].transform.op._mdf = true;
	        items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));

	        if (iteration !== 0) {
	          if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
	            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	          }

	          this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
	          this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
	          this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

	          for (j = 0; j < jLen; j += 1) {
	            itemsTransform[j] = this.matrix.props[j];
	          }

	          this.matrix.reset();
	        } else {
	          this.matrix.reset();

	          for (j = 0; j < jLen; j += 1) {
	            itemsTransform[j] = this.matrix.props[j];
	          }
	        }

	        iteration += 1;
	        cont -= 1;
	        i += dir;
	      }
	    } else {
	      cont = this._currentCopies;
	      i = 0;
	      dir = 1;

	      while (cont) {
	        items = this.elemsData[i].it;
	        itemsTransform = items[items.length - 1].transform.mProps.v.props;
	        items[items.length - 1].transform.mProps._mdf = false;
	        items[items.length - 1].transform.op._mdf = false;
	        cont -= 1;
	        i += dir;
	      }
	    }

	    return hasReloaded;
	  };

	  RepeaterModifier.prototype.addShape = function () {};

	  function RoundCornersModifier() {}

	  extendPrototype([ShapeModifier], RoundCornersModifier);

	  RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
	    this._isAnimated = !!this.rd.effectsSequence.length;
	  };

	  RoundCornersModifier.prototype.processPath = function (path, round) {
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	    var i;
	    var len = path._length;
	    var currentV;
	    var currentI;
	    var currentO;
	    var closerV;
	    var distance;
	    var newPosPerc;
	    var index = 0;
	    var vX;
	    var vY;
	    var oX;
	    var oY;
	    var iX;
	    var iY;

	    for (i = 0; i < len; i += 1) {
	      currentV = path.v[i];
	      currentO = path.o[i];
	      currentI = path.i[i];

	      if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
	        if ((i === 0 || i === len - 1) && !path.c) {
	          clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
	          /* clonedPath.v[index] = currentV;
	                  clonedPath.o[index] = currentO;
	                  clonedPath.i[index] = currentI; */

	          index += 1;
	        } else {
	          if (i === 0) {
	            closerV = path.v[len - 1];
	          } else {
	            closerV = path.v[i - 1];
	          }

	          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
	          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
	          iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
	          vX = iX;
	          iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
	          vY = iY;
	          oX = vX - (vX - currentV[0]) * roundCorner;
	          oY = vY - (vY - currentV[1]) * roundCorner;
	          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
	          index += 1;

	          if (i === len - 1) {
	            closerV = path.v[0];
	          } else {
	            closerV = path.v[i + 1];
	          }

	          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
	          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
	          oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
	          vX = oX;
	          oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
	          vY = oY;
	          iX = vX - (vX - currentV[0]) * roundCorner;
	          iY = vY - (vY - currentV[1]) * roundCorner;
	          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
	          index += 1;
	        }
	      } else {
	        clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
	        index += 1;
	      }
	    }

	    return clonedPath;
	  };

	  RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var rd = this.rd.v;

	    if (rd !== 0) {
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;

	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;

	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
	          }
	        }

	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }

	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };

	  function floatEqual(a, b) {
	    return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
	  }

	  function floatZero(f) {
	    return Math.abs(f) <= 0.00001;
	  }

	  function lerp(p0, p1, amount) {
	    return p0 * (1 - amount) + p1 * amount;
	  }

	  function lerpPoint(p0, p1, amount) {
	    return [lerp(p0[0], p1[0], amount), lerp(p0[1], p1[1], amount)];
	  }

	  function quadRoots(a, b, c) {
	    // no root
	    if (a === 0) return [];
	    var s = b * b - 4 * a * c; // Complex roots

	    if (s < 0) return [];
	    var singleRoot = -b / (2 * a); // 1 root

	    if (s === 0) return [singleRoot];
	    var delta = Math.sqrt(s) / (2 * a); // 2 roots

	    return [singleRoot - delta, singleRoot + delta];
	  }

	  function polynomialCoefficients(p0, p1, p2, p3) {
	    return [-p0 + 3 * p1 - 3 * p2 + p3, 3 * p0 - 6 * p1 + 3 * p2, -3 * p0 + 3 * p1, p0];
	  }

	  function singlePoint(p) {
	    return new PolynomialBezier(p, p, p, p, false);
	  }

	  function PolynomialBezier(p0, p1, p2, p3, linearize) {
	    if (linearize && pointEqual(p0, p1)) {
	      p1 = lerpPoint(p0, p3, 1 / 3);
	    }

	    if (linearize && pointEqual(p2, p3)) {
	      p2 = lerpPoint(p0, p3, 2 / 3);
	    }

	    var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
	    var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
	    this.a = [coeffx[0], coeffy[0]];
	    this.b = [coeffx[1], coeffy[1]];
	    this.c = [coeffx[2], coeffy[2]];
	    this.d = [coeffx[3], coeffy[3]];
	    this.points = [p0, p1, p2, p3];
	  }

	  PolynomialBezier.prototype.point = function (t) {
	    return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
	  };

	  PolynomialBezier.prototype.derivative = function (t) {
	    return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
	  };

	  PolynomialBezier.prototype.tangentAngle = function (t) {
	    var p = this.derivative(t);
	    return Math.atan2(p[1], p[0]);
	  };

	  PolynomialBezier.prototype.normalAngle = function (t) {
	    var p = this.derivative(t);
	    return Math.atan2(p[0], p[1]);
	  };

	  PolynomialBezier.prototype.inflectionPoints = function () {
	    var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
	    if (floatZero(denom)) return [];
	    var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
	    var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
	    if (square < 0) return [];
	    var root = Math.sqrt(square);

	    if (floatZero(root)) {
	      if (root > 0 && root < 1) return [tcusp];
	      return [];
	    }

	    return [tcusp - root, tcusp + root].filter(function (r) {
	      return r > 0 && r < 1;
	    });
	  };

	  PolynomialBezier.prototype.split = function (t) {
	    if (t <= 0) return [singlePoint(this.points[0]), this];
	    if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
	    var p10 = lerpPoint(this.points[0], this.points[1], t);
	    var p11 = lerpPoint(this.points[1], this.points[2], t);
	    var p12 = lerpPoint(this.points[2], this.points[3], t);
	    var p20 = lerpPoint(p10, p11, t);
	    var p21 = lerpPoint(p11, p12, t);
	    var p3 = lerpPoint(p20, p21, t);
	    return [new PolynomialBezier(this.points[0], p10, p20, p3, true), new PolynomialBezier(p3, p21, p12, this.points[3], true)];
	  };

	  function extrema(bez, comp) {
	    var min = bez.points[0][comp];
	    var max = bez.points[bez.points.length - 1][comp];

	    if (min > max) {
	      var e = max;
	      max = min;
	      min = e;
	    } // Derivative roots to find min/max


	    var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);

	    for (var i = 0; i < f.length; i += 1) {
	      if (f[i] > 0 && f[i] < 1) {
	        var val = bez.point(f[i])[comp];
	        if (val < min) min = val;else if (val > max) max = val;
	      }
	    }

	    return {
	      min: min,
	      max: max
	    };
	  }

	  PolynomialBezier.prototype.bounds = function () {
	    return {
	      x: extrema(this, 0),
	      y: extrema(this, 1)
	    };
	  };

	  PolynomialBezier.prototype.boundingBox = function () {
	    var bounds = this.bounds();
	    return {
	      left: bounds.x.min,
	      right: bounds.x.max,
	      top: bounds.y.min,
	      bottom: bounds.y.max,
	      width: bounds.x.max - bounds.x.min,
	      height: bounds.y.max - bounds.y.min,
	      cx: (bounds.x.max + bounds.x.min) / 2,
	      cy: (bounds.y.max + bounds.y.min) / 2
	    };
	  };

	  function intersectData(bez, t1, t2) {
	    var box = bez.boundingBox();
	    return {
	      cx: box.cx,
	      cy: box.cy,
	      width: box.width,
	      height: box.height,
	      bez: bez,
	      t: (t1 + t2) / 2,
	      t1: t1,
	      t2: t2
	    };
	  }

	  function splitData(data) {
	    var split = data.bez.split(0.5);
	    return [intersectData(split[0], data.t1, data.t), intersectData(split[1], data.t, data.t2)];
	  }

	  function boxIntersect(b1, b2) {
	    return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
	  }

	  function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
	    if (!boxIntersect(d1, d2)) return;

	    if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
	      intersections.push([d1.t, d2.t]);
	      return;
	    }

	    var d1s = splitData(d1);
	    var d2s = splitData(d2);
	    intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
	  }

	  PolynomialBezier.prototype.intersections = function (other, tolerance, maxRecursion) {
	    if (tolerance === undefined) tolerance = 2;
	    if (maxRecursion === undefined) maxRecursion = 7;
	    var intersections = [];
	    intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
	    return intersections;
	  };

	  PolynomialBezier.shapeSegment = function (shapePath, index) {
	    var nextIndex = (index + 1) % shapePath.length();
	    return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
	  };

	  PolynomialBezier.shapeSegmentInverted = function (shapePath, index) {
	    var nextIndex = (index + 1) % shapePath.length();
	    return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
	  };

	  function crossProduct(a, b) {
	    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	  }

	  function lineIntersection(start1, end1, start2, end2) {
	    var v1 = [start1[0], start1[1], 1];
	    var v2 = [end1[0], end1[1], 1];
	    var v3 = [start2[0], start2[1], 1];
	    var v4 = [end2[0], end2[1], 1];
	    var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
	    if (floatZero(r[2])) return null;
	    return [r[0] / r[2], r[1] / r[2]];
	  }

	  function polarOffset(p, angle, length) {
	    return [p[0] + Math.cos(angle) * length, p[1] - Math.sin(angle) * length];
	  }

	  function pointDistance(p1, p2) {
	    return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
	  }

	  function pointEqual(p1, p2) {
	    return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
	  }

	  function ZigZagModifier() {}

	  extendPrototype([ShapeModifier], ZigZagModifier);

	  ZigZagModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
	    this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
	    this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
	    this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
	  };

	  function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
	    var angO = angle - Math.PI / 2;
	    var angI = angle + Math.PI / 2;
	    var px = point[0] + Math.cos(angle) * direction * amplitude;
	    var py = point[1] - Math.sin(angle) * direction * amplitude;
	    outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
	  }

	  function getPerpendicularVector(pt1, pt2) {
	    var vector = [pt2[0] - pt1[0], pt2[1] - pt1[1]];
	    var rot = -Math.PI * 0.5;
	    var rotatedVector = [Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1], Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]];
	    return rotatedVector;
	  }

	  function getProjectingAngle(path, cur) {
	    var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
	    var nextIndex = (cur + 1) % path.length();
	    var prevPoint = path.v[prevIndex];
	    var nextPoint = path.v[nextIndex];
	    var pVector = getPerpendicularVector(prevPoint, nextPoint);
	    return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
	  }

	  function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
	    var angle = getProjectingAngle(path, cur);
	    var point = path.v[cur % path._length];
	    var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
	    var nextPoint = path.v[(cur + 1) % path._length];
	    var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
	    var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
	    setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2));
	  }

	  function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
	    for (var i = 0; i < frequency; i += 1) {
	      var t = (i + 1) / (frequency + 1);
	      var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
	      var angle = segment.normalAngle(t);
	      var point = segment.point(t);
	      setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2));
	      direction = -direction;
	    }

	    return direction;
	  }

	  ZigZagModifier.prototype.processPath = function (path, amplitude, frequency, pointType) {
	    var count = path._length;
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;

	    if (!path.c) {
	      count -= 1;
	    }

	    if (count === 0) return clonedPath;
	    var direction = -1;
	    var segment = PolynomialBezier.shapeSegment(path, 0);
	    zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);

	    for (var i = 0; i < count; i += 1) {
	      direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);

	      if (i === count - 1 && !path.c) {
	        segment = null;
	      } else {
	        segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
	      }

	      zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
	    }

	    return clonedPath;
	  };

	  ZigZagModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amplitude = this.amplitude.v;
	    var frequency = Math.max(0, Math.round(this.frequency.v));
	    var pointType = this.pointsType.v;

	    if (amplitude !== 0) {
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;

	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;

	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
	          }
	        }

	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }

	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };

	  function linearOffset(p1, p2, amount) {
	    var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
	    return [polarOffset(p1, angle, amount), polarOffset(p2, angle, amount)];
	  }

	  function offsetSegment(segment, amount) {
	    var p0;
	    var p1a;
	    var p1b;
	    var p2b;
	    var p2a;
	    var p3;
	    var e;
	    e = linearOffset(segment.points[0], segment.points[1], amount);
	    p0 = e[0];
	    p1a = e[1];
	    e = linearOffset(segment.points[1], segment.points[2], amount);
	    p1b = e[0];
	    p2b = e[1];
	    e = linearOffset(segment.points[2], segment.points[3], amount);
	    p2a = e[0];
	    p3 = e[1];
	    var p1 = lineIntersection(p0, p1a, p1b, p2b);
	    if (p1 === null) p1 = p1a;
	    var p2 = lineIntersection(p2a, p3, p1b, p2b);
	    if (p2 === null) p2 = p2a;
	    return new PolynomialBezier(p0, p1, p2, p3);
	  }

	  function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
	    var p0 = seg1.points[3];
	    var p1 = seg2.points[0]; // Bevel

	    if (lineJoin === 3) return p0; // Connected, they don't need a joint

	    if (pointEqual(p0, p1)) return p0; // Round

	    if (lineJoin === 2) {
	      var angleOut = -seg1.tangentAngle(1);
	      var angleIn = -seg2.tangentAngle(0) + Math.PI;
	      var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
	      var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
	      var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
	      outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
	      tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
	      outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
	      return p1;
	    } // Miter


	    var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
	    var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
	    var intersection = lineIntersection(t0, p0, p1, t1);

	    if (intersection && pointDistance(intersection, p0) < miterLimit) {
	      outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
	      return intersection;
	    }

	    return p0;
	  }

	  function getIntersection(a, b) {
	    var intersect = a.intersections(b);
	    if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
	    if (intersect.length) return intersect[0];
	    return null;
	  }

	  function pruneSegmentIntersection(a, b) {
	    var outa = a.slice();
	    var outb = b.slice();
	    var intersect = getIntersection(a[a.length - 1], b[0]);

	    if (intersect) {
	      outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
	      outb[0] = b[0].split(intersect[1])[1];
	    }

	    if (a.length > 1 && b.length > 1) {
	      intersect = getIntersection(a[0], b[b.length - 1]);

	      if (intersect) {
	        return [[a[0].split(intersect[0])[0]], [b[b.length - 1].split(intersect[1])[1]]];
	      }
	    }

	    return [outa, outb];
	  }

	  function pruneIntersections(segments) {
	    var e;

	    for (var i = 1; i < segments.length; i += 1) {
	      e = pruneSegmentIntersection(segments[i - 1], segments[i]);
	      segments[i - 1] = e[0];
	      segments[i] = e[1];
	    }

	    if (segments.length > 1) {
	      e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
	      segments[segments.length - 1] = e[0];
	      segments[0] = e[1];
	    }

	    return segments;
	  }

	  function offsetSegmentSplit(segment, amount) {
	    /*
	      We split each bezier segment into smaller pieces based
	      on inflection points, this ensures the control point
	      polygon is convex.
	        (A cubic bezier can have none, one, or two inflection points)
	    */
	    var flex = segment.inflectionPoints();
	    var left;
	    var right;
	    var split;
	    var mid;

	    if (flex.length === 0) {
	      return [offsetSegment(segment, amount)];
	    }

	    if (flex.length === 1 || floatEqual(flex[1], 1)) {
	      split = segment.split(flex[0]);
	      left = split[0];
	      right = split[1];
	      return [offsetSegment(left, amount), offsetSegment(right, amount)];
	    }

	    split = segment.split(flex[0]);
	    left = split[0];
	    var t = (flex[1] - flex[0]) / (1 - flex[0]);
	    split = split[1].split(t);
	    mid = split[0];
	    right = split[1];
	    return [offsetSegment(left, amount), offsetSegment(mid, amount), offsetSegment(right, amount)];
	  }

	  function OffsetPathModifier() {}

	  extendPrototype([ShapeModifier], OffsetPathModifier);

	  OffsetPathModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
	    this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
	    this.lineJoin = data.lj;
	    this._isAnimated = this.amount.effectsSequence.length !== 0;
	  };

	  OffsetPathModifier.prototype.processPath = function (inputBezier, amount, lineJoin, miterLimit) {
	    var outputBezier = shapePool.newElement();
	    outputBezier.c = inputBezier.c;
	    var count = inputBezier.length();

	    if (!inputBezier.c) {
	      count -= 1;
	    }

	    var i;
	    var j;
	    var segment;
	    var multiSegments = [];

	    for (i = 0; i < count; i += 1) {
	      segment = PolynomialBezier.shapeSegment(inputBezier, i);
	      multiSegments.push(offsetSegmentSplit(segment, amount));
	    }

	    if (!inputBezier.c) {
	      for (i = count - 1; i >= 0; i -= 1) {
	        segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
	        multiSegments.push(offsetSegmentSplit(segment, amount));
	      }
	    }

	    multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints

	    var lastPoint = null;
	    var lastSeg = null;

	    for (i = 0; i < multiSegments.length; i += 1) {
	      var multiSegment = multiSegments[i];
	      if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
	      lastSeg = multiSegment[multiSegment.length - 1];

	      for (j = 0; j < multiSegment.length; j += 1) {
	        segment = multiSegment[j];

	        if (lastPoint && pointEqual(segment.points[0], lastPoint)) {
	          outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
	        } else {
	          outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
	        }

	        outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
	        lastPoint = segment.points[3];
	      }
	    }

	    if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
	    return outputBezier;
	  };

	  OffsetPathModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amount = this.amount.v;
	    var miterLimit = this.miterLimit.v;
	    var lineJoin = this.lineJoin;

	    if (amount !== 0) {
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;

	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;

	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
	          }
	        }

	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }

	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };

	  function getFontProperties(fontData) {
	    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
	    var fWeight = 'normal';
	    var fStyle = 'normal';
	    var len = styles.length;
	    var styleName;

	    for (var i = 0; i < len; i += 1) {
	      styleName = styles[i].toLowerCase();

	      switch (styleName) {
	        case 'italic':
	          fStyle = 'italic';
	          break;

	        case 'bold':
	          fWeight = '700';
	          break;

	        case 'black':
	          fWeight = '900';
	          break;

	        case 'medium':
	          fWeight = '500';
	          break;

	        case 'regular':
	        case 'normal':
	          fWeight = '400';
	          break;

	        case 'light':
	        case 'thin':
	          fWeight = '200';
	          break;
	      }
	    }

	    return {
	      style: fStyle,
	      weight: fontData.fWeight || fWeight
	    };
	  }

	  var FontManager = function () {
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	      w: 0,
	      size: 0,
	      shapes: [],
	      data: {
	        shapes: []
	      }
	    };
	    var combinedCharacters = []; // Hindi characters

	    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
	    var BLACK_FLAG_CODE_POINT = 127988;
	    var CANCEL_TAG_CODE_POINT = 917631;
	    var A_TAG_CODE_POINT = 917601;
	    var Z_TAG_CODE_POINT = 917626;
	    var VARIATION_SELECTOR_16_CODE_POINT = 65039;
	    var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
	    var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
	    var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
	    var surrogateModifiers = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'];

	    function trimFontOptions(font) {
	      var familyArray = font.split(',');
	      var i;
	      var len = familyArray.length;
	      var enabledFamilies = [];

	      for (i = 0; i < len; i += 1) {
	        if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
	          enabledFamilies.push(familyArray[i]);
	        }
	      }

	      return enabledFamilies.join(',');
	    }

	    function setUpNode(font, family) {
	      var parentNode = createTag('span'); // Node is invisible to screen readers.

	      parentNode.setAttribute('aria-hidden', true);
	      parentNode.style.fontFamily = family;
	      var node = createTag('span'); // Characters that vary significantly among different fonts

	      node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen

	      parentNode.style.position = 'absolute';
	      parentNode.style.left = '-10000px';
	      parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious

	      parentNode.style.fontSize = '300px'; // Reset any font properties

	      parentNode.style.fontVariant = 'normal';
	      parentNode.style.fontStyle = 'normal';
	      parentNode.style.fontWeight = 'normal';
	      parentNode.style.letterSpacing = '0';
	      parentNode.appendChild(node);
	      document.body.appendChild(parentNode); // Remember width with no applied web font

	      var width = node.offsetWidth;
	      node.style.fontFamily = trimFontOptions(font) + ', ' + family;
	      return {
	        node: node,
	        w: width,
	        parent: parentNode
	      };
	    }

	    function checkLoadedFonts() {
	      var i;
	      var len = this.fonts.length;
	      var node;
	      var w;
	      var loadedCount = len;

	      for (i = 0; i < len; i += 1) {
	        if (this.fonts[i].loaded) {
	          loadedCount -= 1;
	        } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
	          this.fonts[i].loaded = true;
	        } else {
	          node = this.fonts[i].monoCase.node;
	          w = this.fonts[i].monoCase.w;

	          if (node.offsetWidth !== w) {
	            loadedCount -= 1;
	            this.fonts[i].loaded = true;
	          } else {
	            node = this.fonts[i].sansCase.node;
	            w = this.fonts[i].sansCase.w;

	            if (node.offsetWidth !== w) {
	              loadedCount -= 1;
	              this.fonts[i].loaded = true;
	            }
	          }

	          if (this.fonts[i].loaded) {
	            this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	            this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	          }
	        }
	      }

	      if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
	        setTimeout(this.checkLoadedFontsBinded, 20);
	      } else {
	        setTimeout(this.setIsLoadedBinded, 10);
	      }
	    }

	    function createHelper(fontData, def) {
	      var engine = document.body && def ? 'svg' : 'canvas';
	      var helper;
	      var fontProps = getFontProperties(fontData);

	      if (engine === 'svg') {
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;

	        tHelper.setAttribute('font-family', fontData.fFamily);
	        tHelper.setAttribute('font-style', fontProps.style);
	        tHelper.setAttribute('font-weight', fontProps.weight);
	        tHelper.textContent = '1';

	        if (fontData.fClass) {
	          tHelper.style.fontFamily = 'inherit';
	          tHelper.setAttribute('class', fontData.fClass);
	        } else {
	          tHelper.style.fontFamily = fontData.fFamily;
	        }

	        def.appendChild(tHelper);
	        helper = tHelper;
	      } else {
	        var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
	        tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
	        helper = tCanvasHelper;
	      }

	      function measure(text) {
	        if (engine === 'svg') {
	          helper.textContent = text;
	          return helper.getComputedTextLength();
	        }

	        return helper.measureText(text).width;
	      }

	      return {
	        measureText: measure
	      };
	    }

	    function addFonts(fontData, defs) {
	      if (!fontData) {
	        this.isLoaded = true;
	        return;
	      }

	      if (this.chars) {
	        this.isLoaded = true;
	        this.fonts = fontData.list;
	        return;
	      }

	      if (!document.body) {
	        this.isLoaded = true;
	        fontData.list.forEach(function (data) {
	          data.helper = createHelper(data);
	          data.cache = {};
	        });
	        this.fonts = fontData.list;
	        return;
	      }

	      var fontArr = fontData.list;
	      var i;
	      var len = fontArr.length;
	      var _pendingFonts = len;

	      for (i = 0; i < len; i += 1) {
	        var shouldLoadFont = true;
	        var loadedSelector;
	        var j;
	        fontArr[i].loaded = false;
	        fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
	        fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');

	        if (!fontArr[i].fPath) {
	          fontArr[i].loaded = true;
	          _pendingFonts -= 1;
	        } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
	          loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

	          if (loadedSelector.length > 0) {
	            shouldLoadFont = false;
	          }

	          if (shouldLoadFont) {
	            var s = createTag('style');
	            s.setAttribute('f-forigin', fontArr[i].fOrigin);
	            s.setAttribute('f-origin', fontArr[i].origin);
	            s.setAttribute('f-family', fontArr[i].fFamily);
	            s.type = 'text/css';
	            s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
	            defs.appendChild(s);
	          }
	        } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
	          loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

	          for (j = 0; j < loadedSelector.length; j += 1) {
	            if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
	              // Font is already loaded
	              shouldLoadFont = false;
	            }
	          }

	          if (shouldLoadFont) {
	            var l = createTag('link');
	            l.setAttribute('f-forigin', fontArr[i].fOrigin);
	            l.setAttribute('f-origin', fontArr[i].origin);
	            l.type = 'text/css';
	            l.rel = 'stylesheet';
	            l.href = fontArr[i].fPath;
	            document.body.appendChild(l);
	          }
	        } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
	          loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

	          for (j = 0; j < loadedSelector.length; j += 1) {
	            if (fontArr[i].fPath === loadedSelector[j].src) {
	              // Font is already loaded
	              shouldLoadFont = false;
	            }
	          }

	          if (shouldLoadFont) {
	            var sc = createTag('link');
	            sc.setAttribute('f-forigin', fontArr[i].fOrigin);
	            sc.setAttribute('f-origin', fontArr[i].origin);
	            sc.setAttribute('rel', 'stylesheet');
	            sc.setAttribute('href', fontArr[i].fPath);
	            defs.appendChild(sc);
	          }
	        }

	        fontArr[i].helper = createHelper(fontArr[i], defs);
	        fontArr[i].cache = {};
	        this.fonts.push(fontArr[i]);
	      }

	      if (_pendingFonts === 0) {
	        this.isLoaded = true;
	      } else {
	        // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
	        // Adding this timeout seems to fix it
	        setTimeout(this.checkLoadedFonts.bind(this), 100);
	      }
	    }

	    function addChars(chars) {
	      if (!chars) {
	        return;
	      }

	      if (!this.chars) {
	        this.chars = [];
	      }

	      var i;
	      var len = chars.length;
	      var j;
	      var jLen = this.chars.length;
	      var found;

	      for (i = 0; i < len; i += 1) {
	        j = 0;
	        found = false;

	        while (j < jLen) {
	          if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
	            found = true;
	          }

	          j += 1;
	        }

	        if (!found) {
	          this.chars.push(chars[i]);
	          jLen += 1;
	        }
	      }
	    }

	    function getCharData(_char, style, font) {
	      var i = 0;
	      var len = this.chars.length;

	      while (i < len) {
	        if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
	          return this.chars[i];
	        }

	        i += 1;
	      }

	      if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
	      && !this._warned) {
	        this._warned = true;
	        console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
	      }

	      return emptyChar;
	    }

	    function measureText(_char2, fontName, size) {
	      var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
	      // to avoid collisions between equal chars

	      var index = _char2;

	      if (!fontData.cache[index]) {
	        var tHelper = fontData.helper;

	        if (_char2 === ' ') {
	          var doubleSize = tHelper.measureText('|' + _char2 + '|');
	          var singleSize = tHelper.measureText('||');
	          fontData.cache[index] = (doubleSize - singleSize) / 100;
	        } else {
	          fontData.cache[index] = tHelper.measureText(_char2) / 100;
	        }
	      }

	      return fontData.cache[index] * size;
	    }

	    function getFontByName(name) {
	      var i = 0;
	      var len = this.fonts.length;

	      while (i < len) {
	        if (this.fonts[i].fName === name) {
	          return this.fonts[i];
	        }

	        i += 1;
	      }

	      return this.fonts[0];
	    }

	    function getCodePoint(string) {
	      var codePoint = 0;
	      var first = string.charCodeAt(0);

	      if (first >= 0xD800 && first <= 0xDBFF) {
	        var second = string.charCodeAt(1);

	        if (second >= 0xDC00 && second <= 0xDFFF) {
	          codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	        }
	      }

	      return codePoint;
	    } // Skin tone modifiers


	    function isModifier(firstCharCode, secondCharCode) {
	      var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
	      return surrogateModifiers.indexOf(sum) !== -1;
	    }

	    function isZeroWidthJoiner(charCode) {
	      return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
	    } // This codepoint may change the appearance of the preceding character.
	    // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
	    // as a colorful image as compared to a monochrome text variant.


	    function isVariationSelector(charCode) {
	      return charCode === VARIATION_SELECTOR_16_CODE_POINT;
	    } // The regional indicator symbols are a set of 26 alphabetic Unicode
	    /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
	    // two-letter country codes in a way that allows optional special treatment.


	    function isRegionalCode(string) {
	      var codePoint = getCodePoint(string);

	      if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) {
	        return true;
	      }

	      return false;
	    } // Some Emoji implementations represent combinations of
	    // two “regional indicator” letters as a single flag symbol.


	    function isFlagEmoji(string) {
	      return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
	    }

	    function isCombinedCharacter(_char3) {
	      return combinedCharacters.indexOf(_char3) !== -1;
	    } // Regional flags start with a BLACK_FLAG_CODE_POINT
	    // folowed by 5 chars in the TAG range
	    // and end with a CANCEL_TAG_CODE_POINT


	    function isRegionalFlag(text, index) {
	      var codePoint = getCodePoint(text.substr(index, 2));

	      if (codePoint !== BLACK_FLAG_CODE_POINT) {
	        return false;
	      }

	      var count = 0;
	      index += 2;

	      while (count < 5) {
	        codePoint = getCodePoint(text.substr(index, 2));

	        if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) {
	          return false;
	        }

	        count += 1;
	        index += 2;
	      }

	      return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
	    }

	    function setIsLoaded() {
	      this.isLoaded = true;
	    }

	    var Font = function Font() {
	      this.fonts = [];
	      this.chars = null;
	      this.typekitLoaded = 0;
	      this.isLoaded = false;
	      this._warned = false;
	      this.initTime = Date.now();
	      this.setIsLoadedBinded = this.setIsLoaded.bind(this);
	      this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
	    };

	    Font.isModifier = isModifier;
	    Font.isZeroWidthJoiner = isZeroWidthJoiner;
	    Font.isFlagEmoji = isFlagEmoji;
	    Font.isRegionalCode = isRegionalCode;
	    Font.isCombinedCharacter = isCombinedCharacter;
	    Font.isRegionalFlag = isRegionalFlag;
	    Font.isVariationSelector = isVariationSelector;
	    Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
	    var fontPrototype = {
	      addChars: addChars,
	      addFonts: addFonts,
	      getCharData: getCharData,
	      getFontByName: getFontByName,
	      measureText: measureText,
	      checkLoadedFonts: checkLoadedFonts,
	      setIsLoaded: setIsLoaded
	    };
	    Font.prototype = fontPrototype;
	    return Font;
	  }();

	  function SlotManager(animationData) {
	    this.animationData = animationData;
	  }

	  SlotManager.prototype.getProp = function (data) {
	    if (this.animationData.slots && this.animationData.slots[data.sid]) {
	      return Object.assign(data, this.animationData.slots[data.sid].p);
	    }

	    return data;
	  };

	  function slotFactory(animationData) {
	    return new SlotManager(animationData);
	  }

	  function RenderableElement() {}

	  RenderableElement.prototype = {
	    initRenderable: function initRenderable() {
	      // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	      this.isInRange = false; // layer's display state

	      this.hidden = false; // If layer's transparency equals 0, it can be hidden

	      this.isTransparent = false; // list of animated components

	      this.renderableComponents = [];
	    },
	    addRenderableComponent: function addRenderableComponent(component) {
	      if (this.renderableComponents.indexOf(component) === -1) {
	        this.renderableComponents.push(component);
	      }
	    },
	    removeRenderableComponent: function removeRenderableComponent(component) {
	      if (this.renderableComponents.indexOf(component) !== -1) {
	        this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
	      }
	    },
	    prepareRenderableFrame: function prepareRenderableFrame(num) {
	      this.checkLayerLimits(num);
	    },
	    checkTransparency: function checkTransparency() {
	      if (this.finalTransform.mProp.o.v <= 0) {
	        if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
	          this.isTransparent = true;
	          this.hide();
	        }
	      } else if (this.isTransparent) {
	        this.isTransparent = false;
	        this.show();
	      }
	    },

	    /**
	       * @function
	       * Initializes frame related properties.
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       *
	       */
	    checkLayerLimits: function checkLayerLimits(num) {
	      if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
	        if (this.isInRange !== true) {
	          this.globalData._mdf = true;
	          this._mdf = true;
	          this.isInRange = true;
	          this.show();
	        }
	      } else if (this.isInRange !== false) {
	        this.globalData._mdf = true;
	        this.isInRange = false;
	        this.hide();
	      }
	    },
	    renderRenderable: function renderRenderable() {
	      var i;
	      var len = this.renderableComponents.length;

	      for (i = 0; i < len; i += 1) {
	        this.renderableComponents[i].renderFrame(this._isFirstFrame);
	      }
	      /* this.maskManager.renderFrame(this.finalTransform.mat);
	          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */

	    },
	    sourceRectAtTime: function sourceRectAtTime() {
	      return {
	        top: 0,
	        left: 0,
	        width: 100,
	        height: 100
	      };
	    },
	    getLayerSize: function getLayerSize() {
	      if (this.data.ty === 5) {
	        return {
	          w: this.data.textData.width,
	          h: this.data.textData.height
	        };
	      }

	      return {
	        w: this.data.width,
	        h: this.data.height
	      };
	    }
	  };

	  var getBlendMode = function () {
	    var blendModeEnums = {
	      0: 'source-over',
	      1: 'multiply',
	      2: 'screen',
	      3: 'overlay',
	      4: 'darken',
	      5: 'lighten',
	      6: 'color-dodge',
	      7: 'color-burn',
	      8: 'hard-light',
	      9: 'soft-light',
	      10: 'difference',
	      11: 'exclusion',
	      12: 'hue',
	      13: 'saturation',
	      14: 'color',
	      15: 'luminosity'
	    };
	    return function (mode) {
	      return blendModeEnums[mode] || '';
	    };
	  }();

	  function SliderEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function AngleEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function ColorEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
	  }

	  function PointEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
	  }

	  function LayerIndexEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function MaskIndexEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function CheckboxEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function NoValueEffect() {
	    this.p = {};
	  }

	  function EffectsManager(data, element) {
	    var effects = data.ef || [];
	    this.effectElements = [];
	    var i;
	    var len = effects.length;
	    var effectItem;

	    for (i = 0; i < len; i += 1) {
	      effectItem = new GroupEffect(effects[i], element);
	      this.effectElements.push(effectItem);
	    }
	  }

	  function GroupEffect(data, element) {
	    this.init(data, element);
	  }

	  extendPrototype([DynamicPropertyContainer], GroupEffect);
	  GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

	  GroupEffect.prototype.init = function (data, element) {
	    this.data = data;
	    this.effectElements = [];
	    this.initDynamicPropertyContainer(element);
	    var i;
	    var len = this.data.ef.length;
	    var eff;
	    var effects = this.data.ef;

	    for (i = 0; i < len; i += 1) {
	      eff = null;

	      switch (effects[i].ty) {
	        case 0:
	          eff = new SliderEffect(effects[i], element, this);
	          break;

	        case 1:
	          eff = new AngleEffect(effects[i], element, this);
	          break;

	        case 2:
	          eff = new ColorEffect(effects[i], element, this);
	          break;

	        case 3:
	          eff = new PointEffect(effects[i], element, this);
	          break;

	        case 4:
	        case 7:
	          eff = new CheckboxEffect(effects[i], element, this);
	          break;

	        case 10:
	          eff = new LayerIndexEffect(effects[i], element, this);
	          break;

	        case 11:
	          eff = new MaskIndexEffect(effects[i], element, this);
	          break;

	        case 5:
	          eff = new EffectsManager(effects[i], element);
	          break;
	        // case 6:

	        default:
	          eff = new NoValueEffect(effects[i]);
	          break;
	      }

	      if (eff) {
	        this.effectElements.push(eff);
	      }
	    }
	  };

	  function BaseElement() {}

	  BaseElement.prototype = {
	    checkMasks: function checkMasks() {
	      if (!this.data.hasMask) {
	        return false;
	      }

	      var i = 0;
	      var len = this.data.masksProperties.length;

	      while (i < len) {
	        if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) {
	          return true;
	        }

	        i += 1;
	      }

	      return false;
	    },
	    initExpressions: function initExpressions() {
	      var expressionsInterfaces = getExpressionInterfaces();

	      if (!expressionsInterfaces) {
	        return;
	      }

	      var LayerExpressionInterface = expressionsInterfaces('layer');
	      var EffectsExpressionInterface = expressionsInterfaces('effects');
	      var ShapeExpressionInterface = expressionsInterfaces('shape');
	      var TextExpressionInterface = expressionsInterfaces('text');
	      var CompExpressionInterface = expressionsInterfaces('comp');
	      this.layerInterface = LayerExpressionInterface(this);

	      if (this.data.hasMask && this.maskManager) {
	        this.layerInterface.registerMaskInterface(this.maskManager);
	      }

	      var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
	      this.layerInterface.registerEffectsInterface(effectsInterface);

	      if (this.data.ty === 0 || this.data.xt) {
	        this.compInterface = CompExpressionInterface(this);
	      } else if (this.data.ty === 4) {
	        this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
	        this.layerInterface.content = this.layerInterface.shapeInterface;
	      } else if (this.data.ty === 5) {
	        this.layerInterface.textInterface = TextExpressionInterface(this);
	        this.layerInterface.text = this.layerInterface.textInterface;
	      }
	    },
	    setBlendMode: function setBlendMode() {
	      var blendModeValue = getBlendMode(this.data.bm);
	      var elem = this.baseElement || this.layerElement;
	      elem.style['mix-blend-mode'] = blendModeValue;
	    },
	    initBaseData: function initBaseData(data, globalData, comp) {
	      this.globalData = globalData;
	      this.comp = comp;
	      this.data = data;
	      this.layerId = createElementID(); // Stretch factor for old animations missing this property.

	      if (!this.data.sr) {
	        this.data.sr = 1;
	      } // effects manager


	      this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
	    },
	    getType: function getType() {
	      return this.type;
	    },
	    sourceRectAtTime: function sourceRectAtTime() {}
	  };

	  /**
	   * @file
	   * Handles element's layer frame update.
	   * Checks layer in point and out point
	   *
	   */
	  function FrameElement() {}

	  FrameElement.prototype = {
	    /**
	       * @function
	       * Initializes frame related properties.
	       *
	       */
	    initFrame: function initFrame() {
	      // set to true when inpoint is rendered
	      this._isFirstFrame = false; // list of animated properties

	      this.dynamicProperties = []; // If layer has been modified in current tick this will be true

	      this._mdf = false;
	    },

	    /**
	       * @function
	       * Calculates all dynamic values
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       * @param {boolean} isVisible
	       * if layers is currently in range
	       *
	       */
	    prepareProperties: function prepareProperties(num, isVisible) {
	      var i;
	      var len = this.dynamicProperties.length;

	      for (i = 0; i < len; i += 1) {
	        if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
	          this.dynamicProperties[i].getValue();

	          if (this.dynamicProperties[i]._mdf) {
	            this.globalData._mdf = true;
	            this._mdf = true;
	          }
	        }
	      }
	    },
	    addDynamicProperty: function addDynamicProperty(prop) {
	      if (this.dynamicProperties.indexOf(prop) === -1) {
	        this.dynamicProperties.push(prop);
	      }
	    }
	  };

	  function FootageElement(data, globalData, comp) {
	    this.initFrame();
	    this.initRenderable();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.footageData = globalData.imageLoader.getAsset(this.assetData);
	    this.initBaseData(data, globalData, comp);
	  }

	  FootageElement.prototype.prepareFrame = function () {};

	  extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);

	  FootageElement.prototype.getBaseElement = function () {
	    return null;
	  };

	  FootageElement.prototype.renderFrame = function () {};

	  FootageElement.prototype.destroy = function () {};

	  FootageElement.prototype.initExpressions = function () {
	    var expressionsInterfaces = getExpressionInterfaces();

	    if (!expressionsInterfaces) {
	      return;
	    }

	    var FootageInterface = expressionsInterfaces('footage');
	    this.layerInterface = FootageInterface(this);
	  };

	  FootageElement.prototype.getFootageData = function () {
	    return this.footageData;
	  };

	  function AudioElement(data, globalData, comp) {
	    this.initFrame();
	    this.initRenderable();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initBaseData(data, globalData, comp);
	    this._isPlaying = false;
	    this._canPlay = false;
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.audio = this.globalData.audioController.createAudio(assetPath);
	    this._currentTime = 0;
	    this.globalData.audioController.addAudio(this);
	    this._volumeMultiplier = 1;
	    this._volume = 1;
	    this._previousVolume = null;
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	    this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
	      k: [100]
	    }, 1, 0.01, this);
	  }

	  AudioElement.prototype.prepareFrame = function (num) {
	    this.prepareRenderableFrame(num, true);
	    this.prepareProperties(num, true);

	    if (!this.tm._placeholder) {
	      var timeRemapped = this.tm.v;
	      this._currentTime = timeRemapped;
	    } else {
	      this._currentTime = num / this.data.sr;
	    }

	    this._volume = this.lv.v[0];
	    var totalVolume = this._volume * this._volumeMultiplier;

	    if (this._previousVolume !== totalVolume) {
	      this._previousVolume = totalVolume;
	      this.audio.volume(totalVolume);
	    }
	  };

	  extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

	  AudioElement.prototype.renderFrame = function () {
	    if (this.isInRange && this._canPlay) {
	      if (!this._isPlaying) {
	        this.audio.play();
	        this.audio.seek(this._currentTime / this.globalData.frameRate);
	        this._isPlaying = true;
	      } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
	        this.audio.seek(this._currentTime / this.globalData.frameRate);
	      }
	    }
	  };

	  AudioElement.prototype.show = function () {// this.audio.play()
	  };

	  AudioElement.prototype.hide = function () {
	    this.audio.pause();
	    this._isPlaying = false;
	  };

	  AudioElement.prototype.pause = function () {
	    this.audio.pause();
	    this._isPlaying = false;
	    this._canPlay = false;
	  };

	  AudioElement.prototype.resume = function () {
	    this._canPlay = true;
	  };

	  AudioElement.prototype.setRate = function (rateValue) {
	    this.audio.rate(rateValue);
	  };

	  AudioElement.prototype.volume = function (volumeValue) {
	    this._volumeMultiplier = volumeValue;
	    this._previousVolume = volumeValue * this._volume;
	    this.audio.volume(this._previousVolume);
	  };

	  AudioElement.prototype.getBaseElement = function () {
	    return null;
	  };

	  AudioElement.prototype.destroy = function () {};

	  AudioElement.prototype.sourceRectAtTime = function () {};

	  AudioElement.prototype.initExpressions = function () {};

	  function BaseRenderer() {}

	  BaseRenderer.prototype.checkLayers = function (num) {
	    var i;
	    var len = this.layers.length;
	    var data;
	    this.completeLayers = true;

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (!this.elements[i]) {
	        data = this.layers[i];

	        if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) {
	          this.buildItem(i);
	        }
	      }

	      this.completeLayers = this.elements[i] ? this.completeLayers : false;
	    }

	    this.checkPendingElements();
	  };

	  BaseRenderer.prototype.createItem = function (layer) {
	    switch (layer.ty) {
	      case 2:
	        return this.createImage(layer);

	      case 0:
	        return this.createComp(layer);

	      case 1:
	        return this.createSolid(layer);

	      case 3:
	        return this.createNull(layer);

	      case 4:
	        return this.createShape(layer);

	      case 5:
	        return this.createText(layer);

	      case 6:
	        return this.createAudio(layer);

	      case 13:
	        return this.createCamera(layer);

	      case 15:
	        return this.createFootage(layer);

	      default:
	        return this.createNull(layer);
	    }
	  };

	  BaseRenderer.prototype.createCamera = function () {
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	  };

	  BaseRenderer.prototype.createAudio = function (data) {
	    return new AudioElement(data, this.globalData, this);
	  };

	  BaseRenderer.prototype.createFootage = function (data) {
	    return new FootageElement(data, this.globalData, this);
	  };

	  BaseRenderer.prototype.buildAllItems = function () {
	    var i;
	    var len = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      this.buildItem(i);
	    }

	    this.checkPendingElements();
	  };

	  BaseRenderer.prototype.includeLayers = function (newLayers) {
	    this.completeLayers = false;
	    var i;
	    var len = newLayers.length;
	    var j;
	    var jLen = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      j = 0;

	      while (j < jLen) {
	        if (this.layers[j].id === newLayers[i].id) {
	          this.layers[j] = newLayers[i];
	          break;
	        }

	        j += 1;
	      }
	    }
	  };

	  BaseRenderer.prototype.setProjectInterface = function (pInterface) {
	    this.globalData.projectInterface = pInterface;
	  };

	  BaseRenderer.prototype.initItems = function () {
	    if (!this.globalData.progressiveLoad) {
	      this.buildAllItems();
	    }
	  };

	  BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
	    var elements = this.elements;
	    var layers = this.layers;
	    var i = 0;
	    var len = layers.length;

	    while (i < len) {
	      if (layers[i].ind == parentName) {
	        // eslint-disable-line eqeqeq
	        if (!elements[i] || elements[i] === true) {
	          this.buildItem(i);
	          this.addPendingElement(element);
	        } else {
	          hierarchy.push(elements[i]);
	          elements[i].setAsParent();

	          if (layers[i].parent !== undefined) {
	            this.buildElementParenting(element, layers[i].parent, hierarchy);
	          } else {
	            element.setHierarchy(hierarchy);
	          }
	        }
	      }

	      i += 1;
	    }
	  };

	  BaseRenderer.prototype.addPendingElement = function (element) {
	    this.pendingElements.push(element);
	  };

	  BaseRenderer.prototype.searchExtraCompositions = function (assets) {
	    var i;
	    var len = assets.length;

	    for (i = 0; i < len; i += 1) {
	      if (assets[i].xt) {
	        var comp = this.createComp(assets[i]);
	        comp.initExpressions();
	        this.globalData.projectInterface.registerComposition(comp);
	      }
	    }
	  };

	  BaseRenderer.prototype.getElementById = function (ind) {
	    var i;
	    var len = this.elements.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i].data.ind === ind) {
	        return this.elements[i];
	      }
	    }

	    return null;
	  };

	  BaseRenderer.prototype.getElementByPath = function (path) {
	    var pathValue = path.shift();
	    var element;

	    if (typeof pathValue === 'number') {
	      element = this.elements[pathValue];
	    } else {
	      var i;
	      var len = this.elements.length;

	      for (i = 0; i < len; i += 1) {
	        if (this.elements[i].data.nm === pathValue) {
	          element = this.elements[i];
	          break;
	        }
	      }
	    }

	    if (path.length === 0) {
	      return element;
	    }

	    return element.getElementByPath(path);
	  };

	  BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
	    this.globalData.fontManager = new FontManager();
	    this.globalData.slotManager = slotFactory(animData);
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.imageLoader = this.animationItem.imagePreloader;
	    this.globalData.audioController = this.animationItem.audioController;
	    this.globalData.frameId = 0;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	      w: animData.w,
	      h: animData.h
	    };
	  };

	  var effectTypes = {
	    TRANSFORM_EFFECT: 'transformEFfect'
	  };

	  function TransformElement() {}

	  TransformElement.prototype = {
	    initTransform: function initTransform() {
	      var mat = new Matrix();
	      this.finalTransform = {
	        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
	          o: 0
	        },
	        _matMdf: false,
	        _localMatMdf: false,
	        _opMdf: false,
	        mat: mat,
	        localMat: mat,
	        localOpacity: 1
	      };

	      if (this.data.ao) {
	        this.finalTransform.mProp.autoOriented = true;
	      } // TODO: check TYPE 11: Guided elements


	      if (this.data.ty !== 11) ;
	    },
	    renderTransform: function renderTransform() {
	      this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
	      this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

	      if (this.hierarchy) {
	        var mat;
	        var finalMat = this.finalTransform.mat;
	        var i = 0;
	        var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.

	        if (!this.finalTransform._matMdf) {
	          while (i < len) {
	            if (this.hierarchy[i].finalTransform.mProp._mdf) {
	              this.finalTransform._matMdf = true;
	              break;
	            }

	            i += 1;
	          }
	        }

	        if (this.finalTransform._matMdf) {
	          mat = this.finalTransform.mProp.v.props;
	          finalMat.cloneFromProps(mat);

	          for (i = 0; i < len; i += 1) {
	            finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
	          }
	        }
	      }

	      if (this.finalTransform._matMdf) {
	        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
	      }

	      if (this.finalTransform._opMdf) {
	        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
	      }
	    },
	    renderLocalTransform: function renderLocalTransform() {
	      if (this.localTransforms) {
	        var i = 0;
	        var len = this.localTransforms.length;
	        this.finalTransform._localMatMdf = this.finalTransform._matMdf;

	        if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) {
	          while (i < len) {
	            if (this.localTransforms[i]._mdf) {
	              this.finalTransform._localMatMdf = true;
	            }

	            if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
	              this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
	              this.finalTransform._opMdf = true;
	            }

	            i += 1;
	          }
	        }

	        if (this.finalTransform._localMatMdf) {
	          var localMat = this.finalTransform.localMat;
	          this.localTransforms[0].matrix.clone(localMat);

	          for (i = 1; i < len; i += 1) {
	            var lmat = this.localTransforms[i].matrix;
	            localMat.multiply(lmat);
	          }

	          localMat.multiply(this.finalTransform.mat);
	        }

	        if (this.finalTransform._opMdf) {
	          var localOp = this.finalTransform.localOpacity;

	          for (i = 0; i < len; i += 1) {
	            localOp *= this.localTransforms[i].opacity * 0.01;
	          }

	          this.finalTransform.localOpacity = localOp;
	        }
	      }
	    },
	    searchEffectTransforms: function searchEffectTransforms() {
	      if (this.renderableEffectsManager) {
	        var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);

	        if (transformEffects.length) {
	          this.localTransforms = [];
	          this.finalTransform.localMat = new Matrix();
	          var i = 0;
	          var len = transformEffects.length;

	          for (i = 0; i < len; i += 1) {
	            this.localTransforms.push(transformEffects[i]);
	          }
	        }
	      }
	    },
	    globalToLocal: function globalToLocal(pt) {
	      var transforms = [];
	      transforms.push(this.finalTransform);
	      var flag = true;
	      var comp = this.comp;

	      while (flag) {
	        if (comp.finalTransform) {
	          if (comp.data.hasMask) {
	            transforms.splice(0, 0, comp.finalTransform);
	          }

	          comp = comp.comp;
	        } else {
	          flag = false;
	        }
	      }

	      var i;
	      var len = transforms.length;
	      var ptNew;

	      for (i = 0; i < len; i += 1) {
	        ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);

	        pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
	      }

	      return pt;
	    },
	    mHelper: new Matrix()
	  };

	  function MaskElement(data, element, globalData) {
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties || [];
	    this.maskElement = null;
	    var defs = this.globalData.defs;
	    var i;
	    var len = this.masksProperties ? this.masksProperties.length : 0;
	    this.viewData = createSizedArray(len);
	    this.solidPath = '';
	    var path;
	    var properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j;
	    var jLen;
	    var layerId = createElementID();
	    var rect;
	    var expansor;
	    var feMorph;
	    var x;
	    var maskType = 'clipPath';
	    var maskRef = 'clip-path';

	    for (i = 0; i < len; i += 1) {
	      if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
	        maskType = 'mask';
	        maskRef = 'mask';
	      }

	      if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
	        rect = createNS('rect');
	        rect.setAttribute('fill', '#ffffff');
	        rect.setAttribute('width', this.element.comp.data.w || 0);
	        rect.setAttribute('height', this.element.comp.data.h || 0);
	        currentMasks.push(rect);
	      } else {
	        rect = null;
	      }

	      path = createNS('path');

	      if (properties[i].mode === 'n') {
	        // TODO move this to a factory or to a constructor
	        this.viewData[i] = {
	          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
	          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
	          elem: path,
	          lastPath: ''
	        };
	        defs.appendChild(path);
	      } else {
	        count += 1;
	        path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
	        path.setAttribute('clip-rule', 'nonzero');
	        var filterID;

	        if (properties[i].x.k !== 0) {
	          maskType = 'mask';
	          maskRef = 'mask';
	          x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
	          filterID = createElementID();
	          expansor = createNS('filter');
	          expansor.setAttribute('id', filterID);
	          feMorph = createNS('feMorphology');
	          feMorph.setAttribute('operator', 'erode');
	          feMorph.setAttribute('in', 'SourceGraphic');
	          feMorph.setAttribute('radius', '0');
	          expansor.appendChild(feMorph);
	          defs.appendChild(expansor);
	          path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
	        } else {
	          feMorph = null;
	          x = null;
	        } // TODO move this to a factory or to a constructor


	        this.storedData[i] = {
	          elem: path,
	          x: x,
	          expan: feMorph,
	          lastPath: '',
	          lastOperator: '',
	          filterId: filterID,
	          lastRadius: 0
	        };

	        if (properties[i].mode === 'i') {
	          jLen = currentMasks.length;
	          var g = createNS('g');

	          for (j = 0; j < jLen; j += 1) {
	            g.appendChild(currentMasks[j]);
	          }

	          var mask = createNS('mask');
	          mask.setAttribute('mask-type', 'alpha');
	          mask.setAttribute('id', layerId + '_' + count);
	          mask.appendChild(path);
	          defs.appendChild(mask);
	          g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
	          currentMasks.length = 0;
	          currentMasks.push(g);
	        } else {
	          currentMasks.push(path);
	        }

	        if (properties[i].inv && !this.solidPath) {
	          this.solidPath = this.createLayerSolidPath();
	        } // TODO move this to a factory or to a constructor


	        this.viewData[i] = {
	          elem: path,
	          lastPath: '',
	          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
	          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
	          invRect: rect
	        };

	        if (!this.viewData[i].prop.k) {
	          this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
	        }
	      }
	    }

	    this.maskElement = createNS(maskType);
	    len = currentMasks.length;

	    for (i = 0; i < len; i += 1) {
	      this.maskElement.appendChild(currentMasks[i]);
	    }

	    if (count > 0) {
	      this.maskElement.setAttribute('id', layerId);
	      this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
	      defs.appendChild(this.maskElement);
	    }

	    if (this.viewData.length) {
	      this.element.addRenderableComponent(this);
	    }
	  }

	  MaskElement.prototype.getMaskProperty = function (pos) {
	    return this.viewData[pos].prop;
	  };

	  MaskElement.prototype.renderFrame = function (isFirstFrame) {
	    var finalMat = this.element.finalTransform.mat;
	    var i;
	    var len = this.masksProperties.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.viewData[i].prop._mdf || isFirstFrame) {
	        this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
	      }

	      if (this.viewData[i].op._mdf || isFirstFrame) {
	        this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
	      }

	      if (this.masksProperties[i].mode !== 'n') {
	        if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
	          this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
	        }

	        if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
	          var feMorph = this.storedData[i].expan;

	          if (this.storedData[i].x.v < 0) {
	            if (this.storedData[i].lastOperator !== 'erode') {
	              this.storedData[i].lastOperator = 'erode';
	              this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
	            }

	            feMorph.setAttribute('radius', -this.storedData[i].x.v);
	          } else {
	            if (this.storedData[i].lastOperator !== 'dilate') {
	              this.storedData[i].lastOperator = 'dilate';
	              this.storedData[i].elem.setAttribute('filter', null);
	            }

	            this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
	          }
	        }
	      }
	    }
	  };

	  MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	  };

	  MaskElement.prototype.createLayerSolidPath = function () {
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w;
	    path += ' v' + this.globalData.compSize.h;
	    path += ' h-' + this.globalData.compSize.w;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	  };

	  MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
	    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
	    var i;
	    var len;
	    len = pathNodes._length;

	    for (i = 1; i < len; i += 1) {
	      // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
	    } // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];


	    if (pathNodes.c && len > 1) {
	      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
	    } // pathNodes.__renderedString = pathString;


	    if (viewData.lastPath !== pathString) {
	      var pathShapeValue = '';

	      if (viewData.elem) {
	        if (pathNodes.c) {
	          pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
	        }

	        viewData.elem.setAttribute('d', pathShapeValue);
	      }

	      viewData.lastPath = pathString;
	    }
	  };

	  MaskElement.prototype.destroy = function () {
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	  };

	  var filtersFactory = function () {
	    var ob = {};
	    ob.createFilter = createFilter;
	    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

	    function createFilter(filId, skipCoordinates) {
	      var fil = createNS('filter');
	      fil.setAttribute('id', filId);

	      if (skipCoordinates !== true) {
	        fil.setAttribute('filterUnits', 'objectBoundingBox');
	        fil.setAttribute('x', '0%');
	        fil.setAttribute('y', '0%');
	        fil.setAttribute('width', '100%');
	        fil.setAttribute('height', '100%');
	      }

	      return fil;
	    }

	    function createAlphaToLuminanceFilter() {
	      var feColorMatrix = createNS('feColorMatrix');
	      feColorMatrix.setAttribute('type', 'matrix');
	      feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	      feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	      return feColorMatrix;
	    }

	    return ob;
	  }();

	  var featureSupport = function () {
	    var ob = {
	      maskType: true,
	      svgLumaHidden: true,
	      offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
	    };

	    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
	      ob.maskType = false;
	    }

	    if (/firefox/i.test(navigator.userAgent)) {
	      ob.svgLumaHidden = false;
	    }

	    return ob;
	  }();

	  var registeredEffects$1 = {};
	  var idPrefix = 'filter_result_';

	  function SVGEffects(elem) {
	    var i;
	    var source = 'SourceGraphic';
	    var len = elem.data.ef ? elem.data.ef.length : 0;
	    var filId = createElementID();
	    var fil = filtersFactory.createFilter(filId, true);
	    var count = 0;
	    this.filters = [];
	    var filterManager;

	    for (i = 0; i < len; i += 1) {
	      filterManager = null;
	      var type = elem.data.ef[i].ty;

	      if (registeredEffects$1[type]) {
	        var Effect = registeredEffects$1[type].effect;
	        filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
	        source = idPrefix + count;

	        if (registeredEffects$1[type].countsAsEffect) {
	          count += 1;
	        }
	      }

	      if (filterManager) {
	        this.filters.push(filterManager);
	      }
	    }

	    if (count) {
	      elem.globalData.defs.appendChild(fil);
	      elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	    }

	    if (this.filters.length) {
	      elem.addRenderableComponent(this);
	    }
	  }

	  SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
	    var i;
	    var len = this.filters.length;

	    for (i = 0; i < len; i += 1) {
	      this.filters[i].renderFrame(_isFirstFrame);
	    }
	  };

	  SVGEffects.prototype.getEffects = function (type) {
	    var i;
	    var len = this.filters.length;
	    var effects = [];

	    for (i = 0; i < len; i += 1) {
	      if (this.filters[i].type === type) {
	        effects.push(this.filters[i]);
	      }
	    }

	    return effects;
	  };

	  function registerEffect$1(id, effect, countsAsEffect) {
	    registeredEffects$1[id] = {
	      effect: effect,
	      countsAsEffect: countsAsEffect
	    };
	  }

	  function SVGBaseElement() {}

	  SVGBaseElement.prototype = {
	    initRendererElement: function initRendererElement() {
	      this.layerElement = createNS('g');
	    },
	    createContainerElements: function createContainerElements() {
	      this.matteElement = createNS('g');
	      this.transformedElement = this.layerElement;
	      this.maskedElement = this.layerElement;
	      this._sizeChanged = false;
	      var layerElementParent = null; // If this layer acts as a mask for the following layer

	      if (this.data.td) {
	        this.matteMasks = {};
	        var gg = createNS('g');
	        gg.setAttribute('id', this.layerId);
	        gg.appendChild(this.layerElement);
	        layerElementParent = gg;
	        this.globalData.defs.appendChild(gg);
	      } else if (this.data.tt) {
	        this.matteElement.appendChild(this.layerElement);
	        layerElementParent = this.matteElement;
	        this.baseElement = this.matteElement;
	      } else {
	        this.baseElement = this.layerElement;
	      }

	      if (this.data.ln) {
	        this.layerElement.setAttribute('id', this.data.ln);
	      }

	      if (this.data.cl) {
	        this.layerElement.setAttribute('class', this.data.cl);
	      } // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped


	      if (this.data.ty === 0 && !this.data.hd) {
	        var cp = createNS('clipPath');
	        var pt = createNS('path');
	        pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
	        var clipId = createElementID();
	        cp.setAttribute('id', clipId);
	        cp.appendChild(pt);
	        this.globalData.defs.appendChild(cp);

	        if (this.checkMasks()) {
	          var cpGroup = createNS('g');
	          cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
	          cpGroup.appendChild(this.layerElement);
	          this.transformedElement = cpGroup;

	          if (layerElementParent) {
	            layerElementParent.appendChild(this.transformedElement);
	          } else {
	            this.baseElement = this.transformedElement;
	          }
	        } else {
	          this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
	        }
	      }

	      if (this.data.bm !== 0) {
	        this.setBlendMode();
	      }
	    },
	    renderElement: function renderElement() {
	      if (this.finalTransform._localMatMdf) {
	        this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
	      }

	      if (this.finalTransform._opMdf) {
	        this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
	      }
	    },
	    destroyBaseElement: function destroyBaseElement() {
	      this.layerElement = null;
	      this.matteElement = null;
	      this.maskManager.destroy();
	    },
	    getBaseElement: function getBaseElement() {
	      if (this.data.hd) {
	        return null;
	      }

	      return this.baseElement;
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new MaskElement(this.data, this, this.globalData);
	      this.renderableEffectsManager = new SVGEffects(this);
	      this.searchEffectTransforms();
	    },
	    getMatte: function getMatte(matteType) {
	      // This should not be a common case. But for backward compatibility, we'll create the matte object.
	      // It solves animations that have two consecutive layers marked as matte masks.
	      // Which is an undefined behavior in AE.
	      if (!this.matteMasks) {
	        this.matteMasks = {};
	      }

	      if (!this.matteMasks[matteType]) {
	        var id = this.layerId + '_' + matteType;
	        var filId;
	        var fil;
	        var useElement;
	        var gg;

	        if (matteType === 1 || matteType === 3) {
	          var masker = createNS('mask');
	          masker.setAttribute('id', id);
	          masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
	          useElement = createNS('use');
	          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
	          masker.appendChild(useElement);
	          this.globalData.defs.appendChild(masker);

	          if (!featureSupport.maskType && matteType === 1) {
	            masker.setAttribute('mask-type', 'luminance');
	            filId = createElementID();
	            fil = filtersFactory.createFilter(filId);
	            this.globalData.defs.appendChild(fil);
	            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	            gg = createNS('g');
	            gg.appendChild(useElement);
	            masker.appendChild(gg);
	            gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	          }
	        } else if (matteType === 2) {
	          var maskGroup = createNS('mask');
	          maskGroup.setAttribute('id', id);
	          maskGroup.setAttribute('mask-type', 'alpha');
	          var maskGrouper = createNS('g');
	          maskGroup.appendChild(maskGrouper);
	          filId = createElementID();
	          fil = filtersFactory.createFilter(filId); /// /

	          var feCTr = createNS('feComponentTransfer');
	          feCTr.setAttribute('in', 'SourceGraphic');
	          fil.appendChild(feCTr);
	          var feFunc = createNS('feFuncA');
	          feFunc.setAttribute('type', 'table');
	          feFunc.setAttribute('tableValues', '1.0 0.0');
	          feCTr.appendChild(feFunc); /// /

	          this.globalData.defs.appendChild(fil);
	          var alphaRect = createNS('rect');
	          alphaRect.setAttribute('width', this.comp.data.w);
	          alphaRect.setAttribute('height', this.comp.data.h);
	          alphaRect.setAttribute('x', '0');
	          alphaRect.setAttribute('y', '0');
	          alphaRect.setAttribute('fill', '#ffffff');
	          alphaRect.setAttribute('opacity', '0');
	          maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	          maskGrouper.appendChild(alphaRect);
	          useElement = createNS('use');
	          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
	          maskGrouper.appendChild(useElement);

	          if (!featureSupport.maskType) {
	            maskGroup.setAttribute('mask-type', 'luminance');
	            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	            gg = createNS('g');
	            maskGrouper.appendChild(alphaRect);
	            gg.appendChild(this.layerElement);
	            maskGrouper.appendChild(gg);
	          }

	          this.globalData.defs.appendChild(maskGroup);
	        }

	        this.matteMasks[matteType] = id;
	      }

	      return this.matteMasks[matteType];
	    },
	    setMatte: function setMatte(id) {
	      if (!this.matteElement) {
	        return;
	      }

	      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
	    }
	  };

	  /**
	   * @file
	   * Handles AE's layer parenting property.
	   *
	   */
	  function HierarchyElement() {}

	  HierarchyElement.prototype = {
	    /**
	       * @function
	       * Initializes hierarchy properties
	       *
	       */
	    initHierarchy: function initHierarchy() {
	      // element's parent list
	      this.hierarchy = []; // if element is parent of another layer _isParent will be true

	      this._isParent = false;
	      this.checkParenting();
	    },

	    /**
	       * @function
	       * Sets layer's hierarchy.
	       * @param {array} hierarch
	       * layer's parent list
	       *
	       */
	    setHierarchy: function setHierarchy(hierarchy) {
	      this.hierarchy = hierarchy;
	    },

	    /**
	       * @function
	       * Sets layer as parent.
	       *
	       */
	    setAsParent: function setAsParent() {
	      this._isParent = true;
	    },

	    /**
	       * @function
	       * Searches layer's parenting chain
	       *
	       */
	    checkParenting: function checkParenting() {
	      if (this.data.parent !== undefined) {
	        this.comp.buildElementParenting(this, this.data.parent, []);
	      }
	    }
	  };

	  function RenderableDOMElement() {}

	  (function () {
	    var _prototype = {
	      initElement: function initElement(data, globalData, comp) {
	        this.initFrame();
	        this.initBaseData(data, globalData, comp);
	        this.initTransform(data, globalData, comp);
	        this.initHierarchy();
	        this.initRenderable();
	        this.initRendererElement();
	        this.createContainerElements();
	        this.createRenderableComponents();
	        this.createContent();
	        this.hide();
	      },
	      hide: function hide() {
	        // console.log('HIDE', this);
	        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	          var elem = this.baseElement || this.layerElement;
	          elem.style.display = 'none';
	          this.hidden = true;
	        }
	      },
	      show: function show() {
	        // console.log('SHOW', this);
	        if (this.isInRange && !this.isTransparent) {
	          if (!this.data.hd) {
	            var elem = this.baseElement || this.layerElement;
	            elem.style.display = 'block';
	          }

	          this.hidden = false;
	          this._isFirstFrame = true;
	        }
	      },
	      renderFrame: function renderFrame() {
	        // If it is exported as hidden (data.hd === true) no need to render
	        // If it is not visible no need to render
	        if (this.data.hd || this.hidden) {
	          return;
	        }

	        this.renderTransform();
	        this.renderRenderable();
	        this.renderLocalTransform();
	        this.renderElement();
	        this.renderInnerContent();

	        if (this._isFirstFrame) {
	          this._isFirstFrame = false;
	        }
	      },
	      renderInnerContent: function renderInnerContent() {},
	      prepareFrame: function prepareFrame(num) {
	        this._mdf = false;
	        this.prepareRenderableFrame(num);
	        this.prepareProperties(num, this.isInRange);
	        this.checkTransparency();
	      },
	      destroy: function destroy() {
	        this.innerElem = null;
	        this.destroyBaseElement();
	      }
	    };
	    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
	  })();

	  function IImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);

	    if (this.assetData && this.assetData.sid) {
	      this.assetData = globalData.slotManager.getProp(this.assetData);
	    }

	    this.initElement(data, globalData, comp);
	    this.sourceRect = {
	      top: 0,
	      left: 0,
	      width: this.assetData.w,
	      height: this.assetData.h
	    };
	  }

	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

	  IImageElement.prototype.createContent = function () {
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width', this.assetData.w + 'px');
	    this.innerElem.setAttribute('height', this.assetData.h + 'px');
	    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
	    this.layerElement.appendChild(this.innerElem);
	  };

	  IImageElement.prototype.sourceRectAtTime = function () {
	    return this.sourceRect;
	  };

	  function ProcessedElement(element, position) {
	    this.elem = element;
	    this.pos = position;
	  }

	  function IShapeElement() {}

	  IShapeElement.prototype = {
	    addShapeToModifiers: function addShapeToModifiers(data) {
	      var i;
	      var len = this.shapeModifiers.length;

	      for (i = 0; i < len; i += 1) {
	        this.shapeModifiers[i].addShape(data);
	      }
	    },
	    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
	      var i = 0;
	      var len = this.shapeModifiers.length;

	      while (i < len) {
	        if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
	          return true;
	        }
	      }

	      return false;
	    },
	    renderModifiers: function renderModifiers() {
	      if (!this.shapeModifiers.length) {
	        return;
	      }

	      var i;
	      var len = this.shapes.length;

	      for (i = 0; i < len; i += 1) {
	        this.shapes[i].sh.reset();
	      }

	      len = this.shapeModifiers.length;
	      var shouldBreakProcess;

	      for (i = len - 1; i >= 0; i -= 1) {
	        shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
	        // TODO: find a better solution for this

	        if (shouldBreakProcess) {
	          break;
	        }
	      }
	    },
	    searchProcessedElement: function searchProcessedElement(elem) {
	      var elements = this.processedElements;
	      var i = 0;
	      var len = elements.length;

	      while (i < len) {
	        if (elements[i].elem === elem) {
	          return elements[i].pos;
	        }

	        i += 1;
	      }

	      return 0;
	    },
	    addProcessedElement: function addProcessedElement(elem, pos) {
	      var elements = this.processedElements;
	      var i = elements.length;

	      while (i) {
	        i -= 1;

	        if (elements[i].elem === elem) {
	          elements[i].pos = pos;
	          return;
	        }
	      }

	      elements.push(new ProcessedElement(elem, pos));
	    },
	    prepareFrame: function prepareFrame(num) {
	      this.prepareRenderableFrame(num);
	      this.prepareProperties(num, this.isInRange);
	    }
	  };

	  var lineCapEnum = {
	    1: 'butt',
	    2: 'round',
	    3: 'square'
	  };
	  var lineJoinEnum = {
	    1: 'miter',
	    2: 'round',
	    3: 'bevel'
	  };

	  function SVGShapeData(transformers, level, shape) {
	    this.caches = [];
	    this.styles = [];
	    this.transformers = transformers;
	    this.lStr = '';
	    this.sh = shape;
	    this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
	    // For now, since shapes add up with other shapes. They have to be calculated every time.
	    // One way of finding out is checking if all styles associated to this shape depend only of this shape

	    this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated

	    var i = 0;
	    var len = transformers.length;

	    while (i < len) {
	      if (transformers[i].mProps.dynamicProperties.length) {
	        this._isAnimated = true;
	        break;
	      }

	      i += 1;
	    }
	  }

	  SVGShapeData.prototype.setAsAnimated = function () {
	    this._isAnimated = true;
	  };

	  function SVGStyleData(data, level) {
	    this.data = data;
	    this.type = data.ty;
	    this.d = '';
	    this.lvl = level;
	    this._mdf = false;
	    this.closed = data.hd === true;
	    this.pElem = createNS('path');
	    this.msElem = null;
	  }

	  SVGStyleData.prototype.reset = function () {
	    this.d = '';
	    this._mdf = false;
	  };

	  function DashProperty(elem, data, renderer, container) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = createSizedArray(data.length);
	    this.renderer = renderer;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
	    this.dashoffset = createTypedArray('float32', 1);
	    this.initDynamicPropertyContainer(container);
	    var i;
	    var len = data.length || 0;
	    var prop;

	    for (i = 0; i < len; i += 1) {
	      prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
	      this.k = prop.k || this.k;
	      this.dataProps[i] = {
	        n: data[i].n,
	        p: prop
	      };
	    }

	    if (!this.k) {
	      this.getValue(true);
	    }

	    this._isAnimated = this.k;
	  }

	  DashProperty.prototype.getValue = function (forceRender) {
	    if (this.elem.globalData.frameId === this.frameId && !forceRender) {
	      return;
	    }

	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	    this._mdf = this._mdf || forceRender;

	    if (this._mdf) {
	      var i = 0;
	      var len = this.dataProps.length;

	      if (this.renderer === 'svg') {
	        this.dashStr = '';
	      }

	      for (i = 0; i < len; i += 1) {
	        if (this.dataProps[i].n !== 'o') {
	          if (this.renderer === 'svg') {
	            this.dashStr += ' ' + this.dataProps[i].p.v;
	          } else {
	            this.dashArray[i] = this.dataProps[i].p.v;
	          }
	        } else {
	          this.dashoffset[0] = this.dataProps[i].p.v;
	        }
	      }
	    }
	  };

	  extendPrototype([DynamicPropertyContainer], DashProperty);

	  function SVGStrokeStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
	    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
	    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
	    this.style = styleOb;
	    this._isAnimated = !!this._isAnimated;
	  }

	  extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

	  function SVGFillStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
	    this.style = styleOb;
	  }

	  extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

	  function SVGNoStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.style = styleOb;
	  }

	  extendPrototype([DynamicPropertyContainer], SVGNoStyleData);

	  function GradientProperty(elem, data, container) {
	    this.data = data;
	    this.c = createTypedArray('uint8c', data.p * 4);
	    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
	    this.o = createTypedArray('float32', cLength);
	    this._cmdf = false;
	    this._omdf = false;
	    this._collapsable = this.checkCollapsable();
	    this._hasOpacity = cLength;
	    this.initDynamicPropertyContainer(container);
	    this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
	    this.k = this.prop.k;
	    this.getValue(true);
	  }

	  GradientProperty.prototype.comparePoints = function (values, points) {
	    var i = 0;
	    var len = this.o.length / 2;
	    var diff;

	    while (i < len) {
	      diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);

	      if (diff > 0.01) {
	        return false;
	      }

	      i += 1;
	    }

	    return true;
	  };

	  GradientProperty.prototype.checkCollapsable = function () {
	    if (this.o.length / 2 !== this.c.length / 4) {
	      return false;
	    }

	    if (this.data.k.k[0].s) {
	      var i = 0;
	      var len = this.data.k.k.length;

	      while (i < len) {
	        if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
	          return false;
	        }

	        i += 1;
	      }
	    } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
	      return false;
	    }

	    return true;
	  };

	  GradientProperty.prototype.getValue = function (forceRender) {
	    this.prop.getValue();
	    this._mdf = false;
	    this._cmdf = false;
	    this._omdf = false;

	    if (this.prop._mdf || forceRender) {
	      var i;
	      var len = this.data.p * 4;
	      var mult;
	      var val;

	      for (i = 0; i < len; i += 1) {
	        mult = i % 4 === 0 ? 100 : 255;
	        val = Math.round(this.prop.v[i] * mult);

	        if (this.c[i] !== val) {
	          this.c[i] = val;
	          this._cmdf = !forceRender;
	        }
	      }

	      if (this.o.length) {
	        len = this.prop.v.length;

	        for (i = this.data.p * 4; i < len; i += 1) {
	          mult = i % 2 === 0 ? 100 : 1;
	          val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];

	          if (this.o[i - this.data.p * 4] !== val) {
	            this.o[i - this.data.p * 4] = val;
	            this._omdf = !forceRender;
	          }
	        }
	      }

	      this._mdf = !forceRender;
	    }
	  };

	  extendPrototype([DynamicPropertyContainer], GradientProperty);

	  function SVGGradientFillStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.initGradientData(elem, data, styleOb);
	  }

	  SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
	    this.h = PropertyFactory.getProp(elem, data.h || {
	      k: 0
	    }, 0, 0.01, this);
	    this.a = PropertyFactory.getProp(elem, data.a || {
	      k: 0
	    }, 0, degToRads, this);
	    this.g = new GradientProperty(elem, data.g, this);
	    this.style = styleOb;
	    this.stops = [];
	    this.setGradientData(styleOb.pElem, data);
	    this.setGradientOpacity(data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	  };

	  SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
	    var gradientId = createElementID();
	    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	    gfill.setAttribute('id', gradientId);
	    gfill.setAttribute('spreadMethod', 'pad');
	    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
	    var stops = [];
	    var stop;
	    var j;
	    var jLen;
	    jLen = data.g.p * 4;

	    for (j = 0; j < jLen; j += 4) {
	      stop = createNS('stop');
	      gfill.appendChild(stop);
	      stops.push(stop);
	    }

	    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
	    this.gf = gfill;
	    this.cst = stops;
	  };

	  SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
	    if (this.g._hasOpacity && !this.g._collapsable) {
	      var stop;
	      var j;
	      var jLen;
	      var mask = createNS('mask');
	      var maskElement = createNS('path');
	      mask.appendChild(maskElement);
	      var opacityId = createElementID();
	      var maskId = createElementID();
	      mask.setAttribute('id', maskId);
	      var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	      opFill.setAttribute('id', opacityId);
	      opFill.setAttribute('spreadMethod', 'pad');
	      opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
	      jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
	      var stops = this.stops;

	      for (j = data.g.p * 4; j < jLen; j += 2) {
	        stop = createNS('stop');
	        stop.setAttribute('stop-color', 'rgb(255,255,255)');
	        opFill.appendChild(stop);
	        stops.push(stop);
	      }

	      maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');

	      if (data.ty === 'gs') {
	        maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
	        maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);

	        if (data.lj === 1) {
	          maskElement.setAttribute('stroke-miterlimit', data.ml);
	        }
	      }

	      this.of = opFill;
	      this.ms = mask;
	      this.ost = stops;
	      this.maskId = maskId;
	      styleOb.msElem = maskElement;
	    }
	  };

	  extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

	  function SVGGradientStrokeStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
	    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
	    this.initGradientData(elem, data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	  }

	  extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

	  function ShapeGroupData() {
	    this.it = [];
	    this.prevViewData = [];
	    this.gr = createNS('g');
	  }

	  function SVGTransformData(mProps, op, container) {
	    this.transform = {
	      mProps: mProps,
	      op: op,
	      container: container
	    };
	    this.elements = [];
	    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
	  }

	  var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
	    if (length === 0) {
	      return '';
	    }

	    var _o = pathNodes.o;
	    var _i = pathNodes.i;
	    var _v = pathNodes.v;
	    var i;
	    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);

	    for (i = 1; i < length; i += 1) {
	      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
	    }

	    if (closed && length) {
	      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	      shapeString += 'z';
	    }

	    return shapeString;
	  };

	  var SVGElementsRenderer = function () {
	    var _identityMatrix = new Matrix();

	    var _matrixHelper = new Matrix();

	    var ob = {
	      createRenderFunction: createRenderFunction
	    };

	    function createRenderFunction(data) {
	      switch (data.ty) {
	        case 'fl':
	          return renderFill;

	        case 'gf':
	          return renderGradient;

	        case 'gs':
	          return renderGradientStroke;

	        case 'st':
	          return renderStroke;

	        case 'sh':
	        case 'el':
	        case 'rc':
	        case 'sr':
	          return renderPath;

	        case 'tr':
	          return renderContentTransform;

	        case 'no':
	          return renderNoop;

	        default:
	          return null;
	      }
	    }

	    function renderContentTransform(styleData, itemData, isFirstFrame) {
	      if (isFirstFrame || itemData.transform.op._mdf) {
	        itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
	      }

	      if (isFirstFrame || itemData.transform.mProps._mdf) {
	        itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
	      }
	    }

	    function renderNoop() {}

	    function renderPath(styleData, itemData, isFirstFrame) {
	      var j;
	      var jLen;
	      var pathStringTransformed;
	      var redraw;
	      var pathNodes;
	      var l;
	      var lLen = itemData.styles.length;
	      var lvl = itemData.lvl;
	      var paths;
	      var mat;
	      var iterations;
	      var k;

	      for (l = 0; l < lLen; l += 1) {
	        redraw = itemData.sh._mdf || isFirstFrame;

	        if (itemData.styles[l].lvl < lvl) {
	          mat = _matrixHelper.reset();
	          iterations = lvl - itemData.styles[l].lvl;
	          k = itemData.transformers.length - 1;

	          while (!redraw && iterations > 0) {
	            redraw = itemData.transformers[k].mProps._mdf || redraw;
	            iterations -= 1;
	            k -= 1;
	          }

	          if (redraw) {
	            iterations = lvl - itemData.styles[l].lvl;
	            k = itemData.transformers.length - 1;

	            while (iterations > 0) {
	              mat.multiply(itemData.transformers[k].mProps.v);
	              iterations -= 1;
	              k -= 1;
	            }
	          }
	        } else {
	          mat = _identityMatrix;
	        }

	        paths = itemData.sh.paths;
	        jLen = paths._length;

	        if (redraw) {
	          pathStringTransformed = '';

	          for (j = 0; j < jLen; j += 1) {
	            pathNodes = paths.shapes[j];

	            if (pathNodes && pathNodes._length) {
	              pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
	            }
	          }

	          itemData.caches[l] = pathStringTransformed;
	        } else {
	          pathStringTransformed = itemData.caches[l];
	        }

	        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
	        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
	      }
	    }

	    function renderFill(styleData, itemData, isFirstFrame) {
	      var styleElem = itemData.style;

	      if (itemData.c._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
	      }

	      if (itemData.o._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
	      }
	    }

	    function renderGradientStroke(styleData, itemData, isFirstFrame) {
	      renderGradient(styleData, itemData, isFirstFrame);
	      renderStroke(styleData, itemData, isFirstFrame);
	    }

	    function renderGradient(styleData, itemData, isFirstFrame) {
	      var gfill = itemData.gf;
	      var hasOpacity = itemData.g._hasOpacity;
	      var pt1 = itemData.s.v;
	      var pt2 = itemData.e.v;

	      if (itemData.o._mdf || isFirstFrame) {
	        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
	        itemData.style.pElem.setAttribute(attr, itemData.o.v);
	      }

	      if (itemData.s._mdf || isFirstFrame) {
	        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
	        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
	        gfill.setAttribute(attr1, pt1[0]);
	        gfill.setAttribute(attr2, pt1[1]);

	        if (hasOpacity && !itemData.g._collapsable) {
	          itemData.of.setAttribute(attr1, pt1[0]);
	          itemData.of.setAttribute(attr2, pt1[1]);
	        }
	      }

	      var stops;
	      var i;
	      var len;
	      var stop;

	      if (itemData.g._cmdf || isFirstFrame) {
	        stops = itemData.cst;
	        var cValues = itemData.g.c;
	        len = stops.length;

	        for (i = 0; i < len; i += 1) {
	          stop = stops[i];
	          stop.setAttribute('offset', cValues[i * 4] + '%');
	          stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
	        }
	      }

	      if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
	        var oValues = itemData.g.o;

	        if (itemData.g._collapsable) {
	          stops = itemData.cst;
	        } else {
	          stops = itemData.ost;
	        }

	        len = stops.length;

	        for (i = 0; i < len; i += 1) {
	          stop = stops[i];

	          if (!itemData.g._collapsable) {
	            stop.setAttribute('offset', oValues[i * 2] + '%');
	          }

	          stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
	        }
	      }

	      if (styleData.t === 1) {
	        if (itemData.e._mdf || isFirstFrame) {
	          gfill.setAttribute('x2', pt2[0]);
	          gfill.setAttribute('y2', pt2[1]);

	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('x2', pt2[0]);
	            itemData.of.setAttribute('y2', pt2[1]);
	          }
	        }
	      } else {
	        var rad;

	        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
	          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	          gfill.setAttribute('r', rad);

	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('r', rad);
	          }
	        }

	        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
	          if (!rad) {
	            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	          }

	          var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	          var percent = itemData.h.v;

	          if (percent >= 1) {
	            percent = 0.99;
	          } else if (percent <= -1) {
	            percent = -0.99;
	          }

	          var dist = rad * percent;
	          var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	          var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	          gfill.setAttribute('fx', x);
	          gfill.setAttribute('fy', y);

	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('fx', x);
	            itemData.of.setAttribute('fy', y);
	          }
	        } // gfill.setAttribute('fy','200');

	      }
	    }

	    function renderStroke(styleData, itemData, isFirstFrame) {
	      var styleElem = itemData.style;
	      var d = itemData.d;

	      if (d && (d._mdf || isFirstFrame) && d.dashStr) {
	        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
	        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
	      }

	      if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
	        styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
	      }

	      if (itemData.o._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
	      }

	      if (itemData.w._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);

	        if (styleElem.msElem) {
	          styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
	        }
	      }
	    }

	    return ob;
	  }();

	  function SVGShapeElement(data, globalData, comp) {
	    // List of drawable elements
	    this.shapes = []; // Full shape data

	    this.shapesData = data.shapes; // List of styles that will be applied to shapes

	    this.stylesList = []; // List of modifiers that will be applied to shapes

	    this.shapeModifiers = []; // List of items in shape tree

	    this.itemsData = []; // List of items in previous shape tree

	    this.processedElements = []; // List of animated components

	    this.animatedContents = [];
	    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created

	    this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	  }

	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

	  SVGShapeElement.prototype.initSecondaryElement = function () {};

	  SVGShapeElement.prototype.identityMatrix = new Matrix();

	  SVGShapeElement.prototype.buildExpressionInterface = function () {};

	  SVGShapeElement.prototype.createContent = function () {
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	  };
	  /*
	  This method searches for multiple shapes that affect a single element and one of them is animated
	  */


	  SVGShapeElement.prototype.filterUniqueShapes = function () {
	    var i;
	    var len = this.shapes.length;
	    var shape;
	    var j;
	    var jLen = this.stylesList.length;
	    var style;
	    var tempShapes = [];
	    var areAnimated = false;

	    for (j = 0; j < jLen; j += 1) {
	      style = this.stylesList[j];
	      areAnimated = false;
	      tempShapes.length = 0;

	      for (i = 0; i < len; i += 1) {
	        shape = this.shapes[i];

	        if (shape.styles.indexOf(style) !== -1) {
	          tempShapes.push(shape);
	          areAnimated = shape._isAnimated || areAnimated;
	        }
	      }

	      if (tempShapes.length > 1 && areAnimated) {
	        this.setShapesAsAnimated(tempShapes);
	      }
	    }
	  };

	  SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
	    var i;
	    var len = shapes.length;

	    for (i = 0; i < len; i += 1) {
	      shapes[i].setAsAnimated();
	    }
	  };

	  SVGShapeElement.prototype.createStyleElement = function (data, level) {
	    // TODO: prevent drawing of hidden styles
	    var elementData;
	    var styleOb = new SVGStyleData(data, level);
	    var pathElement = styleOb.pElem;

	    if (data.ty === 'st') {
	      elementData = new SVGStrokeStyleData(this, data, styleOb);
	    } else if (data.ty === 'fl') {
	      elementData = new SVGFillStyleData(this, data, styleOb);
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	      var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
	      elementData = new GradientConstructor(this, data, styleOb);
	      this.globalData.defs.appendChild(elementData.gf);

	      if (elementData.maskId) {
	        this.globalData.defs.appendChild(elementData.ms);
	        this.globalData.defs.appendChild(elementData.of);
	        pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
	      }
	    } else if (data.ty === 'no') {
	      elementData = new SVGNoStyleData(this, data, styleOb);
	    }

	    if (data.ty === 'st' || data.ty === 'gs') {
	      pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
	      pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
	      pathElement.setAttribute('fill-opacity', '0');

	      if (data.lj === 1) {
	        pathElement.setAttribute('stroke-miterlimit', data.ml);
	      }
	    }

	    if (data.r === 2) {
	      pathElement.setAttribute('fill-rule', 'evenodd');
	    }

	    if (data.ln) {
	      pathElement.setAttribute('id', data.ln);
	    }

	    if (data.cl) {
	      pathElement.setAttribute('class', data.cl);
	    }

	    if (data.bm) {
	      pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }

	    this.stylesList.push(styleOb);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };

	  SVGShapeElement.prototype.createGroupElement = function (data) {
	    var elementData = new ShapeGroupData();

	    if (data.ln) {
	      elementData.gr.setAttribute('id', data.ln);
	    }

	    if (data.cl) {
	      elementData.gr.setAttribute('class', data.cl);
	    }

	    if (data.bm) {
	      elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }

	    return elementData;
	  };

	  SVGShapeElement.prototype.createTransformElement = function (data, container) {
	    var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
	    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };

	  SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
	    var ty = 4;

	    if (data.ty === 'rc') {
	      ty = 5;
	    } else if (data.ty === 'el') {
	      ty = 6;
	    } else if (data.ty === 'sr') {
	      ty = 7;
	    }

	    var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
	    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };

	  SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
	    var i = 0;
	    var len = this.animatedContents.length;

	    while (i < len) {
	      if (this.animatedContents[i].element === element) {
	        return;
	      }

	      i += 1;
	    }

	    this.animatedContents.push({
	      fn: SVGElementsRenderer.createRenderFunction(data),
	      element: element,
	      data: data
	    });
	  };

	  SVGShapeElement.prototype.setElementStyles = function (elementData) {
	    var arr = elementData.styles;
	    var j;
	    var jLen = this.stylesList.length;

	    for (j = 0; j < jLen; j += 1) {
	      if (!this.stylesList[j].closed) {
	        arr.push(this.stylesList[j]);
	      }
	    }
	  };

	  SVGShapeElement.prototype.reloadShapes = function () {
	    this._isFirstFrame = true;
	    var i;
	    var len = this.itemsData.length;

	    for (i = 0; i < len; i += 1) {
	      this.prevViewData[i] = this.itemsData[i];
	    }

	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	    len = this.dynamicProperties.length;

	    for (i = 0; i < len; i += 1) {
	      this.dynamicProperties[i].getValue();
	    }

	    this.renderModifiers();
	  };

	  SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
	    var ownTransformers = [].concat(transformers);
	    var i;
	    var len = arr.length - 1;
	    var j;
	    var jLen;
	    var ownStyles = [];
	    var ownModifiers = [];
	    var currentTransform;
	    var modifier;
	    var processedPos;

	    for (i = len; i >= 0; i -= 1) {
	      processedPos = this.searchProcessedElement(arr[i]);

	      if (!processedPos) {
	        arr[i]._render = render;
	      } else {
	        itemsData[i] = prevViewData[processedPos - 1];
	      }

	      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
	        if (!processedPos) {
	          itemsData[i] = this.createStyleElement(arr[i], level);
	        } else {
	          itemsData[i].style.closed = false;
	        }

	        if (arr[i]._render) {
	          if (itemsData[i].style.pElem.parentNode !== container) {
	            container.appendChild(itemsData[i].style.pElem);
	          }
	        }

	        ownStyles.push(itemsData[i].style);
	      } else if (arr[i].ty === 'gr') {
	        if (!processedPos) {
	          itemsData[i] = this.createGroupElement(arr[i]);
	        } else {
	          jLen = itemsData[i].it.length;

	          for (j = 0; j < jLen; j += 1) {
	            itemsData[i].prevViewData[j] = itemsData[i].it[j];
	          }
	        }

	        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);

	        if (arr[i]._render) {
	          if (itemsData[i].gr.parentNode !== container) {
	            container.appendChild(itemsData[i].gr);
	          }
	        }
	      } else if (arr[i].ty === 'tr') {
	        if (!processedPos) {
	          itemsData[i] = this.createTransformElement(arr[i], container);
	        }

	        currentTransform = itemsData[i].transform;
	        ownTransformers.push(currentTransform);
	      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
	        if (!processedPos) {
	          itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
	        }

	        this.setElementStyles(itemsData[i]);
	      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          modifier.init(this, arr[i]);
	          itemsData[i] = modifier;
	          this.shapeModifiers.push(modifier);
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = false;
	        }

	        ownModifiers.push(modifier);
	      } else if (arr[i].ty === 'rp') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          itemsData[i] = modifier;
	          modifier.init(this, arr, i, itemsData);
	          this.shapeModifiers.push(modifier);
	          render = false;
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = true;
	        }

	        ownModifiers.push(modifier);
	      }

	      this.addProcessedElement(arr[i], i + 1);
	    }

	    len = ownStyles.length;

	    for (i = 0; i < len; i += 1) {
	      ownStyles[i].closed = true;
	    }

	    len = ownModifiers.length;

	    for (i = 0; i < len; i += 1) {
	      ownModifiers[i].closed = true;
	    }
	  };

	  SVGShapeElement.prototype.renderInnerContent = function () {
	    this.renderModifiers();
	    var i;
	    var len = this.stylesList.length;

	    for (i = 0; i < len; i += 1) {
	      this.stylesList[i].reset();
	    }

	    this.renderShape();

	    for (i = 0; i < len; i += 1) {
	      if (this.stylesList[i]._mdf || this._isFirstFrame) {
	        if (this.stylesList[i].msElem) {
	          this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers

	          this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
	        }

	        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	      }
	    }
	  };

	  SVGShapeElement.prototype.renderShape = function () {
	    var i;
	    var len = this.animatedContents.length;
	    var animatedContent;

	    for (i = 0; i < len; i += 1) {
	      animatedContent = this.animatedContents[i];

	      if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
	        animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
	      }
	    }
	  };

	  SVGShapeElement.prototype.destroy = function () {
	    this.destroyBaseElement();
	    this.shapesData = null;
	    this.itemsData = null;
	  };

	  function LetterProps(o, sw, sc, fc, m, p) {
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this._mdf = {
	      o: true,
	      sw: !!sw,
	      sc: !!sc,
	      fc: !!fc,
	      m: true,
	      p: true
	    };
	  }

	  LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
	    this._mdf.o = false;
	    this._mdf.sw = false;
	    this._mdf.sc = false;
	    this._mdf.fc = false;
	    this._mdf.m = false;
	    this._mdf.p = false;
	    var updated = false;

	    if (this.o !== o) {
	      this.o = o;
	      this._mdf.o = true;
	      updated = true;
	    }

	    if (this.sw !== sw) {
	      this.sw = sw;
	      this._mdf.sw = true;
	      updated = true;
	    }

	    if (this.sc !== sc) {
	      this.sc = sc;
	      this._mdf.sc = true;
	      updated = true;
	    }

	    if (this.fc !== fc) {
	      this.fc = fc;
	      this._mdf.fc = true;
	      updated = true;
	    }

	    if (this.m !== m) {
	      this.m = m;
	      this._mdf.m = true;
	      updated = true;
	    }

	    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
	      this.p = p;
	      this._mdf.p = true;
	      updated = true;
	    }

	    return updated;
	  };

	  function TextProperty(elem, data) {
	    this._frameId = initialDefaultFrame;
	    this.pv = '';
	    this.v = '';
	    this.kf = false;
	    this._isFirstFrame = true;
	    this._mdf = false;

	    if (data.d && data.d.sid) {
	      data.d = elem.globalData.slotManager.getProp(data.d);
	    }

	    this.data = data;
	    this.elem = elem;
	    this.comp = this.elem.comp;
	    this.keysIndex = 0;
	    this.canResize = false;
	    this.minimumFontSize = 1;
	    this.effectsSequence = [];
	    this.currentData = {
	      ascent: 0,
	      boxWidth: this.defaultBoxWidth,
	      f: '',
	      fStyle: '',
	      fWeight: '',
	      fc: '',
	      j: '',
	      justifyOffset: '',
	      l: [],
	      lh: 0,
	      lineWidths: [],
	      ls: '',
	      of: '',
	      s: '',
	      sc: '',
	      sw: 0,
	      t: 0,
	      tr: 0,
	      sz: 0,
	      ps: null,
	      fillColorAnim: false,
	      strokeColorAnim: false,
	      strokeWidthAnim: false,
	      yOffset: 0,
	      finalSize: 0,
	      finalText: [],
	      finalLineHeight: 0,
	      __complete: false
	    };
	    this.copyData(this.currentData, this.data.d.k[0].s);

	    if (!this.searchProperty()) {
	      this.completeTextData(this.currentData);
	    }
	  }

	  TextProperty.prototype.defaultBoxWidth = [0, 0];

	  TextProperty.prototype.copyData = function (obj, data) {
	    for (var s in data) {
	      if (Object.prototype.hasOwnProperty.call(data, s)) {
	        obj[s] = data[s];
	      }
	    }

	    return obj;
	  };

	  TextProperty.prototype.setCurrentData = function (data) {
	    if (!data.__complete) {
	      this.completeTextData(data);
	    }

	    this.currentData = data;
	    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
	    this._mdf = true;
	  };

	  TextProperty.prototype.searchProperty = function () {
	    return this.searchKeyframes();
	  };

	  TextProperty.prototype.searchKeyframes = function () {
	    this.kf = this.data.d.k.length > 1;

	    if (this.kf) {
	      this.addEffect(this.getKeyframeValue.bind(this));
	    }

	    return this.kf;
	  };

	  TextProperty.prototype.addEffect = function (effectFunction) {
	    this.effectsSequence.push(effectFunction);
	    this.elem.addDynamicProperty(this);
	  };

	  TextProperty.prototype.getValue = function (_finalValue) {
	    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
	      return;
	    }

	    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
	    var currentValue = this.currentData;
	    var currentIndex = this.keysIndex;

	    if (this.lock) {
	      this.setCurrentData(this.currentData);
	      return;
	    }

	    this.lock = true;
	    this._mdf = false;
	    var i;
	    var len = this.effectsSequence.length;
	    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;

	    for (i = 0; i < len; i += 1) {
	      // Checking if index changed to prevent creating a new object every time the expression updates.
	      if (currentIndex !== this.keysIndex) {
	        finalValue = this.effectsSequence[i](finalValue, finalValue.t);
	      } else {
	        finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
	      }
	    }

	    if (currentValue !== finalValue) {
	      this.setCurrentData(finalValue);
	    }

	    this.v = this.currentData;
	    this.pv = this.v;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	  };

	  TextProperty.prototype.getKeyframeValue = function () {
	    var textKeys = this.data.d.k;
	    var frameNum = this.elem.comp.renderedFrame;
	    var i = 0;
	    var len = textKeys.length;

	    while (i <= len - 1) {
	      if (i === len - 1 || textKeys[i + 1].t > frameNum) {
	        break;
	      }

	      i += 1;
	    }

	    if (this.keysIndex !== i) {
	      this.keysIndex = i;
	    }

	    return this.data.d.k[this.keysIndex].s;
	  };

	  TextProperty.prototype.buildFinalText = function (text) {
	    var charactersArray = [];
	    var i = 0;
	    var len = text.length;
	    var charCode;
	    var secondCharCode;
	    var shouldCombine = false;
	    var shouldCombineNext = false;
	    var currentChars = '';

	    while (i < len) {
	      shouldCombine = shouldCombineNext;
	      shouldCombineNext = false;
	      charCode = text.charCodeAt(i);
	      currentChars = text.charAt(i);

	      if (FontManager.isCombinedCharacter(charCode)) {
	        shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
	      } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	        if (FontManager.isRegionalFlag(text, i)) {
	          currentChars = text.substr(i, 14);
	        } else {
	          secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)

	          if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
	            if (FontManager.isModifier(charCode, secondCharCode)) {
	              currentChars = text.substr(i, 2);
	              shouldCombine = true;
	            } else if (FontManager.isFlagEmoji(text.substr(i, 4))) {
	              currentChars = text.substr(i, 4);
	            } else {
	              currentChars = text.substr(i, 2);
	            }
	          }
	        }
	      } else if (charCode > 0xDBFF) {
	        secondCharCode = text.charCodeAt(i + 1);

	        if (FontManager.isVariationSelector(charCode)) {
	          shouldCombine = true;
	        }
	      } else if (FontManager.isZeroWidthJoiner(charCode)) {
	        shouldCombine = true;
	        shouldCombineNext = true;
	      }

	      if (shouldCombine) {
	        charactersArray[charactersArray.length - 1] += currentChars;
	        shouldCombine = false;
	      } else {
	        charactersArray.push(currentChars);
	      }

	      i += currentChars.length;
	    }

	    return charactersArray;
	  };

	  TextProperty.prototype.completeTextData = function (documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i;
	    var len;
	    var newLineFlag;
	    var index = 0;
	    var val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0;
	    var currentPos = 0;
	    var currentLine = 0;
	    var lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j;
	    var jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData;
	    var cLength = 0;
	    var fontProps = getFontProperties(fontData);
	    documentData.fWeight = fontProps.weight;
	    documentData.fStyle = fontProps.style;
	    documentData.finalSize = documentData.s;
	    documentData.finalText = this.buildFinalText(documentData.t);
	    len = documentData.finalText.length;
	    documentData.finalLineHeight = documentData.lh;
	    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
	    var charCode;

	    if (documentData.sz) {
	      var flag = true;
	      var boxWidth = documentData.sz[0];
	      var boxHeight = documentData.sz[1];
	      var currentHeight;
	      var finalText;

	      while (flag) {
	        finalText = this.buildFinalText(documentData.t);
	        currentHeight = 0;
	        lineWidth = 0;
	        len = finalText.length;
	        trackingOffset = documentData.tr / 1000 * documentData.finalSize;
	        var lastSpaceIndex = -1;

	        for (i = 0; i < len; i += 1) {
	          charCode = finalText[i].charCodeAt(0);
	          newLineFlag = false;

	          if (finalText[i] === ' ') {
	            lastSpaceIndex = i;
	          } else if (charCode === 13 || charCode === 3) {
	            lineWidth = 0;
	            newLineFlag = true;
	            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
	          }

	          if (fontManager.chars) {
	            charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
	            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
	          } else {
	            // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	            cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
	          }

	          if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
	            if (lastSpaceIndex === -1) {
	              len += 1;
	            } else {
	              i = lastSpaceIndex;
	            }

	            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
	            finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);

	            lastSpaceIndex = -1;
	            lineWidth = 0;
	          } else {
	            lineWidth += cLength;
	            lineWidth += trackingOffset;
	          }
	        }

	        currentHeight += fontData.ascent * documentData.finalSize / 100;

	        if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
	          documentData.finalSize -= 1;
	          documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
	        } else {
	          documentData.finalText = finalText;
	          len = documentData.finalText.length;
	          flag = false;
	        }
	      }
	    }

	    lineWidth = -trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;

	    for (i = 0; i < len; i += 1) {
	      newLineFlag = false;
	      currentChar = documentData.finalText[i];
	      charCode = currentChar.charCodeAt(0);

	      if (charCode === 13 || charCode === 3) {
	        uncollapsedSpaces = 0;
	        lineWidths.push(lineWidth);
	        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	        lineWidth = -2 * trackingOffset;
	        val = '';
	        newLineFlag = true;
	        currentLine += 1;
	      } else {
	        val = currentChar;
	      }

	      if (fontManager.chars) {
	        charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
	      } else {
	        // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
	      } //


	      if (currentChar === ' ') {
	        uncollapsedSpaces += cLength + trackingOffset;
	      } else {
	        lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	        uncollapsedSpaces = 0;
	      }

	      letters.push({
	        l: cLength,
	        an: cLength,
	        add: currentSize,
	        n: newLineFlag,
	        anIndexes: [],
	        val: val,
	        line: currentLine,
	        animatorJustifyOffset: 0
	      });

	      if (anchorGrouping == 2) {
	        // eslint-disable-line eqeqeq
	        currentSize += cLength;

	        if (val === '' || val === ' ' || i === len - 1) {
	          if (val === '' || val === ' ') {
	            currentSize -= cLength;
	          }

	          while (currentPos <= i) {
	            letters[currentPos].an = currentSize;
	            letters[currentPos].ind = index;
	            letters[currentPos].extra = cLength;
	            currentPos += 1;
	          }

	          index += 1;
	          currentSize = 0;
	        }
	      } else if (anchorGrouping == 3) {
	        // eslint-disable-line eqeqeq
	        currentSize += cLength;

	        if (val === '' || i === len - 1) {
	          if (val === '') {
	            currentSize -= cLength;
	          }

	          while (currentPos <= i) {
	            letters[currentPos].an = currentSize;
	            letters[currentPos].ind = index;
	            letters[currentPos].extra = cLength;
	            currentPos += 1;
	          }

	          currentSize = 0;
	          index += 1;
	        }
	      } else {
	        letters[index].ind = index;
	        letters[index].extra = 0;
	        index += 1;
	      }
	    }

	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);

	    if (documentData.sz) {
	      documentData.boxWidth = documentData.sz[0];
	      documentData.justifyOffset = 0;
	    } else {
	      documentData.boxWidth = maxLineWidth;

	      switch (documentData.j) {
	        case 1:
	          documentData.justifyOffset = -documentData.boxWidth;
	          break;

	        case 2:
	          documentData.justifyOffset = -documentData.boxWidth / 2;
	          break;

	        default:
	          documentData.justifyOffset = 0;
	      }
	    }

	    documentData.lineWidths = lineWidths;
	    var animators = data.a;
	    var animatorData;
	    var letterData;
	    jLen = animators.length;
	    var based;
	    var ind;
	    var indexes = [];

	    for (j = 0; j < jLen; j += 1) {
	      animatorData = animators[j];

	      if (animatorData.a.sc) {
	        documentData.strokeColorAnim = true;
	      }

	      if (animatorData.a.sw) {
	        documentData.strokeWidthAnim = true;
	      }

	      if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
	        documentData.fillColorAnim = true;
	      }

	      ind = 0;
	      based = animatorData.s.b;

	      for (i = 0; i < len; i += 1) {
	        letterData = letters[i];
	        letterData.anIndexes[j] = ind;

	        if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
	          // eslint-disable-line eqeqeq
	          if (animatorData.s.rn === 1) {
	            indexes.push(ind);
	          }

	          ind += 1;
	        }
	      }

	      data.a[j].s.totalChars = ind;
	      var currentInd = -1;
	      var newInd;

	      if (animatorData.s.rn === 1) {
	        for (i = 0; i < len; i += 1) {
	          letterData = letters[i];

	          if (currentInd != letterData.anIndexes[j]) {
	            // eslint-disable-line eqeqeq
	            currentInd = letterData.anIndexes[j];
	            newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
	          }

	          letterData.anIndexes[j] = newInd;
	        }
	      }
	    }

	    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
	  };

	  TextProperty.prototype.updateDocumentData = function (newData, index) {
	    index = index === undefined ? this.keysIndex : index;
	    var dData = this.copyData({}, this.data.d.k[index].s);
	    dData = this.copyData(dData, newData);
	    this.data.d.k[index].s = dData;
	    this.recalculate(index);
	    this.setCurrentData(dData);
	    this.elem.addDynamicProperty(this);
	  };

	  TextProperty.prototype.recalculate = function (index) {
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    this.keysIndex = 0;
	    this._isFirstFrame = true;
	    this.getValue(dData);
	  };

	  TextProperty.prototype.canResizeFont = function (_canResize) {
	    this.canResize = _canResize;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	  };

	  TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
	    this.minimumFontSize = Math.floor(_fontValue) || 1;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	  };

	  var TextSelectorProp = function () {
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;

	    function TextSelectorPropFactory(elem, data) {
	      this._currentTextLength = -1;
	      this.k = false;
	      this.data = data;
	      this.elem = elem;
	      this.comp = elem.comp;
	      this.finalS = 0;
	      this.finalE = 0;
	      this.initDynamicPropertyContainer(elem);
	      this.s = PropertyFactory.getProp(elem, data.s || {
	        k: 0
	      }, 0, 0, this);

	      if ('e' in data) {
	        this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
	      } else {
	        this.e = {
	          v: 100
	        };
	      }

	      this.o = PropertyFactory.getProp(elem, data.o || {
	        k: 0
	      }, 0, 0, this);
	      this.xe = PropertyFactory.getProp(elem, data.xe || {
	        k: 0
	      }, 0, 0, this);
	      this.ne = PropertyFactory.getProp(elem, data.ne || {
	        k: 0
	      }, 0, 0, this);
	      this.sm = PropertyFactory.getProp(elem, data.sm || {
	        k: 100
	      }, 0, 0, this);
	      this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);

	      if (!this.dynamicProperties.length) {
	        this.getValue();
	      }
	    }

	    TextSelectorPropFactory.prototype = {
	      getMult: function getMult(ind) {
	        if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
	          this.getValue();
	        }

	        var x1 = 0;
	        var y1 = 0;
	        var x2 = 1;
	        var y2 = 1;

	        if (this.ne.v > 0) {
	          x1 = this.ne.v / 100.0;
	        } else {
	          y1 = -this.ne.v / 100.0;
	        }

	        if (this.xe.v > 0) {
	          x2 = 1.0 - this.xe.v / 100.0;
	        } else {
	          y2 = 1.0 + this.xe.v / 100.0;
	        }

	        var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
	        var mult = 0;
	        var s = this.finalS;
	        var e = this.finalE;
	        var type = this.data.sh;

	        if (type === 2) {
	          if (e === s) {
	            mult = ind >= e ? 1 : 0;
	          } else {
	            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	          }

	          mult = easer(mult);
	        } else if (type === 3) {
	          if (e === s) {
	            mult = ind >= e ? 0 : 1;
	          } else {
	            mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	          }

	          mult = easer(mult);
	        } else if (type === 4) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));

	            if (mult < 0.5) {
	              mult *= 2;
	            } else {
	              mult = 1 - 2 * (mult - 0.5);
	            }
	          }

	          mult = easer(mult);
	        } else if (type === 5) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            var tot = e - s;
	            /* ind += 0.5;
	                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */

	            ind = min(max(0, ind + 0.5 - s), e - s);
	            var x = -tot / 2 + ind;
	            var a = tot / 2;
	            mult = Math.sqrt(1 - x * x / (a * a));
	          }

	          mult = easer(mult);
	        } else if (type === 6) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            ind = min(max(0, ind + 0.5 - s), e - s);
	            mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
	          }

	          mult = easer(mult);
	        } else {
	          if (ind >= floor(s)) {
	            if (ind - s < 0) {
	              mult = max(0, min(min(e, 1) - (s - ind), 1));
	            } else {
	              mult = max(0, min(e - ind, 1));
	            }
	          }

	          mult = easer(mult);
	        } // Smoothness implementation.
	        // The smoothness represents a reduced range of the original [0; 1] range.
	        // if smoothness is 25%, the new range will be [0.375; 0.625]
	        // Steps are:
	        // - find the lower value of the new range (threshold)
	        // - if multiplier is smaller than that value, floor it to 0
	        // - if it is larger,
	        //     - subtract the threshold
	        //     - divide it by the smoothness (this will return the range to [0; 1])
	        // Note: If it doesn't work on some scenarios, consider applying it before the easer.


	        if (this.sm.v !== 100) {
	          var smoothness = this.sm.v * 0.01;

	          if (smoothness === 0) {
	            smoothness = 0.00000001;
	          }

	          var threshold = 0.5 - smoothness * 0.5;

	          if (mult < threshold) {
	            mult = 0;
	          } else {
	            mult = (mult - threshold) / smoothness;

	            if (mult > 1) {
	              mult = 1;
	            }
	          }
	        }

	        return mult * this.a.v;
	      },
	      getValue: function getValue(newCharsFlag) {
	        this.iterateDynamicProperties();
	        this._mdf = newCharsFlag || this._mdf;
	        this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;

	        if (newCharsFlag && this.data.r === 2) {
	          this.e.v = this._currentTextLength;
	        }

	        var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
	        var o = this.o.v / divisor;
	        var s = this.s.v / divisor + o;
	        var e = this.e.v / divisor + o;

	        if (s > e) {
	          var _s = s;
	          s = e;
	          e = _s;
	        }

	        this.finalS = s;
	        this.finalE = e;
	      }
	    };
	    extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

	    function getTextSelectorProp(elem, data, arr) {
	      return new TextSelectorPropFactory(elem, data);
	    }

	    return {
	      getTextSelectorProp: getTextSelectorProp
	    };
	  }();

	  function TextAnimatorDataProperty(elem, animatorProps, container) {
	    var defaultData = {
	      propType: false
	    };
	    var getProp = PropertyFactory.getProp;
	    var textAnimatorAnimatables = animatorProps.a;
	    this.a = {
	      r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
	      rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
	      ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
	      sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
	      sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
	      s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
	      a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
	      o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
	      p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
	      sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
	      sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
	      fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
	      fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
	      fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
	      fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
	      t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
	    };
	    this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
	    this.s.t = animatorProps.s.t;
	  }

	  function TextAnimatorProperty(textData, renderType, elem) {
	    this._isFirstFrame = true;
	    this._hasMaskedPath = false;
	    this._frameId = -1;
	    this._textData = textData;
	    this._renderType = renderType;
	    this._elem = elem;
	    this._animatorsData = createSizedArray(this._textData.a.length);
	    this._pathData = {};
	    this._moreOptions = {
	      alignment: {}
	    };
	    this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	    this.initDynamicPropertyContainer(elem);
	  }

	  TextAnimatorProperty.prototype.searchProperties = function () {
	    var i;
	    var len = this._textData.a.length;
	    var animatorProps;
	    var getProp = PropertyFactory.getProp;

	    for (i = 0; i < len; i += 1) {
	      animatorProps = this._textData.a[i];
	      this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
	    }

	    if (this._textData.p && 'm' in this._textData.p) {
	      this._pathData = {
	        a: getProp(this._elem, this._textData.p.a, 0, 0, this),
	        f: getProp(this._elem, this._textData.p.f, 0, 0, this),
	        l: getProp(this._elem, this._textData.p.l, 0, 0, this),
	        r: getProp(this._elem, this._textData.p.r, 0, 0, this),
	        p: getProp(this._elem, this._textData.p.p, 0, 0, this),
	        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	      };
	      this._hasMaskedPath = true;
	    } else {
	      this._hasMaskedPath = false;
	    }

	    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
	  };

	  TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
	    this.lettersChangedFlag = lettersChangedFlag;

	    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
	      return;
	    }

	    this._isFirstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var xPos;
	    var yPos;
	    var i;
	    var len;
	    var letters = documentData.l;
	    var pathInfo;
	    var currentLength;
	    var currentPoint;
	    var segmentLength;
	    var flag;
	    var pointInd;
	    var segmentInd;
	    var prevPoint;
	    var points;
	    var segments;
	    var partialLength;
	    var totalLength;
	    var perc;
	    var tanAngle;
	    var mask;

	    if (this._hasMaskedPath) {
	      mask = this._pathData.m;

	      if (!this._pathData.n || this._pathData._mdf) {
	        var paths = mask.v;

	        if (this._pathData.r.v) {
	          paths = paths.reverse();
	        } // TODO: release bezier data cached from previous pathInfo: this._pathData.pi


	        pathInfo = {
	          tLength: 0,
	          segments: []
	        };
	        len = paths._length - 1;
	        var bezierData;
	        totalLength = 0;

	        for (i = 0; i < len; i += 1) {
	          bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
	          pathInfo.tLength += bezierData.segmentLength;
	          pathInfo.segments.push(bezierData);
	          totalLength += bezierData.segmentLength;
	        }

	        i = len;

	        if (mask.v.c) {
	          bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
	          pathInfo.tLength += bezierData.segmentLength;
	          pathInfo.segments.push(bezierData);
	          totalLength += bezierData.segmentLength;
	        }

	        this._pathData.pi = pathInfo;
	      }

	      pathInfo = this._pathData.pi;
	      currentLength = this._pathData.f.v;
	      segmentInd = 0;
	      pointInd = 1;
	      segmentLength = 0;
	      flag = true;
	      segments = pathInfo.segments;

	      if (currentLength < 0 && mask.v.c) {
	        if (pathInfo.tLength < Math.abs(currentLength)) {
	          currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	        }

	        segmentInd = segments.length - 1;
	        points = segments[segmentInd].points;
	        pointInd = points.length - 1;

	        while (currentLength < 0) {
	          currentLength += points[pointInd].partialLength;
	          pointInd -= 1;

	          if (pointInd < 0) {
	            segmentInd -= 1;
	            points = segments[segmentInd].points;
	            pointInd = points.length - 1;
	          }
	        }
	      }

	      points = segments[segmentInd].points;
	      prevPoint = points[pointInd - 1];
	      currentPoint = points[pointInd];
	      partialLength = currentPoint.partialLength;
	    }

	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.finalSize * 1.2 * 0.714;
	    var firstLine = true;
	    var animatorProps;
	    var animatorSelector;
	    var j;
	    var jLen;
	    var letterValue;
	    jLen = animators.length;
	    var mult;
	    var ind = -1;
	    var offf;
	    var xPathPos;
	    var yPathPos;
	    var initPathPos = currentLength;
	    var initSegmentInd = segmentInd;
	    var initPointInd = pointInd;
	    var currentLine = -1;
	    var elemOpacity;
	    var sc;
	    var sw;
	    var fc;
	    var k;
	    var letterSw;
	    var letterSc;
	    var letterFc;
	    var letterM = '';
	    var letterP = this.defaultPropsArray;
	    var letterO; //

	    if (documentData.j === 2 || documentData.j === 1) {
	      var animatorJustifyOffset = 0;
	      var animatorFirstCharOffset = 0;
	      var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
	      var lastIndex = 0;
	      var isNewLine = true;

	      for (i = 0; i < len; i += 1) {
	        if (letters[i].n) {
	          if (animatorJustifyOffset) {
	            animatorJustifyOffset += animatorFirstCharOffset;
	          }

	          while (lastIndex < i) {
	            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	            lastIndex += 1;
	          }

	          animatorJustifyOffset = 0;
	          isNewLine = true;
	        } else {
	          for (j = 0; j < jLen; j += 1) {
	            animatorProps = animators[j].a;

	            if (animatorProps.t.propType) {
	              if (isNewLine && documentData.j === 2) {
	                animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
	              }

	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	              if (mult.length) {
	                animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
	              } else {
	                animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
	              }
	            }
	          }

	          isNewLine = false;
	        }
	      }

	      if (animatorJustifyOffset) {
	        animatorJustifyOffset += animatorFirstCharOffset;
	      }

	      while (lastIndex < i) {
	        letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	        lastIndex += 1;
	      }
	    } //


	    for (i = 0; i < len; i += 1) {
	      matrixHelper.reset();
	      elemOpacity = 1;

	      if (letters[i].n) {
	        xPos = 0;
	        yPos += documentData.yOffset;
	        yPos += firstLine ? 1 : 0;
	        currentLength = initPathPos;
	        firstLine = false;

	        if (this._hasMaskedPath) {
	          segmentInd = initSegmentInd;
	          pointInd = initPointInd;
	          points = segments[segmentInd].points;
	          prevPoint = points[pointInd - 1];
	          currentPoint = points[pointInd];
	          partialLength = currentPoint.partialLength;
	          segmentLength = 0;
	        }

	        letterM = '';
	        letterFc = '';
	        letterSw = '';
	        letterO = '';
	        letterP = this.defaultPropsArray;
	      } else {
	        if (this._hasMaskedPath) {
	          if (currentLine !== letters[i].line) {
	            switch (documentData.j) {
	              case 1:
	                currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                break;

	              case 2:
	                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
	                break;
	            }

	            currentLine = letters[i].line;
	          }

	          if (ind !== letters[i].ind) {
	            if (letters[ind]) {
	              currentLength += letters[ind].extra;
	            }

	            currentLength += letters[i].an / 2;
	            ind = letters[i].ind;
	          }

	          currentLength += alignment[0] * letters[i].an * 0.005;
	          var animatorOffset = 0;

	          for (j = 0; j < jLen; j += 1) {
	            animatorProps = animators[j].a;

	            if (animatorProps.p.propType) {
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	              if (mult.length) {
	                animatorOffset += animatorProps.p.v[0] * mult[0];
	              } else {
	                animatorOffset += animatorProps.p.v[0] * mult;
	              }
	            }

	            if (animatorProps.a.propType) {
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	              if (mult.length) {
	                animatorOffset += animatorProps.a.v[0] * mult[0];
	              } else {
	                animatorOffset += animatorProps.a.v[0] * mult;
	              }
	            }
	          }

	          flag = true; // Force alignment only works with a single line for now

	          if (this._pathData.a.v) {
	            currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
	            currentLength += this._pathData.f.v;
	          }

	          while (flag) {
	            if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	              perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	              xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	              yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	              matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
	              flag = false;
	            } else if (points) {
	              segmentLength += currentPoint.partialLength;
	              pointInd += 1;

	              if (pointInd >= points.length) {
	                pointInd = 0;
	                segmentInd += 1;

	                if (!segments[segmentInd]) {
	                  if (mask.v.c) {
	                    pointInd = 0;
	                    segmentInd = 0;
	                    points = segments[segmentInd].points;
	                  } else {
	                    segmentLength -= currentPoint.partialLength;
	                    points = null;
	                  }
	                } else {
	                  points = segments[segmentInd].points;
	                }
	              }

	              if (points) {
	                prevPoint = currentPoint;
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	              }
	            }
	          }

	          offf = letters[i].an / 2 - letters[i].add;
	          matrixHelper.translate(-offf, 0, 0);
	        } else {
	          offf = letters[i].an / 2 - letters[i].add;
	          matrixHelper.translate(-offf, 0, 0); // Grouping alignment

	          matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;

	          if (animatorProps.t.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"

	            if (xPos !== 0 || documentData.j !== 0) {
	              if (this._hasMaskedPath) {
	                if (mult.length) {
	                  currentLength += animatorProps.t.v * mult[0];
	                } else {
	                  currentLength += animatorProps.t.v * mult;
	                }
	              } else if (mult.length) {
	                xPos += animatorProps.t.v * mult[0];
	              } else {
	                xPos += animatorProps.t.v * mult;
	              }
	            }
	          }
	        }

	        if (documentData.strokeWidthAnim) {
	          sw = documentData.sw || 0;
	        }

	        if (documentData.strokeColorAnim) {
	          if (documentData.sc) {
	            sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	          } else {
	            sc = [0, 0, 0];
	          }
	        }

	        if (documentData.fillColorAnim && documentData.fc) {
	          fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;

	          if (animatorProps.a.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	            if (mult.length) {
	              matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
	            } else {
	              matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
	            }
	          }
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;

	          if (animatorProps.s.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	            if (mult.length) {
	              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
	            } else {
	              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
	            }
	          }
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	          animatorSelector = animators[j].s;
	          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	          if (animatorProps.sk.propType) {
	            if (mult.length) {
	              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	            } else {
	              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	            }
	          }

	          if (animatorProps.r.propType) {
	            if (mult.length) {
	              matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	            } else {
	              matrixHelper.rotateZ(-animatorProps.r.v * mult);
	            }
	          }

	          if (animatorProps.ry.propType) {
	            if (mult.length) {
	              matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
	            } else {
	              matrixHelper.rotateY(animatorProps.ry.v * mult);
	            }
	          }

	          if (animatorProps.rx.propType) {
	            if (mult.length) {
	              matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
	            } else {
	              matrixHelper.rotateX(animatorProps.rx.v * mult);
	            }
	          }

	          if (animatorProps.o.propType) {
	            if (mult.length) {
	              elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
	            } else {
	              elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
	            }
	          }

	          if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
	            if (mult.length) {
	              sw += animatorProps.sw.v * mult[0];
	            } else {
	              sw += animatorProps.sw.v * mult;
	            }
	          }

	          if (documentData.strokeColorAnim && animatorProps.sc.propType) {
	            for (k = 0; k < 3; k += 1) {
	              if (mult.length) {
	                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
	              } else {
	                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
	              }
	            }
	          }

	          if (documentData.fillColorAnim && documentData.fc) {
	            if (animatorProps.fc.propType) {
	              for (k = 0; k < 3; k += 1) {
	                if (mult.length) {
	                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
	                } else {
	                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
	                }
	              }
	            }

	            if (animatorProps.fh.propType) {
	              if (mult.length) {
	                fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
	              } else {
	                fc = addHueToRGB(fc, animatorProps.fh.v * mult);
	              }
	            }

	            if (animatorProps.fs.propType) {
	              if (mult.length) {
	                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
	              } else {
	                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
	              }
	            }

	            if (animatorProps.fb.propType) {
	              if (mult.length) {
	                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
	              } else {
	                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
	              }
	            }
	          }
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;

	          if (animatorProps.p.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	            if (this._hasMaskedPath) {
	              if (mult.length) {
	                matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	              } else {
	                matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	              }
	            } else if (mult.length) {
	              matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	            } else {
	              matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	            }
	          }
	        }

	        if (documentData.strokeWidthAnim) {
	          letterSw = sw < 0 ? 0 : sw;
	        }

	        if (documentData.strokeColorAnim) {
	          letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
	        }

	        if (documentData.fillColorAnim && documentData.fc) {
	          letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
	        }

	        if (this._hasMaskedPath) {
	          matrixHelper.translate(0, -documentData.ls);
	          matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);

	          if (this._pathData.p.v) {
	            tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	            var rot = Math.atan(tanAngle) * 180 / Math.PI;

	            if (currentPoint.point[0] < prevPoint.point[0]) {
	              rot += 180;
	            }

	            matrixHelper.rotate(-rot * Math.PI / 180);
	          }

	          matrixHelper.translate(xPathPos, yPathPos, 0);
	          currentLength -= alignment[0] * letters[i].an * 0.005;

	          if (letters[i + 1] && ind !== letters[i + 1].ind) {
	            currentLength += letters[i].an / 2;
	            currentLength += documentData.tr * 0.001 * documentData.finalSize;
	          }
	        } else {
	          matrixHelper.translate(xPos, yPos, 0);

	          if (documentData.ps) {
	            // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	            matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
	          }

	          switch (documentData.j) {
	            case 1:
	              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
	              break;

	            case 2:
	              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
	              break;
	          }

	          matrixHelper.translate(0, -documentData.ls);
	          matrixHelper.translate(offf, 0, 0);
	          matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
	          xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
	        }

	        if (renderType === 'html') {
	          letterM = matrixHelper.toCSS();
	        } else if (renderType === 'svg') {
	          letterM = matrixHelper.to2dCSS();
	        } else {
	          letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
	        }

	        letterO = elemOpacity;
	      }

	      if (renderedLettersCount <= i) {
	        letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
	        this.renderedLetters.push(letterValue);
	        renderedLettersCount += 1;
	        this.lettersChangedFlag = true;
	      } else {
	        letterValue = this.renderedLetters[i];
	        this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	      }
	    }
	  };

	  TextAnimatorProperty.prototype.getValue = function () {
	    if (this._elem.globalData.frameId === this._frameId) {
	      return;
	    }

	    this._frameId = this._elem.globalData.frameId;
	    this.iterateDynamicProperties();
	  };

	  TextAnimatorProperty.prototype.mHelper = new Matrix();
	  TextAnimatorProperty.prototype.defaultPropsArray = [];
	  extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

	  function ITextElement() {}

	  ITextElement.prototype.initElement = function (data, globalData, comp) {
	    this.lettersChangedFlag = true;
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
	    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	    this.initRenderable();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    this.createContent();
	    this.hide();
	    this.textAnimator.searchProperties(this.dynamicProperties);
	  };

	  ITextElement.prototype.prepareFrame = function (num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	  };

	  ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
	    var j;
	    var jLen = shapes.length;
	    var pathNodes;
	    var shapeStr = '';

	    for (j = 0; j < jLen; j += 1) {
	      if (shapes[j].ty === 'sh') {
	        pathNodes = shapes[j].ks.k;
	        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	      }
	    }

	    return shapeStr;
	  };

	  ITextElement.prototype.updateDocumentData = function (newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	  };

	  ITextElement.prototype.canResizeFont = function (_canResize) {
	    this.textProperty.canResizeFont(_canResize);
	  };

	  ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
	    this.textProperty.setMinimumFontSize(_fontSize);
	  };

	  ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if (documentData.ps) {
	      matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
	    }

	    matrixHelper.translate(0, -documentData.ls, 0);

	    switch (documentData.j) {
	      case 1:
	        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
	        break;

	      case 2:
	        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
	        break;
	    }

	    matrixHelper.translate(xPos, yPos, 0);
	  };

	  ITextElement.prototype.buildColor = function (colorData) {
	    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
	  };

	  ITextElement.prototype.emptyProp = new LetterProps();

	  ITextElement.prototype.destroy = function () {};

	  ITextElement.prototype.validateText = function () {
	    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
	      this.buildNewText();
	      this.textProperty._isFirstFrame = false;
	      this.textProperty._mdf = false;
	    }
	  };

	  var emptyShapeData = {
	    shapes: []
	  };

	  function SVGTextLottieElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

	  SVGTextLottieElement.prototype.createContent = function () {
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	      this.textContainer = createNS('text');
	    }
	  };

	  SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
	    var i = 0;
	    var len = textArray.length;
	    var textContents = [];
	    var currentTextContent = '';

	    while (i < len) {
	      if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
	        textContents.push(currentTextContent);
	        currentTextContent = '';
	      } else {
	        currentTextContent += textArray[i];
	      }

	      i += 1;
	    }

	    textContents.push(currentTextContent);
	    return textContents;
	  };

	  SVGTextLottieElement.prototype.buildShapeData = function (data, scale) {
	    // data should probably be cloned to apply scale separately to each instance of a text on different layers
	    // but since text internal content gets only rendered once and then it's never rerendered,
	    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
	    // Avoiding cloning is preferred since cloning each character shape data is expensive
	    if (data.shapes && data.shapes.length) {
	      var shape = data.shapes[0];

	      if (shape.it) {
	        var shapeItem = shape.it[shape.it.length - 1];

	        if (shapeItem.s) {
	          shapeItem.s.k[0] = scale;
	          shapeItem.s.k[1] = scale;
	        }
	      }
	    }

	    return data;
	  };

	  SVGTextLottieElement.prototype.buildNewText = function () {
	    this.addDynamicProperty(this);
	    var i;
	    var len;
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);

	    if (documentData.fc) {
	      this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    } else {
	      this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }

	    if (documentData.sc) {
	      this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	      this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }

	    this.layerElement.setAttribute('font-size', documentData.finalSize);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

	    if (fontData.fClass) {
	      this.layerElement.setAttribute('class', fontData.fClass);
	    } else {
	      this.layerElement.setAttribute('font-family', fontData.fFamily);
	      var fWeight = documentData.fWeight;
	      var fStyle = documentData.fStyle;
	      this.layerElement.setAttribute('font-style', fStyle);
	      this.layerElement.setAttribute('font-weight', fWeight);
	    }

	    this.layerElement.setAttribute('aria-label', documentData.t);
	    var letters = documentData.l || [];
	    var usesGlyphs = !!this.globalData.fontManager.chars;
	    len = letters.length;
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapeStr = '';
	    var singleShape = this.data.singleShape;
	    var xPos = 0;
	    var yPos = 0;
	    var firstLine = true;
	    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;

	    if (singleShape && !usesGlyphs && !documentData.sz) {
	      var tElement = this.textContainer;
	      var justify = 'start';

	      switch (documentData.j) {
	        case 1:
	          justify = 'end';
	          break;

	        case 2:
	          justify = 'middle';
	          break;

	        default:
	          justify = 'start';
	          break;
	      }

	      tElement.setAttribute('text-anchor', justify);
	      tElement.setAttribute('letter-spacing', trackingOffset);
	      var textContent = this.buildTextContents(documentData.finalText);
	      len = textContent.length;
	      yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;

	      for (i = 0; i < len; i += 1) {
	        tSpan = this.textSpans[i].span || createNS('tspan');
	        tSpan.textContent = textContent[i];
	        tSpan.setAttribute('x', 0);
	        tSpan.setAttribute('y', yPos);
	        tSpan.style.display = 'inherit';
	        tElement.appendChild(tSpan);

	        if (!this.textSpans[i]) {
	          this.textSpans[i] = {
	            span: null,
	            glyph: null
	          };
	        }

	        this.textSpans[i].span = tSpan;
	        yPos += documentData.finalLineHeight;
	      }

	      this.layerElement.appendChild(tElement);
	    } else {
	      var cachedSpansLength = this.textSpans.length;
	      var charData;

	      for (i = 0; i < len; i += 1) {
	        if (!this.textSpans[i]) {
	          this.textSpans[i] = {
	            span: null,
	            childSpan: null,
	            glyph: null
	          };
	        }

	        if (!usesGlyphs || !singleShape || i === 0) {
	          tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');

	          if (cachedSpansLength <= i) {
	            tSpan.setAttribute('stroke-linecap', 'butt');
	            tSpan.setAttribute('stroke-linejoin', 'round');
	            tSpan.setAttribute('stroke-miterlimit', '4');
	            this.textSpans[i].span = tSpan;

	            if (usesGlyphs) {
	              var childSpan = createNS('g');
	              tSpan.appendChild(childSpan);
	              this.textSpans[i].childSpan = childSpan;
	            }

	            this.textSpans[i].span = tSpan;
	            this.layerElement.appendChild(tSpan);
	          }

	          tSpan.style.display = 'inherit';
	        }

	        matrixHelper.reset();

	        if (singleShape) {
	          if (letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	          }

	          this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	          xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;

	          xPos += trackingOffset;
	        }

	        if (usesGlyphs) {
	          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	          var glyphElement; // t === 1 means the character has been replaced with an animated shaped

	          if (charData.t === 1) {
	            glyphElement = new SVGCompElement(charData.data, this.globalData, this);
	          } else {
	            var data = emptyShapeData;

	            if (charData.data && charData.data.shapes) {
	              data = this.buildShapeData(charData.data, documentData.finalSize);
	            }

	            glyphElement = new SVGShapeElement(data, this.globalData, this);
	          }

	          if (this.textSpans[i].glyph) {
	            var glyph = this.textSpans[i].glyph;
	            this.textSpans[i].childSpan.removeChild(glyph.layerElement);
	            glyph.destroy();
	          }

	          this.textSpans[i].glyph = glyphElement;
	          glyphElement._debug = true;
	          glyphElement.prepareFrame(0);
	          glyphElement.renderFrame();
	          this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
	          // this might have issues with strokes and might need a different solution

	          if (charData.t === 1) {
	            this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
	          }
	        } else {
	          if (singleShape) {
	            tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
	          }

	          tSpan.textContent = letters[i].val;
	          tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
	        } //

	      }

	      if (singleShape && tSpan) {
	        tSpan.setAttribute('d', shapeStr);
	      }
	    }

	    while (i < this.textSpans.length) {
	      this.textSpans[i].span.style.display = 'none';
	      i += 1;
	    }

	    this._sizeChanged = true;
	  };

	  SVGTextLottieElement.prototype.sourceRectAtTime = function () {
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderInnerContent();

	    if (this._sizeChanged) {
	      this._sizeChanged = false;
	      var textBox = this.layerElement.getBBox();
	      this.bbox = {
	        top: textBox.y,
	        left: textBox.x,
	        width: textBox.width,
	        height: textBox.height
	      };
	    }

	    return this.bbox;
	  };

	  SVGTextLottieElement.prototype.getValue = function () {
	    var i;
	    var len = this.textSpans.length;
	    var glyphElement;
	    this.renderedFrame = this.comp.renderedFrame;

	    for (i = 0; i < len; i += 1) {
	      glyphElement = this.textSpans[i].glyph;

	      if (glyphElement) {
	        glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);

	        if (glyphElement._mdf) {
	          this._mdf = true;
	        }
	      }
	    }
	  };

	  SVGTextLottieElement.prototype.renderInnerContent = function () {
	    this.validateText();

	    if (!this.data.singleShape || this._mdf) {
	      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

	      if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
	        this._sizeChanged = true;
	        var i;
	        var len;
	        var renderedLetters = this.textAnimator.renderedLetters;
	        var letters = this.textProperty.currentData.l;
	        len = letters.length;
	        var renderedLetter;
	        var textSpan;
	        var glyphElement;

	        for (i = 0; i < len; i += 1) {
	          if (!letters[i].n) {
	            renderedLetter = renderedLetters[i];
	            textSpan = this.textSpans[i].span;
	            glyphElement = this.textSpans[i].glyph;

	            if (glyphElement) {
	              glyphElement.renderFrame();
	            }

	            if (renderedLetter._mdf.m) {
	              textSpan.setAttribute('transform', renderedLetter.m);
	            }

	            if (renderedLetter._mdf.o) {
	              textSpan.setAttribute('opacity', renderedLetter.o);
	            }

	            if (renderedLetter._mdf.sw) {
	              textSpan.setAttribute('stroke-width', renderedLetter.sw);
	            }

	            if (renderedLetter._mdf.sc) {
	              textSpan.setAttribute('stroke', renderedLetter.sc);
	            }

	            if (renderedLetter._mdf.fc) {
	              textSpan.setAttribute('fill', renderedLetter.fc);
	            }
	          }
	        }
	      }
	    }
	  };

	  function ISolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([IImageElement], ISolidElement);

	  ISolidElement.prototype.createContent = function () {
	    var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
	    /// /rect.style.height = this.data.sh;
	    /// /rect.style.fill = this.data.sc;

	    rect.setAttribute('width', this.data.sw);
	    rect.setAttribute('height', this.data.sh);
	    rect.setAttribute('fill', this.data.sc);
	    this.layerElement.appendChild(rect);
	  };

	  function NullElement(data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initFrame();
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	  }

	  NullElement.prototype.prepareFrame = function (num) {
	    this.prepareProperties(num, true);
	  };

	  NullElement.prototype.renderFrame = function () {};

	  NullElement.prototype.getBaseElement = function () {
	    return null;
	  };

	  NullElement.prototype.destroy = function () {};

	  NullElement.prototype.sourceRectAtTime = function () {};

	  NullElement.prototype.hide = function () {};

	  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

	  function SVGRendererBase() {}

	  extendPrototype([BaseRenderer], SVGRendererBase);

	  SVGRendererBase.prototype.createNull = function (data) {
	    return new NullElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.createShape = function (data) {
	    return new SVGShapeElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.createText = function (data) {
	    return new SVGTextLottieElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.createImage = function (data) {
	    return new IImageElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.createSolid = function (data) {
	    return new ISolidElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.configAnimation = function (animData) {
	    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');

	    if (this.renderConfig.viewBoxSize) {
	      this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
	    } else {
	      this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
	    }

	    if (!this.renderConfig.viewBoxOnly) {
	      this.svgElement.setAttribute('width', animData.w);
	      this.svgElement.setAttribute('height', animData.h);
	      this.svgElement.style.width = '100%';
	      this.svgElement.style.height = '100%';
	      this.svgElement.style.transform = 'translate3d(0,0,0)';
	      this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
	    }

	    if (this.renderConfig.width) {
	      this.svgElement.setAttribute('width', this.renderConfig.width);
	    }

	    if (this.renderConfig.height) {
	      this.svgElement.setAttribute('height', this.renderConfig.height);
	    }

	    if (this.renderConfig.className) {
	      this.svgElement.setAttribute('class', this.renderConfig.className);
	    }

	    if (this.renderConfig.id) {
	      this.svgElement.setAttribute('id', this.renderConfig.id);
	    }

	    if (this.renderConfig.focusable !== undefined) {
	      this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
	    }

	    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
	    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";

	    this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation

	    var defs = this.globalData.defs;
	    this.setupGlobalData(animData, defs);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.data = animData;
	    var maskElement = createNS('clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width', animData.w);
	    rect.setAttribute('height', animData.h);
	    rect.setAttribute('x', 0);
	    rect.setAttribute('y', 0);
	    var maskId = createElementID();
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
	    defs.appendChild(maskElement);
	    this.layers = animData.layers;
	    this.elements = createSizedArray(animData.layers.length);
	  };

	  SVGRendererBase.prototype.destroy = function () {
	    if (this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }

	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i;
	    var len = this.layers ? this.layers.length : 0;

	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }

	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	  };

	  SVGRendererBase.prototype.updateContainerSize = function () {};

	  SVGRendererBase.prototype.findIndexByInd = function (ind) {
	    var i = 0;
	    var len = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.layers[i].ind === ind) {
	        return i;
	      }
	    }

	    return -1;
	  };

	  SVGRendererBase.prototype.buildItem = function (pos) {
	    var elements = this.elements;

	    if (elements[pos] || this.layers[pos].ty === 99) {
	      return;
	    }

	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	    elements[pos] = element;

	    if (getExpressionsPlugin()) {
	      if (this.layers[pos].ty === 0) {
	        this.globalData.projectInterface.registerComposition(element);
	      }

	      element.initExpressions();
	    }

	    this.appendElementInPos(element, pos);

	    if (this.layers[pos].tt) {
	      var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;

	      if (elementIndex === -1) {
	        return;
	      }

	      if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
	        this.buildItem(elementIndex);
	        this.addPendingElement(element);
	      } else {
	        var matteElement = elements[elementIndex];
	        var matteMask = matteElement.getMatte(this.layers[pos].tt);
	        element.setMatte(matteMask);
	      }
	    }
	  };

	  SVGRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();

	      if (element.data.tt) {
	        var i = 0;
	        var len = this.elements.length;

	        while (i < len) {
	          if (this.elements[i] === element) {
	            var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
	            var matteElement = this.elements[elementIndex];
	            var matteMask = matteElement.getMatte(this.layers[i].tt);
	            element.setMatte(matteMask);
	            break;
	          }

	          i += 1;
	        }
	      }
	    }
	  };

	  SVGRendererBase.prototype.renderFrame = function (num) {
	    if (this.renderedFrame === num || this.destroyed) {
	      return;
	    }

	    if (num === null) {
	      num = this.renderedFrame;
	    } else {
	      this.renderedFrame = num;
	    } // console.log('-------');
	    // console.log('FRAME ',num);


	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    this.globalData._mdf = false;
	    var i;
	    var len = this.layers.length;

	    if (!this.completeLayers) {
	      this.checkLayers(num);
	    }

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(num - this.layers[i].st);
	      }
	    }

	    if (this.globalData._mdf) {
	      for (i = 0; i < len; i += 1) {
	        if (this.completeLayers || this.elements[i]) {
	          this.elements[i].renderFrame();
	        }
	      }
	    }
	  };

	  SVGRendererBase.prototype.appendElementInPos = function (element, pos) {
	    var newElement = element.getBaseElement();

	    if (!newElement) {
	      return;
	    }

	    var i = 0;
	    var nextElement;

	    while (i < pos) {
	      if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
	        nextElement = this.elements[i].getBaseElement();
	      }

	      i += 1;
	    }

	    if (nextElement) {
	      this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	      this.layerElement.appendChild(newElement);
	    }
	  };

	  SVGRendererBase.prototype.hide = function () {
	    this.layerElement.style.display = 'none';
	  };

	  SVGRendererBase.prototype.show = function () {
	    this.layerElement.style.display = 'block';
	  };

	  function ICompElement() {}

	  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

	  ICompElement.prototype.initElement = function (data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initTransform(data, globalData, comp);
	    this.initRenderable();
	    this.initHierarchy();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();

	    if (this.data.xt || !globalData.progressiveLoad) {
	      this.buildAllItems();
	    }

	    this.hide();
	  };
	  /* ICompElement.prototype.hide = function(){
	      if(!this.hidden){
	          this.hideElement();
	          var i,len = this.elements.length;
	          for( i = 0; i < len; i+=1 ){
	              if(this.elements[i]){
	                  this.elements[i].hide();
	              }
	          }
	      }
	  }; */


	  ICompElement.prototype.prepareFrame = function (num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);

	    if (!this.isInRange && !this.data.xt) {
	      return;
	    }

	    if (!this.tm._placeholder) {
	      var timeRemapped = this.tm.v;

	      if (timeRemapped === this.data.op) {
	        timeRemapped = this.data.op - 1;
	      }

	      this.renderedFrame = timeRemapped;
	    } else {
	      this.renderedFrame = num / this.data.sr;
	    }

	    var i;
	    var len = this.elements.length;

	    if (!this.completeLayers) {
	      this.checkLayers(this.renderedFrame);
	    } // This iteration needs to be backwards because of how expressions connect between each other


	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);

	        if (this.elements[i]._mdf) {
	          this._mdf = true;
	        }
	      }
	    }
	  };

	  ICompElement.prototype.renderInnerContent = function () {
	    var i;
	    var len = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].renderFrame();
	      }
	    }
	  };

	  ICompElement.prototype.setElements = function (elems) {
	    this.elements = elems;
	  };

	  ICompElement.prototype.getElements = function () {
	    return this.elements;
	  };

	  ICompElement.prototype.destroyElements = function () {
	    var i;
	    var len = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i]) {
	        this.elements[i].destroy();
	      }
	    }
	  };

	  ICompElement.prototype.destroy = function () {
	    this.destroyElements();
	    this.destroyBaseElement();
	  };

	  function SVGCompElement(data, globalData, comp) {
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }

	  extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);

	  SVGCompElement.prototype.createComp = function (data) {
	    return new SVGCompElement(data, this.globalData, this);
	  };

	  function SVGRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.svgElement = createNS('svg');
	    var ariaLabel = '';

	    if (config && config.title) {
	      var titleElement = createNS('title');
	      var titleId = createElementID();
	      titleElement.setAttribute('id', titleId);
	      titleElement.textContent = config.title;
	      this.svgElement.appendChild(titleElement);
	      ariaLabel += titleId;
	    }

	    if (config && config.description) {
	      var descElement = createNS('desc');
	      var descId = createElementID();
	      descElement.setAttribute('id', descId);
	      descElement.textContent = config.description;
	      this.svgElement.appendChild(descElement);
	      ariaLabel += ' ' + descId;
	    }

	    if (ariaLabel) {
	      this.svgElement.setAttribute('aria-labelledby', ariaLabel);
	    }

	    var defs = createNS('defs');
	    this.svgElement.appendChild(defs);
	    var maskElement = createNS('g');
	    this.svgElement.appendChild(maskElement);
	    this.layerElement = maskElement;
	    this.renderConfig = {
	      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      contentVisibility: config && config.contentVisibility || 'visible',
	      progressiveLoad: config && config.progressiveLoad || false,
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      viewBoxOnly: config && config.viewBoxOnly || false,
	      viewBoxSize: config && config.viewBoxSize || false,
	      className: config && config.className || '',
	      id: config && config.id || '',
	      focusable: config && config.focusable,
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '100%',
	        height: config && config.filterSize && config.filterSize.height || '100%',
	        x: config && config.filterSize && config.filterSize.x || '0%',
	        y: config && config.filterSize && config.filterSize.y || '0%'
	      },
	      width: config && config.width,
	      height: config && config.height,
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      defs: defs,
	      renderConfig: this.renderConfig
	    };
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	    this.rendererType = 'svg';
	  }

	  extendPrototype([SVGRendererBase], SVGRenderer);

	  SVGRenderer.prototype.createComp = function (data) {
	    return new SVGCompElement(data, this.globalData, this);
	  };

	  function ShapeTransformManager() {
	    this.sequences = {};
	    this.sequenceList = [];
	    this.transform_key_count = 0;
	  }

	  ShapeTransformManager.prototype = {
	    addTransformSequence: function addTransformSequence(transforms) {
	      var i;
	      var len = transforms.length;
	      var key = '_';

	      for (i = 0; i < len; i += 1) {
	        key += transforms[i].transform.key + '_';
	      }

	      var sequence = this.sequences[key];

	      if (!sequence) {
	        sequence = {
	          transforms: [].concat(transforms),
	          finalTransform: new Matrix(),
	          _mdf: false
	        };
	        this.sequences[key] = sequence;
	        this.sequenceList.push(sequence);
	      }

	      return sequence;
	    },
	    processSequence: function processSequence(sequence, isFirstFrame) {
	      var i = 0;
	      var len = sequence.transforms.length;
	      var _mdf = isFirstFrame;

	      while (i < len && !isFirstFrame) {
	        if (sequence.transforms[i].transform.mProps._mdf) {
	          _mdf = true;
	          break;
	        }

	        i += 1;
	      }

	      if (_mdf) {
	        sequence.finalTransform.reset();

	        for (i = len - 1; i >= 0; i -= 1) {
	          sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
	        }
	      }

	      sequence._mdf = _mdf;
	    },
	    processSequences: function processSequences(isFirstFrame) {
	      var i;
	      var len = this.sequenceList.length;

	      for (i = 0; i < len; i += 1) {
	        this.processSequence(this.sequenceList[i], isFirstFrame);
	      }
	    },
	    getNewKey: function getNewKey() {
	      this.transform_key_count += 1;
	      return '_' + this.transform_key_count;
	    }
	  };

	  var lumaLoader = function lumaLoader() {
	    var id = '__lottie_element_luma_buffer';
	    var lumaBuffer = null;
	    var lumaBufferCtx = null;
	    var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
	    // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
	    // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
	    // Naming it solution 2 to mark the extra comment lines.

	    /*
	    var svgString = [
	      '<svg xmlns="http://www.w3.org/2000/svg">',
	      '<filter id="' + id + '">',
	      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0',
	      '"/>',
	      '</filter>',
	      '</svg>',
	    ].join('');
	    var blob = new Blob([svgString], { type: 'image/svg+xml' });
	    var url = URL.createObjectURL(blob);
	    */

	    function createLumaSvgFilter() {
	      var _svg = createNS('svg');

	      var fil = createNS('filter');
	      var matrix = createNS('feColorMatrix');
	      fil.setAttribute('id', id);
	      matrix.setAttribute('type', 'matrix');
	      matrix.setAttribute('color-interpolation-filters', 'sRGB');
	      matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
	      fil.appendChild(matrix);

	      _svg.appendChild(fil);

	      _svg.setAttribute('id', id + '_svg');

	      if (featureSupport.svgLumaHidden) {
	        _svg.style.display = 'none';
	      }

	      return _svg;
	    }

	    function loadLuma() {
	      if (!lumaBuffer) {
	        svg = createLumaSvgFilter();
	        document.body.appendChild(svg);
	        lumaBuffer = createTag('canvas');
	        lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2

	        lumaBufferCtx.filter = 'url(#' + id + ')';
	        lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
	        lumaBufferCtx.fillRect(0, 0, 1, 1);
	      }
	    }

	    function getLuma(canvas) {
	      if (!lumaBuffer) {
	        loadLuma();
	      }

	      lumaBuffer.width = canvas.width;
	      lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2

	      lumaBufferCtx.filter = 'url(#' + id + ')';
	      return lumaBuffer;
	    }

	    return {
	      load: loadLuma,
	      get: getLuma
	    };
	  };

	  function createCanvas(width, height) {
	    if (featureSupport.offscreenCanvas) {
	      return new OffscreenCanvas(width, height);
	    }

	    var canvas = createTag('canvas');
	    canvas.width = width;
	    canvas.height = height;
	    return canvas;
	  }

	  var assetLoader = function () {
	    return {
	      loadLumaCanvas: lumaLoader.load,
	      getLumaCanvas: lumaLoader.get,
	      createCanvas: createCanvas
	    };
	  }();

	  var registeredEffects = {};

	  function CVEffects(elem) {
	    var i;
	    var len = elem.data.ef ? elem.data.ef.length : 0;
	    this.filters = [];
	    var filterManager;

	    for (i = 0; i < len; i += 1) {
	      filterManager = null;
	      var type = elem.data.ef[i].ty;

	      if (registeredEffects[type]) {
	        var Effect = registeredEffects[type].effect;
	        filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
	      }

	      if (filterManager) {
	        this.filters.push(filterManager);
	      }
	    }

	    if (this.filters.length) {
	      elem.addRenderableComponent(this);
	    }
	  }

	  CVEffects.prototype.renderFrame = function (_isFirstFrame) {
	    var i;
	    var len = this.filters.length;

	    for (i = 0; i < len; i += 1) {
	      this.filters[i].renderFrame(_isFirstFrame);
	    }
	  };

	  CVEffects.prototype.getEffects = function (type) {
	    var i;
	    var len = this.filters.length;
	    var effects = [];

	    for (i = 0; i < len; i += 1) {
	      if (this.filters[i].type === type) {
	        effects.push(this.filters[i]);
	      }
	    }

	    return effects;
	  };

	  function registerEffect(id, effect) {
	    registeredEffects[id] = {
	      effect: effect
	    };
	  }

	  function CVMaskElement(data, element) {
	    this.data = data;
	    this.element = element;
	    this.masksProperties = this.data.masksProperties || [];
	    this.viewData = createSizedArray(this.masksProperties.length);
	    var i;
	    var len = this.masksProperties.length;
	    var hasMasks = false;

	    for (i = 0; i < len; i += 1) {
	      if (this.masksProperties[i].mode !== 'n') {
	        hasMasks = true;
	      }

	      this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
	    }

	    this.hasMasks = hasMasks;

	    if (hasMasks) {
	      this.element.addRenderableComponent(this);
	    }
	  }

	  CVMaskElement.prototype.renderFrame = function () {
	    if (!this.hasMasks) {
	      return;
	    }

	    var transform = this.element.finalTransform.mat;
	    var ctx = this.element.canvasContext;
	    var i;
	    var len = this.masksProperties.length;
	    var pt;
	    var pts;
	    var data;
	    ctx.beginPath();

	    for (i = 0; i < len; i += 1) {
	      if (this.masksProperties[i].mode !== 'n') {
	        if (this.masksProperties[i].inv) {
	          ctx.moveTo(0, 0);
	          ctx.lineTo(this.element.globalData.compSize.w, 0);
	          ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
	          ctx.lineTo(0, this.element.globalData.compSize.h);
	          ctx.lineTo(0, 0);
	        }

	        data = this.viewData[i].v;
	        pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
	        ctx.moveTo(pt[0], pt[1]);
	        var j;
	        var jLen = data._length;

	        for (j = 1; j < jLen; j += 1) {
	          pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
	          ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	        }

	        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
	        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	      }
	    }

	    this.element.globalData.renderer.save(true);
	    ctx.clip();
	  };

	  CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

	  CVMaskElement.prototype.destroy = function () {
	    this.element = null;
	  };

	  function CVBaseElement() {}

	  var operationsMap = {
	    1: 'source-in',
	    2: 'source-out',
	    3: 'source-in',
	    4: 'source-out'
	  };
	  CVBaseElement.prototype = {
	    createElements: function createElements() {},
	    initRendererElement: function initRendererElement() {},
	    createContainerElements: function createContainerElements() {
	      // If the layer is masked we will use two buffers to store each different states of the drawing
	      // This solution is not ideal for several reason. But unfortunately, because of the recursive
	      // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
	      // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
	      // It might be challenging because the layer most likely is transformed in some way
	      if (this.data.tt >= 1) {
	        this.buffers = [];
	        var canvasContext = this.globalData.canvasContext;
	        var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
	        this.buffers.push(bufferCanvas);
	        var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
	        this.buffers.push(bufferCanvas2);

	        if (this.data.tt >= 3 && !document._isProxy) {
	          assetLoader.loadLumaCanvas();
	        }
	      }

	      this.canvasContext = this.globalData.canvasContext;
	      this.transformCanvas = this.globalData.transformCanvas;
	      this.renderableEffectsManager = new CVEffects(this);
	      this.searchEffectTransforms();
	    },
	    createContent: function createContent() {},
	    setBlendMode: function setBlendMode() {
	      var globalData = this.globalData;

	      if (globalData.blendMode !== this.data.bm) {
	        globalData.blendMode = this.data.bm;
	        var blendModeValue = getBlendMode(this.data.bm);
	        globalData.canvasContext.globalCompositeOperation = blendModeValue;
	      }
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new CVMaskElement(this.data, this);
	      this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
	    },
	    hideElement: function hideElement() {
	      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	        this.hidden = true;
	      }
	    },
	    showElement: function showElement() {
	      if (this.isInRange && !this.isTransparent) {
	        this.hidden = false;
	        this._isFirstFrame = true;
	        this.maskManager._isFirstFrame = true;
	      }
	    },
	    clearCanvas: function clearCanvas(canvasContext) {
	      canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
	    },
	    prepareLayer: function prepareLayer() {
	      if (this.data.tt >= 1) {
	        var buffer = this.buffers[0];
	        var bufferCtx = buffer.getContext('2d');
	        this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing

	        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
	        // TODO: Check if there is a way to clear the canvas without resetting the transform

	        this.currentTransform = this.canvasContext.getTransform();
	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
	        this.clearCanvas(this.canvasContext);
	        this.canvasContext.setTransform(this.currentTransform);
	      }
	    },
	    exitLayer: function exitLayer() {
	      if (this.data.tt >= 1) {
	        var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
	        // that only contains the content of this layer
	        // (if it is a composition, it also includes the nested layers)

	        var bufferCtx = buffer.getContext('2d');
	        this.clearCanvas(bufferCtx);
	        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again

	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
	        this.clearCanvas(this.canvasContext);
	        this.canvasContext.setTransform(this.currentTransform); // We draw the mask

	        var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
	        mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)

	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
	        // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error

	        if (this.data.tt >= 3 && !document._isProxy) {
	          // We copy the painted mask to a buffer that has a color matrix filter applied to it
	          // that applies the rgb values to the alpha channel
	          var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
	          var lumaBufferCtx = lumaBuffer.getContext('2d');
	          lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
	          this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it

	          this.canvasContext.drawImage(lumaBuffer, 0, 0);
	        }

	        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
	        this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
	        // We use destination-over to draw the global drawing below the current layer

	        this.canvasContext.globalCompositeOperation = 'destination-over';
	        this.canvasContext.drawImage(this.buffers[0], 0, 0);
	        this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation

	        this.canvasContext.globalCompositeOperation = 'source-over';
	      }
	    },
	    renderFrame: function renderFrame(forceRender) {
	      if (this.hidden || this.data.hd) {
	        return;
	      }

	      if (this.data.td === 1 && !forceRender) {
	        return;
	      }

	      this.renderTransform();
	      this.renderRenderable();
	      this.renderLocalTransform();
	      this.setBlendMode();
	      var forceRealStack = this.data.ty === 0;
	      this.prepareLayer();
	      this.globalData.renderer.save(forceRealStack);
	      this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
	      this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
	      this.renderInnerContent();
	      this.globalData.renderer.restore(forceRealStack);
	      this.exitLayer();

	      if (this.maskManager.hasMasks) {
	        this.globalData.renderer.restore(true);
	      }

	      if (this._isFirstFrame) {
	        this._isFirstFrame = false;
	      }
	    },
	    destroy: function destroy() {
	      this.canvasContext = null;
	      this.data = null;
	      this.globalData = null;
	      this.maskManager.destroy();
	    },
	    mHelper: new Matrix()
	  };
	  CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
	  CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

	  function CVShapeData(element, data, styles, transformsManager) {
	    this.styledShapes = [];
	    this.tr = [0, 0, 0, 0, 0, 0];
	    var ty = 4;

	    if (data.ty === 'rc') {
	      ty = 5;
	    } else if (data.ty === 'el') {
	      ty = 6;
	    } else if (data.ty === 'sr') {
	      ty = 7;
	    }

	    this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
	    var i;
	    var len = styles.length;
	    var styledShape;

	    for (i = 0; i < len; i += 1) {
	      if (!styles[i].closed) {
	        styledShape = {
	          transforms: transformsManager.addTransformSequence(styles[i].transforms),
	          trNodes: []
	        };
	        this.styledShapes.push(styledShape);
	        styles[i].elements.push(styledShape);
	      }
	    }
	  }

	  CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

	  function CVShapeElement(data, globalData, comp) {
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this.transformsManager = new ShapeTransformManager();
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
	  CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
	  CVShapeElement.prototype.transformHelper = {
	    opacity: 1,
	    _opMdf: false
	  };
	  CVShapeElement.prototype.dashResetter = [];

	  CVShapeElement.prototype.createContent = function () {
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
	  };

	  CVShapeElement.prototype.createStyleElement = function (data, transforms) {
	    var styleElem = {
	      data: data,
	      type: data.ty,
	      preTransforms: this.transformsManager.addTransformSequence(transforms),
	      transforms: [],
	      elements: [],
	      closed: data.hd === true
	    };
	    var elementData = {};

	    if (data.ty === 'fl' || data.ty === 'st') {
	      elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);

	      if (!elementData.c.k) {
	        styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
	      }
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	      elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
	      elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
	      elementData.h = PropertyFactory.getProp(this, data.h || {
	        k: 0
	      }, 0, 0.01, this);
	      elementData.a = PropertyFactory.getProp(this, data.a || {
	        k: 0
	      }, 0, degToRads, this);
	      elementData.g = new GradientProperty(this, data.g, this);
	    }

	    elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);

	    if (data.ty === 'st' || data.ty === 'gs') {
	      styleElem.lc = lineCapEnum[data.lc || 2];
	      styleElem.lj = lineJoinEnum[data.lj || 2];

	      if (data.lj == 1) {
	        // eslint-disable-line eqeqeq
	        styleElem.ml = data.ml;
	      }

	      elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);

	      if (!elementData.w.k) {
	        styleElem.wi = elementData.w.v;
	      }

	      if (data.d) {
	        var d = new DashProperty(this, data.d, 'canvas', this);
	        elementData.d = d;

	        if (!elementData.d.k) {
	          styleElem.da = elementData.d.dashArray;
	          styleElem["do"] = elementData.d.dashoffset[0];
	        }
	      }
	    } else {
	      styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }

	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	  };

	  CVShapeElement.prototype.createGroupElement = function () {
	    var elementData = {
	      it: [],
	      prevViewData: []
	    };
	    return elementData;
	  };

	  CVShapeElement.prototype.createTransformElement = function (data) {
	    var elementData = {
	      transform: {
	        opacity: 1,
	        _opMdf: false,
	        key: this.transformsManager.getNewKey(),
	        op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
	        mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
	      }
	    };
	    return elementData;
	  };

	  CVShapeElement.prototype.createShapeElement = function (data) {
	    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	  };

	  CVShapeElement.prototype.reloadShapes = function () {
	    this._isFirstFrame = true;
	    var i;
	    var len = this.itemsData.length;

	    for (i = 0; i < len; i += 1) {
	      this.prevViewData[i] = this.itemsData[i];
	    }

	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
	    len = this.dynamicProperties.length;

	    for (i = 0; i < len; i += 1) {
	      this.dynamicProperties[i].getValue();
	    }

	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	  };

	  CVShapeElement.prototype.addTransformToStyleList = function (transform) {
	    var i;
	    var len = this.stylesList.length;

	    for (i = 0; i < len; i += 1) {
	      if (!this.stylesList[i].closed) {
	        this.stylesList[i].transforms.push(transform);
	      }
	    }
	  };

	  CVShapeElement.prototype.removeTransformFromStyleList = function () {
	    var i;
	    var len = this.stylesList.length;

	    for (i = 0; i < len; i += 1) {
	      if (!this.stylesList[i].closed) {
	        this.stylesList[i].transforms.pop();
	      }
	    }
	  };

	  CVShapeElement.prototype.closeStyles = function (styles) {
	    var i;
	    var len = styles.length;

	    for (i = 0; i < len; i += 1) {
	      styles[i].closed = true;
	    }
	  };

	  CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
	    var i;
	    var len = arr.length - 1;
	    var j;
	    var jLen;
	    var ownStyles = [];
	    var ownModifiers = [];
	    var processedPos;
	    var modifier;
	    var currentTransform;
	    var ownTransforms = [].concat(transforms);

	    for (i = len; i >= 0; i -= 1) {
	      processedPos = this.searchProcessedElement(arr[i]);

	      if (!processedPos) {
	        arr[i]._shouldRender = shouldRender;
	      } else {
	        itemsData[i] = prevViewData[processedPos - 1];
	      }

	      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
	        if (!processedPos) {
	          itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
	        } else {
	          itemsData[i].style.closed = false;
	        }

	        ownStyles.push(itemsData[i].style);
	      } else if (arr[i].ty === 'gr') {
	        if (!processedPos) {
	          itemsData[i] = this.createGroupElement(arr[i]);
	        } else {
	          jLen = itemsData[i].it.length;

	          for (j = 0; j < jLen; j += 1) {
	            itemsData[i].prevViewData[j] = itemsData[i].it[j];
	          }
	        }

	        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
	      } else if (arr[i].ty === 'tr') {
	        if (!processedPos) {
	          currentTransform = this.createTransformElement(arr[i]);
	          itemsData[i] = currentTransform;
	        }

	        ownTransforms.push(itemsData[i]);
	        this.addTransformToStyleList(itemsData[i]);
	      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
	        if (!processedPos) {
	          itemsData[i] = this.createShapeElement(arr[i]);
	        }
	      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          modifier.init(this, arr[i]);
	          itemsData[i] = modifier;
	          this.shapeModifiers.push(modifier);
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = false;
	        }

	        ownModifiers.push(modifier);
	      } else if (arr[i].ty === 'rp') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          itemsData[i] = modifier;
	          modifier.init(this, arr, i, itemsData);
	          this.shapeModifiers.push(modifier);
	          shouldRender = false;
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = true;
	        }

	        ownModifiers.push(modifier);
	      }

	      this.addProcessedElement(arr[i], i + 1);
	    }

	    this.removeTransformFromStyleList();
	    this.closeStyles(ownStyles);
	    len = ownModifiers.length;

	    for (i = 0; i < len; i += 1) {
	      ownModifiers[i].closed = true;
	    }
	  };

	  CVShapeElement.prototype.renderInnerContent = function () {
	    this.transformHelper.opacity = 1;
	    this.transformHelper._opMdf = false;
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
	  };

	  CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
	    if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
	      groupTransform.opacity = parentTransform.opacity;
	      groupTransform.opacity *= groupTransform.op.v;
	      groupTransform._opMdf = true;
	    }
	  };

	  CVShapeElement.prototype.drawLayer = function () {
	    var i;
	    var len = this.stylesList.length;
	    var j;
	    var jLen;
	    var k;
	    var kLen;
	    var elems;
	    var nodes;
	    var renderer = this.globalData.renderer;
	    var ctx = this.globalData.canvasContext;
	    var type;
	    var currentStyle;

	    for (i = 0; i < len; i += 1) {
	      currentStyle = this.stylesList[i];
	      type = currentStyle.type; // Skipping style when
	      // Stroke width equals 0
	      // style should not be rendered (extra unused repeaters)
	      // current opacity equals 0
	      // global opacity equals 0

	      if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
	        renderer.save();
	        elems = currentStyle.elements;

	        if (type === 'st' || type === 'gs') {
	          renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;

	          renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;

	          renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;

	          renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;

	          renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
	        } else {
	          renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
	        }

	        renderer.ctxOpacity(currentStyle.coOp);

	        if (type !== 'st' && type !== 'gs') {
	          ctx.beginPath();
	        }

	        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
	        jLen = elems.length;

	        for (j = 0; j < jLen; j += 1) {
	          if (type === 'st' || type === 'gs') {
	            ctx.beginPath();

	            if (currentStyle.da) {
	              ctx.setLineDash(currentStyle.da);
	              ctx.lineDashOffset = currentStyle["do"];
	            }
	          }

	          nodes = elems[j].trNodes;
	          kLen = nodes.length;

	          for (k = 0; k < kLen; k += 1) {
	            if (nodes[k].t === 'm') {
	              ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
	            } else if (nodes[k].t === 'c') {
	              ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
	            } else {
	              ctx.closePath();
	            }
	          }

	          if (type === 'st' || type === 'gs') {
	            // ctx.stroke();
	            renderer.ctxStroke();

	            if (currentStyle.da) {
	              ctx.setLineDash(this.dashResetter);
	            }
	          }
	        }

	        if (type !== 'st' && type !== 'gs') {
	          // ctx.fill(currentStyle.r);
	          this.globalData.renderer.ctxFill(currentStyle.r);
	        }

	        renderer.restore();
	      }
	    }
	  };

	  CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
	    var i;
	    var len = items.length - 1;
	    var groupTransform;
	    groupTransform = parentTransform;

	    for (i = len; i >= 0; i -= 1) {
	      if (items[i].ty === 'tr') {
	        groupTransform = data[i].transform;
	        this.renderShapeTransform(parentTransform, groupTransform);
	      } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
	        this.renderPath(items[i], data[i]);
	      } else if (items[i].ty === 'fl') {
	        this.renderFill(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'st') {
	        this.renderStroke(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
	        this.renderGradientFill(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'gr') {
	        this.renderShape(groupTransform, items[i].it, data[i].it);
	      } else if (items[i].ty === 'tm') ;
	    }

	    if (isMain) {
	      this.drawLayer();
	    }
	  };

	  CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
	    if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
	      var shapeNodes = styledShape.trNodes;
	      var paths = shape.paths;
	      var i;
	      var len;
	      var j;
	      var jLen = paths._length;
	      shapeNodes.length = 0;
	      var groupTransformMat = styledShape.transforms.finalTransform;

	      for (j = 0; j < jLen; j += 1) {
	        var pathNodes = paths.shapes[j];

	        if (pathNodes && pathNodes.v) {
	          len = pathNodes._length;

	          for (i = 1; i < len; i += 1) {
	            if (i === 1) {
	              shapeNodes.push({
	                t: 'm',
	                p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	              });
	            }

	            shapeNodes.push({
	              t: 'c',
	              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
	            });
	          }

	          if (len === 1) {
	            shapeNodes.push({
	              t: 'm',
	              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	            });
	          }

	          if (pathNodes.c && len) {
	            shapeNodes.push({
	              t: 'c',
	              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
	            });
	            shapeNodes.push({
	              t: 'z'
	            });
	          }
	        }
	      }

	      styledShape.trNodes = shapeNodes;
	    }
	  };

	  CVShapeElement.prototype.renderPath = function (pathData, itemData) {
	    if (pathData.hd !== true && pathData._shouldRender) {
	      var i;
	      var len = itemData.styledShapes.length;

	      for (i = 0; i < len; i += 1) {
	        this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
	      }
	    }
	  };

	  CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;

	    if (itemData.c._mdf || this._isFirstFrame) {
	      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
	    }

	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	      styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	  };

	  CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	    var grd;

	    if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
	      var ctx = this.globalData.canvasContext;
	      var pt1 = itemData.s.v;
	      var pt2 = itemData.e.v;

	      if (styleData.t === 1) {
	        grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
	      } else {
	        var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	        var percent = itemData.h.v;

	        if (percent >= 1) {
	          percent = 0.99;
	        } else if (percent <= -1) {
	          percent = -0.99;
	        }

	        var dist = rad * percent;
	        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	        grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
	      }

	      var i;
	      var len = styleData.g.p;
	      var cValues = itemData.g.c;
	      var opacity = 1;

	      for (i = 0; i < len; i += 1) {
	        if (itemData.g._hasOpacity && itemData.g._collapsable) {
	          opacity = itemData.g.o[i * 2 + 1];
	        }

	        grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
	      }

	      styleElem.grd = grd;
	    }

	    styleElem.coOp = itemData.o.v * groupTransform.opacity;
	  };

	  CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	    var d = itemData.d;

	    if (d && (d._mdf || this._isFirstFrame)) {
	      styleElem.da = d.dashArray;
	      styleElem["do"] = d.dashoffset[0];
	    }

	    if (itemData.c._mdf || this._isFirstFrame) {
	      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
	    }

	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	      styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }

	    if (itemData.w._mdf || this._isFirstFrame) {
	      styleElem.wi = itemData.w.v;
	    }
	  };

	  CVShapeElement.prototype.destroy = function () {
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemsData.length = 0;
	  };

	  function CVTextElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	      fill: 'rgba(0,0,0,0)',
	      stroke: 'rgba(0,0,0,0)',
	      sWidth: 0,
	      fValue: ''
	    };
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
	  CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

	  CVTextElement.prototype.buildNewText = function () {
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var hasFill = false;

	    if (documentData.fc) {
	      hasFill = true;
	      this.values.fill = this.buildColor(documentData.fc);
	    } else {
	      this.values.fill = 'rgba(0,0,0,0)';
	    }

	    this.fill = hasFill;
	    var hasStroke = false;

	    if (documentData.sc) {
	      hasStroke = true;
	      this.values.stroke = this.buildColor(documentData.sc);
	      this.values.sWidth = documentData.sw;
	    }

	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i;
	    var len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;

	    var charData;
	    var shapeData;
	    var k;
	    var kLen;
	    var shapes;
	    var j;
	    var jLen;
	    var pathNodes;
	    var commands;
	    var pathArr;
	    var singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
	    var xPos = 0;
	    var yPos = 0;
	    var firstLine = true;
	    var cnt = 0;

	    for (i = 0; i < len; i += 1) {
	      charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	      shapeData = charData && charData.data || {};
	      matrixHelper.reset();

	      if (singleShape && letters[i].n) {
	        xPos = -trackingOffset;
	        yPos += documentData.yOffset;
	        yPos += firstLine ? 1 : 0;
	        firstLine = false;
	      }

	      shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	      jLen = shapes.length;
	      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);

	      if (singleShape) {
	        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	      }

	      commands = createSizedArray(jLen - 1);
	      var commandsCounter = 0;

	      for (j = 0; j < jLen; j += 1) {
	        if (shapes[j].ty === 'sh') {
	          kLen = shapes[j].ks.k.i.length;
	          pathNodes = shapes[j].ks.k;
	          pathArr = [];

	          for (k = 1; k < kLen; k += 1) {
	            if (k === 1) {
	              pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
	            }

	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
	          }

	          pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
	          commands[commandsCounter] = pathArr;
	          commandsCounter += 1;
	        }
	      }

	      if (singleShape) {
	        xPos += letters[i].l;
	        xPos += trackingOffset;
	      }

	      if (this.textSpans[cnt]) {
	        this.textSpans[cnt].elem = commands;
	      } else {
	        this.textSpans[cnt] = {
	          elem: commands
	        };
	      }

	      cnt += 1;
	    }
	  };

	  CVTextElement.prototype.renderInnerContent = function () {
	    this.validateText();
	    var ctx = this.canvasContext;
	    ctx.font = this.values.fValue;
	    this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';

	    this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';

	    this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;

	    if (!this.data.singleShape) {
	      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }

	    var i;
	    var len;
	    var j;
	    var jLen;
	    var k;
	    var kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	    var letters = this.textProperty.currentData.l;
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null;
	    var lastStroke = null;
	    var lastStrokeW = null;
	    var commands;
	    var pathArr;
	    var renderer = this.globalData.renderer;

	    for (i = 0; i < len; i += 1) {
	      if (!letters[i].n) {
	        renderedLetter = renderedLetters[i];

	        if (renderedLetter) {
	          renderer.save();
	          renderer.ctxTransform(renderedLetter.p);
	          renderer.ctxOpacity(renderedLetter.o);
	        }

	        if (this.fill) {
	          if (renderedLetter && renderedLetter.fc) {
	            if (lastFill !== renderedLetter.fc) {
	              renderer.ctxFillStyle(renderedLetter.fc);
	              lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
	            }
	          } else if (lastFill !== this.values.fill) {
	            lastFill = this.values.fill;
	            renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
	          }

	          commands = this.textSpans[i].elem;
	          jLen = commands.length;
	          this.globalData.canvasContext.beginPath();

	          for (j = 0; j < jLen; j += 1) {
	            pathArr = commands[j];
	            kLen = pathArr.length;
	            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);

	            for (k = 2; k < kLen; k += 6) {
	              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	            }
	          }

	          this.globalData.canvasContext.closePath();
	          renderer.ctxFill(); // this.globalData.canvasContext.fill();
	          /// ctx.fillText(this.textSpans[i].val,0,0);
	        }

	        if (this.stroke) {
	          if (renderedLetter && renderedLetter.sw) {
	            if (lastStrokeW !== renderedLetter.sw) {
	              lastStrokeW = renderedLetter.sw;
	              renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
	            }
	          } else if (lastStrokeW !== this.values.sWidth) {
	            lastStrokeW = this.values.sWidth;
	            renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
	          }

	          if (renderedLetter && renderedLetter.sc) {
	            if (lastStroke !== renderedLetter.sc) {
	              lastStroke = renderedLetter.sc;
	              renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
	            }
	          } else if (lastStroke !== this.values.stroke) {
	            lastStroke = this.values.stroke;
	            renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
	          }

	          commands = this.textSpans[i].elem;
	          jLen = commands.length;
	          this.globalData.canvasContext.beginPath();

	          for (j = 0; j < jLen; j += 1) {
	            pathArr = commands[j];
	            kLen = pathArr.length;
	            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);

	            for (k = 2; k < kLen; k += 6) {
	              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	            }
	          }

	          this.globalData.canvasContext.closePath();
	          renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
	          /// ctx.strokeText(letters[i].val,0,0);
	        }

	        if (renderedLetter) {
	          this.globalData.renderer.restore();
	        }
	      }
	    }
	  };

	  function CVImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	    this.img = globalData.imageLoader.getAsset(this.assetData);
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
	  CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	  CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

	  CVImageElement.prototype.createContent = function () {
	    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
	      var canvas = createTag('canvas');
	      canvas.width = this.assetData.w;
	      canvas.height = this.assetData.h;
	      var ctx = canvas.getContext('2d');
	      var imgW = this.img.width;
	      var imgH = this.img.height;
	      var imgRel = imgW / imgH;
	      var canvasRel = this.assetData.w / this.assetData.h;
	      var widthCrop;
	      var heightCrop;
	      var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;

	      if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
	        heightCrop = imgH;
	        widthCrop = heightCrop * canvasRel;
	      } else {
	        widthCrop = imgW;
	        heightCrop = widthCrop / canvasRel;
	      }

	      ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
	      this.img = canvas;
	    }
	  };

	  CVImageElement.prototype.renderInnerContent = function () {
	    this.canvasContext.drawImage(this.img, 0, 0);
	  };

	  CVImageElement.prototype.destroy = function () {
	    this.img = null;
	  };

	  function CVSolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
	  CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	  CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

	  CVSolidElement.prototype.renderInnerContent = function () {
	    // var ctx = this.canvasContext;
	    this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;

	    this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	    //
	  };

	  function CanvasRendererBase() {}

	  extendPrototype([BaseRenderer], CanvasRendererBase);

	  CanvasRendererBase.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this.globalData, this);
	  };

	  CanvasRendererBase.prototype.createText = function (data) {
	    return new CVTextElement(data, this.globalData, this);
	  };

	  CanvasRendererBase.prototype.createImage = function (data) {
	    return new CVImageElement(data, this.globalData, this);
	  };

	  CanvasRendererBase.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this.globalData, this);
	  };

	  CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;

	  CanvasRendererBase.prototype.ctxTransform = function (props) {
	    if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
	      return;
	    }

	    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
	  };

	  CanvasRendererBase.prototype.ctxOpacity = function (op) {
	    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	  };

	  CanvasRendererBase.prototype.ctxFillStyle = function (value) {
	    this.canvasContext.fillStyle = value;
	  };

	  CanvasRendererBase.prototype.ctxStrokeStyle = function (value) {
	    this.canvasContext.strokeStyle = value;
	  };

	  CanvasRendererBase.prototype.ctxLineWidth = function (value) {
	    this.canvasContext.lineWidth = value;
	  };

	  CanvasRendererBase.prototype.ctxLineCap = function (value) {
	    this.canvasContext.lineCap = value;
	  };

	  CanvasRendererBase.prototype.ctxLineJoin = function (value) {
	    this.canvasContext.lineJoin = value;
	  };

	  CanvasRendererBase.prototype.ctxMiterLimit = function (value) {
	    this.canvasContext.miterLimit = value;
	  };

	  CanvasRendererBase.prototype.ctxFill = function (rule) {
	    this.canvasContext.fill(rule);
	  };

	  CanvasRendererBase.prototype.ctxFillRect = function (x, y, w, h) {
	    this.canvasContext.fillRect(x, y, w, h);
	  };

	  CanvasRendererBase.prototype.ctxStroke = function () {
	    this.canvasContext.stroke();
	  };

	  CanvasRendererBase.prototype.reset = function () {
	    if (!this.renderConfig.clearCanvas) {
	      this.canvasContext.restore();
	      return;
	    }

	    this.contextData.reset();
	  };

	  CanvasRendererBase.prototype.save = function () {
	    this.canvasContext.save();
	  };

	  CanvasRendererBase.prototype.restore = function (actionFlag) {
	    if (!this.renderConfig.clearCanvas) {
	      this.canvasContext.restore();
	      return;
	    }

	    if (actionFlag) {
	      this.globalData.blendMode = 'source-over';
	    }

	    this.contextData.restore(actionFlag);
	  };

	  CanvasRendererBase.prototype.configAnimation = function (animData) {
	    if (this.animationItem.wrapper) {
	      this.animationItem.container = createTag('canvas');
	      var containerStyle = this.animationItem.container.style;
	      containerStyle.width = '100%';
	      containerStyle.height = '100%';
	      var origin = '0px 0px 0px';
	      containerStyle.transformOrigin = origin;
	      containerStyle.mozTransformOrigin = origin;
	      containerStyle.webkitTransformOrigin = origin;
	      containerStyle['-webkit-transform'] = origin;
	      containerStyle.contentVisibility = this.renderConfig.contentVisibility;
	      this.animationItem.wrapper.appendChild(this.animationItem.container);
	      this.canvasContext = this.animationItem.container.getContext('2d');

	      if (this.renderConfig.className) {
	        this.animationItem.container.setAttribute('class', this.renderConfig.className);
	      }

	      if (this.renderConfig.id) {
	        this.animationItem.container.setAttribute('id', this.renderConfig.id);
	      }
	    } else {
	      this.canvasContext = this.renderConfig.context;
	    }

	    this.contextData.setContext(this.canvasContext);
	    this.data = animData;
	    this.layers = animData.layers;
	    this.transformCanvas = {
	      w: animData.w,
	      h: animData.h,
	      sx: 0,
	      sy: 0,
	      tx: 0,
	      ty: 0
	    };
	    this.setupGlobalData(animData, document.body);
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = createSizedArray(animData.layers.length);
	    this.updateContainerSize();
	  };

	  CanvasRendererBase.prototype.updateContainerSize = function (width, height) {
	    this.reset();
	    var elementWidth;
	    var elementHeight;

	    if (width) {
	      elementWidth = width;
	      elementHeight = height;
	      this.canvasContext.canvas.width = elementWidth;
	      this.canvasContext.canvas.height = elementHeight;
	    } else {
	      if (this.animationItem.wrapper && this.animationItem.container) {
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	      } else {
	        elementWidth = this.canvasContext.canvas.width;
	        elementHeight = this.canvasContext.canvas.height;
	      }

	      this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
	      this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
	    }

	    var elementRel;
	    var animationRel;

	    if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
	      var par = this.renderConfig.preserveAspectRatio.split(' ');
	      var fillType = par[1] || 'meet';
	      var pos = par[0] || 'xMidYMid';
	      var xPos = pos.substr(0, 4);
	      var yPos = pos.substr(4);
	      elementRel = elementWidth / elementHeight;
	      animationRel = this.transformCanvas.w / this.transformCanvas.h;

	      if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
	        this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	        this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	      } else {
	        this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	      }

	      if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
	        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
	      } else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
	        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
	      } else {
	        this.transformCanvas.tx = 0;
	      }

	      if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
	        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
	      } else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
	        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
	      } else {
	        this.transformCanvas.ty = 0;
	      }
	    } else if (this.renderConfig.preserveAspectRatio === 'none') {
	      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	      this.transformCanvas.tx = 0;
	      this.transformCanvas.ty = 0;
	    } else {
	      this.transformCanvas.sx = this.renderConfig.dpr;
	      this.transformCanvas.sy = this.renderConfig.dpr;
	      this.transformCanvas.tx = 0;
	      this.transformCanvas.ty = 0;
	    }

	    this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
	    /* var i, len = this.elements.length;
	      for(i=0;i<len;i+=1){
	          if(this.elements[i] && this.elements[i].data.ty === 0){
	              this.elements[i].resize(this.globalData.transformCanvas);
	          }
	      } */

	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	    this.renderFrame(this.renderedFrame, true);
	  };

	  CanvasRendererBase.prototype.destroy = function () {
	    if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }

	    var i;
	    var len = this.layers ? this.layers.length : 0;

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }

	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	  };

	  CanvasRendererBase.prototype.renderFrame = function (num, forceRender) {
	    if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) {
	      return;
	    }

	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
	    this.globalData.frameId += 1;
	    this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
	    this.globalData.projectInterface.currentFrame = num; // console.log('--------');
	    // console.log('NEW: ',num);

	    var i;
	    var len = this.layers.length;

	    if (!this.completeLayers) {
	      this.checkLayers(num);
	    }

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(num - this.layers[i].st);
	      }
	    }

	    if (this.globalData._mdf) {
	      if (this.renderConfig.clearCanvas === true) {
	        this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	      } else {
	        this.save();
	      }

	      for (i = len - 1; i >= 0; i -= 1) {
	        if (this.completeLayers || this.elements[i]) {
	          this.elements[i].renderFrame();
	        }
	      }

	      if (this.renderConfig.clearCanvas !== true) {
	        this.restore();
	      }
	    }
	  };

	  CanvasRendererBase.prototype.buildItem = function (pos) {
	    var elements = this.elements;

	    if (elements[pos] || this.layers[pos].ty === 99) {
	      return;
	    }

	    var element = this.createItem(this.layers[pos], this, this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    /* if(this.layers[pos].ty === 0){
	          element.resize(this.globalData.transformCanvas);
	      } */
	  };

	  CanvasRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	    }
	  };

	  CanvasRendererBase.prototype.hide = function () {
	    this.animationItem.container.style.display = 'none';
	  };

	  CanvasRendererBase.prototype.show = function () {
	    this.animationItem.container.style.display = 'block';
	  };

	  function CanvasContext() {
	    this.opacity = -1;
	    this.transform = createTypedArray('float32', 16);
	    this.fillStyle = '';
	    this.strokeStyle = '';
	    this.lineWidth = '';
	    this.lineCap = '';
	    this.lineJoin = '';
	    this.miterLimit = '';
	    this.id = Math.random();
	  }

	  function CVContextData() {
	    this.stack = [];
	    this.cArrPos = 0;
	    this.cTr = new Matrix();
	    var i;
	    var len = 15;

	    for (i = 0; i < len; i += 1) {
	      var canvasContext = new CanvasContext();
	      this.stack[i] = canvasContext;
	    }

	    this._length = len;
	    this.nativeContext = null;
	    this.transformMat = new Matrix();
	    this.currentOpacity = 1; //

	    this.currentFillStyle = '';
	    this.appliedFillStyle = ''; //

	    this.currentStrokeStyle = '';
	    this.appliedStrokeStyle = ''; //

	    this.currentLineWidth = '';
	    this.appliedLineWidth = ''; //

	    this.currentLineCap = '';
	    this.appliedLineCap = ''; //

	    this.currentLineJoin = '';
	    this.appliedLineJoin = ''; //

	    this.appliedMiterLimit = '';
	    this.currentMiterLimit = '';
	  }

	  CVContextData.prototype.duplicate = function () {
	    var newLength = this._length * 2;
	    var i = 0;

	    for (i = this._length; i < newLength; i += 1) {
	      this.stack[i] = new CanvasContext();
	    }

	    this._length = newLength;
	  };

	  CVContextData.prototype.reset = function () {
	    this.cArrPos = 0;
	    this.cTr.reset();
	    this.stack[this.cArrPos].opacity = 1;
	  };

	  CVContextData.prototype.restore = function (forceRestore) {
	    this.cArrPos -= 1;
	    var currentContext = this.stack[this.cArrPos];
	    var transform = currentContext.transform;
	    var i;
	    var arr = this.cTr.props;

	    for (i = 0; i < 16; i += 1) {
	      arr[i] = transform[i];
	    }

	    if (forceRestore) {
	      this.nativeContext.restore();
	      var prevStack = this.stack[this.cArrPos + 1];
	      this.appliedFillStyle = prevStack.fillStyle;
	      this.appliedStrokeStyle = prevStack.strokeStyle;
	      this.appliedLineWidth = prevStack.lineWidth;
	      this.appliedLineCap = prevStack.lineCap;
	      this.appliedLineJoin = prevStack.lineJoin;
	      this.appliedMiterLimit = prevStack.miterLimit;
	    }

	    this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);

	    if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
	      this.nativeContext.globalAlpha = currentContext.opacity;
	      this.currentOpacity = currentContext.opacity;
	    }

	    this.currentFillStyle = currentContext.fillStyle;
	    this.currentStrokeStyle = currentContext.strokeStyle;
	    this.currentLineWidth = currentContext.lineWidth;
	    this.currentLineCap = currentContext.lineCap;
	    this.currentLineJoin = currentContext.lineJoin;
	    this.currentMiterLimit = currentContext.miterLimit;
	  };

	  CVContextData.prototype.save = function (saveOnNativeFlag) {
	    if (saveOnNativeFlag) {
	      this.nativeContext.save();
	    }

	    var props = this.cTr.props;

	    if (this._length <= this.cArrPos) {
	      this.duplicate();
	    }

	    var currentStack = this.stack[this.cArrPos];
	    var i;

	    for (i = 0; i < 16; i += 1) {
	      currentStack.transform[i] = props[i];
	    }

	    this.cArrPos += 1;
	    var newStack = this.stack[this.cArrPos];
	    newStack.opacity = currentStack.opacity;
	    newStack.fillStyle = currentStack.fillStyle;
	    newStack.strokeStyle = currentStack.strokeStyle;
	    newStack.lineWidth = currentStack.lineWidth;
	    newStack.lineCap = currentStack.lineCap;
	    newStack.lineJoin = currentStack.lineJoin;
	    newStack.miterLimit = currentStack.miterLimit;
	  };

	  CVContextData.prototype.setOpacity = function (value) {
	    this.stack[this.cArrPos].opacity = value;
	  };

	  CVContextData.prototype.setContext = function (value) {
	    this.nativeContext = value;
	  };

	  CVContextData.prototype.fillStyle = function (value) {
	    if (this.stack[this.cArrPos].fillStyle !== value) {
	      this.currentFillStyle = value;
	      this.stack[this.cArrPos].fillStyle = value;
	    }
	  };

	  CVContextData.prototype.strokeStyle = function (value) {
	    if (this.stack[this.cArrPos].strokeStyle !== value) {
	      this.currentStrokeStyle = value;
	      this.stack[this.cArrPos].strokeStyle = value;
	    }
	  };

	  CVContextData.prototype.lineWidth = function (value) {
	    if (this.stack[this.cArrPos].lineWidth !== value) {
	      this.currentLineWidth = value;
	      this.stack[this.cArrPos].lineWidth = value;
	    }
	  };

	  CVContextData.prototype.lineCap = function (value) {
	    if (this.stack[this.cArrPos].lineCap !== value) {
	      this.currentLineCap = value;
	      this.stack[this.cArrPos].lineCap = value;
	    }
	  };

	  CVContextData.prototype.lineJoin = function (value) {
	    if (this.stack[this.cArrPos].lineJoin !== value) {
	      this.currentLineJoin = value;
	      this.stack[this.cArrPos].lineJoin = value;
	    }
	  };

	  CVContextData.prototype.miterLimit = function (value) {
	    if (this.stack[this.cArrPos].miterLimit !== value) {
	      this.currentMiterLimit = value;
	      this.stack[this.cArrPos].miterLimit = value;
	    }
	  };

	  CVContextData.prototype.transform = function (props) {
	    this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms

	    var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations

	    this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform

	    currentTransform.cloneFromProps(this.transformMat.props);
	    var trProps = currentTransform.props; // Applying the new transform to the canvas

	    this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
	  };

	  CVContextData.prototype.opacity = function (op) {
	    var currentOpacity = this.stack[this.cArrPos].opacity;
	    currentOpacity *= op < 0 ? 0 : op;

	    if (this.stack[this.cArrPos].opacity !== currentOpacity) {
	      if (this.currentOpacity !== op) {
	        this.nativeContext.globalAlpha = op;
	        this.currentOpacity = op;
	      }

	      this.stack[this.cArrPos].opacity = currentOpacity;
	    }
	  };

	  CVContextData.prototype.fill = function (rule) {
	    if (this.appliedFillStyle !== this.currentFillStyle) {
	      this.appliedFillStyle = this.currentFillStyle;
	      this.nativeContext.fillStyle = this.appliedFillStyle;
	    }

	    this.nativeContext.fill(rule);
	  };

	  CVContextData.prototype.fillRect = function (x, y, w, h) {
	    if (this.appliedFillStyle !== this.currentFillStyle) {
	      this.appliedFillStyle = this.currentFillStyle;
	      this.nativeContext.fillStyle = this.appliedFillStyle;
	    }

	    this.nativeContext.fillRect(x, y, w, h);
	  };

	  CVContextData.prototype.stroke = function () {
	    if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
	      this.appliedStrokeStyle = this.currentStrokeStyle;
	      this.nativeContext.strokeStyle = this.appliedStrokeStyle;
	    }

	    if (this.appliedLineWidth !== this.currentLineWidth) {
	      this.appliedLineWidth = this.currentLineWidth;
	      this.nativeContext.lineWidth = this.appliedLineWidth;
	    }

	    if (this.appliedLineCap !== this.currentLineCap) {
	      this.appliedLineCap = this.currentLineCap;
	      this.nativeContext.lineCap = this.appliedLineCap;
	    }

	    if (this.appliedLineJoin !== this.currentLineJoin) {
	      this.appliedLineJoin = this.currentLineJoin;
	      this.nativeContext.lineJoin = this.appliedLineJoin;
	    }

	    if (this.appliedMiterLimit !== this.currentMiterLimit) {
	      this.appliedMiterLimit = this.currentMiterLimit;
	      this.nativeContext.miterLimit = this.appliedMiterLimit;
	    }

	    this.nativeContext.stroke();
	  };

	  function CVCompElement(data, globalData, comp) {
	    this.completeLayers = false;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = createSizedArray(this.layers.length);
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }

	  extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);

	  CVCompElement.prototype.renderInnerContent = function () {
	    var ctx = this.canvasContext;
	    ctx.beginPath();
	    ctx.moveTo(0, 0);
	    ctx.lineTo(this.data.w, 0);
	    ctx.lineTo(this.data.w, this.data.h);
	    ctx.lineTo(0, this.data.h);
	    ctx.lineTo(0, 0);
	    ctx.clip();
	    var i;
	    var len = this.layers.length;

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].renderFrame();
	      }
	    }
	  };

	  CVCompElement.prototype.destroy = function () {
	    var i;
	    var len = this.layers.length;

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.elements[i]) {
	        this.elements[i].destroy();
	      }
	    }

	    this.layers = null;
	    this.elements = null;
	  };

	  CVCompElement.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	  };

	  function CanvasRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.renderConfig = {
	      clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
	      context: config && config.context || null,
	      progressiveLoad: config && config.progressiveLoad || false,
	      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      contentVisibility: config && config.contentVisibility || 'visible',
	      className: config && config.className || '',
	      id: config && config.id || '',
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.renderConfig.dpr = config && config.dpr || 1;

	    if (this.animationItem.wrapper) {
	      this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
	    }

	    this.renderedFrame = -1;
	    this.globalData = {
	      frameNum: -1,
	      _mdf: false,
	      renderConfig: this.renderConfig,
	      currentGlobalAlpha: -1
	    };
	    this.contextData = new CVContextData();
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	    this.rendererType = 'canvas';

	    if (this.renderConfig.clearCanvas) {
	      this.ctxTransform = this.contextData.transform.bind(this.contextData);
	      this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
	      this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
	      this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
	      this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
	      this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
	      this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
	      this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
	      this.ctxFill = this.contextData.fill.bind(this.contextData);
	      this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
	      this.ctxStroke = this.contextData.stroke.bind(this.contextData);
	      this.save = this.contextData.save.bind(this.contextData);
	    }
	  }

	  extendPrototype([CanvasRendererBase], CanvasRenderer);

	  CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	  };

	  function HBaseElement() {}

	  HBaseElement.prototype = {
	    checkBlendMode: function checkBlendMode() {},
	    initRendererElement: function initRendererElement() {
	      this.baseElement = createTag(this.data.tg || 'div');

	      if (this.data.hasMask) {
	        this.svgElement = createNS('svg');
	        this.layerElement = createNS('g');
	        this.maskedElement = this.layerElement;
	        this.svgElement.appendChild(this.layerElement);
	        this.baseElement.appendChild(this.svgElement);
	      } else {
	        this.layerElement = this.baseElement;
	      }

	      styleDiv(this.baseElement);
	    },
	    createContainerElements: function createContainerElements() {
	      this.renderableEffectsManager = new CVEffects(this);
	      this.transformedElement = this.baseElement;
	      this.maskedElement = this.layerElement;

	      if (this.data.ln) {
	        this.layerElement.setAttribute('id', this.data.ln);
	      }

	      if (this.data.cl) {
	        this.layerElement.setAttribute('class', this.data.cl);
	      }

	      if (this.data.bm !== 0) {
	        this.setBlendMode();
	      }
	    },
	    renderElement: function renderElement() {
	      var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};

	      if (this.finalTransform._matMdf) {
	        var matrixValue = this.finalTransform.mat.toCSS();
	        transformedElementStyle.transform = matrixValue;
	        transformedElementStyle.webkitTransform = matrixValue;
	      }

	      if (this.finalTransform._opMdf) {
	        transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
	      }
	    },
	    renderFrame: function renderFrame() {
	      // If it is exported as hidden (data.hd === true) no need to render
	      // If it is not visible no need to render
	      if (this.data.hd || this.hidden) {
	        return;
	      }

	      this.renderTransform();
	      this.renderRenderable();
	      this.renderElement();
	      this.renderInnerContent();

	      if (this._isFirstFrame) {
	        this._isFirstFrame = false;
	      }
	    },
	    destroy: function destroy() {
	      this.layerElement = null;
	      this.transformedElement = null;

	      if (this.matteElement) {
	        this.matteElement = null;
	      }

	      if (this.maskManager) {
	        this.maskManager.destroy();
	        this.maskManager = null;
	      }
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    addEffects: function addEffects() {},
	    setMatte: function setMatte() {}
	  };
	  HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
	  HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
	  HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;

	  function HSolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);

	  HSolidElement.prototype.createContent = function () {
	    var rect;

	    if (this.data.hasMask) {
	      rect = createNS('rect');
	      rect.setAttribute('width', this.data.sw);
	      rect.setAttribute('height', this.data.sh);
	      rect.setAttribute('fill', this.data.sc);
	      this.svgElement.setAttribute('width', this.data.sw);
	      this.svgElement.setAttribute('height', this.data.sh);
	    } else {
	      rect = createTag('div');
	      rect.style.width = this.data.sw + 'px';
	      rect.style.height = this.data.sh + 'px';
	      rect.style.backgroundColor = this.data.sc;
	    }

	    this.layerElement.appendChild(rect);
	  };

	  function HShapeElement(data, globalData, comp) {
	    // List of drawable elements
	    this.shapes = []; // Full shape data

	    this.shapesData = data.shapes; // List of styles that will be applied to shapes

	    this.stylesList = []; // List of modifiers that will be applied to shapes

	    this.shapeModifiers = []; // List of items in shape tree

	    this.itemsData = []; // List of items in previous shape tree

	    this.processedElements = []; // List of animated components

	    this.animatedContents = [];
	    this.shapesContainer = createNS('g');
	    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created

	    this.prevViewData = [];
	    this.currentBBox = {
	      x: 999999,
	      y: -999999,
	      h: 0,
	      w: 0
	    };
	  }

	  extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
	  HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

	  HShapeElement.prototype.createContent = function () {
	    var cont;
	    this.baseElement.style.fontSize = 0;

	    if (this.data.hasMask) {
	      this.layerElement.appendChild(this.shapesContainer);
	      cont = this.svgElement;
	    } else {
	      cont = createNS('svg');
	      var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	      cont.setAttribute('width', size.w);
	      cont.setAttribute('height', size.h);
	      cont.appendChild(this.shapesContainer);
	      this.layerElement.appendChild(cont);
	    }

	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
	    this.filterUniqueShapes();
	    this.shapeCont = cont;
	  };

	  HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
	    var i;
	    var len = transformers.length;

	    for (i = 0; i < len; i += 1) {
	      point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
	    }

	    return point;
	  };

	  HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
	    var shape = item.sh.v;
	    var transformers = item.transformers;
	    var i;
	    var len = shape._length;
	    var vPoint;
	    var oPoint;
	    var nextIPoint;
	    var nextVPoint;

	    if (len <= 1) {
	      return;
	    }

	    for (i = 0; i < len - 1; i += 1) {
	      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	      nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
	      nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
	      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }

	    if (shape.c) {
	      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	      nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
	      nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
	      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	  };

	  HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
	    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
	    var bounds = this.shapeBoundingBox;
	    boundingBox.x = bmMin(bounds.left, boundingBox.x);
	    boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
	    boundingBox.y = bmMin(bounds.top, boundingBox.y);
	    boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
	  };

	  HShapeElement.prototype.shapeBoundingBox = {
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0
	  };
	  HShapeElement.prototype.tempBoundingBox = {
	    x: 0,
	    xMax: 0,
	    y: 0,
	    yMax: 0,
	    width: 0,
	    height: 0
	  };

	  HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
	    var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];

	    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
	      // eslint-disable-line no-plusplus
	      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	      c = 3 * p1[i] - 3 * p0[i];
	      b |= 0; // eslint-disable-line no-bitwise

	      a |= 0; // eslint-disable-line no-bitwise

	      c |= 0; // eslint-disable-line no-bitwise

	      if (a === 0 && b === 0) ; else if (a === 0) {
	        t = -c / b;

	        if (t > 0 && t < 1) {
	          bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
	        }
	      } else {
	        b2ac = b * b - 4 * c * a;

	        if (b2ac >= 0) {
	          t1 = (-b + bmSqrt(b2ac)) / (2 * a);
	          if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
	          t2 = (-b - bmSqrt(b2ac)) / (2 * a);
	          if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
	        }
	      }
	    }

	    this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
	    this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
	    this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
	    this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
	  };

	  HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
	    return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
	  };

	  HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
	    var i;
	    var len = itemsData.length;

	    for (i = 0; i < len; i += 1) {
	      if (itemsData[i] && itemsData[i].sh) {
	        this.calculateShapeBoundingBox(itemsData[i], boundingBox);
	      } else if (itemsData[i] && itemsData[i].it) {
	        this.calculateBoundingBox(itemsData[i].it, boundingBox);
	      } else if (itemsData[i] && itemsData[i].style && itemsData[i].w) {
	        this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
	      }
	    }
	  };

	  HShapeElement.prototype.expandStrokeBoundingBox = function (widthProperty, boundingBox) {
	    var width = 0;

	    if (widthProperty.keyframes) {
	      for (var i = 0; i < widthProperty.keyframes.length; i += 1) {
	        var kfw = widthProperty.keyframes[i].s;

	        if (kfw > width) {
	          width = kfw;
	        }
	      }

	      width *= widthProperty.mult;
	    } else {
	      width = widthProperty.v * widthProperty.mult;
	    }

	    boundingBox.x -= width;
	    boundingBox.xMax += width;
	    boundingBox.y -= width;
	    boundingBox.yMax += width;
	  };

	  HShapeElement.prototype.currentBoxContains = function (box) {
	    return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
	  };

	  HShapeElement.prototype.renderInnerContent = function () {
	    this._renderShapeFrame();

	    if (!this.hidden && (this._isFirstFrame || this._mdf)) {
	      var tempBoundingBox = this.tempBoundingBox;
	      var max = 999999;
	      tempBoundingBox.x = max;
	      tempBoundingBox.xMax = -max;
	      tempBoundingBox.y = max;
	      tempBoundingBox.yMax = -max;
	      this.calculateBoundingBox(this.itemsData, tempBoundingBox);
	      tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
	      tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();

	      if (this.currentBoxContains(tempBoundingBox)) {
	        return;
	      }

	      var changed = false;

	      if (this.currentBBox.w !== tempBoundingBox.width) {
	        this.currentBBox.w = tempBoundingBox.width;
	        this.shapeCont.setAttribute('width', tempBoundingBox.width);
	        changed = true;
	      }

	      if (this.currentBBox.h !== tempBoundingBox.height) {
	        this.currentBBox.h = tempBoundingBox.height;
	        this.shapeCont.setAttribute('height', tempBoundingBox.height);
	        changed = true;
	      }

	      if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
	        this.currentBBox.w = tempBoundingBox.width;
	        this.currentBBox.h = tempBoundingBox.height;
	        this.currentBBox.x = tempBoundingBox.x;
	        this.currentBBox.y = tempBoundingBox.y;
	        this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
	        var shapeStyle = this.shapeCont.style;
	        var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        shapeStyle.transform = shapeTransform;
	        shapeStyle.webkitTransform = shapeTransform;
	      }
	    }
	  };

	  function HTextElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	      x: 999999,
	      y: -999999,
	      h: 0,
	      w: 0
	    };
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);

	  HTextElement.prototype.createContent = function () {
	    this.isMasked = this.checkMasks();

	    if (this.isMasked) {
	      this.renderType = 'svg';
	      this.compW = this.comp.data.w;
	      this.compH = this.comp.data.h;
	      this.svgElement.setAttribute('width', this.compW);
	      this.svgElement.setAttribute('height', this.compH);
	      var g = createNS('g');
	      this.maskedElement.appendChild(g);
	      this.innerElem = g;
	    } else {
	      this.renderType = 'html';
	      this.innerElem = this.layerElement;
	    }

	    this.checkParenting();
	  };

	  HTextElement.prototype.buildNewText = function () {
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var innerElemStyle = this.innerElem.style;
	    var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    innerElemStyle.fill = textColor;
	    innerElemStyle.color = textColor;

	    if (documentData.sc) {
	      innerElemStyle.stroke = this.buildColor(documentData.sc);
	      innerElemStyle.strokeWidth = documentData.sw + 'px';
	    }

	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

	    if (!this.globalData.fontManager.chars) {
	      innerElemStyle.fontSize = documentData.finalSize + 'px';
	      innerElemStyle.lineHeight = documentData.finalSize + 'px';

	      if (fontData.fClass) {
	        this.innerElem.className = fontData.fClass;
	      } else {
	        innerElemStyle.fontFamily = fontData.fFamily;
	        var fWeight = documentData.fWeight;
	        var fStyle = documentData.fStyle;
	        innerElemStyle.fontStyle = fStyle;
	        innerElemStyle.fontWeight = fWeight;
	      }
	    }

	    var i;
	    var len;
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan;
	    var tParent;
	    var tCont;
	    var matrixHelper = this.mHelper;
	    var shapes;
	    var shapeStr = '';
	    var cnt = 0;

	    for (i = 0; i < len; i += 1) {
	      if (this.globalData.fontManager.chars) {
	        if (!this.textPaths[cnt]) {
	          tSpan = createNS('path');
	          tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
	          tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
	          tSpan.setAttribute('stroke-miterlimit', '4');
	        } else {
	          tSpan = this.textPaths[cnt];
	        }

	        if (!this.isMasked) {
	          if (this.textSpans[cnt]) {
	            tParent = this.textSpans[cnt];
	            tCont = tParent.children[0];
	          } else {
	            tParent = createTag('div');
	            tParent.style.lineHeight = 0;
	            tCont = createNS('svg');
	            tCont.appendChild(tSpan);
	            styleDiv(tParent);
	          }
	        }
	      } else if (!this.isMasked) {
	        if (this.textSpans[cnt]) {
	          tParent = this.textSpans[cnt];
	          tSpan = this.textPaths[cnt];
	        } else {
	          tParent = createTag('span');
	          styleDiv(tParent);
	          tSpan = createTag('span');
	          styleDiv(tSpan);
	          tParent.appendChild(tSpan);
	        }
	      } else {
	        tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	      } // tSpan.setAttribute('visibility', 'hidden');


	      if (this.globalData.fontManager.chars) {
	        var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        var shapeData;

	        if (charData) {
	          shapeData = charData.data;
	        } else {
	          shapeData = null;
	        }

	        matrixHelper.reset();

	        if (shapeData && shapeData.shapes && shapeData.shapes.length) {
	          shapes = shapeData.shapes[0].it;
	          matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	          shapeStr = this.createPathShape(matrixHelper, shapes);
	          tSpan.setAttribute('d', shapeStr);
	        }

	        if (!this.isMasked) {
	          this.innerElem.appendChild(tParent);

	          if (shapeData && shapeData.shapes) {
	            // document.body.appendChild is needed to get exact measure of shape
	            document.body.appendChild(tCont);
	            var boundingBox = tCont.getBBox();
	            tCont.setAttribute('width', boundingBox.width + 2);
	            tCont.setAttribute('height', boundingBox.height + 2);
	            tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
	            var tContStyle = tCont.style;
	            var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
	            tContStyle.transform = tContTranslation;
	            tContStyle.webkitTransform = tContTranslation;
	            letters[i].yOffset = boundingBox.y - 1;
	          } else {
	            tCont.setAttribute('width', 1);
	            tCont.setAttribute('height', 1);
	          }

	          tParent.appendChild(tCont);
	        } else {
	          this.innerElem.appendChild(tSpan);
	        }
	      } else {
	        tSpan.textContent = letters[i].val;
	        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');

	        if (!this.isMasked) {
	          this.innerElem.appendChild(tParent); //

	          var tStyle = tSpan.style;
	          var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
	          tStyle.transform = tSpanTranslation;
	          tStyle.webkitTransform = tSpanTranslation;
	        } else {
	          this.innerElem.appendChild(tSpan);
	        }
	      } //


	      if (!this.isMasked) {
	        this.textSpans[cnt] = tParent;
	      } else {
	        this.textSpans[cnt] = tSpan;
	      }

	      this.textSpans[cnt].style.display = 'block';
	      this.textPaths[cnt] = tSpan;
	      cnt += 1;
	    }

	    while (cnt < this.textSpans.length) {
	      this.textSpans[cnt].style.display = 'none';
	      cnt += 1;
	    }
	  };

	  HTextElement.prototype.renderInnerContent = function () {
	    this.validateText();
	    var svgStyle;

	    if (this.data.singleShape) {
	      if (!this._isFirstFrame && !this.lettersChangedFlag) {
	        return;
	      }

	      if (this.isMasked && this.finalTransform._matMdf) {
	        // Todo Benchmark if using this is better than getBBox
	        this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
	        svgStyle = this.svgElement.style;
	        var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	        svgStyle.transform = translation;
	        svgStyle.webkitTransform = translation;
	      }
	    }

	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

	    if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
	      return;
	    }

	    var i;
	    var len;
	    var count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	    var letters = this.textProperty.currentData.l;
	    len = letters.length;
	    var renderedLetter;
	    var textSpan;
	    var textPath;

	    for (i = 0; i < len; i += 1) {
	      if (letters[i].n) {
	        count += 1;
	      } else {
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;

	        if (renderedLetter._mdf.m) {
	          if (!this.isMasked) {
	            textSpan.style.webkitTransform = renderedLetter.m;
	            textSpan.style.transform = renderedLetter.m;
	          } else {
	            textSpan.setAttribute('transform', renderedLetter.m);
	          }
	        } /// /textSpan.setAttribute('opacity',renderedLetter.o);


	        textSpan.style.opacity = renderedLetter.o;

	        if (renderedLetter.sw && renderedLetter._mdf.sw) {
	          textPath.setAttribute('stroke-width', renderedLetter.sw);
	        }

	        if (renderedLetter.sc && renderedLetter._mdf.sc) {
	          textPath.setAttribute('stroke', renderedLetter.sc);
	        }

	        if (renderedLetter.fc && renderedLetter._mdf.fc) {
	          textPath.setAttribute('fill', renderedLetter.fc);
	          textPath.style.color = renderedLetter.fc;
	        }
	      }
	    }

	    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
	      var boundingBox = this.innerElem.getBBox();

	      if (this.currentBBox.w !== boundingBox.width) {
	        this.currentBBox.w = boundingBox.width;
	        this.svgElement.setAttribute('width', boundingBox.width);
	      }

	      if (this.currentBBox.h !== boundingBox.height) {
	        this.currentBBox.h = boundingBox.height;
	        this.svgElement.setAttribute('height', boundingBox.height);
	      }

	      var margin = 1;

	      if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
	        this.currentBBox.w = boundingBox.width + margin * 2;
	        this.currentBBox.h = boundingBox.height + margin * 2;
	        this.currentBBox.x = boundingBox.x - margin;
	        this.currentBBox.y = boundingBox.y - margin;
	        this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
	        svgStyle = this.svgElement.style;
	        var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        svgStyle.transform = svgTransform;
	        svgStyle.webkitTransform = svgTransform;
	      }
	    }
	  };

	  function HCameraElement(data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initHierarchy();
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this, data.pe, 0, 0, this);

	    if (data.ks.p.s) {
	      this.px = getProp(this, data.ks.p.x, 1, 0, this);
	      this.py = getProp(this, data.ks.p.y, 1, 0, this);
	      this.pz = getProp(this, data.ks.p.z, 1, 0, this);
	    } else {
	      this.p = getProp(this, data.ks.p, 1, 0, this);
	    }

	    if (data.ks.a) {
	      this.a = getProp(this, data.ks.a, 1, 0, this);
	    }

	    if (data.ks.or.k.length && data.ks.or.k[0].to) {
	      var i;
	      var len = data.ks.or.k.length;

	      for (i = 0; i < len; i += 1) {
	        data.ks.or.k[i].to = null;
	        data.ks.or.k[i].ti = null;
	      }
	    }

	    this.or = getProp(this, data.ks.or, 1, degToRads, this);
	    this.or.sh = true;
	    this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
	    this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
	    this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
	    this.mat = new Matrix();
	    this._prevMat = new Matrix();
	    this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.

	    this.finalTransform = {
	      mProp: this
	    };
	  }

	  extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

	  HCameraElement.prototype.setup = function () {
	    var i;
	    var len = this.comp.threeDElements.length;
	    var comp;
	    var perspectiveStyle;
	    var containerStyle;

	    for (i = 0; i < len; i += 1) {
	      // [perspectiveElem,container]
	      comp = this.comp.threeDElements[i];

	      if (comp.type === '3d') {
	        perspectiveStyle = comp.perspectiveElem.style;
	        containerStyle = comp.container.style;
	        var perspective = this.pe.v + 'px';
	        var origin = '0px 0px 0px';
	        var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	        perspectiveStyle.perspective = perspective;
	        perspectiveStyle.webkitPerspective = perspective;
	        containerStyle.transformOrigin = origin;
	        containerStyle.mozTransformOrigin = origin;
	        containerStyle.webkitTransformOrigin = origin;
	        perspectiveStyle.transform = matrix;
	        perspectiveStyle.webkitTransform = matrix;
	      }
	    }
	  };

	  HCameraElement.prototype.createElements = function () {};

	  HCameraElement.prototype.hide = function () {};

	  HCameraElement.prototype.renderFrame = function () {
	    var _mdf = this._isFirstFrame;
	    var i;
	    var len;

	    if (this.hierarchy) {
	      len = this.hierarchy.length;

	      for (i = 0; i < len; i += 1) {
	        _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
	      }
	    }

	    if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
	      this.mat.reset();

	      if (this.hierarchy) {
	        len = this.hierarchy.length - 1;

	        for (i = len; i >= 0; i -= 1) {
	          var mTransf = this.hierarchy[i].finalTransform.mProp;
	          this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
	          this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
	          this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
	          this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
	          this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
	        }
	      }

	      if (this.p) {
	        this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
	      } else {
	        this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
	      }

	      if (this.a) {
	        var diffVector;

	        if (this.p) {
	          diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
	        } else {
	          diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
	        }

	        var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));

	        var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
	        var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
	        var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
	        var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
	        this.mat.rotateY(mRotationY).rotateX(-mRotationX);
	      }

	      this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	      this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	      this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
	      this.mat.translate(0, 0, this.pe.v);
	      var hasMatrixChanged = !this._prevMat.equals(this.mat);

	      if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
	        len = this.comp.threeDElements.length;
	        var comp;
	        var perspectiveStyle;
	        var containerStyle;

	        for (i = 0; i < len; i += 1) {
	          comp = this.comp.threeDElements[i];

	          if (comp.type === '3d') {
	            if (hasMatrixChanged) {
	              var matValue = this.mat.toCSS();
	              containerStyle = comp.container.style;
	              containerStyle.transform = matValue;
	              containerStyle.webkitTransform = matValue;
	            }

	            if (this.pe._mdf) {
	              perspectiveStyle = comp.perspectiveElem.style;
	              perspectiveStyle.perspective = this.pe.v + 'px';
	              perspectiveStyle.webkitPerspective = this.pe.v + 'px';
	            }
	          }
	        }

	        this.mat.clone(this._prevMat);
	      }
	    }

	    this._isFirstFrame = false;
	  };

	  HCameraElement.prototype.prepareFrame = function (num) {
	    this.prepareProperties(num, true);
	  };

	  HCameraElement.prototype.destroy = function () {};

	  HCameraElement.prototype.getBaseElement = function () {
	    return null;
	  };

	  function HImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);

	  HImageElement.prototype.createContent = function () {
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();

	    if (this.data.hasMask) {
	      this.imageElem = createNS('image');
	      this.imageElem.setAttribute('width', this.assetData.w + 'px');
	      this.imageElem.setAttribute('height', this.assetData.h + 'px');
	      this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
	      this.layerElement.appendChild(this.imageElem);
	      this.baseElement.setAttribute('width', this.assetData.w);
	      this.baseElement.setAttribute('height', this.assetData.h);
	    } else {
	      this.layerElement.appendChild(img);
	    }

	    img.crossOrigin = 'anonymous';
	    img.src = assetPath;

	    if (this.data.ln) {
	      this.baseElement.setAttribute('id', this.data.ln);
	    }
	  };

	  function HybridRendererBase(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	      className: config && config.className || '',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '400%',
	        height: config && config.filterSize && config.filterSize.height || '400%',
	        x: config && config.filterSize && config.filterSize.x || '-100%',
	        y: config && config.filterSize && config.filterSize.y || '-100%'
	      }
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	  }

	  extendPrototype([BaseRenderer], HybridRendererBase);
	  HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;

	  HybridRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	    }
	  };

	  HybridRendererBase.prototype.appendElementInPos = function (element, pos) {
	    var newDOMElement = element.getBaseElement();

	    if (!newDOMElement) {
	      return;
	    }

	    var layer = this.layers[pos];

	    if (!layer.ddd || !this.supports3d) {
	      if (this.threeDElements) {
	        this.addTo3dContainer(newDOMElement, pos);
	      } else {
	        var i = 0;
	        var nextDOMElement;
	        var nextLayer;
	        var tmpDOMElement;

	        while (i < pos) {
	          if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
	            nextLayer = this.elements[i];
	            tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	            nextDOMElement = tmpDOMElement || nextDOMElement;
	          }

	          i += 1;
	        }

	        if (nextDOMElement) {
	          if (!layer.ddd || !this.supports3d) {
	            this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	          }
	        } else if (!layer.ddd || !this.supports3d) {
	          this.layerElement.appendChild(newDOMElement);
	        }
	      }
	    } else {
	      this.addTo3dContainer(newDOMElement, pos);
	    }
	  };

	  HybridRendererBase.prototype.createShape = function (data) {
	    if (!this.supports3d) {
	      return new SVGShapeElement(data, this.globalData, this);
	    }

	    return new HShapeElement(data, this.globalData, this);
	  };

	  HybridRendererBase.prototype.createText = function (data) {
	    if (!this.supports3d) {
	      return new SVGTextLottieElement(data, this.globalData, this);
	    }

	    return new HTextElement(data, this.globalData, this);
	  };

	  HybridRendererBase.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.globalData, this);
	    return this.camera;
	  };

	  HybridRendererBase.prototype.createImage = function (data) {
	    if (!this.supports3d) {
	      return new IImageElement(data, this.globalData, this);
	    }

	    return new HImageElement(data, this.globalData, this);
	  };

	  HybridRendererBase.prototype.createSolid = function (data) {
	    if (!this.supports3d) {
	      return new ISolidElement(data, this.globalData, this);
	    }

	    return new HSolidElement(data, this.globalData, this);
	  };

	  HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;

	  HybridRendererBase.prototype.getThreeDContainerByPos = function (pos) {
	    var i = 0;
	    var len = this.threeDElements.length;

	    while (i < len) {
	      if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	        return this.threeDElements[i].perspectiveElem;
	      }

	      i += 1;
	    }

	    return null;
	  };

	  HybridRendererBase.prototype.createThreeDContainer = function (pos, type) {
	    var perspectiveElem = createTag('div');
	    var style;
	    var containerStyle;
	    styleDiv(perspectiveElem);
	    var container = createTag('div');
	    styleDiv(container);

	    if (type === '3d') {
	      style = perspectiveElem.style;
	      style.width = this.globalData.compSize.w + 'px';
	      style.height = this.globalData.compSize.h + 'px';
	      var center = '50% 50%';
	      style.webkitTransformOrigin = center;
	      style.mozTransformOrigin = center;
	      style.transformOrigin = center;
	      containerStyle = container.style;
	      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	      containerStyle.transform = matrix;
	      containerStyle.webkitTransform = matrix;
	    }

	    perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);

	    var threeDContainerData = {
	      container: container,
	      perspectiveElem: perspectiveElem,
	      startPos: pos,
	      endPos: pos,
	      type: type
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	  };

	  HybridRendererBase.prototype.build3dContainers = function () {
	    var i;
	    var len = this.layers.length;
	    var lastThreeDContainerData;
	    var currentContainer = '';

	    for (i = 0; i < len; i += 1) {
	      if (this.layers[i].ddd && this.layers[i].ty !== 3) {
	        if (currentContainer !== '3d') {
	          currentContainer = '3d';
	          lastThreeDContainerData = this.createThreeDContainer(i, '3d');
	        }

	        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
	      } else {
	        if (currentContainer !== '2d') {
	          currentContainer = '2d';
	          lastThreeDContainerData = this.createThreeDContainer(i, '2d');
	        }

	        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
	      }
	    }

	    len = this.threeDElements.length;

	    for (i = len - 1; i >= 0; i -= 1) {
	      this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
	    }
	  };

	  HybridRendererBase.prototype.addTo3dContainer = function (elem, pos) {
	    var i = 0;
	    var len = this.threeDElements.length;

	    while (i < len) {
	      if (pos <= this.threeDElements[i].endPos) {
	        var j = this.threeDElements[i].startPos;
	        var nextElement;

	        while (j < pos) {
	          if (this.elements[j] && this.elements[j].getBaseElement) {
	            nextElement = this.elements[j].getBaseElement();
	          }

	          j += 1;
	        }

	        if (nextElement) {
	          this.threeDElements[i].container.insertBefore(elem, nextElement);
	        } else {
	          this.threeDElements[i].container.appendChild(elem);
	        }

	        break;
	      }

	      i += 1;
	    }
	  };

	  HybridRendererBase.prototype.configAnimation = function (animData) {
	    var resizerElem = createTag('div');
	    var wrapper = this.animationItem.wrapper;
	    var style = resizerElem.style;
	    style.width = animData.w + 'px';
	    style.height = animData.h + 'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    style.transformStyle = 'flat';
	    style.mozTransformStyle = 'flat';
	    style.webkitTransformStyle = 'flat';

	    if (this.renderConfig.className) {
	      resizerElem.setAttribute('class', this.renderConfig.className);
	    }

	    wrapper.appendChild(resizerElem);
	    style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width', '1');
	    svg.setAttribute('height', '1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.data = animData; // Mask animation

	    this.setupGlobalData(animData, svg);
	    this.globalData.defs = defs;
	    this.layers = animData.layers;
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	  };

	  HybridRendererBase.prototype.destroy = function () {
	    if (this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }

	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i;
	    var len = this.layers ? this.layers.length : 0;

	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }

	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	  };

	  HybridRendererBase.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth / elementHeight;
	    var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
	    var sx;
	    var sy;
	    var tx;
	    var ty;

	    if (animationRel > elementRel) {
	      sx = elementWidth / this.globalData.compSize.w;
	      sy = elementWidth / this.globalData.compSize.w;
	      tx = 0;
	      ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
	    } else {
	      sx = elementHeight / this.globalData.compSize.h;
	      sy = elementHeight / this.globalData.compSize.h;
	      tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
	      ty = 0;
	    }

	    var style = this.resizerElem.style;
	    style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
	    style.transform = style.webkitTransform;
	  };

	  HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

	  HybridRendererBase.prototype.hide = function () {
	    this.resizerElem.style.display = 'none';
	  };

	  HybridRendererBase.prototype.show = function () {
	    this.resizerElem.style.display = 'block';
	  };

	  HybridRendererBase.prototype.initItems = function () {
	    this.buildAllItems();

	    if (this.camera) {
	      this.camera.setup();
	    } else {
	      var cWidth = this.globalData.compSize.w;
	      var cHeight = this.globalData.compSize.h;
	      var i;
	      var len = this.threeDElements.length;

	      for (i = 0; i < len; i += 1) {
	        var style = this.threeDElements[i].perspectiveElem.style;
	        style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
	        style.perspective = style.webkitPerspective;
	      }
	    }
	  };

	  HybridRendererBase.prototype.searchExtraCompositions = function (assets) {
	    var i;
	    var len = assets.length;
	    var floatingContainer = createTag('div');

	    for (i = 0; i < len; i += 1) {
	      if (assets[i].xt) {
	        var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
	        comp.initExpressions();
	        this.globalData.projectInterface.registerComposition(comp);
	      }
	    }
	  };

	  function HCompElement(data, globalData, comp) {
	    this.layers = data.layers;
	    this.supports3d = !data.hasMask;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }

	  extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement);
	  HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

	  HCompElement.prototype.createContainerElements = function () {
	    this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';


	    if (this.data.hasMask) {
	      this.svgElement.setAttribute('width', this.data.w);
	      this.svgElement.setAttribute('height', this.data.h);
	      this.transformedElement = this.baseElement;
	    } else {
	      this.transformedElement = this.layerElement;
	    }
	  };

	  HCompElement.prototype.addTo3dContainer = function (elem, pos) {
	    var j = 0;
	    var nextElement;

	    while (j < pos) {
	      if (this.elements[j] && this.elements[j].getBaseElement) {
	        nextElement = this.elements[j].getBaseElement();
	      }

	      j += 1;
	    }

	    if (nextElement) {
	      this.layerElement.insertBefore(elem, nextElement);
	    } else {
	      this.layerElement.appendChild(elem);
	    }
	  };

	  HCompElement.prototype.createComp = function (data) {
	    if (!this.supports3d) {
	      return new SVGCompElement(data, this.globalData, this);
	    }

	    return new HCompElement(data, this.globalData, this);
	  };

	  function HybridRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	      className: config && config.className || '',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '400%',
	        height: config && config.filterSize && config.filterSize.height || '400%',
	        x: config && config.filterSize && config.filterSize.x || '-100%',
	        y: config && config.filterSize && config.filterSize.y || '-100%'
	      },
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	  }

	  extendPrototype([HybridRendererBase], HybridRenderer);

	  HybridRenderer.prototype.createComp = function (data) {
	    if (!this.supports3d) {
	      return new SVGCompElement(data, this.globalData, this);
	    }

	    return new HCompElement(data, this.globalData, this);
	  };

	  var CompExpressionInterface = function () {
	    return function (comp) {
	      function _thisLayerFunction(name) {
	        var i = 0;
	        var len = comp.layers.length;

	        while (i < len) {
	          if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
	            return comp.elements[i].layerInterface;
	          }

	          i += 1;
	        }

	        return null; // return {active:false};
	      }

	      Object.defineProperty(_thisLayerFunction, '_name', {
	        value: comp.data.nm
	      });
	      _thisLayerFunction.layer = _thisLayerFunction;
	      _thisLayerFunction.pixelAspect = 1;
	      _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
	      _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
	      _thisLayerFunction.pixelAspect = 1;
	      _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
	      _thisLayerFunction.displayStartTime = 0;
	      _thisLayerFunction.numLayers = comp.layers.length;
	      return _thisLayerFunction;
	    };
	  }();

	  function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

	  /* eslint-disable */

	  /*
	   Copyright 2014 David Bau.

	   Permission is hereby granted, free of charge, to any person obtaining
	   a copy of this software and associated documentation files (the
	   "Software"), to deal in the Software without restriction, including
	   without limitation the rights to use, copy, modify, merge, publish,
	   distribute, sublicense, and/or sell copies of the Software, and to
	   permit persons to whom the Software is furnished to do so, subject to
	   the following conditions:

	   The above copyright notice and this permission notice shall be
	   included in all copies or substantial portions of the Software.

	   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	   */
	  function seedRandom(pool, math) {
	    //
	    // The following constants are related to IEEE 754 limits.
	    //
	    var global = this,
	        width = 256,
	        // each RC4 output is 0 <= x < 256
	    chunks = 6,
	        // at least six RC4 outputs for each double
	    digits = 52,
	        // there are 52 significant digits in a double
	    rngname = 'random',
	        // rngname: name for Math.random and Math.seedrandom
	    startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto; // node.js crypto module, initialized at the bottom.
	    //
	    // seedrandom()
	    // This is the seedrandom function described above.
	    //

	    function seedrandom(seed, options, callback) {
	      var key = [];
	      options = options === true ? {
	        entropy: true
	      } : options || {}; // Flatten the seed string or build one from local entropy if needed.

	      var shortseed = mixkey(flatten(options.entropy ? [seed, tostring(pool)] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.

	      var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
	      // randomness in every bit of the mantissa of the IEEE 754 value.

	      var prng = function prng() {
	        var n = arc4.g(chunks),
	            // Start with a numerator n < 2 ^ 48
	        d = startdenom,
	            //   and denominator d = 2 ^ 48.
	        x = 0; //   and no 'extra last byte'.

	        while (n < significance) {
	          // Fill up all significant digits by
	          n = (n + x) * width; //   shifting numerator and

	          d *= width; //   denominator and generating a

	          x = arc4.g(1); //   new least-significant-byte.
	        }

	        while (n >= overflow) {
	          // To avoid rounding up, before adding
	          n /= 2; //   last byte, shift everything

	          d /= 2; //   right using integer math until

	          x >>>= 1; //   we have exactly the desired bits.
	        }

	        return (n + x) / d; // Form the number within [0, 1).
	      };

	      prng.int32 = function () {
	        return arc4.g(4) | 0;
	      };

	      prng.quick = function () {
	        return arc4.g(4) / 0x100000000;
	      };

	      prng["double"] = prng; // Mix the randomness into accumulated entropy.

	      mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.

	      return (options.pass || callback || function (prng, seed, is_math_call, state) {
	        if (state) {
	          // Load the arc4 state from the given state if it has an S array.
	          if (state.S) {
	            copy(state, arc4);
	          } // Only provide the .state method if requested via options.state.


	          prng.state = function () {
	            return copy(arc4, {});
	          };
	        } // If called as a method of Math (Math.seedrandom()), mutate
	        // Math.random because that is how seedrandom.js has worked since v1.0.


	        if (is_math_call) {
	          math[rngname] = prng;
	          return seed;
	        } // Otherwise, it is a newer calling convention, so return the
	        // prng directly.
	        else return prng;
	      })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
	    }

	    math['seed' + rngname] = seedrandom; //
	    // ARC4
	    //
	    // An ARC4 implementation.  The constructor takes a key in the form of
	    // an array of at most (width) integers that should be 0 <= x < (width).
	    //
	    // The g(count) method returns a pseudorandom integer that concatenates
	    // the next (count) outputs from ARC4.  Its return value is a number x
	    // that is in the range 0 <= x < (width ^ count).
	    //

	    function ARC4(key) {
	      var t,
	          keylen = key.length,
	          me = this,
	          i = 0,
	          j = me.i = me.j = 0,
	          s = me.S = []; // The empty key [] is treated as [0].

	      if (!keylen) {
	        key = [keylen++];
	      } // Set up S using the standard key scheduling algorithm.


	      while (i < width) {
	        s[i] = i++;
	      }

	      for (i = 0; i < width; i++) {
	        s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
	        s[j] = t;
	      } // The "g" method returns the next (count) outputs as one number.


	      me.g = function (count) {
	        // Using instance members instead of closure state nearly doubles speed.
	        var t,
	            r = 0,
	            i = me.i,
	            j = me.j,
	            s = me.S;

	        while (count--) {
	          t = s[i = mask & i + 1];
	          r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
	        }

	        me.i = i;
	        me.j = j;
	        return r; // For robust unpredictability, the function call below automatically
	        // discards an initial batch of values.  This is called RC4-drop[256].
	        // See http://google.com/search?q=rsa+fluhrer+response&btnI
	      };
	    } //
	    // copy()
	    // Copies internal state of ARC4 to or from a plain object.
	    //


	    function copy(f, t) {
	      t.i = f.i;
	      t.j = f.j;
	      t.S = f.S.slice();
	      return t;
	    } //
	    // flatten()
	    // Converts an object tree to nested arrays of strings.
	    //


	    function flatten(obj, depth) {
	      var result = [],
	          typ = _typeof$2(obj),
	          prop;

	      if (depth && typ == 'object') {
	        for (prop in obj) {
	          try {
	            result.push(flatten(obj[prop], depth - 1));
	          } catch (e) {}
	        }
	      }

	      return result.length ? result : typ == 'string' ? obj : obj + '\0';
	    } //
	    // mixkey()
	    // Mixes a string seed into a key that is an array of integers, and
	    // returns a shortened string seed that is equivalent to the result key.
	    //


	    function mixkey(seed, key) {
	      var stringseed = seed + '',
	          smear,
	          j = 0;

	      while (j < stringseed.length) {
	        key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
	      }

	      return tostring(key);
	    } //
	    // autoseed()
	    // Returns an object for autoseeding, using window.crypto and Node crypto
	    // module if available.
	    //


	    function autoseed() {
	      try {
	        if (nodecrypto) ;

	        var out = new Uint8Array(width);
	        (global.crypto || global.msCrypto).getRandomValues(out);
	        return tostring(out);
	      } catch (e) {
	        var browser = global.navigator,
	            plugins = browser && browser.plugins;
	        return [+new Date(), global, plugins, global.screen, tostring(pool)];
	      }
	    } //
	    // tostring()
	    // Converts an array of charcodes to a string
	    //


	    function tostring(a) {
	      return String.fromCharCode.apply(0, a);
	    } //
	    // When seedrandom.js is loaded, we immediately mix a few bits
	    // from the built-in RNG into the entropy pool.  Because we do
	    // not want to interfere with deterministic PRNG state later,
	    // seedrandom will not call math.random on its own again after
	    // initialization.
	    //


	    mixkey(math.random(), pool); //
	    // Nodejs and AMD support: export the implementation as a module using
	    // either convention.
	    //
	    // End anonymous scope, and pass initial values.
	  }

	  function initialize$2(BMMath) {
	    seedRandom([], BMMath);
	  }

	  var propTypes = {
	    SHAPE: 'shape'
	  };

	  function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

	  var ExpressionManager = function () {

	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	    var XMLHttpRequest = null;
	    var fetch = null;
	    var frames = null;
	    var _lottieGlobal = {};
	    initialize$2(BMMath);

	    function resetFrame() {
	      _lottieGlobal = {};
	    }

	    function $bm_isInstanceOfArray(arr) {
	      return arr.constructor === Array || arr.constructor === Float32Array;
	    }

	    function isNumerable(tOfV, v) {
	      return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
	    }

	    function $bm_neg(a) {
	      var tOfA = _typeof$1(a);

	      if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') {
	        return -a;
	      }

	      if ($bm_isInstanceOfArray(a)) {
	        var i;
	        var lenA = a.length;
	        var retArr = [];

	        for (i = 0; i < lenA; i += 1) {
	          retArr[i] = -a[i];
	        }

	        return retArr;
	      }

	      if (a.propType) {
	        return a.v;
	      }

	      return -a;
	    }

	    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
	    var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
	    var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;

	    function sum(a, b) {
	      var tOfA = _typeof$1(a);

	      var tOfB = _typeof$1(b);

	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') {
	        return a + b;
	      }

	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        a = a.slice(0);
	        a[0] += b;
	        return a;
	      }

	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        b = b.slice(0);
	        b[0] = a + b[0];
	        return b;
	      }

	      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
	        var i = 0;
	        var lenA = a.length;
	        var lenB = b.length;
	        var retArr = [];

	        while (i < lenA || i < lenB) {
	          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
	            retArr[i] = a[i] + b[i];
	          } else {
	            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	          }

	          i += 1;
	        }

	        return retArr;
	      }

	      return 0;
	    }

	    var add = sum;

	    function sub(a, b) {
	      var tOfA = _typeof$1(a);

	      var tOfB = _typeof$1(b);

	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        if (tOfA === 'string') {
	          a = parseInt(a, 10);
	        }

	        if (tOfB === 'string') {
	          b = parseInt(b, 10);
	        }

	        return a - b;
	      }

	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        a = a.slice(0);
	        a[0] -= b;
	        return a;
	      }

	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        b = b.slice(0);
	        b[0] = a - b[0];
	        return b;
	      }

	      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
	        var i = 0;
	        var lenA = a.length;
	        var lenB = b.length;
	        var retArr = [];

	        while (i < lenA || i < lenB) {
	          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
	            retArr[i] = a[i] - b[i];
	          } else {
	            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	          }

	          i += 1;
	        }

	        return retArr;
	      }

	      return 0;
	    }

	    function mul(a, b) {
	      var tOfA = _typeof$1(a);

	      var tOfB = _typeof$1(b);

	      var arr;

	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        return a * b;
	      }

	      var i;
	      var len;

	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        len = a.length;
	        arr = createTypedArray('float32', len);

	        for (i = 0; i < len; i += 1) {
	          arr[i] = a[i] * b;
	        }

	        return arr;
	      }

	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        len = b.length;
	        arr = createTypedArray('float32', len);

	        for (i = 0; i < len; i += 1) {
	          arr[i] = a * b[i];
	        }

	        return arr;
	      }

	      return 0;
	    }

	    function div(a, b) {
	      var tOfA = _typeof$1(a);

	      var tOfB = _typeof$1(b);

	      var arr;

	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        return a / b;
	      }

	      var i;
	      var len;

	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        len = a.length;
	        arr = createTypedArray('float32', len);

	        for (i = 0; i < len; i += 1) {
	          arr[i] = a[i] / b;
	        }

	        return arr;
	      }

	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        len = b.length;
	        arr = createTypedArray('float32', len);

	        for (i = 0; i < len; i += 1) {
	          arr[i] = a / b[i];
	        }

	        return arr;
	      }

	      return 0;
	    }

	    function mod(a, b) {
	      if (typeof a === 'string') {
	        a = parseInt(a, 10);
	      }

	      if (typeof b === 'string') {
	        b = parseInt(b, 10);
	      }

	      return a % b;
	    }

	    var $bm_sum = sum;
	    var $bm_sub = sub;
	    var $bm_mul = mul;
	    var $bm_div = div;
	    var $bm_mod = mod;

	    function clamp(num, min, max) {
	      if (min > max) {
	        var mm = max;
	        max = min;
	        min = mm;
	      }

	      return Math.min(Math.max(num, min), max);
	    }

	    function radiansToDegrees(val) {
	      return val / degToRads;
	    }

	    var radians_to_degrees = radiansToDegrees;

	    function degreesToRadians(val) {
	      return val * degToRads;
	    }

	    var degrees_to_radians = radiansToDegrees;
	    var helperLengthArray = [0, 0, 0, 0, 0, 0];

	    function length(arr1, arr2) {
	      if (typeof arr1 === 'number' || arr1 instanceof Number) {
	        arr2 = arr2 || 0;
	        return Math.abs(arr1 - arr2);
	      }

	      if (!arr2) {
	        arr2 = helperLengthArray;
	      }

	      var i;
	      var len = Math.min(arr1.length, arr2.length);
	      var addedLength = 0;

	      for (i = 0; i < len; i += 1) {
	        addedLength += Math.pow(arr2[i] - arr1[i], 2);
	      }

	      return Math.sqrt(addedLength);
	    }

	    function normalize(vec) {
	      return div(vec, length(vec));
	    }

	    function rgbToHsl(val) {
	      var r = val[0];
	      var g = val[1];
	      var b = val[2];
	      var max = Math.max(r, g, b);
	      var min = Math.min(r, g, b);
	      var h;
	      var s;
	      var l = (max + min) / 2;

	      if (max === min) {
	        h = 0; // achromatic

	        s = 0; // achromatic
	      } else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

	        switch (max) {
	          case r:
	            h = (g - b) / d + (g < b ? 6 : 0);
	            break;

	          case g:
	            h = (b - r) / d + 2;
	            break;

	          case b:
	            h = (r - g) / d + 4;
	            break;
	        }

	        h /= 6;
	      }

	      return [h, s, l, val[3]];
	    }

	    function hue2rgb(p, q, t) {
	      if (t < 0) t += 1;
	      if (t > 1) t -= 1;
	      if (t < 1 / 6) return p + (q - p) * 6 * t;
	      if (t < 1 / 2) return q;
	      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	      return p;
	    }

	    function hslToRgb(val) {
	      var h = val[0];
	      var s = val[1];
	      var l = val[2];
	      var r;
	      var g;
	      var b;

	      if (s === 0) {
	        r = l; // achromatic

	        b = l; // achromatic

	        g = l; // achromatic
	      } else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1 / 3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1 / 3);
	      }

	      return [r, g, b, val[3]];
	    }

	    function linear(t, tMin, tMax, value1, value2) {
	      if (value1 === undefined || value2 === undefined) {
	        value1 = tMin;
	        value2 = tMax;
	        tMin = 0;
	        tMax = 1;
	      }

	      if (tMax < tMin) {
	        var _tMin = tMax;
	        tMax = tMin;
	        tMin = _tMin;
	      }

	      if (t <= tMin) {
	        return value1;
	      }

	      if (t >= tMax) {
	        return value2;
	      }

	      var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);

	      if (!value1.length) {
	        return value1 + (value2 - value1) * perc;
	      }

	      var i;
	      var len = value1.length;
	      var arr = createTypedArray('float32', len);

	      for (i = 0; i < len; i += 1) {
	        arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
	      }

	      return arr;
	    }

	    function random(min, max) {
	      if (max === undefined) {
	        if (min === undefined) {
	          min = 0;
	          max = 1;
	        } else {
	          max = min;
	          min = undefined;
	        }
	      }

	      if (max.length) {
	        var i;
	        var len = max.length;

	        if (!min) {
	          min = createTypedArray('float32', len);
	        }

	        var arr = createTypedArray('float32', len);
	        var rnd = BMMath.random();

	        for (i = 0; i < len; i += 1) {
	          arr[i] = min[i] + rnd * (max[i] - min[i]);
	        }

	        return arr;
	      }

	      if (min === undefined) {
	        min = 0;
	      }

	      var rndm = BMMath.random();
	      return min + rndm * (max - min);
	    }

	    function createPath(points, inTangents, outTangents, closed) {
	      var i;
	      var len = points.length;
	      var path = shapePool.newElement();
	      path.setPathData(!!closed, len);
	      var arrPlaceholder = [0, 0];
	      var inVertexPoint;
	      var outVertexPoint;

	      for (i = 0; i < len; i += 1) {
	        inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
	        outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
	        path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
	      }

	      return path;
	    }

	    function initiateExpression(elem, data, property) {
	      // Bail out if we don't want expressions
	      function noOp(_value) {
	        return _value;
	      }

	      if (!elem.globalData.renderConfig.runExpressions) {
	        return noOp;
	      }

	      var val = data.x;
	      var needsVelocity = /velocity(?![\w\d])/.test(val);

	      var _needsRandom = val.indexOf('random') !== -1;

	      var elemType = elem.data.ty;
	      var transform;
	      var $bm_transform;
	      var content;
	      var effect;
	      var thisProperty = property;
	      thisProperty.valueAtTime = thisProperty.getValueAtTime;
	      Object.defineProperty(thisProperty, 'value', {
	        get: function get() {
	          return thisProperty.v;
	        }
	      });
	      elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
	      elem.comp.displayStartTime = 0;
	      var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
	      var outPoint = elem.data.op / elem.comp.globalData.frameRate;
	      var width = elem.data.sw ? elem.data.sw : 0;
	      var height = elem.data.sh ? elem.data.sh : 0;
	      var name = elem.data.nm;
	      var loopIn;
	      var loop_in;
	      var loopOut;
	      var loop_out;
	      var smooth;
	      var toWorld;
	      var fromWorld;
	      var fromComp;
	      var toComp;
	      var fromCompToSurface;
	      var position;
	      var rotation;
	      var anchorPoint;
	      var scale;
	      var thisLayer;
	      var thisComp;
	      var mask;
	      var valueAtTime;
	      var velocityAtTime;
	      var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls

	      var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval

	      var numKeys = property.kf ? data.k.length : 0;
	      var active = !this.data || this.data.hd !== true;

	      var wiggle = function wiggle(freq, amp) {
	        var iWiggle;
	        var j;
	        var lenWiggle = this.pv.length ? this.pv.length : 1;
	        var addedAmps = createTypedArray('float32', lenWiggle);
	        freq = 5;
	        var iterations = Math.floor(time * freq);
	        iWiggle = 0;
	        j = 0;

	        while (iWiggle < iterations) {
	          // var rnd = BMMath.random();
	          for (j = 0; j < lenWiggle; j += 1) {
	            addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
	          }

	          iWiggle += 1;
	        } // var rnd2 = BMMath.random();


	        var periods = time * freq;
	        var perc = periods - Math.floor(periods);
	        var arr = createTypedArray('float32', lenWiggle);

	        if (lenWiggle > 1) {
	          for (j = 0; j < lenWiggle; j += 1) {
	            arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	            // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	          }

	          return arr;
	        }

	        return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
	      }.bind(this);

	      if (thisProperty.loopIn) {
	        loopIn = thisProperty.loopIn.bind(thisProperty);
	        loop_in = loopIn;
	      }

	      if (thisProperty.loopOut) {
	        loopOut = thisProperty.loopOut.bind(thisProperty);
	        loop_out = loopOut;
	      }

	      if (thisProperty.smooth) {
	        smooth = thisProperty.smooth.bind(thisProperty);
	      }

	      function loopInDuration(type, duration) {
	        return loopIn(type, duration, true);
	      }

	      function loopOutDuration(type, duration) {
	        return loopOut(type, duration, true);
	      }

	      if (this.getValueAtTime) {
	        valueAtTime = this.getValueAtTime.bind(this);
	      }

	      if (this.getVelocityAtTime) {
	        velocityAtTime = this.getVelocityAtTime.bind(this);
	      }

	      var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

	      function lookAt(elem1, elem2) {
	        var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
	        var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
	        var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
	        return [yaw, pitch, 0];
	      }

	      function easeOut(t, tMin, tMax, val1, val2) {
	        return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
	      }

	      function easeIn(t, tMin, tMax, val1, val2) {
	        return applyEase(easeInBez, t, tMin, tMax, val1, val2);
	      }

	      function ease(t, tMin, tMax, val1, val2) {
	        return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
	      }

	      function applyEase(fn, t, tMin, tMax, val1, val2) {
	        if (val1 === undefined) {
	          val1 = tMin;
	          val2 = tMax;
	        } else {
	          t = (t - tMin) / (tMax - tMin);
	        }

	        if (t > 1) {
	          t = 1;
	        } else if (t < 0) {
	          t = 0;
	        }

	        var mult = fn(t);

	        if ($bm_isInstanceOfArray(val1)) {
	          var iKey;
	          var lenKey = val1.length;
	          var arr = createTypedArray('float32', lenKey);

	          for (iKey = 0; iKey < lenKey; iKey += 1) {
	            arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
	          }

	          return arr;
	        }

	        return (val2 - val1) * mult + val1;
	      }

	      function nearestKey(time) {
	        var iKey;
	        var lenKey = data.k.length;
	        var index;
	        var keyTime;

	        if (!data.k.length || typeof data.k[0] === 'number') {
	          index = 0;
	          keyTime = 0;
	        } else {
	          index = -1;
	          time *= elem.comp.globalData.frameRate;

	          if (time < data.k[0].t) {
	            index = 1;
	            keyTime = data.k[0].t;
	          } else {
	            for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
	              if (time === data.k[iKey].t) {
	                index = iKey + 1;
	                keyTime = data.k[iKey].t;
	                break;
	              } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
	                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
	                  index = iKey + 2;
	                  keyTime = data.k[iKey + 1].t;
	                } else {
	                  index = iKey + 1;
	                  keyTime = data.k[iKey].t;
	                }

	                break;
	              }
	            }

	            if (index === -1) {
	              index = iKey + 1;
	              keyTime = data.k[iKey].t;
	            }
	          }
	        }

	        var obKey = {};
	        obKey.index = index;
	        obKey.time = keyTime / elem.comp.globalData.frameRate;
	        return obKey;
	      }

	      function key(ind) {
	        var obKey;
	        var iKey;
	        var lenKey;

	        if (!data.k.length || typeof data.k[0] === 'number') {
	          throw new Error('The property has no keyframe at index ' + ind);
	        }

	        ind -= 1;
	        obKey = {
	          time: data.k[ind].t / elem.comp.globalData.frameRate,
	          value: []
	        };
	        var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
	        lenKey = arr.length;

	        for (iKey = 0; iKey < lenKey; iKey += 1) {
	          obKey[iKey] = arr[iKey];
	          obKey.value[iKey] = arr[iKey];
	        }

	        return obKey;
	      }

	      function framesToTime(fr, fps) {
	        if (!fps) {
	          fps = elem.comp.globalData.frameRate;
	        }

	        return fr / fps;
	      }

	      function timeToFrames(t, fps) {
	        if (!t && t !== 0) {
	          t = time;
	        }

	        if (!fps) {
	          fps = elem.comp.globalData.frameRate;
	        }

	        return t * fps;
	      }

	      function seedRandom(seed) {
	        BMMath.seedrandom(randSeed + seed);
	      }

	      function sourceRectAtTime() {
	        return elem.sourceRectAtTime();
	      }

	      function substring(init, end) {
	        if (typeof value === 'string') {
	          if (end === undefined) {
	            return value.substring(init);
	          }

	          return value.substring(init, end);
	        }

	        return '';
	      }

	      function substr(init, end) {
	        if (typeof value === 'string') {
	          if (end === undefined) {
	            return value.substr(init);
	          }

	          return value.substr(init, end);
	        }

	        return '';
	      }

	      function posterizeTime(framesPerSecond) {
	        time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
	        value = valueAtTime(time);
	      }

	      var time;
	      var velocity;
	      var value;
	      var text;
	      var textIndex;
	      var textTotal;
	      var selectorValue;
	      var index = elem.data.ind;
	      var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	      var parent;
	      var randSeed = Math.floor(Math.random() * 1000000);
	      var globalData = elem.globalData;

	      function executeExpression(_value) {
	        // globalData.pushExpression();
	        value = _value;

	        if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
	          return value;
	        }

	        if (this.propType === 'textSelector') {
	          textIndex = this.textIndex;
	          textTotal = this.textTotal;
	          selectorValue = this.selectorValue;
	        }

	        if (!thisLayer) {
	          text = elem.layerInterface.text;
	          thisLayer = elem.layerInterface;
	          thisComp = elem.comp.compInterface;
	          toWorld = thisLayer.toWorld.bind(thisLayer);
	          fromWorld = thisLayer.fromWorld.bind(thisLayer);
	          fromComp = thisLayer.fromComp.bind(thisLayer);
	          toComp = thisLayer.toComp.bind(thisLayer);
	          mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
	          fromCompToSurface = fromComp;
	        }

	        if (!transform) {
	          transform = elem.layerInterface('ADBE Transform Group');
	          $bm_transform = transform;

	          if (transform) {
	            anchorPoint = transform.anchorPoint;
	            /* position = transform.position;
	                      rotation = transform.rotation;
	                      scale = transform.scale; */
	          }
	        }

	        if (elemType === 4 && !content) {
	          content = thisLayer('ADBE Root Vectors Group');
	        }

	        if (!effect) {
	          effect = thisLayer(4);
	        }

	        hasParent = !!(elem.hierarchy && elem.hierarchy.length);

	        if (hasParent && !parent) {
	          parent = elem.hierarchy[0].layerInterface;
	        }

	        time = this.comp.renderedFrame / this.comp.globalData.frameRate;

	        if (_needsRandom) {
	          seedRandom(randSeed + time);
	        }

	        if (needsVelocity) {
	          velocity = velocityAtTime(time);
	        }

	        expression_function();
	        this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
	        // Changed this to a ternary operation because Rollup failed compiling it correctly

	        scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
	        return scoped_bm_rt;
	      } // Bundlers will see these as dead code and unless we reference them


	      executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData];
	      return executeExpression;
	    }

	    ob.initiateExpression = initiateExpression;
	    ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal];
	    ob.resetFrame = resetFrame;
	    return ob;
	  }();

	  var Expressions = function () {
	    var ob = {};
	    ob.initExpressions = initExpressions;
	    ob.resetFrame = ExpressionManager.resetFrame;

	    function initExpressions(animation) {
	      var stackCount = 0;
	      var registers = [];

	      function pushExpression() {
	        stackCount += 1;
	      }

	      function popExpression() {
	        stackCount -= 1;

	        if (stackCount === 0) {
	          releaseInstances();
	        }
	      }

	      function registerExpressionProperty(expression) {
	        if (registers.indexOf(expression) === -1) {
	          registers.push(expression);
	        }
	      }

	      function releaseInstances() {
	        var i;
	        var len = registers.length;

	        for (i = 0; i < len; i += 1) {
	          registers[i].release();
	        }

	        registers.length = 0;
	      }

	      animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	      animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	      animation.renderer.globalData.pushExpression = pushExpression;
	      animation.renderer.globalData.popExpression = popExpression;
	      animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
	    }

	    return ob;
	  }();

	  var MaskManagerInterface = function () {
	    function MaskInterface(mask, data) {
	      this._mask = mask;
	      this._data = data;
	    }

	    Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	      get: function get() {
	        if (this._mask.prop.k) {
	          this._mask.prop.getValue();
	        }

	        return this._mask.prop;
	      }
	    });
	    Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
	      get: function get() {
	        if (this._mask.op.k) {
	          this._mask.op.getValue();
	        }

	        return this._mask.op.v * 100;
	      }
	    });

	    var MaskManager = function MaskManager(maskManager) {
	      var _masksInterfaces = createSizedArray(maskManager.viewData.length);

	      var i;
	      var len = maskManager.viewData.length;

	      for (i = 0; i < len; i += 1) {
	        _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
	      }

	      var maskFunction = function maskFunction(name) {
	        i = 0;

	        while (i < len) {
	          if (maskManager.masksProperties[i].nm === name) {
	            return _masksInterfaces[i];
	          }

	          i += 1;
	        }

	        return null;
	      };

	      return maskFunction;
	    };

	    return MaskManager;
	  }();

	  var ExpressionPropertyInterface = function () {
	    var defaultUnidimensionalValue = {
	      pv: 0,
	      v: 0,
	      mult: 1
	    };
	    var defaultMultidimensionalValue = {
	      pv: [0, 0, 0],
	      v: [0, 0, 0],
	      mult: 1
	    };

	    function completeProperty(expressionValue, property, type) {
	      Object.defineProperty(expressionValue, 'velocity', {
	        get: function get() {
	          return property.getVelocityAtTime(property.comp.currentFrame);
	        }
	      });
	      expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;

	      expressionValue.key = function (pos) {
	        if (!expressionValue.numKeys) {
	          return 0;
	        }

	        var value = '';

	        if ('s' in property.keyframes[pos - 1]) {
	          value = property.keyframes[pos - 1].s;
	        } else if ('e' in property.keyframes[pos - 2]) {
	          value = property.keyframes[pos - 2].e;
	        } else {
	          value = property.keyframes[pos - 2].s;
	        }

	        var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers

	        valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
	        valueProp.value = type === 'unidimensional' ? value[0] : value;
	        return valueProp;
	      };

	      expressionValue.valueAtTime = property.getValueAtTime;
	      expressionValue.speedAtTime = property.getSpeedAtTime;
	      expressionValue.velocityAtTime = property.getVelocityAtTime;
	      expressionValue.propertyGroup = property.propertyGroup;
	    }

	    function UnidimensionalPropertyInterface(property) {
	      if (!property || !('pv' in property)) {
	        property = defaultUnidimensionalValue;
	      }

	      var mult = 1 / property.mult;
	      var val = property.pv * mult;
	      var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers

	      expressionValue.value = val;
	      completeProperty(expressionValue, property, 'unidimensional');
	      return function () {
	        if (property.k) {
	          property.getValue();
	        }

	        val = property.v * mult;

	        if (expressionValue.value !== val) {
	          expressionValue = new Number(val); // eslint-disable-line no-new-wrappers

	          expressionValue.value = val;
	          completeProperty(expressionValue, property, 'unidimensional');
	        }

	        return expressionValue;
	      };
	    }

	    function MultidimensionalPropertyInterface(property) {
	      if (!property || !('pv' in property)) {
	        property = defaultMultidimensionalValue;
	      }

	      var mult = 1 / property.mult;
	      var len = property.data && property.data.l || property.pv.length;
	      var expressionValue = createTypedArray('float32', len);
	      var arrValue = createTypedArray('float32', len);
	      expressionValue.value = arrValue;
	      completeProperty(expressionValue, property, 'multidimensional');
	      return function () {
	        if (property.k) {
	          property.getValue();
	        }

	        for (var i = 0; i < len; i += 1) {
	          arrValue[i] = property.v[i] * mult;
	          expressionValue[i] = arrValue[i];
	        }

	        return expressionValue;
	      };
	    } // TODO: try to avoid using this getter


	    function defaultGetter() {
	      return defaultUnidimensionalValue;
	    }

	    return function (property) {
	      if (!property) {
	        return defaultGetter;
	      }

	      if (property.propType === 'unidimensional') {
	        return UnidimensionalPropertyInterface(property);
	      }

	      return MultidimensionalPropertyInterface(property);
	    };
	  }();

	  var TransformExpressionInterface = function () {
	    return function (transform) {
	      function _thisFunction(name) {
	        switch (name) {
	          case 'scale':
	          case 'Scale':
	          case 'ADBE Scale':
	          case 6:
	            return _thisFunction.scale;

	          case 'rotation':
	          case 'Rotation':
	          case 'ADBE Rotation':
	          case 'ADBE Rotate Z':
	          case 10:
	            return _thisFunction.rotation;

	          case 'ADBE Rotate X':
	            return _thisFunction.xRotation;

	          case 'ADBE Rotate Y':
	            return _thisFunction.yRotation;

	          case 'position':
	          case 'Position':
	          case 'ADBE Position':
	          case 2:
	            return _thisFunction.position;

	          case 'ADBE Position_0':
	            return _thisFunction.xPosition;

	          case 'ADBE Position_1':
	            return _thisFunction.yPosition;

	          case 'ADBE Position_2':
	            return _thisFunction.zPosition;

	          case 'anchorPoint':
	          case 'AnchorPoint':
	          case 'Anchor Point':
	          case 'ADBE AnchorPoint':
	          case 1:
	            return _thisFunction.anchorPoint;

	          case 'opacity':
	          case 'Opacity':
	          case 11:
	            return _thisFunction.opacity;

	          default:
	            return null;
	        }
	      }

	      Object.defineProperty(_thisFunction, 'rotation', {
	        get: ExpressionPropertyInterface(transform.r || transform.rz)
	      });
	      Object.defineProperty(_thisFunction, 'zRotation', {
	        get: ExpressionPropertyInterface(transform.rz || transform.r)
	      });
	      Object.defineProperty(_thisFunction, 'xRotation', {
	        get: ExpressionPropertyInterface(transform.rx)
	      });
	      Object.defineProperty(_thisFunction, 'yRotation', {
	        get: ExpressionPropertyInterface(transform.ry)
	      });
	      Object.defineProperty(_thisFunction, 'scale', {
	        get: ExpressionPropertyInterface(transform.s)
	      });

	      var _px;

	      var _py;

	      var _pz;

	      var _transformFactory;

	      if (transform.p) {
	        _transformFactory = ExpressionPropertyInterface(transform.p);
	      } else {
	        _px = ExpressionPropertyInterface(transform.px);
	        _py = ExpressionPropertyInterface(transform.py);

	        if (transform.pz) {
	          _pz = ExpressionPropertyInterface(transform.pz);
	        }
	      }

	      Object.defineProperty(_thisFunction, 'position', {
	        get: function get() {
	          if (transform.p) {
	            return _transformFactory();
	          }

	          return [_px(), _py(), _pz ? _pz() : 0];
	        }
	      });
	      Object.defineProperty(_thisFunction, 'xPosition', {
	        get: ExpressionPropertyInterface(transform.px)
	      });
	      Object.defineProperty(_thisFunction, 'yPosition', {
	        get: ExpressionPropertyInterface(transform.py)
	      });
	      Object.defineProperty(_thisFunction, 'zPosition', {
	        get: ExpressionPropertyInterface(transform.pz)
	      });
	      Object.defineProperty(_thisFunction, 'anchorPoint', {
	        get: ExpressionPropertyInterface(transform.a)
	      });
	      Object.defineProperty(_thisFunction, 'opacity', {
	        get: ExpressionPropertyInterface(transform.o)
	      });
	      Object.defineProperty(_thisFunction, 'skew', {
	        get: ExpressionPropertyInterface(transform.sk)
	      });
	      Object.defineProperty(_thisFunction, 'skewAxis', {
	        get: ExpressionPropertyInterface(transform.sa)
	      });
	      Object.defineProperty(_thisFunction, 'orientation', {
	        get: ExpressionPropertyInterface(transform.or)
	      });
	      return _thisFunction;
	    };
	  }();

	  var LayerExpressionInterface = function () {
	    function getMatrix(time) {
	      var toWorldMat = new Matrix();

	      if (time !== undefined) {
	        var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);

	        propMatrix.clone(toWorldMat);
	      } else {
	        var transformMat = this._elem.finalTransform.mProp;
	        transformMat.applyToMatrix(toWorldMat);
	      }

	      return toWorldMat;
	    }

	    function toWorldVec(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      toWorldMat.props[12] = 0;
	      toWorldMat.props[13] = 0;
	      toWorldMat.props[14] = 0;
	      return this.applyPoint(toWorldMat, arr);
	    }

	    function toWorld(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      return this.applyPoint(toWorldMat, arr);
	    }

	    function fromWorldVec(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      toWorldMat.props[12] = 0;
	      toWorldMat.props[13] = 0;
	      toWorldMat.props[14] = 0;
	      return this.invertPoint(toWorldMat, arr);
	    }

	    function fromWorld(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      return this.invertPoint(toWorldMat, arr);
	    }

	    function applyPoint(matrix, arr) {
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;

	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
	        }
	      }

	      return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
	    }

	    function invertPoint(matrix, arr) {
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;

	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
	        }
	      }

	      return matrix.inversePoint(arr);
	    }

	    function fromComp(arr) {
	      var toWorldMat = new Matrix();
	      toWorldMat.reset();

	      this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);

	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;

	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	        }

	        return toWorldMat.inversePoint(arr);
	      }

	      return toWorldMat.inversePoint(arr);
	    }

	    function sampleImage() {
	      return [1, 1, 1, 1];
	    }

	    return function (elem) {
	      var transformInterface;

	      function _registerMaskInterface(maskManager) {
	        _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	      }

	      function _registerEffectsInterface(effects) {
	        _thisLayerFunction.effect = effects;
	      }

	      function _thisLayerFunction(name) {
	        switch (name) {
	          case 'ADBE Root Vectors Group':
	          case 'Contents':
	          case 2:
	            return _thisLayerFunction.shapeInterface;

	          case 1:
	          case 6:
	          case 'Transform':
	          case 'transform':
	          case 'ADBE Transform Group':
	            return transformInterface;

	          case 4:
	          case 'ADBE Effect Parade':
	          case 'effects':
	          case 'Effects':
	            return _thisLayerFunction.effect;

	          case 'ADBE Text Properties':
	            return _thisLayerFunction.textInterface;

	          default:
	            return null;
	        }
	      }

	      _thisLayerFunction.getMatrix = getMatrix;
	      _thisLayerFunction.invertPoint = invertPoint;
	      _thisLayerFunction.applyPoint = applyPoint;
	      _thisLayerFunction.toWorld = toWorld;
	      _thisLayerFunction.toWorldVec = toWorldVec;
	      _thisLayerFunction.fromWorld = fromWorld;
	      _thisLayerFunction.fromWorldVec = fromWorldVec;
	      _thisLayerFunction.toComp = toWorld;
	      _thisLayerFunction.fromComp = fromComp;
	      _thisLayerFunction.sampleImage = sampleImage;
	      _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	      _thisLayerFunction._elem = elem;
	      transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
	      var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	      Object.defineProperties(_thisLayerFunction, {
	        hasParent: {
	          get: function get() {
	            return elem.hierarchy.length;
	          }
	        },
	        parent: {
	          get: function get() {
	            return elem.hierarchy[0].layerInterface;
	          }
	        },
	        rotation: getDescriptor(transformInterface, 'rotation'),
	        scale: getDescriptor(transformInterface, 'scale'),
	        position: getDescriptor(transformInterface, 'position'),
	        opacity: getDescriptor(transformInterface, 'opacity'),
	        anchorPoint: anchorPointDescriptor,
	        anchor_point: anchorPointDescriptor,
	        transform: {
	          get: function get() {
	            return transformInterface;
	          }
	        },
	        active: {
	          get: function get() {
	            return elem.isInRange;
	          }
	        }
	      });
	      _thisLayerFunction.startTime = elem.data.st;
	      _thisLayerFunction.index = elem.data.ind;
	      _thisLayerFunction.source = elem.data.refId;
	      _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	      _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	      _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
	      _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
	      _thisLayerFunction._name = elem.data.nm;
	      _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	      _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	      return _thisLayerFunction;
	    };
	  }();

	  var propertyGroupFactory = function () {
	    return function (interfaceFunction, parentPropertyGroup) {
	      return function (val) {
	        val = val === undefined ? 1 : val;

	        if (val <= 0) {
	          return interfaceFunction;
	        }

	        return parentPropertyGroup(val - 1);
	      };
	    };
	  }();

	  var PropertyInterface = function () {
	    return function (propertyName, propertyGroup) {
	      var interfaceFunction = {
	        _name: propertyName
	      };

	      function _propertyGroup(val) {
	        val = val === undefined ? 1 : val;

	        if (val <= 0) {
	          return interfaceFunction;
	        }

	        return propertyGroup(val - 1);
	      }

	      return _propertyGroup;
	    };
	  }();

	  var EffectsExpressionInterface = function () {
	    var ob = {
	      createEffectsInterface: createEffectsInterface
	    };

	    function createEffectsInterface(elem, propertyGroup) {
	      if (elem.effectsManager) {
	        var effectElements = [];
	        var effectsData = elem.data.ef;
	        var i;
	        var len = elem.effectsManager.effectElements.length;

	        for (i = 0; i < len; i += 1) {
	          effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
	        }

	        var effects = elem.data.ef || [];

	        var groupInterface = function groupInterface(name) {
	          i = 0;
	          len = effects.length;

	          while (i < len) {
	            if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
	              return effectElements[i];
	            }

	            i += 1;
	          }

	          return null;
	        };

	        Object.defineProperty(groupInterface, 'numProperties', {
	          get: function get() {
	            return effects.length;
	          }
	        });
	        return groupInterface;
	      }

	      return null;
	    }

	    function createGroupInterface(data, elements, propertyGroup, elem) {
	      function groupInterface(name) {
	        var effects = data.ef;
	        var i = 0;
	        var len = effects.length;

	        while (i < len) {
	          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
	            if (effects[i].ty === 5) {
	              return effectElements[i];
	            }

	            return effectElements[i]();
	          }

	          i += 1;
	        }

	        throw new Error();
	      }

	      var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);

	      var effectElements = [];
	      var i;
	      var len = data.ef.length;

	      for (i = 0; i < len; i += 1) {
	        if (data.ef[i].ty === 5) {
	          effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
	        } else {
	          effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
	        }
	      }

	      if (data.mn === 'ADBE Color Control') {
	        Object.defineProperty(groupInterface, 'color', {
	          get: function get() {
	            return effectElements[0]();
	          }
	        });
	      }

	      Object.defineProperties(groupInterface, {
	        numProperties: {
	          get: function get() {
	            return data.np;
	          }
	        },
	        _name: {
	          value: data.nm
	        },
	        propertyGroup: {
	          value: _propertyGroup
	        }
	      });
	      groupInterface.enabled = data.en !== 0;
	      groupInterface.active = groupInterface.enabled;
	      return groupInterface;
	    }

	    function createValueInterface(element, type, elem, propertyGroup) {
	      var expressionProperty = ExpressionPropertyInterface(element.p);

	      function interfaceFunction() {
	        if (type === 10) {
	          return elem.comp.compInterface(element.p.v);
	        }

	        return expressionProperty();
	      }

	      if (element.p.setGroupProperty) {
	        element.p.setGroupProperty(PropertyInterface('', propertyGroup));
	      }

	      return interfaceFunction;
	    }

	    return ob;
	  }();

	  var ShapePathInterface = function () {
	    return function pathInterfaceFactory(shape, view, propertyGroup) {
	      var prop = view.sh;

	      function interfaceFunction(val) {
	        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
	          return interfaceFunction.path;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        path: {
	          get: function get() {
	            if (prop.k) {
	              prop.getValue();
	            }

	            return prop;
	          }
	        },
	        shape: {
	          get: function get() {
	            if (prop.k) {
	              prop.getValue();
	            }

	            return prop;
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        ix: {
	          value: shape.ix
	        },
	        propertyIndex: {
	          value: shape.ix
	        },
	        mn: {
	          value: shape.mn
	        },
	        propertyGroup: {
	          value: propertyGroup
	        }
	      });
	      return interfaceFunction;
	    };
	  }();

	  var ShapeExpressionInterface = function () {
	    function iterateElements(shapes, view, propertyGroup) {
	      var arr = [];
	      var i;
	      var len = shapes ? shapes.length : 0;

	      for (i = 0; i < len; i += 1) {
	        if (shapes[i].ty === 'gr') {
	          arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'fl') {
	          arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'st') {
	          arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'tm') {
	          arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'tr') ; else if (shapes[i].ty === 'el') {
	          arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'sr') {
	          arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'sh') {
	          arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rc') {
	          arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rd') {
	          arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rp') {
	          arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'gf') {
	          arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else {
	          arr.push(defaultInterfaceFactory(shapes[i], view[i]));
	        }
	      }

	      return arr;
	    }

	    function contentsInterfaceFactory(shape, view, propertyGroup) {
	      var interfaces;

	      var interfaceFunction = function _interfaceFunction(value) {
	        var i = 0;
	        var len = interfaces.length;

	        while (i < len) {
	          if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
	            return interfaces[i];
	          }

	          i += 1;
	        }

	        if (typeof value === 'number') {
	          return interfaces[value - 1];
	        }

	        return null;
	      };

	      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	      interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	      interfaceFunction.numProperties = interfaces.length;
	      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
	      interfaceFunction.transform = transformInterface;
	      interfaceFunction.propertyIndex = shape.cix;
	      interfaceFunction._name = shape.nm;
	      return interfaceFunction;
	    }

	    function groupInterfaceFactory(shape, view, propertyGroup) {
	      var interfaceFunction = function _interfaceFunction(value) {
	        switch (value) {
	          case 'ADBE Vectors Group':
	          case 'Contents':
	          case 2:
	            return interfaceFunction.content;
	          // Not necessary for now. Keeping them here in case a new case appears
	          // case 'ADBE Vector Transform Group':
	          // case 3:

	          default:
	            return interfaceFunction.transform;
	        }
	      };

	      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	      var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
	      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
	      interfaceFunction.content = content;
	      interfaceFunction.transform = transformInterface;
	      Object.defineProperty(interfaceFunction, '_name', {
	        get: function get() {
	          return shape.nm;
	        }
	      }); // interfaceFunction.content = interfaceFunction;

	      interfaceFunction.numProperties = shape.np;
	      interfaceFunction.propertyIndex = shape.ix;
	      interfaceFunction.nm = shape.nm;
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function fillInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === 'Color' || val === 'color') {
	          return interfaceFunction.color;
	        }

	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }

	        return null;
	      }

	      Object.defineProperties(interfaceFunction, {
	        color: {
	          get: ExpressionPropertyInterface(view.c)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
	      return interfaceFunction;
	    }

	    function gradientFillInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === 'Start Point' || val === 'start point') {
	          return interfaceFunction.startPoint;
	        }

	        if (val === 'End Point' || val === 'end point') {
	          return interfaceFunction.endPoint;
	        }

	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }

	        return null;
	      }

	      Object.defineProperties(interfaceFunction, {
	        startPoint: {
	          get: ExpressionPropertyInterface(view.s)
	        },
	        endPoint: {
	          get: ExpressionPropertyInterface(view.e)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        type: {
	          get: function get() {
	            return 'a';
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
	      view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
	      return interfaceFunction;
	    }

	    function defaultInterfaceFactory() {
	      function interfaceFunction() {
	        return null;
	      }

	      return interfaceFunction;
	    }

	    function strokeInterfaceFactory(shape, view, propertyGroup) {
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);

	      function addPropertyToDashOb(i) {
	        Object.defineProperty(dashOb, shape.d[i].nm, {
	          get: ExpressionPropertyInterface(view.d.dataProps[i].p)
	        });
	      }

	      var i;
	      var len = shape.d ? shape.d.length : 0;
	      var dashOb = {};

	      for (i = 0; i < len; i += 1) {
	        addPropertyToDashOb(i);
	        view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	      }

	      function interfaceFunction(val) {
	        if (val === 'Color' || val === 'color') {
	          return interfaceFunction.color;
	        }

	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }

	        if (val === 'Stroke Width' || val === 'stroke width') {
	          return interfaceFunction.strokeWidth;
	        }

	        return null;
	      }

	      Object.defineProperties(interfaceFunction, {
	        color: {
	          get: ExpressionPropertyInterface(view.c)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        strokeWidth: {
	          get: ExpressionPropertyInterface(view.w)
	        },
	        dash: {
	          get: function get() {
	            return dashOb;
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
	      return interfaceFunction;
	    }

	    function trimInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === shape.e.ix || val === 'End' || val === 'end') {
	          return interfaceFunction.end;
	        }

	        if (val === shape.s.ix) {
	          return interfaceFunction.start;
	        }

	        if (val === shape.o.ix) {
	          return interfaceFunction.offset;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      interfaceFunction.propertyIndex = shape.ix;
	      view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
	      view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
	      interfaceFunction.propertyIndex = shape.ix;
	      interfaceFunction.propertyGroup = propertyGroup;
	      Object.defineProperties(interfaceFunction, {
	        start: {
	          get: ExpressionPropertyInterface(view.s)
	        },
	        end: {
	          get: ExpressionPropertyInterface(view.e)
	        },
	        offset: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function transformInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.a.ix === value || value === 'Anchor Point') {
	          return interfaceFunction.anchorPoint;
	        }

	        if (shape.o.ix === value || value === 'Opacity') {
	          return interfaceFunction.opacity;
	        }

	        if (shape.p.ix === value || value === 'Position') {
	          return interfaceFunction.position;
	        }

	        if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
	          return interfaceFunction.rotation;
	        }

	        if (shape.s.ix === value || value === 'Scale') {
	          return interfaceFunction.scale;
	        }

	        if (shape.sk && shape.sk.ix === value || value === 'Skew') {
	          return interfaceFunction.skew;
	        }

	        if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') {
	          return interfaceFunction.skewAxis;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
	      view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
	      view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

	      if (view.transform.mProps.sk) {
	        view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
	        view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
	      }

	      view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        opacity: {
	          get: ExpressionPropertyInterface(view.transform.mProps.o)
	        },
	        position: {
	          get: ExpressionPropertyInterface(view.transform.mProps.p)
	        },
	        anchorPoint: {
	          get: ExpressionPropertyInterface(view.transform.mProps.a)
	        },
	        scale: {
	          get: ExpressionPropertyInterface(view.transform.mProps.s)
	        },
	        rotation: {
	          get: ExpressionPropertyInterface(view.transform.mProps.r)
	        },
	        skew: {
	          get: ExpressionPropertyInterface(view.transform.mProps.sk)
	        },
	        skewAxis: {
	          get: ExpressionPropertyInterface(view.transform.mProps.sa)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.ty = 'tr';
	      interfaceFunction.mn = shape.mn;
	      interfaceFunction.propertyGroup = propertyGroup;
	      return interfaceFunction;
	    }

	    function ellipseInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }

	        if (shape.s.ix === value) {
	          return interfaceFunction.size;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      interfaceFunction.propertyIndex = shape.ix;
	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        size: {
	          get: ExpressionPropertyInterface(prop.s)
	        },
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function starInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }

	        if (shape.r.ix === value) {
	          return interfaceFunction.rotation;
	        }

	        if (shape.pt.ix === value) {
	          return interfaceFunction.points;
	        }

	        if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
	          return interfaceFunction.outerRadius;
	        }

	        if (shape.os.ix === value) {
	          return interfaceFunction.outerRoundness;
	        }

	        if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
	          return interfaceFunction.innerRadius;
	        }

	        if (shape.is && shape.is.ix === value) {
	          return interfaceFunction.innerRoundness;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
	      prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
	      prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

	      if (shape.ir) {
	        prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
	        prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
	      }

	      Object.defineProperties(interfaceFunction, {
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        rotation: {
	          get: ExpressionPropertyInterface(prop.r)
	        },
	        points: {
	          get: ExpressionPropertyInterface(prop.pt)
	        },
	        outerRadius: {
	          get: ExpressionPropertyInterface(prop.or)
	        },
	        outerRoundness: {
	          get: ExpressionPropertyInterface(prop.os)
	        },
	        innerRadius: {
	          get: ExpressionPropertyInterface(prop.ir)
	        },
	        innerRoundness: {
	          get: ExpressionPropertyInterface(prop.is)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function rectInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }

	        if (shape.r.ix === value) {
	          return interfaceFunction.roundness;
	        }

	        if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
	          return interfaceFunction.size;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
	      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        roundness: {
	          get: ExpressionPropertyInterface(prop.r)
	        },
	        size: {
	          get: ExpressionPropertyInterface(prop.s)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function roundedInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.r.ix === value || value === 'Round Corners 1') {
	          return interfaceFunction.radius;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var prop = view;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        radius: {
	          get: ExpressionPropertyInterface(prop.rd)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function repeaterInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.c.ix === value || value === 'Copies') {
	          return interfaceFunction.copies;
	        }

	        if (shape.o.ix === value || value === 'Offset') {
	          return interfaceFunction.offset;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var prop = view;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
	      prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        copies: {
	          get: ExpressionPropertyInterface(prop.c)
	        },
	        offset: {
	          get: ExpressionPropertyInterface(prop.o)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    return function (shapes, view, propertyGroup) {
	      var interfaces;

	      function _interfaceFunction(value) {
	        if (typeof value === 'number') {
	          value = value === undefined ? 1 : value;

	          if (value === 0) {
	            return propertyGroup;
	          }

	          return interfaces[value - 1];
	        }

	        var i = 0;
	        var len = interfaces.length;

	        while (i < len) {
	          if (interfaces[i]._name === value) {
	            return interfaces[i];
	          }

	          i += 1;
	        }

	        return null;
	      }

	      function parentGroupWrapper() {
	        return propertyGroup;
	      }

	      _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
	      interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
	      _interfaceFunction.numProperties = interfaces.length;
	      _interfaceFunction._name = 'Contents';
	      return _interfaceFunction;
	    };
	  }();

	  var TextExpressionInterface = function () {
	    return function (elem) {
	      var _sourceText;

	      function _thisLayerFunction(name) {
	        switch (name) {
	          case 'ADBE Text Document':
	            return _thisLayerFunction.sourceText;

	          default:
	            return null;
	        }
	      }

	      Object.defineProperty(_thisLayerFunction, 'sourceText', {
	        get: function get() {
	          elem.textProperty.getValue();
	          var stringValue = elem.textProperty.currentData.t;

	          if (!_sourceText || stringValue !== _sourceText.value) {
	            _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
	            // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive

	            _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers

	            Object.defineProperty(_sourceText, 'style', {
	              get: function get() {
	                return {
	                  fillColor: elem.textProperty.currentData.fc
	                };
	              }
	            });
	          }

	          return _sourceText;
	        }
	      });
	      return _thisLayerFunction;
	    };
	  }();

	  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	  var FootageInterface = function () {
	    var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
	      var currentPropertyName = '';
	      var currentProperty = elem.getFootageData();

	      function init() {
	        currentPropertyName = '';
	        currentProperty = elem.getFootageData();
	        return searchProperty;
	      }

	      function searchProperty(value) {
	        if (currentProperty[value]) {
	          currentPropertyName = value;
	          currentProperty = currentProperty[value];

	          if (_typeof(currentProperty) === 'object') {
	            return searchProperty;
	          }

	          return currentProperty;
	        }

	        var propertyNameIndex = value.indexOf(currentPropertyName);

	        if (propertyNameIndex !== -1) {
	          var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
	          currentProperty = currentProperty[index];

	          if (_typeof(currentProperty) === 'object') {
	            return searchProperty;
	          }

	          return currentProperty;
	        }

	        return '';
	      }

	      return init;
	    };

	    var dataInterfaceFactory = function dataInterfaceFactory(elem) {
	      function interfaceFunction(value) {
	        if (value === 'Outline') {
	          return interfaceFunction.outlineInterface();
	        }

	        return null;
	      }

	      interfaceFunction._name = 'Outline';
	      interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
	      return interfaceFunction;
	    };

	    return function (elem) {
	      function _interfaceFunction(value) {
	        if (value === 'Data') {
	          return _interfaceFunction.dataInterface;
	        }

	        return null;
	      }

	      _interfaceFunction._name = 'Data';
	      _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
	      return _interfaceFunction;
	    };
	  }();

	  var interfaces = {
	    layer: LayerExpressionInterface,
	    effects: EffectsExpressionInterface,
	    comp: CompExpressionInterface,
	    shape: ShapeExpressionInterface,
	    text: TextExpressionInterface,
	    footage: FootageInterface
	  };

	  function getInterface(type) {
	    return interfaces[type] || null;
	  }

	  var expressionHelpers = function () {
	    function searchExpressions(elem, data, prop) {
	      if (data.x) {
	        prop.k = true;
	        prop.x = true;
	        prop.initiateExpression = ExpressionManager.initiateExpression;
	        prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
	      }
	    }

	    function getValueAtTime(frameNum) {
	      frameNum *= this.elem.globalData.frameRate;
	      frameNum -= this.offsetTime;

	      if (frameNum !== this._cachingAtTime.lastFrame) {
	        this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
	        this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
	        this._cachingAtTime.lastFrame = frameNum;
	      }

	      return this._cachingAtTime.value;
	    }

	    function getSpeedAtTime(frameNum) {
	      var delta = -0.01;
	      var v1 = this.getValueAtTime(frameNum);
	      var v2 = this.getValueAtTime(frameNum + delta);
	      var speed = 0;

	      if (v1.length) {
	        var i;

	        for (i = 0; i < v1.length; i += 1) {
	          speed += Math.pow(v2[i] - v1[i], 2);
	        }

	        speed = Math.sqrt(speed) * 100;
	      } else {
	        speed = 0;
	      }

	      return speed;
	    }

	    function getVelocityAtTime(frameNum) {
	      if (this.vel !== undefined) {
	        return this.vel;
	      }

	      var delta = -0.001; // frameNum += this.elem.data.st;

	      var v1 = this.getValueAtTime(frameNum);
	      var v2 = this.getValueAtTime(frameNum + delta);
	      var velocity;

	      if (v1.length) {
	        velocity = createTypedArray('float32', v1.length);
	        var i;

	        for (i = 0; i < v1.length; i += 1) {
	          // removing frameRate
	          // if needed, don't add it here
	          // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	          velocity[i] = (v2[i] - v1[i]) / delta;
	        }
	      } else {
	        velocity = (v2 - v1) / delta;
	      }

	      return velocity;
	    }

	    function getStaticValueAtTime() {
	      return this.pv;
	    }

	    function setGroupProperty(propertyGroup) {
	      this.propertyGroup = propertyGroup;
	    }

	    return {
	      searchExpressions: searchExpressions,
	      getSpeedAtTime: getSpeedAtTime,
	      getVelocityAtTime: getVelocityAtTime,
	      getValueAtTime: getValueAtTime,
	      getStaticValueAtTime: getStaticValueAtTime,
	      setGroupProperty: setGroupProperty
	    };
	  }();

	  function addPropertyDecorator() {
	    function loopOut(type, duration, durationFlag) {
	      if (!this.k || !this.keyframes) {
	        return this.pv;
	      }

	      type = type ? type.toLowerCase() : '';
	      var currentFrame = this.comp.renderedFrame;
	      var keyframes = this.keyframes;
	      var lastKeyFrame = keyframes[keyframes.length - 1].t;

	      if (currentFrame <= lastKeyFrame) {
	        return this.pv;
	      }

	      var cycleDuration;
	      var firstKeyFrame;

	      if (!durationFlag) {
	        if (!duration || duration > keyframes.length - 1) {
	          duration = keyframes.length - 1;
	        }

	        firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	        cycleDuration = lastKeyFrame - firstKeyFrame;
	      } else {
	        if (!duration) {
	          cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
	        } else {
	          cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
	        }

	        firstKeyFrame = lastKeyFrame - cycleDuration;
	      }

	      var i;
	      var len;
	      var ret;

	      if (type === 'pingpong') {
	        var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);

	        if (iterations % 2 !== 0) {
	          return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	        }
	      } else if (type === 'offset') {
	        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line

	        var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);

	        if (this.pv.length) {
	          ret = new Array(initV.length);
	          len = ret.length;

	          for (i = 0; i < len; i += 1) {
	            ret[i] = (endV[i] - initV[i]) * repeats + current[i];
	          }

	          return ret;
	        }

	        return (endV - initV) * repeats + current;
	      } else if (type === 'continue') {
	        var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);

	        if (this.pv.length) {
	          ret = new Array(lastValue.length);
	          len = ret.length;

	          for (i = 0; i < len; i += 1) {
	            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
	          }

	          return ret;
	        }

	        return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
	      }

	      return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	    }

	    function loopIn(type, duration, durationFlag) {
	      if (!this.k) {
	        return this.pv;
	      }

	      type = type ? type.toLowerCase() : '';
	      var currentFrame = this.comp.renderedFrame;
	      var keyframes = this.keyframes;
	      var firstKeyFrame = keyframes[0].t;

	      if (currentFrame >= firstKeyFrame) {
	        return this.pv;
	      }

	      var cycleDuration;
	      var lastKeyFrame;

	      if (!durationFlag) {
	        if (!duration || duration > keyframes.length - 1) {
	          duration = keyframes.length - 1;
	        }

	        lastKeyFrame = keyframes[duration].t;
	        cycleDuration = lastKeyFrame - firstKeyFrame;
	      } else {
	        if (!duration) {
	          cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
	        } else {
	          cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
	        }

	        lastKeyFrame = firstKeyFrame + cycleDuration;
	      }

	      var i;
	      var len;
	      var ret;

	      if (type === 'pingpong') {
	        var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);

	        if (iterations % 2 === 0) {
	          return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	        }
	      } else if (type === 'offset') {
	        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
	        var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;

	        if (this.pv.length) {
	          ret = new Array(initV.length);
	          len = ret.length;

	          for (i = 0; i < len; i += 1) {
	            ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
	          }

	          return ret;
	        }

	        return current - (endV - initV) * repeats;
	      } else if (type === 'continue') {
	        var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);

	        if (this.pv.length) {
	          ret = new Array(firstValue.length);
	          len = ret.length;

	          for (i = 0; i < len; i += 1) {
	            ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
	          }

	          return ret;
	        }

	        return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
	      }

	      return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	    }

	    function smooth(width, samples) {
	      if (!this.k) {
	        return this.pv;
	      }

	      width = (width || 0.4) * 0.5;
	      samples = Math.floor(samples || 5);

	      if (samples <= 1) {
	        return this.pv;
	      }

	      var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
	      var initFrame = currentTime - width;
	      var endFrame = currentTime + width;
	      var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
	      var i = 0;
	      var j = 0;
	      var value;

	      if (this.pv.length) {
	        value = createTypedArray('float32', this.pv.length);
	      } else {
	        value = 0;
	      }

	      var sampleValue;

	      while (i < samples) {
	        sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);

	        if (this.pv.length) {
	          for (j = 0; j < this.pv.length; j += 1) {
	            value[j] += sampleValue[j];
	          }
	        } else {
	          value += sampleValue;
	        }

	        i += 1;
	      }

	      if (this.pv.length) {
	        for (j = 0; j < this.pv.length; j += 1) {
	          value[j] /= samples;
	        }
	      } else {
	        value /= samples;
	      }

	      return value;
	    }

	    function getTransformValueAtTime(time) {
	      if (!this._transformCachingAtTime) {
	        this._transformCachingAtTime = {
	          v: new Matrix()
	        };
	      } /// /


	      var matrix = this._transformCachingAtTime.v;
	      matrix.cloneFromProps(this.pre.props);

	      if (this.appliedTransformations < 1) {
	        var anchor = this.a.getValueAtTime(time);
	        matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
	      }

	      if (this.appliedTransformations < 2) {
	        var scale = this.s.getValueAtTime(time);
	        matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
	      }

	      if (this.sk && this.appliedTransformations < 3) {
	        var skew = this.sk.getValueAtTime(time);
	        var skewAxis = this.sa.getValueAtTime(time);
	        matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
	      }

	      if (this.r && this.appliedTransformations < 4) {
	        var rotation = this.r.getValueAtTime(time);
	        matrix.rotate(-rotation * this.r.mult);
	      } else if (!this.r && this.appliedTransformations < 4) {
	        var rotationZ = this.rz.getValueAtTime(time);
	        var rotationY = this.ry.getValueAtTime(time);
	        var rotationX = this.rx.getValueAtTime(time);
	        var orientation = this.or.getValueAtTime(time);
	        matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
	      }

	      if (this.data.p && this.data.p.s) {
	        var positionX = this.px.getValueAtTime(time);
	        var positionY = this.py.getValueAtTime(time);

	        if (this.data.p.z) {
	          var positionZ = this.pz.getValueAtTime(time);
	          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
	        } else {
	          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
	        }
	      } else {
	        var position = this.p.getValueAtTime(time);
	        matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
	      }

	      return matrix; /// /
	    }

	    function getTransformStaticValueAtTime() {
	      return this.v.clone(new Matrix());
	    }

	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;

	    TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
	      var prop = getTransformProperty(elem, data, container);

	      if (prop.dynamicProperties.length) {
	        prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	      } else {
	        prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	      }

	      prop.setGroupProperty = expressionHelpers.setGroupProperty;
	      return prop;
	    };

	    var propertyGetProp = PropertyFactory.getProp;

	    PropertyFactory.getProp = function (elem, data, type, mult, container) {
	      var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
	      // prop.loopOut = loopOut;
	      // prop.loopIn = loopIn;

	      if (prop.kf) {
	        prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
	      } else {
	        prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
	      }

	      prop.setGroupProperty = expressionHelpers.setGroupProperty;
	      prop.loopOut = loopOut;
	      prop.loopIn = loopIn;
	      prop.smooth = smooth;
	      prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
	      prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
	      prop.numKeys = data.a === 1 ? data.k.length : 0;
	      prop.propertyIndex = data.ix;
	      var value = 0;

	      if (type !== 0) {
	        value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
	      }

	      prop._cachingAtTime = {
	        lastFrame: initialDefaultFrame,
	        lastIndex: 0,
	        value: value
	      };
	      expressionHelpers.searchExpressions(elem, data, prop);

	      if (prop.k) {
	        container.addDynamicProperty(prop);
	      }

	      return prop;
	    };

	    function getShapeValueAtTime(frameNum) {
	      // For now this caching object is created only when needed instead of creating it when the shape is initialized.
	      if (!this._cachingAtTime) {
	        this._cachingAtTime = {
	          shapeValue: shapePool.clone(this.pv),
	          lastIndex: 0,
	          lastTime: initialDefaultFrame
	        };
	      }

	      frameNum *= this.elem.globalData.frameRate;
	      frameNum -= this.offsetTime;

	      if (frameNum !== this._cachingAtTime.lastTime) {
	        this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
	        this._cachingAtTime.lastTime = frameNum;
	        this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
	      }

	      return this._cachingAtTime.shapeValue;
	    }

	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

	    function ShapeExpressions() {}

	    ShapeExpressions.prototype = {
	      vertices: function vertices(prop, time) {
	        if (this.k) {
	          this.getValue();
	        }

	        var shapePath = this.v;

	        if (time !== undefined) {
	          shapePath = this.getValueAtTime(time, 0);
	        }

	        var i;
	        var len = shapePath._length;
	        var vertices = shapePath[prop];
	        var points = shapePath.v;
	        var arr = createSizedArray(len);

	        for (i = 0; i < len; i += 1) {
	          if (prop === 'i' || prop === 'o') {
	            arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
	          } else {
	            arr[i] = [vertices[i][0], vertices[i][1]];
	          }
	        }

	        return arr;
	      },
	      points: function points(time) {
	        return this.vertices('v', time);
	      },
	      inTangents: function inTangents(time) {
	        return this.vertices('i', time);
	      },
	      outTangents: function outTangents(time) {
	        return this.vertices('o', time);
	      },
	      isClosed: function isClosed() {
	        return this.v.c;
	      },
	      pointOnPath: function pointOnPath(perc, time) {
	        var shapePath = this.v;

	        if (time !== undefined) {
	          shapePath = this.getValueAtTime(time, 0);
	        }

	        if (!this._segmentsLength) {
	          this._segmentsLength = bez.getSegmentsLength(shapePath);
	        }

	        var segmentsLength = this._segmentsLength;
	        var lengths = segmentsLength.lengths;
	        var lengthPos = segmentsLength.totalLength * perc;
	        var i = 0;
	        var len = lengths.length;
	        var accumulatedLength = 0;
	        var pt;

	        while (i < len) {
	          if (accumulatedLength + lengths[i].addedLength > lengthPos) {
	            var initIndex = i;
	            var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
	            var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
	            pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
	            break;
	          } else {
	            accumulatedLength += lengths[i].addedLength;
	          }

	          i += 1;
	        }

	        if (!pt) {
	          pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
	        }

	        return pt;
	      },
	      vectorOnPath: function vectorOnPath(perc, time, vectorType) {
	        // perc doesn't use triple equality because it can be a Number object as well as a primitive.
	        if (perc == 1) {
	          // eslint-disable-line eqeqeq
	          perc = this.v.c;
	        } else if (perc == 0) {
	          // eslint-disable-line eqeqeq
	          perc = 0.999;
	        }

	        var pt1 = this.pointOnPath(perc, time);
	        var pt2 = this.pointOnPath(perc + 0.001, time);
	        var xLength = pt2[0] - pt1[0];
	        var yLength = pt2[1] - pt1[1];
	        var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));

	        if (magnitude === 0) {
	          return [0, 0];
	        }

	        var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
	        return unitVector;
	      },
	      tangentOnPath: function tangentOnPath(perc, time) {
	        return this.vectorOnPath(perc, time, 'tangent');
	      },
	      normalOnPath: function normalOnPath(perc, time) {
	        return this.vectorOnPath(perc, time, 'normal');
	      },
	      setGroupProperty: expressionHelpers.setGroupProperty,
	      getValueAtTime: expressionHelpers.getStaticValueAtTime
	    };
	    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
	    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;

	    ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
	      var prop = propertyGetShapeProp(elem, data, type, arr, trims);
	      prop.propertyIndex = data.ix;
	      prop.lock = false;

	      if (type === 3) {
	        expressionHelpers.searchExpressions(elem, data.pt, prop);
	      } else if (type === 4) {
	        expressionHelpers.searchExpressions(elem, data.ks, prop);
	      }

	      if (prop.k) {
	        elem.addDynamicProperty(prop);
	      }

	      return prop;
	    };
	  }

	  function initialize$1() {
	    addPropertyDecorator();
	  }

	  function addDecorator() {
	    function searchExpressions() {
	      if (this.data.d.x) {
	        this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
	        this.addEffect(this.getExpressionValue.bind(this));
	        return true;
	      }

	      return null;
	    }

	    TextProperty.prototype.getExpressionValue = function (currentValue, text) {
	      var newValue = this.calculateExpression(text);

	      if (currentValue.t !== newValue) {
	        var newData = {};
	        this.copyData(newData, currentValue);
	        newData.t = newValue.toString();
	        newData.__complete = false;
	        return newData;
	      }

	      return currentValue;
	    };

	    TextProperty.prototype.searchProperty = function () {
	      var isKeyframed = this.searchKeyframes();
	      var hasExpressions = this.searchExpressions();
	      this.kf = isKeyframed || hasExpressions;
	      return this.kf;
	    };

	    TextProperty.prototype.searchExpressions = searchExpressions;
	  }

	  function initialize() {
	    addDecorator();
	  }

	  function SVGComposableEffect() {}

	  SVGComposableEffect.prototype = {
	    createMergeNode: function createMergeNode(resultId, ins) {
	      var feMerge = createNS('feMerge');
	      feMerge.setAttribute('result', resultId);
	      var feMergeNode;
	      var i;

	      for (i = 0; i < ins.length; i += 1) {
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in', ins[i]);
	        feMerge.appendChild(feMergeNode);
	        feMerge.appendChild(feMergeNode);
	      }

	      return feMerge;
	    }
	  };

	  var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';

	  function SVGTintFilter(filter, filterManager, elem, id, source) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
	    feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
	    this.linearFilter = feColorMatrix;
	    feColorMatrix.setAttribute('result', id + '_tint_1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result', id + '_tint_2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    var feMerge = this.createMergeNode(id, [source, id + '_tint_1', id + '_tint_2']);
	    filter.appendChild(feMerge);
	  }

	  extendPrototype([SVGComposableEffect], SVGTintFilter);

	  SVGTintFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var colorBlack = this.filterManager.effectElements[0].p.v;
	      var colorWhite = this.filterManager.effectElements[1].p.v;
	      var opacity = this.filterManager.effectElements[2].p.v / 100;
	      this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
	      this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
	    }
	  };

	  function SVGFillFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result', id);
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	  }

	  SVGFillFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var color = this.filterManager.effectElements[2].p.v;
	      var opacity = this.filterManager.effectElements[6].p.v;
	      this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
	    }
	  };

	  function SVGStrokeEffect(fil, filterManager, elem) {
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	  }

	  SVGStrokeEffect.prototype.initialize = function () {
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path;
	    var groupPath;
	    var i;
	    var len;

	    if (this.filterManager.effectElements[1].p.v === 1) {
	      len = this.elem.maskManager.masksProperties.length;
	      i = 0;
	    } else {
	      i = this.filterManager.effectElements[0].p.v - 1;
	      len = i + 1;
	    }

	    groupPath = createNS('g');
	    groupPath.setAttribute('fill', 'none');
	    groupPath.setAttribute('stroke-linecap', 'round');
	    groupPath.setAttribute('stroke-dashoffset', 1);

	    for (i; i < len; i += 1) {
	      path = createNS('path');
	      groupPath.appendChild(path);
	      this.paths.push({
	        p: path,
	        m: i
	      });
	    }

	    if (this.filterManager.effectElements[10].p.v === 3) {
	      var mask = createNS('mask');
	      var id = createElementID();
	      mask.setAttribute('id', id);
	      mask.setAttribute('mask-type', 'alpha');
	      mask.appendChild(groupPath);
	      this.elem.globalData.defs.appendChild(mask);
	      var g = createNS('g');
	      g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');

	      while (elemChildren[0]) {
	        g.appendChild(elemChildren[0]);
	      }

	      this.elem.layerElement.appendChild(g);
	      this.masker = mask;
	      groupPath.setAttribute('stroke', '#fff');
	    } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
	      if (this.filterManager.effectElements[10].p.v === 2) {
	        elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;

	        while (elemChildren.length) {
	          this.elem.layerElement.removeChild(elemChildren[0]);
	        }
	      }

	      this.elem.layerElement.appendChild(groupPath);
	      this.elem.layerElement.removeAttribute('mask');
	      groupPath.setAttribute('stroke', '#fff');
	    }

	    this.initialized = true;
	    this.pathMasker = groupPath;
	  };

	  SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
	    if (!this.initialized) {
	      this.initialize();
	    }

	    var i;
	    var len = this.paths.length;
	    var mask;
	    var path;

	    for (i = 0; i < len; i += 1) {
	      if (this.paths[i].m !== -1) {
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;

	        if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
	          path.setAttribute('d', mask.lastPath);
	        }

	        if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
	          var dasharrayValue;

	          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
	            var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
	            var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
	            var l = path.getTotalLength();
	            dasharrayValue = '0 0 0 ' + l * s + ' ';
	            var lineLength = l * (e - s);
	            var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
	            var units = Math.floor(lineLength / segment);
	            var j;

	            for (j = 0; j < units; j += 1) {
	              dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
	            }

	            dasharrayValue += '0 ' + l * 10 + ' 0 0';
	          } else {
	            dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
	          }

	          path.setAttribute('stroke-dasharray', dasharrayValue);
	        }
	      }
	    }

	    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
	      this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
	    }

	    if (forceRender || this.filterManager.effectElements[6].p._mdf) {
	      this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
	    }

	    if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
	      if (forceRender || this.filterManager.effectElements[3].p._mdf) {
	        var color = this.filterManager.effectElements[3].p.v;
	        this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
	      }
	    }
	  };

	  function SVGTritoneFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
	    feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	    feComponentTransfer.setAttribute('result', id);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	    filter.appendChild(feComponentTransfer);
	  }

	  SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var color1 = this.filterManager.effectElements[0].p.v;
	      var color2 = this.filterManager.effectElements[1].p.v;
	      var color3 = this.filterManager.effectElements[2].p.v;
	      var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
	      var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
	      var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
	      this.feFuncR.setAttribute('tableValues', tableR);
	      this.feFuncG.setAttribute('tableValues', tableG);
	      this.feFuncB.setAttribute('tableValues', tableB);
	    }
	  };

	  function SVGProLevelsFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer'); // Red

	    if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
	      this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    } // Green


	    if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
	      this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    } // Blue


	    if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
	      this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    } // Alpha


	    if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
	      this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    } // RGB


	    if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
	      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	      filter.appendChild(feComponentTransfer);
	    }

	    if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
	      feComponentTransfer = createNS('feComponentTransfer');
	      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	      feComponentTransfer.setAttribute('result', id);
	      filter.appendChild(feComponentTransfer);
	      this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	      this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	      this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	  }

	  SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	  };

	  SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null, {
	      length: segments
	    });
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack;
	    var inputDelta = inputWhite - inputBlack;

	    while (cnt <= 256) {
	      perc = cnt / 256;

	      if (perc <= min) {
	        colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	      } else if (perc >= max) {
	        colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	      } else {
	        colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
	      }

	      table[pos] = colorValue;
	      pos += 1;
	      cnt += 256 / (segments - 1);
	    }

	    return table.join(' ');
	  };

	  SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var val;
	      var effectElements = this.filterManager.effectElements;

	      if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
	        val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
	        this.feFuncRComposed.setAttribute('tableValues', val);
	        this.feFuncGComposed.setAttribute('tableValues', val);
	        this.feFuncBComposed.setAttribute('tableValues', val);
	      }

	      if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
	        val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
	        this.feFuncR.setAttribute('tableValues', val);
	      }

	      if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
	        val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
	        this.feFuncG.setAttribute('tableValues', val);
	      }

	      if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
	        val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
	        this.feFuncB.setAttribute('tableValues', val);
	      }

	      if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
	        val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
	        this.feFuncA.setAttribute('tableValues', val);
	      }
	    }
	  };

	  function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
	    var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
	    var filterSize = filterManager.data.fs || globalFilterSize;
	    filter.setAttribute('x', filterSize.x || globalFilterSize.x);
	    filter.setAttribute('y', filterSize.y || globalFilterSize.y);
	    filter.setAttribute('width', filterSize.width || globalFilterSize.width);
	    filter.setAttribute('height', filterSize.height || globalFilterSize.height);
	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in', 'SourceAlpha');
	    feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation', '0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx', '25');
	    feOffset.setAttribute('dy', '0');
	    feOffset.setAttribute('in', id + '_drop_shadow_1');
	    feOffset.setAttribute('result', id + '_drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color', '#00ff00');
	    feFlood.setAttribute('flood-opacity', '1');
	    feFlood.setAttribute('result', id + '_drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in', id + '_drop_shadow_3');
	    feComposite.setAttribute('in2', id + '_drop_shadow_2');
	    feComposite.setAttribute('operator', 'in');
	    feComposite.setAttribute('result', id + '_drop_shadow_4');
	    filter.appendChild(feComposite);
	    var feMerge = this.createMergeNode(id, [id + '_drop_shadow_4', source]);
	    filter.appendChild(feMerge); //
	  }

	  extendPrototype([SVGComposableEffect], SVGDropShadowEffect);

	  SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      if (forceRender || this.filterManager.effectElements[4].p._mdf) {
	        this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	      }

	      if (forceRender || this.filterManager.effectElements[0].p._mdf) {
	        var col = this.filterManager.effectElements[0].p.v;
	        this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
	      }

	      if (forceRender || this.filterManager.effectElements[1].p._mdf) {
	        this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
	      }

	      if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
	        var distance = this.filterManager.effectElements[3].p.v;
	        var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
	        var x = distance * Math.cos(angle);
	        var y = distance * Math.sin(angle);
	        this.feOffset.setAttribute('dx', x);
	        this.feOffset.setAttribute('dy', y);
	      }
	    }
	  };

	  var _svgMatteSymbols = [];

	  function SVGMatte3Effect(filterElem, filterManager, elem) {
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	  }

	  SVGMatte3Effect.prototype.findSymbol = function (mask) {
	    var i = 0;
	    var len = _svgMatteSymbols.length;

	    while (i < len) {
	      if (_svgMatteSymbols[i] === mask) {
	        return _svgMatteSymbols[i];
	      }

	      i += 1;
	    }

	    return null;
	  };

	  SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
	    var parentNode = mask.layerElement.parentNode;

	    if (!parentNode) {
	      return;
	    }

	    var children = parentNode.children;
	    var i = 0;
	    var len = children.length;

	    while (i < len) {
	      if (children[i] === mask.layerElement) {
	        break;
	      }

	      i += 1;
	    }

	    var nextChild;

	    if (i <= len - 2) {
	      nextChild = children[i + 1];
	    }

	    var useElem = createNS('use');
	    useElem.setAttribute('href', '#' + symbolId);

	    if (nextChild) {
	      parentNode.insertBefore(useElem, nextChild);
	    } else {
	      parentNode.appendChild(useElem);
	    }
	  };

	  SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
	    if (!this.findSymbol(mask)) {
	      var symbolId = createElementID();
	      var masker = createNS('mask');
	      masker.setAttribute('id', mask.layerId);
	      masker.setAttribute('mask-type', 'alpha');

	      _svgMatteSymbols.push(mask);

	      var defs = elem.globalData.defs;
	      defs.appendChild(masker);
	      var symbol = createNS('symbol');
	      symbol.setAttribute('id', symbolId);
	      this.replaceInParent(mask, symbolId);
	      symbol.appendChild(mask.layerElement);
	      defs.appendChild(symbol);
	      var useElem = createNS('use');
	      useElem.setAttribute('href', '#' + symbolId);
	      masker.appendChild(useElem);
	      mask.data.hd = false;
	      mask.show();
	    }

	    elem.setMatte(mask.layerId);
	  };

	  SVGMatte3Effect.prototype.initialize = function () {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var elements = this.elem.comp.elements;
	    var i = 0;
	    var len = elements.length;

	    while (i < len) {
	      if (elements[i] && elements[i].data.ind === ind) {
	        this.setElementAsMask(this.elem, elements[i]);
	      }

	      i += 1;
	    }

	    this.initialized = true;
	  };

	  SVGMatte3Effect.prototype.renderFrame = function () {
	    if (!this.initialized) {
	      this.initialize();
	    }
	  };

	  function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
	    // Outset the filter region by 100% on all sides to accommodate blur expansion.
	    filter.setAttribute('x', '-100%');
	    filter.setAttribute('y', '-100%');
	    filter.setAttribute('width', '300%');
	    filter.setAttribute('height', '300%');
	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('result', id);
	    filter.appendChild(feGaussianBlur);
	    this.feGaussianBlur = feGaussianBlur;
	  }

	  SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      // Empirical value, matching AE's blur appearance.
	      var kBlurrinessToSigma = 0.3;
	      var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
	      //
	      //   1 -> horizontal & vertical
	      //   2 -> horizontal only
	      //   3 -> vertical only
	      //

	      var dimensions = this.filterManager.effectElements[1].p.v;
	      var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq

	      var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq

	      this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
	      //
	      //   0 -> off -> duplicate
	      //   1 -> on  -> wrap

	      var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq

	      this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
	    }
	  };

	  function TransformEffect() {}

	  TransformEffect.prototype.init = function (effectsManager) {
	    this.effectsManager = effectsManager;
	    this.type = effectTypes.TRANSFORM_EFFECT;
	    this.matrix = new Matrix();
	    this.opacity = -1;
	    this._mdf = false;
	    this._opMdf = false;
	  };

	  TransformEffect.prototype.renderFrame = function (forceFrame) {
	    this._opMdf = false;
	    this._mdf = false;

	    if (forceFrame || this.effectsManager._mdf) {
	      var effectElements = this.effectsManager.effectElements;
	      var anchor = effectElements[0].p.v;
	      var position = effectElements[1].p.v;
	      var isUniformScale = effectElements[2].p.v === 1;
	      var scaleHeight = effectElements[3].p.v;
	      var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
	      var skew = effectElements[5].p.v;
	      var skewAxis = effectElements[6].p.v;
	      var rotation = effectElements[7].p.v;
	      this.matrix.reset();
	      this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
	      this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
	      this.matrix.rotate(-rotation * degToRads);
	      this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
	      this.matrix.translate(position[0], position[1], 0);
	      this._mdf = true;

	      if (this.opacity !== effectElements[8].p.v) {
	        this.opacity = effectElements[8].p.v;
	        this._opMdf = true;
	      }
	    }
	  };

	  function SVGTransformEffect(_, filterManager) {
	    this.init(filterManager);
	  }

	  extendPrototype([TransformEffect], SVGTransformEffect);

	  function CVTransformEffect(effectsManager) {
	    this.init(effectsManager);
	  }

	  extendPrototype([TransformEffect], CVTransformEffect);

	  registerRenderer('canvas', CanvasRenderer);
	  registerRenderer('html', HybridRenderer);
	  registerRenderer('svg', SVGRenderer); // Registering shape modifiers

	  ShapeModifiers.registerModifier('tm', TrimModifier);
	  ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
	  ShapeModifiers.registerModifier('rp', RepeaterModifier);
	  ShapeModifiers.registerModifier('rd', RoundCornersModifier);
	  ShapeModifiers.registerModifier('zz', ZigZagModifier);
	  ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin

	  setExpressionsPlugin(Expressions);
	  setExpressionInterfaces(getInterface);
	  initialize$1();
	  initialize(); // Registering svg effects

	  registerEffect$1(20, SVGTintFilter, true);
	  registerEffect$1(21, SVGFillFilter, true);
	  registerEffect$1(22, SVGStrokeEffect, false);
	  registerEffect$1(23, SVGTritoneFilter, true);
	  registerEffect$1(24, SVGProLevelsFilter, true);
	  registerEffect$1(25, SVGDropShadowEffect, true);
	  registerEffect$1(28, SVGMatte3Effect, false);
	  registerEffect$1(29, SVGGaussianBlurEffect, true);
	  registerEffect$1(35, SVGTransformEffect, false);
	  registerEffect(35, CVTransformEffect);

	  return lottie;

	})); 
} (lottie, lottie.exports));

var lottieExports = lottie.exports;

Object.defineProperty(dist$1, "__esModule", {
  value: true
});

var _extends2 = _extends$4;

var _extends3 = _interopRequireDefault$5(_extends2);

var _getPrototypeOf$2 = getPrototypeOf$1;

var _getPrototypeOf2 = _interopRequireDefault$5(_getPrototypeOf$2);

var _classCallCheck2 = classCallCheck;

var _classCallCheck3 = _interopRequireDefault$5(_classCallCheck2);

var _createClass2 = createClass;

var _createClass3 = _interopRequireDefault$5(_createClass2);

var _possibleConstructorReturn2 = possibleConstructorReturn;

var _possibleConstructorReturn3 = _interopRequireDefault$5(_possibleConstructorReturn2);

var _inherits2 = inherits;

var _inherits3 = _interopRequireDefault$5(_inherits2);

var _react$1 = React$1;

var _react2$1 = _interopRequireDefault$5(_react$1);

var _propTypes$1 = propTypesExports;

var _propTypes2$1 = _interopRequireDefault$5(_propTypes$1);

var _lottieWeb = lottieExports;

var _lottieWeb2 = _interopRequireDefault$5(_lottieWeb);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Lottie = function (_React$Component) {
  (0, _inherits3.default)(Lottie, _React$Component);

  function Lottie() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Lottie);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, _getPrototypeOf2.default)(Lottie)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickToPause = function () {
      // The pause() method is for handling pausing by passing a prop isPaused
      // This method is for handling the ability to pause by clicking on the animation
      if (_this.anim.isPaused) {
        _this.anim.play();
      } else {
        _this.anim.pause();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Lottie, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          options = _props.options,
          eventListeners = _props.eventListeners;
      var loop = options.loop,
          autoplay = options.autoplay,
          animationData = options.animationData,
          rendererSettings = options.rendererSettings,
          segments = options.segments;


      this.options = {
        container: this.el,
        renderer: 'svg',
        loop: loop !== false,
        autoplay: autoplay !== false,
        segments: segments !== false,
        animationData: animationData,
        rendererSettings: rendererSettings
      };

      this.options = (0, _extends3.default)({}, this.options, options);

      this.anim = _lottieWeb2.default.loadAnimation(this.options);
      this.registerEvents(eventListeners);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps /* , nextState */) {
      /* Recreate the animation handle if the data is changed */
      if (this.options.animationData !== nextProps.options.animationData) {
        this.deRegisterEvents(this.props.eventListeners);
        this.destroy();
        this.options = (0, _extends3.default)({}, this.options, nextProps.options);
        this.anim = _lottieWeb2.default.loadAnimation(this.options);
        this.registerEvents(nextProps.eventListeners);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isStopped) {
        this.stop();
      } else if (this.props.segments) {
        this.playSegments();
      } else {
        this.play();
      }

      this.pause();
      this.setSpeed();
      this.setDirection();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.deRegisterEvents(this.props.eventListeners);
      this.destroy();
      this.options.animationData = null;
      this.anim = null;
    }
  }, {
    key: 'setSpeed',
    value: function setSpeed() {
      this.anim.setSpeed(this.props.speed);
    }
  }, {
    key: 'setDirection',
    value: function setDirection() {
      this.anim.setDirection(this.props.direction);
    }
  }, {
    key: 'play',
    value: function play() {
      this.anim.play();
    }
  }, {
    key: 'playSegments',
    value: function playSegments() {
      this.anim.playSegments(this.props.segments);
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.anim.stop();
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (this.props.isPaused && !this.anim.isPaused) {
        this.anim.pause();
      } else if (!this.props.isPaused && this.anim.isPaused) {
        this.anim.pause();
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.anim.destroy();
    }
  }, {
    key: 'registerEvents',
    value: function registerEvents(eventListeners) {
      var _this2 = this;

      eventListeners.forEach(function (eventListener) {
        _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
      });
    }
  }, {
    key: 'deRegisterEvents',
    value: function deRegisterEvents(eventListeners) {
      var _this3 = this;

      eventListeners.forEach(function (eventListener) {
        _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height,
          ariaRole = _props2.ariaRole,
          ariaLabel = _props2.ariaLabel,
          isClickToPauseDisabled = _props2.isClickToPauseDisabled,
          title = _props2.title;


      var getSize = function getSize(initial) {
        var size = void 0;

        if (typeof initial === 'number') {
          size = initial + 'px';
        } else {
          size = initial || '100%';
        }

        return size;
      };

      var lottieStyles = (0, _extends3.default)({
        width: getSize(width),
        height: getSize(height),
        overflow: 'hidden',
        margin: '0 auto',
        outline: 'none'
      }, this.props.style);

      var onClickHandler = isClickToPauseDisabled ? function () {
        return null;
      } : this.handleClickToPause;

      return (
        // Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        _react2$1.default.createElement('div', {
          ref: function ref(c) {
            _this4.el = c;
          },
          style: lottieStyles,
          onClick: onClickHandler,
          title: title,
          role: ariaRole,
          'aria-label': ariaLabel,
          tabIndex: '0'
        })
      );
    }
  }]);
  return Lottie;
}(_react2$1.default.Component);

var _default = dist$1.default = Lottie;


Lottie.propTypes = {
  eventListeners: _propTypes2$1.default.arrayOf(_propTypes2$1.default.object),
  options: _propTypes2$1.default.object.isRequired,
  height: _propTypes2$1.default.oneOfType([_propTypes2$1.default.string, _propTypes2$1.default.number]),
  width: _propTypes2$1.default.oneOfType([_propTypes2$1.default.string, _propTypes2$1.default.number]),
  isStopped: _propTypes2$1.default.bool,
  isPaused: _propTypes2$1.default.bool,
  speed: _propTypes2$1.default.number,
  segments: _propTypes2$1.default.arrayOf(_propTypes2$1.default.number),
  direction: _propTypes2$1.default.number,
  ariaRole: _propTypes2$1.default.string,
  ariaLabel: _propTypes2$1.default.string,
  isClickToPauseDisabled: _propTypes2$1.default.bool,
  title: _propTypes2$1.default.string
};

Lottie.defaultProps = {
  eventListeners: [],
  isStopped: false,
  isPaused: false,
  speed: 1,
  ariaRole: 'button',
  ariaLabel: 'animation',
  isClickToPauseDisabled: false,
  title: ''
};

var v$4 = "5.7.4";
var fr$4 = 25;
var ip$4 = 0;
var op$4 = 51;
var w$4 = 200;
var h$4 = 68;
var nm$4 = "envelope";
var ddd$4 = 0;
var assets$4 = [
];
var layers$4 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "check-mark",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					142.623,
					44.971,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					18.585,
					15.937,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										10.77,
										-7.275
									],
									[
										3.781,
										-0.285
									],
									[
										-3.782,
										7.275
									],
									[
										-10.77,
										0.286
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.125490196078,
								0.63137254902,
								0.419607873056,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								18.731,
								11.541
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.8
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.2
								],
								y: [
									0
								]
							},
							t: 20,
							s: [
								100
							]
						},
						{
							t: 27,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 350,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "check-circle-outline",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					137.441,
					42.489,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					53.441,
					-1.011,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								24,
								24
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.86
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.14
										],
										y: [
											0
										]
									},
									t: 22,
									s: [
										92
									]
								},
								{
									t: 30,
									s: [
										10
									]
								}
							],
							ix: 1
						},
						e: {
							a: 0,
							k: 92,
							ix: 2
						},
						o: {
							a: 0,
							k: 55,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.125490196078,
								0.63137254902,
								0.419607843137,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 2,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								54.447,
								-0.317
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 350,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "check-circle-bkgr",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					137.441,
					42.489,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					53.441,
					-1.011,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.281,
								0.281,
								0.833
							],
							y: [
								1.107,
								1.107,
								1
							]
						},
						o: {
							x: [
								0.695,
								0.695,
								0.167
							],
							y: [
								0.01,
								0.01,
								16.667
							]
						},
						t: 13,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0,
								0,
								0
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 24,
						s: [
							112,
							112,
							100
						]
					},
					{
						t: 40,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								42,
								42
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								54.447,
								-0.317
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 13,
		op: 350,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 3,
		nm: "null-envelope",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				s: true,
				x: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.259
								],
								y: [
									0.989
								]
							},
							o: {
								x: [
									0.015
								],
								y: [
									0.206
								]
							},
							t: 8,
							s: [
								120.5
							]
						},
						{
							t: 25,
							s: [
								150.5
							]
						}
					],
					ix: 3
				},
				y: {
					a: 0,
					k: 34,
					ix: 4
				}
			},
			a: {
				a: 0,
				k: [
					100,
					50,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		ip: 0,
		op: 350,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "envelope",
		parent: 4,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					49.981,
					49.595,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					42.955,
					33.075,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-2.132,
										1.877
									],
									[
										0,
										0
									],
									[
										1.519,
										0
									],
									[
										0,
										0
									],
									[
										1.018,
										-0.985
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-1.017,
										-0.985
									],
									[
										0,
										0
									],
									[
										-1.519,
										0
									],
									[
										0,
										0
									],
									[
										2.132,
										1.877
									]
								],
								v: [
									[
										3.73,
										13.651
									],
									[
										33.555,
										-13.928
									],
									[
										29.64,
										-15.529
									],
									[
										-29.639,
										-15.529
									],
									[
										-33.555,
										-13.928
									],
									[
										-3.729,
										13.651
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.125490196078,
								0.63137254902,
								0.419607873056,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.068,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								42.954,
								23.198
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										3.105,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-3.105
									],
									[
										0,
										0
									],
									[
										-1.062,
										-1.029
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-1.52,
										0
									],
									[
										0,
										0
									],
									[
										-1.018,
										0.985
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										1.586
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-3.105,
										0
									],
									[
										0,
										0
									],
									[
										0,
										1.586
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										1.017,
										0.985
									],
									[
										0,
										0
									],
									[
										1.519,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										1.062,
										-1.029
									],
									[
										0,
										0
									],
									[
										0,
										-3.105
									]
								],
								v: [
									[
										29.639,
										-25.405
									],
									[
										-29.639,
										-25.405
									],
									[
										-35.285,
										-19.759
									],
									[
										-35.285,
										19.759
									],
									[
										-33.555,
										23.806
									],
									[
										-7.812,
										0
									],
									[
										-33.555,
										23.806
									],
									[
										-29.639,
										25.405
									],
									[
										29.639,
										25.405
									],
									[
										33.555,
										23.806
									],
									[
										7.812,
										0
									],
									[
										33.555,
										23.806
									],
									[
										35.285,
										19.759
									],
									[
										35.285,
										-19.759
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 82,
							ix: 2
						},
						o: {
							a: 0,
							k: 62,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.125490196078,
								0.63137254902,
								0.419607873056,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.068,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								42.955,
								33.075
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.54
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.46
								],
								y: [
									0
								]
							},
							t: 8,
							s: [
								22
							]
						},
						{
							t: 20,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.54
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.46
								],
								y: [
									0
								]
							},
							t: 15,
							s: [
								22
							]
						},
						{
							t: 25,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 102,
					ix: 3
				},
				m: 1,
				ix: 3,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 7,
		op: 350,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "accents-trim-path",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					83.5,
					34,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-82,
										-9
									],
									[
										53.75,
										-9
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.602
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.489
										],
										y: [
											0
										]
									},
									t: 6.923,
									s: [
										0
									]
								},
								{
									t: 19.23046875,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.93
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.636
										],
										y: [
											0.001
										]
									},
									t: 0,
									s: [
										0
									]
								},
								{
									t: 11.5380859375,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-82,
										0.5
									],
									[
										53.75,
										0.5
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.602
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.489
										],
										y: [
											0
										]
									},
									t: 13.077,
									s: [
										0
									]
								},
								{
									t: 25.384765625,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.93
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.636
										],
										y: [
											0.001
										]
									},
									t: 6.154,
									s: [
										0
									]
								},
								{
									t: 17.6923828125,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 2",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-82,
										9
									],
									[
										53.75,
										9
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.602
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.489
										],
										y: [
											0
										]
									},
									t: 17.692,
									s: [
										0
									]
								},
								{
									t: 30,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.93
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.636
										],
										y: [
											0.001
										]
									},
									t: 10.77,
									s: [
										0
									]
								},
								{
									t: 22.3076171875,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 3",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 350,
		st: 0,
		bm: 0
	}
];
var markers$4 = [
];
var animationData$4 = {
	v: v$4,
	fr: fr$4,
	ip: ip$4,
	op: op$4,
	w: w$4,
	h: h$4,
	nm: nm$4,
	ddd: ddd$4,
	assets: assets$4,
	layers: layers$4,
	markers: markers$4
};

var lib$2 = {};

var lodash_clonedeep = {exports: {}};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash_clonedeep.exports;

(function (module, exports) {
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;

	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];

	  var length = result.length,
	      skipIndexes = !!length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}

	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;

	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);

	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}

	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}

	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}

	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}

	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}

	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}

	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}

	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}

	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}

	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;

	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}

	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}

	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);

	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}

	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);

	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);

	    case dataViewTag:
	      return cloneDataView(object, isDeep);

	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);

	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);

	    case numberTag:
	    case stringTag:
	      return new Ctor(object);

	    case regexpTag:
	      return cloneRegExp(object);

	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);

	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	module.exports = cloneDeep; 
} (lodash_clonedeep, lodash_clonedeep.exports));

var lodash_clonedeepExports = lodash_clonedeep.exports;

var __spreadArrays = (commonjsGlobal && commonjsGlobal.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(lib$2, "__esModule", { value: true });
lib$2.getColors = lib$2.flatten = replaceColor = lib$2.replaceColor = lib$2.colorify = void 0;
var lodash_clonedeep_1 = __importDefault(lodash_clonedeepExports);
lib$2.colorify = function (destColors, lottie) {
    if (destColors === void 0) { destColors = []; }
    var modifiedColors = [];
    for (var _i = 0, destColors_1 = destColors; _i < destColors_1.length; _i++) {
        var color = destColors_1[_i];
        modifiedColors.push(convertColorToLottieColor(color));
    }
    var newLottie = modifyColors(modifiedColors, lodash_clonedeep_1.default(lottie));
    return newLottie;
};
var convertColorToLottieColor = function (color) {
    if (typeof color === 'string' && color.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i)) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        if (!result) {
            throw new Error('Color can be only hex or rgb array (ex. [10,20,30])');
        }
        return [
            Math.round((parseInt(result[1], 16) / 255) * 1000) / 1000,
            Math.round((parseInt(result[2], 16) / 255) * 1000) / 1000,
            Math.round((parseInt(result[3], 16) / 255) * 1000) / 1000,
        ];
    }
    else if (typeof color === 'object' && color.length === 3 && color.every(function (item) { return item >= 0 && item <= 255; })) {
        return [
            Math.round((color[0] / 255) * 1000) / 1000,
            Math.round((color[1] / 255) * 1000) / 1000,
            Math.round((color[2] / 255) * 1000) / 1000,
        ];
    }
    else if (!color) {
        return undefined;
    }
    else {
        throw new Error('Color can be only hex or rgb array (ex. [10,20,30])');
    }
};
var round = function (n) { return Math.round(n * 1000) / 1000; };
var replaceColor = lib$2.replaceColor = function (sourceColor, targetColor, lottieObj) {
    var genSourceLottieColor = convertColorToLottieColor(sourceColor);
    var genTargetLottieColor = convertColorToLottieColor(targetColor);
    if (!genSourceLottieColor || !genTargetLottieColor) {
        throw new Error('Proper colors must be used for both source and target');
    }
    function doReplace(sourceLottieColor, targetLottieColor, obj) {
        if (obj.s && Array.isArray(obj.s) && obj.s.length === 4) {
            if (sourceLottieColor[0] === obj.s[0] && sourceLottieColor[1] === obj.s[1] && sourceLottieColor[2] === obj.s[2]) {
                obj.s = __spreadArrays(targetLottieColor, [1]);
            }
        }
        else if (obj.c && obj.c.k) {
            if (Array.isArray(obj.c.k) && typeof obj.c.k[0] !== 'number') {
                doReplace(sourceLottieColor, targetLottieColor, obj.c.k);
            }
            else if (sourceLottieColor[0] === round(obj.c.k[0]) &&
                sourceLottieColor[1] === round(obj.c.k[1]) &&
                sourceLottieColor[2] === round(obj.c.k[2])) {
                obj.c.k = targetLottieColor;
            }
        }
        else {
            for (var key in obj) {
                if (typeof obj[key] === 'object') {
                    doReplace(sourceLottieColor, targetLottieColor, obj[key]);
                }
            }
        }
        return obj;
    }
    return doReplace(genSourceLottieColor, genTargetLottieColor, lodash_clonedeep_1.default(lottieObj));
};
lib$2.flatten = function (targetColor, lottieObj) {
    var genTargetLottieColor = convertColorToLottieColor(targetColor);
    if (!genTargetLottieColor) {
        throw new Error('Proper colors must be used for target');
    }
    function doFlatten(targetLottieColor, obj) {
        if (obj.s && Array.isArray(obj.s) && obj.s.length === 4) {
            obj.s = __spreadArrays(targetLottieColor, [1]);
        }
        else if (obj.c && obj.c.k) {
            if (Array.isArray(obj.c.k) && typeof obj.c.k[0] !== 'number') {
                doFlatten(targetLottieColor, obj.c.k);
            }
            else {
                obj.c.k = targetLottieColor;
            }
        }
        else {
            for (var key in obj) {
                if (typeof obj[key] === 'object') {
                    doFlatten(targetLottieColor, obj[key]);
                }
            }
        }
        return obj;
    }
    return doFlatten(genTargetLottieColor, lodash_clonedeep_1.default(lottieObj));
};
var modifyColors = function (colorsArray, lottieObj) {
    var i = 0;
    function doModify(colors, obj) {
        if (obj.s && Array.isArray(obj.s) && obj.s.length === 4) {
            if (colors[i]) {
                obj.s = __spreadArrays(colors[i], [1]);
            }
            i++;
        }
        else if (obj.c && obj.c.k) {
            if (Array.isArray(obj.c.k) && typeof obj.c.k[0] !== 'number') {
                doModify(colors, obj.c.k);
            }
            else {
                if (colors[i]) {
                    obj.c.k = colors[i];
                }
                i++;
            }
        }
        for (var key in obj) {
            if (typeof obj[key] === 'object') {
                doModify(colors, obj[key]);
            }
        }
        return obj;
    }
    return doModify(colorsArray, lottieObj);
};
var convertLottieColorToRgb = function (lottieColor) {
    return [Math.round(lottieColor[0] * 255), Math.round(lottieColor[1] * 255), Math.round(lottieColor[2] * 255)];
};
var convertLottieColorToRgba = function (lottieColor) {
    return [
        Math.round(lottieColor[0] * 255),
        Math.round(lottieColor[1] * 255),
        Math.round(lottieColor[2] * 255),
        lottieColor[3],
    ];
};
lib$2.getColors = function (lottieObj) {
    var res = [];
    function doGet(obj) {
        if (obj.s && Array.isArray(obj.s) && obj.s.length === 4) {
            res.push(convertLottieColorToRgba(obj.s));
        }
        else if (obj.c && obj.c.k) {
            if (Array.isArray(obj.c.k) && typeof obj.c.k[0] !== 'number') {
                doGet(obj.c.k);
            }
            else {
                res.push(convertLottieColorToRgb(obj.c.k));
            }
        }
        else {
            for (var key in obj) {
                if (typeof obj[key] === 'object') {
                    doGet(obj[key]);
                }
            }
        }
        return res;
    }
    doGet(lottieObj);
    return res;
};

function EmailAnimation({
  primaryColor
}) {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: replaceColor('#20A26B', primaryColor, animationData$4),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return /*#__PURE__*/React$1.createElement(_default, {
    options: defaultOptions
  });
}

var v$3 = "4.8.0";
var meta = {
	g: "LottieFiles AE ",
	a: "",
	k: "",
	d: "",
	tc: ""
};
var fr$3 = 30;
var ip$3 = 0;
var op$3 = 31;
var w$3 = 800;
var h$3 = 200;
var nm$3 = "Loading Files";
var ddd$3 = 0;
var assets$3 = [
];
var layers$3 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Search",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.97,
							y: 1
						},
						o: {
							x: 0.69,
							y: 0
						},
						t: 0,
						s: [
							351.535,
							97.918,
							0
						],
						to: [
							6,
							-17,
							0
						],
						ti: [
							11,
							14.25,
							0
						]
					},
					{
						t: 30,
						s: [
							351.535,
							99.418,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					352.535,
					96.918,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										16.521,
										-0.045
									],
									[
										-0.013,
										-34.356
									],
									[
										-34.356,
										0.012
									],
									[
										0.011,
										34.356
									],
									[
										11.651,
										11.659
									]
								],
								o: [
									[
										-34.356,
										0.012
									],
									[
										0.011,
										34.356
									],
									[
										34.356,
										-0.013
									],
									[
										-0.006,
										-16.483
									],
									[
										-11.651,
										-11.715
									]
								],
								v: [
									[
										-0.089,
										-62.489
									],
									[
										-62.274,
										-0.26
									],
									[
										-0.046,
										61.927
									],
									[
										62.142,
										-0.304
									],
									[
										43.936,
										-44.254
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										9.639,
										0.013
									],
									[
										-0.054,
										41.136
									],
									[
										-41.136,
										-0.054
									],
									[
										0.054,
										-41.137
									],
									[
										28.059,
										-11.391
									]
								],
								o: [
									[
										-41.136,
										-0.054
									],
									[
										0.054,
										-41.137
									],
									[
										41.136,
										0.055
									],
									[
										-0.039,
										30.282
									],
									[
										-8.929,
										3.626
									]
								],
								v: [
									[
										-0.098,
										74.485
									],
									[
										-74.484,
										-0.097
									],
									[
										0.098,
										-74.485
									],
									[
										74.484,
										0.098
									],
									[
										28.019,
										69.014
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.792156875134,
								0.807843148708,
								0.835294127464,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								383.401,
								89.476
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Subtraction 48",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										2.999,
										-2.999
									],
									[
										0,
										0
									],
									[
										2.999,
										2.999
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										2.999,
										2.999
									],
									[
										0,
										0
									],
									[
										-2.999,
										2.999
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-25.254,
										-8.902
									],
									[
										-8.902,
										-25.254
									],
									[
										-8.902,
										-25.254
									],
									[
										23.005,
										6.653
									],
									[
										23.005,
										17.514
									],
									[
										17.514,
										23.005
									],
									[
										6.653,
										23.005
									],
									[
										-25.254,
										-8.902
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.713725507259,
								0.733333349228,
								0.768627464771,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								446.9,
								153.591
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Rectangle 4757",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 510,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Files 5",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.24
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.172
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						t: 30,
						s: [
							50
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.24,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.172
						},
						t: 0,
						s: [
							723.194,
							100.918,
							0
						],
						to: [
							-25.25,
							-0.583,
							0
						],
						ti: [
							25.25,
							0.583,
							0
						]
					},
					{
						t: 30,
						s: [
							571.694,
							97.418,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					723.194,
					96.918,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.24,
								0.24,
								0.24
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.172,
								0.172,
								11.207
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 30,
						s: [
							165,
							165,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.019,
										-0.326
									],
									[
										0,
										0
									],
									[
										0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										0.326
									],
									[
										0,
										0
									],
									[
										-0.326,
										0.019
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.326,
										0.019
									],
									[
										0,
										0
									],
									[
										-0.019,
										0.326
									],
									[
										0,
										0
									],
									[
										-0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										-0.326
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-18.935,
										-8.56
									],
									[
										-10.273,
										-8.56
									],
									[
										-9.669,
										-7.956
									],
									[
										-9.669,
										-5.943
									],
									[
										-10.273,
										-5.338
									],
									[
										-18.935,
										-5.338
									],
									[
										-19.54,
										-5.943
									],
									[
										-19.54,
										-7.957
									],
									[
										-18.935,
										-8.562
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.019,
										-0.326
									],
									[
										0,
										0
									],
									[
										0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										0.326
									],
									[
										0,
										0
									],
									[
										-0.326,
										0.019
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.326,
										0.019
									],
									[
										0,
										0
									],
									[
										-0.019,
										0.326
									],
									[
										0,
										0
									],
									[
										-0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										-0.326
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-18.935,
										-0.906
									],
									[
										18.935,
										-0.906
									],
									[
										19.54,
										-0.301
									],
									[
										19.54,
										1.713
									],
									[
										18.935,
										2.318
									],
									[
										-18.935,
										2.318
									],
									[
										-19.54,
										1.713
									],
									[
										-19.54,
										-0.302
									],
									[
										-18.935,
										-0.907
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 2,
						ty: "sh",
						ix: 3,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.325,
										0.019
									],
									[
										0,
										0
									],
									[
										-0.019,
										-0.326
									],
									[
										0,
										0
									],
									[
										0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										0.326
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.326,
										0.019
									],
									[
										0,
										0
									],
									[
										-0.019,
										0.326
									],
									[
										0,
										0
									],
									[
										-0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										-0.325
									]
								],
								v: [
									[
										-18.935,
										5.943
									],
									[
										18.935,
										5.943
									],
									[
										19.54,
										6.547
									],
									[
										19.54,
										8.562
									],
									[
										18.935,
										9.166
									],
									[
										-18.935,
										9.166
									],
									[
										-19.54,
										8.562
									],
									[
										-19.54,
										6.546
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 3",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 3,
						ty: "sh",
						ix: 4,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.326,
										0.019
									],
									[
										0,
										0
									],
									[
										-0.019,
										-0.326
									],
									[
										0,
										0
									],
									[
										0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										0.326
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.326,
										0.019
									],
									[
										0,
										0
									],
									[
										-0.019,
										0.326
									],
									[
										0,
										0
									],
									[
										-0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										-0.326
									]
								],
								v: [
									[
										-18.935,
										12.791
									],
									[
										-0.604,
										12.791
									],
									[
										0.001,
										13.396
									],
									[
										0.001,
										15.41
									],
									[
										-0.604,
										16.014
									],
									[
										-18.935,
										16.014
									],
									[
										-19.54,
										15.41
									],
									[
										-19.54,
										13.396
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 4",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 4,
						ty: "sh",
						ix: 5,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.326,
										0.019
									],
									[
										0,
										0
									],
									[
										-0.019,
										-0.326
									],
									[
										0,
										0
									],
									[
										0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										0.326
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.326,
										0.019
									],
									[
										0,
										0
									],
									[
										-0.019,
										0.326
									],
									[
										0,
										0
									],
									[
										-0.326,
										-0.019
									],
									[
										0,
										0
									],
									[
										0.019,
										-0.326
									]
								],
								v: [
									[
										-18.935,
										-16.014
									],
									[
										-6.446,
										-16.014
									],
									[
										-5.842,
										-15.41
									],
									[
										-5.842,
										-13.396
									],
									[
										-6.446,
										-12.791
									],
									[
										-18.935,
										-12.791
									],
									[
										-19.54,
										-13.396
									],
									[
										-19.54,
										-15.41
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 5",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.698039233685,
								0.75686275959,
								0.819607853889,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								723.194,
								96.817
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2951",
				np: 6,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-9.468,
										-9.468
									],
									[
										9.468,
										9.468
									],
									[
										-9.468,
										9.468
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.698039233685,
								0.75686275959,
								0.819607853889,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								738.705,
								74.961
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2950",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.025,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										2.872,
										-0.021
									],
									[
										0.025,
										0
									],
									[
										0,
										0
									],
									[
										0.022,
										2.872
									],
									[
										0,
										0.026
									],
									[
										0,
										0
									],
									[
										-2.872,
										0.021
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.021,
										2.872
									],
									[
										-0.025,
										0
									],
									[
										0,
										0
									],
									[
										-2.872,
										0.022
									],
									[
										0,
										-0.026
									],
									[
										0,
										0
									],
									[
										-0.021,
										-2.872
									],
									[
										0.025,
										0
									]
								],
								v: [
									[
										-19.64,
										-31.424
									],
									[
										5.942,
										-31.424
									],
									[
										24.878,
										-12.489
									],
									[
										24.878,
										26.187
									],
									[
										19.715,
										31.424
									],
									[
										19.64,
										31.424
									],
									[
										-19.638,
										31.424
									],
									[
										-24.878,
										26.264
									],
									[
										-24.878,
										26.187
									],
									[
										-24.878,
										-26.187
									],
									[
										-19.715,
										-31.424
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.850980401039,
								0.890196084976,
								0.921568632126,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								723.094,
								96.918
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2949",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 510,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Files 4",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.24
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.172
							]
						},
						t: 0,
						s: [
							50
						]
					},
					{
						t: 30,
						s: [
							100
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.24,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.172
						},
						t: 0,
						s: [
							570.918,
							96.918,
							0
						],
						to: [
							-30,
							0,
							0
						],
						ti: [
							30,
							0,
							0
						]
					},
					{
						t: 30,
						s: [
							390.918,
							96.918,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					570.918,
					96.918,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.24,
								0.24,
								0.24
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.172,
								0.172,
								4.483
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 30,
						s: [
							126,
							126,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										0.032
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										-0.549
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-31.928,
										-14.435
									],
									[
										-17.322,
										-14.435
									],
									[
										-16.303,
										-13.415
									],
									[
										-16.303,
										-10.021
									],
									[
										-17.322,
										-9.001
									],
									[
										-31.928,
										-9.001
									],
									[
										-32.948,
										-10.021
									],
									[
										-32.948,
										-13.417
									],
									[
										-31.928,
										-14.436
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										0.032
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										-0.549
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-31.928,
										-1.527
									],
									[
										31.928,
										-1.527
									],
									[
										32.948,
										-0.508
									],
									[
										32.948,
										2.889
									],
									[
										31.928,
										3.908
									],
									[
										-31.928,
										3.908
									],
									[
										-32.948,
										2.889
									],
									[
										-32.948,
										-0.51
									],
									[
										-31.928,
										-1.529
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 2,
						ty: "sh",
						ix: 3,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.033,
										-0.548
									]
								],
								v: [
									[
										-31.928,
										10.021
									],
									[
										31.928,
										10.021
									],
									[
										32.948,
										11.04
									],
									[
										32.948,
										14.436
									],
									[
										31.928,
										15.456
									],
									[
										-31.928,
										15.456
									],
									[
										-32.948,
										14.436
									],
									[
										-32.948,
										11.038
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 3",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 3,
						ty: "sh",
						ix: 4,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										-0.549
									]
								],
								v: [
									[
										-31.928,
										21.568
									],
									[
										-1.018,
										21.568
									],
									[
										0.001,
										22.588
									],
									[
										0.001,
										25.984
									],
									[
										-1.018,
										27.004
									],
									[
										-31.928,
										27.004
									],
									[
										-32.948,
										25.984
									],
									[
										-32.948,
										22.588
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 4",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 4,
						ty: "sh",
						ix: 5,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										-0.549
									]
								],
								v: [
									[
										-31.928,
										-27.004
									],
									[
										-10.87,
										-27.004
									],
									[
										-9.85,
										-25.984
									],
									[
										-9.85,
										-22.588
									],
									[
										-10.87,
										-21.568
									],
									[
										-31.928,
										-21.568
									],
									[
										-32.948,
										-22.588
									],
									[
										-32.948,
										-25.984
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 5",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.698039233685,
								0.75686275959,
								0.819607853889,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								570.918,
								96.747
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2951",
				np: 6,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-15.965,
										-15.965
									],
									[
										15.965,
										15.965
									],
									[
										-15.965,
										15.965
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.698039233685,
								0.75686275959,
								0.819607853889,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								597.073,
								59.895
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2950",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.042,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										4.843,
										-0.035
									],
									[
										0.042,
										0
									],
									[
										0,
										0
									],
									[
										0.037,
										4.843
									],
									[
										0,
										0.043
									],
									[
										0,
										0
									],
									[
										-4.843,
										0.035
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.035,
										4.843
									],
									[
										-0.042,
										0
									],
									[
										0,
										0
									],
									[
										-4.843,
										0.037
									],
									[
										0,
										-0.043
									],
									[
										0,
										0
									],
									[
										-0.035,
										-4.843
									],
									[
										0.042,
										0
									]
								],
								v: [
									[
										-33.117,
										-52.988
									],
									[
										10.02,
										-52.988
									],
									[
										41.949,
										-21.059
									],
									[
										41.949,
										44.156
									],
									[
										33.243,
										52.988
									],
									[
										33.117,
										52.988
									],
									[
										-33.113,
										52.988
									],
									[
										-41.949,
										44.286
									],
									[
										-41.949,
										44.156
									],
									[
										-41.949,
										-44.156
									],
									[
										-33.243,
										-52.988
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.850980401039,
								0.890196084976,
								0.921568632126,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								570.748,
								96.918
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2949",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 510,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "Files 3",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.24
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.172
							]
						},
						t: 0,
						s: [
							100
						]
					},
					{
						t: 30,
						s: [
							50
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.24,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.172
						},
						t: 0,
						s: [
							390.535,
							96.918,
							0
						],
						to: [
							-30,
							0,
							0
						],
						ti: [
							30,
							0,
							0
						]
					},
					{
						t: 30,
						s: [
							210.535,
							96.918,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					390.535,
					96.918,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.24,
								0.24,
								0.24
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.172,
								0.172,
								-3.793
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 30,
						s: [
							78,
							78,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.04,
										-0.692
									],
									[
										0,
										0
									],
									[
										0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										0.692
									],
									[
										0,
										0
									],
									[
										-0.692,
										0.04
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.692,
										0.04
									],
									[
										0,
										0
									],
									[
										-0.04,
										0.692
									],
									[
										0,
										0
									],
									[
										-0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										-0.692
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-40.242,
										-18.193
									],
									[
										-21.833,
										-18.193
									],
									[
										-20.548,
										-16.908
									],
									[
										-20.548,
										-12.63
									],
									[
										-21.833,
										-11.345
									],
									[
										-40.242,
										-11.345
									],
									[
										-41.526,
										-12.63
									],
									[
										-41.526,
										-16.911
									],
									[
										-40.242,
										-18.195
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.04,
										-0.692
									],
									[
										0,
										0
									],
									[
										0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										0.692
									],
									[
										0,
										0
									],
									[
										-0.692,
										0.04
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.692,
										0.04
									],
									[
										0,
										0
									],
									[
										-0.04,
										0.692
									],
									[
										0,
										0
									],
									[
										-0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										-0.692
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-40.242,
										-1.925
									],
									[
										40.242,
										-1.925
									],
									[
										41.526,
										-0.64
									],
									[
										41.526,
										3.641
									],
									[
										40.242,
										4.926
									],
									[
										-40.242,
										4.926
									],
									[
										-41.526,
										3.641
									],
									[
										-41.526,
										-0.642
									],
									[
										-40.242,
										-1.927
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 2,
						ty: "sh",
						ix: 3,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.691,
										0.04
									],
									[
										0,
										0
									],
									[
										-0.04,
										-0.692
									],
									[
										0,
										0
									],
									[
										0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										0.692
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.692,
										0.04
									],
									[
										0,
										0
									],
									[
										-0.04,
										0.692
									],
									[
										0,
										0
									],
									[
										-0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.041,
										-0.691
									]
								],
								v: [
									[
										-40.242,
										12.63
									],
									[
										40.242,
										12.63
									],
									[
										41.526,
										13.914
									],
									[
										41.526,
										18.195
									],
									[
										40.242,
										19.48
									],
									[
										-40.242,
										19.48
									],
									[
										-41.526,
										18.195
									],
									[
										-41.526,
										13.912
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 3",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 3,
						ty: "sh",
						ix: 4,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.692,
										0.04
									],
									[
										0,
										0
									],
									[
										-0.04,
										-0.692
									],
									[
										0,
										0
									],
									[
										0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										0.692
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.692,
										0.04
									],
									[
										0,
										0
									],
									[
										-0.04,
										0.692
									],
									[
										0,
										0
									],
									[
										-0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										-0.692
									]
								],
								v: [
									[
										-40.242,
										27.184
									],
									[
										-1.284,
										27.184
									],
									[
										0.001,
										28.469
									],
									[
										0.001,
										32.75
									],
									[
										-1.284,
										34.035
									],
									[
										-40.242,
										34.035
									],
									[
										-41.526,
										32.75
									],
									[
										-41.526,
										28.469
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 4",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 4,
						ty: "sh",
						ix: 5,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.692,
										0.04
									],
									[
										0,
										0
									],
									[
										-0.04,
										-0.692
									],
									[
										0,
										0
									],
									[
										0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										0.692
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.692,
										0.04
									],
									[
										0,
										0
									],
									[
										-0.04,
										0.692
									],
									[
										0,
										0
									],
									[
										-0.692,
										-0.04
									],
									[
										0,
										0
									],
									[
										0.04,
										-0.692
									]
								],
								v: [
									[
										-40.242,
										-34.035
									],
									[
										-13.7,
										-34.035
									],
									[
										-12.415,
										-32.75
									],
									[
										-12.415,
										-28.469
									],
									[
										-13.7,
										-27.184
									],
									[
										-40.242,
										-27.184
									],
									[
										-41.526,
										-28.469
									],
									[
										-41.526,
										-32.75
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 5",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.698039233685,
								0.75686275959,
								0.819607853889,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								390.534,
								96.702
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2951",
				np: 6,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-20.121,
										-20.121
									],
									[
										20.121,
										20.121
									],
									[
										-20.121,
										20.121
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.698039233685,
								0.75686275959,
								0.819607853889,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								423.5,
								50.255
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2950",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.053,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										6.104,
										-0.044
									],
									[
										0.053,
										0
									],
									[
										0,
										0
									],
									[
										0.047,
										6.104
									],
									[
										0,
										0.055
									],
									[
										0,
										0
									],
									[
										-6.104,
										0.044
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.044,
										6.104
									],
									[
										-0.053,
										0
									],
									[
										0,
										0
									],
									[
										-6.104,
										0.047
									],
									[
										0,
										-0.055
									],
									[
										0,
										0
									],
									[
										-0.044,
										-6.104
									],
									[
										0.053,
										0
									]
								],
								v: [
									[
										-41.74,
										-66.785
									],
									[
										12.628,
										-66.785
									],
									[
										52.871,
										-26.542
									],
									[
										52.871,
										55.653
									],
									[
										41.899,
										66.785
									],
									[
										41.74,
										66.785
									],
									[
										-41.735,
										66.785
									],
									[
										-52.871,
										55.817
									],
									[
										-52.871,
										55.653
									],
									[
										-52.871,
										-55.653
									],
									[
										-41.899,
										-66.785
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.850980401039,
								0.890196084976,
								0.921568632126,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								390.321,
								96.918
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2949",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 510,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "Files 2",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.24
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.172
							]
						},
						t: 0,
						s: [
							50
						]
					},
					{
						t: 30,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.24,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.172
						},
						t: 0,
						s: [
							210.152,
							96.918,
							0
						],
						to: [
							-22,
							0,
							0
						],
						ti: [
							22,
							0,
							0
						]
					},
					{
						t: 30,
						s: [
							78.151,
							96.918,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					210.152,
					96.918,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.24,
								0.24,
								0.24
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.172,
								0.172,
								-6.897
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 30,
						s: [
							60,
							60,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										0.032
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										-0.549
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-31.928,
										-14.435
									],
									[
										-17.322,
										-14.435
									],
									[
										-16.303,
										-13.415
									],
									[
										-16.303,
										-10.021
									],
									[
										-17.322,
										-9.001
									],
									[
										-31.928,
										-9.001
									],
									[
										-32.948,
										-10.021
									],
									[
										-32.948,
										-13.417
									],
									[
										-31.928,
										-14.436
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										0.032
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										-0.549
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-31.928,
										-1.527
									],
									[
										31.928,
										-1.527
									],
									[
										32.948,
										-0.508
									],
									[
										32.948,
										2.889
									],
									[
										31.928,
										3.908
									],
									[
										-31.928,
										3.908
									],
									[
										-32.948,
										2.889
									],
									[
										-32.948,
										-0.51
									],
									[
										-31.928,
										-1.529
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 2,
						ty: "sh",
						ix: 3,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.033,
										-0.548
									]
								],
								v: [
									[
										-31.928,
										10.021
									],
									[
										31.928,
										10.021
									],
									[
										32.948,
										11.04
									],
									[
										32.948,
										14.436
									],
									[
										31.928,
										15.456
									],
									[
										-31.928,
										15.456
									],
									[
										-32.948,
										14.436
									],
									[
										-32.948,
										11.038
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 3",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 3,
						ty: "sh",
						ix: 4,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										-0.549
									]
								],
								v: [
									[
										-31.928,
										21.568
									],
									[
										-1.018,
										21.568
									],
									[
										0.001,
										22.588
									],
									[
										0.001,
										25.984
									],
									[
										-1.018,
										27.004
									],
									[
										-31.928,
										27.004
									],
									[
										-32.948,
										25.984
									],
									[
										-32.948,
										22.588
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 4",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 4,
						ty: "sh",
						ix: 5,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										-0.549
									],
									[
										0,
										0
									],
									[
										0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										0.549
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0.549,
										0.032
									],
									[
										0,
										0
									],
									[
										-0.032,
										0.549
									],
									[
										0,
										0
									],
									[
										-0.549,
										-0.032
									],
									[
										0,
										0
									],
									[
										0.032,
										-0.549
									]
								],
								v: [
									[
										-31.928,
										-27.004
									],
									[
										-10.87,
										-27.004
									],
									[
										-9.85,
										-25.984
									],
									[
										-9.85,
										-22.588
									],
									[
										-10.87,
										-21.568
									],
									[
										-31.928,
										-21.568
									],
									[
										-32.948,
										-22.588
									],
									[
										-32.948,
										-25.984
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 5",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.698039233685,
								0.75686275959,
								0.819607853889,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								210.151,
								96.747
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2951",
				np: 6,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-15.965,
										-15.965
									],
									[
										15.965,
										15.965
									],
									[
										-15.965,
										15.965
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.698039233685,
								0.75686275959,
								0.819607853889,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								236.306,
								59.895
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2950",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.042,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										4.843,
										-0.035
									],
									[
										0.042,
										0
									],
									[
										0,
										0
									],
									[
										0.037,
										4.843
									],
									[
										0,
										0.043
									],
									[
										0,
										0
									],
									[
										-4.843,
										0.035
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.035,
										4.843
									],
									[
										-0.042,
										0
									],
									[
										0,
										0
									],
									[
										-4.843,
										0.037
									],
									[
										0,
										-0.043
									],
									[
										0,
										0
									],
									[
										-0.035,
										-4.843
									],
									[
										0.042,
										0
									]
								],
								v: [
									[
										-33.117,
										-52.988
									],
									[
										10.02,
										-52.988
									],
									[
										41.949,
										-21.059
									],
									[
										41.949,
										44.156
									],
									[
										33.243,
										52.988
									],
									[
										33.117,
										52.988
									],
									[
										-33.113,
										52.988
									],
									[
										-41.949,
										44.286
									],
									[
										-41.949,
										44.156
									],
									[
										-41.949,
										-44.156
									],
									[
										-33.243,
										-52.988
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.850980401039,
								0.890196084976,
								0.921568632126,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								209.981,
								96.918
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 2949",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 510,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 1,
		nm: "BG",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					400,
					100,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					400,
					100,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		sw: 800,
		sh: 200,
		sc: "transparent",
		ip: 0,
		op: 510,
		st: 0,
		bm: 0
	}
];
var markers$3 = [
];
var animationData$3 = {
	v: v$3,
	meta: meta,
	fr: fr$3,
	ip: ip$3,
	op: op$3,
	w: w$3,
	h: h$3,
	nm: nm$3,
	ddd: ddd$3,
	assets: assets$3,
	layers: layers$3,
	markers: markers$3
};

function FileLoadAnimation() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData$3,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return /*#__PURE__*/React$1.createElement(_default, {
    options: defaultOptions
  });
}

var v$2 = "5.9.0";
var fr$2 = 25;
var ip$2 = 0;
var op$2 = 200;
var w$2 = 512;
var h$2 = 512;
var nm$2 = "loader";
var ddd$2 = 0;
var assets$2 = [
];
var layers$2 = [
	{
		ddd: 0,
		ind: 1,
		ty: 3,
		nm: "Null 3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 17,
						s: [
							-10
						]
					},
					{
						t: 124,
						s: [
							370
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					256,
					256,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					50,
					50,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		ip: 0,
		op: 1500,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "light-blue 3",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					47.313,
					46.513,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								374,
								374
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.286274509804,
								0.56862745098,
								0.898039215686,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 116,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								2.687,
								3.487
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.184
								],
								y: [
									0.901
								]
							},
							o: {
								x: [
									0.79
								],
								y: [
									0
								]
							},
							t: 43,
							s: [
								0
							]
						},
						{
							t: 76,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 44,
							s: [
								-12
							]
						},
						{
							t: 45,
							s: [
								0
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.821
								],
								y: [
									0.858
								]
							},
							o: {
								x: [
									0.545
								],
								y: [
									0
								]
							},
							t: 78,
							s: [
								0
							]
						},
						{
							i: {
								x: [
									0.677
								],
								y: [
									-0.039
								]
							},
							o: {
								x: [
									0.344
								],
								y: [
									2.922
								]
							},
							t: 110,
							s: [
								98.275
							]
						},
						{
							t: 116,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 3,
				nm: "Trim Paths 2",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 45,
		op: 111,
		st: 26,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "blue",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					47.313,
					46.513,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								374,
								374
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.211764705882,
								0.274509803922,
								0.850980392157,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 116,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								2.687,
								3.487
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.184
								],
								y: [
									0.913
								]
							},
							o: {
								x: [
									0.79
								],
								y: [
									0
								]
							},
							t: 26,
							s: [
								0
							]
						},
						{
							t: 55,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.827
								],
								y: [
									0.947
								]
							},
							o: {
								x: [
									0.68
								],
								y: [
									0
								]
							},
							t: 83,
							s: [
								0
							]
						},
						{
							t: 116,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 3,
				nm: "Trim Paths 2",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 20,
		op: 165,
		st: 5,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "light-blue 4",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					47.313,
					46.513,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								374,
								374
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.286274509804,
								0.56862745098,
								0.898039215686,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 116,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								2.687,
								3.487
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.184
								],
								y: [
									0.901
								]
							},
							o: {
								x: [
									0.79
								],
								y: [
									0
								]
							},
							t: 17,
							s: [
								0
							]
						},
						{
							t: 50,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.827
								],
								y: [
									0.935
								]
							},
							o: {
								x: [
									0.79
								],
								y: [
									0
								]
							},
							t: 83,
							s: [
								0
							]
						},
						{
							t: 124,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 3,
				nm: "Trim Paths 2",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 15,
		op: 145,
		st: 0,
		bm: 0
	}
];
var markers$2 = [
];
var animationData$2 = {
	v: v$2,
	fr: fr$2,
	ip: ip$2,
	op: op$2,
	w: w$2,
	h: h$2,
	nm: nm$2,
	ddd: ddd$2,
	assets: assets$2,
	layers: layers$2,
	markers: markers$2
};

function SpinnerAnimation() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData$2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return /*#__PURE__*/React$1.createElement(_default, {
    options: defaultOptions
  });
}

var v$1 = "5.9.0";
var fr$1 = 25;
var ip$1 = 0;
var op$1 = 226;
var w$1 = 280;
var h$1 = 280;
var nm$1 = "Certification-icon";
var ddd$1 = 0;
var assets$1 = [
];
var layers$1 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "glare-glowing-12",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 168,
						s: [
							0
						]
					},
					{
						t: 218,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					236,
					73.75,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 168,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 191,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 218,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.254,
								-0.245
							],
							[
								0.021,
								-0.019
							],
							[
								0.434,
								-0.38
							],
							[
								-0.064,
								-0.314
							],
							[
								-0.006,
								-0.029
							],
							[
								0.156,
								-0.085
							],
							[
								0.042,
								0
							],
							[
								0.222,
								0.127
							],
							[
								0.024,
								0.015
							],
							[
								0.494,
								0.315
							],
							[
								0.007,
								-0.004
							],
							[
								0.14,
								-0.08
							],
							[
								0.107,
								0
							],
							[
								0.032,
								0.017
							],
							[
								-0.082,
								0.373
							],
							[
								-0.004,
								0.021
							],
							[
								-0.097,
								0.434
							],
							[
								0.006,
								0.005
							],
							[
								0.117,
								0.113
							],
							[
								-0.02,
								0.133
							],
							[
								-0.364,
								0.038
							],
							[
								-0.021,
								0.002
							],
							[
								-0.413,
								0.041
							],
							[
								-0.121,
								0.286
							],
							[
								-0.011,
								0.027
							],
							[
								-0.162,
								0
							],
							[
								0,
								0
							],
							[
								-0.003,
								-0.001
							],
							[
								-0.004,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.132,
								-0.326
							],
							[
								-0.008,
								-0.02
							],
							[
								-0.191,
								-0.478
							],
							[
								-0.303,
								-0.038
							],
							[
								-0.029,
								-0.003
							],
							[
								-0.027,
								-0.182
							]
						],
						o: [
							[
								-0.117,
								0.113
							],
							[
								-0.006,
								0.005
							],
							[
								0.097,
								0.434
							],
							[
								0.004,
								0.021
							],
							[
								0.083,
								0.373
							],
							[
								-0.032,
								0.017
							],
							[
								-0.107,
								0
							],
							[
								-0.14,
								-0.08
							],
							[
								-0.007,
								-0.004
							],
							[
								-0.493,
								0.315
							],
							[
								-0.024,
								0.015
							],
							[
								-0.222,
								0.127
							],
							[
								-0.042,
								0
							],
							[
								-0.156,
								-0.085
							],
							[
								0.006,
								-0.029
							],
							[
								0.064,
								-0.313
							],
							[
								-0.434,
								-0.38
							],
							[
								-0.021,
								-0.019
							],
							[
								-0.255,
								-0.245
							],
							[
								0.026,
								-0.182
							],
							[
								0.029,
								-0.003
							],
							[
								0.304,
								-0.038
							],
							[
								0.191,
								-0.478
							],
							[
								0.008,
								-0.02
							],
							[
								0.132,
								-0.326
							],
							[
								0,
								0
							],
							[
								0.003,
								0.001
							],
							[
								0.003,
								-0.001
							],
							[
								0,
								0
							],
							[
								0.162,
								0
							],
							[
								0.011,
								0.028
							],
							[
								0.121,
								0.286
							],
							[
								0.413,
								0.041
							],
							[
								0.021,
								0.002
							],
							[
								0.364,
								0.038
							],
							[
								0.019,
								0.133
							]
						],
						v: [
							[
								7.667,
								3.634
							],
							[
								7.019,
								4.217
							],
							[
								6.04,
								5.081
							],
							[
								6.503,
								7.187
							],
							[
								6.519,
								7.264
							],
							[
								6.487,
								7.974
							],
							[
								6.375,
								8
							],
							[
								5.899,
								7.817
							],
							[
								5.163,
								7.362
							],
							[
								4,
								6.629
							],
							[
								2.837,
								7.362
							],
							[
								2.101,
								7.817
							],
							[
								1.625,
								8
							],
							[
								1.513,
								7.974
							],
							[
								1.481,
								7.264
							],
							[
								1.497,
								7.187
							],
							[
								1.96,
								5.081
							],
							[
								0.981,
								4.217
							],
							[
								0.333,
								3.634
							],
							[
								0.003,
								3.101
							],
							[
								0.635,
								2.842
							],
							[
								0.711,
								2.834
							],
							[
								2.734,
								2.623
							],
							[
								3.539,
								0.628
							],
							[
								3.568,
								0.556
							],
							[
								3.968,
								0
							],
							[
								3.991,
								0.001
							],
							[
								4,
								0.004
							],
							[
								4.01,
								0.001
							],
							[
								4.032,
								0
							],
							[
								4.432,
								0.556
							],
							[
								4.461,
								0.628
							],
							[
								5.266,
								2.623
							],
							[
								7.289,
								2.834
							],
							[
								7.365,
								2.842
							],
							[
								7.998,
								3.101
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						1,
						1,
						1,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 60,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 168,
		op: 219,
		st: 119,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "glare-glowing-11",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 160,
						s: [
							0
						]
					},
					{
						t: 210,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					223.75,
					208.5,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 160,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 183,
						s: [
							60,
							60,
							100
						]
					},
					{
						t: 210,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.254,
								-0.245
							],
							[
								0.021,
								-0.019
							],
							[
								0.434,
								-0.38
							],
							[
								-0.064,
								-0.314
							],
							[
								-0.006,
								-0.029
							],
							[
								0.156,
								-0.085
							],
							[
								0.042,
								0
							],
							[
								0.222,
								0.127
							],
							[
								0.024,
								0.015
							],
							[
								0.494,
								0.315
							],
							[
								0.007,
								-0.004
							],
							[
								0.14,
								-0.08
							],
							[
								0.107,
								0
							],
							[
								0.032,
								0.017
							],
							[
								-0.082,
								0.373
							],
							[
								-0.004,
								0.021
							],
							[
								-0.097,
								0.434
							],
							[
								0.006,
								0.005
							],
							[
								0.117,
								0.113
							],
							[
								-0.02,
								0.133
							],
							[
								-0.364,
								0.038
							],
							[
								-0.021,
								0.002
							],
							[
								-0.413,
								0.041
							],
							[
								-0.121,
								0.286
							],
							[
								-0.011,
								0.027
							],
							[
								-0.162,
								0
							],
							[
								0,
								0
							],
							[
								-0.003,
								-0.001
							],
							[
								-0.004,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.132,
								-0.326
							],
							[
								-0.008,
								-0.02
							],
							[
								-0.191,
								-0.478
							],
							[
								-0.303,
								-0.038
							],
							[
								-0.029,
								-0.003
							],
							[
								-0.027,
								-0.182
							]
						],
						o: [
							[
								-0.117,
								0.113
							],
							[
								-0.006,
								0.005
							],
							[
								0.097,
								0.434
							],
							[
								0.004,
								0.021
							],
							[
								0.083,
								0.373
							],
							[
								-0.032,
								0.017
							],
							[
								-0.107,
								0
							],
							[
								-0.14,
								-0.08
							],
							[
								-0.007,
								-0.004
							],
							[
								-0.493,
								0.315
							],
							[
								-0.024,
								0.015
							],
							[
								-0.222,
								0.127
							],
							[
								-0.042,
								0
							],
							[
								-0.156,
								-0.085
							],
							[
								0.006,
								-0.029
							],
							[
								0.064,
								-0.313
							],
							[
								-0.434,
								-0.38
							],
							[
								-0.021,
								-0.019
							],
							[
								-0.255,
								-0.245
							],
							[
								0.026,
								-0.182
							],
							[
								0.029,
								-0.003
							],
							[
								0.304,
								-0.038
							],
							[
								0.191,
								-0.478
							],
							[
								0.008,
								-0.02
							],
							[
								0.132,
								-0.326
							],
							[
								0,
								0
							],
							[
								0.003,
								0.001
							],
							[
								0.003,
								-0.001
							],
							[
								0,
								0
							],
							[
								0.162,
								0
							],
							[
								0.011,
								0.028
							],
							[
								0.121,
								0.286
							],
							[
								0.413,
								0.041
							],
							[
								0.021,
								0.002
							],
							[
								0.364,
								0.038
							],
							[
								0.019,
								0.133
							]
						],
						v: [
							[
								7.667,
								3.634
							],
							[
								7.019,
								4.217
							],
							[
								6.04,
								5.081
							],
							[
								6.503,
								7.187
							],
							[
								6.519,
								7.264
							],
							[
								6.487,
								7.974
							],
							[
								6.375,
								8
							],
							[
								5.899,
								7.817
							],
							[
								5.163,
								7.362
							],
							[
								4,
								6.629
							],
							[
								2.837,
								7.362
							],
							[
								2.101,
								7.817
							],
							[
								1.625,
								8
							],
							[
								1.513,
								7.974
							],
							[
								1.481,
								7.264
							],
							[
								1.497,
								7.187
							],
							[
								1.96,
								5.081
							],
							[
								0.981,
								4.217
							],
							[
								0.333,
								3.634
							],
							[
								0.003,
								3.101
							],
							[
								0.635,
								2.842
							],
							[
								0.711,
								2.834
							],
							[
								2.734,
								2.623
							],
							[
								3.539,
								0.628
							],
							[
								3.568,
								0.556
							],
							[
								3.968,
								0
							],
							[
								3.991,
								0.001
							],
							[
								4,
								0.004
							],
							[
								4.01,
								0.001
							],
							[
								4.032,
								0
							],
							[
								4.432,
								0.556
							],
							[
								4.461,
								0.628
							],
							[
								5.266,
								2.623
							],
							[
								7.289,
								2.834
							],
							[
								7.365,
								2.842
							],
							[
								7.998,
								3.101
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						1,
						1,
						1,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 60,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 160,
		op: 211,
		st: 111,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "glare-glowing-10",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 154,
						s: [
							0
						]
					},
					{
						t: 204,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					162.25,
					155.5,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 154,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 177,
						s: [
							120,
							120,
							100
						]
					},
					{
						t: 204,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.254,
								-0.245
							],
							[
								0.021,
								-0.019
							],
							[
								0.434,
								-0.38
							],
							[
								-0.064,
								-0.314
							],
							[
								-0.006,
								-0.029
							],
							[
								0.156,
								-0.085
							],
							[
								0.042,
								0
							],
							[
								0.222,
								0.127
							],
							[
								0.024,
								0.015
							],
							[
								0.494,
								0.315
							],
							[
								0.007,
								-0.004
							],
							[
								0.14,
								-0.08
							],
							[
								0.107,
								0
							],
							[
								0.032,
								0.017
							],
							[
								-0.082,
								0.373
							],
							[
								-0.004,
								0.021
							],
							[
								-0.097,
								0.434
							],
							[
								0.006,
								0.005
							],
							[
								0.117,
								0.113
							],
							[
								-0.02,
								0.133
							],
							[
								-0.364,
								0.038
							],
							[
								-0.021,
								0.002
							],
							[
								-0.413,
								0.041
							],
							[
								-0.121,
								0.286
							],
							[
								-0.011,
								0.027
							],
							[
								-0.162,
								0
							],
							[
								0,
								0
							],
							[
								-0.003,
								-0.001
							],
							[
								-0.004,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.132,
								-0.326
							],
							[
								-0.008,
								-0.02
							],
							[
								-0.191,
								-0.478
							],
							[
								-0.303,
								-0.038
							],
							[
								-0.029,
								-0.003
							],
							[
								-0.027,
								-0.182
							]
						],
						o: [
							[
								-0.117,
								0.113
							],
							[
								-0.006,
								0.005
							],
							[
								0.097,
								0.434
							],
							[
								0.004,
								0.021
							],
							[
								0.083,
								0.373
							],
							[
								-0.032,
								0.017
							],
							[
								-0.107,
								0
							],
							[
								-0.14,
								-0.08
							],
							[
								-0.007,
								-0.004
							],
							[
								-0.493,
								0.315
							],
							[
								-0.024,
								0.015
							],
							[
								-0.222,
								0.127
							],
							[
								-0.042,
								0
							],
							[
								-0.156,
								-0.085
							],
							[
								0.006,
								-0.029
							],
							[
								0.064,
								-0.313
							],
							[
								-0.434,
								-0.38
							],
							[
								-0.021,
								-0.019
							],
							[
								-0.255,
								-0.245
							],
							[
								0.026,
								-0.182
							],
							[
								0.029,
								-0.003
							],
							[
								0.304,
								-0.038
							],
							[
								0.191,
								-0.478
							],
							[
								0.008,
								-0.02
							],
							[
								0.132,
								-0.326
							],
							[
								0,
								0
							],
							[
								0.003,
								0.001
							],
							[
								0.003,
								-0.001
							],
							[
								0,
								0
							],
							[
								0.162,
								0
							],
							[
								0.011,
								0.028
							],
							[
								0.121,
								0.286
							],
							[
								0.413,
								0.041
							],
							[
								0.021,
								0.002
							],
							[
								0.364,
								0.038
							],
							[
								0.019,
								0.133
							]
						],
						v: [
							[
								7.667,
								3.634
							],
							[
								7.019,
								4.217
							],
							[
								6.04,
								5.081
							],
							[
								6.503,
								7.187
							],
							[
								6.519,
								7.264
							],
							[
								6.487,
								7.974
							],
							[
								6.375,
								8
							],
							[
								5.899,
								7.817
							],
							[
								5.163,
								7.362
							],
							[
								4,
								6.629
							],
							[
								2.837,
								7.362
							],
							[
								2.101,
								7.817
							],
							[
								1.625,
								8
							],
							[
								1.513,
								7.974
							],
							[
								1.481,
								7.264
							],
							[
								1.497,
								7.187
							],
							[
								1.96,
								5.081
							],
							[
								0.981,
								4.217
							],
							[
								0.333,
								3.634
							],
							[
								0.003,
								3.101
							],
							[
								0.635,
								2.842
							],
							[
								0.711,
								2.834
							],
							[
								2.734,
								2.623
							],
							[
								3.539,
								0.628
							],
							[
								3.568,
								0.556
							],
							[
								3.968,
								0
							],
							[
								3.991,
								0.001
							],
							[
								4,
								0.004
							],
							[
								4.01,
								0.001
							],
							[
								4.032,
								0
							],
							[
								4.432,
								0.556
							],
							[
								4.461,
								0.628
							],
							[
								5.266,
								2.623
							],
							[
								7.289,
								2.834
							],
							[
								7.365,
								2.842
							],
							[
								7.998,
								3.101
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						1,
						1,
						1,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 60,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 154,
		op: 205,
		st: 105,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "glare-glowing-9",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 141,
						s: [
							0
						]
					},
					{
						t: 191,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					60.25,
					183.25,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 141,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 164,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 191,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.254,
								-0.245
							],
							[
								0.021,
								-0.019
							],
							[
								0.434,
								-0.38
							],
							[
								-0.064,
								-0.314
							],
							[
								-0.006,
								-0.029
							],
							[
								0.156,
								-0.085
							],
							[
								0.042,
								0
							],
							[
								0.222,
								0.127
							],
							[
								0.024,
								0.015
							],
							[
								0.494,
								0.315
							],
							[
								0.007,
								-0.004
							],
							[
								0.14,
								-0.08
							],
							[
								0.107,
								0
							],
							[
								0.032,
								0.017
							],
							[
								-0.082,
								0.373
							],
							[
								-0.004,
								0.021
							],
							[
								-0.097,
								0.434
							],
							[
								0.006,
								0.005
							],
							[
								0.117,
								0.113
							],
							[
								-0.02,
								0.133
							],
							[
								-0.364,
								0.038
							],
							[
								-0.021,
								0.002
							],
							[
								-0.413,
								0.041
							],
							[
								-0.121,
								0.286
							],
							[
								-0.011,
								0.027
							],
							[
								-0.162,
								0
							],
							[
								0,
								0
							],
							[
								-0.003,
								-0.001
							],
							[
								-0.004,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.132,
								-0.326
							],
							[
								-0.008,
								-0.02
							],
							[
								-0.191,
								-0.478
							],
							[
								-0.303,
								-0.038
							],
							[
								-0.029,
								-0.003
							],
							[
								-0.027,
								-0.182
							]
						],
						o: [
							[
								-0.117,
								0.113
							],
							[
								-0.006,
								0.005
							],
							[
								0.097,
								0.434
							],
							[
								0.004,
								0.021
							],
							[
								0.083,
								0.373
							],
							[
								-0.032,
								0.017
							],
							[
								-0.107,
								0
							],
							[
								-0.14,
								-0.08
							],
							[
								-0.007,
								-0.004
							],
							[
								-0.493,
								0.315
							],
							[
								-0.024,
								0.015
							],
							[
								-0.222,
								0.127
							],
							[
								-0.042,
								0
							],
							[
								-0.156,
								-0.085
							],
							[
								0.006,
								-0.029
							],
							[
								0.064,
								-0.313
							],
							[
								-0.434,
								-0.38
							],
							[
								-0.021,
								-0.019
							],
							[
								-0.255,
								-0.245
							],
							[
								0.026,
								-0.182
							],
							[
								0.029,
								-0.003
							],
							[
								0.304,
								-0.038
							],
							[
								0.191,
								-0.478
							],
							[
								0.008,
								-0.02
							],
							[
								0.132,
								-0.326
							],
							[
								0,
								0
							],
							[
								0.003,
								0.001
							],
							[
								0.003,
								-0.001
							],
							[
								0,
								0
							],
							[
								0.162,
								0
							],
							[
								0.011,
								0.028
							],
							[
								0.121,
								0.286
							],
							[
								0.413,
								0.041
							],
							[
								0.021,
								0.002
							],
							[
								0.364,
								0.038
							],
							[
								0.019,
								0.133
							]
						],
						v: [
							[
								7.667,
								3.634
							],
							[
								7.019,
								4.217
							],
							[
								6.04,
								5.081
							],
							[
								6.503,
								7.187
							],
							[
								6.519,
								7.264
							],
							[
								6.487,
								7.974
							],
							[
								6.375,
								8
							],
							[
								5.899,
								7.817
							],
							[
								5.163,
								7.362
							],
							[
								4,
								6.629
							],
							[
								2.837,
								7.362
							],
							[
								2.101,
								7.817
							],
							[
								1.625,
								8
							],
							[
								1.513,
								7.974
							],
							[
								1.481,
								7.264
							],
							[
								1.497,
								7.187
							],
							[
								1.96,
								5.081
							],
							[
								0.981,
								4.217
							],
							[
								0.333,
								3.634
							],
							[
								0.003,
								3.101
							],
							[
								0.635,
								2.842
							],
							[
								0.711,
								2.834
							],
							[
								2.734,
								2.623
							],
							[
								3.539,
								0.628
							],
							[
								3.568,
								0.556
							],
							[
								3.968,
								0
							],
							[
								3.991,
								0.001
							],
							[
								4,
								0.004
							],
							[
								4.01,
								0.001
							],
							[
								4.032,
								0
							],
							[
								4.432,
								0.556
							],
							[
								4.461,
								0.628
							],
							[
								5.266,
								2.623
							],
							[
								7.289,
								2.834
							],
							[
								7.365,
								2.842
							],
							[
								7.998,
								3.101
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						1,
						1,
						1,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 60,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 141,
		op: 192,
		st: 92,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "glare-glowing-8",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 129,
						s: [
							0
						]
					},
					{
						t: 179,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					229.25,
					66,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 129,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 152,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 179,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								7.159,
								7.159
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 60,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								3.797,
								3.848
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 129,
		op: 180,
		st: 80,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "glare-glowing-7",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 121,
						s: [
							0
						]
					},
					{
						t: 171,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					223.75,
					208.5,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 121,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 144,
						s: [
							60,
							60,
							100
						]
					},
					{
						t: 171,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.254,
								-0.245
							],
							[
								0.021,
								-0.019
							],
							[
								0.434,
								-0.38
							],
							[
								-0.064,
								-0.314
							],
							[
								-0.006,
								-0.029
							],
							[
								0.156,
								-0.085
							],
							[
								0.042,
								0
							],
							[
								0.222,
								0.127
							],
							[
								0.024,
								0.015
							],
							[
								0.494,
								0.315
							],
							[
								0.007,
								-0.004
							],
							[
								0.14,
								-0.08
							],
							[
								0.107,
								0
							],
							[
								0.032,
								0.017
							],
							[
								-0.082,
								0.373
							],
							[
								-0.004,
								0.021
							],
							[
								-0.097,
								0.434
							],
							[
								0.006,
								0.005
							],
							[
								0.117,
								0.113
							],
							[
								-0.02,
								0.133
							],
							[
								-0.364,
								0.038
							],
							[
								-0.021,
								0.002
							],
							[
								-0.413,
								0.041
							],
							[
								-0.121,
								0.286
							],
							[
								-0.011,
								0.027
							],
							[
								-0.162,
								0
							],
							[
								0,
								0
							],
							[
								-0.003,
								-0.001
							],
							[
								-0.004,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.132,
								-0.326
							],
							[
								-0.008,
								-0.02
							],
							[
								-0.191,
								-0.478
							],
							[
								-0.303,
								-0.038
							],
							[
								-0.029,
								-0.003
							],
							[
								-0.027,
								-0.182
							]
						],
						o: [
							[
								-0.117,
								0.113
							],
							[
								-0.006,
								0.005
							],
							[
								0.097,
								0.434
							],
							[
								0.004,
								0.021
							],
							[
								0.083,
								0.373
							],
							[
								-0.032,
								0.017
							],
							[
								-0.107,
								0
							],
							[
								-0.14,
								-0.08
							],
							[
								-0.007,
								-0.004
							],
							[
								-0.493,
								0.315
							],
							[
								-0.024,
								0.015
							],
							[
								-0.222,
								0.127
							],
							[
								-0.042,
								0
							],
							[
								-0.156,
								-0.085
							],
							[
								0.006,
								-0.029
							],
							[
								0.064,
								-0.313
							],
							[
								-0.434,
								-0.38
							],
							[
								-0.021,
								-0.019
							],
							[
								-0.255,
								-0.245
							],
							[
								0.026,
								-0.182
							],
							[
								0.029,
								-0.003
							],
							[
								0.304,
								-0.038
							],
							[
								0.191,
								-0.478
							],
							[
								0.008,
								-0.02
							],
							[
								0.132,
								-0.326
							],
							[
								0,
								0
							],
							[
								0.003,
								0.001
							],
							[
								0.003,
								-0.001
							],
							[
								0,
								0
							],
							[
								0.162,
								0
							],
							[
								0.011,
								0.028
							],
							[
								0.121,
								0.286
							],
							[
								0.413,
								0.041
							],
							[
								0.021,
								0.002
							],
							[
								0.364,
								0.038
							],
							[
								0.019,
								0.133
							]
						],
						v: [
							[
								7.667,
								3.634
							],
							[
								7.019,
								4.217
							],
							[
								6.04,
								5.081
							],
							[
								6.503,
								7.187
							],
							[
								6.519,
								7.264
							],
							[
								6.487,
								7.974
							],
							[
								6.375,
								8
							],
							[
								5.899,
								7.817
							],
							[
								5.163,
								7.362
							],
							[
								4,
								6.629
							],
							[
								2.837,
								7.362
							],
							[
								2.101,
								7.817
							],
							[
								1.625,
								8
							],
							[
								1.513,
								7.974
							],
							[
								1.481,
								7.264
							],
							[
								1.497,
								7.187
							],
							[
								1.96,
								5.081
							],
							[
								0.981,
								4.217
							],
							[
								0.333,
								3.634
							],
							[
								0.003,
								3.101
							],
							[
								0.635,
								2.842
							],
							[
								0.711,
								2.834
							],
							[
								2.734,
								2.623
							],
							[
								3.539,
								0.628
							],
							[
								3.568,
								0.556
							],
							[
								3.968,
								0
							],
							[
								3.991,
								0.001
							],
							[
								4,
								0.004
							],
							[
								4.01,
								0.001
							],
							[
								4.032,
								0
							],
							[
								4.432,
								0.556
							],
							[
								4.461,
								0.628
							],
							[
								5.266,
								2.623
							],
							[
								7.289,
								2.834
							],
							[
								7.365,
								2.842
							],
							[
								7.998,
								3.101
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						1,
						1,
						1,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 60,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 121,
		op: 172,
		st: 72,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "glare-glowing-6",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 115,
						s: [
							0
						]
					},
					{
						t: 165,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146,
					162.75,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 115,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 138,
						s: [
							120,
							120,
							100
						]
					},
					{
						t: 165,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								7.466,
								7.466
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 60,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								3.66,
								3.727
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 115,
		op: 166,
		st: 66,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "glare-glowing-5",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 102,
						s: [
							0
						]
					},
					{
						t: 152,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					55.25,
					190.75,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 102,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 125,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 152,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								7.259,
								7.259
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 60,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								3.716,
								3.738
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 102,
		op: 153,
		st: 53,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "glare-glowing-4",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 76,
						s: [
							0
						]
					},
					{
						t: 126,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					229.25,
					66,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 76,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 99,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 126,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								7.824,
								7.824
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 60,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								3.916,
								4.195
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 76,
		op: 127,
		st: 27,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "glare-glowing-3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 68,
						s: [
							0
						]
					},
					{
						t: 118,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					223.75,
					208.5,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 68,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 91,
						s: [
							60,
							60,
							100
						]
					},
					{
						t: 118,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								7.526,
								7.526
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 60,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								3.872,
								4.197
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 68,
		op: 119,
		st: 19,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "glare-glowing-2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 62,
						s: [
							0
						]
					},
					{
						t: 112,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					166.25,
					118.25,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 62,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 85,
						s: [
							120,
							120,
							100
						]
					},
					{
						t: 112,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								7.52,
								7.52
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 60,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								3.834,
								4.209
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 62,
		op: 113,
		st: 13,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "glare-glowing-1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 49,
						s: [
							0
						]
					},
					{
						t: 99,
						s: [
							180
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					60.25,
					183.25,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 49,
						s: [
							20,
							20,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								0.833
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0.167,
								0.167
							]
						},
						t: 72,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 99,
						s: [
							20,
							20,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								6,
								6
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 60,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								4.06,
								4.177
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						1,
						1,
						1,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 60,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 49,
		op: 100,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "glare-2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 43,
						s: [
							60.211,
							133.414,
							0
						],
						to: [
							50.75,
							0,
							0
						],
						ti: [
							-50.75,
							0,
							0
						]
					},
					{
						t: 100,
						s: [
							364.711,
							133.414,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-75.289,
					-9.586,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "rc",
						d: 1,
						s: {
							a: 0,
							k: [
								7.312,
								355.941
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 4
						},
						nm: "Rectangle Path 1",
						mn: "ADBE Vector Shape - Rect",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 20,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-121.789,
								18.471
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: -15,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Rectangle 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 43,
		op: 102,
		st: 4,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "glare-1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 39,
						s: [
							60.211,
							133.414,
							0
						],
						to: [
							50.75,
							0,
							0
						],
						ti: [
							-50.75,
							0,
							0
						]
					},
					{
						t: 96,
						s: [
							364.711,
							133.414,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-75.289,
					-9.586,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "rc",
						d: 1,
						s: {
							a: 0,
							k: [
								28.312,
								355.941
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 4
						},
						nm: "Rectangle Path 1",
						mn: "ADBE Vector Shape - Rect",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 20,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-121.789,
								18.471
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: -15,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Rectangle 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 39,
		op: 98,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "star-7",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.464
							],
							y: [
								1.332
							]
						},
						o: {
							x: [
								0.031
							],
							y: [
								0.119
							]
						},
						t: 18,
						s: [
							-50
						]
					},
					{
						t: 26,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.52,
							y: 1
						},
						o: {
							x: 0.43,
							y: 0
						},
						t: 18,
						s: [
							140,
							140,
							0
						],
						to: [
							-13.833,
							7.833,
							0
						],
						ti: [
							13.833,
							-7.833,
							0
						]
					},
					{
						t: 26,
						s: [
							57,
							187,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					12,
					12,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.257,
								0.257,
								0.18
							],
							y: [
								1.167,
								1.167,
								1
							]
						},
						o: {
							x: [
								0.21,
								0.21,
								0.21
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.641,
								0.641,
								0.833
							],
							y: [
								7.392,
								7.392,
								1
							]
						},
						o: {
							x: [
								0.136,
								0.136,
								0.167
							],
							y: [
								-8.433,
								-8.433,
								0
							]
						},
						t: 26,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 32,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.763,
								-0.737
							],
							[
								0.064,
								-0.057
							],
							[
								1.303,
								-1.14
							],
							[
								-0.19,
								-0.941
							],
							[
								-0.019,
								-0.087
							],
							[
								0.47,
								-0.255
							],
							[
								0.126,
								0
							],
							[
								0.666,
								0.38
							],
							[
								0.071,
								0.047
							],
							[
								1.48,
								0.945
							],
							[
								0.02,
								-0.012
							],
							[
								0.42,
								-0.24
							],
							[
								0.321,
								0
							],
							[
								0.096,
								0.051
							],
							[
								-0.245,
								1.122
							],
							[
								-0.013,
								0.063
							],
							[
								-0.291,
								1.301
							],
							[
								0.017,
								0.015
							],
							[
								0.351,
								0.339
							],
							[
								-0.059,
								0.402
							],
							[
								-1.094,
								0.116
							],
							[
								-0.063,
								0.007
							],
							[
								-1.241,
								0.124
							],
							[
								-0.363,
								0.859
							],
							[
								-0.034,
								0.083
							],
							[
								-0.487,
								0
							],
							[
								0,
								0
							],
							[
								-0.011,
								-0.002
							],
							[
								-0.01,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.395,
								-0.977
							],
							[
								-0.025,
								-0.061
							],
							[
								-0.573,
								-1.433
							],
							[
								-0.911,
								-0.112
							],
							[
								-0.086,
								-0.008
							],
							[
								-0.08,
								-0.545
							]
						],
						o: [
							[
								-0.352,
								0.339
							],
							[
								-0.018,
								0.015
							],
							[
								0.29,
								1.301
							],
							[
								0.014,
								0.063
							],
							[
								0.247,
								1.122
							],
							[
								-0.096,
								0.052
							],
							[
								-0.321,
								0
							],
							[
								-0.42,
								-0.24
							],
							[
								-0.021,
								-0.012
							],
							[
								-1.481,
								0.945
							],
							[
								-0.073,
								0.047
							],
							[
								-0.666,
								0.38
							],
							[
								-0.127,
								0
							],
							[
								-0.47,
								-0.255
							],
							[
								0.019,
								-0.087
							],
							[
								0.191,
								-0.941
							],
							[
								-1.304,
								-1.14
							],
							[
								-0.063,
								-0.057
							],
							[
								-0.765,
								-0.737
							],
							[
								0.081,
								-0.545
							],
							[
								0.086,
								-0.008
							],
							[
								0.912,
								-0.112
							],
							[
								0.572,
								-1.433
							],
							[
								0.025,
								-0.061
							],
							[
								0.395,
								-0.977
							],
							[
								0,
								0
							],
							[
								0.01,
								0.001
							],
							[
								0.008,
								-0.002
							],
							[
								0,
								0
							],
							[
								0.488,
								0
							],
							[
								0.034,
								0.083
							],
							[
								0.363,
								0.859
							],
							[
								1.24,
								0.124
							],
							[
								0.063,
								0.007
							],
							[
								1.094,
								0.116
							],
							[
								0.06,
								0.402
							]
						],
						v: [
							[
								23.001,
								10.903
							],
							[
								21.056,
								12.651
							],
							[
								18.12,
								15.244
							],
							[
								19.508,
								21.562
							],
							[
								19.558,
								21.791
							],
							[
								19.46,
								23.922
							],
							[
								19.125,
								24
							],
							[
								17.698,
								23.451
							],
							[
								15.49,
								22.086
							],
							[
								12.001,
								19.887
							],
							[
								8.511,
								22.086
							],
							[
								6.303,
								23.451
							],
							[
								4.876,
								24
							],
							[
								4.54,
								23.922
							],
							[
								4.441,
								21.791
							],
							[
								4.491,
								21.562
							],
							[
								5.881,
								15.244
							],
							[
								2.944,
								12.651
							],
							[
								1,
								10.903
							],
							[
								0.007,
								9.302
							],
							[
								1.906,
								8.525
							],
							[
								2.132,
								8.502
							],
							[
								8.203,
								7.869
							],
							[
								10.617,
								1.885
							],
							[
								10.705,
								1.668
							],
							[
								11.905,
								0
							],
							[
								11.971,
								0.005
							],
							[
								12.001,
								0.012
							],
							[
								12.029,
								0.005
							],
							[
								12.095,
								0
							],
							[
								13.295,
								1.668
							],
							[
								13.383,
								1.885
							],
							[
								15.798,
								7.869
							],
							[
								21.868,
								8.502
							],
							[
								22.094,
								8.525
							],
							[
								23.992,
								9.302
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 50,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "star-11",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.919
							],
							y: [
								1.357
							]
						},
						o: {
							x: [
								0.41
							],
							y: [
								0.807
							]
						},
						t: 18,
						s: [
							-45
						]
					},
					{
						t: 32,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.18,
							y: 1
						},
						o: {
							x: 0.21,
							y: 0
						},
						t: 18,
						s: [
							140,
							140,
							0
						],
						to: [
							-17.167,
							-8.167,
							0
						],
						ti: [
							17.167,
							8.167,
							0
						]
					},
					{
						t: 32,
						s: [
							37,
							91,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.762,
								0.762,
								0.18
							],
							y: [
								1.292,
								1.292,
								1
							]
						},
						o: {
							x: [
								0.093,
								0.093,
								0.21
							],
							y: [
								0.284,
								0.284,
								0
							]
						},
						t: 18,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.95,
								0.95,
								0.833
							],
							y: [
								13.501,
								13.501,
								1
							]
						},
						o: {
							x: [
								0.479,
								0.479,
								0.167
							],
							y: [
								-20.78,
								-20.78,
								0
							]
						},
						t: 32,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 37,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.254,
								-0.245
							],
							[
								0.021,
								-0.019
							],
							[
								0.434,
								-0.38
							],
							[
								-0.064,
								-0.314
							],
							[
								-0.006,
								-0.029
							],
							[
								0.156,
								-0.085
							],
							[
								0.042,
								0
							],
							[
								0.222,
								0.127
							],
							[
								0.024,
								0.015
							],
							[
								0.494,
								0.315
							],
							[
								0.007,
								-0.004
							],
							[
								0.14,
								-0.08
							],
							[
								0.107,
								0
							],
							[
								0.032,
								0.017
							],
							[
								-0.082,
								0.373
							],
							[
								-0.004,
								0.021
							],
							[
								-0.097,
								0.434
							],
							[
								0.006,
								0.005
							],
							[
								0.117,
								0.113
							],
							[
								-0.02,
								0.133
							],
							[
								-0.364,
								0.038
							],
							[
								-0.021,
								0.002
							],
							[
								-0.413,
								0.041
							],
							[
								-0.121,
								0.286
							],
							[
								-0.011,
								0.027
							],
							[
								-0.162,
								0
							],
							[
								0,
								0
							],
							[
								-0.003,
								-0.001
							],
							[
								-0.004,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.132,
								-0.326
							],
							[
								-0.008,
								-0.02
							],
							[
								-0.191,
								-0.478
							],
							[
								-0.303,
								-0.038
							],
							[
								-0.029,
								-0.003
							],
							[
								-0.027,
								-0.182
							]
						],
						o: [
							[
								-0.117,
								0.113
							],
							[
								-0.006,
								0.005
							],
							[
								0.097,
								0.434
							],
							[
								0.004,
								0.021
							],
							[
								0.083,
								0.373
							],
							[
								-0.032,
								0.017
							],
							[
								-0.107,
								0
							],
							[
								-0.14,
								-0.08
							],
							[
								-0.007,
								-0.004
							],
							[
								-0.493,
								0.315
							],
							[
								-0.024,
								0.015
							],
							[
								-0.222,
								0.127
							],
							[
								-0.042,
								0
							],
							[
								-0.156,
								-0.085
							],
							[
								0.006,
								-0.029
							],
							[
								0.064,
								-0.313
							],
							[
								-0.434,
								-0.38
							],
							[
								-0.021,
								-0.019
							],
							[
								-0.255,
								-0.245
							],
							[
								0.026,
								-0.182
							],
							[
								0.029,
								-0.003
							],
							[
								0.304,
								-0.038
							],
							[
								0.191,
								-0.478
							],
							[
								0.008,
								-0.02
							],
							[
								0.132,
								-0.326
							],
							[
								0,
								0
							],
							[
								0.003,
								0.001
							],
							[
								0.003,
								-0.001
							],
							[
								0,
								0
							],
							[
								0.162,
								0
							],
							[
								0.011,
								0.028
							],
							[
								0.121,
								0.286
							],
							[
								0.413,
								0.041
							],
							[
								0.021,
								0.002
							],
							[
								0.364,
								0.038
							],
							[
								0.019,
								0.133
							]
						],
						v: [
							[
								7.667,
								3.634
							],
							[
								7.019,
								4.217
							],
							[
								6.04,
								5.081
							],
							[
								6.503,
								7.187
							],
							[
								6.519,
								7.264
							],
							[
								6.487,
								7.974
							],
							[
								6.375,
								8
							],
							[
								5.899,
								7.817
							],
							[
								5.163,
								7.362
							],
							[
								4,
								6.629
							],
							[
								2.837,
								7.362
							],
							[
								2.101,
								7.817
							],
							[
								1.625,
								8
							],
							[
								1.513,
								7.974
							],
							[
								1.481,
								7.264
							],
							[
								1.497,
								7.187
							],
							[
								1.96,
								5.081
							],
							[
								0.981,
								4.217
							],
							[
								0.333,
								3.634
							],
							[
								0.003,
								3.101
							],
							[
								0.635,
								2.842
							],
							[
								0.711,
								2.834
							],
							[
								2.734,
								2.623
							],
							[
								3.539,
								0.628
							],
							[
								3.568,
								0.556
							],
							[
								3.968,
								0
							],
							[
								3.991,
								0.001
							],
							[
								4,
								0.004
							],
							[
								4.01,
								0.001
							],
							[
								4.032,
								0
							],
							[
								4.432,
								0.556
							],
							[
								4.461,
								0.628
							],
							[
								5.266,
								2.623
							],
							[
								7.289,
								2.834
							],
							[
								7.365,
								2.842
							],
							[
								7.998,
								3.101
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 25,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "star-1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.18
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.21
							],
							y: [
								0
							]
						},
						t: 18,
						s: [
							33
						]
					},
					{
						t: 31,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.18,
							y: 1
						},
						o: {
							x: 0.43,
							y: 0
						},
						t: 18,
						s: [
							140,
							140,
							0
						],
						to: [
							10.167,
							-18.333,
							0
						],
						ti: [
							-10.167,
							18.333,
							0
						]
					},
					{
						t: 31,
						s: [
							201,
							30,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					4,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.747,
								0.747,
								0.18
							],
							y: [
								1.328,
								1.328,
								1
							]
						},
						o: {
							x: [
								0.206,
								0.206,
								0.21
							],
							y: [
								0.394,
								0.394,
								0
							]
						},
						t: 18,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.746,
								0.746,
								0.833
							],
							y: [
								-7.969,
								-7.969,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 31,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 36,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.254,
								-0.245
							],
							[
								0.021,
								-0.019
							],
							[
								0.434,
								-0.38
							],
							[
								-0.064,
								-0.314
							],
							[
								-0.006,
								-0.029
							],
							[
								0.156,
								-0.085
							],
							[
								0.042,
								0
							],
							[
								0.222,
								0.126
							],
							[
								0.024,
								0.015
							],
							[
								0.494,
								0.315
							],
							[
								0.007,
								-0.004
							],
							[
								0.14,
								-0.08
							],
							[
								0.107,
								0
							],
							[
								0.032,
								0.017
							],
							[
								-0.082,
								0.373
							],
							[
								-0.004,
								0.021
							],
							[
								-0.097,
								0.434
							],
							[
								0.006,
								0.005
							],
							[
								0.117,
								0.113
							],
							[
								-0.02,
								0.133
							],
							[
								-0.364,
								0.038
							],
							[
								-0.021,
								0.002
							],
							[
								-0.413,
								0.041
							],
							[
								-0.121,
								0.286
							],
							[
								-0.011,
								0.027
							],
							[
								-0.162,
								0
							],
							[
								0,
								0
							],
							[
								-0.003,
								-0.001
							],
							[
								-0.004,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.132,
								-0.326
							],
							[
								-0.008,
								-0.02
							],
							[
								-0.191,
								-0.478
							],
							[
								-0.303,
								-0.038
							],
							[
								-0.029,
								-0.003
							],
							[
								-0.027,
								-0.182
							]
						],
						o: [
							[
								-0.117,
								0.113
							],
							[
								-0.006,
								0.005
							],
							[
								0.097,
								0.434
							],
							[
								0.004,
								0.021
							],
							[
								0.083,
								0.373
							],
							[
								-0.032,
								0.017
							],
							[
								-0.107,
								0
							],
							[
								-0.14,
								-0.08
							],
							[
								-0.007,
								-0.004
							],
							[
								-0.493,
								0.315
							],
							[
								-0.024,
								0.015
							],
							[
								-0.222,
								0.126
							],
							[
								-0.042,
								0
							],
							[
								-0.156,
								-0.085
							],
							[
								0.006,
								-0.029
							],
							[
								0.064,
								-0.313
							],
							[
								-0.434,
								-0.38
							],
							[
								-0.021,
								-0.019
							],
							[
								-0.254,
								-0.245
							],
							[
								0.026,
								-0.182
							],
							[
								0.029,
								-0.003
							],
							[
								0.304,
								-0.038
							],
							[
								0.191,
								-0.478
							],
							[
								0.008,
								-0.02
							],
							[
								0.132,
								-0.326
							],
							[
								0,
								0
							],
							[
								0.003,
								0.001
							],
							[
								0.003,
								-0.001
							],
							[
								0,
								0
							],
							[
								0.162,
								0
							],
							[
								0.011,
								0.028
							],
							[
								0.121,
								0.286
							],
							[
								0.413,
								0.041
							],
							[
								0.021,
								0.002
							],
							[
								0.364,
								0.038
							],
							[
								0.019,
								0.133
							]
						],
						v: [
							[
								7.667,
								3.634
							],
							[
								7.019,
								4.217
							],
							[
								6.04,
								5.081
							],
							[
								6.503,
								7.187
							],
							[
								6.519,
								7.264
							],
							[
								6.487,
								7.974
							],
							[
								6.375,
								8
							],
							[
								5.899,
								7.817
							],
							[
								5.163,
								7.362
							],
							[
								4,
								6.629
							],
							[
								2.837,
								7.362
							],
							[
								2.101,
								7.817
							],
							[
								1.625,
								8
							],
							[
								1.513,
								7.974
							],
							[
								1.481,
								7.264
							],
							[
								1.497,
								7.187
							],
							[
								1.96,
								5.081
							],
							[
								0.981,
								4.217
							],
							[
								0.333,
								3.634
							],
							[
								0.003,
								3.101
							],
							[
								0.635,
								2.842
							],
							[
								0.711,
								2.834
							],
							[
								2.734,
								2.623
							],
							[
								3.539,
								0.628
							],
							[
								3.568,
								0.556
							],
							[
								3.968,
								0
							],
							[
								3.991,
								0.001
							],
							[
								4,
								0.004
							],
							[
								4.01,
								0.001
							],
							[
								4.032,
								0
							],
							[
								4.432,
								0.556
							],
							[
								4.461,
								0.628
							],
							[
								5.266,
								2.623
							],
							[
								7.289,
								2.834
							],
							[
								7.365,
								2.842
							],
							[
								7.998,
								3.101
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 25,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "star-2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.475
							],
							y: [
								1.309
							]
						},
						o: {
							x: [
								0.092
							],
							y: [
								0.206
							]
						},
						t: 18,
						s: [
							45
						]
					},
					{
						t: 27,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.18,
							y: 1
						},
						o: {
							x: 0.43,
							y: 0
						},
						t: 18,
						s: [
							140,
							140,
							0
						],
						to: [
							15.5,
							-11.667,
							0
						],
						ti: [
							-15.5,
							11.667,
							0
						]
					},
					{
						t: 27,
						s: [
							233,
							70,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					12,
					12,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.405,
								0.405,
								0.18
							],
							y: [
								1.192,
								1.192,
								1
							]
						},
						o: {
							x: [
								0.21,
								0.21,
								0.21
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.908,
								0.908,
								0.833
							],
							y: [
								5.371,
								5.371,
								1
							]
						},
						o: {
							x: [
								0.284,
								0.284,
								0.167
							],
							y: [
								-11.194,
								-11.194,
								0
							]
						},
						t: 27,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 32,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.763,
								-0.737
							],
							[
								0.063,
								-0.057
							],
							[
								1.303,
								-1.14
							],
							[
								-0.19,
								-0.941
							],
							[
								-0.019,
								-0.088
							],
							[
								0.47,
								-0.255
							],
							[
								0.126,
								0
							],
							[
								0.666,
								0.38
							],
							[
								0.072,
								0.047
							],
							[
								1.48,
								0.945
							],
							[
								0.02,
								-0.012
							],
							[
								0.42,
								-0.24
							],
							[
								0.321,
								0
							],
							[
								0.096,
								0.051
							],
							[
								-0.246,
								1.121
							],
							[
								-0.013,
								0.063
							],
							[
								-0.291,
								1.301
							],
							[
								0.017,
								0.015
							],
							[
								0.351,
								0.339
							],
							[
								-0.06,
								0.401
							],
							[
								-1.094,
								0.115
							],
							[
								-0.062,
								0.007
							],
							[
								-1.241,
								0.125
							],
							[
								-0.363,
								0.859
							],
							[
								-0.034,
								0.083
							],
							[
								-0.487,
								0
							],
							[
								0,
								0
							],
							[
								-0.011,
								-0.003
							],
							[
								-0.01,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.394,
								-0.977
							],
							[
								-0.025,
								-0.061
							],
							[
								-0.573,
								-1.433
							],
							[
								-0.911,
								-0.112
							],
							[
								-0.086,
								-0.009
							],
							[
								-0.081,
								-0.546
							]
						],
						o: [
							[
								-0.351,
								0.339
							],
							[
								-0.018,
								0.015
							],
							[
								0.291,
								1.301
							],
							[
								0.014,
								0.063
							],
							[
								0.247,
								1.121
							],
							[
								-0.095,
								0.052
							],
							[
								-0.321,
								0
							],
							[
								-0.42,
								-0.24
							],
							[
								-0.021,
								-0.012
							],
							[
								-1.481,
								0.945
							],
							[
								-0.073,
								0.047
							],
							[
								-0.666,
								0.38
							],
							[
								-0.126,
								0
							],
							[
								-0.469,
								-0.255
							],
							[
								0.019,
								-0.088
							],
							[
								0.191,
								-0.94
							],
							[
								-1.303,
								-1.14
							],
							[
								-0.063,
								-0.057
							],
							[
								-0.764,
								-0.737
							],
							[
								0.08,
								-0.546
							],
							[
								0.086,
								-0.009
							],
							[
								0.912,
								-0.112
							],
							[
								0.572,
								-1.433
							],
							[
								0.025,
								-0.061
							],
							[
								0.396,
								-0.977
							],
							[
								0,
								0
							],
							[
								0.009,
								0.001
							],
							[
								0.008,
								-0.003
							],
							[
								0,
								0
							],
							[
								0.487,
								0
							],
							[
								0.034,
								0.084
							],
							[
								0.363,
								0.859
							],
							[
								1.24,
								0.125
							],
							[
								0.063,
								0.007
							],
							[
								1.094,
								0.115
							],
							[
								0.059,
								0.401
							]
						],
						v: [
							[
								23.001,
								10.903
							],
							[
								21.057,
								12.651
							],
							[
								18.12,
								15.244
							],
							[
								19.508,
								21.562
							],
							[
								19.558,
								21.792
							],
							[
								19.46,
								23.922
							],
							[
								19.125,
								24
							],
							[
								17.698,
								23.451
							],
							[
								15.49,
								22.086
							],
							[
								12.001,
								19.887
							],
							[
								8.511,
								22.086
							],
							[
								6.303,
								23.451
							],
							[
								4.876,
								24
							],
							[
								4.54,
								23.922
							],
							[
								4.442,
								21.792
							],
							[
								4.491,
								21.562
							],
							[
								5.881,
								15.244
							],
							[
								2.944,
								12.651
							],
							[
								1,
								10.903
							],
							[
								0.008,
								9.303
							],
							[
								1.906,
								8.526
							],
							[
								2.132,
								8.502
							],
							[
								8.203,
								7.869
							],
							[
								10.617,
								1.885
							],
							[
								10.705,
								1.668
							],
							[
								11.905,
								0
							],
							[
								11.972,
								0.005
							],
							[
								12.001,
								0.013
							],
							[
								12.029,
								0.005
							],
							[
								12.096,
								0
							],
							[
								13.295,
								1.668
							],
							[
								13.384,
								1.885
							],
							[
								15.798,
								7.869
							],
							[
								21.868,
								8.502
							],
							[
								22.094,
								8.526
							],
							[
								23.993,
								9.303
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 50,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "star-4",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.341
							],
							y: [
								1.333
							]
						},
						o: {
							x: [
								0.112
							],
							y: [
								0.356
							]
						},
						t: 18,
						s: [
							-90
						]
					},
					{
						t: 30,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.29,
							y: 1
						},
						o: {
							x: 0.43,
							y: 0
						},
						t: 18,
						s: [
							140,
							140,
							0
						],
						to: [
							13.5,
							11.667,
							0
						],
						ti: [
							-13.5,
							-11.667,
							0
						]
					},
					{
						t: 30,
						s: [
							221,
							210,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					8,
					8,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.201,
								0.201,
								0.18
							],
							y: [
								1.243,
								1.243,
								1
							]
						},
						o: {
							x: [
								0.037,
								0.037,
								0.21
							],
							y: [
								0.201,
								0.201,
								0
							]
						},
						t: 18,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.769,
								0.769,
								0.833
							],
							y: [
								8.723,
								8.723,
								1
							]
						},
						o: {
							x: [
								0.351,
								0.351,
								0.167
							],
							y: [
								-6.837,
								-6.837,
								0
							]
						},
						t: 30,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 36,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.509,
								-0.491
							],
							[
								0.042,
								-0.038
							],
							[
								0.869,
								-0.759
							],
							[
								-0.127,
								-0.628
							],
							[
								-0.013,
								-0.058
							],
							[
								0.313,
								-0.17
							],
							[
								0.084,
								0
							],
							[
								0.444,
								0.254
							],
							[
								0.047,
								0.031
							],
							[
								0.988,
								0.63
							],
							[
								0.013,
								-0.008
							],
							[
								0.28,
								-0.16
							],
							[
								0.214,
								0
							],
							[
								0.063,
								0.034
							],
							[
								-0.163,
								0.747
							],
							[
								-0.009,
								0.042
							],
							[
								-0.193,
								0.868
							],
							[
								0.011,
								0.01
							],
							[
								0.234,
								0.226
							],
							[
								-0.04,
								0.267
							],
							[
								-0.73,
								0.076
							],
							[
								-0.041,
								0.005
							],
							[
								-0.827,
								0.083
							],
							[
								-0.242,
								0.572
							],
							[
								-0.023,
								0.055
							],
							[
								-0.324,
								0
							],
							[
								0,
								0
							],
							[
								-0.006,
								-0.001
							],
							[
								-0.006,
								0.001
							],
							[
								0,
								0
							],
							[
								-0.263,
								-0.651
							],
							[
								-0.016,
								-0.041
							],
							[
								-0.382,
								-0.956
							],
							[
								-0.608,
								-0.075
							],
							[
								-0.057,
								-0.006
							],
							[
								-0.054,
								-0.364
							]
						],
						o: [
							[
								-0.234,
								0.225
							],
							[
								-0.012,
								0.01
							],
							[
								0.194,
								0.868
							],
							[
								0.009,
								0.042
							],
							[
								0.164,
								0.747
							],
							[
								-0.064,
								0.034
							],
							[
								-0.214,
								0
							],
							[
								-0.28,
								-0.16
							],
							[
								-0.014,
								-0.008
							],
							[
								-0.987,
								0.63
							],
							[
								-0.049,
								0.031
							],
							[
								-0.444,
								0.254
							],
							[
								-0.085,
								0
							],
							[
								-0.313,
								-0.17
							],
							[
								0.013,
								-0.058
							],
							[
								0.127,
								-0.627
							],
							[
								-0.868,
								-0.76
							],
							[
								-0.042,
								-0.038
							],
							[
								-0.51,
								-0.491
							],
							[
								0.054,
								-0.364
							],
							[
								0.057,
								-0.006
							],
							[
								0.608,
								-0.075
							],
							[
								0.381,
								-0.956
							],
							[
								0.017,
								-0.041
							],
							[
								0.263,
								-0.651
							],
							[
								0,
								0
							],
							[
								0.007,
								0.001
							],
							[
								0.006,
								-0.001
							],
							[
								0,
								0
							],
							[
								0.325,
								0
							],
							[
								0.023,
								0.056
							],
							[
								0.242,
								0.572
							],
							[
								0.827,
								0.083
							],
							[
								0.042,
								0.004
							],
							[
								0.73,
								0.076
							],
							[
								0.04,
								0.267
							]
						],
						v: [
							[
								15.334,
								7.269
							],
							[
								14.038,
								8.434
							],
							[
								12.08,
								10.162
							],
							[
								13.006,
								14.375
							],
							[
								13.039,
								14.528
							],
							[
								12.974,
								15.948
							],
							[
								12.75,
								16
							],
							[
								11.799,
								15.634
							],
							[
								10.327,
								14.724
							],
							[
								8,
								13.258
							],
							[
								5.674,
								14.724
							],
							[
								4.202,
								15.634
							],
							[
								3.251,
								16
							],
							[
								3.027,
								15.948
							],
							[
								2.961,
								14.528
							],
							[
								2.994,
								14.375
							],
							[
								3.92,
								10.162
							],
							[
								1.963,
								8.434
							],
							[
								0.667,
								7.269
							],
							[
								0.005,
								6.202
							],
							[
								1.271,
								5.684
							],
							[
								1.421,
								5.668
							],
							[
								5.469,
								5.246
							],
							[
								7.078,
								1.257
							],
							[
								7.137,
								1.112
							],
							[
								7.936,
								0
							],
							[
								7.981,
								0.003
							],
							[
								8,
								0.008
							],
							[
								8.019,
								0.003
							],
							[
								8.064,
								0
							],
							[
								8.863,
								1.112
							],
							[
								8.922,
								1.257
							],
							[
								10.532,
								5.246
							],
							[
								14.579,
								5.668
							],
							[
								14.729,
								5.684
							],
							[
								15.995,
								6.202
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 25,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "icon-complete",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					140,
					145.054,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					33,
					30.257,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.671,
								0.64,
								0.833
							],
							y: [
								1.183,
								1.136,
								1
							]
						},
						o: {
							x: [
								0.503,
								0.503,
								0.19
							],
							y: [
								0.002,
								0.002,
								0
							]
						},
						t: 18,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.777,
								0.833,
								0.833
							],
							y: [
								6.733,
								1,
								1
							]
						},
						o: {
							x: [
								0.459,
								0.167,
								0.167
							],
							y: [
								-11.083,
								-2.73,
								0
							]
						},
						t: 29,
						s: [
							95.482,
							95.482,
							100
						]
					},
					{
						t: 34,
						s: [
							95.482,
							95.482,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.967,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.966
							],
							[
								0,
								0
							],
							[
								-0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.966
							],
							[
								0,
								0
							]
						],
						o: [
							[
								0,
								0
							],
							[
								-0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.966
							],
							[
								0,
								0
							],
							[
								0.967,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.966
							]
						],
						v: [
							[
								57.6,
								10.751
							],
							[
								8.4,
								10.751
							],
							[
								6.65,
								12.501
							],
							[
								6.65,
								12.602
							],
							[
								8.4,
								14.352
							],
							[
								57.6,
								14.352
							],
							[
								59.35,
								12.602
							],
							[
								59.35,
								12.501
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			},
			{
				ind: 2,
				ty: "sh",
				ix: 3,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.966
							],
							[
								0,
								0
							],
							[
								-0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.966
							],
							[
								0,
								0
							]
						],
						o: [
							[
								0,
								0
							],
							[
								-0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.966
							],
							[
								0,
								0
							],
							[
								0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.966
							]
						],
						v: [
							[
								34.134,
								23.353
							],
							[
								8.4,
								23.353
							],
							[
								6.65,
								25.103
							],
							[
								6.65,
								25.204
							],
							[
								8.4,
								26.954
							],
							[
								34.134,
								26.954
							],
							[
								35.884,
								25.204
							],
							[
								35.884,
								25.103
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 2",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 2",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			},
			{
				ind: 4,
				ty: "sh",
				ix: 5,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.967,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.966
							],
							[
								0,
								0
							],
							[
								-0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.966
							],
							[
								0,
								0
							]
						],
						o: [
							[
								0,
								0
							],
							[
								-0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.966
							],
							[
								0,
								0
							],
							[
								0.967,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.966
							]
						],
						v: [
							[
								57.6,
								17.052
							],
							[
								8.4,
								17.052
							],
							[
								6.65,
								18.802
							],
							[
								6.65,
								18.903
							],
							[
								8.4,
								20.653
							],
							[
								57.6,
								20.653
							],
							[
								59.35,
								18.903
							],
							[
								59.35,
								18.802
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 3",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 3",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			},
			{
				ind: 6,
				ty: "sh",
				ix: 7,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0,
								0
							],
							[
								0.138,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.76
							],
							[
								5.737,
								0
							],
							[
								0,
								-5.676
							],
							[
								-0.233,
								-0.786
							],
							[
								0,
								0
							],
							[
								0,
								0.138
							],
							[
								0,
								0
							],
							[
								-0.138,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.138
							]
						],
						o: [
							[
								0,
								0.138
							],
							[
								0,
								0
							],
							[
								0.195,
								-0.79
							],
							[
								0,
								-5.676
							],
							[
								-5.736,
								0
							],
							[
								0,
								0.828
							],
							[
								0,
								0
							],
							[
								-0.138,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.138
							],
							[
								0,
								0
							],
							[
								0.138,
								0
							],
							[
								0,
								0
							]
						],
						v: [
							[
								62.117,
								44.106
							],
							[
								61.867,
								44.356
							],
							[
								58.015,
								44.356
							],
							[
								58.283,
								41.955
							],
							[
								47.933,
								31.754
							],
							[
								37.583,
								41.955
							],
							[
								37.894,
								44.356
							],
							[
								4.133,
								44.356
							],
							[
								3.883,
								44.106
							],
							[
								3.883,
								4.1
							],
							[
								4.133,
								3.85
							],
							[
								61.867,
								3.85
							],
							[
								62.117,
								4.1
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 4",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ind: 7,
				ty: "sh",
				ix: 8,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.206,
								-0.028
							],
							[
								0,
								0
							],
							[
								0.107,
								-0.78
							],
							[
								0,
								0
							],
							[
								0.147,
								0.144
							],
							[
								0,
								0
							],
							[
								-0.023,
								0.125
							],
							[
								-0.118,
								0.068
							],
							[
								-0.824,
								0.994
							],
							[
								-0.098,
								0.009
							],
							[
								-0.054,
								-0.053
							],
							[
								0,
								0
							]
						],
						o: [
							[
								0,
								0
							],
							[
								-0.781,
								0.104
							],
							[
								0,
								0
							],
							[
								-0.027,
								0.204
							],
							[
								0,
								0
							],
							[
								-0.06,
								-0.059
							],
							[
								0.024,
								-0.132
							],
							[
								1.131,
								-0.652
							],
							[
								0.07,
								-0.085
							],
							[
								0.093,
								-0.008
							],
							[
								0,
								0
							],
							[
								0.149,
								0.146
							]
						],
						v: [
							[
								58.608,
								50.723
							],
							[
								57.443,
								50.878
							],
							[
								55.94,
								52.374
							],
							[
								55.781,
								53.529
							],
							[
								55.358,
								53.674
							],
							[
								53.002,
								51.354
							],
							[
								52.931,
								51.079
							],
							[
								53.156,
								50.756
							],
							[
								56.107,
								48.244
							],
							[
								56.374,
								48.102
							],
							[
								56.595,
								48.175
							],
							[
								58.75,
								50.297
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 5",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ind: 8,
				ty: "sh",
				ix: 9,
				ks: {
					a: 0,
					k: {
						i: [
							[
								3.757,
								0
							],
							[
								0,
								3.671
							],
							[
								-3.757,
								0
							],
							[
								0,
								-3.67
							]
						],
						o: [
							[
								-3.757,
								0
							],
							[
								0,
								-3.67
							],
							[
								3.757,
								0
							],
							[
								0,
								3.671
							]
						],
						v: [
							[
								47.933,
								48.556
							],
							[
								41.217,
								41.955
							],
							[
								47.933,
								35.354
							],
							[
								54.65,
								41.955
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 6",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ind: 9,
				ty: "sh",
				ix: 10,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.061,
								-0.06
							],
							[
								0,
								0
							],
							[
								0.028,
								0.204
							],
							[
								0,
								0
							],
							[
								0.78,
								0.104
							],
							[
								0,
								0
							],
							[
								-0.145,
								0.147
							],
							[
								0,
								0
							],
							[
								-0.105,
								-0.012
							],
							[
								-0.075,
								-0.096
							],
							[
								-1.15,
								-0.644
							],
							[
								-0.025,
								-0.133
							]
						],
						o: [
							[
								0,
								0
							],
							[
								-0.146,
								0.144
							],
							[
								0,
								0
							],
							[
								-0.107,
								-0.78
							],
							[
								0,
								0
							],
							[
								-0.205,
								-0.028
							],
							[
								0,
								0
							],
							[
								0.055,
								-0.056
							],
							[
								0.11,
								0.012
							],
							[
								0.791,
								1.024
							],
							[
								0.121,
								0.068
							],
							[
								0.025,
								0.126
							]
						],
						v: [
							[
								42.844,
								51.374
							],
							[
								40.508,
								53.674
							],
							[
								40.085,
								53.529
							],
							[
								39.927,
								52.374
							],
							[
								38.424,
								50.878
							],
							[
								37.229,
								50.719
							],
							[
								37.084,
								50.295
							],
							[
								39.215,
								48.148
							],
							[
								39.454,
								48.073
							],
							[
								39.75,
								48.24
							],
							[
								42.682,
								50.772
							],
							[
								42.914,
								51.097
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 7",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ind: 10,
				ty: "sh",
				ix: 11,
				ks: {
					a: 0,
					k: {
						i: [
							[
								0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.967
							],
							[
								0,
								0
							],
							[
								-0.966,
								0
							],
							[
								0,
								0
							],
							[
								0.159,
								-0.157
							],
							[
								0,
								0
							],
							[
								-1.434,
								-0.205
							],
							[
								0,
								0
							],
							[
								-0.016,
								-0.11
							],
							[
								0,
								0
							],
							[
								-1.015,
								1.024
							],
							[
								0,
								0
							],
							[
								-0.011,
								0.004
							],
							[
								0.003,
								0
							],
							[
								-0.014,
								-0.002
							],
							[
								-0.292,
								0
							],
							[
								0,
								0
							],
							[
								-0.047,
								-0.046
							],
							[
								0,
								0
							],
							[
								-0.191,
								1.431
							],
							[
								0,
								0
							],
							[
								-0.111,
								0.016
							],
							[
								0,
								0
							],
							[
								1.032,
								1.017
							],
							[
								0,
								0
							],
							[
								-0.224,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.967
							],
							[
								0,
								0
							]
						],
						o: [
							[
								0,
								0
							],
							[
								-0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0.967
							],
							[
								0,
								0
							],
							[
								0.224,
								0
							],
							[
								0,
								0
							],
							[
								-1.032,
								1.017
							],
							[
								0,
								0
							],
							[
								0.11,
								0.015
							],
							[
								0,
								0
							],
							[
								0.211,
								1.427
							],
							[
								0,
								0
							],
							[
								0.024,
								-0.025
							],
							[
								0.009,
								-0.003
							],
							[
								0.013,
								0.002
							],
							[
								0.181,
								0.027
							],
							[
								0,
								0
							],
							[
								0.065,
								0
							],
							[
								0,
								0
							],
							[
								1.029,
								1.013
							],
							[
								0,
								0
							],
							[
								0.015,
								-0.111
							],
							[
								0,
								0
							],
							[
								1.434,
								-0.205
							],
							[
								0,
								0
							],
							[
								-0.16,
								-0.157
							],
							[
								0,
								0
							],
							[
								0.966,
								0
							],
							[
								0,
								0
							],
							[
								0,
								-0.967
							]
						],
						v: [
							[
								64,
								0.25
							],
							[
								2,
								0.25
							],
							[
								0.25,
								2
							],
							[
								0.25,
								46.206
							],
							[
								2,
								47.956
							],
							[
								33.652,
								47.956
							],
							[
								33.828,
								48.384
							],
							[
								31.46,
								50.715
							],
							[
								32.44,
								53.695
							],
							[
								36.315,
								54.249
							],
							[
								36.527,
								54.46
							],
							[
								37.086,
								58.254
							],
							[
								40.06,
								59.231
							],
							[
								47.106,
								52.126
							],
							[
								47.162,
								52.086
							],
							[
								47.169,
								52.084
							],
							[
								47.21,
								52.09
							],
							[
								47.933,
								52.157
							],
							[
								48.484,
								52.157
							],
							[
								48.659,
								52.228
							],
							[
								55.792,
								59.251
							],
							[
								58.755,
								58.235
							],
							[
								59.243,
								54.567
							],
							[
								59.456,
								54.352
							],
							[
								63.32,
								53.8
							],
							[
								64.3,
								50.82
							],
							[
								61.826,
								48.384
							],
							[
								62.001,
								47.956
							],
							[
								64,
								47.956
							],
							[
								65.75,
								46.206
							],
							[
								65.75,
								2
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 8",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "mm",
				mm: 1,
				nm: "Merge Paths 1",
				mn: "ADBE Vector Filter - Merge",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 4",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 18,
		op: 268,
		st: 18,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "light-circle-behind-bigger",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 99,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					140,
					140,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					60,
					60,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.37,
								0.37,
								0.37
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.67,
								0.63,
								0.63
							],
							y: [
								3.928,
								0,
								0
							]
						},
						t: 0,
						s: [
							43,
							43,
							100
						]
					},
					{
						i: {
							x: [
								0.377,
								0.37,
								0.37
							],
							y: [
								5.634,
								1,
								1
							]
						},
						o: {
							x: [
								0.63,
								0.63,
								0.63
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 2.667,
						s: [
							42,
							43,
							100
						]
					},
					{
						i: {
							x: [
								0.37,
								0.37,
								0.37
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.63,
								0.63,
								0.63
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 6,
						s: [
							43,
							42,
							100
						]
					},
					{
						i: {
							x: [
								0.37,
								0.37,
								0.37
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.63,
								0.63,
								0.63
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 9.333,
						s: [
							42,
							43,
							100
						]
					},
					{
						i: {
							x: [
								0.271,
								0.221,
								0.25
							],
							y: [
								1.234,
								1.062,
								1
							]
						},
						o: {
							x: [
								0.63,
								0.63,
								0.63
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 12,
						s: [
							41,
							41,
							100
						]
					},
					{
						t: 31,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [
							[
								33.333,
								0
							],
							[
								0,
								-33.333
							],
							[
								-33.333,
								0
							],
							[
								0,
								33.333
							]
						],
						o: [
							[
								-33.333,
								0
							],
							[
								0,
								33.333
							],
							[
								33.333,
								0
							],
							[
								0,
								-33.333
							]
						],
						v: [
							[
								60,
								0
							],
							[
								0,
								60
							],
							[
								60,
								120
							],
							[
								120,
								60
							]
						],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			},
			{
				ty: "fl",
				c: {
					a: 0,
					k: [
						0.12549019607843137,
						0.6352941176470588,
						0.4196078431372549,
						1
					],
					ix: 4
				},
				o: {
					a: 0,
					k: 10,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: "Fill 1",
				mn: "ADBE Vector Graphic - Fill",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	}
];
var markers$1 = [
];
var animationData$1 = {
	v: v$1,
	fr: fr$1,
	ip: ip$1,
	op: op$1,
	w: w$1,
	h: h$1,
	nm: nm$1,
	ddd: ddd$1,
	assets: assets$1,
	layers: layers$1,
	markers: markers$1
};

function TrainingCompletedAnimation({
  primaryColor
}) {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: replaceColor('#20A26B', primaryColor, animationData$1),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return /*#__PURE__*/React$1.createElement(_default, {
    options: defaultOptions
  });
}

var v = "5.9.0";
var fr = 30;
var ip = 14;
var op = 204;
var w = 180;
var h = 180;
var nm = "loading-story-v02";
var ddd = 0;
var assets = [
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 3,
		nm: "shield-dolly-out",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					90,
					90,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					50,
					50,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								0.833,
								17.667
							]
						},
						o: {
							x: [
								0.9,
								0.9,
								0.9
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 194,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 202,
						s: [
							0,
							0,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		ip: 141,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "success-outlines",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					50,
					54.947,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					52.905,
					63.885,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-1.529,
										0.051
									],
									[
										-10.656,
										8.062
									],
									[
										-1,
										-0.756
									],
									[
										-15.952,
										-0.532
									],
									[
										0,
										-1.53
									],
									[
										0,
										0
									],
									[
										7.103,
										-3.169
									],
									[
										0.745,
										0.332
									],
									[
										0,
										36.535
									],
									[
										0,
										0
									]
								],
								o: [
									[
										15.952,
										-0.532
									],
									[
										1,
										-0.756
									],
									[
										10.656,
										8.062
									],
									[
										1.529,
										0.051
									],
									[
										0,
										0
									],
									[
										0,
										36.535
									],
									[
										-0.745,
										0.332
									],
									[
										-7.103,
										-3.169
									],
									[
										0,
										0
									],
									[
										0,
										-1.53
									]
								],
								v: [
									[
										-42.668,
										-41.871
									],
									[
										-1.693,
										-55.63
									],
									[
										1.694,
										-55.63
									],
									[
										42.669,
										-41.871
									],
									[
										45.406,
										-39.026
									],
									[
										45.406,
										-1.968
									],
									[
										1.167,
										56.053
									],
									[
										-1.167,
										56.053
									],
									[
										-45.406,
										-1.968
									],
									[
										-45.406,
										-39.026
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 0,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								52.905,
								63.886
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.8
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.59
								],
								y: [
									0
								]
							},
							t: 147.2,
							s: [
								0
							]
						},
						{
							t: 166.4001953125,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.8
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.59
								],
								y: [
									0
								]
							},
							t: 147,
							s: [
								-85
							]
						},
						{
							t: 172.4001953125,
							s: [
								70
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 141.2,
		op: 1041.2,
		st: 141.2,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "icone",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					52.215,
					55.534,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					28.299,
					21.366,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										20.799,
										-13.866
									],
									[
										6.936,
										0.001
									],
									[
										-6.937,
										13.866
									],
									[
										-20.799,
										0.001
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8,
								0.129411764706,
								0.239215686275,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 4,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								28.298,
								21.365
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.4
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.69
								],
								y: [
									0
								]
							},
							t: 162.8,
							s: [
								66
							]
						},
						{
							t: 168.7998046875,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.4
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.69
								],
								y: [
									0
								]
							},
							t: 162.8,
							s: [
								66
							]
						},
						{
							t: 168.7998046875,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 159.2,
		op: 1034,
		st: 134,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "burst",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					48.286,
					49.857,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.63,
										y: 1
									},
									o: {
										x: 0.37,
										y: 0
									},
									t: 155.6,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										2.5
									],
									ti: [
										4.333,
										-2.5
									]
								},
								{
									t: 171.2001953125,
									s: [
										-26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.129411764706,
								0.239215686275,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.647,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 6",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.63,
										y: 1
									},
									o: {
										x: 0.37,
										y: 0
									},
									t: 155.6,
									s: [
										0,
										0
									],
									to: [
										4.333,
										2.5
									],
									ti: [
										-4.333,
										-2.5
									]
								},
								{
									t: 171.2001953125,
									s: [
										26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.129411764706,
								0.239215686275,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 5",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.63,
										y: 1
									},
									o: {
										x: 0.37,
										y: 0
									},
									t: 155.6,
									s: [
										0,
										0
									],
									to: [
										4.333,
										-2.5
									],
									ti: [
										-4.333,
										2.5
									]
								},
								{
									t: 171.2001953125,
									s: [
										26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.129411764706,
								0.239215686275,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								4.601
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 4",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.63,
										y: 1
									},
									o: {
										x: 0.37,
										y: 0
									},
									t: 155.6,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										-2.5
									],
									ti: [
										4.333,
										2.5
									]
								},
								{
									t: 171.2001953125,
									s: [
										-26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.129411764706,
								0.239215686275,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.861,
								4.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 3",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.63,
										y: 1
									},
									o: {
										x: 0.37,
										y: 0
									},
									t: 155.6,
									s: [
										0,
										0
									],
									to: [
										0,
										5.167
									],
									ti: [
										0,
										-5.167
									]
								},
								{
									t: 171.2001953125,
									s: [
										0,
										31
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.129411764706,
								0.239215686275,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								11.777
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 2",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.63,
										y: 1
									},
									o: {
										x: 0.37,
										y: 0
									},
									t: 155.6,
									s: [
										0,
										0
									],
									to: [
										0,
										-5
									],
									ti: [
										0,
										5
									]
								},
								{
									t: 171.2001953125,
									s: [
										0,
										-30
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.129411764706,
								0.239215686275,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								1.984
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 155.6,
		op: 171.2,
		st: 26,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "pssw-burst-4",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					130.786,
					95.357,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 105.6,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										2.5
									],
									ti: [
										4.333,
										-2.5
									]
								},
								{
									t: 121.2001953125,
									s: [
										-26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.647,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 6",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 105.6,
									s: [
										0,
										0
									],
									to: [
										4.333,
										2.5
									],
									ti: [
										-4.333,
										-2.5
									]
								},
								{
									t: 121.2001953125,
									s: [
										26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 5",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 105.6,
									s: [
										0,
										0
									],
									to: [
										4.333,
										-2.5
									],
									ti: [
										-4.333,
										2.5
									]
								},
								{
									t: 121.2001953125,
									s: [
										26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								4.601
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 4",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 105.6,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										-2.5
									],
									ti: [
										4.333,
										2.5
									]
								},
								{
									t: 121.2001953125,
									s: [
										-26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.861,
								4.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 3",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 105.6,
									s: [
										0,
										0
									],
									to: [
										0,
										5.167
									],
									ti: [
										0,
										-5.167
									]
								},
								{
									t: 121.2001953125,
									s: [
										0,
										31
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								11.777
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 2",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 105.6,
									s: [
										0,
										0
									],
									to: [
										0,
										-5
									],
									ti: [
										0,
										5
									]
								},
								{
									t: 121.2001953125,
									s: [
										0,
										-30
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								1.984
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 105.6,
		op: 121.2,
		st: -24,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "pssw-burst-3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					103.28600000000002,
					95.357,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 102,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										2.5
									],
									ti: [
										4.333,
										-2.5
									]
								},
								{
									t: 117.6001953125,
									s: [
										-26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.647,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 6",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 102,
									s: [
										0,
										0
									],
									to: [
										4.333,
										2.5
									],
									ti: [
										-4.333,
										-2.5
									]
								},
								{
									t: 117.6001953125,
									s: [
										26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 5",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 102,
									s: [
										0,
										0
									],
									to: [
										4.333,
										-2.5
									],
									ti: [
										-4.333,
										2.5
									]
								},
								{
									t: 117.6001953125,
									s: [
										26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								4.601
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 4",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 102,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										-2.5
									],
									ti: [
										4.333,
										2.5
									]
								},
								{
									t: 117.6001953125,
									s: [
										-26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.861,
								4.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 3",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 102,
									s: [
										0,
										0
									],
									to: [
										0,
										5.167
									],
									ti: [
										0,
										-5.167
									]
								},
								{
									t: 117.6001953125,
									s: [
										0,
										31
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								11.777
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 2",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 102,
									s: [
										0,
										0
									],
									to: [
										0,
										-5
									],
									ti: [
										0,
										5
									]
								},
								{
									t: 117.6001953125,
									s: [
										0,
										-30
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								1.984
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 102,
		op: 117.6,
		st: -27.6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "pssw-burst-2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					75.286,
					95.357,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 96,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										2.5
									],
									ti: [
										4.333,
										-2.5
									]
								},
								{
									t: 111.6001953125,
									s: [
										-26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.647,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 6",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 96,
									s: [
										0,
										0
									],
									to: [
										4.333,
										2.5
									],
									ti: [
										-4.333,
										-2.5
									]
								},
								{
									t: 111.6001953125,
									s: [
										26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 5",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 96,
									s: [
										0,
										0
									],
									to: [
										4.333,
										-2.5
									],
									ti: [
										-4.333,
										2.5
									]
								},
								{
									t: 111.6001953125,
									s: [
										26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								4.601
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 4",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 96,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										-2.5
									],
									ti: [
										4.333,
										2.5
									]
								},
								{
									t: 111.6001953125,
									s: [
										-26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.861,
								4.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 3",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 96,
									s: [
										0,
										0
									],
									to: [
										0,
										5.167
									],
									ti: [
										0,
										-5.167
									]
								},
								{
									t: 111.6001953125,
									s: [
										0,
										31
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								11.777
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 2",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 96,
									s: [
										0,
										0
									],
									to: [
										0,
										-5
									],
									ti: [
										0,
										5
									]
								},
								{
									t: 111.6001953125,
									s: [
										0,
										-30
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								1.984
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 96,
		op: 111.6,
		st: -33.6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "pssw-burst-1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					48.036,
					95.357,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 91.2,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										2.5
									],
									ti: [
										4.333,
										-2.5
									]
								},
								{
									t: 106.8001953125,
									s: [
										-26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.647,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 6",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 91.2,
									s: [
										0,
										0
									],
									to: [
										4.333,
										2.5
									],
									ti: [
										-4.333,
										-2.5
									]
								},
								{
									t: 106.8001953125,
									s: [
										26,
										15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								9.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 5",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 91.2,
									s: [
										0,
										0
									],
									to: [
										4.333,
										-2.5
									],
									ti: [
										-4.333,
										2.5
									]
								},
								{
									t: 106.8001953125,
									s: [
										26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.853,
								4.601
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 4",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 91.2,
									s: [
										0,
										0
									],
									to: [
										-4.333,
										-2.5
									],
									ti: [
										4.333,
										2.5
									]
								},
								{
									t: 106.8001953125,
									s: [
										-26,
										-15
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2.861,
								4.459
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 3",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 91.2,
									s: [
										0,
										0
									],
									to: [
										0,
										5.167
									],
									ti: [
										0,
										-5.167
									]
								},
								{
									t: 106.8001953125,
									s: [
										0,
										31
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								11.777
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 2",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								2.4,
								2.4
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.87,
										y: 1
									},
									o: {
										x: 0.45,
										y: 0
									},
									t: 91.2,
									s: [
										0,
										0
									],
									to: [
										0,
										-5
									],
									ti: [
										0,
										5
									]
								},
								{
									t: 106.8001953125,
									s: [
										0,
										-30
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1.537,
								1.984
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 91.2,
		op: 106.8,
		st: -38.4,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 3,
		nm: "doll-null",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				s: true,
				x: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.984
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.016
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								90
							]
						},
						{
							t: 19.2001953125,
							s: [
								90
							]
						}
					],
					ix: 3
				},
				y: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.701
								],
								y: [
									0.886
								]
							},
							o: {
								x: [
									0.561
								],
								y: [
									0.449
								]
							},
							t: 0,
							s: [
								-88
							]
						},
						{
							i: {
								x: [
									0.526
								],
								y: [
									1.686
								]
							},
							o: {
								x: [
									0.367
								],
								y: [
									-8.268
								]
							},
							t: 19.2,
							s: [
								90
							]
						},
						{
							t: 51.599609375,
							s: [
								90
							]
						}
					],
					ix: 4
				}
			},
			a: {
				a: 0,
				k: [
					50,
					50,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "simi Outlines",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.646,
					-17.423,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					1.5,
					16.677,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.8,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 19.2,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													1.5,
													1.5
												],
												[
													1.5,
													31.854
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.8,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 36,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													1.521,
													-0.875
												],
												[
													1.5,
													31.854
												]
											],
											c: false
										}
									]
								},
								{
									t: 79.2001953125,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													1.5,
													1.5
												],
												[
													1.5,
													31.854
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 12,
							s: [
								100
							]
						},
						{
							i: {
								x: [
									0.833
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0
								]
							},
							t: 19.2,
							s: [
								0
							]
						},
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.803
								]
							},
							o: {
								x: [
									0.8
								],
								y: [
									0
								]
							},
							t: 63.6,
							s: [
								0
							]
						},
						{
							t: 79.2001953125,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 16.8,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "hook-front",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.662
							],
							y: [
								1.035
							]
						},
						o: {
							x: [
								0.375
							],
							y: [
								0.877
							]
						},
						t: 7.2,
						s: [
							-0.347
						]
					},
					{
						i: {
							x: [
								0.564
							],
							y: [
								0.962
							]
						},
						o: {
							x: [
								0.363
							],
							y: [
								0.111
							]
						},
						t: 32.4,
						s: [
							12.879
						]
					},
					{
						t: 82.799609375,
						s: [
							-0.347
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.855,
					9.582,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					14.807,
					12.697,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-3.046
									],
									[
										3.046,
										0
									],
									[
										0,
										3.046
									],
									[
										-3.046,
										0
									]
								],
								o: [
									[
										0,
										3.046
									],
									[
										-3.046,
										0
									],
									[
										0,
										-3.046
									],
									[
										3.046,
										0
									]
								],
								v: [
									[
										5.516,
										0
									],
									[
										0,
										5.516
									],
									[
										-5.516,
										0
									],
									[
										0,
										-5.516
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 64.8,
									s: [
										100
									]
								},
								{
									t: 80.4001953125,
									s: [
										0
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 80,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								14.598,
								13.016
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										6.405,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										6.406
									],
									[
										0,
										0
									]
								],
								v: [
									[
										5.799,
										-20.008
									],
									[
										5.799,
										6.067
									],
									[
										5.799,
										8.41
									],
									[
										-5.799,
										20.008
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 80.4,
									s: [
										0
									]
								},
								{
									t: 93.600390625,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								8.799,
								39.385
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.8
								],
								y: [
									0
								]
							},
							t: 75.6,
							s: [
								0
							]
						},
						{
							t: 93.600390625,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.8
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0
								]
							},
							t: 13.2,
							s: [
								43
							]
						},
						{
							t: 31.2,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							t: 69.6,
							s: [
								0
							],
							h: 1
						},
						{
							t: 74.4001953125,
							s: [
								158
							],
							h: 1
						}
					],
					ix: 3
				},
				m: 2,
				ix: 3,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 1.2,
		op: 301.2,
		st: 1.2,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "phishing-frame ",
		parent: 14,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.78
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.19
							],
							y: [
								0
							]
						},
						t: 15.6,
						s: [
							-10
						]
					},
					{
						i: {
							x: [
								0.78
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.19
							],
							y: [
								0
							]
						},
						t: 36,
						s: [
							0
						]
					},
					{
						t: 68.400390625,
						s: [
							3
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.82,
							y: 1
						},
						o: {
							x: 0.18,
							y: 0
						},
						t: 15.6,
						s: [
							3.567,
							55.846,
							0
						],
						to: [
							-0.832,
							0.095,
							0
						],
						ti: [
							-0.692,
							-0.263,
							0
						]
					},
					{
						i: {
							x: 0.82,
							y: 1
						},
						o: {
							x: 0.18,
							y: 0
						},
						t: 36,
						s: [
							-1.425,
							56.418,
							0
						],
						to: [
							0.692,
							0.263,
							0
						],
						ti: [
							-1.524,
							-0.168,
							0
						]
					},
					{
						t: 68.400390625,
						s: [
							7.718,
							57.424,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					48.936,
					9.142,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										3.479,
										-0.427
									],
									[
										0,
										0
									],
									[
										0.428,
										3.478
									],
									[
										0,
										0
									],
									[
										-3.479,
										0.427
									],
									[
										0,
										0
									],
									[
										-0.427,
										-3.479
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-3.479,
										0.427
									],
									[
										0,
										0
									],
									[
										-0.427,
										-3.479
									],
									[
										0,
										0
									],
									[
										3.479,
										-0.427
									],
									[
										0,
										0
									],
									[
										0.427,
										3.478
									]
								],
								v: [
									[
										43.026,
										28.137
									],
									[
										-34.941,
										37.711
									],
									[
										-42.014,
										32.186
									],
									[
										-48.552,
										-21.064
									],
									[
										-43.026,
										-28.137
									],
									[
										34.941,
										-37.71
									],
									[
										42.013,
										-32.184
									],
									[
										48.552,
										21.066
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.800000059838,
								0.129411764706,
								0.239215701234,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								51.979,
								41.138
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.8
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.79
								],
								y: [
									0
								]
							},
							t: 72,
							s: [
								0
							]
						},
						{
							t: 92.400390625,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.81
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 15.6,
							s: [
								0
							]
						},
						{
							i: {
								x: [
									0.833
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0
								]
							},
							t: 43.2,
							s: [
								100
							]
						},
						{
							t: 68.400390625,
							s: [
								100
							],
							h: 1
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.81
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 15.6,
							s: [
								159
							]
						},
						{
							i: {
								x: [
									0.833
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0
								]
							},
							t: 43.2,
							s: [
								193
							]
						},
						{
							t: 68.4,
							s: [
								193
							],
							h: 1
						},
						{
							t: 72,
							s: [
								265
							],
							h: 1
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "phishing-inside-lines",
		parent: 15,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					51.203,
					39.791,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					47.778,
					37.799,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										18.124,
										13.446
									],
									[
										-18.124,
										-13.445
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.800000059838,
								0.129411764706,
								0.239215701234,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								75.932,
								51.921
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										14.611,
										-16.618
									],
									[
										-14.611,
										16.618
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.800000059838,
								0.129411764706,
								0.239215701234,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								25.095,
								57.48
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-2.441,
										2.736
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										3.031,
										2.077
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-42.41,
										-10.441
									],
									[
										-1.072,
										19.59
									],
									[
										8.498,
										18.426
									],
									[
										42.409,
										-21.667
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.800000059838,
								0.129411764706,
								0.239215701234,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								45.409,
								24.667
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 16.8,
							s: [
								1
							]
						},
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 56.4,
							s: [
								100
							]
						},
						{
							t: 72,
							s: [
								100
							],
							h: 1
						},
						{
							i: {
								x: [
									0.8
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.8
								],
								y: [
									0
								]
							},
							t: 79.2,
							s: [
								100
							]
						},
						{
							t: 93.599609375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 16.8,
							s: [
								-203
							]
						},
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 56.4,
							s: [
								-103
							]
						},
						{
							t: 72,
							s: [
								-103
							],
							h: 1
						}
					],
					ix: 3
				},
				m: 2,
				ix: 4,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 15.6,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "hook-behind",
		parent: 14,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-2.8,
					48.014,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					8.799,
					14.379,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-2.61,
										-4.521
									],
									[
										-2.61,
										4.521
									],
									[
										2.61,
										4.521
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 96,
									s: [
										0
									]
								},
								{
									t: 99.599609375,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 33.6,
									s: [
										0
									]
								},
								{
									t: 36,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 53,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								5.61,
								7.521
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										6.405
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-6.406,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										5.799,
										10.004
									],
									[
										-5.799,
										-1.594
									],
									[
										-5.799,
										-10.004
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 88.8,
									s: [
										0
									]
								},
								{
									t: 97.2001953125,
									s: [
										99
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 28.8,
									s: [
										0
									]
								},
								{
									t: 34.7998046875,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								8.799,
								15.754
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 99.6,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "lock",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					135.404,
					121.02,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					31.285,
					41.052,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-2.607
									],
									[
										2.607,
										0
									],
									[
										0,
										2.607
									],
									[
										-2.607,
										0
									]
								],
								o: [
									[
										0,
										2.607
									],
									[
										-2.607,
										0
									],
									[
										0,
										-2.607
									],
									[
										2.607,
										0
									]
								],
								v: [
									[
										4.721,
										13.002
									],
									[
										-0.001,
										17.723
									],
									[
										-4.721,
										13.002
									],
									[
										-0.001,
										8.281
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-3.498,
										0
									],
									[
										0,
										-3.494
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-3.497
									],
									[
										3.501,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										6.343,
										-6.209
									],
									[
										-6.344,
										-6.209
									],
									[
										-6.344,
										-15.91
									],
									[
										-0.006,
										-22.248
									],
									[
										6.343,
										-15.91
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 2,
						ty: "sh",
						ix: 3,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-2.733
									],
									[
										0,
										0
									],
									[
										-2.733,
										0
									],
									[
										0,
										0
									],
									[
										0,
										2.734
									],
									[
										0,
										0
									],
									[
										2.733,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										9.732,
										0
									],
									[
										0,
										-9.734
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-2.713,
										0
									],
									[
										0,
										0
									],
									[
										0,
										2.713
									],
									[
										0,
										0
									],
									[
										2.713,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-2.712
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-9.736
									],
									[
										-9.734,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-17.648,
										-6.209
									],
									[
										-18.84,
										-6.209
									],
									[
										-23.785,
										-1.264
									],
									[
										-23.785,
										28.607
									],
									[
										-18.84,
										33.552
									],
									[
										18.839,
										33.552
									],
									[
										23.785,
										28.607
									],
									[
										23.785,
										-1.264
									],
									[
										18.839,
										-6.209
									],
									[
										17.647,
										-6.209
									],
									[
										17.647,
										-15.91
									],
									[
										-0.006,
										-33.552
									],
									[
										-17.648,
										-15.91
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 3",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "mm",
						mm: 1,
						nm: "Merge Paths 1",
						mn: "ADBE Vector Filter - Merge",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.800000059838,
								0.129411764706,
								0.239215701234,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.278431372549,
								0.278431372549,
								0.274509803922,
								1
							],
							ix: 4
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.81
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.81
										],
										y: [
											0
										]
									},
									t: 89.018,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.19
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0
										]
									},
									t: 97.2,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.19
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.22
										],
										y: [
											0
										]
									},
									t: 145.2,
									s: [
										100
									]
								},
								{
									t: 148.7998046875,
									s: [
										0
									]
								}
							],
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								31.284,
								41.052
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 6,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.81
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.81
								],
								y: [
									0
								]
							},
							t: 75.6,
							s: [
								90
							]
						},
						{
							i: {
								x: [
									0.19
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.81
								],
								y: [
									0
								]
							},
							t: 108.327,
							s: [
								0
							]
						},
						{
							t: 130.7998046875,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.81
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.81
								],
								y: [
									0
								]
							},
							t: 90.327,
							s: [
								90
							]
						},
						{
							i: {
								x: [
									0.19
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.81
								],
								y: [
									0
								]
							},
							t: 111.6,
							s: [
								100
							]
						},
						{
							i: {
								x: [
									0.879
								],
								y: [
									0.873
								]
							},
							o: {
								x: [
									0.953
								],
								y: [
									0.188
								]
							},
							t: 130.8,
							s: [
								100
							]
						},
						{
							t: 152.400390625,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							t: 80.4,
							s: [
								4
							],
							h: 1
						},
						{
							t: 130.7998046875,
							s: [
								0
							],
							h: 1
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "pss-dots Outlines",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					90.875,
					101.657,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					50.25,
					8.447,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.527
									],
									[
										4.527,
										0
									],
									[
										0,
										4.527
									],
									[
										-4.527,
										0
									]
								],
								o: [
									[
										0,
										4.527
									],
									[
										-4.527,
										0
									],
									[
										0,
										-4.527
									],
									[
										4.527,
										0
									]
								],
								v: [
									[
										8.197,
										0
									],
									[
										0,
										8.197
									],
									[
										-8.197,
										0
									],
									[
										0,
										-8.197
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								92.053,
								8.447
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.527
									],
									[
										4.527,
										0
									],
									[
										0,
										4.527
									],
									[
										-4.527,
										0
									]
								],
								o: [
									[
										0,
										4.527
									],
									[
										-4.527,
										0
									],
									[
										0,
										-4.527
									],
									[
										4.527,
										0
									]
								],
								v: [
									[
										8.197,
										0
									],
									[
										0,
										8.197
									],
									[
										-8.197,
										0
									],
									[
										0,
										-8.197
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								36.316,
								8.447
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.22,
											0.22
										],
										y: [
											1,
											1
										]
									},
									o: {
										x: [
											0.167,
											0.167
										],
										y: [
											0.167,
											0.167
										]
									},
									t: 94.8,
									s: [
										0,
										0
									]
								},
								{
									t: 102,
									s: [
										100,
										100
									]
								}
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 136.8,
									s: [
										100
									]
								},
								{
									t: 140.400390625,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.527
									],
									[
										4.527,
										0
									],
									[
										0,
										4.527
									],
									[
										-4.527,
										0
									]
								],
								o: [
									[
										0,
										4.527
									],
									[
										-4.527,
										0
									],
									[
										0,
										-4.527
									],
									[
										4.527,
										0
									]
								],
								v: [
									[
										8.197,
										0
									],
									[
										0,
										8.197
									],
									[
										-8.197,
										0
									],
									[
										0,
										-8.197
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								64.185,
								8.447
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.22,
											0.22
										],
										y: [
											1,
											1
										]
									},
									o: {
										x: [
											0.167,
											0.167
										],
										y: [
											0.167,
											0.167
										]
									},
									t: 99.6,
									s: [
										0,
										0
									]
								},
								{
									t: 106.7998046875,
									s: [
										100,
										100
									]
								}
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 139.2,
									s: [
										100
									]
								},
								{
									t: 142.7998046875,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-4.527
									],
									[
										4.527,
										0
									],
									[
										0,
										4.527
									],
									[
										-4.527,
										0
									]
								],
								o: [
									[
										0,
										4.527
									],
									[
										-4.527,
										0
									],
									[
										0,
										-4.527
									],
									[
										4.527,
										0
									]
								],
								v: [
									[
										8.197,
										0
									],
									[
										0,
										8.197
									],
									[
										-8.197,
										0
									],
									[
										0,
										-8.197
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								8.447,
								8.447
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.23,
											0.23
										],
										y: [
											1,
											1
										]
									},
									o: {
										x: [
											0.15,
											0.15
										],
										y: [
											0,
											0
										]
									},
									t: 88.8,
									s: [
										0,
										0
									]
								},
								{
									t: 96,
									s: [
										100,
										100
									]
								}
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 134.4,
									s: [
										100
									]
								},
								{
									t: 138,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 72,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 22,
		ty: 4,
		nm: "passwordPrinter",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					90.633,
					101.657,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					76.782,
					28.457,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										3.308,
										0
									],
									[
										0,
										0
									],
									[
										0,
										3.308
									],
									[
										0,
										0
									],
									[
										-3.308,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-3.308
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-3.308,
										0
									],
									[
										0,
										0
									],
									[
										0,
										-3.308
									],
									[
										0,
										0
									],
									[
										3.308,
										0
									],
									[
										0,
										0
									],
									[
										0,
										3.308
									]
								],
								v: [
									[
										67.735,
										25.399
									],
									[
										-67.734,
										25.399
									],
									[
										-73.725,
										19.409
									],
									[
										-73.725,
										-19.409
									],
									[
										-67.734,
										-25.399
									],
									[
										67.735,
										-25.399
									],
									[
										73.725,
										-19.409
									],
									[
										73.725,
										19.409
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8,
								0.12941176470588237,
								0.23921568627450981,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.058,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								76.782,
								28.457
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.73
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.61
								],
								y: [
									0
								]
							},
							t: 147,
							s: [
								0
							]
						},
						{
							t: 160,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.4
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.51
								],
								y: [
									0
								]
							},
							t: 73.2,
							s: [
								0
							]
						},
						{
							t: 110.400390625,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.833
								],
								y: [
									0.833
								]
							},
							o: {
								x: [
									0.167
								],
								y: [
									0.167
								]
							},
							t: 111,
							s: [
								-109
							]
						},
						{
							t: 147,
							s: [
								95
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 72,
		op: 300,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var animationData = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$1(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf$1(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized$1(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

var reduceHexValue$1 = reduceHexValue;

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */


function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$3({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDarken = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(darken);
var curriedDarken$1 = curriedDarken;

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$3({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore


var curriedLighten = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(lighten);
var curriedLighten$1 = curriedLighten;

/** Recommendation: If using VS Code, install 'Color Highlight' extention to see colour shades directly in the editor */

const palette = {
  graphite: {
    white: '#FFFFFF',
    cloud: '#F7F7F7',
    gray: '#F0EFEF',
    pearl: '#F6FBF9',
    silver: '#EFEFEF',
    ash: '#A5A5A5',
    charcoal: '#777877',
    heavyMetal: '#3B3C3B',
    onyx: '#1D1E1D'
  },
  evergreen: {
    mintLight: '#E9F6F0',
    mint: '#DEF1E9',
    lime: '#8CBD00',
    aspargusLight: '#36AB7A',
    aspargus: '#20A26B'
  },
  vibrant: {
    yellow: '#FFD860',
    gold: '#FCBE00',
    orange: '#FF8540',
    coral: '#C95020',
    red: '#EB5757',
    raspberry: '#CC213D',
    blue: '#3646D9'
  },
  pastel: {
    red: '#FDF2F2',
    orange: '#FFF5F0',
    yellow: '#FFF8E5',
    lime: '#F6FAEB',
    aspargus: '#EDF8F3'
  },
  lightroom: {
    whiteLight: rgba(255, 255, 255, 0.8),
    cloudLight: rgba(247, 247, 247, 0.5),
    goldLight: rgba(252, 190, 0, 0.8),
    goldLightHigh: rgba(252, 190, 0, 0.1),
    redLight: rgba(235, 87, 87, 0.8),
    redLightHigh: rgba(235, 87, 87, 0.1),
    aspargusLight: rgba(32, 162, 107, 0.8),
    aspargusLightHigh: rgba(32, 162, 107, 0.1),
    heavyMetalLight: rgba(59, 60, 59, 0.8),
    heavyMetalLightHigh: rgba(59, 60, 59, 0.1),
    heavyMetalLightUltra: rgba(59, 60, 59, 0.05),
    blackLight: rgba(0, 0, 0, 0.8)
  }
};

function WaitingAnimation() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: replaceColor(palette.vibrant.raspberry, '#FFFFFF', animationData),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return /*#__PURE__*/React$1.createElement(_default, {
    options: defaultOptions
  });
}

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}

function Button({
  children,
  ...rest
}) {
  return /*#__PURE__*/React$1.createElement(Button$1, _extends$2({
    variant: 'outlined',
    color: 'primary'
  }, rest), children);
}

var reactClipboard = {exports: {}};

var clipboard = {exports: {}};

/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */

var hasRequiredClipboard;

function requireClipboard () {
	if (hasRequiredClipboard) return clipboard.exports;
	hasRequiredClipboard = 1;
	(function (module, exports) {
		(function webpackUniversalModuleDefinition(root, factory) {
			module.exports = factory();
		})(commonjsGlobal, function() {
		return /******/ (function() { // webpackBootstrap
		/******/ 	var __webpack_modules__ = ({

		/***/ 686:
		/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

		// EXPORTS
		__webpack_require__.d(__webpack_exports__, {
		  "default": function() { return /* binding */ clipboard; }
		});

		// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
		var tiny_emitter = __webpack_require__(279);
		var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
		// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
		var listen = __webpack_require__(370);
		var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
		// EXTERNAL MODULE: ./node_modules/select/src/select.js
		var src_select = __webpack_require__(817);
		var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
		/**
		 * Executes a given operation type.
		 * @param {String} type
		 * @return {Boolean}
		 */
		function command(type) {
		  try {
		    return document.execCommand(type);
		  } catch (err) {
		    return false;
		  }
		}


		/**
		 * Cut action wrapper.
		 * @param {String|HTMLElement} target
		 * @return {String}
		 */

		var ClipboardActionCut = function ClipboardActionCut(target) {
		  var selectedText = select_default()(target);
		  command('cut');
		  return selectedText;
		};

		/* harmony default export */ var actions_cut = (ClipboardActionCut);
		/**
		 * Creates a fake textarea element with a value.
		 * @param {String} value
		 * @return {HTMLElement}
		 */
		function createFakeElement(value) {
		  var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
		  var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS

		  fakeElement.style.fontSize = '12pt'; // Reset box model

		  fakeElement.style.border = '0';
		  fakeElement.style.padding = '0';
		  fakeElement.style.margin = '0'; // Move element out of screen horizontally

		  fakeElement.style.position = 'absolute';
		  fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

		  var yPosition = window.pageYOffset || document.documentElement.scrollTop;
		  fakeElement.style.top = "".concat(yPosition, "px");
		  fakeElement.setAttribute('readonly', '');
		  fakeElement.value = value;
		  return fakeElement;
		}



		/**
		 * Create fake copy action wrapper using a fake element.
		 * @param {String} target
		 * @param {Object} options
		 * @return {String}
		 */

		var fakeCopyAction = function fakeCopyAction(value, options) {
		  var fakeElement = createFakeElement(value);
		  options.container.appendChild(fakeElement);
		  var selectedText = select_default()(fakeElement);
		  command('copy');
		  fakeElement.remove();
		  return selectedText;
		};
		/**
		 * Copy action wrapper.
		 * @param {String|HTMLElement} target
		 * @param {Object} options
		 * @return {String}
		 */


		var ClipboardActionCopy = function ClipboardActionCopy(target) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
		    container: document.body
		  };
		  var selectedText = '';

		  if (typeof target === 'string') {
		    selectedText = fakeCopyAction(target, options);
		  } else if (target instanceof HTMLInputElement && !['text', 'search', 'url', 'tel', 'password'].includes(target === null || target === void 0 ? void 0 : target.type)) {
		    // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
		    selectedText = fakeCopyAction(target.value, options);
		  } else {
		    selectedText = select_default()(target);
		    command('copy');
		  }

		  return selectedText;
		};

		/* harmony default export */ var actions_copy = (ClipboardActionCopy);
		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



		/**
		 * Inner function which performs selection from either `text` or `target`
		 * properties and then executes copy or cut operations.
		 * @param {Object} options
		 */

		var ClipboardActionDefault = function ClipboardActionDefault() {
		  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		  // Defines base properties passed from constructor.
		  var _options$action = options.action,
		      action = _options$action === void 0 ? 'copy' : _options$action,
		      container = options.container,
		      target = options.target,
		      text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.

		  if (action !== 'copy' && action !== 'cut') {
		    throw new Error('Invalid "action" value, use either "copy" or "cut"');
		  } // Sets the `target` property using an element that will be have its content copied.


		  if (target !== undefined) {
		    if (target && _typeof(target) === 'object' && target.nodeType === 1) {
		      if (action === 'copy' && target.hasAttribute('disabled')) {
		        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
		      }

		      if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
		        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
		      }
		    } else {
		      throw new Error('Invalid "target" value, use a valid Element');
		    }
		  } // Define selection strategy based on `text` property.


		  if (text) {
		    return actions_copy(text, {
		      container: container
		    });
		  } // Defines which selection strategy based on `target` property.


		  if (target) {
		    return action === 'cut' ? actions_cut(target) : actions_copy(target, {
		      container: container
		    });
		  }
		};

		/* harmony default export */ var actions_default = (ClipboardActionDefault);
		function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }

		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

		function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

		function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

		function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

		function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

		function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

		function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

		function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }






		/**
		 * Helper function to retrieve attribute value.
		 * @param {String} suffix
		 * @param {Element} element
		 */

		function getAttributeValue(suffix, element) {
		  var attribute = "data-clipboard-".concat(suffix);

		  if (!element.hasAttribute(attribute)) {
		    return;
		  }

		  return element.getAttribute(attribute);
		}
		/**
		 * Base class which takes one or more elements, adds event listeners to them,
		 * and instantiates a new `ClipboardAction` on each click.
		 */


		var Clipboard = /*#__PURE__*/function (_Emitter) {
		  _inherits(Clipboard, _Emitter);

		  var _super = _createSuper(Clipboard);

		  /**
		   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
		   * @param {Object} options
		   */
		  function Clipboard(trigger, options) {
		    var _this;

		    _classCallCheck(this, Clipboard);

		    _this = _super.call(this);

		    _this.resolveOptions(options);

		    _this.listenClick(trigger);

		    return _this;
		  }
		  /**
		   * Defines if attributes would be resolved using internal setter functions
		   * or custom functions that were passed in the constructor.
		   * @param {Object} options
		   */


		  _createClass(Clipboard, [{
		    key: "resolveOptions",
		    value: function resolveOptions() {
		      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
		      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
		      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
		      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
		    }
		    /**
		     * Adds a click event listener to the passed trigger.
		     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
		     */

		  }, {
		    key: "listenClick",
		    value: function listenClick(trigger) {
		      var _this2 = this;

		      this.listener = listen_default()(trigger, 'click', function (e) {
		        return _this2.onClick(e);
		      });
		    }
		    /**
		     * Defines a new `ClipboardAction` on each click event.
		     * @param {Event} e
		     */

		  }, {
		    key: "onClick",
		    value: function onClick(e) {
		      var trigger = e.delegateTarget || e.currentTarget;
		      var action = this.action(trigger) || 'copy';
		      var text = actions_default({
		        action: action,
		        container: this.container,
		        target: this.target(trigger),
		        text: this.text(trigger)
		      }); // Fires an event based on the copy operation result.

		      this.emit(text ? 'success' : 'error', {
		        action: action,
		        text: text,
		        trigger: trigger,
		        clearSelection: function clearSelection() {
		          if (trigger) {
		            trigger.focus();
		          }

		          window.getSelection().removeAllRanges();
		        }
		      });
		    }
		    /**
		     * Default `action` lookup function.
		     * @param {Element} trigger
		     */

		  }, {
		    key: "defaultAction",
		    value: function defaultAction(trigger) {
		      return getAttributeValue('action', trigger);
		    }
		    /**
		     * Default `target` lookup function.
		     * @param {Element} trigger
		     */

		  }, {
		    key: "defaultTarget",
		    value: function defaultTarget(trigger) {
		      var selector = getAttributeValue('target', trigger);

		      if (selector) {
		        return document.querySelector(selector);
		      }
		    }
		    /**
		     * Allow fire programmatically a copy action
		     * @param {String|HTMLElement} target
		     * @param {Object} options
		     * @returns Text copied.
		     */

		  }, {
		    key: "defaultText",

		    /**
		     * Default `text` lookup function.
		     * @param {Element} trigger
		     */
		    value: function defaultText(trigger) {
		      return getAttributeValue('text', trigger);
		    }
		    /**
		     * Destroy lifecycle.
		     */

		  }, {
		    key: "destroy",
		    value: function destroy() {
		      this.listener.destroy();
		    }
		  }], [{
		    key: "copy",
		    value: function copy(target) {
		      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
		        container: document.body
		      };
		      return actions_copy(target, options);
		    }
		    /**
		     * Allow fire programmatically a cut action
		     * @param {String|HTMLElement} target
		     * @returns Text cutted.
		     */

		  }, {
		    key: "cut",
		    value: function cut(target) {
		      return actions_cut(target);
		    }
		    /**
		     * Returns the support of the given action, or all actions if no action is
		     * given.
		     * @param {String} [action]
		     */

		  }, {
		    key: "isSupported",
		    value: function isSupported() {
		      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
		      var actions = typeof action === 'string' ? [action] : action;
		      var support = !!document.queryCommandSupported;
		      actions.forEach(function (action) {
		        support = support && !!document.queryCommandSupported(action);
		      });
		      return support;
		    }
		  }]);

		  return Clipboard;
		}((tiny_emitter_default()));

		/* harmony default export */ var clipboard = (Clipboard);

		/***/ }),

		/***/ 828:
		/***/ (function(module) {

		var DOCUMENT_NODE_TYPE = 9;

		/**
		 * A polyfill for Element.matches()
		 */
		if (typeof Element !== 'undefined' && !Element.prototype.matches) {
		    var proto = Element.prototype;

		    proto.matches = proto.matchesSelector ||
		                    proto.mozMatchesSelector ||
		                    proto.msMatchesSelector ||
		                    proto.oMatchesSelector ||
		                    proto.webkitMatchesSelector;
		}

		/**
		 * Finds the closest parent that matches a selector.
		 *
		 * @param {Element} element
		 * @param {String} selector
		 * @return {Function}
		 */
		function closest (element, selector) {
		    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
		        if (typeof element.matches === 'function' &&
		            element.matches(selector)) {
		          return element;
		        }
		        element = element.parentNode;
		    }
		}

		module.exports = closest;


		/***/ }),

		/***/ 438:
		/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

		var closest = __webpack_require__(828);

		/**
		 * Delegates event to a selector.
		 *
		 * @param {Element} element
		 * @param {String} selector
		 * @param {String} type
		 * @param {Function} callback
		 * @param {Boolean} useCapture
		 * @return {Object}
		 */
		function _delegate(element, selector, type, callback, useCapture) {
		    var listenerFn = listener.apply(this, arguments);

		    element.addEventListener(type, listenerFn, useCapture);

		    return {
		        destroy: function() {
		            element.removeEventListener(type, listenerFn, useCapture);
		        }
		    }
		}

		/**
		 * Delegates event to a selector.
		 *
		 * @param {Element|String|Array} [elements]
		 * @param {String} selector
		 * @param {String} type
		 * @param {Function} callback
		 * @param {Boolean} useCapture
		 * @return {Object}
		 */
		function delegate(elements, selector, type, callback, useCapture) {
		    // Handle the regular Element usage
		    if (typeof elements.addEventListener === 'function') {
		        return _delegate.apply(null, arguments);
		    }

		    // Handle Element-less usage, it defaults to global delegation
		    if (typeof type === 'function') {
		        // Use `document` as the first parameter, then apply arguments
		        // This is a short way to .unshift `arguments` without running into deoptimizations
		        return _delegate.bind(null, document).apply(null, arguments);
		    }

		    // Handle Selector-based usage
		    if (typeof elements === 'string') {
		        elements = document.querySelectorAll(elements);
		    }

		    // Handle Array-like based usage
		    return Array.prototype.map.call(elements, function (element) {
		        return _delegate(element, selector, type, callback, useCapture);
		    });
		}

		/**
		 * Finds closest match and invokes callback.
		 *
		 * @param {Element} element
		 * @param {String} selector
		 * @param {String} type
		 * @param {Function} callback
		 * @return {Function}
		 */
		function listener(element, selector, type, callback) {
		    return function(e) {
		        e.delegateTarget = closest(e.target, selector);

		        if (e.delegateTarget) {
		            callback.call(element, e);
		        }
		    }
		}

		module.exports = delegate;


		/***/ }),

		/***/ 879:
		/***/ (function(__unused_webpack_module, exports) {

		/**
		 * Check if argument is a HTML element.
		 *
		 * @param {Object} value
		 * @return {Boolean}
		 */
		exports.node = function(value) {
		    return value !== undefined
		        && value instanceof HTMLElement
		        && value.nodeType === 1;
		};

		/**
		 * Check if argument is a list of HTML elements.
		 *
		 * @param {Object} value
		 * @return {Boolean}
		 */
		exports.nodeList = function(value) {
		    var type = Object.prototype.toString.call(value);

		    return value !== undefined
		        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
		        && ('length' in value)
		        && (value.length === 0 || exports.node(value[0]));
		};

		/**
		 * Check if argument is a string.
		 *
		 * @param {Object} value
		 * @return {Boolean}
		 */
		exports.string = function(value) {
		    return typeof value === 'string'
		        || value instanceof String;
		};

		/**
		 * Check if argument is a function.
		 *
		 * @param {Object} value
		 * @return {Boolean}
		 */
		exports.fn = function(value) {
		    var type = Object.prototype.toString.call(value);

		    return type === '[object Function]';
		};


		/***/ }),

		/***/ 370:
		/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

		var is = __webpack_require__(879);
		var delegate = __webpack_require__(438);

		/**
		 * Validates all params and calls the right
		 * listener function based on its target type.
		 *
		 * @param {String|HTMLElement|HTMLCollection|NodeList} target
		 * @param {String} type
		 * @param {Function} callback
		 * @return {Object}
		 */
		function listen(target, type, callback) {
		    if (!target && !type && !callback) {
		        throw new Error('Missing required arguments');
		    }

		    if (!is.string(type)) {
		        throw new TypeError('Second argument must be a String');
		    }

		    if (!is.fn(callback)) {
		        throw new TypeError('Third argument must be a Function');
		    }

		    if (is.node(target)) {
		        return listenNode(target, type, callback);
		    }
		    else if (is.nodeList(target)) {
		        return listenNodeList(target, type, callback);
		    }
		    else if (is.string(target)) {
		        return listenSelector(target, type, callback);
		    }
		    else {
		        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
		    }
		}

		/**
		 * Adds an event listener to a HTML element
		 * and returns a remove listener function.
		 *
		 * @param {HTMLElement} node
		 * @param {String} type
		 * @param {Function} callback
		 * @return {Object}
		 */
		function listenNode(node, type, callback) {
		    node.addEventListener(type, callback);

		    return {
		        destroy: function() {
		            node.removeEventListener(type, callback);
		        }
		    }
		}

		/**
		 * Add an event listener to a list of HTML elements
		 * and returns a remove listener function.
		 *
		 * @param {NodeList|HTMLCollection} nodeList
		 * @param {String} type
		 * @param {Function} callback
		 * @return {Object}
		 */
		function listenNodeList(nodeList, type, callback) {
		    Array.prototype.forEach.call(nodeList, function(node) {
		        node.addEventListener(type, callback);
		    });

		    return {
		        destroy: function() {
		            Array.prototype.forEach.call(nodeList, function(node) {
		                node.removeEventListener(type, callback);
		            });
		        }
		    }
		}

		/**
		 * Add an event listener to a selector
		 * and returns a remove listener function.
		 *
		 * @param {String} selector
		 * @param {String} type
		 * @param {Function} callback
		 * @return {Object}
		 */
		function listenSelector(selector, type, callback) {
		    return delegate(document.body, selector, type, callback);
		}

		module.exports = listen;


		/***/ }),

		/***/ 817:
		/***/ (function(module) {

		function select(element) {
		    var selectedText;

		    if (element.nodeName === 'SELECT') {
		        element.focus();

		        selectedText = element.value;
		    }
		    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
		        var isReadOnly = element.hasAttribute('readonly');

		        if (!isReadOnly) {
		            element.setAttribute('readonly', '');
		        }

		        element.select();
		        element.setSelectionRange(0, element.value.length);

		        if (!isReadOnly) {
		            element.removeAttribute('readonly');
		        }

		        selectedText = element.value;
		    }
		    else {
		        if (element.hasAttribute('contenteditable')) {
		            element.focus();
		        }

		        var selection = window.getSelection();
		        var range = document.createRange();

		        range.selectNodeContents(element);
		        selection.removeAllRanges();
		        selection.addRange(range);

		        selectedText = selection.toString();
		    }

		    return selectedText;
		}

		module.exports = select;


		/***/ }),

		/***/ 279:
		/***/ (function(module) {

		function E () {
		  // Keep this empty so it's easier to inherit from
		  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
		}

		E.prototype = {
		  on: function (name, callback, ctx) {
		    var e = this.e || (this.e = {});

		    (e[name] || (e[name] = [])).push({
		      fn: callback,
		      ctx: ctx
		    });

		    return this;
		  },

		  once: function (name, callback, ctx) {
		    var self = this;
		    function listener () {
		      self.off(name, listener);
		      callback.apply(ctx, arguments);
		    }
		    listener._ = callback;
		    return this.on(name, listener, ctx);
		  },

		  emit: function (name) {
		    var data = [].slice.call(arguments, 1);
		    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
		    var i = 0;
		    var len = evtArr.length;

		    for (i; i < len; i++) {
		      evtArr[i].fn.apply(evtArr[i].ctx, data);
		    }

		    return this;
		  },

		  off: function (name, callback) {
		    var e = this.e || (this.e = {});
		    var evts = e[name];
		    var liveEvents = [];

		    if (evts && callback) {
		      for (var i = 0, len = evts.length; i < len; i++) {
		        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
		          liveEvents.push(evts[i]);
		      }
		    }

		    // Remove event from queue to prevent memory leak
		    // Suggested by https://github.com/lazd
		    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

		    (liveEvents.length)
		      ? e[name] = liveEvents
		      : delete e[name];

		    return this;
		  }
		};

		module.exports = E;
		module.exports.TinyEmitter = E;


		/***/ })

		/******/ 	});
		/************************************************************************/
		/******/ 	// The module cache
		/******/ 	var __webpack_module_cache__ = {};
		/******/ 	
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		/******/ 		// Check if module is in cache
		/******/ 		if(__webpack_module_cache__[moduleId]) {
		/******/ 			return __webpack_module_cache__[moduleId].exports;
		/******/ 		}
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = __webpack_module_cache__[moduleId] = {
		/******/ 			// no module.id needed
		/******/ 			// no module.loaded needed
		/******/ 			exports: {}
		/******/ 		};
		/******/ 	
		/******/ 		// Execute the module function
		/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
		/******/ 	
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		/******/ 	
		/************************************************************************/
		/******/ 	/* webpack/runtime/compat get default export */
		/******/ 	!function() {
		/******/ 		// getDefaultExport function for compatibility with non-harmony modules
		/******/ 		__webpack_require__.n = function(module) {
		/******/ 			var getter = module && module.__esModule ?
		/******/ 				function() { return module['default']; } :
		/******/ 				function() { return module; };
		/******/ 			__webpack_require__.d(getter, { a: getter });
		/******/ 			return getter;
		/******/ 		};
		/******/ 	}();
		/******/ 	
		/******/ 	/* webpack/runtime/define property getters */
		/******/ 	!function() {
		/******/ 		// define getter functions for harmony exports
		/******/ 		__webpack_require__.d = function(exports, definition) {
		/******/ 			for(var key in definition) {
		/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
		/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
		/******/ 				}
		/******/ 			}
		/******/ 		};
		/******/ 	}();
		/******/ 	
		/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
		/******/ 	!function() {
		/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); };
		/******/ 	}();
		/******/ 	
		/************************************************************************/
		/******/ 	// module exports must be returned from runtime so entry inlining is disabled
		/******/ 	// startup
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(686);
		/******/ })()
		.default;
		}); 
	} (clipboard));
	return clipboard.exports;
}

(function (module, exports) {
	(function webpackUniversalModuleDefinition(root, factory) {
		module.exports = factory(requireClipboard(), propTypesExports, React$1, require$$3);
	})(commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE_clipboard__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = "./index.js");
	/******/ })
	/************************************************************************/
	/******/ ({

	/***/ "./index.js":
	/*!******************!*\
	  !*** ./index.js ***!
	  \******************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
	/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
	/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
	/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





	var ClipboardButton =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ClipboardButton, _React$Component);

	  function ClipboardButton() {
	    _classCallCheck(this, ClipboardButton);

	    return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardButton).apply(this, arguments));
	  }

	  _createClass(ClipboardButton, [{
	    key: "propsWith",
	    value: function propsWith(regexp) {
	      var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var object = {};
	      Object.keys(this.props).forEach(function (key) {
	        if (key.search(regexp) !== -1) {
	          var objectKey = remove ? key.replace(regexp, '') : key;
	          object[objectKey] = this.props[key];
	        }
	      }, this);
	      return object;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clipboard && this.clipboard.destroy();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Support old API by trying to assign this.props.options first;
	      var options = this.props.options || this.propsWith(/^option-/, true);
	      var element = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this.element);

	      if (!element) {
	        return;
	      }

	      var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");

	      this.clipboard = new Clipboard(element, options);
	      var callbacks = this.propsWith(/^on/, true);
	      Object.keys(callbacks).forEach(function (callback) {
	        this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
	      }, this);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;

	      var attributes = _objectSpread({
	        title: this.props.title || '',
	        type: this.getType(),
	        className: this.props.className || '',
	        style: this.props.style || {},
	        ref: function ref(element) {
	          return _this.element = element;
	        },
	        onClick: this.props.onClick
	      }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));

	      var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");

	      if (!this.props.isVisibleWhenUnsupported && !Clipboard.isSupported()) {
	        return null;
	      }

	      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(this.getComponent(), attributes, this.props.children);
	    }
	  }, {
	    key: "getType",
	    value: function getType() {
	      if (this.getComponent() === 'button' || this.getComponent() === 'input') {
	        return this.props.type || 'button';
	      } else {
	        return undefined;
	      }
	    }
	  }, {
	    key: "getComponent",
	    value: function getComponent() {
	      return this.props.component || 'button';
	    }
	  }]);

	  return ClipboardButton;
	}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

	_defineProperty(ClipboardButton, "propTypes", {
	  options: function options(props, propName, componentName) {
	    var options = props[propName];

	    if (options && _typeof(options) !== 'object' || Array.isArray(options)) {
	      return new Error("Invalid props '".concat(propName, "' supplied to '").concat(componentName, "'. ") + "'".concat(propName, "' is not an object."));
	    }

	    if (props['option-text'] !== undefined) {
	      var optionText = props['option-text'];

	      if (typeof optionText !== 'function') {
	        return new Error("Invalid props 'option-text' supplied to '".concat(componentName, "'. ") + "'option-text' is not a function.");
	      }
	    }
	  },
	  title: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
	  type: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
	  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
	  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
	  component: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
	  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any
	});

	_defineProperty(ClipboardButton, "defaultProps", {
	  isVisibleWhenUnsupported: true,
	  onClick: function onClick() {}
	  /* Returns a object with all props that fulfill a certain naming pattern
	   *
	   * @param {RegExp} regexp - Regular expression representing which pattern
	   *                          you'll be searching for.
	   * @param {Boolean} remove - Determines if the regular expression should be
	   *                           removed when transmitting the key from the props
	   *                           to the new object.
	   *
	   * e.g:
	   *
	   * // Considering:
	   * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
	   *
	   * // *RegExps not using // so that this comment doesn't break up
	   * this.propsWith(option-*, true); // returns {foo: 1}
	   * this.propsWith(on*, true); // returns {Bar: 2}
	   * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
	   */

	});

	/* harmony default export */ __webpack_exports__["default"] = (ClipboardButton);

	/***/ }),

	/***/ "clipboard":
	/*!********************************************************************************************************!*\
	  !*** external {"root":"ClipboardJS","amd":"clipboard","commonjs":"clipboard","commonjs2":"clipboard"} ***!
	  \********************************************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_clipboard__;

	/***/ }),

	/***/ "prop-types":
	/*!*********************************************************************************************************!*\
	  !*** external {"root":"PropTypes","amd":"prop-types","commonjs":"prop-types","commonjs2":"prop-types"} ***!
	  \*********************************************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;

	/***/ }),

	/***/ "react":
	/*!**************************************************************************************!*\
	  !*** external {"root":"React","amd":"react","commonjs":"react","commonjs2":"react"} ***!
	  \**************************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

	/***/ }),

	/***/ "react-dom":
	/*!*****************************************************************************************************!*\
	  !*** external {"root":"ReactDOM","amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom"} ***!
	  \*****************************************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;

	/***/ })

	/******/ });
	});
	
} (reactClipboard));

var reactClipboardExports = reactClipboard.exports;
var ReactClipboard = /*@__PURE__*/getDefaultExportFromCjs(reactClipboardExports);

const Clipboard = styled(ReactClipboard)`
    background: none;
    border: none;
    color: ${palette.evergreen.aspargus};
    border-radius: 5px;
    margin: 0px;
    font-size: 0.9em;
    transition:  all 0.2s ease;
    padding-left: 0;
`;

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

const getProp = (props, propName) => {
  return props['$' + propName] || props[propName];
};
const FlexDiv = styled.div.withConfig({
  shouldForwardProp: prop => isPropValid(prop)
})`
    display: flex;
    max-width: 100%;
    flex-wrap: wrap;
    ${props => getProp(props, 'backgroundColor') && css`
            background: ${getProp(props, 'backgroundColor')};
        `}
    ${props => props.dropShadowBelow && css`
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.04),
                0px 4px 24px rgba(29, 30, 29, 0.04);
        `}
    ${props => props.dropShadowAbove && css`
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08),
                0px 4px 24px rgba(29, 30, 29, 0.08);
        `}
    ${props => props.$noWrap && css`
            flex-wrap: nowrap;
        `}
    ${props => props.padding && css`
            padding: ${props.padding}px;
        `}
    ${props => props.py && css`
            padding-top: ${props.py}px;
            padding-bottom: ${props.py}px;
        `}
    ${props => props.px && css`
            padding-left: ${props.px}px;
            padding-right: ${props.px}px;
        `}
    ${props => props.pt && css`
            padding-top: ${props.pt}px;
        `}
    ${props => props.pr && css`
            padding-right: ${props.pr}px;
        `}
    ${props => props.pb && css`
            padding-bottom: ${props.pb}px;
        `}
    ${props => props.pl && css`
            padding-left: ${props.pl}px;
        `}
    ${props => props.margin && css`
            margin: ${props.margin}px;
        `}
    ${props => props.my && css`
            margin-top: ${props.my}px;
            margin-bottom: ${props.my}px;
        `}
    ${props => props.mx && css`
            margin-left: ${props.mx}px;
            margin-right: ${props.mx}px;
        `}
    ${props => props.mt && css`
            margin-top: ${props.mt}px;
        `}
    ${props => props.mr && css`
            margin-right: ${props.mr}px;
        `}
    ${props => props.mb && css`
            margin-bottom: ${props.mb}px;
        `}
    ${props => props.ml && css`
            margin-left: ${props.ml}px;
        `}
    ${props => props.marginAuto && css`
            margin: auto;
        `}
    ${props => props.marginLeftAuto && css`
            margin-left: auto;
        `}
    
    ${props => getProp(props, 'alignCenter') && css`
            align-items: center;
        `}
    ${props => getProp(props, 'textAlignCenter') && css`
            text-align: center;
        `}
    ${props => props.alignStretch && css`
            align-items: stretch !important;
        `}
    ${props => props.justifyCenter && css`
            justify-content: center;
        `}
    
    ${props => props.alignStart && css`
            align-items: flex-start !important;
        `}
    ${props => props.alignEnd && css`
            align-items: flex-end !important;
        `}
    ${props => props.justifyEnd && css`
            justify-content: flex-end;
        `}
    
    ${props => props.column && css`
            flex-direction: column;
        `}
    
    ${props => props.width && css`
            width: ${props.width}px;
        `}
    ${props => props.widthPercentage && css`
            width: ${props.widthPercentage}%;
        `}

    ${props => props.maxWidth && css`
            max-width: ${props.maxWidth}px;
        `}
    ${props => props.maxWidthPercentage && css`
            max-width: ${props.maxWidthPercentage}%;
        `}

    ${props => props.fullWidth && css`
            width: 100%;
        `}

    ${props => props.minWidth && css`
            min-width: ${props.minWidth}px;
        `}
        
    ${props => props.height && css`
            height: ${props.height}px;
        `}
    
    ${props => props.maxHeight && css`
            max-height: ${props.maxHeight}px;
        `}
        
    ${props => props.minHeight && css`
            min-height: ${props.minHeight}px;
        `}

    ${props => props.fullHeight && css`
            height: 100%;
        `}
    
    ${props => props.flexGrow && css`
            flex: ${props.flexGrow};
        `}
    ${props => getProp(props, 'borderBottom') && css`
            border-bottom: 1px solid ${palette.lightroom.heavyMetalLightHigh};
        `}
    ${props => props.borderTop && css`
            border-top: 1px solid ${palette.lightroom.heavyMetalLightHigh};
        `}
    ${props => props.borderRight && css`
            border-right: 1px solid ${palette.lightroom.heavyMetalLightHigh};
        `}
        
    ${props => props.border && css`
            border: 1px solid ${palette.lightroom.heavyMetalLightHigh};
            border-radius: 2px;
        `}
    ${props => props.borderWidth && css`
            border-width: ${props.borderWidth}px;
        `}
    ${props => props.borderStyle && css`
            border-style: ${props.borderStyle};
        `}
    ${props => props.borderColor && css`
            border-color: ${props.borderColor};
        `}
    ${props => props.borderRadius && css`
            border-radius: ${props.borderRadius}px;
        `}
    
    ${props => props.overflowYauto && css`
            overflow-y: auto;
        `}
    ${props => props.overflowXauto && css`
            overflow-x: auto;
        `}
    ${props => props.overflowHidden && css`
            overflow: hidden;
        `}
    ${props => props.opacity && css`
            opacity: ${props.opacity};
        `}
   ${props => props.hideScrollbar && css`
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
            &::-webkit-scrollbar {
                display: none; /* all other browsers */
            }
        `}
     

    ${props => props.link && css`
            cursor: pointer;
        `}
    ${props => props.positionRelative && css`
            position: relative;
        `}
    ${props => props.positionAbsolute && css`
            position: absolute;
        `}
    ${props => props.positionSticky && css`
            position: sticky;
        `}
    ${props => props.expandFullyOverParent && css`
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
        `}
    ${props => props.top && css`
            top: ${props.top}px;
        `}
    ${props => props.left && css`
            left: ${props.left}px;
        `}
     ${props => props.right && css`
            right: ${props.right}px;
        `}
    ${props => props.zIndex && css`
            z-index: ${props.zIndex};
        `}
    
    ${props => props.wrapper && css`
            width: 100%;
            min-height: 100%;
        `}
    ${props => props.layoutWrapper && css`
            flex-direction: column;
            min-height: 100vh;
        `}
    ${props => props.columnReverse && css`
            flex-direction: column-reverse;
        `}    
    
    ${props => props.column && css`
            flex-direction: column;
        `}
    ${props => props.rowReverse && css`
            flex-direction: row-reverse;
        `}
    ${props => props.ignoreParentPadding && css`
            margin: -${props.ignoreParentPadding}px;
            max-width: initial;
        `}
    ${props => props.gap && css`
            gap: ${props.gap}px;
        `}

    ${props => props.rowGap && css`
            row-gap: ${props.rowGap}px;
        `}
    ${props => getProp(props, 'desktopOnly') && css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${props => getProp(props, 'mobileOnly') && css`
            display: none;
            @media (max-width: 992px) {
                display: flex;
            }
        `}

    ${props => getProp(props, 'stackOnMobile') && css`
            @media (max-width: 992px) {
                flex-direction: column;
                flex-wrap: nowrap;
            }
        `}
    
    ${props => props.visibilityHidden && css`
            visibility: hidden;
        `}
`;
const Block = styled(FlexDiv)`
    background: white;
    border-radius: 2px;
    padding: 32px;
    margin-top: 20px;
    flex-direction: column;
    border: 1px solid rgba(29, 30, 29, 0.07);
    @media (max-width: 992px) {
        padding: 32px 16px;
    }

    ${props => props.paddingTopOnly && css`
            padding: 32px 0 0 0;
            @media (max-width: 992px) {
                padding: 32px 0 0 0;
            }
        `}
    ${props => props.resetMargin && css`
            margin: 0;
        `}
    ${props => props.resetPadding && css`
            padding: 0;
            @media (max-width: 992px) {
                padding: 0;
            }
        `}
    ${props => props.tablePadding && css`
            padding: 32px 16px 16px 16px;
            @media (max-width: 992px) {
                padding: 32px 16px 16px 16px;
            }
        `}

        ${props => props.noBorder && css`
            border: none;
        `}
`;
const SpaceBetweenDiv = styled(FlexDiv)`
    justify-content: space-between;
    align-items: center;
    width: 100%;

    ${props => props.widthInitial && css`
            width: initial;
        `}
`;
const GridDiv = styled.div`
    display: grid;
    width: 100%;

    ${props => props.columns && css`
            grid-template-columns: repeat(${props.columns}, 1fr);
        `}

    /** Minimum width of each item in the grid, if below it (resizing window) the grid just displays fewer items in the line*/
    ${props => props.minItemWidth && css`
            grid-template-columns: repeat(
                auto-fill,
                minmax(${props.minItemWidth}px, 1fr)
            );
        `}

    ${props => props.gap && css`
            gap: ${props.gap}px;
        `}
`;
const Image$1 = styled.img`
    ${props => props.height && css`
            height: ${props.height}px;
        `}
    ${props => props.width && css`
            width: ${props.width}px;
        `}
    ${props => props.maxWidth && css`
            max-width: ${props.maxWidth}px;
        `}
    ${props => props.minWidth && css`
            min-width: ${props.minWidth}px;
        `}
    ${props => props.fullWidth && css`
            width: 100%;
        `}
    ${props => props.link && css`
            cursor: pointer;
        `}
    ${props => props.borderRadius && css`
            border-radius: ${props.borderRadius}px;
        `}

    ${props => props.cover && css`
            object-fit: cover;
        `}
    
    ${props => props.coverTop && css`
            object-fit: cover;
            object-position: 50% 0;
        `}
    
    ${props => props.cover && css`
            object-fit: cover;
        `}

    ${props => props.contain && css`
            object-fit: contain;
        `}
    
    ${props => props.borderRadiusTop && css`
            border-top-left-radius: ${props.borderRadiusTop}px;
            border-top-right-radius: ${props.borderRadiusTop}px;
        `}
    ${props => props.border && css`
            border: 1px solid ${palette.lightroom.heavyMetalLightHigh};
        `}
    
    ${props => props.dropShadow && css`
            filter: drop-shadow(rgba(0, 0, 0, 0.16) 0px 5px 3px)
                drop-shadow(rgba(0, 0, 0, 0.33) 0px 5px 6px);
            transform: translateZ(
                0
            ); //Needed to make the shadow show up in one piece on first render in Safari
        `}

    ${props => props.desktopOnly && css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${props => props.mobileOnly && css`
            display: none;
            @media (max-width: 992px) {
                display: flex;
            }
        `}
`;

/** Example: January 11, 2021 */
function formatDate(dateString) {
  if (!dateString) {
    return '';
  }
  try {
    return moment(dateString).format('LL');
    //const dt = new Date(dateString);
    //const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    //return dt.getDate() + ' ' + monthNames[dt.getMonth()] + ' ' + dt.getFullYear();
  } catch (e) {
    return '';
  }
}
function joinPath(...parts) {
  if (!parts) return '';
  let result = '';
  for (let i = 0; i < parts.length; i++) {
    result += parts[i].startsWith('/') && i > 0 ? parts[i].substr(1) : parts[i];
    if (i !== parts.length - 1 && !result.endsWith('/')) result += '/';
  }
  return result;
}
function resourcePath(path) {
  if (!path) return path;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/static')) {
    return joinPath("https://resources.awarego.com/", path.replace('/static', ''));
  }
  return path;
}
const primaryColor = props => props.color || props.theme.primary || '#20A26B';
function calculateColor(number) {
  if (number) {
    if (number <= 24) return '#EB5757';
    if (number <= 49) return '#FF8440';
    if (number <= 74) return '#F2C94C';
    if (number <= 89) return '#8CBD00';
    return '#20A26B';
  } else {
    return '#EB5757';
  }
}
function defaultZero(value) {
  return value || 0;
}
function calculateSeverityColor(variant) {
  if (variant === 'error') return 'danger';
  return variant;
}

const Heading = styled.span.withConfig({
  shouldForwardProp: prop => isPropValid(prop)
})`
    color: ${palette.graphite.heavyMetal};
    line-height: normal;
    padding: 0;
    margin: 0;
    font-weight: 700;

    ${props => props.center && css`
            text-align: center;
        `}

    ${props => props.regular && css`
            font-weight: 400 !important;
        `}

    ${props => props.bold && css`
            font-weight: 700 !important;
        `}

    ${props => props.themed && css`
            color: ${props => primaryColor(props)};
        `}
    ${props => props.color && css`
            color: ${props => props.color};
        `}
    ${props => props.lighter && css`
            opacity: 0.6;
        `}
    ${props => props.margin && css`
            margin: ${props.margin}px;
        `}
    ${props => props.my && css`
            margin-top: ${props.my}px;
            margin-bottom: ${props.my}px;
        `}
    ${props => props.mx && css`
            margin-left: ${props.mx}px;
            margin-right: ${props.mx}px;
        `}
    ${props => props.mt && css`
            margin-top: ${props.mt}px;
        `}
    ${props => props.mr && css`
            margin-right: ${props.mr}px;
        `}

    ${props => props.mb && css`
            margin-bottom: ${props.mb}px;
        `}
    ${props => props.ml && css`
            margin-left: ${props.ml}px;
        `}
    
    ${props => props.link && css`
            cursor: pointer;
        `}
    ${props => props.maxWidth && css`
            max-width: ${props.maxWidth}px;
        `}
    
    ${props => props.mobileOnly && css`
            display: none;
            @media (max-width: 992px) {
                display: initial;
            }
        `}
   ${props => props.noWrap && css`
            white-space: nowrap;
        `}
    
        // to be removed when headings are their respective proper h tags
   ${props => props.displayBlock && css`
            display: block;
        `}

    ${props => props.extraBold && css`
            font-weight: 800;
        `}
    ${props => props.desktopOnly && css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${props => props.maxLineCount && css`
            display: -webkit-box;
            -webkit-line-clamp: ${props.maxLineCount};
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
    ${props => props.lineHeight && css`
            line-height: ${props.lineHeight}!important;
        `}}

    ${props => props.fontSizeRem && css`
                font-size: ${props.fontSizeRem}rem!important;
            `}}
`;

// titles only
const Heading1 = styled(Heading)`
    font-size: 24px;
`;

// card titles
const Heading2 = styled(Heading)`
    font-size: 20px;
    font-weight: 800;
`;

// inside cards
const Heading3 = styled(Heading)`
    font-size: 16px;
`;

// smallest heading
const Heading4 = styled(Heading)`
    font-size: 14px;
`;

const DarkArrowTooltip$1 = withStyles(() => ({
  tooltip: {
    backgroundColor: 'black',
    color: 'white',
    fontFamily: 'Nunito Sans',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '18px'
  },
  arrow: {
    color: 'black'
  }
}))(Tooltip);

const Text$1 = styled.span.withConfig({
  shouldForwardProp: prop => isPropValid(prop)
})`
    font-weight: 400;
    color: ${palette.graphite.heavyMetal};
    padding: 0;
    margin: 0;

    ${props => props.center && css`
            text-align: center;
        `}

    ${props => props.semiBold && css`
            font-weight: 600;
        `}
    ${props => props.bold && css`
            font-weight: 700;
        `}
    ${props => props.extraBold && css`
            font-weight: 800;
        `}

    ${props => props.underline && css`
            text-decoration: underline;
        `}
    
    ${props => props.italic && css`
            font-style: italic;
        `}
    
    ${props => props.lighter && css`
            opacity: 0.6;
        `}

    ${props => props.color && css`
            color: ${props => props.color};
        `}
    
    ${props => props.themed && css`
            color: ${props => primaryColor(props)};
        `}
    
    ${props => props.error && css`
            color: ${palette.vibrant.red};
        `}
    
    ${props => props.flex && css`
            display: flex;
            align-items: center;
        `}
    ${props => props.gap && css`
            gap: ${props.gap}px;
        `}
    ${props => props.padding && css`
            padding: ${props.padding}px;
        `}
    ${props => props.margin && css`
            margin: ${props.margin}px;
        `}
    ${props => props.my && css`
            margin-top: ${props.my}px;
            margin-bottom: ${props.my}px;
        `}
    ${props => props.mx && css`
            margin-left: ${props.mx}px;
            margin-right: ${props.mx}px;
        `}
    ${props => props.mt && css`
            margin-top: ${props.mt}px;
        `}

    ${props => props.mb && css`
            margin-bottom: ${props.mb}px;
        `}
    ${props => props.ml && css`
            margin-left: ${props.ml}px;
        `}
    ${props => props.mr && css`
            margin-right: ${props.mr}px;
        `}
    
    ${props => props.airy && css`
            margin-right: 4px;
        `}

    ${props => props.link && css`
            cursor: pointer;
        `}
    ${props => props.uppercase && css`
            text-transform: uppercase;
        `}
    ${props => props.cutLongText && css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `}

    ${props => props.maxLineCount && css`
            display: -webkit-box;
            -webkit-line-clamp: ${props.maxLineCount};
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
    
    ${props => props.noWrap && css`
            white-space: nowrap;
        `}
        
    ${props => props.maxWidth && css`
            max-width: ${props.maxWidth}px;
        `}
    ${props => props.minWidth && css`
            min-width: ${props.minWidth}px;
        `}
    ${props => props.minHeight && css`
            min-height: ${props.minHeight}px;
        `}
    ${props => props.backgroundColor && css`
            background: ${props.backgroundColor};
        `}
    ${props => props.borderRadius && css`
            border-radius: ${props.borderRadius}px;
        `}
    ${props => props.desktopOnly && css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${props => props.mobileOnly && css`
            display: none;
            @media (max-width: 992px) {
                display: initial;
            }
        `}
    ${props => props.lineHeight && css`
            line-height: ${props.lineHeight};
        `}}

    ${props => props.fontSizeRem && css`
        font-size: ${props.fontSizeRem}rem!important;
        `}}
`;

// Text / Lead
const TextLead = styled(Text$1)`
    font-size: 16px;

`;

// Text / Default
const TextDefault = styled(Text$1)`
    font-size: 14px;
`;

// Text / Tiny (2nd line, or small widgets)
const TextTiny = styled(Text$1)`
    font-size: 13px;
`;

// Text / Label
const TextLabel = styled(Text$1)`
    font-size: 11px;
`;

const FullWidthLink = styled(Link)`
    width: 100%;
`;
function StatusBadge({
  text,
  color,
  thinner,
  transparent
}) {
  return /*#__PURE__*/React$1.createElement(FlexDiv, null, /*#__PURE__*/React$1.createElement(FlexDiv, {
    py: 2,
    px: 8,
    borderRadius: 16,
    alignCenter: true,
    justifyCenter: true,
    backgroundColor: color && !transparent ? rgba(color, 0.05) : undefined,
    border: true,
    borderColor: color ? rgba(color, 0.25) : undefined
  }, /*#__PURE__*/React$1.createElement(TextLabel, {
    extraBold: !thinner,
    color: color,
    noWrap: true,
    initialLineHeight: true
  }, text)));
}
const CleanHR = styled.hr`
    margin: 0;
    ${props => props.desktopOnly && css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${props => props.my && css`
            margin-top: ${props.my}px;
            margin-bottom: ${props.my}px;
        `}
`;
function TooltipWrapper({
  tooltipText,
  showTooltip,
  children
}) {
  if (!showTooltip) return children;
  return /*#__PURE__*/React$1.createElement(Tooltip, {
    title: tooltipText
  }, /*#__PURE__*/React$1.createElement("span", null, children));
}
function CopyToClipboardWrapper({
  copyText,
  children,
  onCopied
}) {
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 2,
    alignCenter: true,
    onClick: () => {
      navigator.clipboard.writeText(copyText);
      onCopied();
    },
    link: true,
    $noWrap: true
  }, children, /*#__PURE__*/React$1.createElement(ContentCopyIcon, {
    fontSize: "small"
  }));
}
const LightTooltip$1 = withStyles$1(theme => ({
  tooltip: {
    backgroundColor: '#FFFFFF',
    color: '#1D1E1D',
    boxShadow: theme.shadows[1],
    fontSize: 13,
    padding: '1.5em',
    borderRadius: '6px',
    fontWeight: 600,
    lineHeight: '26px'
  }
}))(Tooltip);
const DarkArrowTooltip = withStyles$1(() => ({
  tooltip: {
    backgroundColor: 'black',
    color: 'white',
    fontFamily: 'Nunito Sans',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '18px'
  },
  arrow: {
    color: 'black'
  }
}))(Tooltip);
const StyledIconButton = withStyles$1(() => ({
  root: {
    backgroundColor: 'transparent',
    color: '#777877',
    padding: '0',
    marginRight: props => props.marginRight || '16px',
    '&:hover': {
      color: '#3B3C3B',
      backgroundColor: 'transparent'
    }
  }
}))(IconButton);
const Tag = ({
  text,
  color,
  backgroundColor
}) => {
  return /*#__PURE__*/React$1.createElement(TextLabel, {
    color: color || palette.graphite.onyx,
    bold: true,
    uppercase: true,
    backgroundColor: backgroundColor || palette.graphite.gray,
    borderRadius: 4
    //link
    ,
    style: {
      padding: '2px 8px'
    }
  }, text);
};
function Snackbar({
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left'
  },
  autoHideDuration = 6000,
  variant,
  message,
  open,
  onClose
}) {
  return /*#__PURE__*/React$1.createElement(Snackbar$1, {
    anchorOrigin: anchorOrigin,
    open: open,
    autoHideDuration: autoHideDuration,
    onClose: onClose
  }, /*#__PURE__*/React$1.createElement(Alert, {
    onClose: onClose,
    severity: calculateSeverityColor(variant)
  }, message));
}

// tooltipText - specify text that should be shown on hover
// textComponent - i.e. textComponent={<Heading3>{training.name}</Heading3>}
// mobileOnly - show only on mobile
// desktopOnly - show only on desktop
// icon - by default, the icon next to the text is an info icon, but can be a different one, i.e. icon={<ExclamationIcon/>}
function TextWithTooltipIcon({
  tooltipText,
  textComponent,
  mobileOnly,
  desktopOnly,
  icon
}) {
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    alignCenter: true,
    gap: 4,
    mobileOnly: mobileOnly,
    desktopOnly: desktopOnly,
    $noWrap: true
  }, textComponent, /*#__PURE__*/React$1.createElement(LightTooltip$1, {
    title: tooltipText,
    placement: "bottom"
  }, icon || /*#__PURE__*/React$1.createElement(InfoOutlinedIcon, {
    fontSize: "small"
  })));
}

const SmallFileCopy = styled(MuiFileCopy)`
    font-size: 1em !important;
`;
const SmallEdit = styled(MuiEdit)`
    font-size: 1em !important;
`;
const SmallDelete = styled(MuiDelete)`
    font-size: 1em !important;
`;
const PrimaryOpenInNew = styled(MuiOpenInNew)`
    color: ${palette.evergreen.aspargus};
`;
const DarkArrowTooltipIcon = ({
  row,
  customFunction,
  title,
  icon
}) => {
  const ariaLabel = `${title}-icon`;
  let isMoreIcon = false;
  const iconComponent = (() => {
    switch (icon) {
      case 'delete':
        return /*#__PURE__*/React$1.createElement(DeleteIcon, null);
      case 'edit':
        return /*#__PURE__*/React$1.createElement(EditIcon, null);
      case 'more':
        isMoreIcon = true;
        return /*#__PURE__*/React$1.createElement(MoreIcon, null);
      default:
        return icon;
    }
  })();
  return /*#__PURE__*/React$1.createElement(DarkArrowTooltip$1, {
    onClick: e => e.preventDefault(),
    title: title,
    arrow: true,
    placement: "top"
  }, /*#__PURE__*/React$1.createElement(StyledIconButton, {
    "aria-controls": isMoreIcon ? "simple-menu" : undefined,
    "aria-haspopup": isMoreIcon ? "true" : "false",
    "aria-label": ariaLabel,
    onClick: e => {
      e.preventDefault();
      customFunction(e, row);
    },
    id: row.id
  }, iconComponent));
};

// making sure week on calendar starts on Monday
moment.updateLocale('en', {
  week: {
    dow: 1
  }
});
const RadioTab = styled(FlexDiv)`
    transition: 0.3s;
    border-radius: 4px;
    cursor: pointer;
    padding: 16px;

    &:hover {
        background-color: white;
    }

    ${props => props.addShadow && css`
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
        `}
`;
const useStyles$a = makeStyles(theme => ({
  inputLabel: {
    fontSize: '13px',
    fontWeight: 700,
    width: '100%',
    color: rgba(palette.graphite.heavyMetal, 0.6)
  },
  inputHelperText: {
    fontSize: '13px',
    width: '100%',
    color: rgba(palette.graphite.heavyMetal, 0.6)
  },
  multiselectError: {
    border: `1px solid ${palette.vibrant.red}`
  },
  error: {
    color: palette.vibrant.red + ' !important'
  },
  hidden: {
    display: 'none'
  },
  inputStyles: {
    '& .MuiOutlinedInput-root': {
      color: palette.graphite.heavyMetal,
      fontSize: '14px',
      fontWeight: '400 !important',
      border: '1px solid #F7F7F7',
      '&.Mui-focused fieldset, &.Mui-error fieldset, &.MuiOutlinedInput-root fieldset': {
        borderColor: 'transparent !important'
      },
      '&.Mui-focused': {
        border: `1px solid ${theme.palette.primary.main}`
      },
      '&.Mui-error': {
        border: `1px solid ${palette.vibrant.red}`
      },
      '&.Mui-disabled': {
        color: rgba(palette.graphite.heavyMetal, 0.6),
        backgroundColor: rgba(palette.graphite.heavyMetal, 0.02)
      }
    },
    '& .MuiFormLabel-shrink, .MuiFormLabel-root': {
      fontSize: '13px',
      color: rgba(palette.graphite.heavyMetal, 0.6),
      marginLeft: '2px',
      transform: 'none',
      fontWeight: 700,
      marginBottom: '4px',
      '&.Mui-error': {
        color: palette.vibrant.red
      },
      '&.Mui-focused:not(.Mui-error)': {
        color: theme.palette.primary.main
      }
    },
    '& .MuiInputBase-root': {
      height: '48px',
      background: 'transparent',
      minWidth: '240px',
      '& input': {
        paddingLeft: '12px'
      }
    },
    '& .MuiInputLabel-formControl': {
      position: 'static'
    },
    '& .MuiFormHelperText-root': {
      color: palette.vibrant.red,
      margin: '-6px 0 8px 2px',
      fontSize: '13px'
    }
  },
  heightSmall: {
    '& .MuiFormLabel-shrink': {
      marginTop: '2px'
    },
    '& .MuiInputBase-root': {
      height: '40px'
    }
  },
  heightLarge: {
    '& .MuiFormLabel-shrink': {
      marginTop: '10px'
    },
    '& .MuiInputBase-root': {
      height: '56px'
    }
  },
  widthSmall: {
    '& .MuiOutlinedInput-root': {
      maxWidth: '80px'
    },
    '& .MuiInputBase-root': {
      '& input': {
        padding: '0px !important'
      },
      minWidth: 'unset'
    }
  },
  inLine: {
    '& .MuiInputBase-root': {
      marginTop: '0px',
      marginBottom: '0px',
      minWidth: 'initial'
    }
  },
  calendarStyles: {
    '& .MuiSvgIcon-root': {
      fill: '#C4C4C4'
    }
  },
  withLeftIcon: {
    '& .MuiInputBase-root input': {
      paddingLeft: '0px'
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '8px'
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: '2px'
    }
  },
  checkboxStyles: {
    '& .MuiFormControlLabel-label': {
      fontSize: '13px',
      fontFamily: 'Nunito Sans, sans-serif',
      color: palette.graphite.heavyMetal,
      fontWeight: 700,
      marginTop: '4px'
    },
    '& .MuiCheckbox-indeterminate': {
      color: theme.palette.primary.main
    }
  },
  lighterLabel: {
    '& .MuiFormControlLabel-label': {
      color: rgba(palette.graphite.heavyMetal, 0.6)
    }
  },
  noYPadding: {
    marginBottom: '0px',
    '& .MuiCheckbox-root': {
      paddingTop: '0px',
      paddingBottom: '0px'
    }
  },
  airy: {
    '& .MuiOutlinedInput-root': {
      marginLeft: '16px'
    }
  },
  noMinWidth: {
    '& .MuiInputBase-root': {
      minWidth: 0
    }
  },
  limitWidth: {
    '& .MuiOutlinedInput-root': {
      '&.MuiOutlinedInput-root.MuiOutlinedInput-root .MuiOutlinedInput-input': {
        maxWidth: '192px'
      }
    }
  },
  selectWithIcons: {
    '& .MuiSelect-selectMenu': {
      whiteSpace: 'normal',
      display: 'flex',
      alignItems: 'center',
      gap: '2px'
    }
  },
  radiogroupStyles: {
    fontSize: '13px',
    fontFamily: 'Nunito Sans, sans-serif',
    color: palette.graphite.heavyMetal,
    fontWeight: 700
  },
  textinputGlobalStylesOverwrite: {
    '& .MuiFormLabel-shrink, .MuiFormLabel-root': {
      color: palette.graphite.heavyMetal,
      marginBottom: '8px',
      fontFamily: 'unset',
      opacity: 0.6,
      '&.Mui-focused, &.Mui-error': {
        opacity: 1
      }
    },
    '& .MuiFormHelperText-root': {
      marginTop: '0px'
    }
  },
  selectGlobalStylesOverwrite: {
    '& .MuiInputBase-root > select': {
      border: 'none',
      background: 'transparent'
    }
  },
  multiselectOverwrite: {
    background: 'transparent'
  },
  darkerInputBorder: {
    '& .MuiOutlinedInput-root': {
      border: '1px solid #A5A5A5'
    }
  }
}));
function InputLabel({
  text,
  error
}) {
  const classes = useStyles$a();
  return /*#__PURE__*/React$1.createElement(InputLabel$1, {
    className: classnames(classes.inputLabel, {
      [classes.error]: !!error
    }),
    error: !!error
  }, text);
}
function InputHelperText({
  text,
  error
}) {
  const classes = useStyles$a();
  return /*#__PURE__*/React$1.createElement(FormHelperText, {
    className: classnames(classes.inputHelperText, {
      [classes.error]: !!error
    }),
    error: !!error
  }, text);
}
function TextInput({
  stretched,
  heightSmall,
  heightLarge,
  select,
  children,
  inline,
  airy,
  limitWidth,
  isMobile,
  overwriteGlobalStyles,
  widthSmall,
  leftIcon,
  hidden,
  darkerInputBorder,
  ...props
}) {
  const classes = useStyles$a();
  return /*#__PURE__*/React$1.createElement(TextField, _extends$2({
    className: classnames(classes.inputStyles, {
      [classes.hidden]: hidden,
      [classes.heightSmall]: heightSmall,
      [classes.heightLarge]: heightLarge,
      [classes.inLine]: inline,
      [classes.airy]: airy,
      [classes.widthSmall]: widthSmall,
      [classes.limitWidth]: limitWidth,
      [classes.noMinWidth]: isMobile,
      [classes.selectWithIcons]: select,
      [classes.withLeftIcon]: leftIcon,
      [classes.darkerInputBorder]: darkerInputBorder,
      [classes.textinputGlobalStylesOverwrite]: overwriteGlobalStyles,
      [classes.selectGlobalStylesOverwrite]: overwriteGlobalStyles && isMobile
    }),
    select: select,
    margin: !inline ? 'dense' : undefined,
    variant: "outlined",
    InputLabelProps: {
      shrink: true,
      // enable showing a tooltip in the label
      style: {
        pointerEvents: 'auto'
      }
    }
  }, props, {
    fullWidth: stretched,
    SelectProps: isMobile ? {
      native: true
    } : {
      MenuProps: {
        disableScrollLock: true
      }
    },
    InputProps: leftIcon ? {
      startAdornment: /*#__PURE__*/React$1.createElement(InputAdornment, {
        position: "start"
      }, leftIcon)
    } : undefined
  }), children);
}
function MultiSelectInput({
  stretched,
  heightSmall,
  heightLarge,
  children,
  inline,
  airy,
  limitWidth,
  isMobile,
  overwriteGlobalStyles,
  widthSmall,
  leftIcon,
  label,
  helperText,
  error,
  ...props
}) {
  const classes = useStyles$a();
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(TextDefault, {
    bold: true,
    mb: 4,
    className: classnames(classes.inputLabel, {
      [classes.error]: !!error
    }),
    color: palette.graphite.charcoal
  }, label), /*#__PURE__*/React$1.createElement(Select, _extends$2({
    className: classnames(classes.inputStyles, {
      [classes.heightSmall]: heightSmall,
      [classes.heightLarge]: heightLarge,
      [classes.inLine]: inline,
      [classes.airy]: airy,
      [classes.widthSmall]: widthSmall,
      [classes.limitWidth]: limitWidth,
      [classes.noMinWidth]: isMobile,
      [classes.withLeftIcon]: leftIcon,
      [classes.textinputGlobalStylesOverwrite]: overwriteGlobalStyles,
      [classes.selectGlobalStylesOverwrite]: overwriteGlobalStyles && isMobile,
      [classes.multiselectOverwrite]: true,
      [classes.multiselectError]: !!error
    }),
    multiple: true,
    variant: "outlined"
  }, props, {
    fullWidth: stretched
  }), children), /*#__PURE__*/React$1.createElement(InputHelperText, {
    error: error,
    text: helperText
  }));
}
const SearchInput = observer(({
  children,
  searchValue,
  onClear,
  ...props
}) => {
  const classes = useStyles$a();
  return /*#__PURE__*/React$1.createElement(TextField, _extends$2({
    className: classnames(classes.inputStyles, classes.inLine),
    variant: "outlined",
    style: {
      cursor: 'pointer'
    },
    value: searchValue
  }, props, {
    InputProps: {
      endAdornment: /*#__PURE__*/React$1.createElement(Fragment, null, searchValue.length > 0 && /*#__PURE__*/React$1.createElement(InputAdornment, {
        position: "start",
        onClick: onClear
      }, /*#__PURE__*/React$1.createElement(CancelIcon, {
        fontSize: "small",
        style: {
          cursor: 'pointer'
        }
      })), /*#__PURE__*/React$1.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React$1.createElement(SearchIcon, {
        fontSize: "small",
        style: {
          cursor: 'default'
        }
      })))
    }
  }), children);
});
function CalendarInput({
  format,
  datePickerOnly,
  isStatic,
  ...props
}) {
  const classes = useStyles$a();
  const sharedCalendarProps = {
    className: classnames(classes.inputStyles, classes.calendarStyles),
    format: format || 'L',
    variant: isStatic ? 'static' : 'dialog',
    inputVariant: 'outlined',
    autoOk: true,
    disablePast: true,
    showTodayButton: true,
    cancelLabel: '',
    DialogProps: {
      disableScrollLock: true
    },
    InputProps: {
      endAdornment: /*#__PURE__*/React$1.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React$1.createElement(CalendarTodayIcon, null))
    }
  };
  console.log('sharedCalendarProps', sharedCalendarProps);
  console.log('props', props);
  return /*#__PURE__*/React$1.createElement(LocalizationProvider, {
    dateAdapter: AdapterMoment
  }, datePickerOnly ? /*#__PURE__*/React$1.createElement(DatePicker, _extends$2({}, props, sharedCalendarProps, {
    value: moment(props.value)
  })) : /*#__PURE__*/React$1.createElement(DateTimePicker, _extends$2({}, props, sharedCalendarProps, {
    value: moment(props.value)
  })));
}
function CheckboxInput({
  label,
  value,
  lighter,
  noYPadding,
  ...props
}) {
  const classes = useStyles$a();
  return /*#__PURE__*/React$1.createElement(FormControlLabel, {
    className: classnames(classes.checkboxStyles, {
      [classes.lighterLabel]: lighter,
      [classes.noYPadding]: noYPadding
    }),
    control: /*#__PURE__*/React$1.createElement(Checkbox, _extends$2({
      value: value || '',
      color: "primary"
    }, props)),
    label: label
  });
}
function RadioGroupInput({
  label,
  value,
  children,
  ...props
}) {
  const classes = useStyles$a();
  return /*#__PURE__*/React$1.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React$1.createElement(FormLabel, {
    className: classnames(classes.radiogroupStyles, {})
  }, label), /*#__PURE__*/React$1.createElement(RadioGroup, _extends$2({
    value: value || ''
  }, props), children));
}
function RadioTabInput({
  buttonText1,
  buttonText2,
  boolean,
  onChange
}) {
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    backgroundColor: palette.lightroom.heavyMetalLightHigh,
    borderRadius: 8,
    padding: 4,
    alignCenter: true,
    gap: 4,
    $noWrap: true
  }, /*#__PURE__*/React$1.createElement(RadioTab, {
    backgroundColor: boolean ? palette.graphite.white : 'transparent',
    addShadow: boolean,
    onClick: () => onChange(true)
  }, buttonText1), /*#__PURE__*/React$1.createElement(RadioTab, {
    backgroundColor: !boolean ? palette.graphite.white : 'transparent',
    addShadow: !boolean,
    onClick: () => onChange(false)
  }, buttonText2));
}

var lib$1 = {exports: {}};

var Modal$2 = {};

var ModalPortal = {exports: {}};

var focusManager = {};

var tabbable = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */

	var DISPLAY_NONE = "none";
	var DISPLAY_CONTENTS = "contents";

	var tabbableNode = /input|select|textarea|button|object|iframe/;

	function isNotOverflowing(element, style) {
	  return style.getPropertyValue("overflow") !== "visible" ||
	  // if 'overflow: visible' set, check if there is actually any overflow
	  element.scrollWidth <= 0 && element.scrollHeight <= 0;
	}

	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;

	  try {
	    // Otherwise we need to check some styles
	    var style = window.getComputedStyle(element);
	    var displayValue = style.getPropertyValue("display");
	    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
	  } catch (exception) {
	    // eslint-disable-next-line no-console
	    console.warn("Failed to inspect element style");
	    return false;
	  }
	}

	function visible(element) {
	  var parentElement = element;
	  var rootNode = element.getRootNode && element.getRootNode();
	  while (parentElement) {
	    if (parentElement === document.body) break;

	    // if we are not hidden yet, skip to checking outside the Web Component
	    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}

	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}

	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}

	function findTabbableDescendants(element) {
	  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
	    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
	  }, []);
	  return descendants.filter(tabbable);
	}
	module.exports = exports["default"]; 
} (tabbable, tabbable.exports));

var tabbableExports = tabbable.exports;

Object.defineProperty(focusManager, "__esModule", {
  value: true
});
focusManager.resetState = resetState$4;
focusManager.log = log$4;
focusManager.handleBlur = handleBlur;
focusManager.handleFocus = handleFocus;
focusManager.markForFocusLater = markForFocusLater;
focusManager.returnFocus = returnFocus;
focusManager.popWithoutFocus = popWithoutFocus;
focusManager.setupScopedFocus = setupScopedFocus;
focusManager.teardownScopedFocus = teardownScopedFocus;

var _tabbable = tabbableExports;

var _tabbable2 = _interopRequireDefault$4(_tabbable);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$4() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log$4() {
  if (process.env.NODE_ENV !== "production") {
    console.log("focusManager ----------");
    focusLaterElements.forEach(function (f) {
      var check = f || {};
      console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
  }
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

var scopeTab = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;

	var _tabbable = tabbableExports;

	var _tabbable2 = _interopRequireDefault(_tabbable);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function getActiveElement() {
	  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

	  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
	}

	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);

	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }

	  var target = void 0;

	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	  var activeElement = getActiveElement();

	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }

	  if (tail === activeElement && !shiftKey) {
	    target = head;
	  }

	  if (head === activeElement && shiftKey) {
	    target = tail;
	  }

	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }

	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;

	  var x = tabbable.indexOf(activeElement);

	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }

	  target = tabbable[x];

	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }

	  event.preventDefault();

	  target.focus();
	}
	module.exports = exports["default"]; 
} (scopeTab, scopeTab.exports));

var scopeTabExports = scopeTab.exports;

var ariaAppHider$1 = {};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var safeHTMLElement = {};

var exenv = {exports: {}};

/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function (module) {
	/* global define */

	(function () {

		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);

		var ExecutionEnvironment = {

			canUseDOM: canUseDOM,

			canUseWorkers: typeof Worker !== 'undefined',

			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),

			canUseViewport: canUseDOM && !!window.screen

		};

		if (module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}

	}()); 
} (exenv));

var exenvExports = exenv.exports;

Object.defineProperty(safeHTMLElement, "__esModule", {
  value: true
});
safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = undefined;

var _exenv = exenvExports;

var _exenv2 = _interopRequireDefault$3(_exenv);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

safeHTMLElement.canUseDOM = EE.canUseDOM;

safeHTMLElement.default = SafeHTMLElement;

Object.defineProperty(ariaAppHider$1, "__esModule", {
  value: true
});
ariaAppHider$1.resetState = resetState$3;
ariaAppHider$1.log = log$3;
ariaAppHider$1.assertNodeList = assertNodeList;
ariaAppHider$1.setElement = setElement;
ariaAppHider$1.validateElement = validateElement;
ariaAppHider$1.hide = hide;
ariaAppHider$1.show = show;
ariaAppHider$1.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = warning_1;

var _warning2 = _interopRequireDefault$2(_warning);

var _safeHTMLElement$1 = safeHTMLElement;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$3() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log$3() {
  if (process.env.NODE_ENV !== "production") {
    var check = globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
  }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement$1.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

var classList = {};

Object.defineProperty(classList, "__esModule", {
  value: true
});
classList.resetState = resetState$2;
classList.log = log$2;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState$2() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log$2() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n  ";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
    }

    classes = document.body.className;

    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
    }

    buffer += "\n";

    console.log(buffer);
  }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
classList.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
classList.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

var portalOpenInstances$1 = {};

Object.defineProperty(portalOpenInstances$1, "__esModule", {
  value: true
});
portalOpenInstances$1.log = log$1;
portalOpenInstances$1.resetState = resetState$1;

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck$2(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log$1() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState$1() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

portalOpenInstances$1.default = portalOpenInstances;

var bodyTrap$1 = {};

Object.defineProperty(bodyTrap$1, "__esModule", {
  value: true
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log;

var _portalOpenInstances = portalOpenInstances$1;

var _portalOpenInstances2 = _interopRequireDefault$1(_portalOpenInstances);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = React$1;

	var _propTypes = propTypesExports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _focusManager = focusManager;

	var focusManager$1 = _interopRequireWildcard(_focusManager);

	var _scopeTab = scopeTabExports;

	var _scopeTab2 = _interopRequireDefault(_scopeTab);

	var _ariaAppHider = ariaAppHider$1;

	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

	var _classList = classList;

	var classList$1 = _interopRequireWildcard(_classList);

	var _safeHTMLElement = safeHTMLElement;

	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

	var _portalOpenInstances = portalOpenInstances$1;

	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);



	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};

	/**
	 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
	 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
	 * `react-modal` only supports React >18 (which dropped IE support).
	 */
	var isTabKey = function isTabKey(event) {
	  return event.code === "Tab" || event.keyCode === 9;
	};
	var isEscKey = function isEscKey(event) {
	  return event.code === "Escape" || event.keyCode === 27;
	};

	var ariaHiddenInstances = 0;

	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);

	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);

	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };

	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };

	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName,
	          parentSelector = _this$props.parentSelector;


	      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

	      // Remove classes.
	      bodyOpenClassName && classList$1.remove(parentDocument.body, bodyOpenClassName);

	      htmlOpenClassName && classList$1.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;

	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }

	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager$1.returnFocus(_this.props.preventScroll);
	          focusManager$1.teardownScopedFocus();
	        } else {
	          focusManager$1.popWithoutFocus();
	        }
	      }

	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }

	      _portalOpenInstances2.default.deregister(_this);
	    };

	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager$1.setupScopedFocus(_this.node);
	          focusManager$1.markForFocusLater();
	        }

	        _this.setState({ isOpen: true }, function () {
	          _this.openAnimationFrame = requestAnimationFrame(function () {
	            _this.setState({ afterOpen: true });

	            if (_this.props.isOpen && _this.props.onAfterOpen) {
	              _this.props.onAfterOpen({
	                overlayEl: _this.overlay,
	                contentEl: _this.content
	              });
	            }
	          });
	        });
	      }
	    };

	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };

	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
	    };

	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };

	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };

	    _this.handleKeyDown = function (event) {
	      if (isTabKey(event)) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }

	      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };

	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }

	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };

	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };

	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };

	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };

	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };

	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };

	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };

	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };

	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };

	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };

	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };

	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };

	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }

	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (process.env.NODE_ENV !== "production") {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }

	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }

	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	      cancelAnimationFrame(this.openAnimationFrame);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName,
	          parentSelector = _props.parentSelector;


	      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

	      // Add classes.
	      bodyOpenClassName && classList$1.add(parentDocument.body, bodyOpenClassName);

	      htmlOpenClassName && classList$1.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }

	      _portalOpenInstances2.default.register(this);
	    }

	    // Don't steal focus from inner elements

	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles,
	          children = _props2.children;

	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

	      if (this.shouldBeClosed()) {
	        return null;
	      }

	      var overlayProps = {
	        ref: this.setOverlayRef,
	        className: this.buildClassName("overlay", overlayClassName),
	        style: _extends({}, overlayStyles, this.props.style.overlay),
	        onClick: this.handleOverlayOnClick,
	        onMouseDown: this.handleOverlayOnMouseDown
	      };

	      var contentProps = _extends({
	        id: id,
	        ref: this.setContentRef,
	        style: _extends({}, contentStyles, this.props.style.content),
	        className: this.buildClassName("content", className),
	        tabIndex: "-1",
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleContentOnMouseDown,
	        onMouseUp: this.handleContentOnMouseUp,
	        onClick: this.handleContentOnClick,
	        role: this.props.role,
	        "aria-label": this.props.contentLabel
	      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
	        "data-testid": this.props.testId
	      });

	      var contentElement = this.props.contentElement(contentProps, children);
	      return this.props.overlayElement(overlayProps, contentElement);
	    }
	  }]);

	  return ModalPortal;
	}(_react.Component);

	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  parentSelector: _propTypes2.default.func,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"]; 
} (ModalPortal, ModalPortal.exports));

var ModalPortalExports = ModalPortal.exports;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  polyfill: polyfill
});

var require$$6 = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

Object.defineProperty(Modal$2, "__esModule", {
  value: true
});
Modal$2.bodyOpenClassName = Modal$2.portalClassName = undefined;

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React$1;

var _react2 = _interopRequireDefault(_react);

var _reactDom = require$$3;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = propTypesExports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = ModalPortalExports;

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = ariaAppHider$1;

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = safeHTMLElement;

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = require$$6;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = Modal$2.portalClassName = "ReactModalPortal";
var bodyOpenClassName = Modal$2.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal$1 = function (_Component) {
  _inherits$1(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$1(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends$1({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  _createClass$1(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends$1({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal$1.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal$1.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal$1.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal$1);

if (process.env.NODE_ENV !== "production") {
  Modal$1.setCreateHTMLElement = function (fn) {
    return createHTMLElement = fn;
  };
}

Modal$2.default = Modal$1;

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _Modal = Modal$2;

	var _Modal2 = _interopRequireDefault(_Modal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Modal2.default;
	module.exports = exports["default"]; 
} (lib$1, lib$1.exports));

var libExports = lib$1.exports;
var Modal = /*@__PURE__*/getDefaultExportFromCjs(libExports);

const StyledBigModal = styled(Modal)`
    background-color: white;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    width: ${props => props.width}px;
    max-width: 90%;
    max-height: 70vh;
`;
const fullScreenModalStyles = {
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0
  }
};
const PageCentralizedHeading2 = styled(Heading2)`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
`;
function BigModal({
  heading,
  modalContent,
  modalFooterContent,
  isOpen,
  onRequestClose,
  extraHeaderContent,
  filterContent,
  shouldCloseOnOverlayClick = true,
  width = 900
}) {
  const headingText = /*#__PURE__*/React$1.createElement(Heading1, null, heading);
  return /*#__PURE__*/React$1.createElement(StyledBigModal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    width: width,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
  }, /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
    minHeight: 80,
    px: 48,
    dropShadowBelow: true,
    positionRelative: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 8
  }, extraHeaderContent ? /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true
  }, /*#__PURE__*/React$1.createElement(Heading2, null, headingText), extraHeaderContent) : /*#__PURE__*/React$1.createElement(Heading2, null, headingText)), /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 24,
    alignCenter: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    $noWrap: true,
    gap: 16
  }, filterContent, /*#__PURE__*/React$1.createElement(Image$1, {
    src: "/static/img/close.svg",
    alt: "Close",
    onClick: onRequestClose,
    link: true
  })))), /*#__PURE__*/React$1.createElement(ModalBody, null, modalContent), modalFooterContent && /*#__PURE__*/React$1.createElement(FlexDiv, {
    maxHeight: 96,
    px: 48,
    py: 24,
    dropShadowAbove: true,
    justifyEnd: true,
    alignCenter: true,
    gap: 16
  }, modalFooterContent));
}
function ModalBody({
  children
}) {
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    py: 32,
    px: 48,
    overflowYauto: true,
    $noWrap: true
  }, children);
}
function FullscreenModal({
  heading,
  modalContent,
  isOpen,
  onRequestClose,
  logo
}) {
  return /*#__PURE__*/React$1.createElement(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    style: fullScreenModalStyles
  }, /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
    minHeight: 70,
    px: 48,
    dropShadowBelow: true,
    positionRelative: true
  }, logo, /*#__PURE__*/React$1.createElement(PageCentralizedHeading2, null, heading), /*#__PURE__*/React$1.createElement(Image$1, {
    src: "/static/img/close.svg",
    alt: "Close",
    onClick: onRequestClose,
    link: true
  })), modalContent);
}

// wrap an image with video thumbnail in this wrapper, it will slightly darken the image and place a play button over it
const VideoThumbnailWrapper = styled.div`
    position: relative;
    border-radius: 4px;
    cursor: pointer;
    ${props => props.fullWidth && css`
            width: 100%;
        `}

    &:after {
        position: absolute;
        border-radius: 4px;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: ease 0.2s all;
        content: '';
        background-image: url('/static/img/icon-play.png');
        background-repeat: no-repeat;
        background-size: 30px auto;
        background-position: center center;
        background-color: ${rgba(palette.graphite.heavyMetal, 0.2)};
    }
`;

var lib = {};

var uaParser_min = {exports: {}};

/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */

(function (module, exports) {
	(function(window,undefined$1){var LIBVERSION="1.0.37",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i]);}else {mergedRegexes[i]=regexes[i];}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i];}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined$1},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match);}else {this[q[0]]=q[1];}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined$1;}else {this[q[0]]=match?match.replace(q[1],q[2]):undefined$1;}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined$1;}}else {this[q]=match?match:undefined$1;}}}}i+=2;}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined$1:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined$1:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(heytap|ovi)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser)/i,/\[(linkedin)app\]/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i,/panasonic;(viera)/i],[NAME,VERSION],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined$1;}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined$1;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined$1;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined$1;_browser[VERSION]=undefined$1;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave";}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined$1;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined$1;_device[MODEL]=undefined$1;_device[TYPE]=undefined$1;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE;}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET;}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined$1;_engine[VERSION]=undefined$1;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined$1;_os[VERSION]=undefined$1;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS);}return _os};this.getResult=function(){return {ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);{if(module.exports){exports=module.exports=UAParser;}exports.UAParser=UAParser;}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop];}};}})(typeof window==="object"?window:commonjsGlobal); 
} (uaParser_min, uaParser_min.exports));

var uaParser_minExports = uaParser_min.exports;

Object.defineProperty(lib, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = React$1;
var React__default = _interopDefault(React);

var UAParser = uaParser_minExports;

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children;
      _ref8.viewClassName;
      _ref8.style;
      var props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children;
      _ref12.viewClassName;
      _ref12.style;
      var condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

lib.AndroidView = AndroidView;
lib.BrowserTypes = BrowserTypes;
lib.BrowserView = BrowserView;
lib.ConsoleView = ConsoleView;
lib.CustomView = CustomView;
lib.IEView = IEView;
lib.IOSView = IOSView;
lib.MobileOnlyView = MobileOnlyView;
lib.MobileView = MobileView;
lib.OsTypes = OsTypes;
lib.SmartTVView = SmartTVView;
lib.TabletView = TabletView;
lib.WearableView = WearableView;
lib.WinPhoneView = WinPhoneView;
var browserName_1 = lib.browserName = browserName;
lib.browserVersion = browserVersion;
lib.deviceDetect = deviceDetect;
lib.deviceType = deviceType;
lib.engineName = engineName;
lib.engineVersion = engineVersion;
lib.fullBrowserVersion = fullBrowserVersion;
lib.getSelectorsByUserAgent = getSelectorsByUserAgent;
lib.getUA = getUA;
lib.isAndroid = isAndroid;
lib.isBrowser = isBrowser;
lib.isChrome = isChrome;
lib.isChromium = isChromium;
lib.isConsole = isConsole;
lib.isDesktop = isDesktop;
lib.isEdge = isEdge;
lib.isEdgeChromium = isEdgeChromium;
lib.isElectron = isElectron;
lib.isEmbedded = isEmbedded;
lib.isFirefox = isFirefox;
lib.isIE = isIE;
lib.isIOS = isIOS;
lib.isIOS13 = isIOS13;
lib.isIPad13 = isIPad13;
lib.isIPhone13 = isIPhone13;
lib.isIPod13 = isIPod13;
lib.isLegacyEdge = isLegacyEdge;
lib.isMIUI = isMIUI;
lib.isMacOs = isMacOs;
var isMobile_1 = lib.isMobile = isMobile;
lib.isMobileOnly = isMobileOnly;
lib.isMobileSafari = isMobileSafari;
lib.isOpera = isOpera;
lib.isSafari = isSafari;
lib.isSamsungBrowser = isSamsungBrowser;
lib.isSmartTV = isSmartTV;
lib.isTablet = isTablet;
lib.isWearable = isWearable;
lib.isWinPhone = isWinPhone;
lib.isWindows = isWindows;
lib.isYandex = isYandex;
lib.mobileModel = mobileModel;
lib.mobileVendor = mobileVendor;
lib.osName = osName;
lib.osVersion = osVersion;
lib.parseUserAgent = parseUserAgent;
lib.setUserAgent = setUserAgent;
lib.useDeviceData = useDeviceData;
lib.useDeviceSelectors = useDeviceSelectors;
lib.useMobileOrientation = useMobileOrientation;
lib.withOrientationChange = withOrientationChange;

const useStyles$9 = makeStyles(() => ({
  toggleButtonStyles: {
    marginRight: '1px',
    transition: 'ease 0.2s all',
    flexGrow: 1,
    border: '1px solid #D2D2D2',
    borderRadius: '4px',
    '&:focus': {
      outline: 'none'
    }
  },
  buttonStyles: {
    padding: '12px 40px',
    margin: '0 2px',
    background: palette.graphite.white,
    boxShadow: '0px 4px 8px rgba(29, 30, 29, 0.06)',
    borderRadius: '4px',
    transition: 'ease 0.2s all',
    textTransform: 'none',
    border: '2px solid transparent',
    whiteSpace: 'nowrap',
    '@media (max-width: 992px)': {
      marginRight: '0px',
      marginTop: '20px',
      width: '70%',
      fontSize: '14px',
      fontWeight: 700,
      margin: '5px'
    },
    '&:hover': {
      boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.08), 0px 4px 24px rgba(29, 30, 29, 0.08)'
    },
    '&:active': {
      boxShadow: '0px 0px 4px rgba(29, 30, 29, 0.08)'
    },
    '&.MuiToggleButtonGroup-grouped': {
      marginRight: '10px',
      borderRadius: '4px'
    }
  },
  isSelected: {
    '&.Mui-selected': {
      backgroundColor: palette.graphite.heavyMetal,
      '&:hover': {
        backgroundColor: palette.lightroom.heavyMetalLight
      },
      '&:active': {
        border: '2px solid',
        borderColor: palette.lightroom.heavyMetalLight,
        background: palette.graphite.heavyMetal
      }
    }
  },
  buttonIcon: {
    content: '',
    position: 'absolute',
    left: '10px',
    width: '20px',
    height: '20px'
  },
  correctIcon: {
    background: 'url(/static/img/assessment/icon-correct.svg) no-repeat center center'
  },
  incorrectIcon: {
    background: 'url(/static/img/assessment/icon-incorrect.svg) no-repeat center center'
  },
  equalWidth: {
    flexBasis: props => props.oneOf && Math.round(100 / props.oneOf) + '%',
    flexGrow: 0
  },
  fullWidthGroup: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    marginBottom: '20px',
    gap: '16px',
    flexWrap: props => props.isMobile ? 'wrap' : 'nowrap'
  },
  isUserCorrect: {
    backgroundColor: palette.lightroom.aspargusLightHigh,
    borderColor: palette.evergreen.aspargus,
    borderWidth: '2px'
  },
  isIncorrect: {
    backgroundColor: palette.lightroom.redLightHigh,
    borderColor: palette.vibrant.red,
    borderWidth: '2px'
  }
}));
function AnswerableToggleButtonGroup({
  value,
  handleToggle,
  fullWidth,
  children,
  ...props
}) {
  const classes = useStyles$9();
  return /*#__PURE__*/React$1.createElement(ToggleButtonGroup, _extends$2({
    className: classnames({
      [classes.fullWidthGroup]: fullWidth
    }),
    onChange: handleToggle,
    value: value,
    exclusive: true,
    "aria-label": "text alignment"
  }, props), children);
}
function AnswerableToggleButton({
  key,
  value,
  text,
  answer,
  handleToggle,
  selected,
  oneOf
}) {
  const classes = useStyles$9({
    oneOf,
    isMobile: isMobile_1
  });
  const isCorrect = () => {
    return answer && answer.correctAnswer[value];
  };
  const isUserCorrect = () => {
    return answer && answer.correctAnswer[value] && answer.userAnswer.value === value;
  };
  const isIncorrect = () => {
    return answer && !answer.correctAnswer[value] && answer.userAnswer.value === value && answer.userAnswer.score === 0;
  };
  const getAnswerColor = (isCorrect, isIncorrect, isSelected) => {
    if (isCorrect) {
      return palette.evergreen.aspargus;
    } else if (isIncorrect) {
      return palette.vibrant.red;
    } else if (isSelected) {
      return palette.graphite.white;
    } else {
      return palette.graphite.heavyMetal;
    }
  };
  return /*#__PURE__*/React$1.createElement(ToggleButton, {
    className: classnames(classes.buttonStyles, classes.toggleButtonStyles, {
      'Mui-disabled': !!answer,
      [classes.isCorrect]: isCorrect(),
      [classes.isUserCorrect]: isUserCorrect(),
      [classes.isIncorrect]: isIncorrect(),
      [classes.toggleButtonHover]: !isMobile_1,
      [classes.equalWidth]: oneOf && oneOf > 0,
      [classes.isSelected]: selected
    }),
    key: key,
    "aria-label": value,
    value: value,
    selected: selected,
    onClick: !answer && handleToggle
  }, (isCorrect() || isIncorrect()) &&
  /*#__PURE__*/
  // Sometimes we display an Icon
  React$1.createElement(FlexDiv, {
    className: classnames(classes.buttonIcon, {
      [classes.correctIcon]: isCorrect(),
      [classes.incorrectIcon]: isIncorrect()
    })
  }), /*#__PURE__*/React$1.createElement(TextDefault, {
    bold: true,
    color: getAnswerColor(isUserCorrect(), isIncorrect(), selected)
  }, text));
}

const useStyles$8 = makeStyles(() => ({
  speechBubbleStyles: {
    padding: '16px',
    backgroundColor: 'white',
    border: `2px solid ${palette.lightroom.heavyMetalLightUltra}`,
    boxShadow: 'none',
    marginBottom: 'unset !important',
    // overriding global style that's giving label extra margin
    '& .MuiFormControlLabel-label': {
      marginLeft: 'unset !important'
    }
  },
  rightBubble: {
    borderRadius: '24px 24px 0px 24px',
    backgroundColor: '#F7F7F7'
  },
  leftBubble: {
    borderRadius: '24px 24px 24px 0px'
  },
  isAnswer: {
    cursor: 'default',
    '&:hover': {
      boxShadow: 'none'
    }
  },
  isUserCorrect: {
    backgroundColor: palette.lightroom.aspargusLightHigh,
    borderColor: palette.evergreen.aspargus,
    borderWidth: '2px'
  },
  isIncorrect: {
    backgroundColor: palette.lightroom.redLightHigh,
    borderColor: palette.vibrant.red,
    borderWidth: '2px',
    '& .MuiCheckbox-root': {
      color: palette.vibrant.red
    }
  },
  isSelected: {
    borderWidth: '2px',
    borderColor: palette.graphite.heavyMetal
  },
  checkboxStyles: {
    '& .MuiFormControlLabel-label': {
      fontSize: '13px',
      fontFamily: 'Nunito Sans, sans-serif',
      color: palette.graphite.heavyMetal,
      fontWeight: 700
    }
  },
  checkboxIsUserCorrect: {
    '& .MuiFormControlLabel-label': {
      color: palette.evergreen.aspargus
    },
    '& .MuiCheckbox-root': {
      color: palette.evergreen.aspargus
    }
  },
  checkboxIsIncorrect: {
    '& .MuiFormControlLabel-label': {
      color: palette.vibrant.red
    },
    '& .MuiCheckbox-root': {
      color: palette.vibrant.red
    }
  },
  unStyledLabel: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    padding: 0,
    marginBottom: 'unset',
    '&:hover': {
      boxShadow: 'none'
    }
  },
  unStyledCheckbox: {
    margin: '0 !important',
    padding: '2px !important'
  }
}));

/** Checkbox input without border or shade, and displays answer with styled checkmark, not the Cancel/Correct icons
 * Example usage: Used in the 'select_none' option in Conversation questions */
function UnStyledCheckboxInput({
  label,
  groupValue,
  value,
  lighter,
  isUserCorrect,
  isIncorrect,
  isAnswer,
  ...props
}) {
  const classes = useStyles$8();
  const isChecked =
  //This checkbox should be checked if...
  (groupValue || []).includes(value) ||
  //...its value is one of the ones currently selected
  isAnswer && (isIncorrect || isUserCorrect); //...or it's displaying a selected answer

  return /*#__PURE__*/React$1.createElement(FormControlLabel, {
    className: classnames(classes.checkboxStyles, classes.unStyledLabel, {
      [classes.checkboxIsIncorrect]: isIncorrect,
      [classes.checkboxIsUserCorrect]: isUserCorrect,
      [classes.isAnswer]: isAnswer
    }),
    control: /*#__PURE__*/React$1.createElement(Checkbox, _extends$2({
      className: classnames(classes.unStyledCheckbox, {
        [classes.isAnswer]: isAnswer
      }),
      checked: isChecked,
      color: "primary"
    }, props)),
    label: label
  });
}
function SpeechBubbleInput({
  label,
  groupValue,
  value,
  side,
  isUserCorrect,
  isIncorrect,
  isAnswer,
  onChange,
  ...props
}) {
  const classes = useStyles$8();
  return /*#__PURE__*/React$1.createElement(FormControlLabel, _extends$2({
    className: classnames(classes.speechBubbleStyles, {
      [classes.isSelected]: (groupValue || []).includes(value),
      [classes.leftBubble]: side === 'left',
      [classes.rightBubble]: side === 'right',
      [classes.isAnswer]: isAnswer,
      [classes.isUserCorrect]: isUserCorrect,
      [classes.isIncorrect]: isIncorrect
    }),
    control: /*#__PURE__*/React$1.createElement(Checkbox, {
      checked: (groupValue || []).includes(value),
      onChange: onChange,
      hidden: true
    }),
    label: label
  }, props));
}

const useStyles$7 = makeStyles(() => ({
  assessmentFormControlLabel: {
    padding: '12px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 8px rgba(29, 30, 29, 0.06)',
    border: '2px solid rgba(#1D1E1D, 0)',
    borderRadius: '4px',
    transition: 'ease 0.2s all',
    '&:hover': {
      boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.08), 0px 4px 24px rgba(29, 30, 29, 0.08)'
    },
    '&.active': {
      border: '0px 0px 4px rgba(29, 30, 29, 0.08)'
    },
    '&.selected': {
      border: '2px solid rgba(#1D1E1D, 0.8)'
    }
  },
  unStyledLabel: {
    boxShadow: 'none',
    padding: 0,
    marginBottom: 'unset',
    border: 'none',
    '&:hover': {
      boxShadow: 'none'
    },
    '&.selected': {
      border: 'none'
    }
  },
  incorrect: {
    border: '2px solid ' + palette.lightroom.redLight,
    backgroundColor: palette.lightroom.redLightHigh,
    '& .MuiTypography-root': {
      color: palette.vibrant.red,
      fontWeight: 700
    },
    '& .MuiRadio-root': {
      background: "url('/static/img/assessment/icon-incorrect.svg') no-repeat center center",
      color: 'transparent'
    }
  },
  somewhatCorrect: {
    border: '2px solid ' + palette.lightroom.goldLight,
    backgroundColor: palette.lightroom.goldLightHigh,
    '& .MuiTypography-root': {
      color: palette.vibrant.gold,
      fontWeight: 700
    },
    '& .MuiRadio-root': {
      background: "url('/static/img/assessment/icon-somewhat-incorrect.svg') no-repeat center center",
      color: 'transparent'
    }
  },
  correct: {
    '& .MuiRadio-root': {
      background: "url('/static/img/assessment/icon-correct.svg') no-repeat center center",
      color: 'transparent'
    }
  },
  userCorrect: {
    border: '2px solid ' + palette.lightroom.aspargusLight,
    backgroundColor: palette.lightroom.aspargusLightHigh,
    '& .MuiTypography-root': {
      color: palette.evergreen.aspargus,
      fontWeight: 700
    }
  },
  correctButIrrelevant: {
    border: '2px solid ' + palette.lightroom.heavyMetalLight,
    backgroundColor: palette.lightroom.heavyMetalLightHigh,
    '& .MuiTypography-root': {
      color: palette.graphite.heavyMetal,
      fontWeight: 700
    },
    '& .MuiRadio-root': {
      background: "url('/static/img/assessment/icon-correct-but-irrelevant.svg') no-repeat center center",
      color: 'transparent'
    }
  }
}));
const AnswerableRadioButton = observer(({
  onChange,
  groupValue,
  groupId,
  value,
  text,
  answer,
  decisionKey,
  overwriteGlobalStyles
}) => {
  const {
    t
  } = useTranslation('assessment');
  const classes = useStyles$7();
  const isCorrect = () => {
    return answer.correctAnswer[value] ||
    //Decision answer
    decisionKey && answer.correctAnswer[decisionKey].value === value;
  };
  const isUserCorrect = () => {
    return answer.correctAnswer[value] && answer.userAnswer.value === value ||
    //Decision answer
    decisionKey && answer.correctAnswer[decisionKey].value === value && answer.userAnswer[decisionKey].value === value;
  };
  const isIncorrect = () => {
    return !answer.correctAnswer[value] && answer.userAnswer.value === value && answer.userAnswer.score === 0 ||
    //Decision answer
    decisionKey && answer.correctAnswer[decisionKey].value !== answer.userAnswer[decisionKey].value && answer.userAnswer[decisionKey].value === value && answer.userAnswer[decisionKey].score === 0;
  };
  const isSomewhatCorrect = () => {
    return !answer.correctAnswer[value] && answer.userAnswer.value === value && answer.userAnswer.score > 0;
  };
  if (!answer) {
    return /*#__PURE__*/React$1.createElement(FormControlLabel$1, {
      className: classnames(classes.assessmentFormControlLabel, {
        selected: groupValue === value,
        [classes.unStyledLabel]: overwriteGlobalStyles
      }),
      control: /*#__PURE__*/React$1.createElement(Radio, {
        color: "primary",
        value: value,
        onChange: e => onChange(e, groupId)
      }),
      label: text && t(text)
    });
  } else {
    return /*#__PURE__*/React$1.createElement(FormControlLabel$1, {
      className: classnames('Mui-disabled', classes.assessmentFormControlLabel, {
        [classes.correct]: isCorrect(),
        [classes.userCorrect]: isUserCorrect(),
        [classes.incorrect]: isIncorrect(),
        [classes.somewhatCorrect]: isSomewhatCorrect(),
        [classes.unStyledLabel]: overwriteGlobalStyles
      }),
      control: /*#__PURE__*/React$1.createElement(Radio, {
        color: "primary"
      }),
      label: text && t(text)
    });
  }
});

var RadioButtonsGroup = observer(({
  groupId,
  radioOptions,
  onChange,
  value,
  answer,
  overwriteGlobalStyles,
  label
}) => {
  return /*#__PURE__*/React$1.createElement(RadioGroupInput, {
    "aria-label": "email",
    name: "email",
    value: value,
    label: label
  }, radioOptions.map((v, i) => {
    return /*#__PURE__*/React$1.createElement(AnswerableRadioButton, {
      key: 'radio-' + i,
      groupId: groupId,
      onChange: onChange,
      groupValue: value,
      value: v.value,
      text: v.text,
      answer: answer,
      overwriteGlobalStyles: overwriteGlobalStyles
    });
  }));
});

var SelectsGroup = observer(({
  groupId,
  selectOptions,
  onChange,
  value,
  answer,
  label
}) => {
  const {
    t
  } = useTranslation('assessment');
  const isCorrect = optionValue => {
    return answer && answer.correctAnswer[optionValue];
  };
  const isIncorrect = optionValue => {
    return answer && answer.userAnswer && answer.correctAnswer && answer.correctAnswer.value !== optionValue && answer.userAnswer.value === optionValue;
  };

  /** Which option should be displayed */
  const getDisplayValue = () => {
    return answer && answer.userAnswer && answer.userAnswer.value || answer && answer.correctAnswer && answer.correctAnswer.value || '';
  };
  const answerIcon = optionValue => {
    if (answer) {
      if (isCorrect(optionValue)) {
        return isMobile_1 ? '✅' : /*#__PURE__*/React$1.createElement("img", {
          src: resourcePath('/static/img/assessment/icon-correct.svg')
        });
      } else if (isIncorrect(optionValue)) {
        return isMobile_1 ? '❌' : /*#__PURE__*/React$1.createElement("img", {
          src: resourcePath('/static/img/assessment/icon-incorrect.svg')
        });
      }
    }
  };
  const answerColor = optionValue => {
    if (isCorrect(optionValue)) {
      return palette.evergreen.aspargus;
    } else if (isIncorrect(optionValue)) {
      return palette.vibrant.red;
    } else {
      return palette.graphite.heavyMetal;
    }
  };
  return /*#__PURE__*/React$1.createElement(TextInput, {
    onChange: e => !answer && onChange(e, groupId),
    value: value,
    label: label,
    select: true
    //disabled={!!answer} Not disabling this so the user can see which answer is correct
    ,
    isMobile: isMobile_1,
    overwriteGlobalStyles: true,
    defaultValue: getDisplayValue()
  }, isMobile_1 ? /*#__PURE__*/React$1.createElement("option", {
    value: "",
    disabled: true
  }, t('Please select')) : /*#__PURE__*/React$1.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    lighter: true,
    italic: true
  }, t('Please select'))), selectOptions.map(o => isMobile_1 ? /*#__PURE__*/React$1.createElement("option", {
    key: o.value,
    value: o.value
  }, answerIcon(o.value), " ", t(o.text)) : /*#__PURE__*/React$1.createElement(MenuItem, {
    style: {
      whiteSpace: 'normal'
    },
    key: o.value,
    value: o.value
  }, answerIcon(o.value), /*#__PURE__*/React$1.createElement(TextDefault, {
    color: answerColor(o.value)
  }, t(o.text)))));
});

const UpdatesCenterBlock = ({
  ui,
  handleChange,
  value,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  const onChange = (event, groupId) => {
    let val = value || [];
    val[groupId] = event.target.value;

    /** Current values or initialize the value array in the form we want*/
    let valueArray = !!value ? value : initializeValueArray();

    /** Find the group whose value we are updating, and update the value.
     * Example: Setting the value for 'check_for_updates' group to 'once_a_week' */
    const updatedData = valueArray.map(x => {
      return x[groupId] !== undefined ? {
        ...x,
        [groupId]: event.target.value
      } : x;
    });
    handleChange(updatedData);
  };

  /** Init the value array to an object for each groupItem, with its actionId (groupId) as the key and empty string as value.
   * (in this case) [{"check_for_updates":""},{"install_updates":""},{"updates_from_websites":""}] */
  const initializeValueArray = () => {
    let group = ui.group || [];
    let valueArray = [];
    for (let i = 0; i < group.length; i++) {
      valueArray[i] = {
        [group[i].actionId]: ''
      };
    }
    return valueArray;
  };

  /** Simply find the 'check_for_updates' group definition in the JSON array*/
  const getCheckForUpdatesGroup = useMemo(() => ui.group.find(group => group.actionId === 'check_for_updates'), []);
  const getInstallUpdatesGroup = useMemo(() => ui.group.find(group => group.actionId === 'install_updates'), []);
  const getUpdatesFromWebsitesGroup = useMemo(() => ui.group.find(group => group.actionId === 'updates_from_websites'), []);
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    backgroundColor: "white",
    dropShadowAbove: true,
    borderRadius: 8,
    marginAuto: true,
    overflowHidden: true,
    maxWidthPercentage: 80
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    backgroundColor: 'rgba(142, 191, 249, 0.1)',
    padding: '48px 16px 24px 32',
    positionRelative: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    positionAbsolute: true,
    right: '0',
    top: '0'
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(`/static/img/update-cog-wheel.png`),
    alt: t('cog_wheel')
  })), /*#__PURE__*/React$1.createElement(Heading2, null, t(ui.title)), /*#__PURE__*/React$1.createElement(TextLead, {
    lighter: true
  }, t(ui.description))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    px: 32,
    py: 24
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    mb: 8
  }, /*#__PURE__*/React$1.createElement(RadioButtonsGroup, {
    groupId: 'check_for_updates',
    radioOptions: getCheckForUpdatesGroup.options,
    onChange: onChange,
    value: value && value[0]['check_for_updates'] /* Index is 0 because this is the first group in this form */,
    answer: answer && {
      correctAnswer: answer.correctAnswer && answer.correctAnswer['check_for_updates'],
      userAnswer: answer.userAnswer && answer.userAnswer['check_for_updates']
    },
    overwriteGlobalStyles: true,
    label: t(getCheckForUpdatesGroup.title)
  })), /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    mb: 8
  }, /*#__PURE__*/React$1.createElement(SelectsGroup, {
    groupId: 'install_updates',
    selectOptions: getInstallUpdatesGroup.options,
    onChange: onChange,
    label: t(getInstallUpdatesGroup.title),
    value: value && value[1]['install_updates'] /* Index is 1 because this is the second group in this form */,
    answer: answer && {
      correctAnswer: answer.correctAnswer && answer.correctAnswer['install_updates'],
      userAnswer: answer.userAnswer && answer.userAnswer['install_updates']
    }
  })), /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    mt: 8
  }, /*#__PURE__*/React$1.createElement(RadioButtonsGroup, {
    groupId: 'updates_from_websites',
    radioOptions: getUpdatesFromWebsitesGroup.options,
    onChange: onChange,
    value: value && value[2]['updates_from_websites'] /* Index is 2 because this is the third group in this form */,
    answer: answer && {
      correctAnswer: answer.correctAnswer && answer.correctAnswer['updates_from_websites'],
      userAnswer: answer.userAnswer && answer.userAnswer['updates_from_websites']
    },
    label: t(getUpdatesFromWebsitesGroup.title),
    overwriteGlobalStyles: true
  }))));
};

function GroupOfBlocksFactory({
  ui,
  ...rest
}) {
  const Component = useMemo(() => {
    switch (ui.variant) {
      case 'updates-center':
        return UpdatesCenterBlock;
    }
  }, [ui]);
  return /*#__PURE__*/React$1.createElement(Component, _extends$2({
    ui: ui
  }, rest));
}
var GroupOfBlocksHTML = observer(GroupOfBlocksFactory);

/**
 * A component which handles our default i18next Trans usage.
 * Replacing predefined tags in translation values with the correct HTML elements
 */
const DefaultTrans = ({
  translatedString
}) => {
  return /*#__PURE__*/React$1.createElement(Trans, {
    components: {
      p: /*#__PURE__*/React$1.createElement("p", null),
      b: /*#__PURE__*/React$1.createElement("b", null),
      strong: /*#__PURE__*/React$1.createElement("strong", null),
      u: /*#__PURE__*/React$1.createElement("u", null)
    }
  }, translatedString);
};

const BlueButton = styled.button`
    margin-left: auto;
    color: white;
    background: linear-gradient(0deg, #377efc 0%, #7eb1f0 100%);
    border: 1px solid rgba(44, 94, 189, 0.3);
    border-radius: 4px;
    font-size: 13px;
    padding: 8px 24px;
`;
function RansomwareAttack() {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    borderRadius: 8,
    dropShadowAbove: true,
    overflowHidden: true,
    mt: 24
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    backgroundColor: 'linear-gradient(180deg, #C63023 0%, #A82216 103.56%);',
    column: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    backgroundColor: "rgba(29, 30, 29, 0.05)",
    justifyEnd: true,
    px: 24,
    py: 16
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    alt: t('close'),
    src: resourcePath('/static/img/assessment/ch2_close.png')
  })), /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
    py: 24,
    px: 24,
    alignCenter: true,
    $noWrap: true,
    gap: 16
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    gap: 8
  }, /*#__PURE__*/React$1.createElement(Heading2, {
    color: "white"
  }, t('Your files have been encrypted!')), /*#__PURE__*/React$1.createElement(TextDefault, {
    color: "white"
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    backgroundColor: "rgba(255,255,255,0.1)",
    padding: 4,
    borderRadius: 4,
    bold: true,
    color: "white",
    airy: true
  }, "71:59:05"), t('time left until your files are destroyed'))), /*#__PURE__*/React$1.createElement(Image$1, {
    height: 100,
    alt: t('lock'),
    src: resourcePath('/static/img/assessment/ch2_lock.png')
  }))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    padding: 24
  }, /*#__PURE__*/React$1.createElement(TextTiny, {
    mb: 24
  }, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('ch2_presentation_text')
  })), /*#__PURE__*/React$1.createElement(BlueButton, null, " ", t('Next'))));
}

const StyledThemedButton = styled.button.withConfig({
  shouldForwardProp: (prop, elementToBeCreated) => isPropValid(prop)
})`
    border: none;
    border-radius: 0.25rem;
    padding: 0.7rem 1.4rem;
    font-size: 14px;
    font-weight: 800;
    text-transform: uppercase;
    transition: ease 0.2s all;
    cursor: pointer;
    &:focus {
        box-shadow: 0 0 0 3px ${props => rgba(primaryColor(props), 0.25)};
        outline: none;
    }

    ${props => {
  switch (props.mode) {
    case 'primary':
      return css`
                    color: white;
                    background-color: ${props => primaryColor(props)};
                    transition: ease 0.2s all;
                    &:hover {
                        background-color: ${props => curriedDarken$1(0.1, primaryColor(props))} !important;
                        border-color: ${props => curriedDarken$1(0.05, primaryColor(props))} !important;
                        color: white;
                    }

                    &:active {
                        background-color: ${props => curriedDarken$1(0.2, primaryColor(props))} !important;
                        border-color: ${props => curriedDarken$1(0.15, primaryColor(props))} !important;
                    }

                    &:focus {
                        box-shadow: 0 0 0 0.2rem
                            ${props => curriedLighten$1(0.05, primaryColor(props))} !important;
                        background-color: ${props => curriedDarken$1(0.1, primaryColor(props))};
                    }
                `;
    case 'secondary':
      return css`
                    color: ${props => primaryColor(props)} !important;
                    background-color: ${props => rgba(primaryColor(props), 0.1)};
                    transition: ease 0.2s all;
                    &:hover {
                        background-color: ${props => rgba(primaryColor(props), 0.2)};
                    }
                    &:focus {
                        box-shadow: 0 0 0 0.2rem
                            ${props => rgba(primaryColor(props), 0.1)} !important;
                        background-color: ${props => rgba(primaryColor(props), 0.2)};
                    }
                `;
    case 'black':
      return css`
                    color: white;
                    background-color: #1d1e1d;
                    transition: ease 0.2s all;
                    &:hover {
                        background-color: black !important;
                        border-color: ${curriedDarken$1(0.05, '#1D1E1D')} !important;
                        color: white;
                    }

                    &:active {
                        background-color: black !important;
                        border-color: ${curriedDarken$1(0.15, '#1D1E1D')} !important;
                        color: white;
                    }

                    &:focus {
                        box-shadow: 0 0 0 0.2rem ${curriedLighten$1(0.05, '#1D1E1D')} !important;
                        background-color: black;
                        color: white;
                    }
                `;
    case 'gray':
      return css`
                    color: black;
                    background-color: rgba(${palette.graphite.heavyMetal}, 0.6);
                    transition: ease 0.2s all;
                    &:hover {
                        background-color: ${curriedDarken$1(0.1, rgba(palette.graphite.heavyMetal, 0.6))} !important;
                        border-color: ${curriedDarken$1(0.05, rgba(palette.graphite.heavyMetal, 0.6))} !important;
                        color: white;
                    }

                    &:active {
                        background-color: ${curriedDarken$1(0.2, rgba(palette.graphite.heavyMetal, 0.6))} !important;
                        border-color: ${curriedDarken$1(0.15, rgba(palette.graphite.heavyMetal, 0.6))} !important;
                        color: white;
                    }

                    &:focus {
                        box-shadow: 0 0 0 0.2rem
                            ${curriedLighten$1(0.05, rgba(palette.graphite.heavyMetal, 0.6))} !important;
                        background-color: ${curriedDarken$1(0.1, rgba(palette.graphite.heavyMetal, 0.6))};
                        color: white;
                    }
                `;
    case 'red':
      return css`
                    color: white;
                    background-color: ${palette.vibrant.raspberry};
                    transition: ease 0.2s all;
                    &:hover {
                        background-color: ${curriedDarken$1(0.1, palette.vibrant.raspberry)} !important;
                        border-color: ${curriedDarken$1(0.05, palette.vibrant.raspberry)} !important;
                        color: white;
                    }

                    &:active {
                        background-color: ${curriedDarken$1(0.2, palette.vibrant.raspberry)} !important;
                        border-color: ${curriedDarken$1(0.15, palette.vibrant.raspberry)} !important;
                        color: white;
                    }

                    &:focus {
                        box-shadow: 0 0 0 0.2rem
                            ${curriedLighten$1(0.05, palette.vibrant.raspberry)} !important;
                        background-color: ${curriedDarken$1(0.1, palette.vibrant.raspberry)};
                        color: white;
                    }
                `;
    case 'text':
    default:
      return css`
                    background: none !important;
                    border: none;
                    color: ${palette.graphite.heavyMetal};
                    font-weight: 100;
                    -webkit-transition: ease 0.2s all;
                    transition: ease 0.2s all;
                    width: none;
                    box-shadow: none !important;
                    &:hover {
                        color: ${primaryColor(props)};
                        background: none !important;
                        border: none;
                        text-decoration: underline;
                    }
                `;
  }
}}

    ${props => {
  switch (props.size) {
    case 'tiny':
      return css`
                    padding: 7px 16px;
                    border-radius: 4px;
                    font-weight: 700;
                    font-size: 14px;
                `;
    case 'small':
      return css`
                    padding: 0.3rem 1.3rem;
                    line-height: 1.5;
                    border-radius: 0.2rem;
                    font-weight: 700;
                `;
    case 'fullWidth':
      return css`
                    width: 100%;
                `;
    default:
      return;
  }
}}

    ${props => props.disabled && css`
            opacity: 0.3;
            pointer-events: none;
        `};
    ${props => props.hidden && css`
            opacity: 0;
        `};

    ${props => props.height && css`
            height: ${props.height}px;
        `};

    ${props => props.$airy && css`
            margin-left: 16px;
        `};

    ${props => props.$noTextTransform && css`
            text-transform: none;
        `};

    ${props => props.$noWrap && css`
            white-space: nowrap;
        `};
    ${props => props.$center && css`
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        `};
    ${props => props.flexGrow && css`
            flex: ${props.flexGrow};
        `}
    ${props => props.flexBasisPercent && css`
            flex-basis: ${props.flexBasisPercent}%;
        `}
    ${props => props.roundSize && css`
            width: ${props.roundSize}px;
            height: ${props.roundSize}px;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        `};
`;
const StyledIcon = styled.span`
  & svg { font-size: 1.2rem;
  vertical-align: text-bottom;}
  /* Add any additional styles for icons here */
`;
const ThemedButton = ({
  text,
  $saving,
  style,
  icon,
  iconPosition,
  ...props
}) => {
  const styles = {
    display: $saving ? 'inline-flex' : 'inline-block',
    padding: $saving ? '0.2rem 1rem 0.2rem 0rem' : undefined,
    ...style
  };
  return /*#__PURE__*/React$1.createElement(StyledThemedButton, _extends$2({}, props, {
    style: styles
  }), $saving ? /*#__PURE__*/React$1.createElement(CircularProgress, {
    size: 20,
    style: {
      color: palette.graphite.gray,
      margin: '8px'
    }
  }) : null, iconPosition === 'start' && /*#__PURE__*/React$1.createElement(StyledIcon, {
    style: {
      marginRight: '6px'
    }
  }, icon), text, iconPosition === 'end' && /*#__PURE__*/React$1.createElement(StyledIcon, {
    style: {
      marginLeft: '6px'
    }
  }, icon));
};
ThemedButton.propTypes = {
  /** Adds left margin */
  $airy: propTypesExports.PropTypes.bool,
  /** Button label. You can also pass another another element (e.g. string with carret element) */
  text: propTypesExports.PropTypes.node,
  /** Centers button */
  $center: propTypesExports.PropTypes.bool,
  /** Disables button. */
  disabled: propTypesExports.PropTypes.bool,
  /** How much of the flex container's remaining space should be assigned to the flex item's main size.*/
  flexGrow: propTypesExports.PropTypes.number,
  /** The flex-basis CSS property sets the initial main size of a flex item.
   * Value is calculated as a percentil.
   * Default value is auto.
   */
  flexBasisPercent: propTypesExports.PropTypes.number,
  /** Set height of the button in px */
  height: propTypesExports.PropTypes.number,
  /** Hide button */
  hidden: propTypesExports.PropTypes.bool,
  /** Undo uppercase on button text */
  $noTextTransform: propTypesExports.PropTypes.bool,
  /** Set white-space to nowrap => suppress line-breaks */
  $noWrap: propTypesExports.PropTypes.bool,
  /** Set weight & height to identical provided number, with border-radius100% (rouded corners) */
  roundSize: propTypesExports.PropTypes.number,
  /** Set button style, for default skip this prop in component */
  mode: propTypesExports.PropTypes.oneOf(['primary', 'secondary', 'gray', 'black', 'red', 'text']),
  /** Set button size, for default skip this prop in component*/
  size: propTypesExports.PropTypes.oneOf(['tiny', 'small', 'fullWidth']),
  /** Optional click handler*/
  onClick: propTypesExports.PropTypes.func,
  /** Show loading indicator */
  $saving: propTypesExports.PropTypes.bool,
  /** Show button with icon */
  icon: propTypesExports.PropTypes.node,
  /** Icon before(start) or after(end) the text */
  iconPosition: propTypesExports.PropTypes.oneOf(['start', 'end'])
};
ThemedButton.defaultProps = {
  $airy: false,
  $center: false,
  disabled: false,
  hidden: false,
  $noTextTransform: false,
  $noWrap: false,
  onClick: undefined,
  flexGrow: 0,
  $saving: false,
  icon: null,
  iconPosition: null
};

function EmailLinksAlert({
  isShowingLinkAlert,
  t
}) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "email-attention",
    style: {
      opacity: isShowingLinkAlert ? '1' : '0'
    }
  }, t('Links don’t work. This is only a simulation'), ".");
}
var EmailLinksAlert$1 = observer(EmailLinksAlert);

function InstallPlugin({
  ui,
  onAction,
  onNextQuestion
}) {
  const {
    t
  } = useTranslation('assessment');
  const [isShowingLinkAlert, setIsShowingLinkAlert] = useState(false);
  const {
    links
  } = ui;
  const handleInstallClick = () => {
    if (links && links[0] && links[0].clickActionId) {
      onAction && onAction(links[0].clickActionId);
    }
    setIsShowingLinkAlert(true);
  };
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    justifyCenter: true,
    alignCenter: true,
    fullHeight: true,
    gap: 16
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath('/static/img/assessment/plugin-missing.svg'),
    alt: t('Plugin missing')
  }), /*#__PURE__*/React$1.createElement(Heading1, {
    my: 8
  }, t('Plugin missing')), /*#__PURE__*/React$1.createElement(TextLead, {
    center: true
  }, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('plugin_missing', {
      browserName: browserName_1
    })
  })), /*#__PURE__*/React$1.createElement(ThemedButton, {
    mode: "black",
    onClick: () => handleInstallClick(),
    text: t('Install plugin')
  }), /*#__PURE__*/React$1.createElement(TextDefault, {
    bold: true,
    link: true,
    underline: true,
    onClick: () => onNextQuestion()
  }, t('Proceed anyway')), /*#__PURE__*/React$1.createElement(TextTiny, {
    lighter: true
  }, "(", t('Some elements might not be displayed properly'), ")"), links && links[0] && /*#__PURE__*/React$1.createElement(EmailLinksAlert$1, {
    isShowingLinkAlert: isShowingLinkAlert,
    t: t
  }));
}

function CustomFactory({
  ui,
  onAction,
  ...rest
}) {
  const Component = useMemo(() => {
    switch (ui.variant) {
      case 'ransomwareAttack':
        return RansomwareAttack;
      case 'installPlugin':
        return InstallPlugin;
      default:
        return Fragment;
    }
  }, [ui]);
  return /*#__PURE__*/React$1.createElement(Component, _extends$2({
    ui: ui,
    onAction: onAction
  }, rest));
}
var CustomHTML = observer(CustomFactory);

const DetailsField$1 = ({
  children,
  isLabel
}) => {
  return /*#__PURE__*/React$1.createElement("td", null, /*#__PURE__*/React$1.createElement(TextLabel, {
    lighter: isLabel,
    mr: isLabel ? 4 : ''
  }, children));
};

const DetailsField = ({
  children
}) => {
  return /*#__PURE__*/React$1.createElement("tr", {
    style: {
      fontSize: '11px'
    }
  }, children);
};

function patchEmail(email) {
  if (email && email.indexOf("|") > -1) {
    // return part before |
    return email.split("|")[0];
  }
  return email;
}
const Table = ({
  t,
  fromName,
  fromEmail,
  userName,
  userEmail,
  toExtraEmailTransformed,
  subject
}) => /*#__PURE__*/React$1.createElement("table", null, /*#__PURE__*/React$1.createElement("tbody", null, /*#__PURE__*/React$1.createElement(DetailsField, null, /*#__PURE__*/React$1.createElement(DetailsField$1, {
  isLabel: true
}, t('from')), /*#__PURE__*/React$1.createElement(DetailsField$1, null, /*#__PURE__*/React$1.createElement("b", null, fromName), " ", '<', fromEmail, '>')), /*#__PURE__*/React$1.createElement(DetailsField, null, /*#__PURE__*/React$1.createElement(DetailsField$1, {
  isLabel: true
}, t('to')), /*#__PURE__*/React$1.createElement(DetailsField$1, null, userName, " ", '<', patchEmail(userEmail), '>', ' ', toExtraEmailTransformed && /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement("br", null), toExtraEmailTransformed))), /*#__PURE__*/React$1.createElement(DetailsField, null, /*#__PURE__*/React$1.createElement(DetailsField$1, {
  isLabel: true
}, t('date')), /*#__PURE__*/React$1.createElement(DetailsField$1, null, formatDate(new Date()), ", 10:38:12")), /*#__PURE__*/React$1.createElement(DetailsField, null, /*#__PURE__*/React$1.createElement(DetailsField$1, {
  isLabel: true
}, t('subject')), /*#__PURE__*/React$1.createElement(DetailsField$1, null, t(subject)))));
const Details$1 = ({
  userEmail,
  userName,
  fromName,
  fromEmail,
  subject,
  toExtraEmail,
  node,
  open,
  t
}) => {
  const toExtraEmailTransformed = toExtraEmail && toExtraEmail.split(',').map((email, i) => /*#__PURE__*/React$1.createElement("span", {
    key: i
  }, email, /*#__PURE__*/React$1.createElement("br", null)));
  return /*#__PURE__*/React$1.createElement("div", {
    ref: node,
    style: {
      display: open ? 'block' : 'none'
    }
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    borderRadius: 8,
    padding: 8,
    gap: 8,
    border: true,
    mobileOnly: true
  }, /*#__PURE__*/React$1.createElement(Table, {
    t,
    fromName,
    fromEmail,
    userName,
    userEmail,
    toExtraEmailTransformed,
    subject
  })), /*#__PURE__*/React$1.createElement(FlexDiv, {
    padding: 16,
    gap: 16,
    border: true,
    desktopOnly: true,
    positionAbsolute: true,
    zIndex: 1,
    backgroundColor: "white",
    left: 96,
    top: 64
  }, /*#__PURE__*/React$1.createElement(Table, {
    t,
    fromName,
    fromEmail,
    userName,
    userEmail,
    toExtraEmailTransformed,
    subject
  })));
};
var DefaultDetails = observer(Details$1);

function EmailDetailsFactory({
  ui,
  ...rest
}) {
  const Component = useMemo(() => {
    return DefaultDetails;
    // switch (ui.variant) {
    //     // case "some":
    //     //   return SOMEOTHERDETAILS;  // put here some rule to choose the right component
    //     default:
    //         return DefaultDetails;
    // }
  }, [JSON.stringify(ui)]);
  return /*#__PURE__*/React$1.createElement(Component, _extends$2({
    presentation: ui
  }, rest));
}
var Details = observer(EmailDetailsFactory);

const useStyles$6 = makeStyles(() => ({
  linkTooltip: {
    color: palette.graphite.onyx,
    fontSize: '12px',
    fontWeight: 400,
    position: 'absolute',
    textAlign: 'start',
    border: '1px solid #cccccc',
    padding: '6px',
    borderRadius: '2px',
    backgroundColor: palette.graphite.white,
    boxShadow: '0px 0px 21px -4px rgba(0, 0, 0, 0.17)',
    zIndex: 1000,
    visibility: 'hidden'
  },
  isVisible: {
    visibility: 'visible'
  }
}));
function EmailLinksTooltip({
  isVisible,
  text
}) {
  const classes = useStyles$6();
  return /*#__PURE__*/React$1.createElement("div", {
    className: classnames([classes.linkTooltip], {
      [classes.isVisible]: !!isVisible
    })
  }, text);
}
var EmailLinksTooltip$1 = observer(EmailLinksTooltip);

const EmailLink$1 = ({
  link,
  handleLinkClick,
  handleLinkMouseEnter,
  handleLinkMouseLeave,
  isHoveringOnLink
}) => {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement("span", {
    className: "link text",
    onClick: () => handleLinkClick(link.clickActionId),
    onMouseEnter: handleLinkMouseEnter,
    onMouseLeave: handleLinkMouseLeave
  }, t(link.text), /*#__PURE__*/React$1.createElement(EmailLinksTooltip$1, {
    isVisible: isHoveringOnLink,
    text: link.href
  }));
};

const useStyles$5 = makeStyles(() => ({
  officeButton: {
    display: 'inline-block',
    outline: 'none',
    cursor: 'pointer',
    textAlign: 'center',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none'
    },
    '&.active': {
      position: 'relative',
      top: '1px'
    },
    padding: '12px 20px',
    color: '#ffffff',
    background: 'linear-gradient(0deg, #377EFC 0%, #7EB1F0 100%)',
    border: '1px solid rgba(44, 94, 189, 0.3)',
    borderRadius: '4px',
    fontFamily: 'Nunito Sans',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '100%'
  }
}));

/**
 * The blue gradient button used by Microsoft Office 365
 *
 * Takes in functions related to link functionality, so it can handle...link functionality :)
 */
const OfficeButtonLink = ({
  link,
  handleLinkClick,
  handleLinkMouseEnter,
  handleLinkMouseLeave,
  isHoveringOnLink
}) => {
  const {
    t
  } = useTranslation('assessment');
  const classes = useStyles$5();
  return /*#__PURE__*/React$1.createElement("span", {
    className: classes.officeButton,
    onClick: () => handleLinkClick(link.clickActionId),
    onMouseEnter: handleLinkMouseEnter,
    onMouseLeave: handleLinkMouseLeave
  }, t(link.text), /*#__PURE__*/React$1.createElement(EmailLinksTooltip$1, {
    isVisible: isHoveringOnLink,
    text: link.href
  }));
};

function EmailLinkFactory({
  link,
  ...rest
}) {
  const Component = useMemo(() => {
    switch (link.variant) {
      case 'office':
        return OfficeButtonLink;
      // The blue gradient button used by Microsoft Office 365
      default:
        return EmailLink$1;
    }
  }, [link]);
  return /*#__PURE__*/React$1.createElement(Component, _extends$2({
    link: link
  }, rest));
}
var EmailLinkFactory$1 = observer(EmailLinkFactory);

const EmailLink = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  link
}) => {
  const [isHoveringOnLink, setIsHoveringOnLink] = React$1.useState(false);
  const handleLinkMouseEnter = () => {
    setIsHoveringOnLink(true);
    onMouseEnter();
  };
  const handleLinkMouseLeave = () => {
    setIsHoveringOnLink(false);
    onMouseLeave(link.hoverActionId);
  };
  return link ? /*#__PURE__*/React$1.createElement(EmailLinkFactory$1, {
    handleLinkClick: onClick,
    handleLinkMouseLeave: handleLinkMouseLeave,
    handleLinkMouseEnter: handleLinkMouseEnter,
    isHoveringOnLink: isHoveringOnLink,
    link: link
  }) : null;
};

const generateEmailTransComponentsObject = (link, links, linkFunctionality) => {
  let components = {
    strong: /*#__PURE__*/React$1.createElement("strong", null),
    b: /*#__PURE__*/React$1.createElement("strong", null),
    error: /*#__PURE__*/React$1.createElement("span", {
      style: {
        color: '#F00707'
      }
    }),
    lighter: /*#__PURE__*/React$1.createElement("div", {
      className: "lighter"
    }),
    themed: /*#__PURE__*/React$1.createElement("div", {
      style: {
        color: '#8132A8'
      }
    }),
    pseudoLink: /*#__PURE__*/React$1.createElement("span", {
      style: {
        color: '#0521E5',
        textDecoration: 'underline'
      }
    }),
    lt: '<',
    gt: '>'
  };
  if (link) components['u'] = addLinkComponent(link, linkFunctionality.handleLinkClick, linkFunctionality.handleLinkMouseLeave, linkFunctionality.handleLinkMouseEnter);
  if (links) {
    {
      links.map((link, index) => {
        return components['u' + (index + 1)] = addLinkComponent(link, linkFunctionality.handleLinkClick, linkFunctionality.handleLinkMouseLeave, linkFunctionality.handleLinkMouseEnter);
      });
    }
  }
  return components;
};
const addLinkComponent = (link, handleLinkClick, handleLinkMouseLeave, handleLinkMouseEnter) => {
  return /*#__PURE__*/React$1.createElement(EmailLink, {
    onClick: handleLinkClick,
    onMouseLeave: handleLinkMouseLeave,
    onMouseEnter: handleLinkMouseEnter,
    link: link
  });
};

/**
 * A component which handles our default Assessment Email Trans usage.
 * Replacing predefined tags in translation values with the correct HTML elements
 *
 * @param translatedString The string to send to trans, after translation and interpolation (if any)
 * @param link {Object} Use if the text contains a single link whose activity we want to score (click, hover etc.)
 * @param links {Array} Use if there are multiple links withing the text
 * @param linkFunctionality {Object} The click and hover functionality handlers. Expects the handlers to be {handleLinkClick,
 *             handleLinkMouseLeave,
 *             handleLinkMouseEnter}
 * @returns {JSX.Element} i18next <Trans object
 */
const EmailTrans = ({
  translatedString,
  link,
  links,
  linkFunctionality
}) => {
  return /*#__PURE__*/React$1.createElement(Trans, {
    components: generateEmailTransComponentsObject(link, links, linkFunctionality)
  }, translatedString);
};

const EmailFooter = ({
  footer,
  handleLinkClick,
  handleLinkMouseLeave,
  handleLinkMouseEnter,
  link
}) => {
  const {
    t
  } = useTranslation('assessment');
  /** footer key can either be defined within a footer object, or as a standalone key */
  const footerTranslationKey = footer.text || footer;
  /** footer text is by default lighter than regular text, but this can be disabled in definition */
  const useLighterText = !footer.disableDefaultOpacity;
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    pt: 16,
    borderTop: true
  }, /*#__PURE__*/React$1.createElement(TextLabel, {
    lighter: useLighterText
  }, /*#__PURE__*/React$1.createElement(EmailTrans, {
    translatedString: t(footerTranslationKey),
    link: link,
    linkFunctionality: {
      handleLinkClick,
      handleLinkMouseLeave,
      handleLinkMouseEnter
    }
  })));
};

const useStyles$4 = makeStyles(() => ({
  priorityDisclaimer: {
    color: palette.graphite.onyx,
    fontSize: '12px',
    fontWeight: '400',
    padding: '2px',
    backgroundColor: palette.graphite.gray,
    borderRadius: '2px'
  },
  priorityIcon: {
    color: palette.graphite.ash,
    marginLeft: '4px',
    marginRight: '8px',
    marginBottom: '2px',
    fontSize: '16px'
  }
}));
const EmailPriorityDisclaimer = ({}) => {
  const {
    t
  } = useTranslation('assessment');
  const classes = useStyles$4();
  return /*#__PURE__*/React$1.createElement("div", {
    className: classes.priorityDisclaimer
  }, /*#__PURE__*/React$1.createElement(ErrorOutlineOutlinedIcon, {
    className: classes.priorityIcon
  }), t('This message is high priority'));
};

function DefaultEmail({
  ui,
  userName,
  handleLinkClick,
  handleLinkMouseLeave,
  handleLinkMouseEnter
}) {
  const {
    t
  } = useTranslation('assessment');
  const {
    link,
    links,
    email,
    personalizedData = {}
  } = ui;
  const {
    text,
    from_name,
    from_address,
    footer,
    extraLogo,
    showHighPriority
  } = email;
  const {
    spoofedDomain,
    companyDomain
  } = personalizedData;
  const yesterday = (d => new Date(d.setDate(d.getDate() - 1)))(new Date());
  const today = new Date();
  const inOneWeek = (d => new Date(d.setDate(d.getDate() + 7)))(new Date());
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    className: "email-text"
  }, showHighPriority && /*#__PURE__*/React$1.createElement(EmailPriorityDisclaimer, null), extraLogo && /*#__PURE__*/React$1.createElement(FlexDiv, {
    my: 20
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(extraLogo.src || extraLogo),
    alt: t('icon'),
    height: extraLogo.height || 21
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "body"
  }, /*#__PURE__*/React$1.createElement(EmailTrans, {
    translatedString: t(text, {
      username: userName ? userName.split(' ')[0] : '',
      sender_name: from_name ? from_name.split(' ')[0] : '',
      sender_full_name: from_name ? from_name : '',
      sender_from_address: from_address ? from_address : '',
      yesterday: formatDate(yesterday),
      today: formatDate(today),
      inOneWeek: formatDate(inOneWeek),
      spoofedDomain: spoofedDomain ? spoofedDomain : '',
      companyDomain: companyDomain ? companyDomain : ''
    }),
    link: link,
    links: links,
    linkFunctionality: {
      handleLinkClick,
      handleLinkMouseLeave,
      handleLinkMouseEnter
    }
  })), footer && /*#__PURE__*/React$1.createElement(EmailFooter, {
    footer: footer,
    handleLinkClick: handleLinkClick,
    handleLinkMouseLeave: handleLinkMouseLeave,
    handleLinkMouseEnter: handleLinkMouseEnter,
    link: footer.link
  })));
}
var DefaultEmail$1 = observer(DefaultEmail);

function DhlEmail({
  ui
}) {
  const {
    t
  } = useTranslation('assessment');
  const today = new Date();
  const {
    email,
    personalizedData = {}
  } = ui;
  const {
    companyName = 'Mondelez International'
  } = personalizedData;
  const {
    text,
    footer,
    extraLogo
  } = email;
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'dhl-email'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dhl-email--left"
  }, extraLogo && /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(extraLogo),
    alt: t('icon'),
    height: 21
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "dhl-email--right"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dhl-email--right--header"
  }, t('Parcel Arrival Notification')), /*#__PURE__*/React$1.createElement("div", {
    className: "dhl-email--right--content"
  }, /*#__PURE__*/React$1.createElement(Trans, {
    values: {
      companyName
    },
    defaults: t(text, {
      companyName,
      today: formatDate(today)
    }),
    components: {
      strong: /*#__PURE__*/React$1.createElement("strong", null),
      themed: /*#__PURE__*/React$1.createElement("div", {
        className: "dhl-email--right--content__red"
      })
    }
  }, t(text, {
    companyName,
    today: formatDate(today)
  })), footer && /*#__PURE__*/React$1.createElement(FlexDiv, {
    borderTop: true,
    my: 8,
    py: 8
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dhl-email--right--content__lighter"
  }, t(footer))))));
}
var DHLBody = observer(DhlEmail);

const {
  REACT_APP_STATIC_PREFIX: REACT_APP_STATIC_PREFIX$4 = '/static'
} = process.env;
function MDLZnewsletter({
  ui,
  handleLinkClick,
  handleLinkMouseLeave,
  handleLinkMouseEnter
}) {
  const {
    t
  } = useTranslation('assessment');
  const {
    link
  } = ui;
  return /*#__PURE__*/React$1.createElement("div", {
    className: "email-text mdlz-newsletter"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "mdlz-email-header"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: `${REACT_APP_STATIC_PREFIX$4}/img/assessment/email-header-mdlz.png`,
    alt: t('Need to do')
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "body"
  }, /*#__PURE__*/React$1.createElement(EmailTrans, {
    link: link,
    linkFunctionality: {
      handleLinkClick,
      handleLinkMouseLeave,
      handleLinkMouseEnter
    },
    translatedString: t(ui.email.text)
  })), /*#__PURE__*/React$1.createElement(Row, null, /*#__PURE__*/React$1.createElement(Col, {
    md: "4",
    xs: "12"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "img"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: `${REACT_APP_STATIC_PREFIX$4}/img/assessment/email-windows10-logo.png`,
    alt: t('Windows 10')
  }))), /*#__PURE__*/React$1.createElement(Col, {
    md: "8",
    xs: "12"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "blue"
  }, /*#__PURE__*/React$1.createElement("strong", null, t('Important pre-upgrade tasks')), /*#__PURE__*/React$1.createElement("ul", null, /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('Start now by making time for the upgrade')
  })), /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('Move your files to OneDrive for Business')
  })), /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('Restart your PC before the upgrade')
  })))))));
}
var MDLZNewsletterBody = observer(MDLZnewsletter);

function EmailTextFactory({
  ui,
  ...rest
}) {
  const Component = useMemo(() => {
    switch (ui.variant) {
      case 'dhl':
        return DHLBody;
      case 'mdlzNewsletter':
        return MDLZNewsletterBody;
      default:
        return DefaultEmail$1;
    }
  }, [ui]);
  return /*#__PURE__*/React$1.createElement(Component, _extends$2({
    ui: ui
  }, rest));
}
var EmailText = observer(EmailTextFactory);

function PresentationHeading({
  ui
}) {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, ui.pretitle && /*#__PURE__*/React$1.createElement(Heading3, {
    lighter: true
  }, t(ui.pretitle)), ui.title && /*#__PURE__*/React$1.createElement(Heading1, {
    mb: 8
  }, t(ui.title), " "), ui.description && /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t(ui.description)
  }));
}
var PresentationHeading$1 = observer(PresentationHeading);

const CustomPresentation = observer(({
  ui,
  onAction,
  onNextQuestion
}) => {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(PresentationHeading$1, {
    ui: ui,
    t: t
  }), /*#__PURE__*/React$1.createElement(CustomHTML, {
    ui: ui,
    onAction: onAction,
    onNextQuestion: onNextQuestion
  })));
});

function EmailAttachment({
  isHoveringOnAttachment,
  attachment,
  t,
  handleAttachmentClick,
  handleAttachmentMouseEnter,
  handleAttachmentMouseLeave
}) {
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    pt: 24
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    width: 180,
    link: true,
    src: resourcePath(isHoveringOnAttachment ? attachment.iconHover : attachment.icon),
    alt: t(attachment.text),
    onClick: handleAttachmentClick,
    onMouseEnter: handleAttachmentMouseEnter,
    onMouseLeave: handleAttachmentMouseLeave
  }));
}
var EmailAttachment$1 = observer(EmailAttachment);

function EmailAttachmentHover({
  isHoveringOnAttachment,
  attachment
}) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "email-attachment-hover",
    style: {
      visibility: isHoveringOnAttachment ? 'visible' : 'hidden'
    }
  }, attachment.href);
}
var EmailAttachmentHover$1 = observer(EmailAttachmentHover);

function EmailAvatar({
  ui,
  desktopOnly,
  mobileOnly
}) {
  const {
    email
  } = ui;
  const {
    from_name,
    avatar_background_color
  } = email;
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    borderRadius: "50",
    backgroundColor: avatar_background_color || '#2E56E4',
    padding: 8,
    height: 40,
    minWidth: 40,
    width: 40,
    alignCenter: true,
    justifyCenter: true,
    desktopOnly: desktopOnly,
    mobileOnly: mobileOnly
  }, /*#__PURE__*/React$1.createElement(TextLead, {
    color: "white",
    bold: true
  }, from_name.split(' ').map(n => n[0]).join('')));
}
var EmailAvatar$1 = observer(EmailAvatar);

function EmailHeader({
  ui,
  t,
  userEmail,
  userName,
  fromName,
  fromEmail,
  subject,
  toExtraEmail,
  onShowDetails
}) {
  const node = useRef();
  const [open, setOpen] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);
  const handleClick = e => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setOpen(false);
  };
  const handleOpen = () => {
    onShowDetails();
    setOpen(!open);
    setOpenTooltip(false);
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    mb: 16
  }, /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
    alignStart: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 8
  }, /*#__PURE__*/React$1.createElement(EmailAvatar$1, {
    ui: ui,
    mobileOnly: true
  }), /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    gap: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 4,
    alignCenter: true
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    bold: true
  }, ui.email.from_name), /*#__PURE__*/React$1.createElement(TextLabel, {
    lighter: true,
    mobileOnly: true
  }, "10:38")), /*#__PURE__*/React$1.createElement(Tooltip$1, {
    title: t('Click to show details'),
    open: openTooltip,
    onOpen: () => setOpenTooltip(true),
    onClose: () => setOpenTooltip(false)
  }, /*#__PURE__*/React$1.createElement(TextLabel, {
    lighter: true,
    alignCenter: true,
    link: true
  }, t('to me'), ' ', /*#__PURE__*/React$1.createElement(ArrowDropDownIcon, {
    fontSize: "small",
    onClick: handleOpen
  }))))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 4,
    alignCenter: true
  }, /*#__PURE__*/React$1.createElement(TextLabel, {
    lighter: true,
    desktopOnly: true
  }, "10:38 ", t('AM (0 minutes ago)')), /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath('/static/img/assessment/icon/star_border_24px.svg'),
    alt: t('Star'),
    className: "hover-details desktopOnly"
  }), /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath('/static/img/assessment/icon/reply_24px.svg'),
    alt: t('Reply')
  }), /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath('/static/img/assessment/icon/more_vert_24px.svg'),
    alt: t('More')
  }))), /*#__PURE__*/React$1.createElement(Details, {
    userEmail: userEmail,
    userName: userName,
    fromName: fromName,
    fromEmail: fromEmail,
    subject: subject,
    toExtraEmail: toExtraEmail,
    node: node,
    open: open,
    t: t
  }));
}
var EmailHeader$1 = observer(EmailHeader);

function InstructionsOverlay({
  closeModal,
  t
}) {
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    backgroundColor: rgba(255, 255, 255, 0.97),
    alignCenter: true,
    column: true,
    justifyCenter: true,
    px: 24,
    py: 64,
    borderRadius: 8,
    positionAbsolute: true,
    expandFullyOverParent: true,
    zIndex: 2,
    minHeight: 500
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    alt: "envelope",
    src: resourcePath('/static/img/assessment/phishing.svg')
  }), /*#__PURE__*/React$1.createElement(Heading3, {
    mt: 24
  }, t('overlay_heading')), /*#__PURE__*/React$1.createElement(FlexDiv, {
    mt: 24
  }, /*#__PURE__*/React$1.createElement(TextDefault, null, /*#__PURE__*/React$1.createElement("ul", null, /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('overlay_checkName')
  })), /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('overlay_links')
  }))), /*#__PURE__*/React$1.createElement("div", null, t('overlay_paragraph')))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    mt: 24
  }, /*#__PURE__*/React$1.createElement(ThemedButton, {
    mode: "secondary",
    onClick: () => closeModal(),
    text: t('Got it')
  })));
}
var InstructionsOverlay$1 = observer(InstructionsOverlay);

const EmailQuizGeneral = observer(({
  ui,
  onAction,
  userEmail,
  userName,
  isInAnswerMode = false
}) => {
  const {
    t
  } = useTranslation('assessment');
  const [isShowingDetails, setIsShowingDetails] = useState(false);
  const [isShowingLinkAlert, setIsShowingLinkAlert] = useState(false);
  const [isHoveringOnAttachment, setIsHoveringOnAttachment] = useState(false);
  const [hoverStartTime, setHoverStartTime] = useState(null);
  const [instructionsOverlayOpen, setInstructionsOverlayOpen] = useState(ui.email.showInstructionsOverlay && !isInAnswerMode);
  const address = ui.address;
  const attachment = ui.attachment;
  const link = ui.link;
  const handleShowDetails = () => {
    if (address && address.clickActionId && !isShowingDetails) {
      onAction && onAction(address.clickActionId);
    }
    setIsShowingDetails(!isShowingDetails);
  };
  const handleAttachmentMouseEnter = () => {
    setIsHoveringOnAttachment(true);
    startHover();
  };
  const handleAttachmentMouseLeave = () => {
    setIsHoveringOnAttachment(false);
    endHover();
  };
  const handleAttachmentClick = () => {
    if (attachment && attachment.clickActionId) {
      onAction && onAction(attachment.clickActionId);
    }
    setIsShowingLinkAlert(true);
  };
  const handleLinkMouseEnter = () => {
    startHover();
  };
  const handleLinkMouseLeave = hoverActionId => {
    endHover(hoverActionId);
  };
  const handleLinkClick = clickActionId => {
    if (clickActionId) {
      onAction && onAction(clickActionId);
    }
    setIsShowingLinkAlert(true);
  };
  const startHover = () => {
    setHoverStartTime(new Date());
  };
  const endHover = hoverActionId => {
    let hoverEnd = new Date();
    // Only fire the action if user hovers over link for more than 2 seconds
    if (hoverEnd - hoverStartTime > 2000) {
      hoverActionId && onAction && onAction(hoverActionId);
    }
  };
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(PresentationHeading$1, {
    ui: ui,
    t: t
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "email-gmail"
  }, instructionsOverlayOpen && /*#__PURE__*/React$1.createElement(InstructionsOverlay$1, {
    closeModal: () => setInstructionsOverlayOpen(false),
    t: t
  }), /*#__PURE__*/React$1.createElement(FlexDiv, {
    $noWrap: true,
    gap: 8
  }, /*#__PURE__*/React$1.createElement(EmailAvatar$1, {
    ui: ui,
    desktopOnly: true
  }), /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true
  }, /*#__PURE__*/React$1.createElement(EmailHeader$1, {
    ui: ui,
    t: t,
    fromName: t(ui.email.from_name),
    fromEmail: t(ui.email.from_address),
    toEmail: ui.email.to_address,
    userEmail: ui.email.to_address || userEmail,
    userName: ui.email.to_name || userName,
    subject: t(ui.email.subject),
    toExtraEmail: ui.email.extra_to_string,
    onShowDetails: handleShowDetails
  }), /*#__PURE__*/React$1.createElement(EmailText, {
    ui: ui,
    userName: userName,
    handleLinkClick: handleLinkClick,
    handleLinkMouseLeave: handleLinkMouseLeave,
    handleLinkMouseEnter: handleLinkMouseEnter
  }), attachment && /*#__PURE__*/React$1.createElement(FlexDiv, {
    borderTop: true,
    mt: 16
  }, /*#__PURE__*/React$1.createElement(EmailAttachment$1, {
    isHoveringOnAttachment: isHoveringOnAttachment,
    attachment: attachment,
    t: t,
    handleAttachmentClick: handleAttachmentClick,
    handleAttachmentMouseEnter: handleAttachmentMouseEnter,
    handleAttachmentMouseLeave: handleAttachmentMouseLeave
  })))), attachment && attachment.href && /*#__PURE__*/React$1.createElement(EmailAttachmentHover$1, {
    isHoveringOnAttachment: isHoveringOnAttachment,
    attachment: attachment
  }), (attachment || link) && /*#__PURE__*/React$1.createElement(EmailLinksAlert$1, {
    isShowingLinkAlert: isShowingLinkAlert,
    t: t
  })))));
});

const {
  REACT_APP_STATIC_PREFIX: REACT_APP_STATIC_PREFIX$3 = '/static'
} = process.env;
const EmailQuizMdlzNewsletter = observer(({
  ui,
  onAction,
  userEmail,
  userName
}) => {
  const {
    t
  } = useTranslation('assessment');
  const [isShowingDetails, setIsShowingDetails] = React$1.useState(false);
  //const [isShowingPath, setIsShowingPath] = React.useState(false);
  const [hoverStartTime, setHoverStartTime] = React$1.useState(null);
  const [isShowingLinkAlert, setIsShowingLinkAlert] = React$1.useState(false);
  const link = ui.link;
  const address = ui.address;
  const handleShowDetails = () => {
    if (!isShowingDetails) {
      address.clickActionId && onAction && onAction(address.clickActionId);
    }
    setIsShowingDetails(!isShowingDetails);
  };
  const handleLinkMouseEnter = () => {
    //setIsShowingPath(true);
    setHoverStartTime(new Date());
  };
  const handleLinkMouseLeave = () => {
    //setIsShowingPath(false);
    let attachmentHoverEnd = new Date();
    //Only fire the action if user hovers over attachment for more than 3 seconds
    if (attachmentHoverEnd - hoverStartTime > 2000) {
      onAction && onAction(link.hoverActionId);
    }
  };
  const handleLinkClick = () => {
    setIsShowingLinkAlert(true);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(PresentationHeading$1, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "email-gmail mdlz-newsletter"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "email-header"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "profile-img",
    style: {
      backgroundColor: ui.email.avatar_background_color || '#2E56E4'
    }
  }, t(ui.email.from_initials)), /*#__PURE__*/React$1.createElement("div", {
    className: "email-top-line"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "details-header"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "from"
  }, t(ui.email.from_name)), /*#__PURE__*/React$1.createElement("span", {
    className: "mobileOnly mobile-email-time"
  }, t('gmail_short_time')), /*#__PURE__*/React$1.createElement("span", {
    className: "desktopOnly email-time"
  }, t('gmail_long_time')), /*#__PURE__*/React$1.createElement("div", {
    className: "email-icons"
  }, /*#__PURE__*/React$1.createElement("img", {
    className: "desktopOnly",
    src: `${REACT_APP_STATIC_PREFIX$3}/img/assessment/icon/star_border_24px.svg`,
    alt: t('Star')
  }), /*#__PURE__*/React$1.createElement("img", {
    src: `${REACT_APP_STATIC_PREFIX$3}/img/assessment/icon/reply_24px.svg`,
    alt: t('Reply')
  }), /*#__PURE__*/React$1.createElement("img", {
    src: `${REACT_APP_STATIC_PREFIX$3}/img/assessment/icon/more_vert_24px.svg`,
    alt: t('More')
  }))), /*#__PURE__*/React$1.createElement(Details, {
    ui: ui,
    fromName: t(ui.email.from_name),
    fromEmail: t(ui.email.from_address),
    userEmail: userEmail,
    userName: userName,
    subject: t(ui.email.subject),
    onShowDetails: handleShowDetails,
    t: t
  }))), /*#__PURE__*/React$1.createElement("div", {
    className: "email-text"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "mdlz-email-header"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: `${REACT_APP_STATIC_PREFIX$3}/img/assessment/email-header-mdlz.png`,
    alt: t('Need to do')
  })), /*#__PURE__*/React$1.createElement("p", null, /*#__PURE__*/React$1.createElement(Trans, {
    defaults: t(ui.email.text),
    components: {
      strong: /*#__PURE__*/React$1.createElement("strong", null),
      u: /*#__PURE__*/React$1.createElement(EmailLink, {
        onClick: handleLinkClick,
        onMouseLeave: handleLinkMouseLeave,
        onMouseEnter: handleLinkMouseEnter,
        link: link
      })
    }
  }, t(ui.email.text))), /*#__PURE__*/React$1.createElement(Row, null, /*#__PURE__*/React$1.createElement(Col, {
    md: "4",
    xs: "12"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "img"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: `${REACT_APP_STATIC_PREFIX$3}/img/assessment/email-windows10-logo.png`,
    alt: t('Windows 10')
  }))), /*#__PURE__*/React$1.createElement(Col, {
    md: "8",
    xs: "12"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "blue"
  }, /*#__PURE__*/React$1.createElement("strong", null, t('Important pre-upgrade tasks')), /*#__PURE__*/React$1.createElement("ul", null, /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('Start now by making time for the upgrade')
  })), /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('Move your files to OneDrive for Business')
  })), /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t('Restart your PC before the upgrade')
  }))))))), /*#__PURE__*/React$1.createElement("div", {
    className: "mdlz-email-footer"
  }, t('For help with your Windows 10 upgrade, contact User First IT Support (Service Desk) using your preferred method — Skype for Business chat, phone, or email.')), /*#__PURE__*/React$1.createElement("div", {
    className: "email-attention",
    style: {
      opacity: isShowingLinkAlert ? '1' : '0'
    }
  }, t('Links don’t work. This is only a simulation'), "."))));
});

/*
    Presentation handles multiple images.
    - To use, supply array to image property of presentation definition instead of string -
    Example: "image": ["/static/img/assessment/ws4_presentation_1.jpg", "/static/img/assessment/ws4_presentation_2.jpg"]
    */

const Illustration = observer(({
  ui
}) => {
  const {
    t
  } = useTranslation('assessment');
  const [imageZoomed, setIsImageZoomed] = React$1.useState(false);
  const handleImageClick = () => {
    setIsImageZoomed(!imageZoomed);
  };
  const renderImage = (imageSrc, imageZoom) => {
    return /*#__PURE__*/React$1.createElement("div", {
      className: classnames('image', {
        clickable: imageZoom
      })
    }, imageZoom && /*#__PURE__*/React$1.createElement(Image$1, {
      src: resourcePath(imageSrc),
      alt: t('illustration'),
      onClick: handleImageClick,
      className: "presentationImage"
    }), !imageZoom && /*#__PURE__*/React$1.createElement(Image$1, {
      fullWidth: true,
      src: resourcePath(imageSrc),
      alt: t('illustration')
    }));
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(TextTiny, null, t(ui.pretitle)), /*#__PURE__*/React$1.createElement(Heading1, {
    mb: 8
  }, t(ui.title), " "), /*#__PURE__*/React$1.createElement(Trans, {
    components: {
      p: /*#__PURE__*/React$1.createElement(TextLead, null)
    }
  }, t(ui.description)), Array.isArray(ui.image.slice()) ? /*#__PURE__*/React$1.createElement("div", {
    className: "imageContainer"
  }, ui.image.map(imageSrc => {
    return renderImage(imageSrc, ui.imageZoom);
  })) : renderImage(ui.image, ui.imageZoom), /*#__PURE__*/React$1.createElement("div", {
    className: "image-zoomed",
    onClick: handleImageClick,
    style: {
      opacity: imageZoomed ? '1' : '0',
      visibility: imageZoomed ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(ui.imageZoom),
    alt: t('illustration'),
    onClick: handleImageClick
  }))));
});

const {
  REACT_APP_STATIC_PREFIX: REACT_APP_STATIC_PREFIX$2 = '/static'
} = process.env;

// customizing styling of Tooltip
const LightTooltip = withStyles$1(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    fontStyle: 'italic',
    padding: '1em'
  }
}))(Tooltip);
const InteractiveImg = observer(({
  ui
}) => {
  const {
    t
  } = useTranslation('assessment');
  const [open, setOpen] = useState(false);
  const [openedHint, setOpenedHint] = useState(null);
  const openTooltip = key => {
    setOpen(true);
    setOpenedHint(key);
  };
  const closeTooltip = () => {
    setOpen(false);
    setOpenedHint(null);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(PresentationHeading$1, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "hoverable-image",
    style: {
      backgroundImage: `url(${resourcePath(ui.image)})`
    }
  }, ui.hoverPoints.map((point, i) => /*#__PURE__*/React$1.createElement(LightTooltip, {
    style: {
      top: point.top,
      left: point.left,
      position: 'absolute'
    },
    title: `“${t(point.text)}”`,
    placement: "bottom-start",
    onMouseEnter: () => openTooltip(i),
    onClick: () => openTooltip(i),
    onMouseLeave: closeTooltip,
    onClose: closeTooltip,
    open: open && openedHint === i,
    key: i
  }, /*#__PURE__*/React$1.createElement("img", {
    src: `${REACT_APP_STATIC_PREFIX$2}/img/assessment/orange-dot.svg`,
    alt: "tooltip"
  }))))));
});

const Message = observer(({
  ui
}) => {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(Heading1, {
    mb: 8
  }, t(ui.title), " "), /*#__PURE__*/React$1.createElement("p", null, t(ui.description), " "), /*#__PURE__*/React$1.createElement("div", {
    className: "chat-message"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "img"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: resourcePath(ui.messenger_image),
    alt: "illustration"
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "top"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "name"
  }, ui.messenger_name), /*#__PURE__*/React$1.createElement("div", {
    className: "time"
  }, ui.messenger_time)), /*#__PURE__*/React$1.createElement("div", {
    className: "text"
  }, t(ui.messenger_text)))), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement(Heading3, {
    lighter: true
  }, t(ui.pretitle), " ")));
});

const QuestionHeading = observer(({
  ui
}) => {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Heading3, {
    lighter: true,
    mb: 8
  }, t(ui.pretitle)), /*#__PURE__*/React$1.createElement(Heading2, {
    bold: true
  }, t(ui.title), " "), ui.description ? /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t(ui.description)
  }) : /*#__PURE__*/React$1.createElement("p", null));
});

const Password = observer(({
  ui,
  onAction,
  scorePercentage
}) => {
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      alignItems: 'center'
    },
    wrapper: {
      margin: theme.spacing(1),
      position: 'relative'
    },
    buttonProgress: {
      color: '#ffffff',
      position: 'absolute',
      top: '30%',
      right: '40%',
      zIndex: 1000,
      '@media (max-width: 992px)': {
        top: 'initial',
        right: 'initial',
        position: 'initial'
      }
    },
    wrap: {
      width: '100%',
      padding: '20px',
      background: '#FFFFFF',
      border: '1px solid rgba(232, 234, 233, 0.5)',
      boxSizing: 'border-box',
      boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.08), 0px 4px 24px rgba(29, 30, 29, 0.08)',
      borderRadius: 8,
      marginTop: '24px'
    },
    description: {
      fontSize: '12px'
    }
  }));
  const {
    t
  } = useTranslation('assessment');
  const classes = useStyles();
  //const {brandingStore} = useStores();
  const [loading, setLoading] = React$1.useState(false);
  const [showingResults, setShowingResults] = React$1.useState(false);
  const [missingFromPassword, setMissingFromPassword] = React$1.useState([]);
  const [passwordResolution, setPasswordResolution] = React$1.useState({});
  const [passwordVisible, setPasswordVisibility] = React$1.useState(true);
  const redColor = '#EB5757';
  const yellowColor = '#FCBE00';
  const greenColor = '#20A26B';
  const passwordShouldContain = ['Lowercase', 'Uppercase', 'Number', 'Symbols', 'Length'];
  const passwordInput = /*#__PURE__*/React$1.createRef();
  const timer = React$1.useRef();
  const passwordForm = ui['password-form'];
  const uppercaseRegExp = /(?=.*[\p{Lu}])/u;
  const lowercaseRegExp = /(?=.*[\p{Ll}])/u;
  const numberRegExp = /(?=.*\d)/;
  const specialRegExp = /(?=.*[\p{P}\p{S}])/u;
  React$1.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  const togglePasswordVisibility = () => {
    setPasswordVisibility(!passwordVisible);
  };
  const checkPassword = event => {
    const password = passwordInput.current.value;
    //Set spinner to button for few seconds
    if (!loading) {
      setLoading(true);
      timer.current = window.setTimeout(() => {
        setLoading(false);
        setShowingResults(true);
      }, 2000);
    }

    //handleChange that user did input password
    if (password.length > 0) {
      onAction && onAction(passwordForm.clickActionId);
    }

    //Check password for
    let missing = [];
    if (!uppercaseRegExp.test(password)) {
      missing.push('Uppercase');
    }
    if (!lowercaseRegExp.test(password)) {
      missing.push('Lowercase');
    }
    if (!numberRegExp.test(password)) {
      missing.push('Number');
    }
    if (!specialRegExp.test(password)) {
      missing.push('Symbols');
    }
    if (password.length < 12) {
      missing.push('Length');
    }
    setPasswordResolution(resolvePassword(missing.length));
    setMissingFromPassword(missing);
  };
  const resolvePassword = missingCount => {
    switch (missingCount) {
      case 0:
        return {
          text: t('Very strong'),
          percentage: 100
        };
      case 1:
        return {
          text: t('Strong'),
          percentage: 75
        };
      case 2:
        return {
          text: t('Medium'),
          percentage: 50
        };
      case 3:
        return {
          text: t('Weak'),
          percentage: 25
        };
      default:
        return {
          text: t('Very weak'),
          percentage: 0
        };
    }
  };
  const calculateColor = percentage => {
    if (percentage <= 33) return redColor;
    if (percentage <= 67) return yellowColor;
    return greenColor;
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(PresentationHeading$1, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement("div", {
    className: classes.wrap
  }, /*#__PURE__*/React$1.createElement(Heading3, null, t(ui.componentHeader), " "), /*#__PURE__*/React$1.createElement("p", {
    className: classes.description
  }, t(ui.componentDescription)), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Heading3, null, t('Not sure? Check your password here')), /*#__PURE__*/React$1.createElement("p", {
    style: {
      fontSize: '14px'
    }
  }, t('The stronger your password is, the harder it is to hack. Test your password strength here.')), /*#__PURE__*/React$1.createElement("div", {
    className: classnames('password-tester', {
      visible: passwordVisible
    })
  }, /*#__PURE__*/React$1.createElement(FormControl$1, null, /*#__PURE__*/React$1.createElement(TextField, {
    style: {
      background: '#FCFCFC'
    },
    inputRef: passwordInput,
    id: "password-tester-password",
    variant: "outlined",
    placeholder: t('Type in your password'),
    type: passwordVisible ? 'password' : 'text',
    className: classnames('password-input')
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "show-password",
    onClick: () => togglePasswordVisibility()
  }), /*#__PURE__*/React$1.createElement(Button$1, {
    variant: "contained",
    color: "primary",
    component: "span",
    type: "submit",
    onClick: checkPassword,
    className: classnames({
      'button-disabled': loading
    })
  }, loading ? /*#__PURE__*/React$1.createElement(CircularProgress$1, {
    size: 24,
    className: classes.buttonProgress
  }) : t('Test'))))), showingResults && /*#__PURE__*/React$1.createElement("div", {
    className: "password-tester-results"
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    bold: true
  }, t('Your password is'), ":"), ' ', /*#__PURE__*/React$1.createElement(TextDefault, {
    extraBold: true
  }, passwordResolution.text, ' '), /*#__PURE__*/React$1.createElement("div", {
    className: "meter"
  }, /*#__PURE__*/React$1.createElement("span", {
    style: {
      width: passwordResolution.percentage + '%',
      backgroundColor: calculateColor(passwordResolution.percentage)
    }
  })), /*#__PURE__*/React$1.createElement("ul", null, passwordShouldContain.map((criteria, i) => {
    return /*#__PURE__*/React$1.createElement("li", {
      className: classnames('action', {
        incorrect: missingFromPassword.indexOf(criteria) >= 0
      }, {
        correct: missingFromPassword.indexOf(criteria) < 0
      }),
      key: 'criteria-' + i
    }, t(criteria));
  }))))));
});

const Question = observer(({
  ui
}) => {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(Heading1, {
    mb: 8
  }, t(ui.title), " "), /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t(ui.description)
  }), ui.password && /*#__PURE__*/React$1.createElement("div", {
    className: "password"
  }, t(ui.password)), ui.pretitle && /*#__PURE__*/React$1.createElement(Heading3, null, t(ui.pretitle))));
});

const DecisionOverlay = observer(({
  decisionQuestion,
  onAnswer,
  isAtEnd
}) => {
  const {
    t
  } = useTranslation();
  const madeDecision = decision => {
    onAnswer(decisionQuestion.id, decision);
  };
  useEffect(() => {}, [decisionQuestion]);
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    positionAbsolute: true,
    zIndex: 2,
    justifyCenter: true,
    alignCenter: true,
    fullWidth: true,
    fullHeight: true,
    column: true,
    backgroundColor: rgba(0, 0, 0, 0.4)
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    dropShadowBelow: true,
    borderRadius: 3,
    positionRelative: true,
    py: 24,
    px: 48
  }, /*#__PURE__*/React$1.createElement(Heading2, {
    color: palette.graphite.white,
    center: true
  }, isAtEnd ? t('The end') : t(decisionQuestion.questionText))), !isAtEnd && /*#__PURE__*/React$1.createElement(FlexDiv, {
    desktopOnly: true,
    gap: 16
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    link: true,
    onClick: () => madeDecision(decisionQuestion.decision_1),
    width: 240,
    justifyCenter: true,
    alignCenter: true,
    backgroundColor: palette.graphite.white,
    borderRadius: 4,
    textAlignCenter: true
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    my: 16,
    bold: true
  }, t(decisionQuestion.decision_1.text))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    link: true,
    onClick: () => madeDecision(decisionQuestion.decision_2),
    width: 240,
    justifyCenter: true,
    alignCenter: true,
    backgroundColor: palette.graphite.white,
    borderRadius: 4,
    textAlignCenter: true
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    my: 16,
    bold: true
  }, t(decisionQuestion.decision_2.text)))));
});

const CheckCircle = styled(MuiCheckCircle)`
    color: ${palette.evergreen.aspargus};
    ${props => props.inactive && css`
            color: rgba(palette.graphite.heavyMetal, 0.1);
        `};

    ${props => props.big ? css`
                  transform: scale(1.5);
              ` : css`
                  transform: scale(0.75);
              `}
`;
const CancelCircle = styled(CancelIcon)`
    color: ${palette.vibrant.red};
    ${props => props.big ? css`
                  transform: scale(1.5);
              ` : css`
                  transform: scale(0.75);
              `}
`;

const DecisionFeedback = observer(({
  subject,
  showAnswerVideo,
  tryAgain
}) => {
  const {
    numberOfRightAnswers,
    numberOfPossibleDecisions = 1,
    decisionFeedbackTable
  } = subject;
  const userDidAnswerCorrectly = numberOfRightAnswers / numberOfPossibleDecisions === 1;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(FlexDiv, {
    positionAbsolute: true,
    justifyCenter: true,
    alignCenter: true,
    zIndex: 2,
    fullWidth: true,
    fullHeight: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    backgroundColor: rgba(palette.graphite.white, 0.9),
    justifyCenter: true,
    alignCenter: true,
    padding: 16,
    column: true,
    gap: 24,
    borderRadius: 8,
    fullWidth: true,
    maxWidth: 444,
    mx: 48,
    pt: 32,
    pb: 24
  }, /*#__PURE__*/React$1.createElement(Heading3, null, userDidAnswerCorrectly ? t('decisionSubjectFeedbackTitlePositive') : t('decisionSubjectFeedbackTitleImprovable')), /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 16
  }, decisionFeedbackTable.map(decision => /*#__PURE__*/React$1.createElement(React$1.Fragment, null, decision.decision_1.key === decision.answer && (decision.decision_1.correct ? /*#__PURE__*/React$1.createElement(CheckCircle, {
    color: palette.evergreen.aspargus,
    big: true
  }) : /*#__PURE__*/React$1.createElement(CancelCircle, {
    color: palette.vibrant.red,
    big: true
  })), decision.decision_2.key === decision.answer && (decision.decision_2.correct ? /*#__PURE__*/React$1.createElement(CheckCircle, {
    color: palette.evergreen.aspargus,
    big: true
  }) : /*#__PURE__*/React$1.createElement(CancelCircle, {
    color: palette.vibrant.red,
    big: true
  }))))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 16,
    desktopOnly: true,
    column: true,
    alignCenter: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    alignCenter: true
  }, /*#__PURE__*/React$1.createElement(Trans, {
    components: {
      p: /*#__PURE__*/React$1.createElement(TextDefault, null),
      b: /*#__PURE__*/React$1.createElement(TextDefault, {
        bold: true
      })
    }
  }, t('decisionSubjectFeedbackInfo', {
    count: numberOfRightAnswers,
    numberOfRightAnswers,
    numberOfPossibleDecisions
  })), /*#__PURE__*/React$1.createElement(TextDefault, null, ' ', userDidAnswerCorrectly ? t('decisionSubjectFeedbackCommentPositive') : t('decisionSubjectFeedbackCommentImprovable'))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 24
  }, /*#__PURE__*/React$1.createElement(ThemedButton, {
    mode: !userDidAnswerCorrectly ? 'primary' : 'secondary',
    onClick: tryAgain,
    text: t('tryAgain')
  }), /*#__PURE__*/React$1.createElement(ThemedButton, {
    mode: "secondary",
    text: t('previewVideo'),
    onClick: showAnswerVideo
  }))))));
});

function DecisionPlayerProgressbar({
  totalLength = 1,
  counter
}) {
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    fullWidth: true,
    backgroundColor: palette.graphite.heavyMetal,
    height: 10
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    widthPercentage: counter / totalLength * 100 / 0.95 //Dividing by 0.95 because we stop video at 95% to ask user to make a decision
    ,
    backgroundColor: primaryColor,
    fullHeight: true
  }));
}

function StartDecisionIcon() {
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      height: 61,
      width: 60
    }
  }, /*#__PURE__*/React$1.createElement("svg", {
    width: "59",
    height: "58",
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React$1.createElement("path", {
    opacity: "0.15",
    d: "M36.0038 24.5509C37.6936 25.7464 37.6936 28.2536 36.0038 29.4491L7.47406 49.6326C5.48712 51.0383 2.74144 49.6174 2.74144 47.1835V6.81645C2.74144 4.38255 5.48712 2.96169 7.47406 4.36737L36.0038 24.5509Z",
    fill: "#1D1E1D"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M14.0516 53.449L42.5813 33.2654C44.8344 31.6715 44.8344 28.3285 42.5813 26.7346L14.0516 6.551C11.4023 4.67677 7.74144 6.57125 7.74144 9.81645V50.1835C7.74144 53.4287 11.4024 55.3232 14.0516 53.449Z",
    fill: "white",
    stroke: "#1D1E1D",
    strokeWidth: "2"
  }), /*#__PURE__*/React$1.createElement("path", {
    opacity: "0.15",
    d: "M22.3442 48.6745C23.0012 49.1835 25.6384 50.5515 26.4355 51.0343C28.7597 52.4451 29.8582 53.1708 32.526 53.9442C32.8718 54.0429 33.1431 54.4713 33.3387 54.921C33.5936 55.5073 34.268 55.8581 34.8514 55.5963L43.2486 51.8274C43.3695 51.7731 43.4779 51.6948 43.5409 51.5782C43.7502 51.1914 44.169 50.0515 43.9564 47.3404C43.6781 43.793 42.2958 40.3864 40.7409 37.2488C39.7911 35.3369 37.8736 36.4043 37.7082 37.5443C37.6793 37.742 37.6744 37.9372 37.681 38.1111C37.6854 38.2252 37.4788 38.3009 37.4163 38.2054C37.0657 37.6693 36.5281 36.8994 36.201 36.6831C35.9862 36.5427 35.334 36.3418 34.9578 36.4289C34.4915 36.5381 34.0004 36.7852 33.6247 37.0406C33.3821 37.2062 33.018 37.7215 32.9695 38.1335C32.9553 38.2527 32.2836 38.5561 32.1982 38.4718C32.0971 38.3722 31.9935 38.2824 31.8883 38.2068C30.6467 37.3183 28.4721 38.6424 28.8478 40.1569C28.8757 40.2697 28.6189 40.4119 28.5555 40.3144C27.4281 38.5825 25.7684 36.102 24.6366 34.7168C22.7752 32.4386 19.8428 34.2256 21.6497 37.3399C23.1778 39.9841 26.2393 43.7914 27.8767 46.3798C28.2095 46.7941 28.0148 46.628 27.5043 46.3451C27.1182 46.1315 27.0122 46.044 26.6639 45.8735C26.2849 45.6867 25.6406 45.3437 25.1874 45.222C24.4358 45.0189 23.6114 44.817 22.8604 45.0723C21.8657 45.4087 21.2764 46.4887 21.5372 47.419C21.6835 47.942 21.7692 48.2221 22.3442 48.6745Z",
    fill: "#1D1E1D"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M31.4002 42.3893C31.5218 42.4071 31.6359 42.4258 31.741 42.443L31.7596 42.446C32.1997 42.5174 32.7665 42.7234 33.1499 42.869L27.337 46.2986C27.3399 46.306 27.3429 46.3135 27.3459 46.3211C27.4353 46.549 27.5524 46.8471 27.7596 47.1323C27.9859 47.4437 28.2751 47.6855 28.6417 47.9179L28.6416 47.9179L28.6481 47.9219C29.0745 48.1877 30.011 48.5972 30.8403 48.9519C31.1074 49.0662 31.37 49.1775 31.6174 49.2823C32.1955 49.5273 32.6899 49.7368 32.9618 49.8658C33.1146 49.9384 33.2628 50.0091 33.407 50.0779C35.5051 51.0788 36.7618 51.6783 39.3425 52.1566C39.3474 52.1612 39.3528 52.1667 39.3589 52.173C39.4266 52.2434 39.513 52.362 39.6077 52.5281C40.1292 53.4428 41.4051 54.0783 42.5525 53.4158L50.3174 48.9328C50.5382 48.8053 50.8412 48.572 51.007 48.1705C51.2718 47.5288 51.5418 46.165 51.0481 43.4513C50.3903 39.8363 48.6239 36.5289 46.7814 33.6018L46.7809 33.601C46.4105 33.0139 45.929 32.5886 45.3531 32.3822C44.7756 32.1753 44.2001 32.2237 43.7133 32.4127C43.1909 32.6156 42.7193 33.0038 42.4062 33.491C42.2548 33.3586 42.0911 33.2349 41.9274 33.1492L41.9229 33.1468C41.6654 33.0137 41.3174 32.9318 41.0303 32.8931C40.7506 32.8554 40.3089 32.8272 39.9058 32.965L39.9034 32.9658C39.3133 33.1691 38.7546 33.533 38.3501 33.8728L38.3486 33.8741C38.0937 34.0891 37.8893 34.4028 37.7544 34.673C37.7145 34.7528 37.674 34.8422 37.6364 34.9388C36.592 34.5028 35.4688 34.8746 34.7443 35.4395C34.4677 35.6552 34.2034 35.936 33.9958 36.2641C32.8995 34.9388 31.6539 33.4868 30.7272 32.5626C29.4381 31.277 27.6468 31.0614 26.4843 32.1272C25.3039 33.2095 25.3634 35.0451 26.5658 36.7041C27.4753 37.9627 28.7866 39.4556 30.0687 40.8949C30.2263 41.0718 30.3835 41.2479 30.5396 41.4229C30.8314 41.7499 31.1196 42.0728 31.4002 42.3893ZM31.4002 42.3893C30.7052 42.2874 29.7685 42.214 28.9053 42.6093L31.4002 42.3893ZM28.9051 42.6094C27.5278 43.2383 26.7811 44.8856 27.3369 46.2982L28.9051 42.6094Z",
    fill: "white",
    stroke: "#1D1E1D",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

function StartFeedback({
  startDecisionsSubjectVideo
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(FlexDiv, {
    positionAbsolute: true,
    justifyCenter: true,
    alignCenter: true,
    zIndex: 2,
    fullWidth: true,
    fullHeight: true,
    desktopOnly: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    backgroundColor: rgba(palette.graphite.white, 0.9),
    justifyCenter: true,
    alignCenter: true,
    padding: 24,
    width: 400,
    column: true,
    gap: 24,
    borderRadius: 8
  }, /*#__PURE__*/React$1.createElement(StartDecisionIcon, null), /*#__PURE__*/React$1.createElement(Heading3, {
    mt: 16
  }, t('decisionSubjectStartFeedbackTitle')), /*#__PURE__*/React$1.createElement(TextDefault, {
    center: true
  }, t('decisionSubjectStartFeedbackDescription')), /*#__PURE__*/React$1.createElement(ThemedButton, {
    mode: "secondary",
    onClick: startDecisionsSubjectVideo,
    text: t('decisionSubjectStartFeedbackButton')
  }))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    positionAbsolute: true,
    justifyCenter: true,
    alignCenter: true,
    zIndex: 2,
    fullWidth: true,
    fullHeight: true,
    mobileOnly: true,
    column: true,
    onClick: startDecisionsSubjectVideo
  }, /*#__PURE__*/React$1.createElement(StartDecisionIcon, null), /*#__PURE__*/React$1.createElement(Heading3, {
    mt: 16,
    color: palette.graphite.white
  }, t('decisionSubjectStartFeedbackTitle'))));
}

var Spinner = (() => /*#__PURE__*/React$1.createElement("div", {
  className: "spinner"
}, /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1",
  width: "86px",
  height: "86px",
  viewBox: "0 0 28 28"
}, /*#__PURE__*/React$1.createElement("g", {
  className: "qp-circular-loader"
}, /*#__PURE__*/React$1.createElement("path", {
  className: "qp-circular-loader-path",
  fill: "none",
  d: "M 14,1.5 A 12.5,12.5 0 1 1 1.5,14",
  strokeLinecap: "round"
})))));

function StartFeedbackMobile({
  startDecisionsSubjectVideo
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    justifyCenter: true,
    alignCenter: true,
    padding: 20,
    fullWidth: true,
    column: true,
    gap: 16,
    mobileOnly: true
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    center: true
  }, t('decisionSubjectStartFeedbackDescription')), /*#__PURE__*/React$1.createElement(ThemedButton, {
    mode: "secondary",
    onClick: startDecisionsSubjectVideo,
    text: t('decisionSubjectStartFeedbackButton')
  }));
}

function DecisionOverlayMobile({
  decisionQuestion,
  onAnswer,
  isAtEnd
}) {
  const {
    t
  } = useTranslation();
  const madeDecision = decision => {
    onAnswer(decisionQuestion.id, decision);
  };
  return !isAtEnd && /*#__PURE__*/React$1.createElement(FlexDiv, {
    backgroundColor: rgba(palette.graphite.heavyMetal, 0.1),
    fullWidth: true,
    gap: 16,
    padding: 24,
    column: true,
    mobileOnly: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    link: true,
    onClick: () => madeDecision(decisionQuestion.decision_1),
    fullWidth: true,
    justifyCenter: true,
    alignCenter: true,
    backgroundColor: palette.graphite.white,
    borderRadius: 4
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    my: 16
  }, t(decisionQuestion.decision_1.text))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    link: true,
    onClick: () => madeDecision(decisionQuestion.decision_2),
    fullWidth: true,
    justifyCenter: true,
    alignCenter: true,
    backgroundColor: palette.graphite.white,
    borderRadius: 4
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    my: 16
  }, t(decisionQuestion.decision_2.text))));
}

const DecisionFeedbackMobile = observer(({
  subject,
  showAnswerVideo,
  tryAgain
}) => {
  const {
    numberOfPossibleDecisions = 1,
    numberOfRightAnswers
  } = subject;
  const userDidAnswerCorrectly = numberOfRightAnswers / numberOfPossibleDecisions === 1;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React$1.createElement(FlexDiv, {
    fullWidth: true,
    gap: 16,
    padding: 24,
    column: true,
    mobileOnly: true
  }, /*#__PURE__*/React$1.createElement(Trans, {
    components: {
      p: /*#__PURE__*/React$1.createElement(TextDefault, null),
      b: /*#__PURE__*/React$1.createElement(TextDefault, {
        bold: true
      })
    }
  }, t('decisionSubjectFeedbackInfo', {
    count: numberOfRightAnswers,
    numberOfRightAnswers,
    numberOfPossibleDecisions
  })), /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 16,
    column: true
  }, /*#__PURE__*/React$1.createElement(ThemedButton, {
    mode: !userDidAnswerCorrectly ? 'primary' : 'secondary',
    maxWidth: true,
    onClick: tryAgain,
    text: t('tryAgain')
  }), /*#__PURE__*/React$1.createElement(ThemedButton, {
    mode: "secondary",
    maxWidth: true,
    onClick: showAnswerVideo,
    text: t('previewVideo')
  })));
});

const CONSTANTS = {
  EVENTS: {
    LOGIN: 1,
    LOGOUT: 2,
    SUBJECT_OPEN: 3,
    SUBJECT_CLOSE: 4,
    ANSWARE_CORRECT: 5,
    ANSWARE_INCORRECT: 6,
    VIDEO_START: 7,
    VIDEO_25: 8,
    VIDEO_50: 9,
    VIDEO_75: 10,
    VIDEO_95: 11,
    VIDEO_100: 12,
    CAMPAIGN_EMAIL: 13
  },
  USERS_VIEW: {
    LISTS: 1,
    EDIT: 2,
    ADD_USERS: 3,
    LIST_USERS: 4,
    LIST_VIEW: 5
  }
};
const VideoPlayer = observer(({
  subject,
  logEvent,
  videoPlayerUrl,
  token,
  videoTokenRequested,
  presetCaptionsLanguage,
  captionsSettings,
  onChange,
  enableAssessmentFinish,
  isAssessment,
  onLastDecision,
  resetDecisions,
  onFinishedWatchingAnswer
}) => {
  const {
    t
  } = useTranslation();
  const [videoDecisions, setVideoDecisions] = useState(null);
  const [showOverlay, setShowingOverlay] = useState(false);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const [isReady, setIsReady] = useState(false);
  const [currentPlaylistIndex, setCurrentPlaylistIndex] = useState(0);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showStartFeedback, setShowStartFeedback] = useState(false);
  const [isPlayingDecisionAnswer, setPlayingDecisionAnswer] = useState(false);
  const [counter, setProgress] = useState(0);

  /////////////////////////////////////////////////////////////
  /// Re-render functionality to fix JWPlayer not refreshing on subject change
  const [rerender, setRerender] = useState(true);
  useEffect(() => {
    setRerender(true);
  }, [subject]);
  useEffect(() => {
    if (rerender) {
      setRerender(false);
    }
  }, [rerender]);
  /////////////////////////////////////////////////////////////

  useEffect(() => {
    if (subject && subject.video_decisions) {
      if (!isAssessment) {
        setShowFeedback(isReady && !showStartFeedback && subject.hasBeenTried);
        setIsAtEnd(!isPlayingDecisionAnswer && subject.hasBeenTried);
      }
      setVideoDecisions(subject.video_decisions);
    }
  }, [subject, isReady, showStartFeedback]);
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(oldValue => {
        const newValue = isPaused ? oldValue : oldValue + 0.5;
        return newValue;
      });
    }, 500);
    return () => clearInterval(interval);
  }, [isPaused]);
  const onError = (ev, data) => {
    if (ev.code === 232403) {
      videoTokenRequested(subject.video_id_jw);
    }
    if (ev.code === 224003) {
      videoTokenRequested(subject.id);
    }
  };
  const onSetupError = ev => {
    if (ev.code === 102403) {
      videoTokenRequested(subject.id);
    }
    if (ev.code === 224003) {
      videoTokenRequested(subject.id);
    }
  };
  const setCaptionsLanguage = () => {
    let captionsIndex = 0;
    if (presetCaptionsLanguage) {
      const captions = window.jwplayer().getCaptionsList();
      for (let i = 0; i < captions.length; i++) {
        if (captions[i].label === presetCaptionsLanguage) {
          captionsIndex = i;
        }
      }
    }
    window.jwplayer().setCurrentCaptions(captionsIndex);
    hideNextUpPopupWindow();
  };
  const getPlayerCustomProps = () => {
    let props = {
      skin: {
        name: 'AwareGO'
      }
    };
    if (captionsSettings) {
      props.captions = JSON.parse(captionsSettings);
    }
    return props;
  };
  const handleNinetyFivePercent = () => {
    if (subject && subject.video_decisions) {
      window.jwplayer().pause();
      setIsPaused(true);
      if (!videoDecisions[window.jwplayer().getPlaylistIndex()].decision_1 || isPlayingDecisionAnswer) {
        //If this index points to a decision question without a decision, don't pause
        setIsAtEnd(true);
        if (isAssessment) {
          //If it is an assessment decision, it ends here
          enableAssessmentFinish();
        } else {
          //Showing the feedback modal (With 'Try Again' and 'See answer')
          setShowFeedback(true);
          if (isPlayingDecisionAnswer) {
            onFinishedWatchingAnswer();
            onLastDecision({
              previewed: true
            });
          } else {
            onLastDecision();
          }
        }
      } else {
        setIsAtEnd(false);
      }
      setShowingOverlay(true);
    }
  };
  const onAnswer = (decisionQuestionId, decision) => {
    setCurrentPlaylistIndex(decision.playlistIndex);
    setShowingOverlay(false);
    if (isAssessment) {
      onChange(decisionQuestionId, decision);
    } else {
      onChange(decision, currentPlaylistIndex);
    }
    window.jwplayer().playlistItem(decision.playlistIndex);
  };
  const hideNextUpPopupWindow = () => {
    const nextUpElement = window.jwplayer().getContainer().querySelector('.jw-nextup-container');
    if (nextUpElement) {
      nextUpElement.style.display = 'none';
    }
  };
  const tryAgainDecisionSubject = () => {
    setProgress(0);
    isPlayingDecisionAnswer && setPlayingDecisionAnswer(false);
    isPlayingDecisionAnswer && videoTokenRequested(subject.id);
    setIsAtEnd(false);
    setCurrentPlaylistIndex(0);
    setShowFeedback(false);
    setShowingOverlay(false);
    window.jwplayer().playlistItem(0);
    resetDecisions();
  };
  const showAnswerVideo = () => {
    setProgress(0);
    videoTokenRequested(subject.answerSubjectId);
    setCurrentPlaylistIndex(0);
    setPlayingDecisionAnswer(true);
    setShowingOverlay(false);
    setIsAtEnd(false);
    resetDecisions();
  };
  const shouldShowQuestionOverlay = () => {
    return videoDecisions && showOverlay && !showFeedback && videoDecisions[currentPlaylistIndex] && (videoDecisions[currentPlaylistIndex].questionText || isAtEnd);
  };
  const startVideo = () => {
    window.jwplayer().play();
    setShowStartFeedback(false);
  };
  if (!token) {
    return /*#__PURE__*/React$1.createElement("div", {
      className: "video"
    }, /*#__PURE__*/React$1.createElement("div", {
      className: "spinner-table small",
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React$1.createElement(Spinner, null)));
  } else if (!token.videoId) {
    return /*#__PURE__*/React$1.createElement("div", {
      className: "video"
    }, subject.title, " video not available.");
  } else {
    const playlist = token && `https://content.jwplatform.com/feeds/${token.videoId}.json${token.sig_feed}`;
    const customProps = getPlayerCustomProps();
    return Modernizr.video ? videoPlayerUrl ? /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(FlexDiv, {
      column: true,
      positionRelative: true
    }, shouldShowQuestionOverlay() && /*#__PURE__*/React$1.createElement(DecisionOverlay, {
      decisionQuestion: videoDecisions[currentPlaylistIndex],
      onAnswer: onAnswer,
      isAtEnd: isAtEnd
    }), showFeedback && !isPlayingDecisionAnswer && /*#__PURE__*/React$1.createElement(DecisionFeedback, {
      subject: subject,
      showAnswerVideo: showAnswerVideo,
      tryAgain: tryAgainDecisionSubject
    }), showStartFeedback && /*#__PURE__*/React$1.createElement(StartFeedback, {
      startDecisionsSubjectVideo: startVideo
    }), !rerender && /*#__PURE__*/React$1.createElement(ReactJWPlayer, {
      className: classnames('video-item', {
        'decision-video-item': subject.video_decisions
      }),
      image: subject.thumb,
      playerId: subject.slug || 'video-player',
      playerScript: videoPlayerUrl,
      licenseKey: "tbMPLx6pAOjLHsSbrqGJdPVygT90S8O71WG28+3dDJA=",
      playlist: playlist,
      width: "100%",
      aspectratio: "16:9",
      responsive: true,
      isAutoPlay: false,
      onSetupError: () => onSetupError(),
      onError: () => onError(),
      allowFullscreen: false,
      onTwentyFivePercent: () => logEvent(subject, CONSTANTS.EVENTS.VIDEO_25),
      onFiftyPercent: () => logEvent(subject, CONSTANTS.EVENTS.VIDEO_50),
      onSeventyFivePercent: () => logEvent(subject, CONSTANTS.EVENTS.VIDEO_75),
      onNinetyFivePercent: () => {
        handleNinetyFivePercent();
        logEvent(subject, CONSTANTS.EVENTS.VIDEO_95);
      },
      onOneHundredPercent: () => logEvent(subject, CONSTANTS.EVENTS.VIDEO_100),
      onPlay: () => {
        logEvent(subject, CONSTANTS.EVENTS.VIDEO_START, token);
        setIsPaused(false);
        //subject.isStarted();
      },
      onResume: () => {
        setIsPaused(false);
      },
      onPause: () => {
        setIsPaused(true);
      },
      onReady: () => {
        setCaptionsLanguage();
        setIsReady(true);
        setShowStartFeedback(subject.type === 3 && !isAtEnd && !showFeedback && !isPlayingDecisionAnswer && !subject.hasBeenTried);
        if (isPlayingDecisionAnswer) {
          window.jwplayer().play();
        }
      },
      customProps: customProps
    })), subject.type === 3 && isReady && /*#__PURE__*/React$1.createElement(DecisionPlayerProgressbar, {
      counter: counter,
      totalLength: isPlayingDecisionAnswer ? subject.answerSubjectLength : videoDecisions && videoDecisions[currentPlaylistIndex] && videoDecisions[currentPlaylistIndex].longestDecisionTree
    }), shouldShowQuestionOverlay() && /*#__PURE__*/React$1.createElement(DecisionOverlayMobile, {
      decisionQuestion: videoDecisions[currentPlaylistIndex],
      onAnswer: onAnswer,
      isAtEnd: isAtEnd
    }), showStartFeedback && /*#__PURE__*/React$1.createElement(StartFeedbackMobile, {
      startDecisionsSubjectVideo: startVideo
    }), showFeedback && /*#__PURE__*/React$1.createElement(DecisionFeedbackMobile, {
      subject: subject,
      showAnswerVideo: showAnswerVideo,
      tryAgain: tryAgainDecisionSubject
    })) : null : /*#__PURE__*/React$1.createElement("div", {
      className: "alert alert-danger"
    }, t('Your browser does not currently recognize any of the video formats available'));
  }
});

const Video = observer(({
  ui,
  videoTokenRequested,
  videoPlayerUrl,
  token,
  playerPresetCaptionsLanguage,
  playerCaptionsSettings
}) => {
  useTranslation('assessment');
  const logEvent = (subject, event_id, context, options) => {};
  return /*#__PURE__*/React$1.createElement("div", {
    className: "assessment-presentation"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React$1.createElement(PresentationHeading$1, {
    ui: ui
  }), ui.subject ? /*#__PURE__*/React$1.createElement(VideoPlayer, {
    videoTokenRequested: videoTokenRequested,
    token: token && token.token,
    videoPlayerUrl: videoPlayerUrl,
    subject: ui.subject,
    logEvent: logEvent,
    presetCaptionsLanguage: playerPresetCaptionsLanguage,
    captionsSettings: playerCaptionsSettings
  }) : /*#__PURE__*/React$1.createElement("p", null, "Failed to load player, no subject supplied")));
});

const Dot = styled.div`
    background-color: ${props => props.color};
    border-radius: 50%;
    width: ${props => props.dotSize}px;
    height: ${props => props.dotSize}px;
    margin-right: 4px;
`;
const ColoredText = styled.span`
    color: ${props => props.color};
    font-size: ${props => props.fontSize}px;
    line-height: normal;
    font-weight: 700;
`;
const LegendDiv = styled.div`
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;

    ${props => props.fullWidth && css`
            width: 100%;
            justify-content: space-between;
        `}

    .legend-text {
        margin-right: 15px;
        display: flex;
        align-items: baseline;
    }
`;
const fiveColorLegend = [{
  color: palette.evergreen.aspargus,
  text: 'Excellent',
  interval: '90-100'
}, {
  color: palette.evergreen.lime,
  text: 'Very good',
  interval: '75-89'
}, {
  color: palette.vibrant.gold,
  text: 'Fair',
  interval: '50-74'
}, {
  color: palette.vibrant.orange,
  text: 'Risky',
  interval: '25-49'
}, {
  color: palette.vibrant.red,
  text: 'Very risky',
  interval: '0-24'
}];
function generateLegend(stepCount) {
  if (stepCount === 2) return [fiveColorLegend[0], fiveColorLegend[4]];
  if (stepCount === 3) return [fiveColorLegend[0], fiveColorLegend[2], fiveColorLegend[4]];
  if (stepCount === 5) return fiveColorLegend;
  return null;
}
function Legend({
  stepCount = 0,
  fontSize = 10,
  dotSize = 8,
  fullWidth = false,
  vertical = false
}) {
  let legend = generateLegend(stepCount);
  if (legend) {
    return vertical ? /*#__PURE__*/React$1.createElement(FlexDiv, {
      column: true,
      fullWidth: true,
      mt: 8
    }, legend.map((score, i) => /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
      key: i,
      mb: 16
    }, /*#__PURE__*/React$1.createElement(FlexDiv, {
      gap: 8
    }, /*#__PURE__*/React$1.createElement(Dot, {
      color: score.color,
      dotSize: dotSize
    }), /*#__PURE__*/React$1.createElement(ColoredText, {
      color: score.color,
      fontSize: fontSize
    }, score.text)), /*#__PURE__*/React$1.createElement(ColoredText, {
      color: score.color,
      fontSize: fontSize
    }, score.interval)))) : /*#__PURE__*/React$1.createElement(LegendDiv, {
      fullWidth: fullWidth
    }, legend.map((l, i) => /*#__PURE__*/React$1.createElement("div", {
      className: "legend-text",
      key: i
    }, /*#__PURE__*/React$1.createElement(Dot, {
      color: l.color,
      dotSize: dotSize
    }), /*#__PURE__*/React$1.createElement(ColoredText, {
      color: l.color,
      fontSize: fontSize
    }, l.text))));
  }
  return null;
}

const BlockAnswer = observer(({
  blockAnswers,
  hideBlock = false,
  question,
  calculateColor,
  legendStepCount,
  blockType,
  additionalText
}) => {
  const {
    t
  } = useTranslation('assessment');
  const scorePercentage = blockAnswers && blockAnswers.userAnswer ? blockAnswers.userAnswer.resolution.percentage : 0;
  if (blockAnswers && blockAnswers.answerText) {
    const description = blockAnswers.answerText.description ? sanitizeHtml(blockAnswers.answerText.description, {
      allowedTags: ['strong', 'p']
    }) : blockAnswers.answerText.description_key;
    let correctQuestionCount = 0;
    if (blockAnswers.correctAnswer) {
      if (blockType !== 'groupOfBlocks') {
        Object.keys(blockAnswers.correctAnswer).forEach(optionId => {
          if (blockAnswers.userAnswer[optionId] && blockAnswers.userAnswer[optionId].value === blockAnswers.correctAnswer[optionId].value) {
            correctQuestionCount++;
          }
        });
      } else {
        /** For the 'groupOfBlocks' block type, we need to drill down one extra level from the group -> groupId -> optionId
         * Example:
         *
         * correctAnswer: {
         *   "check_for_updates": {
         *     "once_a_day": {
         *       "value": "once_a_day",
         *       "score": 100
         *     }
         *   },
         *   ...
         * }
         *
         * userAnswer: {
         *   "check_for_updates": {
         *     "action_id": "updates_center_form[check_for_updates]",
         *     "question_id": 63,
         *     "value": "once_a_day",
         *     "score": 100,
         *     "details": {}
         *   },
         *   ...
         * }*/
        Object.keys(blockAnswers.correctAnswer).forEach(groupId => {
          Object.keys(blockAnswers.correctAnswer[groupId]).forEach(optionId => {
            if (blockAnswers.userAnswer[groupId] && blockAnswers.userAnswer[groupId].value === blockAnswers.correctAnswer[groupId][optionId].value) {
              correctQuestionCount++;
            }
          });
        });
      }
    }
    let headingText = blockAnswers.answerText.heading || blockAnswers.userAnswer && blockAnswers.userAnswer.resolution.heading || '';
    let answerResolutionHeading;
    if ( /**Display the '0∕2 correct answers.' type answer heading */
    headingText === 'correct_answers' && blockAnswers.correctAnswer) {
      answerResolutionHeading = t('correct_answers', {
        count: `${correctQuestionCount}∕${Object.keys(blockAnswers.correctAnswer).length}`
      });
    } else if ( /** Display the '0∕2 correct answers and 1 wrong.' type answer heading if there is a wrong selection involved */
    headingText === 'correct_and_wrong_answers' && blockAnswers.correctAnswer && blockAnswers.userAnswer) {
      /** blockAnswers.userAnswer can contain 'actions' and 'resolution' properties,
       * we only want the answers that have a value associated with them. */
      let userWrongAnswerCount = Object.keys(blockAnswers.userAnswer).filter(key => !!blockAnswers.userAnswer[key].value).filter(key => key !== 'select_none') /** A special case, for 'Conversation' question. So we don't say '0∕2 correct answers and 1 wrong.' when user selected none of the options but say '0∕2 correct answers.' instead. */.filter(x => !Object.keys(blockAnswers.correctAnswer).includes(x)).length;
      if (userWrongAnswerCount > 0) {
        answerResolutionHeading = t('correct_and_wrong_answers', {
          count: `${correctQuestionCount}∕${Object.keys(blockAnswers.correctAnswer).length}`,
          wrongCount: userWrongAnswerCount
        });
      } else {
        answerResolutionHeading = t('correct_answers', {
          count: `${correctQuestionCount}∕${Object.keys(blockAnswers.correctAnswer).length}`
        });
      }
    } else {
      answerResolutionHeading = t(headingText);
    }

    /** Special case for strings that include {details.missing}, replace that with translated details */
    if (headingText && headingText.includes('{details.missing}')) {
      answerResolutionHeading = headingText.substring(0, headingText.length - ' {details.missing}.'.length);
      answerResolutionHeading = t(answerResolutionHeading);
      if (blockAnswers.userAnswer) {
        const missingArray = blockAnswers.userAnswer.details.missing;
        let missingString = formatArrayToStringWithTranslation(missingArray);
        answerResolutionHeading += ' ' + missingString;
      }
    }

    // Create the string 'lowercase letters, numbers, or special characters'
    function formatArrayToStringWithTranslation(arr) {
      if (arr.length === 0) {
        return '';
      } else if (arr.length === 1) {
        return t(arr[0]);
      } else {
        const lastItem = arr.pop(); // Remove and store the last item
        const formattedArray = arr.map(item => t(item));
        const formattedString = formattedArray.join(', ') + ' ' + t('or') + ' ' + t(lastItem);
        return formattedString;
      }
    }
    return /*#__PURE__*/React$1.createElement("div", {
      className: classnames('question-answer-block', {
        'hide-arrow': hideBlock
      })
    }, /*#__PURE__*/React$1.createElement(Legend, {
      stepCount: legendStepCount
    }), /*#__PURE__*/React$1.createElement(Heading2, {
      bold: true,
      my: 8
    }, /*#__PURE__*/React$1.createElement("span", {
      style: {
        color: calculateColor ? calculateColor(scorePercentage) : '#054'
      }
    }, blockAnswers.userAnswer && (t(blockAnswers.userAnswer.resolution.text) || t(blockAnswers.userAnswer.resolution.prefix))), answerResolutionHeading), !hideBlock && blockAnswers.userAnswer &&
    /*#__PURE__*/
    //Don't show the action list when showing answers with the 'password' presentation
    React$1.createElement("div", {
      className: "question-answer-actions"
    }, blockAnswers.userAnswer.actions && blockAnswers.userAnswer.actions.length > 0 && /*#__PURE__*/React$1.createElement(TextLabel, {
      bold: true
    }, t('ACTIONS')), blockAnswers.userAnswer.actions && blockAnswers.userAnswer.actions.length > 0 && blockAnswers.userAnswer.actions.map((action, i) => {
      return action && /*#__PURE__*/React$1.createElement("div", {
        className: classnames('action', {
          incorrect: action.type === 'incorrect'
        }, {
          correct: action.type === 'correct'
        }),
        key: 'action-' + i
      }, t(action.text), ' ');
    })), blockAnswers.answerText.details && /*#__PURE__*/React$1.createElement("div", {
      className: "question-answer-actions"
    }, /*#__PURE__*/React$1.createElement(TextLabel, {
      bold: true,
      className: "details-header"
    }, t(blockAnswers.answerText.details.header)), /*#__PURE__*/React$1.createElement("ol", null, blockAnswers.answerText.details.items.map((item, i) => {
      return /*#__PURE__*/React$1.createElement("li", {
        className: classnames('action'),
        key: 'option-' + i
      }, t(item.text), /*#__PURE__*/React$1.createElement("span", null, t(item.description)));
    }))), blockAnswers.passwordCriteria && /*#__PURE__*/React$1.createElement("div", {
      className: "question-answer-actions"
    }, /*#__PURE__*/React$1.createElement(TextLabel, {
      bold: true
    }, t('CRITERIA')), blockAnswers.passwordCriteria.map((criteria, i) => {
      return /*#__PURE__*/React$1.createElement("div", {
        className: classnames('action', {
          incorrect: !criteria.contains
        }, {
          correct: criteria.contains
        }),
        key: 'criteria-' + i
      }, t(criteria.text));
    })), /*#__PURE__*/React$1.createElement(Trans, {
      defaults: question && question.personalizedKeysActions && question.personalizedKeysActions.some(key => key.action === 'mutateEmail') ? t(blockAnswers.answerText.description_key, {
        fakeEmailAddress: question.ui.presentation.email.from_address
      }) : t(blockAnswers.answerText.description_key) || t(description),
      components: {
        strong: /*#__PURE__*/React$1.createElement("strong", null),
        b: /*#__PURE__*/React$1.createElement("strong", null),
        p: /*#__PURE__*/React$1.createElement(TextDefault, {
          mt: 8,
          color: palette.lightroom.heavyMetalLight
        })
      }
    }), additionalText && /*#__PURE__*/React$1.createElement(Trans, {
      defaults: t(additionalText),
      components: {
        strong: /*#__PURE__*/React$1.createElement("strong", null),
        b: /*#__PURE__*/React$1.createElement("strong", null),
        p: /*#__PURE__*/React$1.createElement(TextDefault, {
          mt: 8,
          color: palette.lightroom.heavyMetalLight
        })
      }
    }));
  } else {
    return null;
  }
});

const useStyles$3 = makeStyles(() => ({
  assessmentFormControlLabel: {
    padding: '12px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 8px rgba(29, 30, 29, 0.06)',
    border: '2px solid rgba(#1D1E1D, 0)',
    borderRadius: '4px',
    transition: 'ease 0.2s all',
    '&:hover': {
      boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.08), 0px 4px 24px rgba(29, 30, 29, 0.08)'
    },
    '&.active': {
      border: '0px 0px 4px rgba(29, 30, 29, 0.08)'
    },
    '&.selected': {
      border: '2px solid rgba(#1D1E1D, 0.8)'
    }
  },
  incorrect: {
    border: '2px solid ' + palette.lightroom.redLight,
    backgroundColor: palette.lightroom.redLightHigh,
    '& .MuiTypography-root': {
      color: palette.vibrant.red,
      fontWeight: 700
    },
    '& .MuiRadio-root': {
      background: "url('/static/img/assessment/icon-incorrect.svg') no-repeat center center",
      color: 'transparent'
    }
  },
  somewhatCorrect: {
    border: '2px solid ' + palette.vibrant.gold,
    backgroundColor: palette.lightroom.goldLightHigh,
    '& .MuiTypography-root': {
      color: palette.vibrant.gold,
      fontWeight: 700
    },
    '& .MuiRadio-root': {
      background: "url('/static/img/assessment/icon-somewhat-incorrect.svg') no-repeat center center",
      color: 'transparent'
    }
  },
  correct: {
    '& .MuiRadio-root': {
      background: "url('/static/img/assessment/icon-correct.svg') no-repeat center center",
      color: 'transparent'
    }
  },
  userCorrect: {
    border: '2px solid ' + palette.lightroom.aspargusLight,
    backgroundColor: palette.lightroom.aspargusLightHigh,
    '& .MuiTypography-root': {
      color: palette.evergreen.aspargus,
      fontWeight: 700
    }
  },
  correctButIrrelevant: {
    border: '2px solid ' + palette.lightroom.heavyMetalLight,
    '& .MuiTypography-root': {
      color: palette.graphite.heavyMetal,
      fontWeight: 700
    },
    '& .MuiRadio-root': {
      background: "url('/static/img/assessment/icon-correct-but-irrelevant.svg') no-repeat center center",
      color: 'transparent'
    }
  }
}));
var AnswerableCheckbox = observer(({
  onChange,
  groupValue,
  value,
  text,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  const classes = useStyles$3();
  if (!answer) {
    return /*#__PURE__*/React$1.createElement(FormControlLabel$1, {
      className: classnames([classes.assessmentFormControlLabel], {
        selected: (groupValue || []).includes(value)
      }),
      control: /*#__PURE__*/React$1.createElement(Checkbox$1, {
        checked: (groupValue || []).includes(value),
        onChange: e => onChange(e, value),
        color: "primary"
      }),
      label: t(text)
    });
  } else {
    return /*#__PURE__*/React$1.createElement(FormControlLabel$1, {
      className: classnames('Mui-disabled', [classes.assessmentFormControlLabel], {
        [classes.correct]: answer.correctAnswer[value] && answer.correctAnswer[value].score > 0,
        [classes.userCorrect]: answer.correctAnswer[value] && answer.userAnswer[value] && answer.correctAnswer[value].score > 0,
        [classes.correctButIrrelevant]: answer.correctAnswer[value] && answer.userAnswer[value] && answer.correctAnswer[value].score <= 0,
        [classes.incorrect]: answer.userAnswer[value] && !answer.correctAnswer[value]
      }),
      disabled: true,
      control: /*#__PURE__*/React$1.createElement(Radio, {
        color: "primary"
      }),
      label: t(text)
    });
  }
});

const CheckBoxes = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  useTranslation('assessment');
  const onChange = (event, boxVal) => {
    let val = [...(value || [])];
    if (event.target.checked) {
      if (!val.includes(boxVal)) val.push(boxVal);
    } else {
      val = val.filter(x => x !== boxVal);
    }
    handleChange(val, null, null, true);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "section-exam"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement(FormControl, {
    component: "fieldset"
  }, ui.options.map((v, i) => {
    return /*#__PURE__*/React$1.createElement(AnswerableCheckbox, {
      onChange: onChange,
      groupValue: value,
      key: 'checkbox-' + i,
      value: v.value,
      text: v.text,
      answer: answer
    });
  })))));
});

const Divider = styled.div`
    display: flex;
    align-items: center;
    text-align: center;

    &::before,
    &::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid ${palette.lightroom.heavyMetalLightHigh};
    }

    &:not(:empty)::before {
        margin-right: 0.25em;
    }
    &:not(:empty)::after {
        margin-left: 0.25em;
    }
`;
function DividerWithContent({
  items,
  onClick
}) {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement(Divider, {
    onClick: () => onClick(items.map(a => a.value))
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    borderRadius: 50,
    border: true,
    py: 4,
    px: 8,
    link: true
  }, /*#__PURE__*/React$1.createElement(TextTiny, null, /*#__PURE__*/React$1.createElement(UnfoldMore, {
    fontSize: "small"
  }), items.length, " ", t(pluralize('message', items.length)), ' ')));
}

function ConversationItem({
  ui,
  node,
  onChange,
  groupValue,
  value,
  answer
}) {
  const {
    t
  } = useTranslation('assessment');
  const isCorrect = () => {
    return answer && answer.correctAnswer[value] && answer.correctAnswer[value].score > 0;
  };
  const isUserCorrect = () => {
    return answer && answer.correctAnswer[value] && answer.userAnswer[value] && answer.correctAnswer[value].score > 0;
  };
  const isIncorrect = () => {
    return answer && answer.userAnswer[value] && !answer.correctAnswer[value];
  };
  return /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
    gap: 16,
    alignEnd: true
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    gap: 8,
    rowReverse: node.side === 'right',
    $noWrap: true,
    alignEnd: true,
    pl: node.side === 'right' && 40,
    pr: node.side === 'left' && 40,
    flexGrow: 2,
    mr: answer && !isCorrect() && !isUserCorrect() && !isIncorrect() && 36,
    borderTop: node.isSelectNoneCheckbox && !answer,
    mt: node.isSelectNoneCheckbox && 24,
    py: node.isSelectNoneCheckbox && !answer && 24
  }, !node.isSelectNoneCheckbox &&
  /*#__PURE__*/
  //If this is a 'select none' checkbox, we don't want a thumb
  React$1.createElement(Image$1, {
    alt: t(`person on the ${node.side}`),
    src: resourcePath(ui[`${node.side}Thumb`]),
    width: 32,
    height: 32,
    borderRadius: 50,
    border: true
  }), !node.isSelectNoneCheckbox ?
  /*#__PURE__*/
  //Display the 'speech bubble' like checkbox label
  React$1.createElement(SpeechBubbleInput, {
    label: t(node.text),
    groupValue: groupValue,
    value: value,
    side: node.side,
    isUserCorrect: isUserCorrect(),
    isIncorrect: isIncorrect(),
    isAnswer: !!answer,
    onChange: e => onChange(e, value, false, 'select_none')
  }) :
  /*#__PURE__*/
  /** Display the 'select none' checkbox. */
  React$1.createElement(UnStyledCheckboxInput, {
    label: t(node.text),
    groupValue: groupValue,
    value: value,
    isUserCorrect: isUserCorrect(),
    isIncorrect: isIncorrect(),
    isAnswer: !!answer,
    onChange: e => {
      onChange(e, value, true);
    }
  })), (isCorrect() || isUserCorrect()) && /*#__PURE__*/React$1.createElement(TextDefault, {
    color: palette.evergreen.aspargus
  }, /*#__PURE__*/React$1.createElement(MuiCheckCircle, {
    fontSize: "small"
  })), isIncorrect() && /*#__PURE__*/React$1.createElement(TextDefault, {
    color: palette.vibrant.red
  }, /*#__PURE__*/React$1.createElement(CancelIcon, {
    fontSize: "small"
  })));
}
var ConversationItem$1 = observer(ConversationItem);

const Conversation = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  const [expandedConversationItems, expandConversationItemsGroup] = useState([]);
  const generateDisplayArray = () => {
    /** If we are not showing answers, we are showing the question and should show all conversation options */
    if (!answer) return ui.options;
    let display = [];
    const relevantConversationItems = {
      ...answer.correctAnswer,
      ...answer.userAnswer
    };
    let groupOfHiddenConversationItems = [];
    ui.options.map((option, i) => {
      /** A 'select_none' option, that is not relevant, should not be part of the answer shown to the user */
      if (!relevantConversationItems[option.value] && option.value === 'select_none') {
        return false;
      }
      /** If it is neither a relevant conversation item nor in a group we have expanded, we hide it (add it to a group)*/
      if (!relevantConversationItems[option.value] && expandedConversationItems.indexOf(option.value) < 0) {
        groupOfHiddenConversationItems.push(option);
      } else {
        if (groupOfHiddenConversationItems.length > 0) {
          display.push(groupOfHiddenConversationItems);
          groupOfHiddenConversationItems = [];
        }
        display.push(option);
      }
    });
    /** At the end we push the last group to our display array, if any */
    if (groupOfHiddenConversationItems.length > 0) {
      display.push(groupOfHiddenConversationItems);
    }
    return display;
  };
  const data = useMemo(() => generateDisplayArray(), [expandedConversationItems.length]);
  useTranslation('assessment');
  const onChange = (event, boxVal, shouldOverrideAllOthers = false, doOverrideValue = null) => {
    if (answer) return;
    let val = [...(value || [])];
    if (event.target.checked) {
      if (!val.includes(boxVal)) {
        /** Normally we just add this new block value to existing values, but if 'There were no potentially
         * sensitive information being exchanged.' was selected we override all others with the given value. */
        if (shouldOverrideAllOthers) {
          val = [boxVal];
        } else {
          val.push(boxVal);
          /** ...and for every other option selected, we remove the 'select_all' checkmark/value*/
          if (doOverrideValue) {
            val = val.filter(x => x !== doOverrideValue);
          }
        }
      }
    } else {
      val = val.filter(x => x !== boxVal);
    }
    handleChange(val, null, null, true);
  };
  const onExpand = itemsToExpand => {
    expandConversationItemsGroup(expandedConversationItems.concat(itemsToExpand));
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    gap: 8
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    gap: 8
  }, data.map((node, i) => {
    return Array.isArray(node) ? /*#__PURE__*/React$1.createElement(DividerWithContent, {
      key: 'divider-' + i,
      items: node,
      onClick: onExpand
    }) : /*#__PURE__*/React$1.createElement(ConversationItem$1, {
      onChange: onChange,
      groupValue: value,
      key: 'item-' + i,
      value: node.value,
      answer: answer,
      ui: ui,
      node: node
    });
  })))));
});

const Decision = observer(({
  ui,
  handleChange,
  enableAssessmentFinish,
  value,
  videoTokenRequested,
  videoPlayerUrl,
  token,
  playerPresetCaptionsLanguage,
  playerCaptionsSettings
}) => {
  const onChange = (decisionQuestionId, decision) => {
    if (decision) {
      let val = value || {};
      val[decisionQuestionId] = decision.key;
      handleChange(val, null, null, true);
    }
  };
  const logEvent = (subject, event_id, context, options) => {};
  return /*#__PURE__*/React$1.createElement("div", {
    className: "section-exam"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), ui.subject && ui.subject.type === 3 ? /*#__PURE__*/React$1.createElement(VideoPlayer, {
    videoTokenRequested: videoTokenRequested,
    token: token && token.token,
    videoPlayerUrl: videoPlayerUrl,
    onChange: onChange,
    enableAssessmentFinish: enableAssessmentFinish,
    subject: ui.subject,
    logEvent: logEvent,
    presetCaptionsLanguage: playerPresetCaptionsLanguage,
    captionsSettings: playerCaptionsSettings,
    isAssessment: true
  }) : /*#__PURE__*/React$1.createElement("p", null, "Failed to load player, no subject supplied"))));
});

const DecisionAnswers = observer(({
  ui,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  return /*#__PURE__*/React$1.createElement("div", {
    className: "section-exam"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, Object.keys(ui.decisions).sort((a, b) => ui.decisions[a].order - ui.decisions[b].order).map((decisionKey, i) => {
    return answer && answer.userAnswer[decisionKey] && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, i > 0 && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement("br", null)), /*#__PURE__*/React$1.createElement("div", {
      className: 'assessment-question'
    }, /*#__PURE__*/React$1.createElement(Heading2, {
      bold: true
    }, t(ui.decisions[decisionKey].question)), /*#__PURE__*/React$1.createElement(FormControl, {
      component: "fieldset"
    }, /*#__PURE__*/React$1.createElement(RadioGroup, {
      "aria-label": "email",
      name: "email",
      value: ''
    }, ui.decisions[decisionKey].options.map((decisionOption, i) => {
      return /*#__PURE__*/React$1.createElement(AnswerableRadioButton, {
        key: 'radio-' + i,
        groupValue: 'value',
        value: decisionOption.value,
        text: decisionOption.text,
        answer: answer,
        decisionKey: decisionKey
      });
    })))));
  })));
});

const GroupOfBlocks = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  return /*#__PURE__*/React$1.createElement(GroupOfBlocksHTML, {
    ui: ui,
    handleChange: handleChange,
    value: value,
    answer: answer
  });
});

const SocialPost = observer(({
  socialPostData
}) => {
  const {
    t
  } = useTranslation('assessment');
  const [imageZoomed, setIsImageZoomed] = React$1.useState(false);
  const handleImageClick = () => {
    setIsImageZoomed(!imageZoomed);
  };
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, socialPostData.type === 'linkedin' && /*#__PURE__*/React$1.createElement("div", {
    className: 'post_linkedin'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'post_header'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'left'
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(socialPostData.human_profile_image),
    alt: t('Profile')
  })), /*#__PURE__*/React$1.createElement("div", {
    className: 'right'
  }, /*#__PURE__*/React$1.createElement("h3", null, t(socialPostData.human_name), ' ', /*#__PURE__*/React$1.createElement("span", null, ' ', "\u2022 ", t(socialPostData.human_connection))), /*#__PURE__*/React$1.createElement("p", null, t(socialPostData.human_subtitle)), /*#__PURE__*/React$1.createElement("p", null, t(socialPostData.age)))), /*#__PURE__*/React$1.createElement("div", {
    className: 'post_main'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'post_text'
  }, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t(socialPostData.text)
  })), socialPostData.imageZoom && /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(socialPostData.image),
    alt: t('illustration'),
    link: true,
    fullWidth: true,
    onClick: handleImageClick
  }), !socialPostData.imageZoom && socialPostData.image && /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(socialPostData.image),
    alt: t('illustration'),
    fullWidth: true
  }), /*#__PURE__*/React$1.createElement("div", {
    className: 'post_feedback'
  }, t(socialPostData.like_count), " \u2022", ' ', t(socialPostData.comment_count), " ", t('Comments')))), socialPostData.type === 'facebook' && /*#__PURE__*/React$1.createElement("div", {
    className: 'post_facebook'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'post_header'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'left'
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(socialPostData.human_profile_image),
    alt: t('Profile')
  })), /*#__PURE__*/React$1.createElement("div", {
    className: 'right'
  }, /*#__PURE__*/React$1.createElement("h3", null, t(socialPostData.human_name), ' ', /*#__PURE__*/React$1.createElement("span", null, ' ', "\u2022 ", t(socialPostData.human_feeling))), /*#__PURE__*/React$1.createElement("p", null, t(socialPostData.human_subtitle)), /*#__PURE__*/React$1.createElement("p", null, t(socialPostData.age)))), /*#__PURE__*/React$1.createElement("div", {
    className: 'post_main'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'post_text'
  }, /*#__PURE__*/React$1.createElement(DefaultTrans, {
    translatedString: t(socialPostData.text)
  })), socialPostData.imageZoom && /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(socialPostData.image),
    alt: t('illustration'),
    link: true,
    fullWidth: true,
    onClick: handleImageClick
  }), !socialPostData.imageZoom && socialPostData.image && /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(socialPostData.image),
    alt: t('illustration'),
    fullWidth: true
  }), /*#__PURE__*/React$1.createElement("div", {
    className: 'post_feedback facebook'
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'left'
  }, t(socialPostData.like_count)), /*#__PURE__*/React$1.createElement("div", {
    className: 'right'
  }, t(socialPostData.comment_count), ' ', t('Comments'))))), /*#__PURE__*/React$1.createElement("div", {
    className: "image-zoomed",
    onClick: handleImageClick,
    style: {
      opacity: imageZoomed ? '1' : '0',
      visibility: imageZoomed ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    src: resourcePath(socialPostData.imageZoom),
    alt: t('illustration'),
    onClick: handleImageClick
  })));
});

const NumericalScale = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  const [showLabels, setShowLabels] = React$1.useState(true);
  const handleToggle = (event, newValue) => {
    handleChange(newValue);
    if (newValue) {
      hideLabel();
    } else {
      showLabel();
    }
  };
  const showLabel = () => {
    setShowLabels(true);
  };
  const hideLabel = () => {
    setShowLabels(false);
  };
  useEffect(() => {
    showLabel();
  }, [ui]);
  return /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, ui.image && /*#__PURE__*/React$1.createElement("div", {
    className: "image-fullwidth"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: resourcePath(ui.image),
    alt: "illustration"
  })), /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement(ToggleButtonGroup, {
    className: classnames('numerical-scale ', {
      showLabels: showLabels
    }, {
      [`score-${answer && answer.userAnswer && answer.userAnswer.score}`]: answer && answer.userAnswer
    }),
    onChange: handleToggle,
    value: value || answer && answer.userAnswer.value,
    exclusive: true,
    "aria-label": "numerical scale"
  }, ui.options.map((v, i) => {
    return /*#__PURE__*/React$1.createElement(ToggleButton, {
      className: classnames('numerical-scale-button', {
        'Mui-disabled': !!answer,
        answer: !!answer,
        question: !answer
      }),
      key: 'select-' + i,
      "aria-label": v.value,
      value: v.value
    }, ' ', t(v.text), /*#__PURE__*/React$1.createElement("label", null, t(v.label)));
  }))));
});

var arrayMove$2 = {exports: {}};

const arrayMoveMutate = (array, from, to) => {
	const startIndex = from < 0 ? array.length + from : from;

	if (startIndex >= 0 && startIndex < array.length) {
		const endIndex = to < 0 ? array.length + to : to;

		const [item] = array.splice(from, 1);
		array.splice(endIndex, 0, item);
	}
};

const arrayMove = (array, from, to) => {
	array = [...array];
	arrayMoveMutate(array, from, to);
	return array;
};

arrayMove$2.exports = arrayMove;
arrayMove$2.exports.mutate = arrayMoveMutate;

var arrayMoveExports = arrayMove$2.exports;
var arrayMove$1 = /*@__PURE__*/getDefaultExportFromCjs(arrayMoveExports);

const useStyles$2 = makeStyles(() => ({
  listNumber: {
    background: '#e4f1ec',
    borderRadius: '10px',
    height: '20px',
    width: '20px',
    color: palette.evergreen.aspargus,
    fontWeight: 'bold',
    fontSize: '10px',
    lineHeight: '20px',
    textAlign: 'center'
  },
  listItemText: {
    margin: '0 0 0 10px',
    padding: '15px 10px',
    background: '#fff',
    boxShadow: '0 0 2px rgba(0,0,0,.08)',
    borderRadius: '4px',
    flex: '1 1 auto',
    minWidth: '0',
    '& .MuiListItemText-primary': {
      overflowWrap: 'break-word',
      marginRight: '0',
      maxWidth: '60%'
    }
  },
  orderableListArrows: {
    marginRight: '35px',
    display: 'flex'
  },
  arrowButton: {
    background: 'none',
    //border: 1px solid #1D1E1D;
    boxShadow: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none'
    },
    disabled: {
      opacity: 0.2
    }
  },
  orderableListArrow: {
    border: '1px solid #efefef',
    borderRadius: '50%',
    width: '40px',
    '&.MuiFab-sizeSmall': {
      '@media (max-width: 992px)': {}
    },
    '@media (max-width: 992px)': {
      transform: 'scale(0.8)'
    }
  },
  secondaryAction: {
    top: '50%',
    right: '16px',
    position: 'absolute',
    transform: 'translateY(-50%)'
  },
  dragHandle: {
    position: 'absolute',
    top: '8px'
  },
  dragHandleContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    minWidth: '50px'
  },
  answerIcon: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    top: '-10px',
    left: '-70px',
    '&.incorrect': {
      background: "url('/static/img/assessment/icon-incorrect.svg') no-repeat left center"
    },
    '&.correct': {
      background: "url('/static/img/assessment/icon-correct.svg') no-repeat left center"
    }
  }
}));
const OrderableList = observer(({
  ui,
  handleChange,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  const classes = useStyles$2();
  const shuffleArray = array => {
    const arrayCopy = [...array];
    arrayCopy.map((value, i) => {
      return {
        id: i + 1,
        value: value.value,
        text: value.text
      };
    });
    for (let i = arrayCopy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arrayCopy[i], arrayCopy[j]] = [arrayCopy[j], arrayCopy[i]];
    }
    return arrayCopy;
  };
  const pickFromAnswer = (array, userOrder) => {
    const arrayCopy = [...array];
    arrayCopy.map((value, i) => {
      return {
        id: i + 1,
        value: value.value,
        text: value.text
      };
    });
    const resultArray = [];
    userOrder.forEach(value => {
      resultArray.push(arrayCopy.find(obj => obj.value === value));
    });
    return resultArray;
  };

  //const [items, setItems] = useState(answer ? pickFromAnswer(ui.options, JSON.parse(answer.userAnswer.value)) : shuffleArray(ui.options));
  const [items, setItems] = useState(answer && answer.userAnswer.value ? pickFromAnswer(ui.options, JSON.parse(answer.userAnswer.value)) : shuffleArray(ui.options));
  useEffect(() => {
    if (handleChange) handleChange(getItemsValues());
  }, [items]);
  const onDrop = ({
    removedIndex,
    addedIndex
  }) => {
    setItems(items => arrayMove$1(items, removedIndex, addedIndex));
  };
  const onMoveUp = index => {
    if (index > 0) {
      onDrop({
        removedIndex: index,
        addedIndex: index - 1
      });
    }
  };
  const onMoveDown = (index, itemsLength) => {
    if (index < itemsLength) {
      onDrop({
        removedIndex: index,
        addedIndex: index + 1
      });
    }
  };
  const getItemsValues = () => {
    let result = [];
    items.forEach((item, i) => {
      result[i] = item.value;
    });
    return result;
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), !answer ? /*#__PURE__*/React$1.createElement(List, null, /*#__PURE__*/React$1.createElement(Container, {
    dragHandleSelector: ".drag-handle",
    lockAxis: "y",
    onDrop: onDrop
  }, items.map((item, i) => /*#__PURE__*/React$1.createElement(Draggable, {
    key: i
  }, /*#__PURE__*/React$1.createElement(ListItem, null, /*#__PURE__*/React$1.createElement("div", {
    className: classnames(classes.listNumber)
  }, i + 1), /*#__PURE__*/React$1.createElement(ListItemText, {
    className: classnames(classes.listItemText),
    primary: t(item.text)
  }), /*#__PURE__*/React$1.createElement(ListItemSecondaryAction, {
    className: classnames(classes.secondaryAction)
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames(classes.orderableListArrows)
  }, /*#__PURE__*/React$1.createElement(ListItemIcon, {
    className: classnames({
      disabled: i === 0
    }),
    disabled: i === 0,
    onClick: () => onMoveUp(i)
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames(classes.orderableListArrow)
  }, /*#__PURE__*/React$1.createElement(Fab, {
    className: classnames(classes.arrowButton),
    size: 'small'
  }, /*#__PURE__*/React$1.createElement(ExpandLess, null)))), /*#__PURE__*/React$1.createElement(ListItemIcon, {
    className: classnames({
      disabled: i >= items.length
    }),
    disabled: i >= items.length,
    onClick: () => onMoveDown(i, items.length)
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames(classes.orderableListArrow)
  }, /*#__PURE__*/React$1.createElement(Fab, {
    size: 'small',
    className: classnames(classes.arrowButton)
  }, /*#__PURE__*/React$1.createElement(ExpandMore, null))))), /*#__PURE__*/React$1.createElement(ListItemIcon, {
    className: "drag-handle",
    style: {
      cursor: 'ns-resize'
    }
  }, /*#__PURE__*/React$1.createElement(DragHandleIcon, {
    className: classnames(classes.dragHandle)
  })))))))) : answer.userAnswer.value ? /*#__PURE__*/React$1.createElement(List, null, items.map((item, i) => /*#__PURE__*/React$1.createElement(ListItem, {
    key: i
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames(classes.listNumber)
  }, i + 1), /*#__PURE__*/React$1.createElement(ListItemText, {
    className: classnames(classes.listItemText),
    primary: t(item.text)
  }), /*#__PURE__*/React$1.createElement(ListItemSecondaryAction, null, answer.correctAnswer.value[i] === JSON.parse(answer.userAnswer.value)[i] && /*#__PURE__*/React$1.createElement("div", {
    className: classnames(classes.answerIcon, 'correct')
  }), answer.correctAnswer.value[i] !== JSON.parse(answer.userAnswer.value)[i] && /*#__PURE__*/React$1.createElement("div", {
    className: classnames(classes.answerIcon, 'incorrect')
  }))))) : /*#__PURE__*/React$1.createElement("p", null, t("You didn't answer this question."))));
});

const PasswordTester = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  useTranslation('assessment');
  const [passwordString, setPasswordString] = useState(value);
  const maxLength = 6;
  const onChange = event => {
    setPasswordString(event.target.value);
    handleChange(event.target.value);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "section-exam"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement(FormControl$1, {
    className: "password-tester-formcontrol"
  }, !answer ? /*#__PURE__*/React$1.createElement(TextField, {
    style: {
      background: '#FCFCFC'
    },
    id: "password-tester-password",
    helperText: `${passwordString ? passwordString.length : 0}/${maxLength}`,
    variant: "outlined",
    inputProps: {
      maxLength: maxLength
    },
    value: passwordString,
    onChange: onChange
  }) : /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(TextField, {
    style: {
      background: '#FCFCFC'
    },
    id: "password-tester-password",
    variant: "outlined",
    disabled: true,
    inputProps: {
      maxLength: maxLength
    },
    value: typeof answer.userAnswer.details === 'string' ? JSON.parse(answer.userAnswer.details).password : answer.userAnswer.details.password
  }), /*#__PURE__*/React$1.createElement("div", null))))));
});

const Questionwithsocialpost = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  const handleToggle = (event, newValue) => {
    handleChange(newValue);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement(SocialPost, {
    socialPostData: ui.socialpost
  }), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement(AnswerableToggleButtonGroup, {
    handleToggle: handleToggle,
    value: value,
    fullWidth: true
  }, ui.options.map((v, i) => {
    return /*#__PURE__*/React$1.createElement(AnswerableToggleButton, {
      key: 'select-' + i,
      name: 'select-' + i,
      value: v.value,
      text: t(v.text),
      answer: answer,
      selected: value === v.value,
      handleToggle: handleToggle,
      oneOf: ui.options.length //How many buttons in total, used to give them equal width
    });
  }))));
});

const Questionwithbuttons = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  const handleToggle = (event, newValue) => {
    handleChange(newValue);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question seperate-buttons'
  }, ui.image && /*#__PURE__*/React$1.createElement("div", {
    className: "image fullwidth"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: resourcePath(ui.image),
    alt: "illustration"
  })), /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement(AnswerableToggleButtonGroup, {
    handleToggle: handleToggle,
    value: value,
    fullWidth: true
  }, ui.options.map((v, i) => {
    return /*#__PURE__*/React$1.createElement(AnswerableToggleButton, {
      key: 'select-' + i,
      name: 'select-' + i,
      value: v.value,
      text: t(v.text),
      answer: answer,
      selected: value === v.value,
      handleToggle: handleToggle,
      oneOf: ui.options.length //How many buttons in total, used to give them equal width
    });
  }))));
});

const Questionwithimage = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  const [imageZoomed, setIsImageZoomed] = React$1.useState(false);
  const handleToggle = (event, newValue) => {
    handleChange(newValue);
  };
  const handleImageClick = () => {
    setIsImageZoomed(!imageZoomed);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement("div", {
    className: classnames('image', {
      clickable: ui.imageZoom
    })
  }, ui.imageZoom && /*#__PURE__*/React$1.createElement("img", {
    src: resourcePath(ui.image),
    alt: "illustration",
    onClick: handleImageClick
  }), !ui.imageZoom && /*#__PURE__*/React$1.createElement("img", {
    src: resourcePath(ui.image),
    alt: "illustration"
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "image-zoomed",
    onClick: handleImageClick,
    style: {
      opacity: imageZoomed ? '1' : '0',
      visibility: imageZoomed ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/React$1.createElement("img", {
    src: resourcePath(ui.imageZoom),
    alt: "illustration",
    onClick: handleImageClick
  })), /*#__PURE__*/React$1.createElement("br", null), /*#__PURE__*/React$1.createElement(AnswerableToggleButtonGroup, {
    handleToggle: handleToggle,
    value: value,
    fullWidth: true
  }, ui.options.map((v, i) => {
    return /*#__PURE__*/React$1.createElement(AnswerableToggleButton, {
      key: 'select-' + i,
      name: 'select-' + i,
      value: v.value,
      text: t(v.text),
      answer: answer,
      selected: value === v.value,
      handleToggle: handleToggle,
      oneOf: ui.options.length //How many buttons in total, used to give them equal width
    });
  }))));
});

const RadioButtons = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  const onChange = event => {
    handleChange(event.target.value);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "section-exam"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), /*#__PURE__*/React$1.createElement(RadioButtonsGroup, {
    radioOptions: ui.options,
    onChange: onChange,
    value: value,
    answer: answer
  }))));
});

// customizing styling of ToggleButton
const YesNoButton = withStyles$1(() => ({
  root: {
    fontSize: 12,
    padding: '0.5em 1em',
    textTransform: 'none'
  }
}))(ToggleButton);
const useStyles$1 = makeStyles(() => ({
  incorrect: {
    border: '2px solid ' + palette.lightroom.redLight,
    backgroundColor: palette.lightroom.redLightHigh,
    '& .MuiTypography-root': {
      color: palette.vibrant.red,
      fontWeight: 700
    }
  },
  userCorrect: {
    border: '2px solid ' + palette.lightroom.aspargusLight,
    backgroundColor: palette.lightroom.aspargusLightHigh,
    '& .MuiTypography-root': {
      color: palette.evergreen.aspargus,
      fontWeight: 700
    }
  }
}));
const YesNoList = observer(({
  ui,
  handleChange,
  value,
  answer
}) => {
  const {
    t
  } = useTranslation('assessment');
  const classes = useStyles$1();
  const [choices, setChoices] = useState(value);
  const handleToggle = (optionValue, yesNoString) => {
    setChoices(choices => ({
      ...choices,
      [optionValue]: yesNoString
    }));
  };
  useEffect(() => {
    if (choices) {
      //If the user has answered all we fire transition to next block
      if (Object.keys(choices).length === ui.questions.length) {
        handleChange(choices, ui.actionId, null, true);
      }
    }
  }, [choices]);
  useEffect(() => {
    setChoices(value);
  }, [ui]);
  const resolveValue = questionId => {
    if (!choices || !choices[questionId]) return null;
    return `${questionId}-${choices[questionId]}`;
  };
  const isSelected = (questionId, yesNoString) => {
    if (!choices || !choices[questionId]) return false;
    return choices[questionId] === yesNoString;
  };
  return /*#__PURE__*/React$1.createElement("div", {
    className: "section-exam"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classnames('assessment')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'assessment-question'
  }, /*#__PURE__*/React$1.createElement(QuestionHeading, {
    ui: ui
  }), ui.questions.map((question, i) => !answer ? /*#__PURE__*/React$1.createElement("div", {
    className: "yes-no-question"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: 'question'
  }, t(question.text)), /*#__PURE__*/React$1.createElement(ToggleButtonGroup, {
    value: resolveValue(question.actionId),
    "aria-label": question.value + '-group',
    style: {
      marginLeft: '1em'
    }
  }, /*#__PURE__*/React$1.createElement(YesNoButton, {
    className: 'yes-no-button',
    value: question.value + '-yes',
    selected: isSelected(question.actionId, 'yes'),
    onClick: e => handleToggle(question.actionId, 'yes'),
    "aria-label": 'Yes'
  }, t('Yes')), /*#__PURE__*/React$1.createElement(YesNoButton, {
    className: 'yes-no-button',
    value: question.value + '-no',
    selected: isSelected(question.actionId, 'no'),
    onClick: e => handleToggle(question.actionId, 'no'),
    "aria-label": 'No'
  }, t('No')))) : /*#__PURE__*/React$1.createElement(FormControlLabel, {
    className: classnames('Mui-disabled yes-no-question answer', {
      [classes.userCorrect]: answer.userAnswer[question.actionId] && answer.correctAnswer[question.actionId].value === answer.userAnswer[question.actionId].value,
      [classes.incorrect]: !answer.userAnswer[question.actionId] || answer.correctAnswer[question.actionId].value !== answer.userAnswer[question.actionId].value
    }),
    key: i,
    control: /*#__PURE__*/React$1.createElement(ToggleButtonGroup, {
      "aria-label": question.value + '-group',
      style: {
        marginLeft: '1em'
      }
    }, /*#__PURE__*/React$1.createElement(YesNoButton, {
      disabled: true,
      className: 'yes-no-button',
      selected: answer.userAnswer[question.actionId] && answer.userAnswer[question.actionId].value === 'yes',
      "aria-label": t('Yes')
    }, t('Yes')), /*#__PURE__*/React$1.createElement(YesNoButton, {
      disabled: true,
      className: 'yes-no-button',
      selected: answer.userAnswer[question.actionId] && answer.userAnswer[question.actionId].value === 'no',
      "aria-label": t('No')
    }, t('No'))),
    label: t(question.text),
    labelPlacement: "start"
  })), /*#__PURE__*/React$1.createElement(TextTiny, {
    color: palette.graphite.charcoal,
    style: {
      paddingTop: '12px',
      paddingLeft: '8px'
    }
  }, t('Please answer all questions')))));
});

var dist=function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=3)}([function(e,t){e.exports=React$1;},function(e,t){e.exports=propTypesExports;},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r,o=n(0);var i=((r=o)&&r.__esModule?r:{default:r}).default.createContext(null);t.default=i;},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.SvgLoader=t.SvgProxy=void 0;var r=i(n(4)),o=i(n(8));function i(e){return e&&e.__esModule?e:{default:e}}t.SvgProxy=o.default,t.SvgLoader=r.default;},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=s(n(0)),a=s(n(1)),l=s(n(5)),u=s(n(2));function s(e){return e&&e.__esModule?e:{default:e}}var c=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));if(n.mounted=!1,n.state={svg:null,svgCount:0},null==i.default.Fragment)throw new Error("This version of React doesn't support Fragments, please update it");return n.onSVGReady=n.onSVGReady.bind(n),n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}(t,e),o(t,[{key:"componentDidMount",value:function(){this.mounted=!0;}},{key:"componentWillUnmount",value:function(){this.mounted=!1;}},{key:"onSVGReady",value:function(e){var t=this;setTimeout((function(){t.mounted&&(t.setState(r({},t.state,{svg:e,svgCount:t.state.svgCount+1})),t.props.onSVGReady(e));}),0);}},{key:"render",value:function(){var e=this.props,t=e.path,n=(e.onSVGReady,e.children,e.svgXML),o=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}(e,["path","onSVGReady","children","svgXML"]),a=null!=this.state.svg?this.props.children:null;return i.default.createElement(i.default.Fragment,null,i.default.createElement(l.default,r({path:t,callback:this.onSVGReady,svgXML:n},o)),i.default.createElement(u.default.Provider,{value:{path:t,svgCount:this.state.svgCount,svg:this.state.svg}},a))}}]),t}(i.default.Component);t.default=c,c.propTypes={path:a.default.string,svgXML:a.default.string,onSVGReady:a.default.func,style:a.default.object,children:a.default.any},c.defaultProps={path:null,svgXML:null,onSVGReady:function(){},style:null};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=l(n(1)),a=l(n(0));function l(e){return e&&e.__esModule?e:{default:e}}function u(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}var s="undefined"!=typeof window?n(6):void 0,c=function(e){function t(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var e=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.refCallback=e.refCallback.bind(e),e}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}(t,e),o(t,[{key:"componentDidUpdate",value:function(e){this.props.path===e.path&&this.props.svgXML===e.svgXML||(this.container&&(this.container.innerHTML=""),this.renderSVG(this.props));}},{key:"refCallback",value:function(e){e&&(this.container=e,this.renderSVG());}},{key:"renderSVG",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.props,n=this.container,r=t.callback,o=(t.path,t.svgXML),i=(t.className,u(t,["callback","path","svgXML","className"]));s(n,{each:function(t){if(t)throw new Error(t);r(e.container);},svgXML:o},(function(){n&&i&&Object.keys(i).reduce((function(e,t){return "style"!==t&&e.setAttribute(t,i[t]),n}),n);}));}},{key:"render",value:function(){var e=this.props,t=(e.callback,e.path,e.svgXML,u(e,["callback","path","svgXML"]));return a.default.createElement("svg",r({ref:this.refCallback,"data-src":this.props.path},t))}}]),t}(a.default.Component);t.default=c,c.defaultProps={callback:function(){},path:null,svgXML:null},c.propTypes={callback:i.default.func,path:i.default.string,svgXML:i.default.string};},function(e,t,n){(function(e){var r,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};
/**
 * Changes:
 * - Don't replace the node.  Justs its innerHTML
 * Adapted from:
 * Original Copyright notice ---------------------------
 * SVGInjector v1.1.3 - Fast, caching, dynamic inline SVG DOM injection library
 * https://github.com/iconic/SVGInjector
 *
 * Copyright (c) 2014-2015 Waybury <hello@waybury.com>
 * @license MIT
 *
 */
!function(i,a){var l="file:"===i.location.protocol;a.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1");var u=Array.prototype.forEach||function(e,t){if(null==this||"function"!=typeof e)throw new TypeError;var n,r=this.length>>>0;for(n=0;n<r;++n)n in this&&e.call(t,this[n],n,this);},s={},c=0,f=[],p=[],d=function(e){return e.cloneNode(!0)},v=function(e,t){p[e]=p[e]||[],p[e].push(t);},h=function(e,t){if(void 0!==s[e])s[e]instanceof SVGSVGElement?t(d(s[e])):v(e,t);else {if(!i.XMLHttpRequest)return t("Browser does not support XMLHttpRequest"),!1;s[e]={},v(e,t);var n=new XMLHttpRequest;n.onreadystatechange=function(){if(4===n.readyState){if(404===n.status||null===n.responseXML)return t("Unable to load SVG file: "+e),l&&t("Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver."),t(),!1;if(!(200===n.status||l&&0===n.status))return t("There was a problem injecting the SVG: "+n.status+" "+n.statusText),!1;if(n.responseXML instanceof Document)s[e]=n.responseXML.documentElement;else if(DOMParser&&DOMParser instanceof Function){var r;try{r=(new DOMParser).parseFromString(n.responseText,"text/xml");}catch(e){r=void 0;}if(!r||r.getElementsByTagName("parsererror").length)return t("Unable to parse SVG file: "+e),!1;s[e]=r.documentElement;}!function(e){for(var t=0,n=p[e].length;t<n;t++)!function(t){setTimeout((function(){p[e][t](d(s[e]));}),0);}(t);}(e);}},n.open("GET",e),n.overrideMimeType&&n.overrideMimeType("text/xml"),n.send();}},y=function(e,t){if(void 0===t||"string"==typeof t)return !1;var n=e.getAttribute("id");n&&t.setAttribute("id",n);var r=e.getAttribute("title");r&&t.setAttribute("title",r);var o=[].concat(t.getAttribute("class")||[],"injected-svg",e.getAttribute("class")||[]).join(" ");t.setAttribute("class",function(e){for(var t={},n=(e=e.split(" ")).length,r=[];n--;)t.hasOwnProperty(e[n])||(t[e[n]]=1,r.unshift(e[n]));return r.join(" ")}(o));var i=e.getAttribute("style");i&&t.setAttribute("style",i);var a=[].filter.call(e.attributes,(function(e){return /^data-\w[\w\-]*$/.test(e.name)}));u.call(a,(function(e){e.name&&e.value&&t.setAttribute(e.name,e.value);}));var l,s,p,d,v,h={clipPath:["clip-path"],"color-profile":["color-profile"],cursor:["cursor"],filter:["filter"],linearGradient:["fill","stroke"],marker:["marker","marker-start","marker-mid","marker-end"],mask:["mask"],pattern:["fill","stroke"],radialGradient:["fill","stroke"]};Object.keys(h).forEach((function(e){l=e,p=h[e];for(var n=0,r=(s=t.querySelectorAll("defs "+l+"[id]")).length;n<r;n++){var o;d=s[n].id,v=d+"-"+c,u.call(p,(function(e){for(var n=0,r=(o=t.querySelectorAll("["+e+'*="'+d+'"]')).length;n<r;n++)o[n].setAttribute(e,"url(#"+v+")");})),s[n].id=v;}})),t.removeAttribute("xmlns:a");var y=t.querySelectorAll("style");if(u.call(y,(function(e){e.textContent+="";})),b(e,t),t.hasAttributes())for(var g=t.attributes,m=g.length-1;m>=0;m--)g[m].name+"->"+g[m].value,e.setAttribute(g[m].name,g[m].value);delete f[f.indexOf(e)],e=null,c++;},b=function(e,t){if(e.innerHTML=t.innerHTML||"",!e.innerHTML){var n=a.createElement("div"),r="<svg>"+function(e){var t=new XMLSerializer;return Array.prototype.slice.call(e.childNodes).map((function(e){return t.serializeToString(e)})).join("")}(t)+"</svg>";n.innerHTML=""+r,e.textContent="",Array.prototype.slice.call(n.childNodes[0].childNodes).forEach((function(t){e.appendChild(t);}));}},g=function(e,t,n,r){if(n){var o;try{o=(new DOMParser).parseFromString(n,"text/xml");}catch(e){o=void 0;}if(!o||o.getElementsByTagName("parsererror").length)return r("Unable to parse SVG file: "+o.getElementsByTagName("parsererror")[0].innerHTML),!1;y(e,o.documentElement),r();}else {var i=e.getAttribute("data-src")||e.getAttribute("src");if(e.setAttribute("src",""),-1!==f.indexOf(e))return;f.push(e),h(i,(function(t){y(e,t),r();}));}},m=function(e,t,n){(t=t||{}).pngFallback;var r=t.each,o=t.svgXML;if(void 0!==e.length){var i=0;u.call(e,(function(t){g(t,0,o,(function(){r&&"function"==typeof r&&r(),n&&e.length===++i&&n(i);}));}));}else e?g(e,0,o,(function(){r&&"function"==typeof r&&r(),n&&n(1),e=null;})):n&&n(0);};"object"===o(e)&&"object"===o(e.exports)?e.exports=t=m:void 0===(r=function(){return m}.call(t,n,t,e))||(e.exports=r);}(window,document);}).call(this,n(7)(e));},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=l(n(0)),i=l(n(1)),a=l(n(2));function l(e){return e&&e.__esModule?e:{default:e}}var u=/(\w+)_(\S+)/,s={xlink:"http://www.w3.org/1999/xlink"},c=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.elemRefs=[],n.svgRef=null,n.path=null,n.originalValues={},n.onSvgUpdated=n.onSvgUpdated.bind(n),n.updateSvgElements=n.updateSvgElements.bind(n),n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}(t,e),r(t,[{key:"componentDidMount",value:function(){this.updateSvgElements(this.props);}},{key:"componentDidUpdate",value:function(e){this.props.selector!==e.selector&&(this.elemRefs=[]),this.updateSvgElements(this.props);}},{key:"onSvgUpdated",value:function(){this.updateSvgElements(this.props,!0);}},{key:"updateSvgElements",value:function(e,t){var n=this.svgRef;if(n&&(0===this.elemRefs.length||t)){var r=[].slice.apply(n.querySelectorAll(e.selector));0===r.length&&-1!==["svg","root"].indexOf(e.selector)&&r.push(n),e.onElementSelected&&r.length&&e.onElementSelected(1===r.length?r[0]:r),this.elemRefs=r;}if(this.elemRefs)for(var o=Object.keys(e),i=0;i<o.length;i+=1){var a=o[i];if(!(-1!==["selector","onElementSelected"].indexOf(a))){var l=null,c=null,f=null,p=u.exec(a);p&&p[1]?(l=p[1],c=s[l],f=l+":"+p[2]):f=a;for(var d=0;d<this.elemRefs.length;d+=1){var v=this.elemRefs[d];if("function"==typeof e[a])v[a.toLowerCase()]=e[a];else {if("string"!=typeof e[a])return;null==this.originalValues[a]&&(this.originalValues[a]=v.getAttributeNS(c,f)||"");var h=e[a].replace("$ORIGINAL",this.originalValues[a]);v.setAttributeNS(c,f,h),"string"==typeof e.children&&e.children.trim().length&&(v.textContent=e.children);}}}}}},{key:"render",value:function(){var e=this;return o.default.createElement(a.default.Consumer,null,(function(t){var n=t.path,r=t.svg,o=t.svgCount;e.svgCount&&e.svgCount!==o?e.onSvgUpdated():(e.svgRef=r,e.path=n,e.svgCount=o);}))}}]),t}(o.default.Component);t.default=c,c.propTypes={selector:i.default.string.isRequired,onElementSelected:i.default.func},c.defaultProps={onElementSelected:function(){}};}]);

var reactSvgmt = dist;

const {
  REACT_APP_STATIC_PREFIX: REACT_APP_STATIC_PREFIX$1 = '/static'
} = process.env;

/**
 * Step indicator in assessment.
 */

const ThemedAssessmentStepIndicator = observer(({
  primaryColor,
  isCurrent,
  isActive
}) => {
  return /*#__PURE__*/React$1.createElement("span", null, /*#__PURE__*/React$1.createElement(reactSvgmt.SvgLoader, {
    path: isCurrent ? `${REACT_APP_STATIC_PREFIX$1}/img/icon-step-active.svg` : `${REACT_APP_STATIC_PREFIX$1}/img/icon-step.svg`
  }, /*#__PURE__*/React$1.createElement(reactSvgmt.SvgProxy, {
    selector: "circle",
    fill: isActive ? primaryColor : palette.graphite.ash
  })));
});

const AssessmentStepIndicator = ({
  isCurrent,
  isActive,
  primaryColor
}) => {
  if (isCurrent) {
    return (
      /*#__PURE__*/
      // A large themed circle is used for the current step
      React$1.createElement(ThemedAssessmentStepIndicator, {
        primaryColor: primaryColor,
        isCurrent: true,
        isActive: true
      })
    );
  } else if (isActive) {
    return (
      /*#__PURE__*/
      // A small themed circle is used for completed steps
      React$1.createElement(ThemedAssessmentStepIndicator, {
        primaryColor: primaryColor,
        isActive: true
      })
    );
  } else {
    return (
      /*#__PURE__*/
      // A grey circle is used for future steps
      React$1.createElement(ThemedAssessmentStepIndicator, null)
    );
  }
};

// exemplary usage:
// <DropdownThemedButton
//     text="Create assessment"
//     wrapperProps={{ flexGrow: 1 }}
//     btnProps={{ mode: 'primary' }}
//     items={[
//         {
//             text: 'Assessment',
//             props: {
//                 component: Link,
//                 to: '/assessment/create',
//             },
//         },
//         {
//             text: 'Assessment (SCORM, cmi5)',
//             props: {
//                 component: 'a',
//                 href: demoLink,
//                 target: '_blank',
//                 rel: 'noreferrer',
//             },
//         },
//     ]}
// />;

const DropdownThemedButton = ({
  text,
  wrapperProps,
  btnProps,
  items
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClickAway = () => {
    setAnchorEl(false);
  };
  const dropdownOpen = Boolean(anchorEl);
  const dropdownItems = items && items.map((x, i) => /*#__PURE__*/React$1.createElement(MenuItem$1, _extends$2({
    key: i
  }, x.props), /*#__PURE__*/React$1.createElement(TextDefault, {
    bold: true,
    padding: 4
  }, x.text)));
  return /*#__PURE__*/React$1.createElement(ClickAwayListener, {
    onClickAway: handleClickAway
  }, /*#__PURE__*/React$1.createElement(FlexDiv, _extends$2({
    positionRelative: true
  }, wrapperProps), /*#__PURE__*/React$1.createElement(ThemedButton, _extends$2({}, btnProps, {
    size: "fullWidth",
    onClick: handleClick,
    text: /*#__PURE__*/React$1.createElement(React$1.Fragment, null, text, " ", /*#__PURE__*/React$1.createElement(ArrowDropDownIcon, {
      fontSize: "small"
    }))
  })), /*#__PURE__*/React$1.createElement(Popper, {
    open: dropdownOpen,
    anchorEl: anchorEl,
    disablePortal: true,
    placement: "bottom-start",
    style: {
      minWidth: '100%',
      paddingTop: 4,
      paddingBottom: 4,
      zIndex: 100
    }
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    backgroundColor: "white",
    style: {
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.04), 0px 4px 24px rgba(29, 30, 29, 0.08)'
    },
    borderRadius: 4,
    py: 16,
    onClick: handleClickAway
  }, dropdownItems))));
};

const {
  REACT_APP_STATIC_PREFIX = '/static'
} = process.env;
const DebugPrimary = styled.span`
    content: ${props => props.theme.primary};
`;
const DebugSecondary = styled.span`
    content: ${props => props.theme.secondary};
`;
const DebugColors = () => {
  const theme = useTheme();
  return /*#__PURE__*/React$1.createElement("div", null, "primary: ", theme && theme.primary || 'nothing', " ", /*#__PURE__*/React$1.createElement(DebugPrimary, null), /*#__PURE__*/React$1.createElement("br", null), "secondary: ", theme && theme.secondary || 'nothing', ' ', /*#__PURE__*/React$1.createElement(DebugSecondary, null), /*#__PURE__*/React$1.createElement("br", null));
};
const ThemedText = styled.span`
    color: ${props => primaryColor(props)};
`;
const ThemedBigText = styled(ThemedText)`
    font-size: 1.4em;
    font-weight: 700;
`;
const ThemedCertificateButton = styled(ThemedButton)`
    flex: 1;
    margin-top: 10px;
    background: ${props => primaryColor(props)};
    line-height: 24px;
    font-size: 18px;
    font-weight: 700;
    color: white;
    padding-left: 0px;
    padding-right: 23px;
    min-width: 400px;
    margin: 10px auto 0 auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    position: relative;
    overflow: visible;
    transition: ease 0.2s background;
    border: none;
    &:hover {
        background: ${props => curriedLighten$1(0.1, primaryColor(props))}
        &:after {
            background-size: 34px auto;
        }
    }
    @media (max-width: 899px) {
        max-width: 96%;
        min-width: unset;
        padding-left: 20px;
        padding-right: 60px;

    }
    &:after {
        content: "";
        transition: ease 0.2s background;

        position: absolute;
        background: url('${REACT_APP_STATIC_PREFIX}/img/icon-send.svg') no-repeat center center;
        background-size: 32px auto;
        right: 14px;
        top: 4px;
        height: 44px;
        width: 44px;
    }
`;
const ThemedSlider = styled(Slider)`
    color: ${props => primaryColor(props)};
`;
const ThemedStep = styled.span`
    white-space: nowrap;
    font-size: 14px;
    color: ${rgba(palette.graphite.heavyMetal, 0.2)};
    font-weight: 800;
    text-transform: uppercase;
    color: ${curriedLighten$1(0.6, palette.graphite.heavyMetal)};
    font-weight: 700;
    border-left-color: white;
    border-left-style: solid;
    border-left-width: 4px;
    border-right-color: white;
    justify-content: space-between;
    flex-direction: row;
    display: flex;
    letter-spacing: 0.04em;
    padding-right: 20px;
    a {
        width: 100%;
    }
    &:after {
        position: absolute;
        content: '';
        width: 20px;
        height: 36px;
        right: 0px;
        top: 0px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 14px auto;
        transition: ease 0.2s all;
    }

    ${props => props.enabled && !props.active && css`
            cursor: pointer;
            color: ${palette.graphite.heavyMetal};
            &:hover {
                color: ${props => curriedLighten$1(0.1, primaryColor(props))};
                border-left-color: ${curriedLighten$1(0.4, palette.graphite.heavyMetal)};
                border-right-color: ${curriedLighten$1(0.4, palette.graphite.heavyMetal)};
            }
            &:after {
                position: absolute;
                content: '';
                width: 20px;
                height: 36px;
                right: 0px;
                top: 0px;
                background-size: 14px auto;
            }
        `};
    ${props => props.active && css`
            border-left-color: ${props => primaryColor(props)};
            border-right-color: ${props => primaryColor(props)};
            border-left-style: solid ${props => primaryColor(props)};
            border-left-width: 4px;
            a {
                color: ${props => primaryColor(props)};
                font-weight: 800;
            }
            span {
                font-weight: 600;
            }
        `};
    ${props => props.viewed && css`
            &:after {
                background-image: url('${REACT_APP_STATIC_PREFIX}/img/icon-subject-inprogress.svg');
            }
            &.answered {
                &:after {
                    background-image: url('${REACT_APP_STATIC_PREFIX}/img/icon-subject-completed.svg');
                }
            }
        `};
`;
const ThemedCard = styled(Card)`
    ${props => props.selected && css`
            color: ${props => props.color || props.theme.primary};
            background-color: ${props => rgba(props.color || props.theme.primary, 0.05)};
            border-color: ${props => props.color || props.theme.primary};
        `}
`;

const BounceAnimation = keyframes`
    0% { transform: translate(0, 0); }
	50% { transform: translate(0, 15px); }
	100% { transform: translate(0, 0); }
`;
styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px 5px 15px 5px;
    border-radius: 5px;
    color: white;
    font-size: 16px;
    font-weight: 100;

    ${props => props.fullscreen && css`
            justify-content: center;
        `};
`;
styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin: 30px 0 30px 0;
    transform: scale(${props => props.size / 100});
`;
styled.div`
    background-color: ${props => rgba(props.color || props.theme.primary, 0.8)};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    /* Animation */
    animation: ${BounceAnimation} 1s 1s infinite;
    animation-delay: ${props => props.delay};
`;

const ImageAsLink = styled.img`
    cursor: pointer;
`;
const StyledConfirmationModal = styled(Modal)`
    inset: auto;
    padding: 24px 0;
    width: 672px;
    background-color: white;
    border-radius: 4px;
    max-height: 70vh;
`;
const ConfirmationModal = observer(({
  confirmationRequired,
  confirmationDescription,
  confirmationAction,
  confirmationTitle,
  confirmationShowCancel,
  confirmationCancelText = 'Cancel',
  additionalCheckbox,
  isConfirmationDelete,
  cancelConfirm,
  doConfirm
}) => {
  const [additionalCheckboxChecked, setAdditionalCheckboxChecked] = useState(false);
  const handleClose = () => {
    cancelConfirm();
  };
  const onConfirm = async arg => {
    if (!additionalCheckbox || additionalCheckboxChecked) return doConfirm(arg);
  };
  const renderAction = confirmationAction => {
    if (Array.isArray(confirmationAction)) {
      return confirmationAction.map(action => {
        return /*#__PURE__*/React$1.createElement(ThemedButton, {
          mode: !isConfirmationDelete ? 'primary' : 'red',
          key: action.key,
          onClick: () => onConfirm(action.key),
          text: action.value
        });
      });
    } else {
      return /*#__PURE__*/React$1.createElement(ThemedButton, {
        mode: !isConfirmationDelete ? 'primary' : 'red',
        onClick: onConfirm,
        text: confirmationAction
      });
    }
  };
  const toggleAdditionalCheckboxChecked = () => {
    setAdditionalCheckboxChecked(!additionalCheckboxChecked);
  };
  return confirmationRequired ? /*#__PURE__*/React$1.createElement(StyledConfirmationModal, {
    isOpen: true,
    onRequestClose: handleClose
  }, /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
    maxHeight: 88,
    px: 48,
    py: 24
  }, /*#__PURE__*/React$1.createElement(Heading1, null, confirmationTitle), /*#__PURE__*/React$1.createElement(ImageAsLink, {
    src: "/static/img/close.svg",
    alt: "Close",
    onClick: handleClose
  })), /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    py: 8,
    px: 48,
    overflowYauto: true
  }, /*#__PURE__*/React$1.createElement(TextLead, null, confirmationDescription), additionalCheckbox && /*#__PURE__*/React$1.createElement("label", {
    htmlFor: 'additionalCheckbox'
  }, /*#__PURE__*/React$1.createElement("input", {
    type: "checkbox",
    className: "checkmark",
    autoComplete: false,
    id: 'additionalCheckbox',
    checked: additionalCheckboxChecked,
    onChange: toggleAdditionalCheckboxChecked
  }), additionalCheckbox, /*#__PURE__*/React$1.createElement("span", {
    className: "checkmark"
  }))), /*#__PURE__*/React$1.createElement(FlexDiv, {
    justifyEnd: true,
    maxHeight: 96,
    px: 48,
    py: 24,
    alignCenter: true
  }, confirmationShowCancel && /*#__PURE__*/React$1.createElement(FlexDiv, {
    pr: 40
  }, /*#__PURE__*/React$1.createElement(TextDefault, {
    uppercase: true,
    extraBold: true,
    link: true,
    onClick: handleClose
  }, confirmationCancelText)), renderAction(confirmationAction), ' ')) : null;
});

const Eye = observer(props => {
  return /*#__PURE__*/React$1.createElement(EyeIcon, props);
});

// to use this component, specify:
// - value
// - customColor

// WIDTH
// - it's 56px by default
// - if custom width needed, specify it as width={123}
// - use fullWidth prop if the progress bar should take all available width of the parent

// HEIGHT
// - it's 16px by default
// - if custom height needed, specify it as height={6}

const useStyles = makeStyles({
  colorPrimary: {
    backgroundColor: props => props.value === 0 ? '#EDEDED' : rgba(props.customColor, 0.15)
  },
  barColorPrimary: {
    backgroundColor: props => props.customColor
  },
  root: {
    width: props => {
      if (props.fullWidth) return '100%';
      if (props.width) return props.width;
      return 56;
    },
    height: props => {
      if (props.height) return props.height;
      return 16;
    },
    display: 'inline-flex',
    marginRight: 10,
    borderRadius: 8
  }
});
function InlineProgressBar(props) {
  const {
    value
  } = props;
  const {
    colorPrimary,
    barColorPrimary,
    root
  } = useStyles(props);
  return /*#__PURE__*/React$1.createElement(LinearProgress, {
    classes: {
      colorPrimary: colorPrimary,
      barColorPrimary: barColorPrimary,
      root: root
    },
    color: "primary",
    variant: "determinate",
    value: value
  });
}

const NestedMenuItem = ({
  items,
  text,
  loading = false
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClickAway = () => {
    setAnchorEl(null);
  };
  const dropdownOpen = Boolean(anchorEl);
  const dropdownItems = items && items.map((x, i) => /*#__PURE__*/React$1.createElement(MenuItem$1, _extends$2({
    key: i
  }, x.props), x.text));
  return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(MenuItem$1, {
    onClick: handleClick,
    selected: dropdownOpen
  }, /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
    gap: 8,
    $noWrap: true
  }, text, loading ? /*#__PURE__*/React$1.createElement(CircularProgress, {
    size: 20,
    thickness: 4,
    color: "inherit"
  }) : /*#__PURE__*/React$1.createElement(NavigateNextIcon, {
    fontSize: "small"
  }))), /*#__PURE__*/React$1.createElement(Popover, {
    open: dropdownOpen,
    anchorEl: anchorEl,
    onClose: handleClickAway,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    elevation: 1
  }, /*#__PURE__*/React$1.createElement(FlexDiv, {
    column: true,
    backgroundColor: "white",
    borderRadius: 4,
    onClick: handleClickAway,
    py: 8
  }, dropdownItems)));
};

const Text = styled.span`
    font-size: ${props => props.fontSize}px;
    font-weight: 700;
    color: ${props => props.color};
`;

// to use this component, specify:
// - value

// hidePercentage
// - percentage is shown by default, if you want to hide it, use hidePercentage

// fullWidth
// - use fullWidth prop if the progress bar should take all available width of the parent

// fontSize
// - it's 14px by default
// - if custom fontSize needed, specify it as fontSize={24}

// showNA
// - display N/A instead of the number, in grey

// invertColoring
// - if true, show red color for highest numbers & green color for lowest numbers
// - ie, if showing % of employees at risk, the higher the number, the worse it gets, so it needs to be red

// ...props
// specify all other props that are usable in InlineProgressBar

function ProgressWithNumber({
  value,
  hidePercentage,
  fontSize = 14,
  fullWidth,
  showNA,
  invertColoring = false,
  ...props
}) {
  const content = /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(InlineProgressBar, _extends$2({
    value: showNA ? 100 : defaultZero(value),
    customColor: showNA ? '#EBEEF1' : calculateColor(invertColoring ? 100 - value : value)
  }, props, {
    fullWidth: fullWidth
  })), /*#__PURE__*/React$1.createElement(Text, {
    color: showNA ? rgba(palette.graphite.heavyMetal, 0.6) : calculateColor(invertColoring ? 100 - value : value),
    fontSize: fontSize
  }, showNA ? 'N/A' : defaultZero(value), hidePercentage || showNA ? '' : '%'));
  return fullWidth ? /*#__PURE__*/React$1.createElement(SpaceBetweenDiv, {
    alignCenter: true,
    $noWrap: true
  }, content) : content;
}

// TO USE THIS COMPONENT, SPECIFY:
// - percentage

// OPTIONAL PROPS:

// halfCircle/fullCircle
// - by default, the component creates a circle cut in 3/4
// - use halfCircle prop if you want to use a circle cut in half
// - use fullCircle prop if you want to use a full circle

// width
// - by default, the width of this component is 200px
// - if custom width in px needed, specify it as width={80}

// top
// - this prop determines positioning of text within the circle
// - if custom position of text in px needed (which it most probably will), specify is as top={20}

// mt (= margin-top)
// - default margin top is 0
// - use this if circle needs better vertical positioning within its surroundings
// - if custom margin top in px needed, specify it as mt={8}

// CONTENT WITHIN THE CIRCLE

// - text
// -- use text prop to insert any kind of text within the circle - it gives flexibility in terms of what the text should be and its styling
// -- example use:  <SemiCircleProgress {...} text={<TextLead>45 ouf of 100</TextLead>}/>

// - percentageText
// -- use percentageText if you want to display the percentage only
// -- example use: <SemiCircleProgress {...} percentageText/>
// -- you can also choose to not have percentageText colored by using prop percentageTextNotColored

// - showNA
// -- if showNA is true, the component will have text N/A and will be grey

const Wrapper = styled.div`
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    position: relative;
    margin-top: ${props => props.mt}px;
`;
const PercentageText = styled.span`
    font-size: ${props => props.width / 3.16}px;
    font-weight: 800;
    color: ${props => props.color};
`;
const NAText = styled.span`
    font-size: ${props => props.width / 4}px;
    font-weight: 800;
    color: ${rgba(palette.graphite.heavyMetal, 0.6)};
`;
function SemiCircleProgress({
  percentage = 100,
  halfCircle = false,
  fullCircle = false,
  width = 200,
  top = 100,
  text = '',
  mt = 0,
  trailColorGray = false,
  percentageText,
  percentageTextNotColored,
  showNA
}) {
  const setHeight = () => {
    if (halfCircle) return width / 1.84;
    if (fullCircle) return width;
    return width / 1.36;
  };
  const setCircleRatio = () => {
    if (halfCircle) return 0.48;
    if (fullCircle) return 1;
    return 0.62;
  };
  const setRotation = () => {
    if (halfCircle) return 0.76;
    if (fullCircle) return 0.5;
    return 0.69;
  };
  const value = defaultZero(percentage);
  const returnContent = () => {
    if (showNA) return /*#__PURE__*/React$1.createElement(NAText, {
      width: width
    }, "N/A");
    if (percentageText) return /*#__PURE__*/React$1.createElement(PercentageText, {
      color: percentageTextNotColored ? palette.graphite.heavyMetal : calculateColor(value),
      width: width
    }, value);
    return text;
  };
  return /*#__PURE__*/React$1.createElement(Wrapper, {
    mt: mt,
    height: setHeight(),
    width: width
  }, /*#__PURE__*/React$1.createElement(CircularProgressbar, {
    value: value,
    circleRatio: setCircleRatio(),
    strokeWidth: 14,
    styles: buildStyles({
      rotation: setRotation(),
      pathColor: calculateColor(value),
      trailColor: trailColorGray || showNA ? '#EBEEF1' : rgba(calculateColor(value), 0.1),
      pathTransitionDuration: 1,
      strokeLinecap: 'round'
    })
  }), /*#__PURE__*/React$1.createElement(FlexDiv, {
    marginAuto: true,
    positionAbsolute: true,
    width: width,
    justifyCenter: true,
    top: top,
    column: true,
    alignCenter: true
  }, returnContent()));
}

const TEST = function TEST({
  children,
  ...rest
}) {
  return "test-test-test";
};

const version = packageJson.version;

export { AnswerableRadioButton, AnswerableToggleButton, AnswerableToggleButtonGroup, AssessmentStepIndicator, BigModal, Block, BlockAnswer, Button, CalendarInput, CheckBoxes, CheckboxInput, CleanHR, Clipboard, ConfirmationModal, Conversation, CopyToClipboardWrapper, CustomPresentation, DarkArrowTooltip, DarkArrowTooltipIcon, DebugColors, DebugPrimary, DebugSecondary, Decision, DecisionAnswers, DropdownThemedButton, EmailAnimation, EmailQuizGeneral, EmailQuizMdlzNewsletter, Eye, FileLoadAnimation, FlexDiv, FullWidthLink, FullscreenModal, GridDiv, GroupOfBlocks, Heading1, Heading2, Heading3, Heading4, Illustration, Image$1 as Image, InlineProgressBar, InputHelperText, InputLabel, InteractiveImg, Legend, LightTooltip$1 as LightTooltip, Message, ModalBody, MultiSelectInput, NestedMenuItem, NumericalScale, OrderableList, Password, PasswordTester, PrimaryOpenInNew, ProgressWithNumber, Question, QuestionHeading, Questionwithbuttons, Questionwithimage, Questionwithsocialpost, RadioButtons, RadioGroupInput, RadioTabInput, SearchInput, SemiCircleProgress, SmallDelete, SmallEdit, SmallFileCopy, Snackbar, SocialPost, SpaceBetweenDiv, SpeechBubbleInput, SpinnerAnimation, StatusBadge, StyledIconButton, TEST, Tag, TextDefault, TextInput, TextLabel, TextLead, TextTiny, TextWithTooltipIcon, ThemedBigText, ThemedButton, ThemedCard, ThemedCertificateButton, ThemedSlider, ThemedStep, ThemedText, TooltipWrapper, TrainingCompletedAnimation, UnStyledCheckboxInput, Video, VideoPlayer, VideoThumbnailWrapper, WaitingAnimation, YesNoList, palette, version };
//# sourceMappingURL=bundle.js.map
